
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4k8M8", function(module, exports) {
"use strict";
function $325fd6489d42c51c$var$Vnode(tag, key, attrs, children, text, dom) {
    return {
        tag: tag,
        key: key,
        attrs: attrs,
        children: children,
        text: text,
        dom: dom,
        domSize: undefined,
        state: undefined,
        events: undefined,
        instance: undefined
    };
}
$325fd6489d42c51c$var$Vnode.normalize = function(node) {
    if (Array.isArray(node)) return $325fd6489d42c51c$var$Vnode("[", undefined, undefined, $325fd6489d42c51c$var$Vnode.normalizeChildren(node), undefined, undefined);
    if (node == null || typeof node === "boolean") return null;
    if (typeof node === "object") return node;
    return $325fd6489d42c51c$var$Vnode("#", undefined, undefined, String(node), undefined, undefined);
};
$325fd6489d42c51c$var$Vnode.normalizeChildren = function(input) {
    var children = [];
    if (input.length) {
        var isKeyed = input[0] != null && input[0].key != null;
        // Note: this is a *very* perf-sensitive check.
        // Fun fact: merging the loop like this is somehow faster than splitting
        // it, noticeably so.
        for(var i = 1; i < input.length; i++){
            if ((input[i] != null && input[i].key != null) !== isKeyed) throw new TypeError(isKeyed && (input[i] != null || typeof input[i] === "boolean") ? "In fragments, vnodes must either all have keys or none have keys. You may wish to consider using an explicit keyed empty fragment, m.fragment({key: ...}), instead of a hole." : "In fragments, vnodes must either all have keys or none have keys.");
        }
        for(var i = 0; i < input.length; i++)children[i] = $325fd6489d42c51c$var$Vnode.normalize(input[i]);
    }
    return children;
};
module.exports = $325fd6489d42c51c$var$Vnode;

});

parcelRegister("jtFfp", function(module, exports) {
"use strict";

var $4k8M8 = parcelRequire("4k8M8");
module.exports = function(html) {
    if (html == null) html = "";
    return $4k8M8("<", undefined, undefined, html, undefined, undefined);
};

});

parcelRegister("61OSB", function(module, exports) {
"use strict";

var $4k8M8 = parcelRequire("4k8M8");

var $eJpVZ = parcelRequire("eJpVZ");
module.exports = function() {
    var vnode = $eJpVZ.apply(0, arguments);
    vnode.tag = "[";
    vnode.children = $4k8M8.normalizeChildren(vnode.children);
    return vnode;
};

});
parcelRegister("eJpVZ", function(module, exports) {
"use strict";

var $4k8M8 = parcelRequire("4k8M8");
// Call via `hyperscriptVnode.apply(startOffset, arguments)`
//
// The reason I do it this way, forwarding the arguments and passing the start
// offset in `this`, is so I don't have to create a temporary array in a
// performance-critical path.
//
// In native ES6, I'd instead add a final `...args` parameter to the
// `hyperscript` and `fragment` factories and define this as
// `hyperscriptVnode(...args)`, since modern engines do optimize that away. But
// ES5 (what Mithril.js requires thanks to IE support) doesn't give me that luxury,
// and engines aren't nearly intelligent enough to do either of these:
//
// 1. Elide the allocation for `[].slice.call(arguments, 1)` when it's passed to
//    another function only to be indexed.
// 2. Elide an `arguments` allocation when it's passed to any function other
//    than `Function.prototype.apply` or `Reflect.apply`.
//
// In ES6, it'd probably look closer to this (I'd need to profile it, though):
// module.exports = function(attrs, ...children) {
//     if (attrs == null || typeof attrs === "object" && attrs.tag == null && !Array.isArray(attrs)) {
//         if (children.length === 1 && Array.isArray(children[0])) children = children[0]
//     } else {
//         children = children.length === 0 && Array.isArray(attrs) ? attrs : [attrs, ...children]
//         attrs = undefined
//     }
//
//     if (attrs == null) attrs = {}
//     return Vnode("", attrs.key, attrs, children)
// }
module.exports = function() {
    var attrs = arguments[this], start = this + 1, children;
    if (attrs == null) attrs = {};
    else if (typeof attrs !== "object" || attrs.tag != null || Array.isArray(attrs)) {
        attrs = {};
        start = this;
    }
    if (arguments.length === start + 1) {
        children = arguments[start];
        if (!Array.isArray(children)) children = [
            children
        ];
    } else {
        children = [];
        while(start < arguments.length)children.push(arguments[start++]);
    }
    return $4k8M8("", attrs.key, attrs, children);
};

});


parcelRegister("3UKYh", function(module, exports) {
"use strict";
/** @constructor */ var $2d9b098d8467e1af$var$PromisePolyfill = function(executor) {
    if (!(this instanceof $2d9b098d8467e1af$var$PromisePolyfill)) throw new Error("Promise must be called with 'new'.");
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var self = this, resolvers = [], rejectors = [], resolveCurrent = handler(resolvers, true), rejectCurrent = handler(rejectors, false);
    var instance = self._instance = {
        resolvers: resolvers,
        rejectors: rejectors
    };
    var callAsync = typeof setImmediate === "function" ? setImmediate : setTimeout;
    function handler(list, shouldAbsorb) {
        return function execute(value) {
            var then;
            try {
                if (shouldAbsorb && value != null && (typeof value === "object" || typeof value === "function") && typeof (then = value.then) === "function") {
                    if (value === self) throw new TypeError("Promise can't be resolved with itself.");
                    executeOnce(then.bind(value));
                } else callAsync(function() {
                    if (!shouldAbsorb && list.length === 0) console.error("Possible unhandled promise rejection:", value);
                    for(var i = 0; i < list.length; i++)list[i](value);
                    resolvers.length = 0, rejectors.length = 0;
                    instance.state = shouldAbsorb;
                    instance.retry = function() {
                        execute(value);
                    };
                });
            } catch (e) {
                rejectCurrent(e);
            }
        };
    }
    function executeOnce(then) {
        var runs = 0;
        function run(fn) {
            return function(value) {
                if (runs++ > 0) return;
                fn(value);
            };
        }
        var onerror = run(rejectCurrent);
        try {
            then(run(resolveCurrent), onerror);
        } catch (e) {
            onerror(e);
        }
    }
    executeOnce(executor);
};
$2d9b098d8467e1af$var$PromisePolyfill.prototype.then = function(onFulfilled, onRejection) {
    var self = this, instance = self._instance;
    function handle(callback, list, next, state) {
        list.push(function(value) {
            if (typeof callback !== "function") next(value);
            else try {
                resolveNext(callback(value));
            } catch (e) {
                if (rejectNext) rejectNext(e);
            }
        });
        if (typeof instance.retry === "function" && state === instance.state) instance.retry();
    }
    var resolveNext, rejectNext;
    var promise = new $2d9b098d8467e1af$var$PromisePolyfill(function(resolve, reject) {
        resolveNext = resolve, rejectNext = reject;
    });
    handle(onFulfilled, instance.resolvers, resolveNext, true), handle(onRejection, instance.rejectors, rejectNext, false);
    return promise;
};
$2d9b098d8467e1af$var$PromisePolyfill.prototype.catch = function(onRejection) {
    return this.then(null, onRejection);
};
$2d9b098d8467e1af$var$PromisePolyfill.prototype.finally = function(callback) {
    return this.then(function(value) {
        return $2d9b098d8467e1af$var$PromisePolyfill.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        return $2d9b098d8467e1af$var$PromisePolyfill.resolve(callback()).then(function() {
            return $2d9b098d8467e1af$var$PromisePolyfill.reject(reason);
        });
    });
};
$2d9b098d8467e1af$var$PromisePolyfill.resolve = function(value) {
    if (value instanceof $2d9b098d8467e1af$var$PromisePolyfill) return value;
    return new $2d9b098d8467e1af$var$PromisePolyfill(function(resolve) {
        resolve(value);
    });
};
$2d9b098d8467e1af$var$PromisePolyfill.reject = function(value) {
    return new $2d9b098d8467e1af$var$PromisePolyfill(function(resolve, reject) {
        reject(value);
    });
};
$2d9b098d8467e1af$var$PromisePolyfill.all = function(list) {
    return new $2d9b098d8467e1af$var$PromisePolyfill(function(resolve, reject) {
        var total = list.length, count = 0, values = [];
        if (list.length === 0) resolve([]);
        else for(var i = 0; i < list.length; i++)(function(i) {
            function consume(value) {
                count++;
                values[i] = value;
                if (count === total) resolve(values);
            }
            if (list[i] != null && (typeof list[i] === "object" || typeof list[i] === "function") && typeof list[i].then === "function") list[i].then(consume, reject);
            else consume(list[i]);
        })(i);
    });
};
$2d9b098d8467e1af$var$PromisePolyfill.race = function(list) {
    return new $2d9b098d8467e1af$var$PromisePolyfill(function(resolve, reject) {
        for(var i = 0; i < list.length; i++)list[i].then(resolve, reject);
    });
};
module.exports = $2d9b098d8467e1af$var$PromisePolyfill;

});

parcelRegister("kOTGc", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ikexr"))(typeof window !== "undefined" ? window : null);

});
parcelRegister("ikexr", function(module, exports) {
"use strict";

var $4k8M8 = parcelRequire("4k8M8");
module.exports = function($window) {
    var $doc = $window && $window.document;
    var currentRedraw;
    var nameSpace = {
        svg: "http://www.w3.org/2000/svg",
        math: "http://www.w3.org/1998/Math/MathML"
    };
    function getNameSpace(vnode) {
        return vnode.attrs && vnode.attrs.xmlns || nameSpace[vnode.tag];
    }
    //sanity check to discourage people from doing `vnode.state = ...`
    function checkState(vnode, original) {
        if (vnode.state !== original) throw new Error("'vnode.state' must not be modified.");
    }
    //Note: the hook is passed as the `this` argument to allow proxying the
    //arguments without requiring a full array allocation to do so. It also
    //takes advantage of the fact the current `vnode` is the first argument in
    //all lifecycle methods.
    function callHook(vnode) {
        var original = vnode.state;
        try {
            return this.apply(original, arguments);
        } finally{
            checkState(vnode, original);
        }
    }
    // IE11 (at least) throws an UnspecifiedError when accessing document.activeElement when
    // inside an iframe. Catch and swallow this error, and heavy-handidly return null.
    function activeElement() {
        try {
            return $doc.activeElement;
        } catch (e) {
            return null;
        }
    }
    //create
    function createNodes(parent, vnodes, start, end, hooks, nextSibling, ns) {
        for(var i = start; i < end; i++){
            var vnode = vnodes[i];
            if (vnode != null) createNode(parent, vnode, hooks, ns, nextSibling);
        }
    }
    function createNode(parent, vnode, hooks, ns, nextSibling) {
        var tag = vnode.tag;
        if (typeof tag === "string") {
            vnode.state = {};
            if (vnode.attrs != null) initLifecycle(vnode.attrs, vnode, hooks);
            switch(tag){
                case "#":
                    createText(parent, vnode, nextSibling);
                    break;
                case "<":
                    createHTML(parent, vnode, ns, nextSibling);
                    break;
                case "[":
                    createFragment(parent, vnode, hooks, ns, nextSibling);
                    break;
                default:
                    createElement(parent, vnode, hooks, ns, nextSibling);
            }
        } else createComponent(parent, vnode, hooks, ns, nextSibling);
    }
    function createText(parent, vnode, nextSibling) {
        vnode.dom = $doc.createTextNode(vnode.children);
        insertNode(parent, vnode.dom, nextSibling);
    }
    var possibleParents = {
        caption: "table",
        thead: "table",
        tbody: "table",
        tfoot: "table",
        tr: "tbody",
        th: "tr",
        td: "tr",
        colgroup: "table",
        col: "colgroup"
    };
    function createHTML(parent, vnode, ns, nextSibling) {
        var match = vnode.children.match(/^\s*?<(\w+)/im) || [];
        // not using the proper parent makes the child element(s) vanish.
        //     var div = document.createElement("div")
        //     div.innerHTML = "<td>i</td><td>j</td>"
        //     console.log(div.innerHTML)
        // --> "ij", no <td> in sight.
        var temp = $doc.createElement(possibleParents[match[1]] || "div");
        if (ns === "http://www.w3.org/2000/svg") {
            temp.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg">' + vnode.children + "</svg>";
            temp = temp.firstChild;
        } else temp.innerHTML = vnode.children;
        vnode.dom = temp.firstChild;
        vnode.domSize = temp.childNodes.length;
        // Capture nodes to remove, so we don't confuse them.
        vnode.instance = [];
        var fragment = $doc.createDocumentFragment();
        var child;
        while(child = temp.firstChild){
            vnode.instance.push(child);
            fragment.appendChild(child);
        }
        insertNode(parent, fragment, nextSibling);
    }
    function createFragment(parent, vnode, hooks, ns, nextSibling) {
        var fragment = $doc.createDocumentFragment();
        if (vnode.children != null) {
            var children = vnode.children;
            createNodes(fragment, children, 0, children.length, hooks, null, ns);
        }
        vnode.dom = fragment.firstChild;
        vnode.domSize = fragment.childNodes.length;
        insertNode(parent, fragment, nextSibling);
    }
    function createElement(parent, vnode, hooks, ns, nextSibling) {
        var tag = vnode.tag;
        var attrs = vnode.attrs;
        var is = attrs && attrs.is;
        ns = getNameSpace(vnode) || ns;
        var element = ns ? is ? $doc.createElementNS(ns, tag, {
            is: is
        }) : $doc.createElementNS(ns, tag) : is ? $doc.createElement(tag, {
            is: is
        }) : $doc.createElement(tag);
        vnode.dom = element;
        if (attrs != null) setAttrs(vnode, attrs, ns);
        insertNode(parent, element, nextSibling);
        if (!maybeSetContentEditable(vnode)) {
            if (vnode.children != null) {
                var children = vnode.children;
                createNodes(element, children, 0, children.length, hooks, null, ns);
                if (vnode.tag === "select" && attrs != null) setLateSelectAttrs(vnode, attrs);
            }
        }
    }
    function initComponent(vnode, hooks) {
        var sentinel;
        if (typeof vnode.tag.view === "function") {
            vnode.state = Object.create(vnode.tag);
            sentinel = vnode.state.view;
            if (sentinel.$$reentrantLock$$ != null) return;
            sentinel.$$reentrantLock$$ = true;
        } else {
            vnode.state = void 0;
            sentinel = vnode.tag;
            if (sentinel.$$reentrantLock$$ != null) return;
            sentinel.$$reentrantLock$$ = true;
            vnode.state = vnode.tag.prototype != null && typeof vnode.tag.prototype.view === "function" ? new vnode.tag(vnode) : vnode.tag(vnode);
        }
        initLifecycle(vnode.state, vnode, hooks);
        if (vnode.attrs != null) initLifecycle(vnode.attrs, vnode, hooks);
        vnode.instance = $4k8M8.normalize(callHook.call(vnode.state.view, vnode));
        if (vnode.instance === vnode) throw Error("A view cannot return the vnode it received as argument");
        sentinel.$$reentrantLock$$ = null;
    }
    function createComponent(parent, vnode, hooks, ns, nextSibling) {
        initComponent(vnode, hooks);
        if (vnode.instance != null) {
            createNode(parent, vnode.instance, hooks, ns, nextSibling);
            vnode.dom = vnode.instance.dom;
            vnode.domSize = vnode.dom != null ? vnode.instance.domSize : 0;
        } else vnode.domSize = 0;
    }
    //update
    /**
	 * @param {Element|Fragment} parent - the parent element
	 * @param {Vnode[] | null} old - the list of vnodes of the last `render()` call for
	 *                               this part of the tree
	 * @param {Vnode[] | null} vnodes - as above, but for the current `render()` call.
	 * @param {Function[]} hooks - an accumulator of post-render hooks (oncreate/onupdate)
	 * @param {Element | null} nextSibling - the next DOM node if we're dealing with a
	 *                                       fragment that is not the last item in its
	 *                                       parent
	 * @param {'svg' | 'math' | String | null} ns) - the current XML namespace, if any
	 * @returns void
	 */ // This function diffs and patches lists of vnodes, both keyed and unkeyed.
    //
    // We will:
    //
    // 1. describe its general structure
    // 2. focus on the diff algorithm optimizations
    // 3. discuss DOM node operations.
    // ## Overview:
    //
    // The updateNodes() function:
    // - deals with trivial cases
    // - determines whether the lists are keyed or unkeyed based on the first non-null node
    //   of each list.
    // - diffs them and patches the DOM if needed (that's the brunt of the code)
    // - manages the leftovers: after diffing, are there:
    //   - old nodes left to remove?
    // 	 - new nodes to insert?
    // 	 deal with them!
    //
    // The lists are only iterated over once, with an exception for the nodes in `old` that
    // are visited in the fourth part of the diff and in the `removeNodes` loop.
    // ## Diffing
    //
    // Reading https://github.com/localvoid/ivi/blob/ddc09d06abaef45248e6133f7040d00d3c6be853/packages/ivi/src/vdom/implementation.ts#L617-L837
    // may be good for context on longest increasing subsequence-based logic for moving nodes.
    //
    // In order to diff keyed lists, one has to
    //
    // 1) match nodes in both lists, per key, and update them accordingly
    // 2) create the nodes present in the new list, but absent in the old one
    // 3) remove the nodes present in the old list, but absent in the new one
    // 4) figure out what nodes in 1) to move in order to minimize the DOM operations.
    //
    // To achieve 1) one can create a dictionary of keys => index (for the old list), then iterate
    // over the new list and for each new vnode, find the corresponding vnode in the old list using
    // the map.
    // 2) is achieved in the same step: if a new node has no corresponding entry in the map, it is new
    // and must be created.
    // For the removals, we actually remove the nodes that have been updated from the old list.
    // The nodes that remain in that list after 1) and 2) have been performed can be safely removed.
    // The fourth step is a bit more complex and relies on the longest increasing subsequence (LIS)
    // algorithm.
    //
    // the longest increasing subsequence is the list of nodes that can remain in place. Imagine going
    // from `1,2,3,4,5` to `4,5,1,2,3` where the numbers are not necessarily the keys, but the indices
    // corresponding to the keyed nodes in the old list (keyed nodes `e,d,c,b,a` => `b,a,e,d,c` would
    //  match the above lists, for example).
    //
    // In there are two increasing subsequences: `4,5` and `1,2,3`, the latter being the longest. We
    // can update those nodes without moving them, and only call `insertNode` on `4` and `5`.
    //
    // @localvoid adapted the algo to also support node deletions and insertions (the `lis` is actually
    // the longest increasing subsequence *of old nodes still present in the new list*).
    //
    // It is a general algorithm that is fireproof in all circumstances, but it requires the allocation
    // and the construction of a `key => oldIndex` map, and three arrays (one with `newIndex => oldIndex`,
    // the `LIS` and a temporary one to create the LIS).
    //
    // So we cheat where we can: if the tails of the lists are identical, they are guaranteed to be part of
    // the LIS and can be updated without moving them.
    //
    // If two nodes are swapped, they are guaranteed not to be part of the LIS, and must be moved (with
    // the exception of the last node if the list is fully reversed).
    //
    // ## Finding the next sibling.
    //
    // `updateNode()` and `createNode()` expect a nextSibling parameter to perform DOM operations.
    // When the list is being traversed top-down, at any index, the DOM nodes up to the previous
    // vnode reflect the content of the new list, whereas the rest of the DOM nodes reflect the old
    // list. The next sibling must be looked for in the old list using `getNextSibling(... oldStart + 1 ...)`.
    //
    // In the other scenarios (swaps, upwards traversal, map-based diff),
    // the new vnodes list is traversed upwards. The DOM nodes at the bottom of the list reflect the
    // bottom part of the new vnodes list, and we can use the `v.dom`  value of the previous node
    // as the next sibling (cached in the `nextSibling` variable).
    // ## DOM node moves
    //
    // In most scenarios `updateNode()` and `createNode()` perform the DOM operations. However,
    // this is not the case if the node moved (second and fourth part of the diff algo). We move
    // the old DOM nodes before updateNode runs because it enables us to use the cached `nextSibling`
    // variable rather than fetching it using `getNextSibling()`.
    //
    // The fourth part of the diff currently inserts nodes unconditionally, leading to issues
    // like #1791 and #1999. We need to be smarter about those situations where adjascent old
    // nodes remain together in the new list in a way that isn't covered by parts one and
    // three of the diff algo.
    function updateNodes(parent, old, vnodes, hooks, nextSibling, ns) {
        if (old === vnodes || old == null && vnodes == null) return;
        else if (old == null || old.length === 0) createNodes(parent, vnodes, 0, vnodes.length, hooks, nextSibling, ns);
        else if (vnodes == null || vnodes.length === 0) removeNodes(parent, old, 0, old.length);
        else {
            var isOldKeyed = old[0] != null && old[0].key != null;
            var isKeyed = vnodes[0] != null && vnodes[0].key != null;
            var start = 0, oldStart = 0;
            if (!isOldKeyed) while(oldStart < old.length && old[oldStart] == null)oldStart++;
            if (!isKeyed) while(start < vnodes.length && vnodes[start] == null)start++;
            if (isOldKeyed !== isKeyed) {
                removeNodes(parent, old, oldStart, old.length);
                createNodes(parent, vnodes, start, vnodes.length, hooks, nextSibling, ns);
            } else if (!isKeyed) {
                // Don't index past the end of either list (causes deopts).
                var commonLength = old.length < vnodes.length ? old.length : vnodes.length;
                // Rewind if necessary to the first non-null index on either side.
                // We could alternatively either explicitly create or remove nodes when `start !== oldStart`
                // but that would be optimizing for sparse lists which are more rare than dense ones.
                start = start < oldStart ? start : oldStart;
                for(; start < commonLength; start++){
                    o = old[start];
                    v = vnodes[start];
                    if (o === v || o == null && v == null) continue;
                    else if (o == null) createNode(parent, v, hooks, ns, getNextSibling(old, start + 1, nextSibling));
                    else if (v == null) removeNode(parent, o);
                    else updateNode(parent, o, v, hooks, getNextSibling(old, start + 1, nextSibling), ns);
                }
                if (old.length > commonLength) removeNodes(parent, old, start, old.length);
                if (vnodes.length > commonLength) createNodes(parent, vnodes, start, vnodes.length, hooks, nextSibling, ns);
            } else {
                // keyed diff
                var oldEnd = old.length - 1, end = vnodes.length - 1, map, o, v, oe, ve, topSibling;
                // bottom-up
                while(oldEnd >= oldStart && end >= start){
                    oe = old[oldEnd];
                    ve = vnodes[end];
                    if (oe.key !== ve.key) break;
                    if (oe !== ve) updateNode(parent, oe, ve, hooks, nextSibling, ns);
                    if (ve.dom != null) nextSibling = ve.dom;
                    oldEnd--, end--;
                }
                // top-down
                while(oldEnd >= oldStart && end >= start){
                    o = old[oldStart];
                    v = vnodes[start];
                    if (o.key !== v.key) break;
                    oldStart++, start++;
                    if (o !== v) updateNode(parent, o, v, hooks, getNextSibling(old, oldStart, nextSibling), ns);
                }
                // swaps and list reversals
                while(oldEnd >= oldStart && end >= start){
                    if (start === end) break;
                    if (o.key !== ve.key || oe.key !== v.key) break;
                    topSibling = getNextSibling(old, oldStart, nextSibling);
                    moveNodes(parent, oe, topSibling);
                    if (oe !== v) updateNode(parent, oe, v, hooks, topSibling, ns);
                    if (++start <= --end) moveNodes(parent, o, nextSibling);
                    if (o !== ve) updateNode(parent, o, ve, hooks, nextSibling, ns);
                    if (ve.dom != null) nextSibling = ve.dom;
                    oldStart++;
                    oldEnd--;
                    oe = old[oldEnd];
                    ve = vnodes[end];
                    o = old[oldStart];
                    v = vnodes[start];
                }
                // bottom up once again
                while(oldEnd >= oldStart && end >= start){
                    if (oe.key !== ve.key) break;
                    if (oe !== ve) updateNode(parent, oe, ve, hooks, nextSibling, ns);
                    if (ve.dom != null) nextSibling = ve.dom;
                    oldEnd--, end--;
                    oe = old[oldEnd];
                    ve = vnodes[end];
                }
                if (start > end) removeNodes(parent, old, oldStart, oldEnd + 1);
                else if (oldStart > oldEnd) createNodes(parent, vnodes, start, end + 1, hooks, nextSibling, ns);
                else {
                    // inspired by ivi https://github.com/ivijs/ivi/ by Boris Kaul
                    var originalNextSibling = nextSibling, vnodesLength = end - start + 1, oldIndices = new Array(vnodesLength), li = 0, i = 0, pos = 2147483647, matched = 0, map, lisIndices;
                    for(i = 0; i < vnodesLength; i++)oldIndices[i] = -1;
                    for(i = end; i >= start; i--){
                        if (map == null) map = getKeyMap(old, oldStart, oldEnd + 1);
                        ve = vnodes[i];
                        var oldIndex = map[ve.key];
                        if (oldIndex != null) {
                            pos = oldIndex < pos ? oldIndex : -1 // becomes -1 if nodes were re-ordered
                            ;
                            oldIndices[i - start] = oldIndex;
                            oe = old[oldIndex];
                            old[oldIndex] = null;
                            if (oe !== ve) updateNode(parent, oe, ve, hooks, nextSibling, ns);
                            if (ve.dom != null) nextSibling = ve.dom;
                            matched++;
                        }
                    }
                    nextSibling = originalNextSibling;
                    if (matched !== oldEnd - oldStart + 1) removeNodes(parent, old, oldStart, oldEnd + 1);
                    if (matched === 0) createNodes(parent, vnodes, start, end + 1, hooks, nextSibling, ns);
                    else {
                        if (pos === -1) {
                            // the indices of the indices of the items that are part of the
                            // longest increasing subsequence in the oldIndices list
                            lisIndices = makeLisIndices(oldIndices);
                            li = lisIndices.length - 1;
                            for(i = end; i >= start; i--){
                                v = vnodes[i];
                                if (oldIndices[i - start] === -1) createNode(parent, v, hooks, ns, nextSibling);
                                else if (lisIndices[li] === i - start) li--;
                                else moveNodes(parent, v, nextSibling);
                                if (v.dom != null) nextSibling = vnodes[i].dom;
                            }
                        } else for(i = end; i >= start; i--){
                            v = vnodes[i];
                            if (oldIndices[i - start] === -1) createNode(parent, v, hooks, ns, nextSibling);
                            if (v.dom != null) nextSibling = vnodes[i].dom;
                        }
                    }
                }
            }
        }
    }
    function updateNode(parent, old, vnode, hooks, nextSibling, ns) {
        var oldTag = old.tag, tag = vnode.tag;
        if (oldTag === tag) {
            vnode.state = old.state;
            vnode.events = old.events;
            if (shouldNotUpdate(vnode, old)) return;
            if (typeof oldTag === "string") {
                if (vnode.attrs != null) updateLifecycle(vnode.attrs, vnode, hooks);
                switch(oldTag){
                    case "#":
                        updateText(old, vnode);
                        break;
                    case "<":
                        updateHTML(parent, old, vnode, ns, nextSibling);
                        break;
                    case "[":
                        updateFragment(parent, old, vnode, hooks, nextSibling, ns);
                        break;
                    default:
                        updateElement(old, vnode, hooks, ns);
                }
            } else updateComponent(parent, old, vnode, hooks, nextSibling, ns);
        } else {
            removeNode(parent, old);
            createNode(parent, vnode, hooks, ns, nextSibling);
        }
    }
    function updateText(old, vnode) {
        if (old.children.toString() !== vnode.children.toString()) old.dom.nodeValue = vnode.children;
        vnode.dom = old.dom;
    }
    function updateHTML(parent, old, vnode, ns, nextSibling) {
        if (old.children !== vnode.children) {
            removeHTML(parent, old);
            createHTML(parent, vnode, ns, nextSibling);
        } else {
            vnode.dom = old.dom;
            vnode.domSize = old.domSize;
            vnode.instance = old.instance;
        }
    }
    function updateFragment(parent, old, vnode, hooks, nextSibling, ns) {
        updateNodes(parent, old.children, vnode.children, hooks, nextSibling, ns);
        var domSize = 0, children = vnode.children;
        vnode.dom = null;
        if (children != null) {
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child != null && child.dom != null) {
                    if (vnode.dom == null) vnode.dom = child.dom;
                    domSize += child.domSize || 1;
                }
            }
            if (domSize !== 1) vnode.domSize = domSize;
        }
    }
    function updateElement(old, vnode, hooks, ns) {
        var element = vnode.dom = old.dom;
        ns = getNameSpace(vnode) || ns;
        if (vnode.tag === "textarea") {
            if (vnode.attrs == null) vnode.attrs = {};
        }
        updateAttrs(vnode, old.attrs, vnode.attrs, ns);
        if (!maybeSetContentEditable(vnode)) updateNodes(element, old.children, vnode.children, hooks, null, ns);
    }
    function updateComponent(parent, old, vnode, hooks, nextSibling, ns) {
        vnode.instance = $4k8M8.normalize(callHook.call(vnode.state.view, vnode));
        if (vnode.instance === vnode) throw Error("A view cannot return the vnode it received as argument");
        updateLifecycle(vnode.state, vnode, hooks);
        if (vnode.attrs != null) updateLifecycle(vnode.attrs, vnode, hooks);
        if (vnode.instance != null) {
            if (old.instance == null) createNode(parent, vnode.instance, hooks, ns, nextSibling);
            else updateNode(parent, old.instance, vnode.instance, hooks, nextSibling, ns);
            vnode.dom = vnode.instance.dom;
            vnode.domSize = vnode.instance.domSize;
        } else if (old.instance != null) {
            removeNode(parent, old.instance);
            vnode.dom = undefined;
            vnode.domSize = 0;
        } else {
            vnode.dom = old.dom;
            vnode.domSize = old.domSize;
        }
    }
    function getKeyMap(vnodes, start, end) {
        var map = Object.create(null);
        for(; start < end; start++){
            var vnode = vnodes[start];
            if (vnode != null) {
                var key = vnode.key;
                if (key != null) map[key] = start;
            }
        }
        return map;
    }
    // Lifted from ivi https://github.com/ivijs/ivi/
    // takes a list of unique numbers (-1 is special and can
    // occur multiple times) and returns an array with the indices
    // of the items that are part of the longest increasing
    // subsequence
    var lisTemp = [];
    function makeLisIndices(a) {
        var result = [
            0
        ];
        var u = 0, v = 0, i = 0;
        var il = lisTemp.length = a.length;
        for(var i = 0; i < il; i++)lisTemp[i] = a[i];
        for(var i = 0; i < il; ++i){
            if (a[i] === -1) continue;
            var j = result[result.length - 1];
            if (a[j] < a[i]) {
                lisTemp[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v = result.length - 1;
            while(u < v){
                // Fast integer average without overflow.
                // eslint-disable-next-line no-bitwise
                var c = (u >>> 1) + (v >>> 1) + (u & v & 1);
                if (a[result[c]] < a[i]) u = c + 1;
                else v = c;
            }
            if (a[i] < a[result[u]]) {
                if (u > 0) lisTemp[i] = result[u - 1];
                result[u] = i;
            }
        }
        u = result.length;
        v = result[u - 1];
        while(u-- > 0){
            result[u] = v;
            v = lisTemp[v];
        }
        lisTemp.length = 0;
        return result;
    }
    function getNextSibling(vnodes, i, nextSibling) {
        for(; i < vnodes.length; i++){
            if (vnodes[i] != null && vnodes[i].dom != null) return vnodes[i].dom;
        }
        return nextSibling;
    }
    // This covers a really specific edge case:
    // - Parent node is keyed and contains child
    // - Child is removed, returns unresolved promise in `onbeforeremove`
    // - Parent node is moved in keyed diff
    // - Remaining children still need moved appropriately
    //
    // Ideally, I'd track removed nodes as well, but that introduces a lot more
    // complexity and I'm not exactly interested in doing that.
    function moveNodes(parent, vnode, nextSibling) {
        var frag = $doc.createDocumentFragment();
        moveChildToFrag(parent, frag, vnode);
        insertNode(parent, frag, nextSibling);
    }
    function moveChildToFrag(parent, frag, vnode) {
        // Dodge the recursion overhead in a few of the most common cases.
        while(vnode.dom != null && vnode.dom.parentNode === parent){
            if (typeof vnode.tag !== "string") {
                vnode = vnode.instance;
                if (vnode != null) continue;
            } else if (vnode.tag === "<") for(var i = 0; i < vnode.instance.length; i++)frag.appendChild(vnode.instance[i]);
            else if (vnode.tag !== "[") // Don't recurse for text nodes *or* elements, just fragments
            frag.appendChild(vnode.dom);
            else if (vnode.children.length === 1) {
                vnode = vnode.children[0];
                if (vnode != null) continue;
            } else for(var i = 0; i < vnode.children.length; i++){
                var child = vnode.children[i];
                if (child != null) moveChildToFrag(parent, frag, child);
            }
            break;
        }
    }
    function insertNode(parent, dom, nextSibling) {
        if (nextSibling != null) parent.insertBefore(dom, nextSibling);
        else parent.appendChild(dom);
    }
    function maybeSetContentEditable(vnode) {
        if (vnode.attrs == null || vnode.attrs.contenteditable == null && // attribute
        vnode.attrs.contentEditable == null // property
        ) return false;
        var children = vnode.children;
        if (children != null && children.length === 1 && children[0].tag === "<") {
            var content = children[0].children;
            if (vnode.dom.innerHTML !== content) vnode.dom.innerHTML = content;
        } else if (children != null && children.length !== 0) throw new Error("Child node of a contenteditable must be trusted.");
        return true;
    }
    //remove
    function removeNodes(parent, vnodes, start, end) {
        for(var i = start; i < end; i++){
            var vnode = vnodes[i];
            if (vnode != null) removeNode(parent, vnode);
        }
    }
    function removeNode(parent, vnode) {
        var mask = 0;
        var original = vnode.state;
        var stateResult, attrsResult;
        if (typeof vnode.tag !== "string" && typeof vnode.state.onbeforeremove === "function") {
            var result = callHook.call(vnode.state.onbeforeremove, vnode);
            if (result != null && typeof result.then === "function") {
                mask = 1;
                stateResult = result;
            }
        }
        if (vnode.attrs && typeof vnode.attrs.onbeforeremove === "function") {
            var result = callHook.call(vnode.attrs.onbeforeremove, vnode);
            if (result != null && typeof result.then === "function") {
                // eslint-disable-next-line no-bitwise
                mask |= 2;
                attrsResult = result;
            }
        }
        checkState(vnode, original);
        // If we can, try to fast-path it and avoid all the overhead of awaiting
        if (!mask) {
            onremove(vnode);
            removeChild(parent, vnode);
        } else {
            if (stateResult != null) {
                var next = function() {
                    // eslint-disable-next-line no-bitwise
                    if (mask & 1) {
                        mask &= 2;
                        if (!mask) reallyRemove();
                    }
                };
                stateResult.then(next, next);
            }
            if (attrsResult != null) {
                var next = function() {
                    // eslint-disable-next-line no-bitwise
                    if (mask & 2) {
                        mask &= 1;
                        if (!mask) reallyRemove();
                    }
                };
                attrsResult.then(next, next);
            }
        }
        function reallyRemove() {
            checkState(vnode, original);
            onremove(vnode);
            removeChild(parent, vnode);
        }
    }
    function removeHTML(parent, vnode) {
        for(var i = 0; i < vnode.instance.length; i++)parent.removeChild(vnode.instance[i]);
    }
    function removeChild(parent, vnode) {
        // Dodge the recursion overhead in a few of the most common cases.
        while(vnode.dom != null && vnode.dom.parentNode === parent){
            if (typeof vnode.tag !== "string") {
                vnode = vnode.instance;
                if (vnode != null) continue;
            } else if (vnode.tag === "<") removeHTML(parent, vnode);
            else {
                if (vnode.tag !== "[") {
                    parent.removeChild(vnode.dom);
                    if (!Array.isArray(vnode.children)) break;
                }
                if (vnode.children.length === 1) {
                    vnode = vnode.children[0];
                    if (vnode != null) continue;
                } else for(var i = 0; i < vnode.children.length; i++){
                    var child = vnode.children[i];
                    if (child != null) removeChild(parent, child);
                }
            }
            break;
        }
    }
    function onremove(vnode) {
        if (typeof vnode.tag !== "string" && typeof vnode.state.onremove === "function") callHook.call(vnode.state.onremove, vnode);
        if (vnode.attrs && typeof vnode.attrs.onremove === "function") callHook.call(vnode.attrs.onremove, vnode);
        if (typeof vnode.tag !== "string") {
            if (vnode.instance != null) onremove(vnode.instance);
        } else {
            var children = vnode.children;
            if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child != null) onremove(child);
            }
        }
    }
    //attrs
    function setAttrs(vnode, attrs, ns) {
        // If you assign an input type that is not supported by IE 11 with an assignment expression, an error will occur.
        //
        // Also, the DOM does things to inputs based on the value, so it needs set first.
        // See: https://github.com/MithrilJS/mithril.js/issues/2622
        if (vnode.tag === "input" && attrs.type != null) vnode.dom.setAttribute("type", attrs.type);
        var isFileInput = attrs != null && vnode.tag === "input" && attrs.type === "file";
        for(var key in attrs)setAttr(vnode, key, null, attrs[key], ns, isFileInput);
    }
    function setAttr(vnode, key, old, value, ns, isFileInput) {
        if (key === "key" || key === "is" || value == null || isLifecycleMethod(key) || old === value && !isFormAttribute(vnode, key) && typeof value !== "object" || key === "type" && vnode.tag === "input") return;
        if (key[0] === "o" && key[1] === "n") return updateEvent(vnode, key, value);
        if (key.slice(0, 6) === "xlink:") vnode.dom.setAttributeNS("http://www.w3.org/1999/xlink", key.slice(6), value);
        else if (key === "style") updateStyle(vnode.dom, old, value);
        else if (hasPropertyKey(vnode, key, ns)) {
            if (key === "value") {
                // Only do the coercion if we're actually going to check the value.
                /* eslint-disable no-implicit-coercion */ //setting input[value] to same value by typing on focused element moves cursor to end in Chrome
                //setting input[type=file][value] to same value causes an error to be generated if it's non-empty
                if ((vnode.tag === "input" || vnode.tag === "textarea") && vnode.dom.value === "" + value && (isFileInput || vnode.dom === activeElement())) return;
                //setting select[value] to same value while having select open blinks select dropdown in Chrome
                if (vnode.tag === "select" && old !== null && vnode.dom.value === "" + value) return;
                //setting option[value] to same value while having select open blinks select dropdown in Chrome
                if (vnode.tag === "option" && old !== null && vnode.dom.value === "" + value) return;
                //setting input[type=file][value] to different value is an error if it's non-empty
                // Not ideal, but it at least works around the most common source of uncaught exceptions for now.
                if (isFileInput && "" + value !== "") {
                    console.error("`value` is read-only on file inputs!");
                    return;
                }
            /* eslint-enable no-implicit-coercion */ }
            vnode.dom[key] = value;
        } else if (typeof value === "boolean") {
            if (value) vnode.dom.setAttribute(key, "");
            else vnode.dom.removeAttribute(key);
        } else vnode.dom.setAttribute(key === "className" ? "class" : key, value);
    }
    function removeAttr(vnode, key, old, ns) {
        if (key === "key" || key === "is" || old == null || isLifecycleMethod(key)) return;
        if (key[0] === "o" && key[1] === "n") updateEvent(vnode, key, undefined);
        else if (key === "style") updateStyle(vnode.dom, old, null);
        else if (hasPropertyKey(vnode, key, ns) && key !== "className" && key !== "title" // creates "null" as title
         && !(key === "value" && (vnode.tag === "option" || vnode.tag === "select" && vnode.dom.selectedIndex === -1 && vnode.dom === activeElement())) && !(vnode.tag === "input" && key === "type")) vnode.dom[key] = null;
        else {
            var nsLastIndex = key.indexOf(":");
            if (nsLastIndex !== -1) key = key.slice(nsLastIndex + 1);
            if (old !== false) vnode.dom.removeAttribute(key === "className" ? "class" : key);
        }
    }
    function setLateSelectAttrs(vnode, attrs) {
        if ("value" in attrs) {
            if (attrs.value === null) {
                if (vnode.dom.selectedIndex !== -1) vnode.dom.value = null;
            } else {
                var normalized = "" + attrs.value // eslint-disable-line no-implicit-coercion
                ;
                if (vnode.dom.value !== normalized || vnode.dom.selectedIndex === -1) vnode.dom.value = normalized;
            }
        }
        if ("selectedIndex" in attrs) setAttr(vnode, "selectedIndex", null, attrs.selectedIndex, undefined);
    }
    function updateAttrs(vnode, old, attrs, ns) {
        if (old && old === attrs) console.warn("Don't reuse attrs object, use new object for every redraw, this will throw in next major");
        if (attrs != null) {
            // If you assign an input type that is not supported by IE 11 with an assignment expression, an error will occur.
            //
            // Also, the DOM does things to inputs based on the value, so it needs set first.
            // See: https://github.com/MithrilJS/mithril.js/issues/2622
            if (vnode.tag === "input" && attrs.type != null) vnode.dom.setAttribute("type", attrs.type);
            var isFileInput = vnode.tag === "input" && attrs.type === "file";
            for(var key in attrs)setAttr(vnode, key, old && old[key], attrs[key], ns, isFileInput);
        }
        var val;
        if (old != null) {
            for(var key in old)if ((val = old[key]) != null && (attrs == null || attrs[key] == null)) removeAttr(vnode, key, val, ns);
        }
    }
    function isFormAttribute(vnode, attr) {
        return attr === "value" || attr === "checked" || attr === "selectedIndex" || attr === "selected" && vnode.dom === activeElement() || vnode.tag === "option" && vnode.dom.parentNode === $doc.activeElement;
    }
    function isLifecycleMethod(attr) {
        return attr === "oninit" || attr === "oncreate" || attr === "onupdate" || attr === "onremove" || attr === "onbeforeremove" || attr === "onbeforeupdate";
    }
    function hasPropertyKey(vnode, key, ns) {
        // Filter out namespaced keys
        return ns === undefined && // If it's a custom element, just keep it.
        (vnode.tag.indexOf("-") > -1 || vnode.attrs != null && vnode.attrs.is || // If it's a normal element, let's try to avoid a few browser bugs.
        key !== "href" && key !== "list" && key !== "form" && key !== "width" && key !== "height" // && key !== "type"
        ) && key in vnode.dom;
    }
    //style
    var uppercaseRegex = /[A-Z]/g;
    function toLowerCase(capital) {
        return "-" + capital.toLowerCase();
    }
    function normalizeKey(key) {
        return key[0] === "-" && key[1] === "-" ? key : key === "cssFloat" ? "float" : key.replace(uppercaseRegex, toLowerCase);
    }
    function updateStyle(element, old, style) {
        if (old === style) ;
        else if (style == null) // New style is missing, just clear it.
        element.style.cssText = "";
        else if (typeof style !== "object") // New style is a string, let engine deal with patching.
        element.style.cssText = style;
        else if (old == null || typeof old !== "object") {
            // `old` is missing or a string, `style` is an object.
            element.style.cssText = "";
            // Add new style properties
            for(var key in style){
                var value = style[key];
                if (value != null) element.style.setProperty(normalizeKey(key), String(value));
            }
        } else {
            // Both old & new are (different) objects.
            // Update style properties that have changed
            for(var key in style){
                var value = style[key];
                if (value != null && (value = String(value)) !== String(old[key])) element.style.setProperty(normalizeKey(key), value);
            }
            // Remove style properties that no longer exist
            for(var key in old)if (old[key] != null && style[key] == null) element.style.removeProperty(normalizeKey(key));
        }
    }
    // Here's an explanation of how this works:
    // 1. The event names are always (by design) prefixed by `on`.
    // 2. The EventListener interface accepts either a function or an object
    //    with a `handleEvent` method.
    // 3. The object does not inherit from `Object.prototype`, to avoid
    //    any potential interference with that (e.g. setters).
    // 4. The event name is remapped to the handler before calling it.
    // 5. In function-based event handlers, `ev.target === this`. We replicate
    //    that below.
    // 6. In function-based event handlers, `return false` prevents the default
    //    action and stops event propagation. We replicate that below.
    function EventDict() {
        // Save this, so the current redraw is correctly tracked.
        this._ = currentRedraw;
    }
    EventDict.prototype = Object.create(null);
    EventDict.prototype.handleEvent = function(ev) {
        var handler = this["on" + ev.type];
        var result;
        if (typeof handler === "function") result = handler.call(ev.currentTarget, ev);
        else if (typeof handler.handleEvent === "function") handler.handleEvent(ev);
        if (this._ && ev.redraw !== false) (0, this._)();
        if (result === false) {
            ev.preventDefault();
            ev.stopPropagation();
        }
    };
    //event
    function updateEvent(vnode, key, value) {
        if (vnode.events != null) {
            vnode.events._ = currentRedraw;
            if (vnode.events[key] === value) return;
            if (value != null && (typeof value === "function" || typeof value === "object")) {
                if (vnode.events[key] == null) vnode.dom.addEventListener(key.slice(2), vnode.events, false);
                vnode.events[key] = value;
            } else {
                if (vnode.events[key] != null) vnode.dom.removeEventListener(key.slice(2), vnode.events, false);
                vnode.events[key] = undefined;
            }
        } else if (value != null && (typeof value === "function" || typeof value === "object")) {
            vnode.events = new EventDict();
            vnode.dom.addEventListener(key.slice(2), vnode.events, false);
            vnode.events[key] = value;
        }
    }
    //lifecycle
    function initLifecycle(source, vnode, hooks) {
        if (typeof source.oninit === "function") callHook.call(source.oninit, vnode);
        if (typeof source.oncreate === "function") hooks.push(callHook.bind(source.oncreate, vnode));
    }
    function updateLifecycle(source, vnode, hooks) {
        if (typeof source.onupdate === "function") hooks.push(callHook.bind(source.onupdate, vnode));
    }
    function shouldNotUpdate(vnode, old) {
        do {
            if (vnode.attrs != null && typeof vnode.attrs.onbeforeupdate === "function") {
                var force = callHook.call(vnode.attrs.onbeforeupdate, vnode, old);
                if (force !== undefined && !force) break;
            }
            if (typeof vnode.tag !== "string" && typeof vnode.state.onbeforeupdate === "function") {
                var force = callHook.call(vnode.state.onbeforeupdate, vnode, old);
                if (force !== undefined && !force) break;
            }
            return false;
        }while (false); // eslint-disable-line no-constant-condition
        vnode.dom = old.dom;
        vnode.domSize = old.domSize;
        vnode.instance = old.instance;
        // One would think having the actual latest attributes would be ideal,
        // but it doesn't let us properly diff based on our current internal
        // representation. We have to save not only the old DOM info, but also
        // the attributes used to create it, as we diff *that*, not against the
        // DOM directly (with a few exceptions in `setAttr`). And, of course, we
        // need to save the children and text as they are conceptually not
        // unlike special "attributes" internally.
        vnode.attrs = old.attrs;
        vnode.children = old.children;
        vnode.text = old.text;
        return true;
    }
    var currentDOM;
    return function(dom, vnodes, redraw) {
        if (!dom) throw new TypeError("DOM element being rendered to does not exist.");
        if (currentDOM != null && dom.contains(currentDOM)) throw new TypeError("Node is currently being rendered to and thus is locked.");
        var prevRedraw = currentRedraw;
        var prevDOM = currentDOM;
        var hooks = [];
        var active = activeElement();
        var namespace = dom.namespaceURI;
        currentDOM = dom;
        currentRedraw = typeof redraw === "function" ? redraw : undefined;
        try {
            // First time rendering into a node clears it out
            if (dom.vnodes == null) dom.textContent = "";
            vnodes = $4k8M8.normalizeChildren(Array.isArray(vnodes) ? vnodes : [
                vnodes
            ]);
            updateNodes(dom, dom.vnodes, vnodes, hooks, null, namespace === "http://www.w3.org/1999/xhtml" ? undefined : namespace);
            dom.vnodes = vnodes;
            // `document.activeElement` can return null: https://html.spec.whatwg.org/multipage/interaction.html#dom-document-activeelement
            if (active != null && activeElement() !== active && typeof active.focus === "function") active.focus();
            for(var i = 0; i < hooks.length; i++)hooks[i]();
        } finally{
            currentRedraw = prevRedraw;
            currentDOM = prevDOM;
        }
    };
};

});


parcelRegister("eNh2e", function(module, exports) {
"use strict";

var $4k8M8 = parcelRequire("4k8M8");
module.exports = function(render, schedule, console) {
    var subscriptions = [];
    var pending = false;
    var offset = -1;
    function sync() {
        for(offset = 0; offset < subscriptions.length; offset += 2)try {
            render(subscriptions[offset], $4k8M8(subscriptions[offset + 1]), redraw);
        } catch (e) {
            console.error(e);
        }
        offset = -1;
    }
    function redraw() {
        if (!pending) {
            pending = true;
            schedule(function() {
                pending = false;
                sync();
            });
        }
    }
    redraw.sync = sync;
    function mount(root, component) {
        if (component != null && component.view == null && typeof component !== "function") throw new TypeError("m.mount expects a component, not a vnode.");
        var index = subscriptions.indexOf(root);
        if (index >= 0) {
            subscriptions.splice(index, 2);
            if (index <= offset) offset -= 2;
            render(root, []);
        }
        if (component != null) {
            subscriptions.push(root, component);
            render(root, $4k8M8(component), redraw);
        }
    }
    return {
        mount: mount,
        redraw: redraw
    };
};

});

parcelRegister("h5ivH", function(module, exports) {
"use strict";

var $du6FX = parcelRequire("du6FX");

var $7ezzr = parcelRequire("7ezzr");
module.exports = function($window, Promise, oncompletion) {
    var callbackCount = 0;
    function PromiseProxy(executor) {
        return new Promise(executor);
    }
    // In case the global Promise is some userland library's where they rely on
    // `foo instanceof this.constructor`, `this.constructor.resolve(value)`, or
    // similar. Let's *not* break them.
    PromiseProxy.prototype = Promise.prototype;
    PromiseProxy.__proto__ = Promise // eslint-disable-line no-proto
    ;
    function makeRequest(factory) {
        return function(url, args) {
            if (typeof url !== "string") {
                args = url;
                url = url.url;
            } else if (args == null) args = {};
            var promise = new Promise(function(resolve, reject) {
                factory($du6FX(url, args.params), args, function(data) {
                    if (typeof args.type === "function") {
                        if (Array.isArray(data)) for(var i = 0; i < data.length; i++)data[i] = new args.type(data[i]);
                        else data = new args.type(data);
                    }
                    resolve(data);
                }, reject);
            });
            if (args.background === true) return promise;
            var count = 0;
            function complete() {
                if (--count === 0 && typeof oncompletion === "function") oncompletion();
            }
            return wrap(promise);
            function wrap(promise) {
                var then = promise.then;
                // Set the constructor, so engines know to not await or resolve
                // this as a native promise. At the time of writing, this is
                // only necessary for V8, but their behavior is the correct
                // behavior per spec. See this spec issue for more details:
                // https://github.com/tc39/ecma262/issues/1577. Also, see the
                // corresponding comment in `request/tests/test-request.js` for
                // a bit more background on the issue at hand.
                promise.constructor = PromiseProxy;
                promise.then = function() {
                    count++;
                    var next = then.apply(promise, arguments);
                    next.then(complete, function(e) {
                        complete();
                        if (count === 0) throw e;
                    });
                    return wrap(next);
                };
                return promise;
            }
        };
    }
    function hasHeader(args, name) {
        for(var key in args.headers){
            if ($7ezzr.call(args.headers, key) && key.toLowerCase() === name) return true;
        }
        return false;
    }
    return {
        request: makeRequest(function(url, args, resolve, reject) {
            var method = args.method != null ? args.method.toUpperCase() : "GET";
            var body = args.body;
            var assumeJSON = (args.serialize == null || args.serialize === JSON.serialize) && !(body instanceof $window.FormData || body instanceof $window.URLSearchParams);
            var responseType = args.responseType || (typeof args.extract === "function" ? "" : "json");
            var xhr = new $window.XMLHttpRequest(), aborted = false, isTimeout = false;
            var original = xhr, replacedAbort;
            var abort = xhr.abort;
            xhr.abort = function() {
                aborted = true;
                abort.call(this);
            };
            xhr.open(method, url, args.async !== false, typeof args.user === "string" ? args.user : undefined, typeof args.password === "string" ? args.password : undefined);
            if (assumeJSON && body != null && !hasHeader(args, "content-type")) xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");
            if (typeof args.deserialize !== "function" && !hasHeader(args, "accept")) xhr.setRequestHeader("Accept", "application/json, text/*");
            if (args.withCredentials) xhr.withCredentials = args.withCredentials;
            if (args.timeout) xhr.timeout = args.timeout;
            xhr.responseType = responseType;
            for(var key in args.headers)if ($7ezzr.call(args.headers, key)) xhr.setRequestHeader(key, args.headers[key]);
            xhr.onreadystatechange = function(ev) {
                // Don't throw errors on xhr.abort().
                if (aborted) return;
                if (ev.target.readyState === 4) try {
                    var success = ev.target.status >= 200 && ev.target.status < 300 || ev.target.status === 304 || /^file:\/\//i.test(url);
                    // When the response type isn't "" or "text",
                    // `xhr.responseText` is the wrong thing to use.
                    // Browsers do the right thing and throw here, and we
                    // should honor that and do the right thing by
                    // preferring `xhr.response` where possible/practical.
                    var response = ev.target.response, message;
                    if (responseType === "json") {
                        // For IE and Edge, which don't implement
                        // `responseType: "json"`.
                        if (!ev.target.responseType && typeof args.extract !== "function") // Handle no-content which will not parse.
                        try {
                            response = JSON.parse(ev.target.responseText);
                        } catch (e) {
                            response = null;
                        }
                    } else if (!responseType || responseType === "text") // Only use this default if it's text. If a parsed
                    // document is needed on old IE and friends (all
                    // unsupported), the user should use a custom
                    // `config` instead. They're already using this at
                    // their own risk.
                    {
                        if (response == null) response = ev.target.responseText;
                    }
                    if (typeof args.extract === "function") {
                        response = args.extract(ev.target, args);
                        success = true;
                    } else if (typeof args.deserialize === "function") response = args.deserialize(response);
                    if (success) resolve(response);
                    else {
                        var completeErrorResponse = function() {
                            try {
                                message = ev.target.responseText;
                            } catch (e) {
                                message = response;
                            }
                            var error = new Error(message);
                            error.code = ev.target.status;
                            error.response = response;
                            reject(error);
                        };
                        if (xhr.status === 0) // Use setTimeout to push this code block onto the event queue
                        // This allows `xhr.ontimeout` to run in the case that there is a timeout
                        // Without this setTimeout, `xhr.ontimeout` doesn't have a chance to reject
                        // as `xhr.onreadystatechange` will run before it
                        setTimeout(function() {
                            if (isTimeout) return;
                            completeErrorResponse();
                        });
                        else completeErrorResponse();
                    }
                } catch (e) {
                    reject(e);
                }
            };
            xhr.ontimeout = function(ev) {
                isTimeout = true;
                var error = new Error("Request timed out");
                error.code = ev.target.status;
                reject(error);
            };
            if (typeof args.config === "function") {
                xhr = args.config(xhr, args, url) || xhr;
                // Propagate the `abort` to any replacement XHR as well.
                if (xhr !== original) {
                    replacedAbort = xhr.abort;
                    xhr.abort = function() {
                        aborted = true;
                        replacedAbort.call(this);
                    };
                }
            }
            if (body == null) xhr.send();
            else if (typeof args.serialize === "function") xhr.send(args.serialize(body));
            else if (body instanceof $window.FormData || body instanceof $window.URLSearchParams) xhr.send(body);
            else xhr.send(JSON.stringify(body));
        }),
        jsonp: makeRequest(function(url, args, resolve, reject) {
            var callbackName = args.callbackName || "_mithril_" + Math.round(Math.random() * 1e16) + "_" + callbackCount++;
            var script = $window.document.createElement("script");
            $window[callbackName] = function(data) {
                delete $window[callbackName];
                script.parentNode.removeChild(script);
                resolve(data);
            };
            script.onerror = function() {
                delete $window[callbackName];
                script.parentNode.removeChild(script);
                reject(new Error("JSONP request failed"));
            };
            script.src = url + (url.indexOf("?") < 0 ? "?" : "&") + encodeURIComponent(args.callbackKey || "callback") + "=" + encodeURIComponent(callbackName);
            $window.document.documentElement.appendChild(script);
        })
    };
};

});
parcelRegister("du6FX", function(module, exports) {
"use strict";

var $eY9jh = parcelRequire("eY9jh");

var $fbbBc = parcelRequire("fbbBc");
// Returns `path` from `template` + `params`
module.exports = function(template, params) {
    if (/:([^\/\.-]+)(\.{3})?:/.test(template)) throw new SyntaxError("Template parameter names must be separated by either a '/', '-', or '.'.");
    if (params == null) return template;
    var queryIndex = template.indexOf("?");
    var hashIndex = template.indexOf("#");
    var queryEnd = hashIndex < 0 ? template.length : hashIndex;
    var pathEnd = queryIndex < 0 ? queryEnd : queryIndex;
    var path = template.slice(0, pathEnd);
    var query = {};
    $fbbBc(query, params);
    var resolved = path.replace(/:([^\/\.-]+)(\.{3})?/g, function(m, key, variadic) {
        delete query[key];
        // If no such parameter exists, don't interpolate it.
        if (params[key] == null) return m;
        // Escape normal parameters, but not variadic ones.
        return variadic ? params[key] : encodeURIComponent(String(params[key]));
    });
    // In case the template substitution adds new query/hash parameters.
    var newQueryIndex = resolved.indexOf("?");
    var newHashIndex = resolved.indexOf("#");
    var newQueryEnd = newHashIndex < 0 ? resolved.length : newHashIndex;
    var newPathEnd = newQueryIndex < 0 ? newQueryEnd : newQueryIndex;
    var result = resolved.slice(0, newPathEnd);
    if (queryIndex >= 0) result += template.slice(queryIndex, queryEnd);
    if (newQueryIndex >= 0) result += (queryIndex < 0 ? "?" : "&") + resolved.slice(newQueryIndex, newQueryEnd);
    var querystring = $eY9jh(query);
    if (querystring) result += (queryIndex < 0 && newQueryIndex < 0 ? "?" : "&") + querystring;
    if (hashIndex >= 0) result += template.slice(hashIndex);
    if (newHashIndex >= 0) result += (hashIndex < 0 ? "" : "&") + resolved.slice(newHashIndex);
    return result;
};

});
parcelRegister("eY9jh", function(module, exports) {
"use strict";
module.exports = function(object) {
    if (Object.prototype.toString.call(object) !== "[object Object]") return "";
    var args = [];
    for(var key in object)destructure(key, object[key]);
    return args.join("&");
    function destructure(key, value) {
        if (Array.isArray(value)) for(var i = 0; i < value.length; i++)destructure(key + "[" + i + "]", value[i]);
        else if (Object.prototype.toString.call(value) === "[object Object]") for(var i in value)destructure(key + "[" + i + "]", value[i]);
        else args.push(encodeURIComponent(key) + (value != null && value !== "" ? "=" + encodeURIComponent(value) : ""));
    }
};

});

parcelRegister("fbbBc", function(module, exports) {
// This exists so I'm only saving it once.
"use strict";

var $7ezzr = parcelRequire("7ezzr");
module.exports = Object.assign || function(target, source) {
    for(var key in source)if ($7ezzr.call(source, key)) target[key] = source[key];
};

});
parcelRegister("7ezzr", function(module, exports) {
// This exists so I'm only saving it once.
"use strict";
module.exports = ({}).hasOwnProperty;

});




parcelRegister("chKJA", function(module, exports) {
"use strict";

var $2ykbI = parcelRequire("2ykbI");

module.exports = (parcelRequire("2JyUv"))(typeof window !== "undefined" ? window : null, $2ykbI);

});
parcelRegister("2ykbI", function(module, exports) {
"use strict";

var $kOTGc = parcelRequire("kOTGc");

module.exports = (parcelRequire("eNh2e"))($kOTGc, typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : null, typeof console !== "undefined" ? console : null);

});

parcelRegister("2JyUv", function(module, exports) {
"use strict";

var $4k8M8 = parcelRequire("4k8M8");

var $5Fe89 = parcelRequire("5Fe89");

var $2zqO5 = parcelRequire("2zqO5");

var $du6FX = parcelRequire("du6FX");

var $3pZOj = parcelRequire("3pZOj");

var $5JLhg = parcelRequire("5JLhg");

var $fbbBc = parcelRequire("fbbBc");

var $zg7DE = parcelRequire("zg7DE");
var $1fdadd3abd33f920$var$sentinel = {};
function $1fdadd3abd33f920$var$decodeURIComponentSave(component) {
    try {
        return decodeURIComponent(component);
    } catch (e) {
        return component;
    }
}
module.exports = function($window, mountRedraw) {
    var callAsync = $window == null ? null : typeof $window.setImmediate === "function" ? $window.setImmediate : $window.setTimeout;
    var p = $2zqO5.resolve();
    var scheduled = false;
    // state === 0: init
    // state === 1: scheduled
    // state === 2: done
    var ready = false;
    var state = 0;
    var compiled, fallbackRoute;
    var currentResolver = $1fdadd3abd33f920$var$sentinel, component, attrs, currentPath, lastUpdate;
    var RouterRoot = {
        onbeforeupdate: function() {
            state = state ? 2 : 1;
            return !(!state || $1fdadd3abd33f920$var$sentinel === currentResolver);
        },
        onremove: function() {
            $window.removeEventListener("popstate", fireAsync, false);
            $window.removeEventListener("hashchange", resolveRoute, false);
        },
        view: function() {
            if (!state || $1fdadd3abd33f920$var$sentinel === currentResolver) return;
            // Wrap in a fragment to preserve existing key semantics
            var vnode = [
                $4k8M8(component, attrs.key, attrs)
            ];
            if (currentResolver) vnode = currentResolver.render(vnode[0]);
            return vnode;
        }
    };
    var SKIP = route.SKIP = {};
    function resolveRoute() {
        scheduled = false;
        // Consider the pathname holistically. The prefix might even be invalid,
        // but that's not our problem.
        var prefix = $window.location.hash;
        if (route.prefix[0] !== "#") {
            prefix = $window.location.search + prefix;
            if (route.prefix[0] !== "?") {
                prefix = $window.location.pathname + prefix;
                if (prefix[0] !== "/") prefix = "/" + prefix;
            }
        }
        // This seemingly useless `.concat()` speeds up the tests quite a bit,
        // since the representation is consistently a relatively poorly
        // optimized cons string.
        var path = prefix.concat().replace(/(?:%[a-f89][a-f0-9])+/gim, $1fdadd3abd33f920$var$decodeURIComponentSave).slice(route.prefix.length);
        var data = $3pZOj(path);
        $fbbBc(data.params, $window.history.state);
        function reject(e) {
            console.error(e);
            setPath(fallbackRoute, null, {
                replace: true
            });
        }
        loop(0);
        function loop(i) {
            // state === 0: init
            // state === 1: scheduled
            // state === 2: done
            for(; i < compiled.length; i++)if (compiled[i].check(data)) {
                var payload = compiled[i].component;
                var matchedRoute = compiled[i].route;
                var localComp = payload;
                var update = lastUpdate = function(comp) {
                    if (update !== lastUpdate) return;
                    if (comp === SKIP) return loop(i + 1);
                    component = comp != null && (typeof comp.view === "function" || typeof comp === "function") ? comp : "div";
                    attrs = data.params, currentPath = path, lastUpdate = null;
                    currentResolver = payload.render ? payload : null;
                    if (state === 2) mountRedraw.redraw();
                    else {
                        state = 2;
                        mountRedraw.redraw.sync();
                    }
                };
                // There's no understating how much I *wish* I could
                // use `async`/`await` here...
                if (payload.view || typeof payload === "function") {
                    payload = {};
                    update(localComp);
                } else if (payload.onmatch) p.then(function() {
                    return payload.onmatch(data.params, path, matchedRoute);
                }).then(update, path === fallbackRoute ? null : reject);
                else update("div");
                return;
            }
            if (path === fallbackRoute) throw new Error("Could not resolve default route " + fallbackRoute + ".");
            setPath(fallbackRoute, null, {
                replace: true
            });
        }
    }
    // Set it unconditionally so `m.route.set` and `m.route.Link` both work,
    // even if neither `pushState` nor `hashchange` are supported. It's
    // cleared if `hashchange` is used, since that makes it automatically
    // async.
    function fireAsync() {
        if (!scheduled) {
            scheduled = true;
            // TODO: just do `mountRedraw.redraw()` here and elide the timer
            // dependency. Note that this will muck with tests a *lot*, so it's
            // not as easy of a change as it sounds.
            callAsync(resolveRoute);
        }
    }
    function setPath(path, data, options) {
        path = $du6FX(path, data);
        if (ready) {
            fireAsync();
            var state = options ? options.state : null;
            var title = options ? options.title : null;
            if (options && options.replace) $window.history.replaceState(state, title, route.prefix + path);
            else $window.history.pushState(state, title, route.prefix + path);
        } else $window.location.href = route.prefix + path;
    }
    function route(root, defaultRoute, routes) {
        if (!root) throw new TypeError("DOM element being rendered to does not exist.");
        compiled = Object.keys(routes).map(function(route) {
            if (route[0] !== "/") throw new SyntaxError("Routes must start with a '/'.");
            if (/:([^\/\.-]+)(\.{3})?:/.test(route)) throw new SyntaxError("Route parameter names must be separated with either '/', '.', or '-'.");
            return {
                route: route,
                component: routes[route],
                check: $5JLhg(route)
            };
        });
        fallbackRoute = defaultRoute;
        if (defaultRoute != null) {
            var defaultData = $3pZOj(defaultRoute);
            if (!compiled.some(function(i) {
                return i.check(defaultData);
            })) throw new ReferenceError("Default route doesn't match any known routes.");
        }
        if (typeof $window.history.pushState === "function") $window.addEventListener("popstate", fireAsync, false);
        else if (route.prefix[0] === "#") $window.addEventListener("hashchange", resolveRoute, false);
        ready = true;
        mountRedraw.mount(root, RouterRoot);
        resolveRoute();
    }
    route.set = function(path, data, options) {
        if (lastUpdate != null) {
            options = options || {};
            options.replace = true;
        }
        lastUpdate = null;
        setPath(path, data, options);
    };
    route.get = function() {
        return currentPath;
    };
    route.prefix = "#!";
    route.Link = {
        view: function(vnode) {
            // Omit the used parameters from the rendered element - they are
            // internal. Also, censor the various lifecycle methods.
            //
            // We don't strip the other parameters because for convenience we
            // let them be specified in the selector as well.
            var child = $5Fe89(vnode.attrs.selector || "a", $zg7DE(vnode.attrs, [
                "options",
                "params",
                "selector",
                "onclick"
            ]), vnode.children);
            var options, onclick, href;
            // Let's provide a *right* way to disable a route link, rather than
            // letting people screw up accessibility on accident.
            //
            // The attribute is coerced so users don't get surprised over
            // `disabled: 0` resulting in a button that's somehow routable
            // despite being visibly disabled.
            if (child.attrs.disabled = Boolean(child.attrs.disabled)) {
                child.attrs.href = null;
                child.attrs["aria-disabled"] = "true";
            // If you *really* do want add `onclick` on a disabled link, use
            // an `oncreate` hook to add it.
            } else {
                options = vnode.attrs.options;
                onclick = vnode.attrs.onclick;
                // Easier to build it now to keep it isomorphic.
                href = $du6FX(child.attrs.href, vnode.attrs.params);
                child.attrs.href = route.prefix + href;
                child.attrs.onclick = function(e) {
                    var result;
                    if (typeof onclick === "function") result = onclick.call(e.currentTarget, e);
                    else if (onclick == null || typeof onclick !== "object") ;
                    else if (typeof onclick.handleEvent === "function") onclick.handleEvent(e);
                    // Adapted from React Router's implementation:
                    // https://github.com/ReactTraining/react-router/blob/520a0acd48ae1b066eb0b07d6d4d1790a1d02482/packages/react-router-dom/modules/Link.js
                    //
                    // Try to be flexible and intuitive in how we handle links.
                    // Fun fact: links aren't as obvious to get right as you
                    // would expect. There's a lot more valid ways to click a
                    // link than this, and one might want to not simply click a
                    // link, but right click or command-click it to copy the
                    // link target, etc. Nope, this isn't just for blind people.
                    if (// Skip if `onclick` prevented default
                    result !== false && !e.defaultPrevented && // Ignore everything but left clicks
                    (e.button === 0 || e.which === 0 || e.which === 1) && // Let the browser handle `target=_blank`, etc.
                    (!e.currentTarget.target || e.currentTarget.target === "_self") && // No modifier keys
                    !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey) {
                        e.preventDefault();
                        e.redraw = false;
                        route.set(href, null, options);
                    }
                };
            }
            return child;
        }
    };
    route.param = function(key) {
        return attrs && key != null ? attrs[key] : attrs;
    };
    return route;
};

});
parcelRegister("5Fe89", function(module, exports) {
"use strict";

var $4k8M8 = parcelRequire("4k8M8");

var $eJpVZ = parcelRequire("eJpVZ");

var $7ezzr = parcelRequire("7ezzr");
var $41fbbe194bdba758$var$selectorParser = /(?:(^|#|\.)([^#\.\[\]]+))|(\[(.+?)(?:\s*=\s*("|'|)((?:\\["'\]]|.)*?)\5)?\])/g;
var $41fbbe194bdba758$var$selectorCache = {};
function $41fbbe194bdba758$var$isEmpty(object) {
    for(var key in object)if ($7ezzr.call(object, key)) return false;
    return true;
}
function $41fbbe194bdba758$var$compileSelector(selector) {
    var match, tag = "div", classes = [], attrs = {};
    while(match = $41fbbe194bdba758$var$selectorParser.exec(selector)){
        var type = match[1], value = match[2];
        if (type === "" && value !== "") tag = value;
        else if (type === "#") attrs.id = value;
        else if (type === ".") classes.push(value);
        else if (match[3][0] === "[") {
            var attrValue = match[6];
            if (attrValue) attrValue = attrValue.replace(/\\(["'])/g, "$1").replace(/\\\\/g, "\\");
            if (match[4] === "class") classes.push(attrValue);
            else attrs[match[4]] = attrValue === "" ? attrValue : attrValue || true;
        }
    }
    if (classes.length > 0) attrs.className = classes.join(" ");
    return $41fbbe194bdba758$var$selectorCache[selector] = {
        tag: tag,
        attrs: attrs
    };
}
function $41fbbe194bdba758$var$execSelector(state, vnode) {
    var attrs = vnode.attrs;
    var hasClass = $7ezzr.call(attrs, "class");
    var className = hasClass ? attrs.class : attrs.className;
    vnode.tag = state.tag;
    vnode.attrs = {};
    if (!$41fbbe194bdba758$var$isEmpty(state.attrs) && !$41fbbe194bdba758$var$isEmpty(attrs)) {
        var newAttrs = {};
        for(var key in attrs)if ($7ezzr.call(attrs, key)) newAttrs[key] = attrs[key];
        attrs = newAttrs;
    }
    for(var key in state.attrs)if ($7ezzr.call(state.attrs, key) && key !== "className" && !$7ezzr.call(attrs, key)) attrs[key] = state.attrs[key];
    if (className != null || state.attrs.className != null) attrs.className = className != null ? state.attrs.className != null ? String(state.attrs.className) + " " + String(className) : className : state.attrs.className != null ? state.attrs.className : null;
    if (hasClass) attrs.class = null;
    for(var key in attrs)if ($7ezzr.call(attrs, key) && key !== "key") {
        vnode.attrs = attrs;
        break;
    }
    return vnode;
}
function $41fbbe194bdba758$var$hyperscript(selector) {
    if (selector == null || typeof selector !== "string" && typeof selector !== "function" && typeof selector.view !== "function") throw Error("The selector must be either a string or a component.");
    var vnode = $eJpVZ.apply(1, arguments);
    if (typeof selector === "string") {
        vnode.children = $4k8M8.normalizeChildren(vnode.children);
        if (selector !== "[") return $41fbbe194bdba758$var$execSelector($41fbbe194bdba758$var$selectorCache[selector] || $41fbbe194bdba758$var$compileSelector(selector), vnode);
    }
    vnode.tag = selector;
    return vnode;
}
module.exports = $41fbbe194bdba758$var$hyperscript;

});

parcelRegister("2zqO5", function(module, exports) {
/* global window */ "use strict";

var $3UKYh = parcelRequire("3UKYh");
if (typeof window !== "undefined") {
    if (typeof window.Promise === "undefined") window.Promise = $3UKYh;
    else if (!window.Promise.prototype.finally) window.Promise.prototype.finally = $3UKYh.prototype.finally;
    module.exports = window.Promise;
} else if (typeof $parcel$global !== "undefined") {
    if (typeof $parcel$global.Promise === "undefined") $parcel$global.Promise = $3UKYh;
    else if (!$parcel$global.Promise.prototype.finally) $parcel$global.Promise.prototype.finally = $3UKYh.prototype.finally;
    module.exports = $parcel$global.Promise;
} else module.exports = $3UKYh;

});

parcelRegister("3pZOj", function(module, exports) {
"use strict";

var $8mO4U = parcelRequire("8mO4U");
// Returns `{path, params}` from `url`
module.exports = function(url) {
    var queryIndex = url.indexOf("?");
    var hashIndex = url.indexOf("#");
    var queryEnd = hashIndex < 0 ? url.length : hashIndex;
    var pathEnd = queryIndex < 0 ? queryEnd : queryIndex;
    var path = url.slice(0, pathEnd).replace(/\/{2,}/g, "/");
    if (!path) path = "/";
    else {
        if (path[0] !== "/") path = "/" + path;
        if (path.length > 1 && path[path.length - 1] === "/") path = path.slice(0, -1);
    }
    return {
        path: path,
        params: queryIndex < 0 ? {} : $8mO4U(url.slice(queryIndex + 1, queryEnd))
    };
};

});
parcelRegister("8mO4U", function(module, exports) {
"use strict";
function $6177394b9349d792$var$decodeURIComponentSave(str) {
    try {
        return decodeURIComponent(str);
    } catch (err) {
        return str;
    }
}
module.exports = function(string) {
    if (string === "" || string == null) return {};
    if (string.charAt(0) === "?") string = string.slice(1);
    var entries = string.split("&"), counters = {}, data = {};
    for(var i = 0; i < entries.length; i++){
        var entry = entries[i].split("=");
        var key = $6177394b9349d792$var$decodeURIComponentSave(entry[0]);
        var value = entry.length === 2 ? $6177394b9349d792$var$decodeURIComponentSave(entry[1]) : "";
        if (value === "true") value = true;
        else if (value === "false") value = false;
        var levels = key.split(/\]\[?|\[/);
        var cursor = data;
        if (key.indexOf("[") > -1) levels.pop();
        for(var j = 0; j < levels.length; j++){
            var level = levels[j], nextLevel = levels[j + 1];
            var isNumber = nextLevel == "" || !isNaN(parseInt(nextLevel, 10));
            if (level === "") {
                var key = levels.slice(0, j).join();
                if (counters[key] == null) counters[key] = Array.isArray(cursor) ? cursor.length : 0;
                level = counters[key]++;
            } else if (level === "__proto__") break;
            if (j === levels.length - 1) cursor[level] = value;
            else {
                // Read own properties exclusively to disallow indirect
                // prototype pollution
                var desc = Object.getOwnPropertyDescriptor(cursor, level);
                if (desc != null) desc = desc.value;
                if (desc == null) cursor[level] = desc = isNumber ? [] : {};
                cursor = desc;
            }
        }
    }
    return data;
};

});


parcelRegister("5JLhg", function(module, exports) {
"use strict";

var $3pZOj = parcelRequire("3pZOj");
// Compiles a template into a function that takes a resolved path (without query
// strings) and returns an object containing the template parameters with their
// parsed values. This expects the input of the compiled template to be the
// output of `parsePathname`. Note that it does *not* remove query parameters
// specified in the template.
module.exports = function(template) {
    var templateData = $3pZOj(template);
    var templateKeys = Object.keys(templateData.params);
    var keys = [];
    var regexp = new RegExp("^" + templateData.path.replace(// I escape literal text so people can use things like `:file.:ext` or
    // `:lang-:locale` in routes. This is all merged into one pass so I
    // don't also accidentally escape `-` and make it harder to detect it to
    // ban it from template parameters.
    /:([^\/.-]+)(\.{3}|\.(?!\.)|-)?|[\\^$*+.()|\[\]{}]/g, function(m, key, extra) {
        if (key == null) return "\\" + m;
        keys.push({
            k: key,
            r: extra === "..."
        });
        if (extra === "...") return "(.*)";
        if (extra === ".") return "([^/]+)\\.";
        return "([^/]+)" + (extra || "");
    }) + "$");
    return function(data) {
        // First, check the params. Usually, there isn't any, and it's just
        // checking a static set.
        for(var i = 0; i < templateKeys.length; i++){
            if (templateData.params[templateKeys[i]] !== data.params[templateKeys[i]]) return false;
        }
        // If no interpolations exist, let's skip all the ceremony
        if (!keys.length) return regexp.test(data.path);
        var values = regexp.exec(data.path);
        if (values == null) return false;
        for(var i = 0; i < keys.length; i++)data.params[keys[i].k] = keys[i].r ? values[i + 1] : decodeURIComponent(values[i + 1]);
        return true;
    };
};

});

parcelRegister("zg7DE", function(module, exports) {
"use strict";

var $7ezzr = parcelRequire("7ezzr");
// Words in RegExp literals are sometimes mangled incorrectly by the internal bundler, so use RegExp().
var $069fc688592cd9ff$var$magic = new RegExp("^(?:key|oninit|oncreate|onbeforeupdate|onupdate|onbeforeremove|onremove)$");
module.exports = function(attrs, extras) {
    var result = {};
    if (extras != null) {
        for(var key in attrs)if ($7ezzr.call(attrs, key) && !$069fc688592cd9ff$var$magic.test(key) && extras.indexOf(key) < 0) result[key] = attrs[key];
    } else {
        for(var key in attrs)if ($7ezzr.call(attrs, key) && !$069fc688592cd9ff$var$magic.test(key)) result[key] = attrs[key];
    }
    return result;
};

});



parcelRegister("f5dPJ", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("gisW9", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $PEwcN = parcelRequire("PEwcN");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $PEwcN.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $PEwcN.default)(Rgb, rgb, (0, $PEwcN.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $PEwcN.default)(Hsl, hsl, (0, $PEwcN.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("PEwcN", function(module, exports) {

$parcel$export(module.exports, "default", () => $09b431a73d2b2057$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $09b431a73d2b2057$export$8b58be045bf06082);
function $09b431a73d2b2057$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $09b431a73d2b2057$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("61ebs", function(module, exports) {

$parcel$export(module.exports, "point", () => point);
$parcel$export(module.exports, "default", () => $461dd6b16a287958$export$2e2bcd8739ae039);

var $5Wuwv = parcelRequire("5Wuwv");

var $hpcPW = parcelRequire("hpcPW");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, $5Wuwv.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, $5Wuwv.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $461dd6b16a287958$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, $hpcPW.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("5Wuwv", function(module, exports) {

$parcel$export(module.exports, "abs", () => $453a0bccc684abd9$export$2335f513bbd82c6d);
$parcel$export(module.exports, "atan2", () => $453a0bccc684abd9$export$b8b770ee6a0d9760);
$parcel$export(module.exports, "cos", () => $453a0bccc684abd9$export$50d414a77b60d802);
$parcel$export(module.exports, "max", () => $453a0bccc684abd9$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $453a0bccc684abd9$export$96ec731ed4dcb222);
$parcel$export(module.exports, "sin", () => $453a0bccc684abd9$export$5de3937cb4b592ed);
$parcel$export(module.exports, "sqrt", () => $453a0bccc684abd9$export$eba8049fb5020b81);
$parcel$export(module.exports, "epsilon", () => $453a0bccc684abd9$export$6c421550c66a327d);
$parcel$export(module.exports, "pi", () => $453a0bccc684abd9$export$18c7bea995a110f);
$parcel$export(module.exports, "halfPi", () => $453a0bccc684abd9$export$e51408a300e8929a);
$parcel$export(module.exports, "tau", () => $453a0bccc684abd9$export$a4b4b4d4d776fe92);
$parcel$export(module.exports, "acos", () => $453a0bccc684abd9$export$fd6306be3fde5b04);
$parcel$export(module.exports, "asin", () => $453a0bccc684abd9$export$41726bdb1fc63f);
const $453a0bccc684abd9$export$2335f513bbd82c6d = Math.abs;
const $453a0bccc684abd9$export$b8b770ee6a0d9760 = Math.atan2;
const $453a0bccc684abd9$export$50d414a77b60d802 = Math.cos;
const $453a0bccc684abd9$export$8960430cfd85939f = Math.max;
const $453a0bccc684abd9$export$96ec731ed4dcb222 = Math.min;
const $453a0bccc684abd9$export$5de3937cb4b592ed = Math.sin;
const $453a0bccc684abd9$export$eba8049fb5020b81 = Math.sqrt;
const $453a0bccc684abd9$export$6c421550c66a327d = 1e-12;
const $453a0bccc684abd9$export$18c7bea995a110f = Math.PI;
const $453a0bccc684abd9$export$e51408a300e8929a = $453a0bccc684abd9$export$18c7bea995a110f / 2;
const $453a0bccc684abd9$export$a4b4b4d4d776fe92 = 2 * $453a0bccc684abd9$export$18c7bea995a110f;
function $453a0bccc684abd9$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $453a0bccc684abd9$export$18c7bea995a110f : Math.acos(x);
}
function $453a0bccc684abd9$export$41726bdb1fc63f(x) {
    return x >= 1 ? $453a0bccc684abd9$export$e51408a300e8929a : x <= -1 ? -$453a0bccc684abd9$export$e51408a300e8929a : Math.asin(x);
}

});

parcelRegister("hpcPW", function(module, exports) {

$parcel$export(module.exports, "point", () => $cabeba982504b7d2$export$105684a3041cb6f3);
$parcel$export(module.exports, "Cardinal", () => $cabeba982504b7d2$export$ee51ff373511cbeb);
$parcel$export(module.exports, "default", () => $cabeba982504b7d2$export$2e2bcd8739ae039);
function $cabeba982504b7d2$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $cabeba982504b7d2$export$ee51ff373511cbeb(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$cabeba982504b7d2$export$ee51ff373511cbeb.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $cabeba982504b7d2$export$105684a3041cb6f3(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                $cabeba982504b7d2$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $cabeba982504b7d2$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $cabeba982504b7d2$export$ee51ff373511cbeb(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


/* 2024 Jan Provaznik (jan@provaznik.pro)
 */ var $1db9ba4f1f551c94$exports = {};
"use strict";
var $b26ba759aec39482$exports = {};
"use strict";

var $5Fe89 = parcelRequire("5Fe89");

$5Fe89.trust = (parcelRequire("jtFfp"));

$5Fe89.fragment = (parcelRequire("61OSB"));
$b26ba759aec39482$exports = $5Fe89;


var $b7f6a7e8d3e11d54$exports = {};
"use strict";

var $2zqO5 = parcelRequire("2zqO5");

var $2ykbI = parcelRequire("2ykbI");

$b7f6a7e8d3e11d54$exports = (parcelRequire("h5ivH"))(typeof window !== "undefined" ? window : null, $2zqO5, $2ykbI.redraw);



var $2ykbI = parcelRequire("2ykbI");
var $1db9ba4f1f551c94$var$m = function m() {
    return $b26ba759aec39482$exports.apply(this, arguments);
};
$1db9ba4f1f551c94$var$m.m = $b26ba759aec39482$exports;
$1db9ba4f1f551c94$var$m.trust = $b26ba759aec39482$exports.trust;
$1db9ba4f1f551c94$var$m.fragment = $b26ba759aec39482$exports.fragment;
$1db9ba4f1f551c94$var$m.Fragment = "[";
$1db9ba4f1f551c94$var$m.mount = $2ykbI.mount;

$1db9ba4f1f551c94$var$m.route = (parcelRequire("chKJA"));

$1db9ba4f1f551c94$var$m.render = (parcelRequire("kOTGc"));
$1db9ba4f1f551c94$var$m.redraw = $2ykbI.redraw;
$1db9ba4f1f551c94$var$m.request = $b7f6a7e8d3e11d54$exports.request;
$1db9ba4f1f551c94$var$m.jsonp = $b7f6a7e8d3e11d54$exports.jsonp;

$1db9ba4f1f551c94$var$m.parseQueryString = (parcelRequire("8mO4U"));

$1db9ba4f1f551c94$var$m.buildQueryString = (parcelRequire("eY9jh"));

$1db9ba4f1f551c94$var$m.parsePathname = (parcelRequire("3pZOj"));

$1db9ba4f1f551c94$var$m.buildPathname = (parcelRequire("du6FX"));

$1db9ba4f1f551c94$var$m.vnode = (parcelRequire("4k8M8"));

$1db9ba4f1f551c94$var$m.PromisePolyfill = (parcelRequire("3UKYh"));

$1db9ba4f1f551c94$var$m.censor = (parcelRequire("zg7DE"));
$1db9ba4f1f551c94$exports = $1db9ba4f1f551c94$var$m;


var $9fb2269b6c8334a7$exports = {};
/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */ /**
 * bluebird build version 3.7.2
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/ var $449e3df09682ce9f$exports = {};
// shim for using process in browser
var $449e3df09682ce9f$var$process = $449e3df09682ce9f$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $449e3df09682ce9f$var$cachedSetTimeout;
var $449e3df09682ce9f$var$cachedClearTimeout;
function $449e3df09682ce9f$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $449e3df09682ce9f$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $449e3df09682ce9f$var$cachedSetTimeout = setTimeout;
        else $449e3df09682ce9f$var$cachedSetTimeout = $449e3df09682ce9f$var$defaultSetTimout;
    } catch (e) {
        $449e3df09682ce9f$var$cachedSetTimeout = $449e3df09682ce9f$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $449e3df09682ce9f$var$cachedClearTimeout = clearTimeout;
        else $449e3df09682ce9f$var$cachedClearTimeout = $449e3df09682ce9f$var$defaultClearTimeout;
    } catch (e) {
        $449e3df09682ce9f$var$cachedClearTimeout = $449e3df09682ce9f$var$defaultClearTimeout;
    }
})();
function $449e3df09682ce9f$var$runTimeout(fun) {
    if ($449e3df09682ce9f$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($449e3df09682ce9f$var$cachedSetTimeout === $449e3df09682ce9f$var$defaultSetTimout || !$449e3df09682ce9f$var$cachedSetTimeout) && setTimeout) {
        $449e3df09682ce9f$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $449e3df09682ce9f$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $449e3df09682ce9f$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $449e3df09682ce9f$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $449e3df09682ce9f$var$runClearTimeout(marker) {
    if ($449e3df09682ce9f$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($449e3df09682ce9f$var$cachedClearTimeout === $449e3df09682ce9f$var$defaultClearTimeout || !$449e3df09682ce9f$var$cachedClearTimeout) && clearTimeout) {
        $449e3df09682ce9f$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $449e3df09682ce9f$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $449e3df09682ce9f$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $449e3df09682ce9f$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $449e3df09682ce9f$var$queue = [];
var $449e3df09682ce9f$var$draining = false;
var $449e3df09682ce9f$var$currentQueue;
var $449e3df09682ce9f$var$queueIndex = -1;
function $449e3df09682ce9f$var$cleanUpNextTick() {
    if (!$449e3df09682ce9f$var$draining || !$449e3df09682ce9f$var$currentQueue) return;
    $449e3df09682ce9f$var$draining = false;
    if ($449e3df09682ce9f$var$currentQueue.length) $449e3df09682ce9f$var$queue = $449e3df09682ce9f$var$currentQueue.concat($449e3df09682ce9f$var$queue);
    else $449e3df09682ce9f$var$queueIndex = -1;
    if ($449e3df09682ce9f$var$queue.length) $449e3df09682ce9f$var$drainQueue();
}
function $449e3df09682ce9f$var$drainQueue() {
    if ($449e3df09682ce9f$var$draining) return;
    var timeout = $449e3df09682ce9f$var$runTimeout($449e3df09682ce9f$var$cleanUpNextTick);
    $449e3df09682ce9f$var$draining = true;
    var len = $449e3df09682ce9f$var$queue.length;
    while(len){
        $449e3df09682ce9f$var$currentQueue = $449e3df09682ce9f$var$queue;
        $449e3df09682ce9f$var$queue = [];
        while(++$449e3df09682ce9f$var$queueIndex < len)if ($449e3df09682ce9f$var$currentQueue) $449e3df09682ce9f$var$currentQueue[$449e3df09682ce9f$var$queueIndex].run();
        $449e3df09682ce9f$var$queueIndex = -1;
        len = $449e3df09682ce9f$var$queue.length;
    }
    $449e3df09682ce9f$var$currentQueue = null;
    $449e3df09682ce9f$var$draining = false;
    $449e3df09682ce9f$var$runClearTimeout(timeout);
}
$449e3df09682ce9f$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $449e3df09682ce9f$var$queue.push(new $449e3df09682ce9f$var$Item(fun, args));
    if ($449e3df09682ce9f$var$queue.length === 1 && !$449e3df09682ce9f$var$draining) $449e3df09682ce9f$var$runTimeout($449e3df09682ce9f$var$drainQueue);
};
// v8 likes predictible objects
function $449e3df09682ce9f$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$449e3df09682ce9f$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$449e3df09682ce9f$var$process.title = "browser";
$449e3df09682ce9f$var$process.browser = true;
$449e3df09682ce9f$var$process.env = {};
$449e3df09682ce9f$var$process.argv = [];
$449e3df09682ce9f$var$process.version = ""; // empty string to avoid regexp issues
$449e3df09682ce9f$var$process.versions = {};
function $449e3df09682ce9f$var$noop() {}
$449e3df09682ce9f$var$process.on = $449e3df09682ce9f$var$noop;
$449e3df09682ce9f$var$process.addListener = $449e3df09682ce9f$var$noop;
$449e3df09682ce9f$var$process.once = $449e3df09682ce9f$var$noop;
$449e3df09682ce9f$var$process.off = $449e3df09682ce9f$var$noop;
$449e3df09682ce9f$var$process.removeListener = $449e3df09682ce9f$var$noop;
$449e3df09682ce9f$var$process.removeAllListeners = $449e3df09682ce9f$var$noop;
$449e3df09682ce9f$var$process.emit = $449e3df09682ce9f$var$noop;
$449e3df09682ce9f$var$process.prependListener = $449e3df09682ce9f$var$noop;
$449e3df09682ce9f$var$process.prependOnceListener = $449e3df09682ce9f$var$noop;
$449e3df09682ce9f$var$process.listeners = function(name) {
    return [];
};
$449e3df09682ce9f$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$449e3df09682ce9f$var$process.cwd = function() {
    return "/";
};
$449e3df09682ce9f$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$449e3df09682ce9f$var$process.umask = function() {
    return 0;
};


!function(e) {
    var f;
    $9fb2269b6c8334a7$exports = e();
}(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = typeof _dereq_ == "function" && _dereq_;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = typeof _dereq_ == "function" && _dereq_;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var SomePromiseArray = Promise1._SomePromiseArray;
                    function any(promises) {
                        var ret = new SomePromiseArray(promises);
                        var promise = ret.promise();
                        ret.setHowMany(1);
                        ret.setUnwrap();
                        ret.init();
                        return promise;
                    }
                    Promise1.any = function(promises) {
                        return any(promises);
                    };
                    Promise1.prototype.any = function() {
                        return any(this);
                    };
                };
            },
            {}
        ],
        2: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var firstLineError;
                try {
                    throw new Error();
                } catch (e) {
                    firstLineError = e;
                }
                var schedule = _dereq_1("./schedule");
                var Queue = _dereq_1("./queue");
                function Async() {
                    this._customScheduler = false;
                    this._isTickUsed = false;
                    this._lateQueue = new Queue(16);
                    this._normalQueue = new Queue(16);
                    this._haveDrainedQueues = false;
                    var self1 = this;
                    this.drainQueues = function() {
                        self1._drainQueues();
                    };
                    this._schedule = schedule;
                }
                Async.prototype.setScheduler = function(fn) {
                    var prev = this._schedule;
                    this._schedule = fn;
                    this._customScheduler = true;
                    return prev;
                };
                Async.prototype.hasCustomScheduler = function() {
                    return this._customScheduler;
                };
                Async.prototype.haveItemsQueued = function() {
                    return this._isTickUsed || this._haveDrainedQueues;
                };
                Async.prototype.fatalError = function(e, isNode) {
                    if (isNode) {
                        $449e3df09682ce9f$exports.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) + "\n");
                        $449e3df09682ce9f$exports.exit(2);
                    } else this.throwLater(e);
                };
                Async.prototype.throwLater = function(fn, arg) {
                    if (arguments.length === 1) {
                        arg = fn;
                        fn = function() {
                            throw arg;
                        };
                    }
                    if (typeof setTimeout !== "undefined") setTimeout(function() {
                        fn(arg);
                    }, 0);
                    else try {
                        this._schedule(function() {
                            fn(arg);
                        });
                    } catch (e) {
                        throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
                    }
                };
                function AsyncInvokeLater(fn, receiver, arg) {
                    this._lateQueue.push(fn, receiver, arg);
                    this._queueTick();
                }
                function AsyncInvoke(fn, receiver, arg) {
                    this._normalQueue.push(fn, receiver, arg);
                    this._queueTick();
                }
                function AsyncSettlePromises(promise) {
                    this._normalQueue._pushOne(promise);
                    this._queueTick();
                }
                Async.prototype.invokeLater = AsyncInvokeLater;
                Async.prototype.invoke = AsyncInvoke;
                Async.prototype.settlePromises = AsyncSettlePromises;
                function _drainQueue(queue) {
                    while(queue.length() > 0)_drainQueueStep(queue);
                }
                function _drainQueueStep(queue) {
                    var fn = queue.shift();
                    if (typeof fn !== "function") fn._settlePromises();
                    else {
                        var receiver = queue.shift();
                        var arg = queue.shift();
                        fn.call(receiver, arg);
                    }
                }
                Async.prototype._drainQueues = function() {
                    _drainQueue(this._normalQueue);
                    this._reset();
                    this._haveDrainedQueues = true;
                    _drainQueue(this._lateQueue);
                };
                Async.prototype._queueTick = function() {
                    if (!this._isTickUsed) {
                        this._isTickUsed = true;
                        this._schedule(this.drainQueues);
                    }
                };
                Async.prototype._reset = function() {
                    this._isTickUsed = false;
                };
                module1.exports = Async;
                module1.exports.firstLineError = firstLineError;
            },
            {
                "./queue": 26,
                "./schedule": 29
            }
        ],
        3: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, debug) {
                    var calledBind = false;
                    var rejectThis = function(_, e) {
                        this._reject(e);
                    };
                    var targetRejected = function(e, context) {
                        context.promiseRejectionQueued = true;
                        context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
                    };
                    var bindingResolved = function(thisArg, context) {
                        if ((this._bitField & 50397184) === 0) this._resolveCallback(context.target);
                    };
                    var bindingRejected = function(e, context) {
                        if (!context.promiseRejectionQueued) this._reject(e);
                    };
                    Promise1.prototype.bind = function(thisArg) {
                        if (!calledBind) {
                            calledBind = true;
                            Promise1.prototype._propagateFrom = debug.propagateFromFunction();
                            Promise1.prototype._boundValue = debug.boundValueFunction();
                        }
                        var maybePromise = tryConvertToPromise(thisArg);
                        var ret = new Promise1(INTERNAL);
                        ret._propagateFrom(this, 1);
                        var target = this._target();
                        ret._setBoundTo(maybePromise);
                        if (maybePromise instanceof Promise1) {
                            var context = {
                                promiseRejectionQueued: false,
                                promise: ret,
                                target: target,
                                bindingPromise: maybePromise
                            };
                            target._then(INTERNAL, targetRejected, undefined, ret, context);
                            maybePromise._then(bindingResolved, bindingRejected, undefined, ret, context);
                            ret._setOnCancel(maybePromise);
                        } else ret._resolveCallback(target);
                        return ret;
                    };
                    Promise1.prototype._setBoundTo = function(obj) {
                        if (obj !== undefined) {
                            this._bitField = this._bitField | 2097152;
                            this._boundTo = obj;
                        } else this._bitField = this._bitField & -2097153;
                    };
                    Promise1.prototype._isBound = function() {
                        return (this._bitField & 2097152) === 2097152;
                    };
                    Promise1.bind = function(thisArg, value) {
                        return Promise1.resolve(value).bind(thisArg);
                    };
                };
            },
            {}
        ],
        4: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var old;
                if (typeof Promise !== "undefined") old = Promise;
                function noConflict() {
                    try {
                        if (Promise === bluebird) Promise = old;
                    } catch (e) {}
                    return bluebird;
                }
                var bluebird = _dereq_1("./promise")();
                bluebird.noConflict = noConflict;
                module1.exports = bluebird;
            },
            {
                "./promise": 22
            }
        ],
        5: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var cr = Object.create;
                if (cr) {
                    var callerCache = cr(null);
                    var getterCache = cr(null);
                    callerCache[" size"] = getterCache[" size"] = 0;
                }
                module1.exports = function(Promise1) {
                    var util = _dereq_1("./util");
                    var canEvaluate = util.canEvaluate;
                    var isIdentifier = util.isIdentifier;
                    var getMethodCaller;
                    var getGetter;
                    var makeMethodCaller, makeGetter, getCompiled;
                    function ensureMethod(obj, methodName) {
                        var fn;
                        if (obj != null) fn = obj[methodName];
                        if (typeof fn !== "function") {
                            var message = "Object " + util.classString(obj) + " has no method '" + util.toString(methodName) + "'";
                            throw new Promise1.TypeError(message);
                        }
                        return fn;
                    }
                    function caller(obj) {
                        var methodName = this.pop();
                        var fn = ensureMethod(obj, methodName);
                        return fn.apply(obj, this);
                    }
                    Promise1.prototype.call = function(methodName) {
                        var args = [].slice.call(arguments, 1);
                        var maybeCaller;
                        args.push(methodName);
                        return this._then(caller, undefined, undefined, args, undefined);
                    };
                    function namedGetter(obj) {
                        return obj[this];
                    }
                    function indexedGetter(obj) {
                        var index = +this;
                        if (index < 0) index = Math.max(0, index + obj.length);
                        return obj[index];
                    }
                    Promise1.prototype.get = function(propertyName) {
                        var isIndex = typeof propertyName === "number";
                        var getter;
                        if (!isIndex) {
                            if (canEvaluate) {
                                var maybeGetter = getGetter(propertyName);
                                getter = maybeGetter !== null ? maybeGetter : namedGetter;
                            } else getter = namedGetter;
                        } else getter = indexedGetter;
                        return this._then(getter, undefined, undefined, propertyName, undefined);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        6: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var async = Promise1._async;
                    Promise1.prototype["break"] = Promise1.prototype.cancel = function() {
                        if (!debug.cancellation()) return this._warn("cancellation is disabled");
                        var promise = this;
                        var child = promise;
                        while(promise._isCancellable()){
                            if (!promise._cancelBy(child)) {
                                if (child._isFollowing()) child._followee().cancel();
                                else child._cancelBranched();
                                break;
                            }
                            var parent = promise._cancellationParent;
                            if (parent == null || !parent._isCancellable()) {
                                if (promise._isFollowing()) promise._followee().cancel();
                                else promise._cancelBranched();
                                break;
                            } else {
                                if (promise._isFollowing()) promise._followee().cancel();
                                promise._setWillBeCancelled();
                                child = promise;
                                promise = parent;
                            }
                        }
                    };
                    Promise1.prototype._branchHasCancelled = function() {
                        this._branchesRemainingToCancel--;
                    };
                    Promise1.prototype._enoughBranchesHaveCancelled = function() {
                        return this._branchesRemainingToCancel === undefined || this._branchesRemainingToCancel <= 0;
                    };
                    Promise1.prototype._cancelBy = function(canceller) {
                        if (canceller === this) {
                            this._branchesRemainingToCancel = 0;
                            this._invokeOnCancel();
                            return true;
                        } else {
                            this._branchHasCancelled();
                            if (this._enoughBranchesHaveCancelled()) {
                                this._invokeOnCancel();
                                return true;
                            }
                        }
                        return false;
                    };
                    Promise1.prototype._cancelBranched = function() {
                        if (this._enoughBranchesHaveCancelled()) this._cancel();
                    };
                    Promise1.prototype._cancel = function() {
                        if (!this._isCancellable()) return;
                        this._setCancelled();
                        async.invoke(this._cancelPromises, this, undefined);
                    };
                    Promise1.prototype._cancelPromises = function() {
                        if (this._length() > 0) this._settlePromises();
                    };
                    Promise1.prototype._unsetOnCancel = function() {
                        this._onCancelField = undefined;
                    };
                    Promise1.prototype._isCancellable = function() {
                        return this.isPending() && !this._isCancelled();
                    };
                    Promise1.prototype.isCancellable = function() {
                        return this.isPending() && !this.isCancelled();
                    };
                    Promise1.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
                        if (util.isArray(onCancelCallback)) for(var i = 0; i < onCancelCallback.length; ++i)this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
                        else if (onCancelCallback !== undefined) {
                            if (typeof onCancelCallback === "function") {
                                if (!internalOnly) {
                                    var e = tryCatch(onCancelCallback).call(this._boundValue());
                                    if (e === errorObj) {
                                        this._attachExtraTrace(e.e);
                                        async.throwLater(e.e);
                                    }
                                }
                            } else onCancelCallback._resultCancelled(this);
                        }
                    };
                    Promise1.prototype._invokeOnCancel = function() {
                        var onCancelCallback = this._onCancel();
                        this._unsetOnCancel();
                        async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
                    };
                    Promise1.prototype._invokeInternalOnCancel = function() {
                        if (this._isCancellable()) {
                            this._doInvokeOnCancel(this._onCancel(), true);
                            this._unsetOnCancel();
                        }
                    };
                    Promise1.prototype._resultCancelled = function() {
                        this.cancel();
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        7: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(NEXT_FILTER) {
                    var util = _dereq_1("./util");
                    var getKeys = _dereq_1("./es5").keys;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    function catchFilter(instances, cb, promise) {
                        return function(e) {
                            var boundTo = promise._boundValue();
                            predicateLoop: for(var i = 0; i < instances.length; ++i){
                                var item = instances[i];
                                if (item === Error || item != null && item.prototype instanceof Error) {
                                    if (e instanceof item) return tryCatch(cb).call(boundTo, e);
                                } else if (typeof item === "function") {
                                    var matchesPredicate = tryCatch(item).call(boundTo, e);
                                    if (matchesPredicate === errorObj) return matchesPredicate;
                                    else if (matchesPredicate) return tryCatch(cb).call(boundTo, e);
                                } else if (util.isObject(e)) {
                                    var keys = getKeys(item);
                                    for(var j = 0; j < keys.length; ++j){
                                        var key = keys[j];
                                        if (item[key] != e[key]) continue predicateLoop;
                                    }
                                    return tryCatch(cb).call(boundTo, e);
                                }
                            }
                            return NEXT_FILTER;
                        };
                    }
                    return catchFilter;
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        8: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var longStackTraces = false;
                    var contextStack = [];
                    Promise1.prototype._promiseCreated = function() {};
                    Promise1.prototype._pushContext = function() {};
                    Promise1.prototype._popContext = function() {
                        return null;
                    };
                    Promise1._peekContext = Promise1.prototype._peekContext = function() {};
                    function Context() {
                        this._trace = new Context.CapturedTrace(peekContext());
                    }
                    Context.prototype._pushContext = function() {
                        if (this._trace !== undefined) {
                            this._trace._promiseCreated = null;
                            contextStack.push(this._trace);
                        }
                    };
                    Context.prototype._popContext = function() {
                        if (this._trace !== undefined) {
                            var trace = contextStack.pop();
                            var ret = trace._promiseCreated;
                            trace._promiseCreated = null;
                            return ret;
                        }
                        return null;
                    };
                    function createContext() {
                        if (longStackTraces) return new Context();
                    }
                    function peekContext() {
                        var lastIndex = contextStack.length - 1;
                        if (lastIndex >= 0) return contextStack[lastIndex];
                        return undefined;
                    }
                    Context.CapturedTrace = null;
                    Context.create = createContext;
                    Context.deactivateLongStackTraces = function() {};
                    Context.activateLongStackTraces = function() {
                        var Promise_pushContext = Promise1.prototype._pushContext;
                        var Promise_popContext = Promise1.prototype._popContext;
                        var Promise_PeekContext = Promise1._peekContext;
                        var Promise_peekContext = Promise1.prototype._peekContext;
                        var Promise_promiseCreated = Promise1.prototype._promiseCreated;
                        Context.deactivateLongStackTraces = function() {
                            Promise1.prototype._pushContext = Promise_pushContext;
                            Promise1.prototype._popContext = Promise_popContext;
                            Promise1._peekContext = Promise_PeekContext;
                            Promise1.prototype._peekContext = Promise_peekContext;
                            Promise1.prototype._promiseCreated = Promise_promiseCreated;
                            longStackTraces = false;
                        };
                        longStackTraces = true;
                        Promise1.prototype._pushContext = Context.prototype._pushContext;
                        Promise1.prototype._popContext = Context.prototype._popContext;
                        Promise1._peekContext = Promise1.prototype._peekContext = peekContext;
                        Promise1.prototype._promiseCreated = function() {
                            var ctx = this._peekContext();
                            if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
                        };
                    };
                    return Context;
                };
            },
            {}
        ],
        9: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, Context, enableAsyncHooks, disableAsyncHooks) {
                    var async = Promise1._async;
                    var Warning = _dereq_1("./errors").Warning;
                    var util = _dereq_1("./util");
                    var es5 = _dereq_1("./es5");
                    var canAttachTrace = util.canAttachTrace;
                    var unhandledRejectionHandled;
                    var possiblyUnhandledRejection;
                    var bluebirdFramePattern = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
                    var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
                    var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
                    var stackFramePattern = null;
                    var formatStack = null;
                    var indentStackFrames = false;
                    var printWarning;
                    var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 && true);
                    var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 && (debugging || util.env("BLUEBIRD_WARNINGS")));
                    var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 && (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
                    var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 && (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
                    var deferUnhandledRejectionCheck;
                    (function() {
                        var promises = [];
                        function unhandledRejectionCheck() {
                            for(var i = 0; i < promises.length; ++i)promises[i]._notifyUnhandledRejection();
                            unhandledRejectionClear();
                        }
                        function unhandledRejectionClear() {
                            promises.length = 0;
                        }
                        deferUnhandledRejectionCheck = function(promise) {
                            promises.push(promise);
                            setTimeout(unhandledRejectionCheck, 1);
                        };
                        es5.defineProperty(Promise1, "_unhandledRejectionCheck", {
                            value: unhandledRejectionCheck
                        });
                        es5.defineProperty(Promise1, "_unhandledRejectionClear", {
                            value: unhandledRejectionClear
                        });
                    })();
                    Promise1.prototype.suppressUnhandledRejections = function() {
                        var target = this._target();
                        target._bitField = target._bitField & -1048577 | 524288;
                    };
                    Promise1.prototype._ensurePossibleRejectionHandled = function() {
                        if ((this._bitField & 524288) !== 0) return;
                        this._setRejectionIsUnhandled();
                        deferUnhandledRejectionCheck(this);
                    };
                    Promise1.prototype._notifyUnhandledRejectionIsHandled = function() {
                        fireRejectionEvent("rejectionHandled", unhandledRejectionHandled, undefined, this);
                    };
                    Promise1.prototype._setReturnedNonUndefined = function() {
                        this._bitField = this._bitField | 268435456;
                    };
                    Promise1.prototype._returnedNonUndefined = function() {
                        return (this._bitField & 268435456) !== 0;
                    };
                    Promise1.prototype._notifyUnhandledRejection = function() {
                        if (this._isRejectionUnhandled()) {
                            var reason = this._settledValue();
                            this._setUnhandledRejectionIsNotified();
                            fireRejectionEvent("unhandledRejection", possiblyUnhandledRejection, reason, this);
                        }
                    };
                    Promise1.prototype._setUnhandledRejectionIsNotified = function() {
                        this._bitField = this._bitField | 262144;
                    };
                    Promise1.prototype._unsetUnhandledRejectionIsNotified = function() {
                        this._bitField = this._bitField & -262145;
                    };
                    Promise1.prototype._isUnhandledRejectionNotified = function() {
                        return (this._bitField & 262144) > 0;
                    };
                    Promise1.prototype._setRejectionIsUnhandled = function() {
                        this._bitField = this._bitField | 1048576;
                    };
                    Promise1.prototype._unsetRejectionIsUnhandled = function() {
                        this._bitField = this._bitField & -1048577;
                        if (this._isUnhandledRejectionNotified()) {
                            this._unsetUnhandledRejectionIsNotified();
                            this._notifyUnhandledRejectionIsHandled();
                        }
                    };
                    Promise1.prototype._isRejectionUnhandled = function() {
                        return (this._bitField & 1048576) > 0;
                    };
                    Promise1.prototype._warn = function(message, shouldUseOwnTrace, promise) {
                        return warn(message, shouldUseOwnTrace, promise || this);
                    };
                    Promise1.onPossiblyUnhandledRejection = function(fn) {
                        var context = Promise1._getContext();
                        possiblyUnhandledRejection = util.contextBind(context, fn);
                    };
                    Promise1.onUnhandledRejectionHandled = function(fn) {
                        var context = Promise1._getContext();
                        unhandledRejectionHandled = util.contextBind(context, fn);
                    };
                    var disableLongStackTraces = function() {};
                    Promise1.longStackTraces = function() {
                        if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
                        if (!config.longStackTraces && longStackTracesIsSupported()) {
                            var Promise_captureStackTrace = Promise1.prototype._captureStackTrace;
                            var Promise_attachExtraTrace = Promise1.prototype._attachExtraTrace;
                            var Promise_dereferenceTrace = Promise1.prototype._dereferenceTrace;
                            config.longStackTraces = true;
                            disableLongStackTraces = function() {
                                if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
                                Promise1.prototype._captureStackTrace = Promise_captureStackTrace;
                                Promise1.prototype._attachExtraTrace = Promise_attachExtraTrace;
                                Promise1.prototype._dereferenceTrace = Promise_dereferenceTrace;
                                Context.deactivateLongStackTraces();
                                config.longStackTraces = false;
                            };
                            Promise1.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
                            Promise1.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
                            Promise1.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
                            Context.activateLongStackTraces();
                        }
                    };
                    Promise1.hasLongStackTraces = function() {
                        return config.longStackTraces && longStackTracesIsSupported();
                    };
                    var legacyHandlers = {
                        unhandledrejection: {
                            before: function() {
                                var ret = util.global.onunhandledrejection;
                                util.global.onunhandledrejection = null;
                                return ret;
                            },
                            after: function(fn) {
                                util.global.onunhandledrejection = fn;
                            }
                        },
                        rejectionhandled: {
                            before: function() {
                                var ret = util.global.onrejectionhandled;
                                util.global.onrejectionhandled = null;
                                return ret;
                            },
                            after: function(fn) {
                                util.global.onrejectionhandled = fn;
                            }
                        }
                    };
                    var fireDomEvent = function() {
                        var dispatch = function(legacy, e) {
                            if (legacy) {
                                var fn;
                                try {
                                    fn = legacy.before();
                                    return !util.global.dispatchEvent(e);
                                } finally{
                                    legacy.after(fn);
                                }
                            } else return !util.global.dispatchEvent(e);
                        };
                        try {
                            if (typeof CustomEvent === "function") {
                                var event = new CustomEvent("CustomEvent");
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var eventData = {
                                        detail: event,
                                        cancelable: true
                                    };
                                    var domEvent = new CustomEvent(name, eventData);
                                    es5.defineProperty(domEvent, "promise", {
                                        value: event.promise
                                    });
                                    es5.defineProperty(domEvent, "reason", {
                                        value: event.reason
                                    });
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            } else if (typeof Event === "function") {
                                var event = new Event("CustomEvent");
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var domEvent = new Event(name, {
                                        cancelable: true
                                    });
                                    domEvent.detail = event;
                                    es5.defineProperty(domEvent, "promise", {
                                        value: event.promise
                                    });
                                    es5.defineProperty(domEvent, "reason", {
                                        value: event.reason
                                    });
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            } else {
                                var event = document.createEvent("CustomEvent");
                                event.initCustomEvent("testingtheevent", false, true, {});
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var domEvent = document.createEvent("CustomEvent");
                                    domEvent.initCustomEvent(name, false, true, event);
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            }
                        } catch (e) {}
                        return function() {
                            return false;
                        };
                    }();
                    var fireGlobalEvent = function() {
                        if (util.isNode) return function() {
                            return $449e3df09682ce9f$exports.emit.apply($449e3df09682ce9f$exports, arguments);
                        };
                        else {
                            if (!util.global) return function() {
                                return false;
                            };
                            return function(name) {
                                var methodName = "on" + name.toLowerCase();
                                var method = util.global[methodName];
                                if (!method) return false;
                                method.apply(util.global, [].slice.call(arguments, 1));
                                return true;
                            };
                        }
                    }();
                    function generatePromiseLifecycleEventObject(name, promise) {
                        return {
                            promise: promise
                        };
                    }
                    var eventToObjectGenerator = {
                        promiseCreated: generatePromiseLifecycleEventObject,
                        promiseFulfilled: generatePromiseLifecycleEventObject,
                        promiseRejected: generatePromiseLifecycleEventObject,
                        promiseResolved: generatePromiseLifecycleEventObject,
                        promiseCancelled: generatePromiseLifecycleEventObject,
                        promiseChained: function(name, promise, child) {
                            return {
                                promise: promise,
                                child: child
                            };
                        },
                        warning: function(name, warning) {
                            return {
                                warning: warning
                            };
                        },
                        unhandledRejection: function(name, reason, promise) {
                            return {
                                reason: reason,
                                promise: promise
                            };
                        },
                        rejectionHandled: generatePromiseLifecycleEventObject
                    };
                    var activeFireEvent = function(name) {
                        var globalEventFired = false;
                        try {
                            globalEventFired = fireGlobalEvent.apply(null, arguments);
                        } catch (e) {
                            async.throwLater(e);
                            globalEventFired = true;
                        }
                        var domEventFired = false;
                        try {
                            domEventFired = fireDomEvent(name, eventToObjectGenerator[name].apply(null, arguments));
                        } catch (e) {
                            async.throwLater(e);
                            domEventFired = true;
                        }
                        return domEventFired || globalEventFired;
                    };
                    Promise1.config = function(opts) {
                        opts = Object(opts);
                        if ("longStackTraces" in opts) {
                            if (opts.longStackTraces) Promise1.longStackTraces();
                            else if (!opts.longStackTraces && Promise1.hasLongStackTraces()) disableLongStackTraces();
                        }
                        if ("warnings" in opts) {
                            var warningsOption = opts.warnings;
                            config.warnings = !!warningsOption;
                            wForgottenReturn = config.warnings;
                            if (util.isObject(warningsOption)) {
                                if ("wForgottenReturn" in warningsOption) wForgottenReturn = !!warningsOption.wForgottenReturn;
                            }
                        }
                        if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
                            if (async.haveItemsQueued()) throw new Error("cannot enable cancellation after promises are in use");
                            Promise1.prototype._clearCancellationData = cancellationClearCancellationData;
                            Promise1.prototype._propagateFrom = cancellationPropagateFrom;
                            Promise1.prototype._onCancel = cancellationOnCancel;
                            Promise1.prototype._setOnCancel = cancellationSetOnCancel;
                            Promise1.prototype._attachCancellationCallback = cancellationAttachCancellationCallback;
                            Promise1.prototype._execute = cancellationExecute;
                            propagateFromFunction = cancellationPropagateFrom;
                            config.cancellation = true;
                        }
                        if ("monitoring" in opts) {
                            if (opts.monitoring && !config.monitoring) {
                                config.monitoring = true;
                                Promise1.prototype._fireEvent = activeFireEvent;
                            } else if (!opts.monitoring && config.monitoring) {
                                config.monitoring = false;
                                Promise1.prototype._fireEvent = defaultFireEvent;
                            }
                        }
                        if ("asyncHooks" in opts && util.nodeSupportsAsyncResource) {
                            var prev = config.asyncHooks;
                            var cur = !!opts.asyncHooks;
                            if (prev !== cur) {
                                config.asyncHooks = cur;
                                if (cur) enableAsyncHooks();
                                else disableAsyncHooks();
                            }
                        }
                        return Promise1;
                    };
                    function defaultFireEvent() {
                        return false;
                    }
                    Promise1.prototype._fireEvent = defaultFireEvent;
                    Promise1.prototype._execute = function(executor, resolve, reject) {
                        try {
                            executor(resolve, reject);
                        } catch (e) {
                            return e;
                        }
                    };
                    Promise1.prototype._onCancel = function() {};
                    Promise1.prototype._setOnCancel = function(handler) {};
                    Promise1.prototype._attachCancellationCallback = function(onCancel) {};
                    Promise1.prototype._captureStackTrace = function() {};
                    Promise1.prototype._attachExtraTrace = function() {};
                    Promise1.prototype._dereferenceTrace = function() {};
                    Promise1.prototype._clearCancellationData = function() {};
                    Promise1.prototype._propagateFrom = function(parent, flags) {};
                    function cancellationExecute(executor, resolve, reject) {
                        var promise = this;
                        try {
                            executor(resolve, reject, function(onCancel) {
                                if (typeof onCancel !== "function") throw new TypeError("onCancel must be a function, got: " + util.toString(onCancel));
                                promise._attachCancellationCallback(onCancel);
                            });
                        } catch (e) {
                            return e;
                        }
                    }
                    function cancellationAttachCancellationCallback(onCancel) {
                        if (!this._isCancellable()) return this;
                        var previousOnCancel = this._onCancel();
                        if (previousOnCancel !== undefined) {
                            if (util.isArray(previousOnCancel)) previousOnCancel.push(onCancel);
                            else this._setOnCancel([
                                previousOnCancel,
                                onCancel
                            ]);
                        } else this._setOnCancel(onCancel);
                    }
                    function cancellationOnCancel() {
                        return this._onCancelField;
                    }
                    function cancellationSetOnCancel(onCancel) {
                        this._onCancelField = onCancel;
                    }
                    function cancellationClearCancellationData() {
                        this._cancellationParent = undefined;
                        this._onCancelField = undefined;
                    }
                    function cancellationPropagateFrom(parent, flags) {
                        if ((flags & 1) !== 0) {
                            this._cancellationParent = parent;
                            var branchesRemainingToCancel = parent._branchesRemainingToCancel;
                            if (branchesRemainingToCancel === undefined) branchesRemainingToCancel = 0;
                            parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
                        }
                        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
                    }
                    function bindingPropagateFrom(parent, flags) {
                        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
                    }
                    var propagateFromFunction = bindingPropagateFrom;
                    function boundValueFunction() {
                        var ret = this._boundTo;
                        if (ret !== undefined) {
                            if (ret instanceof Promise1) {
                                if (ret.isFulfilled()) return ret.value();
                                else return undefined;
                            }
                        }
                        return ret;
                    }
                    function longStackTracesCaptureStackTrace() {
                        this._trace = new CapturedTrace(this._peekContext());
                    }
                    function longStackTracesAttachExtraTrace(error, ignoreSelf) {
                        if (canAttachTrace(error)) {
                            var trace = this._trace;
                            if (trace !== undefined) {
                                if (ignoreSelf) trace = trace._parent;
                            }
                            if (trace !== undefined) trace.attachExtraTrace(error);
                            else if (!error.__stackCleaned__) {
                                var parsed = parseStackAndMessage(error);
                                util.notEnumerableProp(error, "stack", parsed.message + "\n" + parsed.stack.join("\n"));
                                util.notEnumerableProp(error, "__stackCleaned__", true);
                            }
                        }
                    }
                    function longStackTracesDereferenceTrace() {
                        this._trace = undefined;
                    }
                    function checkForgottenReturns(returnValue, promiseCreated, name, promise, parent) {
                        if (returnValue === undefined && promiseCreated !== null && wForgottenReturn) {
                            if (parent !== undefined && parent._returnedNonUndefined()) return;
                            if ((promise._bitField & 65535) === 0) return;
                            if (name) name = name + " ";
                            var handlerLine = "";
                            var creatorLine = "";
                            if (promiseCreated._trace) {
                                var traceLines = promiseCreated._trace.stack.split("\n");
                                var stack = cleanStack(traceLines);
                                for(var i = stack.length - 1; i >= 0; --i){
                                    var line = stack[i];
                                    if (!nodeFramePattern.test(line)) {
                                        var lineMatches = line.match(parseLinePattern);
                                        if (lineMatches) handlerLine = "at " + lineMatches[1] + ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                                        break;
                                    }
                                }
                                if (stack.length > 0) {
                                    var firstUserLine = stack[0];
                                    for(var i = 0; i < traceLines.length; ++i)if (traceLines[i] === firstUserLine) {
                                        if (i > 0) creatorLine = "\n" + traceLines[i - 1];
                                        break;
                                    }
                                }
                            }
                            var msg = "a promise was created in a " + name + "handler " + handlerLine + "but was not returned from it, " + "see http://goo.gl/rRqMUw" + creatorLine;
                            promise._warn(msg, true, promiseCreated);
                        }
                    }
                    function deprecated(name, replacement) {
                        var message = name + " is deprecated and will be removed in a future version.";
                        if (replacement) message += " Use " + replacement + " instead.";
                        return warn(message);
                    }
                    function warn(message, shouldUseOwnTrace, promise) {
                        if (!config.warnings) return;
                        var warning = new Warning(message);
                        var ctx;
                        if (shouldUseOwnTrace) promise._attachExtraTrace(warning);
                        else if (config.longStackTraces && (ctx = Promise1._peekContext())) ctx.attachExtraTrace(warning);
                        else {
                            var parsed = parseStackAndMessage(warning);
                            warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
                        }
                        if (!activeFireEvent("warning", warning)) formatAndLogError(warning, "", true);
                    }
                    function reconstructStack(message, stacks) {
                        for(var i = 0; i < stacks.length - 1; ++i){
                            stacks[i].push("From previous event:");
                            stacks[i] = stacks[i].join("\n");
                        }
                        if (i < stacks.length) stacks[i] = stacks[i].join("\n");
                        return message + "\n" + stacks.join("\n");
                    }
                    function removeDuplicateOrEmptyJumps(stacks) {
                        for(var i = 0; i < stacks.length; ++i)if (stacks[i].length === 0 || i + 1 < stacks.length && stacks[i][0] === stacks[i + 1][0]) {
                            stacks.splice(i, 1);
                            i--;
                        }
                    }
                    function removeCommonRoots(stacks) {
                        var current = stacks[0];
                        for(var i = 1; i < stacks.length; ++i){
                            var prev = stacks[i];
                            var currentLastIndex = current.length - 1;
                            var currentLastLine = current[currentLastIndex];
                            var commonRootMeetPoint = -1;
                            for(var j = prev.length - 1; j >= 0; --j)if (prev[j] === currentLastLine) {
                                commonRootMeetPoint = j;
                                break;
                            }
                            for(var j = commonRootMeetPoint; j >= 0; --j){
                                var line = prev[j];
                                if (current[currentLastIndex] === line) {
                                    current.pop();
                                    currentLastIndex--;
                                } else break;
                            }
                            current = prev;
                        }
                    }
                    function cleanStack(stack) {
                        var ret = [];
                        for(var i = 0; i < stack.length; ++i){
                            var line = stack[i];
                            var isTraceLine = "    (No stack trace)" === line || stackFramePattern.test(line);
                            var isInternalFrame = isTraceLine && shouldIgnore(line);
                            if (isTraceLine && !isInternalFrame) {
                                if (indentStackFrames && line.charAt(0) !== " ") line = "    " + line;
                                ret.push(line);
                            }
                        }
                        return ret;
                    }
                    function stackFramesAsArray(error) {
                        var stack = error.stack.replace(/\s+$/g, "").split("\n");
                        for(var i = 0; i < stack.length; ++i){
                            var line = stack[i];
                            if ("    (No stack trace)" === line || stackFramePattern.test(line)) break;
                        }
                        if (i > 0 && error.name != "SyntaxError") stack = stack.slice(i);
                        return stack;
                    }
                    function parseStackAndMessage(error) {
                        var stack = error.stack;
                        var message = error.toString();
                        stack = typeof stack === "string" && stack.length > 0 ? stackFramesAsArray(error) : [
                            "    (No stack trace)"
                        ];
                        return {
                            message: message,
                            stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
                        };
                    }
                    function formatAndLogError(error, title, isSoft) {
                        if (typeof console !== "undefined") {
                            var message;
                            if (util.isObject(error)) {
                                var stack = error.stack;
                                message = title + formatStack(stack, error);
                            } else message = title + String(error);
                            if (typeof printWarning === "function") printWarning(message, isSoft);
                            else if (typeof console.log === "function" || typeof console.log === "object") console.log(message);
                        }
                    }
                    function fireRejectionEvent(name, localHandler, reason, promise) {
                        var localEventFired = false;
                        try {
                            if (typeof localHandler === "function") {
                                localEventFired = true;
                                if (name === "rejectionHandled") localHandler(promise);
                                else localHandler(reason, promise);
                            }
                        } catch (e) {
                            async.throwLater(e);
                        }
                        if (name === "unhandledRejection") {
                            if (!activeFireEvent(name, reason, promise) && !localEventFired) formatAndLogError(reason, "Unhandled rejection ");
                        } else activeFireEvent(name, promise);
                    }
                    function formatNonError(obj) {
                        var str;
                        if (typeof obj === "function") str = "[function " + (obj.name || "anonymous") + "]";
                        else {
                            str = obj && typeof obj.toString === "function" ? obj.toString() : util.toString(obj);
                            var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
                            if (ruselessToString.test(str)) try {
                                var newStr = JSON.stringify(obj);
                                str = newStr;
                            } catch (e) {}
                            if (str.length === 0) str = "(empty array)";
                        }
                        return "(<" + snip(str) + ">, no stack trace)";
                    }
                    function snip(str) {
                        var maxChars = 41;
                        if (str.length < maxChars) return str;
                        return str.substr(0, maxChars - 3) + "...";
                    }
                    function longStackTracesIsSupported() {
                        return typeof captureStackTrace === "function";
                    }
                    var shouldIgnore = function() {
                        return false;
                    };
                    var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
                    function parseLineInfo(line) {
                        var matches = line.match(parseLineInfoRegex);
                        if (matches) return {
                            fileName: matches[1],
                            line: parseInt(matches[2], 10)
                        };
                    }
                    function setBounds(firstLineError, lastLineError) {
                        if (!longStackTracesIsSupported()) return;
                        var firstStackLines = (firstLineError.stack || "").split("\n");
                        var lastStackLines = (lastLineError.stack || "").split("\n");
                        var firstIndex = -1;
                        var lastIndex = -1;
                        var firstFileName;
                        var lastFileName;
                        for(var i = 0; i < firstStackLines.length; ++i){
                            var result = parseLineInfo(firstStackLines[i]);
                            if (result) {
                                firstFileName = result.fileName;
                                firstIndex = result.line;
                                break;
                            }
                        }
                        for(var i = 0; i < lastStackLines.length; ++i){
                            var result = parseLineInfo(lastStackLines[i]);
                            if (result) {
                                lastFileName = result.fileName;
                                lastIndex = result.line;
                                break;
                            }
                        }
                        if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName || firstFileName !== lastFileName || firstIndex >= lastIndex) return;
                        shouldIgnore = function(line) {
                            if (bluebirdFramePattern.test(line)) return true;
                            var info = parseLineInfo(line);
                            if (info) {
                                if (info.fileName === firstFileName && firstIndex <= info.line && info.line <= lastIndex) return true;
                            }
                            return false;
                        };
                    }
                    function CapturedTrace(parent) {
                        this._parent = parent;
                        this._promisesCreated = 0;
                        var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
                        captureStackTrace(this, CapturedTrace);
                        if (length > 32) this.uncycle();
                    }
                    util.inherits(CapturedTrace, Error);
                    Context.CapturedTrace = CapturedTrace;
                    CapturedTrace.prototype.uncycle = function() {
                        var length = this._length;
                        if (length < 2) return;
                        var nodes = [];
                        var stackToIndex = {};
                        for(var i = 0, node = this; node !== undefined; ++i){
                            nodes.push(node);
                            node = node._parent;
                        }
                        length = this._length = i;
                        for(var i = length - 1; i >= 0; --i){
                            var stack = nodes[i].stack;
                            if (stackToIndex[stack] === undefined) stackToIndex[stack] = i;
                        }
                        for(var i = 0; i < length; ++i){
                            var currentStack = nodes[i].stack;
                            var index = stackToIndex[currentStack];
                            if (index !== undefined && index !== i) {
                                if (index > 0) {
                                    nodes[index - 1]._parent = undefined;
                                    nodes[index - 1]._length = 1;
                                }
                                nodes[i]._parent = undefined;
                                nodes[i]._length = 1;
                                var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
                                if (index < length - 1) {
                                    cycleEdgeNode._parent = nodes[index + 1];
                                    cycleEdgeNode._parent.uncycle();
                                    cycleEdgeNode._length = cycleEdgeNode._parent._length + 1;
                                } else {
                                    cycleEdgeNode._parent = undefined;
                                    cycleEdgeNode._length = 1;
                                }
                                var currentChildLength = cycleEdgeNode._length + 1;
                                for(var j = i - 2; j >= 0; --j){
                                    nodes[j]._length = currentChildLength;
                                    currentChildLength++;
                                }
                                return;
                            }
                        }
                    };
                    CapturedTrace.prototype.attachExtraTrace = function(error) {
                        if (error.__stackCleaned__) return;
                        this.uncycle();
                        var parsed = parseStackAndMessage(error);
                        var message = parsed.message;
                        var stacks = [
                            parsed.stack
                        ];
                        var trace = this;
                        while(trace !== undefined){
                            stacks.push(cleanStack(trace.stack.split("\n")));
                            trace = trace._parent;
                        }
                        removeCommonRoots(stacks);
                        removeDuplicateOrEmptyJumps(stacks);
                        util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
                        util.notEnumerableProp(error, "__stackCleaned__", true);
                    };
                    var captureStackTrace = function stackDetection() {
                        var v8stackFramePattern = /^\s*at\s*/;
                        var v8stackFormatter = function(stack, error) {
                            if (typeof stack === "string") return stack;
                            if (error.name !== undefined && error.message !== undefined) return error.toString();
                            return formatNonError(error);
                        };
                        if (typeof Error.stackTraceLimit === "number" && typeof Error.captureStackTrace === "function") {
                            Error.stackTraceLimit += 6;
                            stackFramePattern = v8stackFramePattern;
                            formatStack = v8stackFormatter;
                            var captureStackTrace = Error.captureStackTrace;
                            shouldIgnore = function(line) {
                                return bluebirdFramePattern.test(line);
                            };
                            return function(receiver, ignoreUntil) {
                                Error.stackTraceLimit += 6;
                                captureStackTrace(receiver, ignoreUntil);
                                Error.stackTraceLimit -= 6;
                            };
                        }
                        var err = new Error();
                        if (typeof err.stack === "string" && err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
                            stackFramePattern = /@/;
                            formatStack = v8stackFormatter;
                            indentStackFrames = true;
                            return function captureStackTrace(o) {
                                o.stack = new Error().stack;
                            };
                        }
                        var hasStackAfterThrow;
                        try {
                            throw new Error();
                        } catch (e) {
                            hasStackAfterThrow = "stack" in e;
                        }
                        if (!("stack" in err) && hasStackAfterThrow && typeof Error.stackTraceLimit === "number") {
                            stackFramePattern = v8stackFramePattern;
                            formatStack = v8stackFormatter;
                            return function captureStackTrace(o) {
                                Error.stackTraceLimit += 6;
                                try {
                                    throw new Error();
                                } catch (e) {
                                    o.stack = e.stack;
                                }
                                Error.stackTraceLimit -= 6;
                            };
                        }
                        formatStack = function(stack, error) {
                            if (typeof stack === "string") return stack;
                            if ((typeof error === "object" || typeof error === "function") && error.name !== undefined && error.message !== undefined) return error.toString();
                            return formatNonError(error);
                        };
                        return null;
                    }([]);
                    if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
                        printWarning = function(message) {
                            console.warn(message);
                        };
                        if (util.isNode && $449e3df09682ce9f$exports.stderr.isTTY) printWarning = function(message, isSoft) {
                            var color = isSoft ? "\x1b[33m" : "\x1b[31m";
                            console.warn(color + message + "\x1b[0m\n");
                        };
                        else if (!util.isNode && typeof new Error().stack === "string") printWarning = function(message, isSoft) {
                            console.warn("%c" + message, isSoft ? "color: darkorange" : "color: red");
                        };
                    }
                    var config = {
                        warnings: warnings,
                        longStackTraces: false,
                        cancellation: false,
                        monitoring: false,
                        asyncHooks: false
                    };
                    if (longStackTraces) Promise1.longStackTraces();
                    return {
                        asyncHooks: function() {
                            return config.asyncHooks;
                        },
                        longStackTraces: function() {
                            return config.longStackTraces;
                        },
                        warnings: function() {
                            return config.warnings;
                        },
                        cancellation: function() {
                            return config.cancellation;
                        },
                        monitoring: function() {
                            return config.monitoring;
                        },
                        propagateFromFunction: function() {
                            return propagateFromFunction;
                        },
                        boundValueFunction: function() {
                            return boundValueFunction;
                        },
                        checkForgottenReturns: checkForgottenReturns,
                        setBounds: setBounds,
                        warn: warn,
                        deprecated: deprecated,
                        CapturedTrace: CapturedTrace,
                        fireDomEvent: fireDomEvent,
                        fireGlobalEvent: fireGlobalEvent
                    };
                };
            },
            {
                "./errors": 12,
                "./es5": 13,
                "./util": 36
            }
        ],
        10: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    function returner() {
                        return this.value;
                    }
                    function thrower() {
                        throw this.reason;
                    }
                    Promise1.prototype["return"] = Promise1.prototype.thenReturn = function(value) {
                        if (value instanceof Promise1) value.suppressUnhandledRejections();
                        return this._then(returner, undefined, undefined, {
                            value: value
                        }, undefined);
                    };
                    Promise1.prototype["throw"] = Promise1.prototype.thenThrow = function(reason) {
                        return this._then(thrower, undefined, undefined, {
                            reason: reason
                        }, undefined);
                    };
                    Promise1.prototype.catchThrow = function(reason) {
                        if (arguments.length <= 1) return this._then(undefined, thrower, undefined, {
                            reason: reason
                        }, undefined);
                        else {
                            var _reason = arguments[1];
                            var handler = function() {
                                throw _reason;
                            };
                            return this.caught(reason, handler);
                        }
                    };
                    Promise1.prototype.catchReturn = function(value) {
                        if (arguments.length <= 1) {
                            if (value instanceof Promise1) value.suppressUnhandledRejections();
                            return this._then(undefined, returner, undefined, {
                                value: value
                            }, undefined);
                        } else {
                            var _value = arguments[1];
                            if (_value instanceof Promise1) _value.suppressUnhandledRejections();
                            var handler = function() {
                                return _value;
                            };
                            return this.caught(value, handler);
                        }
                    };
                };
            },
            {}
        ],
        11: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var PromiseReduce = Promise1.reduce;
                    var PromiseAll = Promise1.all;
                    function promiseAllThis() {
                        return PromiseAll(this);
                    }
                    function PromiseMapSeries(promises, fn) {
                        return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
                    }
                    Promise1.prototype.each = function(fn) {
                        return PromiseReduce(this, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, this, undefined);
                    };
                    Promise1.prototype.mapSeries = function(fn) {
                        return PromiseReduce(this, fn, INTERNAL, INTERNAL);
                    };
                    Promise1.each = function(promises, fn) {
                        return PromiseReduce(promises, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, promises, undefined);
                    };
                    Promise1.mapSeries = PromiseMapSeries;
                };
            },
            {}
        ],
        12: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var es5 = _dereq_1("./es5");
                var Objectfreeze = es5.freeze;
                var util = _dereq_1("./util");
                var inherits = util.inherits;
                var notEnumerableProp = util.notEnumerableProp;
                function subError(nameProperty, defaultMessage) {
                    function SubError(message) {
                        if (!(this instanceof SubError)) return new SubError(message);
                        notEnumerableProp(this, "message", typeof message === "string" ? message : defaultMessage);
                        notEnumerableProp(this, "name", nameProperty);
                        if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
                        else Error.call(this);
                    }
                    inherits(SubError, Error);
                    return SubError;
                }
                var _TypeError, _RangeError;
                var Warning = subError("Warning", "warning");
                var CancellationError = subError("CancellationError", "cancellation error");
                var TimeoutError = subError("TimeoutError", "timeout error");
                var AggregateError = subError("AggregateError", "aggregate error");
                try {
                    _TypeError = TypeError;
                    _RangeError = RangeError;
                } catch (e) {
                    _TypeError = subError("TypeError", "type error");
                    _RangeError = subError("RangeError", "range error");
                }
                var methods = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" ");
                for(var i = 0; i < methods.length; ++i)if (typeof Array.prototype[methods[i]] === "function") AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
                es5.defineProperty(AggregateError.prototype, "length", {
                    value: 0,
                    configurable: false,
                    writable: true,
                    enumerable: true
                });
                AggregateError.prototype["isOperational"] = true;
                var level = 0;
                AggregateError.prototype.toString = function() {
                    var indent = Array(level * 4 + 1).join(" ");
                    var ret = "\n" + indent + "AggregateError of:" + "\n";
                    level++;
                    indent = Array(level * 4 + 1).join(" ");
                    for(var i = 0; i < this.length; ++i){
                        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
                        var lines = str.split("\n");
                        for(var j = 0; j < lines.length; ++j)lines[j] = indent + lines[j];
                        str = lines.join("\n");
                        ret += str + "\n";
                    }
                    level--;
                    return ret;
                };
                function OperationalError(message) {
                    if (!(this instanceof OperationalError)) return new OperationalError(message);
                    notEnumerableProp(this, "name", "OperationalError");
                    notEnumerableProp(this, "message", message);
                    this.cause = message;
                    this["isOperational"] = true;
                    if (message instanceof Error) {
                        notEnumerableProp(this, "message", message.message);
                        notEnumerableProp(this, "stack", message.stack);
                    } else if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
                }
                inherits(OperationalError, Error);
                var errorTypes = Error["__BluebirdErrorTypes__"];
                if (!errorTypes) {
                    errorTypes = Objectfreeze({
                        CancellationError: CancellationError,
                        TimeoutError: TimeoutError,
                        OperationalError: OperationalError,
                        RejectionError: OperationalError,
                        AggregateError: AggregateError
                    });
                    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
                        value: errorTypes,
                        writable: false,
                        enumerable: false,
                        configurable: false
                    });
                }
                module1.exports = {
                    Error: Error,
                    TypeError: _TypeError,
                    RangeError: _RangeError,
                    CancellationError: errorTypes.CancellationError,
                    OperationalError: errorTypes.OperationalError,
                    TimeoutError: errorTypes.TimeoutError,
                    AggregateError: errorTypes.AggregateError,
                    Warning: Warning
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        13: [
            function(_dereq_1, module1, exports) {
                var isES5 = function() {
                    "use strict";
                    return this === undefined;
                }();
                if (isES5) module1.exports = {
                    freeze: Object.freeze,
                    defineProperty: Object.defineProperty,
                    getDescriptor: Object.getOwnPropertyDescriptor,
                    keys: Object.keys,
                    names: Object.getOwnPropertyNames,
                    getPrototypeOf: Object.getPrototypeOf,
                    isArray: Array.isArray,
                    isES5: isES5,
                    propertyIsWritable: function(obj, prop) {
                        var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
                        return !!(!descriptor || descriptor.writable || descriptor.set);
                    }
                };
                else {
                    var has = {}.hasOwnProperty;
                    var str = {}.toString;
                    var proto = {}.constructor.prototype;
                    var ObjectKeys = function(o) {
                        var ret = [];
                        for(var key in o)if (has.call(o, key)) ret.push(key);
                        return ret;
                    };
                    var ObjectGetDescriptor = function(o, key) {
                        return {
                            value: o[key]
                        };
                    };
                    var ObjectDefineProperty = function(o, key, desc) {
                        o[key] = desc.value;
                        return o;
                    };
                    var ObjectFreeze = function(obj) {
                        return obj;
                    };
                    var ObjectGetPrototypeOf = function(obj) {
                        try {
                            return Object(obj).constructor.prototype;
                        } catch (e) {
                            return proto;
                        }
                    };
                    var ArrayIsArray = function(obj) {
                        try {
                            return str.call(obj) === "[object Array]";
                        } catch (e) {
                            return false;
                        }
                    };
                    module1.exports = {
                        isArray: ArrayIsArray,
                        keys: ObjectKeys,
                        names: ObjectKeys,
                        defineProperty: ObjectDefineProperty,
                        getDescriptor: ObjectGetDescriptor,
                        freeze: ObjectFreeze,
                        getPrototypeOf: ObjectGetPrototypeOf,
                        isES5: isES5,
                        propertyIsWritable: function() {
                            return true;
                        }
                    };
                }
            },
            {}
        ],
        14: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var PromiseMap = Promise1.map;
                    Promise1.prototype.filter = function(fn, options) {
                        return PromiseMap(this, fn, options, INTERNAL);
                    };
                    Promise1.filter = function(promises, fn, options) {
                        return PromiseMap(promises, fn, options, INTERNAL);
                    };
                };
            },
            {}
        ],
        15: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, tryConvertToPromise, NEXT_FILTER) {
                    var util = _dereq_1("./util");
                    var CancellationError = Promise1.CancellationError;
                    var errorObj = util.errorObj;
                    var catchFilter = _dereq_1("./catch_filter")(NEXT_FILTER);
                    function PassThroughHandlerContext(promise, type, handler) {
                        this.promise = promise;
                        this.type = type;
                        this.handler = handler;
                        this.called = false;
                        this.cancelPromise = null;
                    }
                    PassThroughHandlerContext.prototype.isFinallyHandler = function() {
                        return this.type === 0;
                    };
                    function FinallyHandlerCancelReaction(finallyHandler) {
                        this.finallyHandler = finallyHandler;
                    }
                    FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
                        checkCancel(this.finallyHandler);
                    };
                    function checkCancel(ctx, reason) {
                        if (ctx.cancelPromise != null) {
                            if (arguments.length > 1) ctx.cancelPromise._reject(reason);
                            else ctx.cancelPromise._cancel();
                            ctx.cancelPromise = null;
                            return true;
                        }
                        return false;
                    }
                    function succeed() {
                        return finallyHandler.call(this, this.promise._target()._settledValue());
                    }
                    function fail(reason) {
                        if (checkCancel(this, reason)) return;
                        errorObj.e = reason;
                        return errorObj;
                    }
                    function finallyHandler(reasonOrValue) {
                        var promise = this.promise;
                        var handler = this.handler;
                        if (!this.called) {
                            this.called = true;
                            var ret = this.isFinallyHandler() ? handler.call(promise._boundValue()) : handler.call(promise._boundValue(), reasonOrValue);
                            if (ret === NEXT_FILTER) return ret;
                            else if (ret !== undefined) {
                                promise._setReturnedNonUndefined();
                                var maybePromise = tryConvertToPromise(ret, promise);
                                if (maybePromise instanceof Promise1) {
                                    if (this.cancelPromise != null) {
                                        if (maybePromise._isCancelled()) {
                                            var reason = new CancellationError("late cancellation observer");
                                            promise._attachExtraTrace(reason);
                                            errorObj.e = reason;
                                            return errorObj;
                                        } else if (maybePromise.isPending()) maybePromise._attachCancellationCallback(new FinallyHandlerCancelReaction(this));
                                    }
                                    return maybePromise._then(succeed, fail, undefined, this, undefined);
                                }
                            }
                        }
                        if (promise.isRejected()) {
                            checkCancel(this);
                            errorObj.e = reasonOrValue;
                            return errorObj;
                        } else {
                            checkCancel(this);
                            return reasonOrValue;
                        }
                    }
                    Promise1.prototype._passThrough = function(handler, type, success, fail) {
                        if (typeof handler !== "function") return this.then();
                        return this._then(success, fail, undefined, new PassThroughHandlerContext(this, type, handler), undefined);
                    };
                    Promise1.prototype.lastly = Promise1.prototype["finally"] = function(handler) {
                        return this._passThrough(handler, 0, finallyHandler, finallyHandler);
                    };
                    Promise1.prototype.tap = function(handler) {
                        return this._passThrough(handler, 1, finallyHandler);
                    };
                    Promise1.prototype.tapCatch = function(handlerOrPredicate) {
                        var len = arguments.length;
                        if (len === 1) return this._passThrough(handlerOrPredicate, 1, undefined, finallyHandler);
                        else {
                            var catchInstances = new Array(len - 1), j = 0, i;
                            for(i = 0; i < len - 1; ++i){
                                var item = arguments[i];
                                if (util.isObject(item)) catchInstances[j++] = item;
                                else return Promise1.reject(new TypeError("tapCatch statement predicate: expecting an object but got " + util.classString(item)));
                            }
                            catchInstances.length = j;
                            var handler = arguments[i];
                            return this._passThrough(catchFilter(catchInstances, handler, this), 1, undefined, finallyHandler);
                        }
                    };
                    return PassThroughHandlerContext;
                };
            },
            {
                "./catch_filter": 7,
                "./util": 36
            }
        ],
        16: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug) {
                    var errors = _dereq_1("./errors");
                    var TypeError1 = errors.TypeError;
                    var util = _dereq_1("./util");
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    var yieldHandlers = [];
                    function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
                        for(var i = 0; i < yieldHandlers.length; ++i){
                            traceParent._pushContext();
                            var result = tryCatch(yieldHandlers[i])(value);
                            traceParent._popContext();
                            if (result === errorObj) {
                                traceParent._pushContext();
                                var ret = Promise1.reject(errorObj.e);
                                traceParent._popContext();
                                return ret;
                            }
                            var maybePromise = tryConvertToPromise(result, traceParent);
                            if (maybePromise instanceof Promise1) return maybePromise;
                        }
                        return null;
                    }
                    function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
                        if (debug.cancellation()) {
                            var internal = new Promise1(INTERNAL);
                            var _finallyPromise = this._finallyPromise = new Promise1(INTERNAL);
                            this._promise = internal.lastly(function() {
                                return _finallyPromise;
                            });
                            internal._captureStackTrace();
                            internal._setOnCancel(this);
                        } else {
                            var promise = this._promise = new Promise1(INTERNAL);
                            promise._captureStackTrace();
                        }
                        this._stack = stack;
                        this._generatorFunction = generatorFunction;
                        this._receiver = receiver;
                        this._generator = undefined;
                        this._yieldHandlers = typeof yieldHandler === "function" ? [
                            yieldHandler
                        ].concat(yieldHandlers) : yieldHandlers;
                        this._yieldedPromise = null;
                        this._cancellationPhase = false;
                    }
                    util.inherits(PromiseSpawn, Proxyable);
                    PromiseSpawn.prototype._isResolved = function() {
                        return this._promise === null;
                    };
                    PromiseSpawn.prototype._cleanup = function() {
                        this._promise = this._generator = null;
                        if (debug.cancellation() && this._finallyPromise !== null) {
                            this._finallyPromise._fulfill();
                            this._finallyPromise = null;
                        }
                    };
                    PromiseSpawn.prototype._promiseCancelled = function() {
                        if (this._isResolved()) return;
                        var implementsReturn = typeof this._generator["return"] !== "undefined";
                        var result;
                        if (!implementsReturn) {
                            var reason = new Promise1.CancellationError("generator .return() sentinel");
                            Promise1.coroutine.returnSentinel = reason;
                            this._promise._attachExtraTrace(reason);
                            this._promise._pushContext();
                            result = tryCatch(this._generator["throw"]).call(this._generator, reason);
                            this._promise._popContext();
                        } else {
                            this._promise._pushContext();
                            result = tryCatch(this._generator["return"]).call(this._generator, undefined);
                            this._promise._popContext();
                        }
                        this._cancellationPhase = true;
                        this._yieldedPromise = null;
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._promiseFulfilled = function(value) {
                        this._yieldedPromise = null;
                        this._promise._pushContext();
                        var result = tryCatch(this._generator.next).call(this._generator, value);
                        this._promise._popContext();
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._promiseRejected = function(reason) {
                        this._yieldedPromise = null;
                        this._promise._attachExtraTrace(reason);
                        this._promise._pushContext();
                        var result = tryCatch(this._generator["throw"]).call(this._generator, reason);
                        this._promise._popContext();
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._resultCancelled = function() {
                        if (this._yieldedPromise instanceof Promise1) {
                            var promise = this._yieldedPromise;
                            this._yieldedPromise = null;
                            promise.cancel();
                        }
                    };
                    PromiseSpawn.prototype.promise = function() {
                        return this._promise;
                    };
                    PromiseSpawn.prototype._run = function() {
                        this._generator = this._generatorFunction.call(this._receiver);
                        this._receiver = this._generatorFunction = undefined;
                        this._promiseFulfilled(undefined);
                    };
                    PromiseSpawn.prototype._continue = function(result) {
                        var promise = this._promise;
                        if (result === errorObj) {
                            this._cleanup();
                            if (this._cancellationPhase) return promise.cancel();
                            else return promise._rejectCallback(result.e, false);
                        }
                        var value = result.value;
                        if (result.done === true) {
                            this._cleanup();
                            if (this._cancellationPhase) return promise.cancel();
                            else return promise._resolveCallback(value);
                        } else {
                            var maybePromise = tryConvertToPromise(value, this._promise);
                            if (!(maybePromise instanceof Promise1)) {
                                maybePromise = promiseFromYieldHandler(maybePromise, this._yieldHandlers, this._promise);
                                if (maybePromise === null) {
                                    this._promiseRejected(new TypeError1("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s", String(value)) + "From coroutine:\n" + this._stack.split("\n").slice(1, -7).join("\n")));
                                    return;
                                }
                            }
                            maybePromise = maybePromise._target();
                            var bitField = maybePromise._bitField;
                            if ((bitField & 50397184) === 0) {
                                this._yieldedPromise = maybePromise;
                                maybePromise._proxy(this, null);
                            } else if ((bitField & 33554432) !== 0) Promise1._async.invoke(this._promiseFulfilled, this, maybePromise._value());
                            else if ((bitField & 16777216) !== 0) Promise1._async.invoke(this._promiseRejected, this, maybePromise._reason());
                            else this._promiseCancelled();
                        }
                    };
                    Promise1.coroutine = function(generatorFunction, options) {
                        if (typeof generatorFunction !== "function") throw new TypeError1("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
                        var yieldHandler = Object(options).yieldHandler;
                        var PromiseSpawn$ = PromiseSpawn;
                        var stack = new Error().stack;
                        return function() {
                            var generator = generatorFunction.apply(this, arguments);
                            var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler, stack);
                            var ret = spawn.promise();
                            spawn._generator = generator;
                            spawn._promiseFulfilled(undefined);
                            return ret;
                        };
                    };
                    Promise1.coroutine.addYieldHandler = function(fn) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        yieldHandlers.push(fn);
                    };
                    Promise1.spawn = function(generatorFunction) {
                        debug.deprecated("Promise.spawn()", "Promise.coroutine()");
                        if (typeof generatorFunction !== "function") return apiRejection("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
                        var spawn = new PromiseSpawn(generatorFunction, this);
                        var ret = spawn.promise();
                        spawn._run(Promise1.spawn);
                        return ret;
                    };
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        17: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, tryConvertToPromise, INTERNAL, async) {
                    var util = _dereq_1("./util");
                    var canEvaluate = util.canEvaluate;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var reject;
                    var thenCallback, promiseSetter, generateHolderClass, holderClasses, thenCallbacks, promiseSetters, i;
                    Promise1.join = function() {
                        var last = arguments.length - 1;
                        var fn;
                        if (last > 0 && typeof arguments[last] === "function") {
                            fn = arguments[last];
                            var ret, HolderClass, holder, callbacks, i, maybePromise, bitField, context;
                        }
                        var args = [].slice.call(arguments);
                        if (fn) args.pop();
                        var ret = new PromiseArray(args).promise();
                        return fn !== undefined ? ret.spread(fn) : ret;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        18: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var async = Promise1._async;
                    function MappingPromiseArray(promises, fn, limit, _filter) {
                        this.constructor$(promises);
                        this._promise._captureStackTrace();
                        var context = Promise1._getContext();
                        this._callback = util.contextBind(context, fn);
                        this._preservedValues = _filter === INTERNAL ? new Array(this.length()) : null;
                        this._limit = limit;
                        this._inFlight = 0;
                        this._queue = [];
                        async.invoke(this._asyncInit, this, undefined);
                        if (util.isArray(promises)) for(var i = 0; i < promises.length; ++i){
                            var maybePromise = promises[i];
                            if (maybePromise instanceof Promise1) maybePromise.suppressUnhandledRejections();
                        }
                    }
                    util.inherits(MappingPromiseArray, PromiseArray);
                    MappingPromiseArray.prototype._asyncInit = function() {
                        this._init$(undefined, -2);
                    };
                    MappingPromiseArray.prototype._init = function() {};
                    MappingPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        var values = this._values;
                        var length = this.length();
                        var preservedValues = this._preservedValues;
                        var limit = this._limit;
                        if (index < 0) {
                            index = index * -1 - 1;
                            values[index] = value;
                            if (limit >= 1) {
                                this._inFlight--;
                                this._drainQueue();
                                if (this._isResolved()) return true;
                            }
                        } else {
                            if (limit >= 1 && this._inFlight >= limit) {
                                values[index] = value;
                                this._queue.push(index);
                                return false;
                            }
                            if (preservedValues !== null) preservedValues[index] = value;
                            var promise = this._promise;
                            var callback = this._callback;
                            var receiver = promise._boundValue();
                            promise._pushContext();
                            var ret = tryCatch(callback).call(receiver, value, index, length);
                            var promiseCreated = promise._popContext();
                            debug.checkForgottenReturns(ret, promiseCreated, preservedValues !== null ? "Promise.filter" : "Promise.map", promise);
                            if (ret === errorObj) {
                                this._reject(ret.e);
                                return true;
                            }
                            var maybePromise = tryConvertToPromise(ret, this._promise);
                            if (maybePromise instanceof Promise1) {
                                maybePromise = maybePromise._target();
                                var bitField = maybePromise._bitField;
                                if ((bitField & 50397184) === 0) {
                                    if (limit >= 1) this._inFlight++;
                                    values[index] = maybePromise;
                                    maybePromise._proxy(this, (index + 1) * -1);
                                    return false;
                                } else if ((bitField & 33554432) !== 0) ret = maybePromise._value();
                                else if ((bitField & 16777216) !== 0) {
                                    this._reject(maybePromise._reason());
                                    return true;
                                } else {
                                    this._cancel();
                                    return true;
                                }
                            }
                            values[index] = ret;
                        }
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= length) {
                            if (preservedValues !== null) this._filter(values, preservedValues);
                            else this._resolve(values);
                            return true;
                        }
                        return false;
                    };
                    MappingPromiseArray.prototype._drainQueue = function() {
                        var queue = this._queue;
                        var limit = this._limit;
                        var values = this._values;
                        while(queue.length > 0 && this._inFlight < limit){
                            if (this._isResolved()) return;
                            var index = queue.pop();
                            this._promiseFulfilled(values[index], index);
                        }
                    };
                    MappingPromiseArray.prototype._filter = function(booleans, values) {
                        var len = values.length;
                        var ret = new Array(len);
                        var j = 0;
                        for(var i = 0; i < len; ++i)if (booleans[i]) ret[j++] = values[i];
                        ret.length = j;
                        this._resolve(ret);
                    };
                    MappingPromiseArray.prototype.preservedValues = function() {
                        return this._preservedValues;
                    };
                    function map(promises, fn, options, _filter) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var limit = 0;
                        if (options !== undefined) {
                            if (typeof options === "object" && options !== null) {
                                if (typeof options.concurrency !== "number") return Promise1.reject(new TypeError("'concurrency' must be a number but it is " + util.classString(options.concurrency)));
                                limit = options.concurrency;
                            } else return Promise1.reject(new TypeError("options argument must be an object but it is " + util.classString(options)));
                        }
                        limit = typeof limit === "number" && isFinite(limit) && limit >= 1 ? limit : 0;
                        return new MappingPromiseArray(promises, fn, limit, _filter).promise();
                    }
                    Promise1.prototype.map = function(fn, options) {
                        return map(this, fn, options, null);
                    };
                    Promise1.map = function(promises, fn, options, _filter) {
                        return map(promises, fn, options, _filter);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        19: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    Promise1.method = function(fn) {
                        if (typeof fn !== "function") throw new Promise1.TypeError("expecting a function but got " + util.classString(fn));
                        return function() {
                            var ret = new Promise1(INTERNAL);
                            ret._captureStackTrace();
                            ret._pushContext();
                            var value = tryCatch(fn).apply(this, arguments);
                            var promiseCreated = ret._popContext();
                            debug.checkForgottenReturns(value, promiseCreated, "Promise.method", ret);
                            ret._resolveFromSyncValue(value);
                            return ret;
                        };
                    };
                    Promise1.attempt = Promise1["try"] = function(fn) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        ret._pushContext();
                        var value;
                        if (arguments.length > 1) {
                            debug.deprecated("calling Promise.try with more than 1 argument");
                            var arg = arguments[1];
                            var ctx = arguments[2];
                            value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg) : tryCatch(fn).call(ctx, arg);
                        } else value = tryCatch(fn)();
                        var promiseCreated = ret._popContext();
                        debug.checkForgottenReturns(value, promiseCreated, "Promise.try", ret);
                        ret._resolveFromSyncValue(value);
                        return ret;
                    };
                    Promise1.prototype._resolveFromSyncValue = function(value) {
                        if (value === util.errorObj) this._rejectCallback(value.e, false);
                        else this._resolveCallback(value, true);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        20: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var util = _dereq_1("./util");
                var maybeWrapAsError = util.maybeWrapAsError;
                var errors = _dereq_1("./errors");
                var OperationalError = errors.OperationalError;
                var es5 = _dereq_1("./es5");
                function isUntypedError(obj) {
                    return obj instanceof Error && es5.getPrototypeOf(obj) === Error.prototype;
                }
                var rErrorKey = /^(?:name|message|stack|cause)$/;
                function wrapAsOperationalError(obj) {
                    var ret;
                    if (isUntypedError(obj)) {
                        ret = new OperationalError(obj);
                        ret.name = obj.name;
                        ret.message = obj.message;
                        ret.stack = obj.stack;
                        var keys = es5.keys(obj);
                        for(var i = 0; i < keys.length; ++i){
                            var key = keys[i];
                            if (!rErrorKey.test(key)) ret[key] = obj[key];
                        }
                        return ret;
                    }
                    util.markAsOriginatingFromRejection(obj);
                    return obj;
                }
                function nodebackForPromise(promise, multiArgs) {
                    return function(err, value) {
                        if (promise === null) return;
                        if (err) {
                            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
                            promise._attachExtraTrace(wrapped);
                            promise._reject(wrapped);
                        } else if (!multiArgs) promise._fulfill(value);
                        else {
                            var args = [].slice.call(arguments, 1);
                            promise._fulfill(args);
                        }
                        promise = null;
                    };
                }
                module1.exports = nodebackForPromise;
            },
            {
                "./errors": 12,
                "./es5": 13,
                "./util": 36
            }
        ],
        21: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var util = _dereq_1("./util");
                    var async = Promise1._async;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    function spreadAdapter(val, nodeback) {
                        var promise = this;
                        if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
                        var ret = tryCatch(nodeback).apply(promise._boundValue(), [
                            null
                        ].concat(val));
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    function successAdapter(val, nodeback) {
                        var promise = this;
                        var receiver = promise._boundValue();
                        var ret = val === undefined ? tryCatch(nodeback).call(receiver, null) : tryCatch(nodeback).call(receiver, null, val);
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    function errorAdapter(reason, nodeback) {
                        var promise = this;
                        if (!reason) {
                            var newReason = new Error(reason + "");
                            newReason.cause = reason;
                            reason = newReason;
                        }
                        var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    Promise1.prototype.asCallback = Promise1.prototype.nodeify = function(nodeback, options) {
                        if (typeof nodeback == "function") {
                            var adapter = successAdapter;
                            if (options !== undefined && Object(options).spread) adapter = spreadAdapter;
                            this._then(adapter, errorAdapter, undefined, this, nodeback);
                        }
                        return this;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        22: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function() {
                    var makeSelfResolutionError = function() {
                        return new TypeError1("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n");
                    };
                    var reflectHandler = function() {
                        return new Promise1.PromiseInspection(this._target());
                    };
                    var apiRejection = function(msg) {
                        return Promise1.reject(new TypeError1(msg));
                    };
                    function Proxyable() {}
                    var UNDEFINED_BINDING = {};
                    var util = _dereq_1("./util");
                    util.setReflectHandler(reflectHandler);
                    var getDomain = function() {
                        var domain = $449e3df09682ce9f$exports.domain;
                        if (domain === undefined) return null;
                        return domain;
                    };
                    var getContextDefault = function() {
                        return null;
                    };
                    var getContextDomain = function() {
                        return {
                            domain: getDomain(),
                            async: null
                        };
                    };
                    var AsyncResource = util.isNode && util.nodeSupportsAsyncResource ? _dereq_1("async_hooks").AsyncResource : null;
                    var getContextAsyncHooks = function() {
                        return {
                            domain: getDomain(),
                            async: new AsyncResource("Bluebird::Promise")
                        };
                    };
                    var getContext = util.isNode ? getContextDomain : getContextDefault;
                    util.notEnumerableProp(Promise1, "_getContext", getContext);
                    var enableAsyncHooks = function() {
                        getContext = getContextAsyncHooks;
                        util.notEnumerableProp(Promise1, "_getContext", getContextAsyncHooks);
                    };
                    var disableAsyncHooks = function() {
                        getContext = getContextDomain;
                        util.notEnumerableProp(Promise1, "_getContext", getContextDomain);
                    };
                    var es5 = _dereq_1("./es5");
                    var Async = _dereq_1("./async");
                    var async = new Async();
                    es5.defineProperty(Promise1, "_async", {
                        value: async
                    });
                    var errors = _dereq_1("./errors");
                    var TypeError1 = Promise1.TypeError = errors.TypeError;
                    Promise1.RangeError = errors.RangeError;
                    var CancellationError = Promise1.CancellationError = errors.CancellationError;
                    Promise1.TimeoutError = errors.TimeoutError;
                    Promise1.OperationalError = errors.OperationalError;
                    Promise1.RejectionError = errors.OperationalError;
                    Promise1.AggregateError = errors.AggregateError;
                    var INTERNAL = function() {};
                    var APPLY = {};
                    var NEXT_FILTER = {};
                    var tryConvertToPromise = _dereq_1("./thenables")(Promise1, INTERNAL);
                    var PromiseArray = _dereq_1("./promise_array")(Promise1, INTERNAL, tryConvertToPromise, apiRejection, Proxyable);
                    var Context = _dereq_1("./context")(Promise1);
                    /*jshint unused:false*/ var createContext = Context.create;
                    var debug = _dereq_1("./debuggability")(Promise1, Context, enableAsyncHooks, disableAsyncHooks);
                    var CapturedTrace = debug.CapturedTrace;
                    var PassThroughHandlerContext = _dereq_1("./finally")(Promise1, tryConvertToPromise, NEXT_FILTER);
                    var catchFilter = _dereq_1("./catch_filter")(NEXT_FILTER);
                    var nodebackForPromise = _dereq_1("./nodeback");
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    function check(self1, executor) {
                        if (self1 == null || self1.constructor !== Promise1) throw new TypeError1("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");
                        if (typeof executor !== "function") throw new TypeError1("expecting a function but got " + util.classString(executor));
                    }
                    function Promise1(executor) {
                        if (executor !== INTERNAL) check(this, executor);
                        this._bitField = 0;
                        this._fulfillmentHandler0 = undefined;
                        this._rejectionHandler0 = undefined;
                        this._promise0 = undefined;
                        this._receiver0 = undefined;
                        this._resolveFromExecutor(executor);
                        this._promiseCreated();
                        this._fireEvent("promiseCreated", this);
                    }
                    Promise1.prototype.toString = function() {
                        return "[object Promise]";
                    };
                    Promise1.prototype.caught = Promise1.prototype["catch"] = function(fn) {
                        var len = arguments.length;
                        if (len > 1) {
                            var catchInstances = new Array(len - 1), j = 0, i;
                            for(i = 0; i < len - 1; ++i){
                                var item = arguments[i];
                                if (util.isObject(item)) catchInstances[j++] = item;
                                else return apiRejection("Catch statement predicate: expecting an object but got " + util.classString(item));
                            }
                            catchInstances.length = j;
                            fn = arguments[i];
                            if (typeof fn !== "function") throw new TypeError1("The last argument to .catch() must be a function, got " + util.toString(fn));
                            return this.then(undefined, catchFilter(catchInstances, fn, this));
                        }
                        return this.then(undefined, fn);
                    };
                    Promise1.prototype.reflect = function() {
                        return this._then(reflectHandler, reflectHandler, undefined, this, undefined);
                    };
                    Promise1.prototype.then = function(didFulfill, didReject) {
                        if (debug.warnings() && arguments.length > 0 && typeof didFulfill !== "function" && typeof didReject !== "function") {
                            var msg = ".then() only accepts functions but was passed: " + util.classString(didFulfill);
                            if (arguments.length > 1) msg += ", " + util.classString(didReject);
                            this._warn(msg);
                        }
                        return this._then(didFulfill, didReject, undefined, undefined, undefined);
                    };
                    Promise1.prototype.done = function(didFulfill, didReject) {
                        var promise = this._then(didFulfill, didReject, undefined, undefined, undefined);
                        promise._setIsFinal();
                    };
                    Promise1.prototype.spread = function(fn) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        return this.all()._then(fn, undefined, undefined, APPLY, undefined);
                    };
                    Promise1.prototype.toJSON = function() {
                        var ret = {
                            isFulfilled: false,
                            isRejected: false,
                            fulfillmentValue: undefined,
                            rejectionReason: undefined
                        };
                        if (this.isFulfilled()) {
                            ret.fulfillmentValue = this.value();
                            ret.isFulfilled = true;
                        } else if (this.isRejected()) {
                            ret.rejectionReason = this.reason();
                            ret.isRejected = true;
                        }
                        return ret;
                    };
                    Promise1.prototype.all = function() {
                        if (arguments.length > 0) this._warn(".all() was passed arguments but it does not take any");
                        return new PromiseArray(this).promise();
                    };
                    Promise1.prototype.error = function(fn) {
                        return this.caught(util.originatesFromRejection, fn);
                    };
                    Promise1.getNewLibraryCopy = module1.exports;
                    Promise1.is = function(val) {
                        return val instanceof Promise1;
                    };
                    Promise1.fromNode = Promise1.fromCallback = function(fn) {
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs : false;
                        var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
                        if (result === errorObj) ret._rejectCallback(result.e, true);
                        if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
                        return ret;
                    };
                    Promise1.all = function(promises) {
                        return new PromiseArray(promises).promise();
                    };
                    Promise1.cast = function(obj) {
                        var ret = tryConvertToPromise(obj);
                        if (!(ret instanceof Promise1)) {
                            ret = new Promise1(INTERNAL);
                            ret._captureStackTrace();
                            ret._setFulfilled();
                            ret._rejectionHandler0 = obj;
                        }
                        return ret;
                    };
                    Promise1.resolve = Promise1.fulfilled = Promise1.cast;
                    Promise1.reject = Promise1.rejected = function(reason) {
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        ret._rejectCallback(reason, true);
                        return ret;
                    };
                    Promise1.setScheduler = function(fn) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        return async.setScheduler(fn);
                    };
                    Promise1.prototype._then = function(didFulfill, didReject, _, receiver, internalData) {
                        var haveInternalData = internalData !== undefined;
                        var promise = haveInternalData ? internalData : new Promise1(INTERNAL);
                        var target = this._target();
                        var bitField = target._bitField;
                        if (!haveInternalData) {
                            promise._propagateFrom(this, 3);
                            promise._captureStackTrace();
                            if (receiver === undefined && (this._bitField & 2097152) !== 0) {
                                if (!((bitField & 50397184) === 0)) receiver = this._boundValue();
                                else receiver = target === this ? undefined : this._boundTo;
                            }
                            this._fireEvent("promiseChained", this, promise);
                        }
                        var context = getContext();
                        if (!((bitField & 50397184) === 0)) {
                            var handler, value, settler = target._settlePromiseCtx;
                            if ((bitField & 33554432) !== 0) {
                                value = target._rejectionHandler0;
                                handler = didFulfill;
                            } else if ((bitField & 16777216) !== 0) {
                                value = target._fulfillmentHandler0;
                                handler = didReject;
                                target._unsetRejectionIsUnhandled();
                            } else {
                                settler = target._settlePromiseLateCancellationObserver;
                                value = new CancellationError("late cancellation observer");
                                target._attachExtraTrace(value);
                                handler = didReject;
                            }
                            async.invoke(settler, target, {
                                handler: util.contextBind(context, handler),
                                promise: promise,
                                receiver: receiver,
                                value: value
                            });
                        } else target._addCallbacks(didFulfill, didReject, promise, receiver, context);
                        return promise;
                    };
                    Promise1.prototype._length = function() {
                        return this._bitField & 65535;
                    };
                    Promise1.prototype._isFateSealed = function() {
                        return (this._bitField & 117506048) !== 0;
                    };
                    Promise1.prototype._isFollowing = function() {
                        return (this._bitField & 67108864) === 67108864;
                    };
                    Promise1.prototype._setLength = function(len) {
                        this._bitField = this._bitField & -65536 | len & 65535;
                    };
                    Promise1.prototype._setFulfilled = function() {
                        this._bitField = this._bitField | 33554432;
                        this._fireEvent("promiseFulfilled", this);
                    };
                    Promise1.prototype._setRejected = function() {
                        this._bitField = this._bitField | 16777216;
                        this._fireEvent("promiseRejected", this);
                    };
                    Promise1.prototype._setFollowing = function() {
                        this._bitField = this._bitField | 67108864;
                        this._fireEvent("promiseResolved", this);
                    };
                    Promise1.prototype._setIsFinal = function() {
                        this._bitField = this._bitField | 4194304;
                    };
                    Promise1.prototype._isFinal = function() {
                        return (this._bitField & 4194304) > 0;
                    };
                    Promise1.prototype._unsetCancelled = function() {
                        this._bitField = this._bitField & -65537;
                    };
                    Promise1.prototype._setCancelled = function() {
                        this._bitField = this._bitField | 65536;
                        this._fireEvent("promiseCancelled", this);
                    };
                    Promise1.prototype._setWillBeCancelled = function() {
                        this._bitField = this._bitField | 8388608;
                    };
                    Promise1.prototype._setAsyncGuaranteed = function() {
                        if (async.hasCustomScheduler()) return;
                        var bitField = this._bitField;
                        this._bitField = bitField | (bitField & 536870912) >> 2 ^ 134217728;
                    };
                    Promise1.prototype._setNoAsyncGuarantee = function() {
                        this._bitField = (this._bitField | 536870912) & -134217729;
                    };
                    Promise1.prototype._receiverAt = function(index) {
                        var ret = index === 0 ? this._receiver0 : this[index * 4 - 4 + 3];
                        if (ret === UNDEFINED_BINDING) return undefined;
                        else if (ret === undefined && this._isBound()) return this._boundValue();
                        return ret;
                    };
                    Promise1.prototype._promiseAt = function(index) {
                        return this[index * 4 - 4 + 2];
                    };
                    Promise1.prototype._fulfillmentHandlerAt = function(index) {
                        return this[index * 4 - 4 + 0];
                    };
                    Promise1.prototype._rejectionHandlerAt = function(index) {
                        return this[index * 4 - 4 + 1];
                    };
                    Promise1.prototype._boundValue = function() {};
                    Promise1.prototype._migrateCallback0 = function(follower) {
                        var bitField = follower._bitField;
                        var fulfill = follower._fulfillmentHandler0;
                        var reject = follower._rejectionHandler0;
                        var promise = follower._promise0;
                        var receiver = follower._receiverAt(0);
                        if (receiver === undefined) receiver = UNDEFINED_BINDING;
                        this._addCallbacks(fulfill, reject, promise, receiver, null);
                    };
                    Promise1.prototype._migrateCallbackAt = function(follower, index) {
                        var fulfill = follower._fulfillmentHandlerAt(index);
                        var reject = follower._rejectionHandlerAt(index);
                        var promise = follower._promiseAt(index);
                        var receiver = follower._receiverAt(index);
                        if (receiver === undefined) receiver = UNDEFINED_BINDING;
                        this._addCallbacks(fulfill, reject, promise, receiver, null);
                    };
                    Promise1.prototype._addCallbacks = function(fulfill, reject, promise, receiver, context) {
                        var index = this._length();
                        if (index >= 65531) {
                            index = 0;
                            this._setLength(0);
                        }
                        if (index === 0) {
                            this._promise0 = promise;
                            this._receiver0 = receiver;
                            if (typeof fulfill === "function") this._fulfillmentHandler0 = util.contextBind(context, fulfill);
                            if (typeof reject === "function") this._rejectionHandler0 = util.contextBind(context, reject);
                        } else {
                            var base = index * 4 - 4;
                            this[base + 2] = promise;
                            this[base + 3] = receiver;
                            if (typeof fulfill === "function") this[base + 0] = util.contextBind(context, fulfill);
                            if (typeof reject === "function") this[base + 1] = util.contextBind(context, reject);
                        }
                        this._setLength(index + 1);
                        return index;
                    };
                    Promise1.prototype._proxy = function(proxyable, arg) {
                        this._addCallbacks(undefined, undefined, arg, proxyable, null);
                    };
                    Promise1.prototype._resolveCallback = function(value, shouldBind) {
                        if ((this._bitField & 117506048) !== 0) return;
                        if (value === this) return this._rejectCallback(makeSelfResolutionError(), false);
                        var maybePromise = tryConvertToPromise(value, this);
                        if (!(maybePromise instanceof Promise1)) return this._fulfill(value);
                        if (shouldBind) this._propagateFrom(maybePromise, 2);
                        var promise = maybePromise._target();
                        if (promise === this) {
                            this._reject(makeSelfResolutionError());
                            return;
                        }
                        var bitField = promise._bitField;
                        if ((bitField & 50397184) === 0) {
                            var len = this._length();
                            if (len > 0) promise._migrateCallback0(this);
                            for(var i = 1; i < len; ++i)promise._migrateCallbackAt(this, i);
                            this._setFollowing();
                            this._setLength(0);
                            this._setFollowee(maybePromise);
                        } else if ((bitField & 33554432) !== 0) this._fulfill(promise._value());
                        else if ((bitField & 16777216) !== 0) this._reject(promise._reason());
                        else {
                            var reason = new CancellationError("late cancellation observer");
                            promise._attachExtraTrace(reason);
                            this._reject(reason);
                        }
                    };
                    Promise1.prototype._rejectCallback = function(reason, synchronous, ignoreNonErrorWarnings) {
                        var trace = util.ensureErrorObject(reason);
                        var hasStack = trace === reason;
                        if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
                            var message = "a promise was rejected with a non-error: " + util.classString(reason);
                            this._warn(message, true);
                        }
                        this._attachExtraTrace(trace, synchronous ? hasStack : false);
                        this._reject(reason);
                    };
                    Promise1.prototype._resolveFromExecutor = function(executor) {
                        if (executor === INTERNAL) return;
                        var promise = this;
                        this._captureStackTrace();
                        this._pushContext();
                        var synchronous = true;
                        var r = this._execute(executor, function(value) {
                            promise._resolveCallback(value);
                        }, function(reason) {
                            promise._rejectCallback(reason, synchronous);
                        });
                        synchronous = false;
                        this._popContext();
                        if (r !== undefined) promise._rejectCallback(r, true);
                    };
                    Promise1.prototype._settlePromiseFromHandler = function(handler, receiver, value, promise) {
                        var bitField = promise._bitField;
                        if ((bitField & 65536) !== 0) return;
                        promise._pushContext();
                        var x;
                        if (receiver === APPLY) {
                            if (!value || typeof value.length !== "number") {
                                x = errorObj;
                                x.e = new TypeError1("cannot .spread() a non-array: " + util.classString(value));
                            } else x = tryCatch(handler).apply(this._boundValue(), value);
                        } else x = tryCatch(handler).call(receiver, value);
                        var promiseCreated = promise._popContext();
                        bitField = promise._bitField;
                        if ((bitField & 65536) !== 0) return;
                        if (x === NEXT_FILTER) promise._reject(value);
                        else if (x === errorObj) promise._rejectCallback(x.e, false);
                        else {
                            debug.checkForgottenReturns(x, promiseCreated, "", promise, this);
                            promise._resolveCallback(x);
                        }
                    };
                    Promise1.prototype._target = function() {
                        var ret = this;
                        while(ret._isFollowing())ret = ret._followee();
                        return ret;
                    };
                    Promise1.prototype._followee = function() {
                        return this._rejectionHandler0;
                    };
                    Promise1.prototype._setFollowee = function(promise) {
                        this._rejectionHandler0 = promise;
                    };
                    Promise1.prototype._settlePromise = function(promise, handler, receiver, value) {
                        var isPromise = promise instanceof Promise1;
                        var bitField = this._bitField;
                        var asyncGuaranteed = (bitField & 134217728) !== 0;
                        if ((bitField & 65536) !== 0) {
                            if (isPromise) promise._invokeInternalOnCancel();
                            if (receiver instanceof PassThroughHandlerContext && receiver.isFinallyHandler()) {
                                receiver.cancelPromise = promise;
                                if (tryCatch(handler).call(receiver, value) === errorObj) promise._reject(errorObj.e);
                            } else if (handler === reflectHandler) promise._fulfill(reflectHandler.call(receiver));
                            else if (receiver instanceof Proxyable) receiver._promiseCancelled(promise);
                            else if (isPromise || promise instanceof PromiseArray) promise._cancel();
                            else receiver.cancel();
                        } else if (typeof handler === "function") {
                            if (!isPromise) handler.call(receiver, value, promise);
                            else {
                                if (asyncGuaranteed) promise._setAsyncGuaranteed();
                                this._settlePromiseFromHandler(handler, receiver, value, promise);
                            }
                        } else if (receiver instanceof Proxyable) {
                            if (!receiver._isResolved()) {
                                if ((bitField & 33554432) !== 0) receiver._promiseFulfilled(value, promise);
                                else receiver._promiseRejected(value, promise);
                            }
                        } else if (isPromise) {
                            if (asyncGuaranteed) promise._setAsyncGuaranteed();
                            if ((bitField & 33554432) !== 0) promise._fulfill(value);
                            else promise._reject(value);
                        }
                    };
                    Promise1.prototype._settlePromiseLateCancellationObserver = function(ctx) {
                        var handler = ctx.handler;
                        var promise = ctx.promise;
                        var receiver = ctx.receiver;
                        var value = ctx.value;
                        if (typeof handler === "function") {
                            if (!(promise instanceof Promise1)) handler.call(receiver, value, promise);
                            else this._settlePromiseFromHandler(handler, receiver, value, promise);
                        } else if (promise instanceof Promise1) promise._reject(value);
                    };
                    Promise1.prototype._settlePromiseCtx = function(ctx) {
                        this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
                    };
                    Promise1.prototype._settlePromise0 = function(handler, value, bitField) {
                        var promise = this._promise0;
                        var receiver = this._receiverAt(0);
                        this._promise0 = undefined;
                        this._receiver0 = undefined;
                        this._settlePromise(promise, handler, receiver, value);
                    };
                    Promise1.prototype._clearCallbackDataAtIndex = function(index) {
                        var base = index * 4 - 4;
                        this[base + 2] = this[base + 3] = this[base + 0] = this[base + 1] = undefined;
                    };
                    Promise1.prototype._fulfill = function(value) {
                        var bitField = this._bitField;
                        if ((bitField & 117506048) >>> 16) return;
                        if (value === this) {
                            var err = makeSelfResolutionError();
                            this._attachExtraTrace(err);
                            return this._reject(err);
                        }
                        this._setFulfilled();
                        this._rejectionHandler0 = value;
                        if ((bitField & 65535) > 0) {
                            if ((bitField & 134217728) !== 0) this._settlePromises();
                            else async.settlePromises(this);
                            this._dereferenceTrace();
                        }
                    };
                    Promise1.prototype._reject = function(reason) {
                        var bitField = this._bitField;
                        if ((bitField & 117506048) >>> 16) return;
                        this._setRejected();
                        this._fulfillmentHandler0 = reason;
                        if (this._isFinal()) return async.fatalError(reason, util.isNode);
                        if ((bitField & 65535) > 0) async.settlePromises(this);
                        else this._ensurePossibleRejectionHandled();
                    };
                    Promise1.prototype._fulfillPromises = function(len, value) {
                        for(var i = 1; i < len; i++){
                            var handler = this._fulfillmentHandlerAt(i);
                            var promise = this._promiseAt(i);
                            var receiver = this._receiverAt(i);
                            this._clearCallbackDataAtIndex(i);
                            this._settlePromise(promise, handler, receiver, value);
                        }
                    };
                    Promise1.prototype._rejectPromises = function(len, reason) {
                        for(var i = 1; i < len; i++){
                            var handler = this._rejectionHandlerAt(i);
                            var promise = this._promiseAt(i);
                            var receiver = this._receiverAt(i);
                            this._clearCallbackDataAtIndex(i);
                            this._settlePromise(promise, handler, receiver, reason);
                        }
                    };
                    Promise1.prototype._settlePromises = function() {
                        var bitField = this._bitField;
                        var len = bitField & 65535;
                        if (len > 0) {
                            if ((bitField & 16842752) !== 0) {
                                var reason = this._fulfillmentHandler0;
                                this._settlePromise0(this._rejectionHandler0, reason, bitField);
                                this._rejectPromises(len, reason);
                            } else {
                                var value = this._rejectionHandler0;
                                this._settlePromise0(this._fulfillmentHandler0, value, bitField);
                                this._fulfillPromises(len, value);
                            }
                            this._setLength(0);
                        }
                        this._clearCancellationData();
                    };
                    Promise1.prototype._settledValue = function() {
                        var bitField = this._bitField;
                        if ((bitField & 33554432) !== 0) return this._rejectionHandler0;
                        else if ((bitField & 16777216) !== 0) return this._fulfillmentHandler0;
                    };
                    if (typeof Symbol !== "undefined" && Symbol.toStringTag) es5.defineProperty(Promise1.prototype, Symbol.toStringTag, {
                        get: function() {
                            return "Object";
                        }
                    });
                    function deferResolve(v) {
                        this.promise._resolveCallback(v);
                    }
                    function deferReject(v) {
                        this.promise._rejectCallback(v, false);
                    }
                    Promise1.defer = Promise1.pending = function() {
                        debug.deprecated("Promise.defer", "new Promise");
                        var promise = new Promise1(INTERNAL);
                        return {
                            promise: promise,
                            resolve: deferResolve,
                            reject: deferReject
                        };
                    };
                    util.notEnumerableProp(Promise1, "_makeSelfResolutionError", makeSelfResolutionError);
                    _dereq_1("./method")(Promise1, INTERNAL, tryConvertToPromise, apiRejection, debug);
                    _dereq_1("./bind")(Promise1, INTERNAL, tryConvertToPromise, debug);
                    _dereq_1("./cancel")(Promise1, PromiseArray, apiRejection, debug);
                    _dereq_1("./direct_resolve")(Promise1);
                    _dereq_1("./synchronous_inspection")(Promise1);
                    _dereq_1("./join")(Promise1, PromiseArray, tryConvertToPromise, INTERNAL, async);
                    Promise1.Promise = Promise1;
                    Promise1.version = "3.7.2";
                    _dereq_1("./call_get.js")(Promise1);
                    _dereq_1("./generators.js")(Promise1, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
                    _dereq_1("./map.js")(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
                    _dereq_1("./nodeify.js")(Promise1);
                    _dereq_1("./promisify.js")(Promise1, INTERNAL);
                    _dereq_1("./props.js")(Promise1, PromiseArray, tryConvertToPromise, apiRejection);
                    _dereq_1("./race.js")(Promise1, INTERNAL, tryConvertToPromise, apiRejection);
                    _dereq_1("./reduce.js")(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
                    _dereq_1("./settle.js")(Promise1, PromiseArray, debug);
                    _dereq_1("./some.js")(Promise1, PromiseArray, apiRejection);
                    _dereq_1("./timers.js")(Promise1, INTERNAL, debug);
                    _dereq_1("./using.js")(Promise1, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
                    _dereq_1("./any.js")(Promise1);
                    _dereq_1("./each.js")(Promise1, INTERNAL);
                    _dereq_1("./filter.js")(Promise1, INTERNAL);
                    util.toFastProperties(Promise1);
                    util.toFastProperties(Promise1.prototype);
                    function fillTypes(value) {
                        var p = new Promise1(INTERNAL);
                        p._fulfillmentHandler0 = value;
                        p._rejectionHandler0 = value;
                        p._promise0 = value;
                        p._receiver0 = value;
                    }
                    // Complete slack tracking, opt out of field-type tracking and           
                    // stabilize map                                                         
                    fillTypes({
                        a: 1
                    });
                    fillTypes({
                        b: 2
                    });
                    fillTypes({
                        c: 3
                    });
                    fillTypes(1);
                    fillTypes(function() {});
                    fillTypes(undefined);
                    fillTypes(false);
                    fillTypes(new Promise1(INTERNAL));
                    debug.setBounds(Async.firstLineError, util.lastLineError);
                    return Promise1;
                };
            },
            {
                "./any.js": 1,
                "./async": 2,
                "./bind": 3,
                "./call_get.js": 5,
                "./cancel": 6,
                "./catch_filter": 7,
                "./context": 8,
                "./debuggability": 9,
                "./direct_resolve": 10,
                "./each.js": 11,
                "./errors": 12,
                "./es5": 13,
                "./filter.js": 14,
                "./finally": 15,
                "./generators.js": 16,
                "./join": 17,
                "./map.js": 18,
                "./method": 19,
                "./nodeback": 20,
                "./nodeify.js": 21,
                "./promise_array": 23,
                "./promisify.js": 24,
                "./props.js": 25,
                "./race.js": 27,
                "./reduce.js": 28,
                "./settle.js": 30,
                "./some.js": 31,
                "./synchronous_inspection": 32,
                "./thenables": 33,
                "./timers.js": 34,
                "./using.js": 35,
                "./util": 36,
                "async_hooks": undefined
            }
        ],
        23: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection, Proxyable) {
                    var util = _dereq_1("./util");
                    var isArray = util.isArray;
                    function toResolutionValue(val) {
                        switch(val){
                            case -2:
                                return [];
                            case -3:
                                return {};
                            case -6:
                                return new Map();
                        }
                    }
                    function PromiseArray(values) {
                        var promise = this._promise = new Promise1(INTERNAL);
                        if (values instanceof Promise1) {
                            promise._propagateFrom(values, 3);
                            values.suppressUnhandledRejections();
                        }
                        promise._setOnCancel(this);
                        this._values = values;
                        this._length = 0;
                        this._totalResolved = 0;
                        this._init(undefined, -2);
                    }
                    util.inherits(PromiseArray, Proxyable);
                    PromiseArray.prototype.length = function() {
                        return this._length;
                    };
                    PromiseArray.prototype.promise = function() {
                        return this._promise;
                    };
                    PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
                        var values = tryConvertToPromise(this._values, this._promise);
                        if (values instanceof Promise1) {
                            values = values._target();
                            var bitField = values._bitField;
                            this._values = values;
                            if ((bitField & 50397184) === 0) {
                                this._promise._setAsyncGuaranteed();
                                return values._then(init, this._reject, undefined, this, resolveValueIfEmpty);
                            } else if ((bitField & 33554432) !== 0) values = values._value();
                            else if ((bitField & 16777216) !== 0) return this._reject(values._reason());
                            else return this._cancel();
                        }
                        values = util.asArray(values);
                        if (values === null) {
                            var err = apiRejection("expecting an array or an iterable object but got " + util.classString(values)).reason();
                            this._promise._rejectCallback(err, false);
                            return;
                        }
                        if (values.length === 0) {
                            if (resolveValueIfEmpty === -5) this._resolveEmptyArray();
                            else this._resolve(toResolutionValue(resolveValueIfEmpty));
                            return;
                        }
                        this._iterate(values);
                    };
                    PromiseArray.prototype._iterate = function(values) {
                        var len = this.getActualLength(values.length);
                        this._length = len;
                        this._values = this.shouldCopyValues() ? new Array(len) : this._values;
                        var result = this._promise;
                        var isResolved = false;
                        var bitField = null;
                        for(var i = 0; i < len; ++i){
                            var maybePromise = tryConvertToPromise(values[i], result);
                            if (maybePromise instanceof Promise1) {
                                maybePromise = maybePromise._target();
                                bitField = maybePromise._bitField;
                            } else bitField = null;
                            if (isResolved) {
                                if (bitField !== null) maybePromise.suppressUnhandledRejections();
                            } else if (bitField !== null) {
                                if ((bitField & 50397184) === 0) {
                                    maybePromise._proxy(this, i);
                                    this._values[i] = maybePromise;
                                } else if ((bitField & 33554432) !== 0) isResolved = this._promiseFulfilled(maybePromise._value(), i);
                                else if ((bitField & 16777216) !== 0) isResolved = this._promiseRejected(maybePromise._reason(), i);
                                else isResolved = this._promiseCancelled(i);
                            } else isResolved = this._promiseFulfilled(maybePromise, i);
                        }
                        if (!isResolved) result._setAsyncGuaranteed();
                    };
                    PromiseArray.prototype._isResolved = function() {
                        return this._values === null;
                    };
                    PromiseArray.prototype._resolve = function(value) {
                        this._values = null;
                        this._promise._fulfill(value);
                    };
                    PromiseArray.prototype._cancel = function() {
                        if (this._isResolved() || !this._promise._isCancellable()) return;
                        this._values = null;
                        this._promise._cancel();
                    };
                    PromiseArray.prototype._reject = function(reason) {
                        this._values = null;
                        this._promise._rejectCallback(reason, false);
                    };
                    PromiseArray.prototype._promiseFulfilled = function(value, index) {
                        this._values[index] = value;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    PromiseArray.prototype._promiseCancelled = function() {
                        this._cancel();
                        return true;
                    };
                    PromiseArray.prototype._promiseRejected = function(reason) {
                        this._totalResolved++;
                        this._reject(reason);
                        return true;
                    };
                    PromiseArray.prototype._resultCancelled = function() {
                        if (this._isResolved()) return;
                        var values = this._values;
                        this._cancel();
                        if (values instanceof Promise1) values.cancel();
                        else {
                            for(var i = 0; i < values.length; ++i)if (values[i] instanceof Promise1) values[i].cancel();
                        }
                    };
                    PromiseArray.prototype.shouldCopyValues = function() {
                        return true;
                    };
                    PromiseArray.prototype.getActualLength = function(len) {
                        return len;
                    };
                    return PromiseArray;
                };
            },
            {
                "./util": 36
            }
        ],
        24: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var THIS = {};
                    var util = _dereq_1("./util");
                    var nodebackForPromise = _dereq_1("./nodeback");
                    var withAppended = util.withAppended;
                    var maybeWrapAsError = util.maybeWrapAsError;
                    var canEvaluate = util.canEvaluate;
                    var TypeError1 = _dereq_1("./errors").TypeError;
                    var defaultSuffix = "Async";
                    var defaultPromisified = {
                        __isPromisified__: true
                    };
                    var noCopyProps = [
                        "arity",
                        "length",
                        "name",
                        "arguments",
                        "caller",
                        "callee",
                        "prototype",
                        "__isPromisified__"
                    ];
                    var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
                    var defaultFilter = function(name) {
                        return util.isIdentifier(name) && name.charAt(0) !== "_" && name !== "constructor";
                    };
                    function propsFilter(key) {
                        return !noCopyPropsPattern.test(key);
                    }
                    function isPromisified(fn) {
                        try {
                            return fn.__isPromisified__ === true;
                        } catch (e) {
                            return false;
                        }
                    }
                    function hasPromisified(obj, key, suffix) {
                        var val = util.getDataPropertyOrDefault(obj, key + suffix, defaultPromisified);
                        return val ? isPromisified(val) : false;
                    }
                    function checkValid(ret, suffix, suffixRegexp) {
                        for(var i = 0; i < ret.length; i += 2){
                            var key = ret[i];
                            if (suffixRegexp.test(key)) {
                                var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
                                for(var j = 0; j < ret.length; j += 2){
                                    if (ret[j] === keyWithoutAsyncSuffix) throw new TypeError1("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s", suffix));
                                }
                            }
                        }
                    }
                    function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
                        var keys = util.inheritedDataKeys(obj);
                        var ret = [];
                        for(var i = 0; i < keys.length; ++i){
                            var key = keys[i];
                            var value = obj[key];
                            var passesDefaultFilter = filter === defaultFilter ? true : defaultFilter(key, value, obj);
                            if (typeof value === "function" && !isPromisified(value) && !hasPromisified(obj, key, suffix) && filter(key, value, obj, passesDefaultFilter)) ret.push(key, value);
                        }
                        checkValid(ret, suffix, suffixRegexp);
                        return ret;
                    }
                    var escapeIdentRegex = function(str) {
                        return str.replace(/([$])/, "\\$");
                    };
                    var makeNodePromisifiedEval;
                    var switchCaseArgumentOrder, argumentSequence, parameterDeclaration, parameterCount;
                    function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
                        var defaultThis = function() {
                            return this;
                        }();
                        var method = callback;
                        if (typeof method === "string") callback = fn;
                        function promisified() {
                            var _receiver = receiver;
                            if (receiver === THIS) _receiver = this;
                            var promise = new Promise1(INTERNAL);
                            promise._captureStackTrace();
                            var cb = typeof method === "string" && this !== defaultThis ? this[method] : callback;
                            var fn = nodebackForPromise(promise, multiArgs);
                            try {
                                cb.apply(_receiver, withAppended(arguments, fn));
                            } catch (e) {
                                promise._rejectCallback(maybeWrapAsError(e), true, true);
                            }
                            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
                            return promise;
                        }
                        util.notEnumerableProp(promisified, "__isPromisified__", true);
                        return promisified;
                    }
                    var makeNodePromisified = canEvaluate ? makeNodePromisifiedEval : makeNodePromisifiedClosure;
                    function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
                        var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
                        var methods = promisifiableMethods(obj, suffix, suffixRegexp, filter);
                        for(var i = 0, len = methods.length; i < len; i += 2){
                            var key = methods[i];
                            var fn = methods[i + 1];
                            var promisifiedKey = key + suffix;
                            if (promisifier === makeNodePromisified) obj[promisifiedKey] = makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                            else {
                                var promisified = promisifier(fn, function() {
                                    return makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                                });
                                util.notEnumerableProp(promisified, "__isPromisified__", true);
                                obj[promisifiedKey] = promisified;
                            }
                        }
                        util.toFastProperties(obj);
                        return obj;
                    }
                    function promisify(callback, receiver, multiArgs) {
                        return makeNodePromisified(callback, receiver, undefined, callback, null, multiArgs);
                    }
                    Promise1.promisify = function(fn, options) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        if (isPromisified(fn)) return fn;
                        options = Object(options);
                        var receiver = options.context === undefined ? THIS : options.context;
                        var multiArgs = !!options.multiArgs;
                        var ret = promisify(fn, receiver, multiArgs);
                        util.copyDescriptors(fn, ret, propsFilter);
                        return ret;
                    };
                    Promise1.promisifyAll = function(target, options) {
                        if (typeof target !== "function" && typeof target !== "object") throw new TypeError1("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");
                        options = Object(options);
                        var multiArgs = !!options.multiArgs;
                        var suffix = options.suffix;
                        if (typeof suffix !== "string") suffix = defaultSuffix;
                        var filter = options.filter;
                        if (typeof filter !== "function") filter = defaultFilter;
                        var promisifier = options.promisifier;
                        if (typeof promisifier !== "function") promisifier = makeNodePromisified;
                        if (!util.isIdentifier(suffix)) throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");
                        var keys = util.inheritedDataKeys(target);
                        for(var i = 0; i < keys.length; ++i){
                            var value = target[keys[i]];
                            if (keys[i] !== "constructor" && util.isClass(value)) {
                                promisifyAll(value.prototype, suffix, filter, promisifier, multiArgs);
                                promisifyAll(value, suffix, filter, promisifier, multiArgs);
                            }
                        }
                        return promisifyAll(target, suffix, filter, promisifier, multiArgs);
                    };
                };
            },
            {
                "./errors": 12,
                "./nodeback": 20,
                "./util": 36
            }
        ],
        25: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, tryConvertToPromise, apiRejection) {
                    var util = _dereq_1("./util");
                    var isObject = util.isObject;
                    var es5 = _dereq_1("./es5");
                    var Es6Map;
                    if (typeof Map === "function") Es6Map = Map;
                    var mapToEntries = function() {
                        var index = 0;
                        var size = 0;
                        function extractEntry(value, key) {
                            this[index] = value;
                            this[index + size] = key;
                            index++;
                        }
                        return function mapToEntries(map) {
                            size = map.size;
                            index = 0;
                            var ret = new Array(map.size * 2);
                            map.forEach(extractEntry, ret);
                            return ret;
                        };
                    }();
                    var entriesToMap = function(entries) {
                        var ret = new Es6Map();
                        var length = entries.length / 2 | 0;
                        for(var i = 0; i < length; ++i){
                            var key = entries[length + i];
                            var value = entries[i];
                            ret.set(key, value);
                        }
                        return ret;
                    };
                    function PropertiesPromiseArray(obj) {
                        var isMap = false;
                        var entries;
                        if (Es6Map !== undefined && obj instanceof Es6Map) {
                            entries = mapToEntries(obj);
                            isMap = true;
                        } else {
                            var keys = es5.keys(obj);
                            var len = keys.length;
                            entries = new Array(len * 2);
                            for(var i = 0; i < len; ++i){
                                var key = keys[i];
                                entries[i] = obj[key];
                                entries[i + len] = key;
                            }
                        }
                        this.constructor$(entries);
                        this._isMap = isMap;
                        this._init$(undefined, isMap ? -6 : -3);
                    }
                    util.inherits(PropertiesPromiseArray, PromiseArray);
                    PropertiesPromiseArray.prototype._init = function() {};
                    PropertiesPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        this._values[index] = value;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            var val;
                            if (this._isMap) val = entriesToMap(this._values);
                            else {
                                val = {};
                                var keyOffset = this.length();
                                for(var i = 0, len = this.length(); i < len; ++i)val[this._values[i + keyOffset]] = this._values[i];
                            }
                            this._resolve(val);
                            return true;
                        }
                        return false;
                    };
                    PropertiesPromiseArray.prototype.shouldCopyValues = function() {
                        return false;
                    };
                    PropertiesPromiseArray.prototype.getActualLength = function(len) {
                        return len >> 1;
                    };
                    function props(promises) {
                        var ret;
                        var castValue = tryConvertToPromise(promises);
                        if (!isObject(castValue)) return apiRejection("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n");
                        else if (castValue instanceof Promise1) ret = castValue._then(Promise1.props, undefined, undefined, undefined, undefined);
                        else ret = new PropertiesPromiseArray(castValue).promise();
                        if (castValue instanceof Promise1) ret._propagateFrom(castValue, 2);
                        return ret;
                    }
                    Promise1.prototype.props = function() {
                        return props(this);
                    };
                    Promise1.props = function(promises) {
                        return props(promises);
                    };
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        26: [
            function(_dereq_1, module1, exports) {
                "use strict";
                function arrayMove(src, srcIndex, dst, dstIndex, len) {
                    for(var j = 0; j < len; ++j){
                        dst[j + dstIndex] = src[j + srcIndex];
                        src[j + srcIndex] = void 0;
                    }
                }
                function Queue(capacity) {
                    this._capacity = capacity;
                    this._length = 0;
                    this._front = 0;
                }
                Queue.prototype._willBeOverCapacity = function(size) {
                    return this._capacity < size;
                };
                Queue.prototype._pushOne = function(arg) {
                    var length = this.length();
                    this._checkCapacity(length + 1);
                    var i = this._front + length & this._capacity - 1;
                    this[i] = arg;
                    this._length = length + 1;
                };
                Queue.prototype.push = function(fn, receiver, arg) {
                    var length = this.length() + 3;
                    if (this._willBeOverCapacity(length)) {
                        this._pushOne(fn);
                        this._pushOne(receiver);
                        this._pushOne(arg);
                        return;
                    }
                    var j = this._front + length - 3;
                    this._checkCapacity(length);
                    var wrapMask = this._capacity - 1;
                    this[j + 0 & wrapMask] = fn;
                    this[j + 1 & wrapMask] = receiver;
                    this[j + 2 & wrapMask] = arg;
                    this._length = length;
                };
                Queue.prototype.shift = function() {
                    var front = this._front, ret = this[front];
                    this[front] = undefined;
                    this._front = front + 1 & this._capacity - 1;
                    this._length--;
                    return ret;
                };
                Queue.prototype.length = function() {
                    return this._length;
                };
                Queue.prototype._checkCapacity = function(size) {
                    if (this._capacity < size) this._resizeTo(this._capacity << 1);
                };
                Queue.prototype._resizeTo = function(capacity) {
                    var oldCapacity = this._capacity;
                    this._capacity = capacity;
                    var front = this._front;
                    var length = this._length;
                    var moveItemsCount = front + length & oldCapacity - 1;
                    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
                };
                module1.exports = Queue;
            },
            {}
        ],
        27: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection) {
                    var util = _dereq_1("./util");
                    var raceLater = function(promise) {
                        return promise.then(function(array) {
                            return race(array, promise);
                        });
                    };
                    function race(promises, parent) {
                        var maybePromise = tryConvertToPromise(promises);
                        if (maybePromise instanceof Promise1) return raceLater(maybePromise);
                        else {
                            promises = util.asArray(promises);
                            if (promises === null) return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
                        }
                        var ret = new Promise1(INTERNAL);
                        if (parent !== undefined) ret._propagateFrom(parent, 3);
                        var fulfill = ret._fulfill;
                        var reject = ret._reject;
                        for(var i = 0, len = promises.length; i < len; ++i){
                            var val = promises[i];
                            if (val === undefined && !(i in promises)) continue;
                            Promise1.cast(val)._then(fulfill, reject, undefined, ret, null);
                        }
                        return ret;
                    }
                    Promise1.race = function(promises) {
                        return race(promises, undefined);
                    };
                    Promise1.prototype.race = function() {
                        return race(this, undefined);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        28: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    function ReductionPromiseArray(promises, fn, initialValue, _each) {
                        this.constructor$(promises);
                        var context = Promise1._getContext();
                        this._fn = util.contextBind(context, fn);
                        if (initialValue !== undefined) {
                            initialValue = Promise1.resolve(initialValue);
                            initialValue._attachCancellationCallback(this);
                        }
                        this._initialValue = initialValue;
                        this._currentCancellable = null;
                        if (_each === INTERNAL) this._eachValues = Array(this._length);
                        else if (_each === 0) this._eachValues = null;
                        else this._eachValues = undefined;
                        this._promise._captureStackTrace();
                        this._init$(undefined, -5);
                    }
                    util.inherits(ReductionPromiseArray, PromiseArray);
                    ReductionPromiseArray.prototype._gotAccum = function(accum) {
                        if (this._eachValues !== undefined && this._eachValues !== null && accum !== INTERNAL) this._eachValues.push(accum);
                    };
                    ReductionPromiseArray.prototype._eachComplete = function(value) {
                        if (this._eachValues !== null) this._eachValues.push(value);
                        return this._eachValues;
                    };
                    ReductionPromiseArray.prototype._init = function() {};
                    ReductionPromiseArray.prototype._resolveEmptyArray = function() {
                        this._resolve(this._eachValues !== undefined ? this._eachValues : this._initialValue);
                    };
                    ReductionPromiseArray.prototype.shouldCopyValues = function() {
                        return false;
                    };
                    ReductionPromiseArray.prototype._resolve = function(value) {
                        this._promise._resolveCallback(value);
                        this._values = null;
                    };
                    ReductionPromiseArray.prototype._resultCancelled = function(sender) {
                        if (sender === this._initialValue) return this._cancel();
                        if (this._isResolved()) return;
                        this._resultCancelled$();
                        if (this._currentCancellable instanceof Promise1) this._currentCancellable.cancel();
                        if (this._initialValue instanceof Promise1) this._initialValue.cancel();
                    };
                    ReductionPromiseArray.prototype._iterate = function(values) {
                        this._values = values;
                        var value;
                        var i;
                        var length = values.length;
                        if (this._initialValue !== undefined) {
                            value = this._initialValue;
                            i = 0;
                        } else {
                            value = Promise1.resolve(values[0]);
                            i = 1;
                        }
                        this._currentCancellable = value;
                        for(var j = i; j < length; ++j){
                            var maybePromise = values[j];
                            if (maybePromise instanceof Promise1) maybePromise.suppressUnhandledRejections();
                        }
                        if (!value.isRejected()) for(; i < length; ++i){
                            var ctx = {
                                accum: null,
                                value: values[i],
                                index: i,
                                length: length,
                                array: this
                            };
                            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
                            if ((i & 127) === 0) value._setNoAsyncGuarantee();
                        }
                        if (this._eachValues !== undefined) value = value._then(this._eachComplete, undefined, undefined, this, undefined);
                        value._then(completed, completed, undefined, value, this);
                    };
                    Promise1.prototype.reduce = function(fn, initialValue) {
                        return reduce(this, fn, initialValue, null);
                    };
                    Promise1.reduce = function(promises, fn, initialValue, _each) {
                        return reduce(promises, fn, initialValue, _each);
                    };
                    function completed(valueOrReason, array) {
                        if (this.isFulfilled()) array._resolve(valueOrReason);
                        else array._reject(valueOrReason);
                    }
                    function reduce(promises, fn, initialValue, _each) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
                        return array.promise();
                    }
                    function gotAccum(accum) {
                        this.accum = accum;
                        this.array._gotAccum(accum);
                        var value = tryConvertToPromise(this.value, this.array._promise);
                        if (value instanceof Promise1) {
                            this.array._currentCancellable = value;
                            return value._then(gotValue, undefined, undefined, this, undefined);
                        } else return gotValue.call(this, value);
                    }
                    function gotValue(value) {
                        var array = this.array;
                        var promise = array._promise;
                        var fn = tryCatch(array._fn);
                        promise._pushContext();
                        var ret;
                        if (array._eachValues !== undefined) ret = fn.call(promise._boundValue(), value, this.index, this.length);
                        else ret = fn.call(promise._boundValue(), this.accum, value, this.index, this.length);
                        if (ret instanceof Promise1) array._currentCancellable = ret;
                        var promiseCreated = promise._popContext();
                        debug.checkForgottenReturns(ret, promiseCreated, array._eachValues !== undefined ? "Promise.each" : "Promise.reduce", promise);
                        return ret;
                    }
                };
            },
            {
                "./util": 36
            }
        ],
        29: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var util = _dereq_1("./util");
                var schedule;
                var noAsyncScheduler = function() {
                    throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
                };
                var NativePromise = util.getNativePromise();
                if (util.isNode && typeof MutationObserver === "undefined") {
                    var GlobalSetImmediate = $parcel$global.setImmediate;
                    var ProcessNextTick = $449e3df09682ce9f$exports.nextTick;
                    schedule = util.isRecentNode ? function(fn) {
                        GlobalSetImmediate.call($parcel$global, fn);
                    } : function(fn) {
                        ProcessNextTick.call($449e3df09682ce9f$exports, fn);
                    };
                } else if (typeof NativePromise === "function" && typeof NativePromise.resolve === "function") {
                    var nativePromise = NativePromise.resolve();
                    schedule = function(fn) {
                        nativePromise.then(fn);
                    };
                } else if (typeof MutationObserver !== "undefined" && !(typeof window !== "undefined" && window.navigator && (window.navigator.standalone || window.cordova)) && "classList" in document.documentElement) schedule = function() {
                    var div = document.createElement("div");
                    var opts = {
                        attributes: true
                    };
                    var toggleScheduled = false;
                    var div2 = document.createElement("div");
                    var o2 = new MutationObserver(function() {
                        div.classList.toggle("foo");
                        toggleScheduled = false;
                    });
                    o2.observe(div2, opts);
                    var scheduleToggle = function() {
                        if (toggleScheduled) return;
                        toggleScheduled = true;
                        div2.classList.toggle("foo");
                    };
                    return function schedule(fn) {
                        var o = new MutationObserver(function() {
                            o.disconnect();
                            fn();
                        });
                        o.observe(div, opts);
                        scheduleToggle();
                    };
                }();
                else if (typeof setImmediate !== "undefined") schedule = function(fn) {
                    setImmediate(fn);
                };
                else if (typeof setTimeout !== "undefined") schedule = function(fn) {
                    setTimeout(fn, 0);
                };
                else schedule = noAsyncScheduler;
                module1.exports = schedule;
            },
            {
                "./util": 36
            }
        ],
        30: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, debug) {
                    var PromiseInspection = Promise1.PromiseInspection;
                    var util = _dereq_1("./util");
                    function SettledPromiseArray(values) {
                        this.constructor$(values);
                    }
                    util.inherits(SettledPromiseArray, PromiseArray);
                    SettledPromiseArray.prototype._promiseResolved = function(index, inspection) {
                        this._values[index] = inspection;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    SettledPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        var ret = new PromiseInspection();
                        ret._bitField = 33554432;
                        ret._settledValueField = value;
                        return this._promiseResolved(index, ret);
                    };
                    SettledPromiseArray.prototype._promiseRejected = function(reason, index) {
                        var ret = new PromiseInspection();
                        ret._bitField = 16777216;
                        ret._settledValueField = reason;
                        return this._promiseResolved(index, ret);
                    };
                    Promise1.settle = function(promises) {
                        debug.deprecated(".settle()", ".reflect()");
                        return new SettledPromiseArray(promises).promise();
                    };
                    Promise1.allSettled = function(promises) {
                        return new SettledPromiseArray(promises).promise();
                    };
                    Promise1.prototype.settle = function() {
                        return Promise1.settle(this);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        31: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection) {
                    var util = _dereq_1("./util");
                    var RangeError1 = _dereq_1("./errors").RangeError;
                    var AggregateError = _dereq_1("./errors").AggregateError;
                    var isArray = util.isArray;
                    var CANCELLATION = {};
                    function SomePromiseArray(values) {
                        this.constructor$(values);
                        this._howMany = 0;
                        this._unwrap = false;
                        this._initialized = false;
                    }
                    util.inherits(SomePromiseArray, PromiseArray);
                    SomePromiseArray.prototype._init = function() {
                        if (!this._initialized) return;
                        if (this._howMany === 0) {
                            this._resolve([]);
                            return;
                        }
                        this._init$(undefined, -5);
                        var isArrayResolved = isArray(this._values);
                        if (!this._isResolved() && isArrayResolved && this._howMany > this._canPossiblyFulfill()) this._reject(this._getRangeError(this.length()));
                    };
                    SomePromiseArray.prototype.init = function() {
                        this._initialized = true;
                        this._init();
                    };
                    SomePromiseArray.prototype.setUnwrap = function() {
                        this._unwrap = true;
                    };
                    SomePromiseArray.prototype.howMany = function() {
                        return this._howMany;
                    };
                    SomePromiseArray.prototype.setHowMany = function(count) {
                        this._howMany = count;
                    };
                    SomePromiseArray.prototype._promiseFulfilled = function(value) {
                        this._addFulfilled(value);
                        if (this._fulfilled() === this.howMany()) {
                            this._values.length = this.howMany();
                            if (this.howMany() === 1 && this._unwrap) this._resolve(this._values[0]);
                            else this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    SomePromiseArray.prototype._promiseRejected = function(reason) {
                        this._addRejected(reason);
                        return this._checkOutcome();
                    };
                    SomePromiseArray.prototype._promiseCancelled = function() {
                        if (this._values instanceof Promise1 || this._values == null) return this._cancel();
                        this._addRejected(CANCELLATION);
                        return this._checkOutcome();
                    };
                    SomePromiseArray.prototype._checkOutcome = function() {
                        if (this.howMany() > this._canPossiblyFulfill()) {
                            var e = new AggregateError();
                            for(var i = this.length(); i < this._values.length; ++i)if (this._values[i] !== CANCELLATION) e.push(this._values[i]);
                            if (e.length > 0) this._reject(e);
                            else this._cancel();
                            return true;
                        }
                        return false;
                    };
                    SomePromiseArray.prototype._fulfilled = function() {
                        return this._totalResolved;
                    };
                    SomePromiseArray.prototype._rejected = function() {
                        return this._values.length - this.length();
                    };
                    SomePromiseArray.prototype._addRejected = function(reason) {
                        this._values.push(reason);
                    };
                    SomePromiseArray.prototype._addFulfilled = function(value) {
                        this._values[this._totalResolved++] = value;
                    };
                    SomePromiseArray.prototype._canPossiblyFulfill = function() {
                        return this.length() - this._rejected();
                    };
                    SomePromiseArray.prototype._getRangeError = function(count) {
                        var message = "Input array must contain at least " + this._howMany + " items but contains only " + count + " items";
                        return new RangeError1(message);
                    };
                    SomePromiseArray.prototype._resolveEmptyArray = function() {
                        this._reject(this._getRangeError(0));
                    };
                    function some(promises, howMany) {
                        if ((howMany | 0) !== howMany || howMany < 0) return apiRejection("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");
                        var ret = new SomePromiseArray(promises);
                        var promise = ret.promise();
                        ret.setHowMany(howMany);
                        ret.init();
                        return promise;
                    }
                    Promise1.some = function(promises, howMany) {
                        return some(promises, howMany);
                    };
                    Promise1.prototype.some = function(howMany) {
                        return some(this, howMany);
                    };
                    Promise1._SomePromiseArray = SomePromiseArray;
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        32: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    function PromiseInspection(promise) {
                        if (promise !== undefined) {
                            promise = promise._target();
                            this._bitField = promise._bitField;
                            this._settledValueField = promise._isFateSealed() ? promise._settledValue() : undefined;
                        } else {
                            this._bitField = 0;
                            this._settledValueField = undefined;
                        }
                    }
                    PromiseInspection.prototype._settledValue = function() {
                        return this._settledValueField;
                    };
                    var value = PromiseInspection.prototype.value = function() {
                        if (!this.isFulfilled()) throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");
                        return this._settledValue();
                    };
                    var reason = PromiseInspection.prototype.error = PromiseInspection.prototype.reason = function() {
                        if (!this.isRejected()) throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");
                        return this._settledValue();
                    };
                    var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
                        return (this._bitField & 33554432) !== 0;
                    };
                    var isRejected = PromiseInspection.prototype.isRejected = function() {
                        return (this._bitField & 16777216) !== 0;
                    };
                    var isPending = PromiseInspection.prototype.isPending = function() {
                        return (this._bitField & 50397184) === 0;
                    };
                    var isResolved = PromiseInspection.prototype.isResolved = function() {
                        return (this._bitField & 50331648) !== 0;
                    };
                    PromiseInspection.prototype.isCancelled = function() {
                        return (this._bitField & 8454144) !== 0;
                    };
                    Promise1.prototype.__isCancelled = function() {
                        return (this._bitField & 65536) === 65536;
                    };
                    Promise1.prototype._isCancelled = function() {
                        return this._target().__isCancelled();
                    };
                    Promise1.prototype.isCancelled = function() {
                        return (this._target()._bitField & 8454144) !== 0;
                    };
                    Promise1.prototype.isPending = function() {
                        return isPending.call(this._target());
                    };
                    Promise1.prototype.isRejected = function() {
                        return isRejected.call(this._target());
                    };
                    Promise1.prototype.isFulfilled = function() {
                        return isFulfilled.call(this._target());
                    };
                    Promise1.prototype.isResolved = function() {
                        return isResolved.call(this._target());
                    };
                    Promise1.prototype.value = function() {
                        return value.call(this._target());
                    };
                    Promise1.prototype.reason = function() {
                        var target = this._target();
                        target._unsetRejectionIsUnhandled();
                        return reason.call(target);
                    };
                    Promise1.prototype._value = function() {
                        return this._settledValue();
                    };
                    Promise1.prototype._reason = function() {
                        this._unsetRejectionIsUnhandled();
                        return this._settledValue();
                    };
                    Promise1.PromiseInspection = PromiseInspection;
                };
            },
            {}
        ],
        33: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var util = _dereq_1("./util");
                    var errorObj = util.errorObj;
                    var isObject = util.isObject;
                    function tryConvertToPromise(obj, context) {
                        if (isObject(obj)) {
                            if (obj instanceof Promise1) return obj;
                            var then = getThen(obj);
                            if (then === errorObj) {
                                if (context) context._pushContext();
                                var ret = Promise1.reject(then.e);
                                if (context) context._popContext();
                                return ret;
                            } else if (typeof then === "function") {
                                if (isAnyBluebirdPromise(obj)) {
                                    var ret = new Promise1(INTERNAL);
                                    obj._then(ret._fulfill, ret._reject, undefined, ret, null);
                                    return ret;
                                }
                                return doThenable(obj, then, context);
                            }
                        }
                        return obj;
                    }
                    function doGetThen(obj) {
                        return obj.then;
                    }
                    function getThen(obj) {
                        try {
                            return doGetThen(obj);
                        } catch (e) {
                            errorObj.e = e;
                            return errorObj;
                        }
                    }
                    var hasProp = {}.hasOwnProperty;
                    function isAnyBluebirdPromise(obj) {
                        try {
                            return hasProp.call(obj, "_promise0");
                        } catch (e) {
                            return false;
                        }
                    }
                    function doThenable(x, then, context) {
                        var promise = new Promise1(INTERNAL);
                        var ret = promise;
                        if (context) context._pushContext();
                        promise._captureStackTrace();
                        if (context) context._popContext();
                        var synchronous = true;
                        var result = util.tryCatch(then).call(x, resolve, reject);
                        synchronous = false;
                        if (promise && result === errorObj) {
                            promise._rejectCallback(result.e, true, true);
                            promise = null;
                        }
                        function resolve(value) {
                            if (!promise) return;
                            promise._resolveCallback(value);
                            promise = null;
                        }
                        function reject(reason) {
                            if (!promise) return;
                            promise._rejectCallback(reason, synchronous, true);
                            promise = null;
                        }
                        return ret;
                    }
                    return tryConvertToPromise;
                };
            },
            {
                "./util": 36
            }
        ],
        34: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var TimeoutError = Promise1.TimeoutError;
                    function HandleWrapper(handle) {
                        this.handle = handle;
                    }
                    HandleWrapper.prototype._resultCancelled = function() {
                        clearTimeout(this.handle);
                    };
                    var afterValue = function(value) {
                        return delay(+this).thenReturn(value);
                    };
                    var delay = Promise1.delay = function(ms, value) {
                        var ret;
                        var handle;
                        if (value !== undefined) {
                            ret = Promise1.resolve(value)._then(afterValue, null, null, ms, undefined);
                            if (debug.cancellation() && value instanceof Promise1) ret._setOnCancel(value);
                        } else {
                            ret = new Promise1(INTERNAL);
                            handle = setTimeout(function() {
                                ret._fulfill();
                            }, +ms);
                            if (debug.cancellation()) ret._setOnCancel(new HandleWrapper(handle));
                            ret._captureStackTrace();
                        }
                        ret._setAsyncGuaranteed();
                        return ret;
                    };
                    Promise1.prototype.delay = function(ms) {
                        return delay(ms, this);
                    };
                    var afterTimeout = function(promise, message, parent) {
                        var err;
                        if (typeof message !== "string") {
                            if (message instanceof Error) err = message;
                            else err = new TimeoutError("operation timed out");
                        } else err = new TimeoutError(message);
                        util.markAsOriginatingFromRejection(err);
                        promise._attachExtraTrace(err);
                        promise._reject(err);
                        if (parent != null) parent.cancel();
                    };
                    function successClear(value) {
                        clearTimeout(this.handle);
                        return value;
                    }
                    function failureClear(reason) {
                        clearTimeout(this.handle);
                        throw reason;
                    }
                    Promise1.prototype.timeout = function(ms, message) {
                        ms = +ms;
                        var ret, parent;
                        var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
                            if (ret.isPending()) afterTimeout(ret, message, parent);
                        }, ms));
                        if (debug.cancellation()) {
                            parent = this.then();
                            ret = parent._then(successClear, failureClear, undefined, handleWrapper, undefined);
                            ret._setOnCancel(handleWrapper);
                        } else ret = this._then(successClear, failureClear, undefined, handleWrapper, undefined);
                        return ret;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        35: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var TypeError1 = _dereq_1("./errors").TypeError;
                    var inherits = _dereq_1("./util").inherits;
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    var NULL = {};
                    function thrower(e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                    function castPreservingDisposable(thenable) {
                        var maybePromise = tryConvertToPromise(thenable);
                        if (maybePromise !== thenable && typeof thenable._isDisposable === "function" && typeof thenable._getDisposer === "function" && thenable._isDisposable()) maybePromise._setDisposable(thenable._getDisposer());
                        return maybePromise;
                    }
                    function dispose(resources, inspection) {
                        var i = 0;
                        var len = resources.length;
                        var ret = new Promise1(INTERNAL);
                        function iterator() {
                            if (i >= len) return ret._fulfill();
                            var maybePromise = castPreservingDisposable(resources[i++]);
                            if (maybePromise instanceof Promise1 && maybePromise._isDisposable()) {
                                try {
                                    maybePromise = tryConvertToPromise(maybePromise._getDisposer().tryDispose(inspection), resources.promise);
                                } catch (e) {
                                    return thrower(e);
                                }
                                if (maybePromise instanceof Promise1) return maybePromise._then(iterator, thrower, null, null, null);
                            }
                            iterator();
                        }
                        iterator();
                        return ret;
                    }
                    function Disposer(data, promise, context) {
                        this._data = data;
                        this._promise = promise;
                        this._context = context;
                    }
                    Disposer.prototype.data = function() {
                        return this._data;
                    };
                    Disposer.prototype.promise = function() {
                        return this._promise;
                    };
                    Disposer.prototype.resource = function() {
                        if (this.promise().isFulfilled()) return this.promise().value();
                        return NULL;
                    };
                    Disposer.prototype.tryDispose = function(inspection) {
                        var resource = this.resource();
                        var context = this._context;
                        if (context !== undefined) context._pushContext();
                        var ret = resource !== NULL ? this.doDispose(resource, inspection) : null;
                        if (context !== undefined) context._popContext();
                        this._promise._unsetDisposable();
                        this._data = null;
                        return ret;
                    };
                    Disposer.isDisposer = function(d) {
                        return d != null && typeof d.resource === "function" && typeof d.tryDispose === "function";
                    };
                    function FunctionDisposer(fn, promise, context) {
                        this.constructor$(fn, promise, context);
                    }
                    inherits(FunctionDisposer, Disposer);
                    FunctionDisposer.prototype.doDispose = function(resource, inspection) {
                        var fn = this.data();
                        return fn.call(resource, resource, inspection);
                    };
                    function maybeUnwrapDisposer(value) {
                        if (Disposer.isDisposer(value)) {
                            this.resources[this.index]._setDisposable(value);
                            return value.promise();
                        }
                        return value;
                    }
                    function ResourceList(length) {
                        this.length = length;
                        this.promise = null;
                        this[length - 1] = null;
                    }
                    ResourceList.prototype._resultCancelled = function() {
                        var len = this.length;
                        for(var i = 0; i < len; ++i){
                            var item = this[i];
                            if (item instanceof Promise1) item.cancel();
                        }
                    };
                    Promise1.using = function() {
                        var len = arguments.length;
                        if (len < 2) return apiRejection("you must pass at least 2 arguments to Promise.using");
                        var fn = arguments[len - 1];
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var input;
                        var spreadArgs = true;
                        if (len === 2 && Array.isArray(arguments[0])) {
                            input = arguments[0];
                            len = input.length;
                            spreadArgs = false;
                        } else {
                            input = arguments;
                            len--;
                        }
                        var resources = new ResourceList(len);
                        for(var i = 0; i < len; ++i){
                            var resource = input[i];
                            if (Disposer.isDisposer(resource)) {
                                var disposer = resource;
                                resource = resource.promise();
                                resource._setDisposable(disposer);
                            } else {
                                var maybePromise = tryConvertToPromise(resource);
                                if (maybePromise instanceof Promise1) resource = maybePromise._then(maybeUnwrapDisposer, null, null, {
                                    resources: resources,
                                    index: i
                                }, undefined);
                            }
                            resources[i] = resource;
                        }
                        var reflectedResources = new Array(resources.length);
                        for(var i = 0; i < reflectedResources.length; ++i)reflectedResources[i] = Promise1.resolve(resources[i]).reflect();
                        var resultPromise = Promise1.all(reflectedResources).then(function(inspections) {
                            for(var i = 0; i < inspections.length; ++i){
                                var inspection = inspections[i];
                                if (inspection.isRejected()) {
                                    errorObj.e = inspection.error();
                                    return errorObj;
                                } else if (!inspection.isFulfilled()) {
                                    resultPromise.cancel();
                                    return;
                                }
                                inspections[i] = inspection.value();
                            }
                            promise._pushContext();
                            fn = tryCatch(fn);
                            var ret = spreadArgs ? fn.apply(undefined, inspections) : fn(inspections);
                            var promiseCreated = promise._popContext();
                            debug.checkForgottenReturns(ret, promiseCreated, "Promise.using", promise);
                            return ret;
                        });
                        var promise = resultPromise.lastly(function() {
                            var inspection = new Promise1.PromiseInspection(resultPromise);
                            return dispose(resources, inspection);
                        });
                        resources.promise = promise;
                        promise._setOnCancel(resources);
                        return promise;
                    };
                    Promise1.prototype._setDisposable = function(disposer) {
                        this._bitField = this._bitField | 131072;
                        this._disposer = disposer;
                    };
                    Promise1.prototype._isDisposable = function() {
                        return (this._bitField & 131072) > 0;
                    };
                    Promise1.prototype._getDisposer = function() {
                        return this._disposer;
                    };
                    Promise1.prototype._unsetDisposable = function() {
                        this._bitField = this._bitField & -131073;
                        this._disposer = undefined;
                    };
                    Promise1.prototype.disposer = function(fn) {
                        if (typeof fn === "function") return new FunctionDisposer(fn, this, createContext());
                        throw new TypeError1();
                    };
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        36: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var es5 = _dereq_1("./es5");
                var canEvaluate = typeof navigator == "undefined";
                var errorObj = {
                    e: {}
                };
                var tryCatchTarget;
                var globalObject = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : this !== undefined ? this : null;
                function tryCatcher() {
                    try {
                        var target = tryCatchTarget;
                        tryCatchTarget = null;
                        return target.apply(this, arguments);
                    } catch (e) {
                        errorObj.e = e;
                        return errorObj;
                    }
                }
                function tryCatch(fn) {
                    tryCatchTarget = fn;
                    return tryCatcher;
                }
                var inherits = function(Child, Parent) {
                    var hasProp = {}.hasOwnProperty;
                    function T() {
                        this.constructor = Child;
                        this.constructor$ = Parent;
                        for(var propertyName in Parent.prototype)if (hasProp.call(Parent.prototype, propertyName) && propertyName.charAt(propertyName.length - 1) !== "$") this[propertyName + "$"] = Parent.prototype[propertyName];
                    }
                    T.prototype = Parent.prototype;
                    Child.prototype = new T();
                    return Child.prototype;
                };
                function isPrimitive(val) {
                    return val == null || val === true || val === false || typeof val === "string" || typeof val === "number";
                }
                function isObject(value) {
                    return typeof value === "function" || typeof value === "object" && value !== null;
                }
                function maybeWrapAsError(maybeError) {
                    if (!isPrimitive(maybeError)) return maybeError;
                    return new Error(safeToString(maybeError));
                }
                function withAppended(target, appendee) {
                    var len = target.length;
                    var ret = new Array(len + 1);
                    var i;
                    for(i = 0; i < len; ++i)ret[i] = target[i];
                    ret[i] = appendee;
                    return ret;
                }
                function getDataPropertyOrDefault(obj, key, defaultValue) {
                    if (es5.isES5) {
                        var desc = Object.getOwnPropertyDescriptor(obj, key);
                        if (desc != null) return desc.get == null && desc.set == null ? desc.value : defaultValue;
                    } else return ({}).hasOwnProperty.call(obj, key) ? obj[key] : undefined;
                }
                function notEnumerableProp(obj, name, value) {
                    if (isPrimitive(obj)) return obj;
                    var descriptor = {
                        value: value,
                        configurable: true,
                        enumerable: false,
                        writable: true
                    };
                    es5.defineProperty(obj, name, descriptor);
                    return obj;
                }
                function thrower(r) {
                    throw r;
                }
                var inheritedDataKeys = function() {
                    var excludedPrototypes = [
                        Array.prototype,
                        Object.prototype,
                        Function.prototype
                    ];
                    var isExcludedProto = function(val) {
                        for(var i = 0; i < excludedPrototypes.length; ++i){
                            if (excludedPrototypes[i] === val) return true;
                        }
                        return false;
                    };
                    if (es5.isES5) {
                        var getKeys = Object.getOwnPropertyNames;
                        return function(obj) {
                            var ret = [];
                            var visitedKeys = Object.create(null);
                            while(obj != null && !isExcludedProto(obj)){
                                var keys;
                                try {
                                    keys = getKeys(obj);
                                } catch (e) {
                                    return ret;
                                }
                                for(var i = 0; i < keys.length; ++i){
                                    var key = keys[i];
                                    if (visitedKeys[key]) continue;
                                    visitedKeys[key] = true;
                                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                                    if (desc != null && desc.get == null && desc.set == null) ret.push(key);
                                }
                                obj = es5.getPrototypeOf(obj);
                            }
                            return ret;
                        };
                    } else {
                        var hasProp = {}.hasOwnProperty;
                        return function(obj) {
                            if (isExcludedProto(obj)) return [];
                            var ret = [];
                            /*jshint forin:false */ enumeration: for(var key in obj)if (hasProp.call(obj, key)) ret.push(key);
                            else {
                                for(var i = 0; i < excludedPrototypes.length; ++i){
                                    if (hasProp.call(excludedPrototypes[i], key)) continue enumeration;
                                }
                                ret.push(key);
                            }
                            return ret;
                        };
                    }
                }();
                var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
                function isClass(fn) {
                    try {
                        if (typeof fn === "function") {
                            var keys = es5.names(fn.prototype);
                            var hasMethods = es5.isES5 && keys.length > 1;
                            var hasMethodsOtherThanConstructor = keys.length > 0 && !(keys.length === 1 && keys[0] === "constructor");
                            var hasThisAssignmentAndStaticMethods = thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
                            if (hasMethods || hasMethodsOtherThanConstructor || hasThisAssignmentAndStaticMethods) return true;
                        }
                        return false;
                    } catch (e) {
                        return false;
                    }
                }
                function toFastProperties(obj) {
                    /*jshint -W027,-W055,-W031*/ function FakeConstructor() {}
                    FakeConstructor.prototype = obj;
                    var receiver = new FakeConstructor();
                    function ic() {
                        return typeof receiver.foo;
                    }
                    ic();
                    ic();
                    return obj;
                }
                var rident = /^[a-z$_][a-z$_0-9]*$/i;
                function isIdentifier(str) {
                    return rident.test(str);
                }
                function filledRange(count, prefix, suffix) {
                    var ret = new Array(count);
                    for(var i = 0; i < count; ++i)ret[i] = prefix + i + suffix;
                    return ret;
                }
                function safeToString(obj) {
                    try {
                        return obj + "";
                    } catch (e) {
                        return "[no string representation]";
                    }
                }
                function isError(obj) {
                    return obj instanceof Error || obj !== null && typeof obj === "object" && typeof obj.message === "string" && typeof obj.name === "string";
                }
                function markAsOriginatingFromRejection(e) {
                    try {
                        notEnumerableProp(e, "isOperational", true);
                    } catch (ignore) {}
                }
                function originatesFromRejection(e) {
                    if (e == null) return false;
                    return e instanceof Error["__BluebirdErrorTypes__"].OperationalError || e["isOperational"] === true;
                }
                function canAttachTrace(obj) {
                    return isError(obj) && es5.propertyIsWritable(obj, "stack");
                }
                var ensureErrorObject = function() {
                    if (!("stack" in new Error())) return function(value) {
                        if (canAttachTrace(value)) return value;
                        try {
                            throw new Error(safeToString(value));
                        } catch (err) {
                            return err;
                        }
                    };
                    else return function(value) {
                        if (canAttachTrace(value)) return value;
                        return new Error(safeToString(value));
                    };
                }();
                function classString(obj) {
                    return ({}).toString.call(obj);
                }
                function copyDescriptors(from, to, filter) {
                    var keys = es5.names(from);
                    for(var i = 0; i < keys.length; ++i){
                        var key = keys[i];
                        if (filter(key)) try {
                            es5.defineProperty(to, key, es5.getDescriptor(from, key));
                        } catch (ignore) {}
                    }
                }
                var asArray = function(v) {
                    if (es5.isArray(v)) return v;
                    return null;
                };
                if (typeof Symbol !== "undefined" && Symbol.iterator) {
                    var ArrayFrom = typeof Array.from === "function" ? function(v) {
                        return Array.from(v);
                    } : function(v) {
                        var ret = [];
                        var it = v[Symbol.iterator]();
                        var itResult;
                        while(!(itResult = it.next()).done)ret.push(itResult.value);
                        return ret;
                    };
                    asArray = function(v) {
                        if (es5.isArray(v)) return v;
                        else if (v != null && typeof v[Symbol.iterator] === "function") return ArrayFrom(v);
                        return null;
                    };
                }
                var isNode = typeof $449e3df09682ce9f$exports !== "undefined" && classString($449e3df09682ce9f$exports).toLowerCase() === "[object process]";
                var hasEnvVariables = typeof $449e3df09682ce9f$exports !== "undefined" && typeof $449e3df09682ce9f$exports.env !== "undefined";
                function env(key) {
                    return hasEnvVariables ? $449e3df09682ce9f$exports.env[key] : undefined;
                }
                function getNativePromise() {
                    if (typeof Promise === "function") try {
                        var promise = new Promise(function() {});
                        if (classString(promise) === "[object Promise]") return Promise;
                    } catch (e) {}
                }
                var reflectHandler;
                function contextBind(ctx, cb) {
                    if (ctx === null || typeof cb !== "function" || cb === reflectHandler) return cb;
                    if (ctx.domain !== null) cb = ctx.domain.bind(cb);
                    var async = ctx.async;
                    if (async !== null) {
                        var old = cb;
                        cb = function() {
                            var args = new Array(2).concat([].slice.call(arguments));
                            args[0] = old;
                            args[1] = this;
                            return async.runInAsyncScope.apply(async, args);
                        };
                    }
                    return cb;
                }
                var ret = {
                    setReflectHandler: function(fn) {
                        reflectHandler = fn;
                    },
                    isClass: isClass,
                    isIdentifier: isIdentifier,
                    inheritedDataKeys: inheritedDataKeys,
                    getDataPropertyOrDefault: getDataPropertyOrDefault,
                    thrower: thrower,
                    isArray: es5.isArray,
                    asArray: asArray,
                    notEnumerableProp: notEnumerableProp,
                    isPrimitive: isPrimitive,
                    isObject: isObject,
                    isError: isError,
                    canEvaluate: canEvaluate,
                    errorObj: errorObj,
                    tryCatch: tryCatch,
                    inherits: inherits,
                    withAppended: withAppended,
                    maybeWrapAsError: maybeWrapAsError,
                    toFastProperties: toFastProperties,
                    filledRange: filledRange,
                    toString: safeToString,
                    canAttachTrace: canAttachTrace,
                    ensureErrorObject: ensureErrorObject,
                    originatesFromRejection: originatesFromRejection,
                    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
                    classString: classString,
                    copyDescriptors: copyDescriptors,
                    isNode: isNode,
                    hasEnvVariables: hasEnvVariables,
                    env: env,
                    global: globalObject,
                    getNativePromise: getNativePromise,
                    contextBind: contextBind
                };
                ret.isRecentNode = ret.isNode && function() {
                    var version;
                    if ($449e3df09682ce9f$exports.versions && $449e3df09682ce9f$exports.versions.node) version = $449e3df09682ce9f$exports.versions.node.split(".").map(Number);
                    else if ($449e3df09682ce9f$exports.version) version = $449e3df09682ce9f$exports.version.split(".").map(Number);
                    return version[0] === 0 && version[1] > 10 || version[0] > 0;
                }();
                ret.nodeSupportsAsyncResource = ret.isNode && function() {
                    var supportsAsync = false;
                    try {
                        var res = _dereq_1("async_hooks").AsyncResource;
                        supportsAsync = typeof res.prototype.runInAsyncScope === "function";
                    } catch (e) {
                        supportsAsync = false;
                    }
                    return supportsAsync;
                }();
                if (ret.isNode) ret.toFastProperties($449e3df09682ce9f$exports);
                try {
                    throw new Error();
                } catch (e) {
                    ret.lastLineError = e;
                }
                module1.exports = ret;
            },
            {
                "./es5": 13,
                "async_hooks": undefined
            }
        ]
    }, {}, [
        4
    ])(4);
});
if (typeof window !== "undefined" && window !== null) window.P = window.Promise;
else if (typeof self !== "undefined" && self !== null) self.P = self.Promise;


var $7815081cbe1e48a7$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $7815081cbe1e48a7$exports) {
        classNames.default = classNames;
        $7815081cbe1e48a7$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


parcelRequire("f5dPJ");
var $7f092e43d4b75e53$exports = {};
"use strict";
function $7f092e43d4b75e53$var$product(elements) {
    if (!Array.isArray(elements)) throw new TypeError();
    var end = elements.length - 1, result = [];
    function addTo(curr, start) {
        var first = elements[start], last = start === end;
        for(var i = 0; i < first.length; ++i){
            var copy = curr.slice();
            copy.push(first[i]);
            if (last) result.push(copy);
            else addTo(copy, start + 1);
        }
    }
    if (elements.length) addTo([], 0);
    else result.push([]);
    return result;
}
$7f092e43d4b75e53$exports = $7f092e43d4b75e53$var$product;


class $d881a5f91c2f3e81$export$2e2bcd8739ae039 {
    constructor(items, title, field){
        this.$items = items;
        this.$title = title;
        this.$field = field;
    }
    // Properties
    get field() {
        return this.$field;
    }
    get title() {
        return this.$title;
    }
    get items() {
        return this.$items;
    }
    //
    get selected() {
        return this.items.filter((item)=>item.isSelected);
    }
    // Properties of items
    get isSelectedAll() {
        return this.$items.every((each)=>each.isSelected);
    }
    get isSelectedSome() {
        return this.$items.some((each)=>each.isSelected);
    }
    // Method
    toggleSelected(item) {
        item.isSelected = !item.isSelected;
    }
    toggleSelectAll() {
        const value = !this.isSelectedAll;
        this.$items.map((each)=>each.isSelected = value);
    }
} // vim:syntax=javascript


class $c855476682ea0f22$export$2e2bcd8739ae039 {
    constructor(entries){
        this.$entries = entries;
    }
    get entries() {
        return this.$entries;
    }
    get selected() {
        return this.entries.filter((entry)=>entry.isSelected);
    }
    get selectedSome() {
        return this.entries.some((entry)=>entry.isSelected);
    }
    get selectedEach() {
        return this.entries.every((entry)=>entry.isSelected);
    }
    toggleOne(entry) {
        entry.isSelected = !entry.isSelected;
    }
} // vim:syntax=javascript




class $c2eadb66456eb74a$export$2e2bcd8739ae039 {
    view(vnode) {
        const model = vnode.attrs.model;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("ul.cube-select-facts", [
            model.entries.map((entry)=>this.renderEntry(vnode, model, entry))
        ]);
    }
    renderEntry(vnode, model, entry) {
        console.log(entry);
        return (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("li", {
            onclick: (ev)=>model.toggleOne(entry)
        }, [
            (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("input", {
                type: "checkbox",
                checked: entry.isSelected
            }),
            (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("span", entry.title)
        ]);
    }
} // vim:syntax=javascript




class $8bc561695f7b9c84$export$2e2bcd8739ae039 {
    constructor(){
        this.isCollapsed = true;
    }
    view(vnode) {
        const model = vnode.attrs.model;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))(".cube-select-dimension-elements", [
            this.renderHead(vnode, model),
            this.renderBody(vnode, model)
        ]);
    }
    toggleCollapsed() {
        this.isCollapsed = !this.isCollapsed;
    }
    renderHead(vnode, model) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))(".head", [
            (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))(".control", [
                (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("input", {
                    type: "checkbox",
                    checked: model.isSelectedAll,
                    indeterminate: !model.isSelectedAll && model.isSelectedSome,
                    onclick: (event)=>model.toggleSelectAll()
                })
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))(".caption", {
                onclick: (event)=>this.toggleCollapsed()
            }, [
                (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("span", model.title),
                (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("span", this.isCollapsed ? "+" : "-")
            ])
        ]);
    }
    renderBody(vnode, model) {
        if (this.isCollapsed) return;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("ul.body", [
            model.items.map((each)=>{
                return (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("li.item", {
                    onclick: (ev)=>model.toggleSelected(each)
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("input", {
                        type: "checkbox",
                        checked: each.isSelected
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("span", each.label)
                ]);
            })
        ]);
    }
} // vim:syntax=javascript


var $71a2d64234b12d65$exports = {};
"use strict";
var $71a2d64234b12d65$var$isMergeableObject = function isMergeableObject(value) {
    return $71a2d64234b12d65$var$isNonNullObject(value) && !$71a2d64234b12d65$var$isSpecial(value);
};
function $71a2d64234b12d65$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $71a2d64234b12d65$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $71a2d64234b12d65$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $71a2d64234b12d65$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $71a2d64234b12d65$var$REACT_ELEMENT_TYPE = $71a2d64234b12d65$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $71a2d64234b12d65$var$isReactElement(value) {
    return value.$$typeof === $71a2d64234b12d65$var$REACT_ELEMENT_TYPE;
}
function $71a2d64234b12d65$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $71a2d64234b12d65$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $71a2d64234b12d65$var$deepmerge($71a2d64234b12d65$var$emptyTarget(value), value, options) : value;
}
function $71a2d64234b12d65$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $71a2d64234b12d65$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $71a2d64234b12d65$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $71a2d64234b12d65$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : $71a2d64234b12d65$var$deepmerge;
}
function $71a2d64234b12d65$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $71a2d64234b12d65$var$getKeys(target) {
    return Object.keys(target).concat($71a2d64234b12d65$var$getEnumerableOwnPropertySymbols(target));
}
function $71a2d64234b12d65$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $71a2d64234b12d65$var$propertyIsUnsafe(target, key) {
    return $71a2d64234b12d65$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $71a2d64234b12d65$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $71a2d64234b12d65$var$getKeys(target).forEach(function(key) {
        destination[key] = $71a2d64234b12d65$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $71a2d64234b12d65$var$getKeys(source).forEach(function(key) {
        if ($71a2d64234b12d65$var$propertyIsUnsafe(target, key)) return;
        if ($71a2d64234b12d65$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $71a2d64234b12d65$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $71a2d64234b12d65$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $71a2d64234b12d65$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $71a2d64234b12d65$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $71a2d64234b12d65$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $71a2d64234b12d65$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $71a2d64234b12d65$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $71a2d64234b12d65$var$mergeObject(target, source, options);
}
$71a2d64234b12d65$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $71a2d64234b12d65$var$deepmerge(prev, next, options);
    }, {});
};
var $71a2d64234b12d65$var$deepmerge_1 = $71a2d64234b12d65$var$deepmerge;
$71a2d64234b12d65$exports = $71a2d64234b12d65$var$deepmerge_1;



var $f5dPJ = parcelRequire("f5dPJ");

var $ac9f869b8637e826$exports = {};
var $519a338fba25811b$exports = {};

$parcel$export($519a338fba25811b$exports, "bisect", () => $263d20e47b8a3378$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "bisectRight", () => $263d20e47b8a3378$export$4d945ad3ad5751b0);
$parcel$export($519a338fba25811b$exports, "bisectLeft", () => $263d20e47b8a3378$export$df7d25c84ebd12a5);
$parcel$export($519a338fba25811b$exports, "bisectCenter", () => $263d20e47b8a3378$export$c1cb828b1117c77b);
$parcel$export($519a338fba25811b$exports, "ascending", () => $f64c55ab13ca9913$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "bisector", () => $a48de5bf29a63c46$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "blur", () => $0e52bb170b12b86c$export$2cc7ff91bcacba5e);
$parcel$export($519a338fba25811b$exports, "blur2", () => $0e52bb170b12b86c$export$7671911241d9460b);
$parcel$export($519a338fba25811b$exports, "blurImage", () => $0e52bb170b12b86c$export$44bf2d4c3a4dda00);
$parcel$export($519a338fba25811b$exports, "count", () => $651219df81728ee3$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "cross", () => $0e5f906e003dba4b$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "cumsum", () => $9478b657f84fae79$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "descending", () => $3820d1163d2cbf10$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "deviation", () => $67d053767afbcfb0$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "extent", () => $7dfd54d3fa480d64$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "Adder", () => $4e51c5d9e96ea8c7$export$bda7ba77fb86c375);
$parcel$export($519a338fba25811b$exports, "fsum", () => $4e51c5d9e96ea8c7$export$61cb83f1a93e9fae);
$parcel$export($519a338fba25811b$exports, "fcumsum", () => $4e51c5d9e96ea8c7$export$5a6391da70c130da);
$parcel$export($519a338fba25811b$exports, "group", () => $d9d17ae8c456c306$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "flatGroup", () => $d9d17ae8c456c306$export$4ed6fc79ae2c51b5);
$parcel$export($519a338fba25811b$exports, "flatRollup", () => $d9d17ae8c456c306$export$788c7294dbcd8e36);
$parcel$export($519a338fba25811b$exports, "groups", () => $d9d17ae8c456c306$export$d4abd167df80d226);
$parcel$export($519a338fba25811b$exports, "index", () => $d9d17ae8c456c306$export$b610b8812bbcded9);
$parcel$export($519a338fba25811b$exports, "indexes", () => $d9d17ae8c456c306$export$8b04ba635e5803cd);
$parcel$export($519a338fba25811b$exports, "rollup", () => $d9d17ae8c456c306$export$97e11c0b0230f130);
$parcel$export($519a338fba25811b$exports, "rollups", () => $d9d17ae8c456c306$export$24814875ed03194b);
$parcel$export($519a338fba25811b$exports, "groupSort", () => $0dcd0a69e5912f72$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "bin", () => $a834045de4cfbb5b$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "histogram", () => $a834045de4cfbb5b$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "thresholdFreedmanDiaconis", () => $d245e7f7f6278a9f$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "thresholdScott", () => $a4c4ae797fe5b3c6$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "thresholdSturges", () => $fd876a2d70480179$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "max", () => $2a55c062ab1a12b9$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "maxIndex", () => $aabaa0ca6e97cbe2$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "mean", () => $7ddf432de505a4dc$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "median", () => $6a40b4b9e100e776$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "medianIndex", () => $6a40b4b9e100e776$export$57546ab4fd3c7a5e);
$parcel$export($519a338fba25811b$exports, "merge", () => $6341023b666029a7$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "min", () => $1110482c2879adab$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "minIndex", () => $44b878b2518322a8$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "mode", () => $6e487b69bbe1c75a$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "nice", () => $a71794ecb80cbf90$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "pairs", () => $22f93d164c9f5d36$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "permute", () => $cee0855bc77f7075$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "quantile", () => $058a580f1d366c99$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "quantileIndex", () => $058a580f1d366c99$export$f1fcc854ecc6ce55);
$parcel$export($519a338fba25811b$exports, "quantileSorted", () => $058a580f1d366c99$export$f924a6cad778dddb);
$parcel$export($519a338fba25811b$exports, "quickselect", () => $33d5ac6315bfa495$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "range", () => $e4dbde6ec669fccd$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "rank", () => $c60d74e2a9330f2b$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "least", () => $d946f525fcb687dc$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "leastIndex", () => $17137e49b6270194$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "greatest", () => $09ccbe016bbe9b56$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "greatestIndex", () => $72a32bc84d2e3f54$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "scan", () => $16b080726d96aeaf$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "shuffle", () => $09aa46897db2fb54$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "shuffler", () => $09aa46897db2fb54$export$a430ea578c95d356);
$parcel$export($519a338fba25811b$exports, "sum", () => $2ab268eff5ee0033$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "ticks", () => $60d8cb9860d70e68$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "tickIncrement", () => $60d8cb9860d70e68$export$bc64d00cc98e7e95);
$parcel$export($519a338fba25811b$exports, "tickStep", () => $60d8cb9860d70e68$export$81087d9b915d4ede);
$parcel$export($519a338fba25811b$exports, "transpose", () => $f9b8d6b640b443c5$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "variance", () => $9fc36284d3af74e7$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "zip", () => $8ce2aba54db49350$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "every", () => $fcef2b6a367d44cb$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "some", () => $ccc5fd93232e02e3$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "filter", () => $fbf82e41ba141931$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "map", () => $e174c94416ec168c$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "reduce", () => $f1146cac7d5ba9b3$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "reverse", () => $15cdfea54388641a$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "sort", () => $6f30b441ad7a113f$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "difference", () => $b669dc05423acfc8$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "disjoint", () => $49822c8e3c2d52ca$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "intersection", () => $350c0faa8b97fdcf$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "subset", () => $2a902786db480752$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "superset", () => $9cf973f3ac1fdcf0$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "union", () => $b5a88d212a54c510$export$2e2bcd8739ae039);
$parcel$export($519a338fba25811b$exports, "InternMap", () => $1565c3f84209a139$export$dcc6fb7d82b5bc7b);
$parcel$export($519a338fba25811b$exports, "InternSet", () => $1565c3f84209a139$export$55278c3294239828);
function $f64c55ab13ca9913$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $3820d1163d2cbf10$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $a48de5bf29a63c46$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $f64c55ab13ca9913$export$2e2bcd8739ae039);
        compare2 = (d, x)=>(0, $f64c55ab13ca9913$export$2e2bcd8739ae039)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $f64c55ab13ca9913$export$2e2bcd8739ae039) || f === (0, $3820d1163d2cbf10$export$2e2bcd8739ae039) ? f : $a48de5bf29a63c46$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $a48de5bf29a63c46$var$zero() {
    return 0;
}


function $30b688f7f9a34de6$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $30b688f7f9a34de6$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $263d20e47b8a3378$var$ascendingBisect = (0, $a48de5bf29a63c46$export$2e2bcd8739ae039)((0, $f64c55ab13ca9913$export$2e2bcd8739ae039));
const $263d20e47b8a3378$export$4d945ad3ad5751b0 = $263d20e47b8a3378$var$ascendingBisect.right;
const $263d20e47b8a3378$export$df7d25c84ebd12a5 = $263d20e47b8a3378$var$ascendingBisect.left;
const $263d20e47b8a3378$export$c1cb828b1117c77b = (0, $a48de5bf29a63c46$export$2e2bcd8739ae039)((0, $30b688f7f9a34de6$export$2e2bcd8739ae039)).center;
var $263d20e47b8a3378$export$2e2bcd8739ae039 = $263d20e47b8a3378$export$4d945ad3ad5751b0;




function $0e52bb170b12b86c$export$2cc7ff91bcacba5e(values, r) {
    if (!((r = +r) >= 0)) throw new RangeError("invalid r");
    let length = values.length;
    if (!((length = Math.floor(length)) >= 0)) throw new RangeError("invalid length");
    if (!length || !r) return values;
    const blur = $0e52bb170b12b86c$var$blurf(r);
    const temp = values.slice();
    blur(values, temp, 0, length, 1);
    blur(temp, values, 0, length, 1);
    blur(values, temp, 0, length, 1);
    return values;
}
const $0e52bb170b12b86c$export$7671911241d9460b = $0e52bb170b12b86c$var$Blur2($0e52bb170b12b86c$var$blurf);
const $0e52bb170b12b86c$export$44bf2d4c3a4dda00 = $0e52bb170b12b86c$var$Blur2($0e52bb170b12b86c$var$blurfImage);
function $0e52bb170b12b86c$var$Blur2(blur) {
    return function(data, rx, ry = rx) {
        if (!((rx = +rx) >= 0)) throw new RangeError("invalid rx");
        if (!((ry = +ry) >= 0)) throw new RangeError("invalid ry");
        let { data: values, width: width, height: height } = data;
        if (!((width = Math.floor(width)) >= 0)) throw new RangeError("invalid width");
        if (!((height = Math.floor(height !== undefined ? height : values.length / width)) >= 0)) throw new RangeError("invalid height");
        if (!width || !height || !rx && !ry) return data;
        const blurx = rx && blur(rx);
        const blury = ry && blur(ry);
        const temp = values.slice();
        if (blurx && blury) {
            $0e52bb170b12b86c$var$blurh(blurx, temp, values, width, height);
            $0e52bb170b12b86c$var$blurh(blurx, values, temp, width, height);
            $0e52bb170b12b86c$var$blurh(blurx, temp, values, width, height);
            $0e52bb170b12b86c$var$blurv(blury, values, temp, width, height);
            $0e52bb170b12b86c$var$blurv(blury, temp, values, width, height);
            $0e52bb170b12b86c$var$blurv(blury, values, temp, width, height);
        } else if (blurx) {
            $0e52bb170b12b86c$var$blurh(blurx, values, temp, width, height);
            $0e52bb170b12b86c$var$blurh(blurx, temp, values, width, height);
            $0e52bb170b12b86c$var$blurh(blurx, values, temp, width, height);
        } else if (blury) {
            $0e52bb170b12b86c$var$blurv(blury, values, temp, width, height);
            $0e52bb170b12b86c$var$blurv(blury, temp, values, width, height);
            $0e52bb170b12b86c$var$blurv(blury, values, temp, width, height);
        }
        return data;
    };
}
function $0e52bb170b12b86c$var$blurh(blur, T, S, w, h) {
    for(let y = 0, n = w * h; y < n;)blur(T, S, y, y += w, 1);
}
function $0e52bb170b12b86c$var$blurv(blur, T, S, w, h) {
    for(let x = 0, n = w * h; x < w; ++x)blur(T, S, x, x + n, w);
}
function $0e52bb170b12b86c$var$blurfImage(radius) {
    const blur = $0e52bb170b12b86c$var$blurf(radius);
    return (T, S, start, stop, step)=>{
        start <<= 2, stop <<= 2, step <<= 2;
        blur(T, S, start + 0, stop + 0, step);
        blur(T, S, start + 1, stop + 1, step);
        blur(T, S, start + 2, stop + 2, step);
        blur(T, S, start + 3, stop + 3, step);
    };
}
// Given a target array T, a source array S, sets each value T[i] to the average
// of {S[i - r], …, S[i], …, S[i + r]}, where r = ⌊radius⌋, start <= i < stop,
// for each i, i + step, i + 2 * step, etc., and where S[j] is clamped between
// S[start] (inclusive) and S[stop] (exclusive). If the given radius is not an
// integer, S[i - r - 1] and S[i + r + 1] are added to the sum, each weighted
// according to r - ⌊radius⌋.
function $0e52bb170b12b86c$var$blurf(radius) {
    const radius0 = Math.floor(radius);
    if (radius0 === radius) return $0e52bb170b12b86c$var$bluri(radius);
    const t = radius - radius0;
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius0 * S[start];
        const s0 = step * radius0;
        const s1 = s0 + step;
        for(let i = start, j = start + s0; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s0)];
            T[i] = (sum + t * (S[Math.max(start, i - s1)] + S[Math.min(stop, i + s1)])) / w;
            sum -= S[Math.max(start, i - s0)];
        }
    };
}
// Like blurf, but optimized for integer radius.
function $0e52bb170b12b86c$var$bluri(radius) {
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius * S[start];
        const s = step * radius;
        for(let i = start, j = start + s; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s)];
            T[i] = sum / w;
            sum -= S[Math.max(start, i - s)];
        }
    };
}


function $651219df81728ee3$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}


function $0e5f906e003dba4b$var$length(array) {
    return array.length | 0;
}
function $0e5f906e003dba4b$var$empty(length) {
    return !(length > 0);
}
function $0e5f906e003dba4b$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $0e5f906e003dba4b$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $0e5f906e003dba4b$export$2e2bcd8739ae039(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $0e5f906e003dba4b$var$reducer(values.pop());
    values = values.map($0e5f906e003dba4b$var$arrayify);
    const lengths = values.map($0e5f906e003dba4b$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($0e5f906e003dba4b$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}


function $9478b657f84fae79$export$2e2bcd8739ae039(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}



function $9fc36284d3af74e7$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}


function $67d053767afbcfb0$export$2e2bcd8739ae039(values, valueof) {
    const v = (0, $9fc36284d3af74e7$export$2e2bcd8739ae039)(values, valueof);
    return v ? Math.sqrt(v) : v;
}


function $7dfd54d3fa480d64$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}


// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $4e51c5d9e96ea8c7$export$bda7ba77fb86c375 {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function $4e51c5d9e96ea8c7$export$61cb83f1a93e9fae(values, valueof) {
    const adder = new $4e51c5d9e96ea8c7$export$bda7ba77fb86c375();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $4e51c5d9e96ea8c7$export$5a6391da70c130da(values, valueof) {
    const adder = new $4e51c5d9e96ea8c7$export$bda7ba77fb86c375();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}


class $1565c3f84209a139$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $1565c3f84209a139$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($1565c3f84209a139$var$intern_get(this, key));
    }
    has(key) {
        return super.has($1565c3f84209a139$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($1565c3f84209a139$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($1565c3f84209a139$var$intern_delete(this, key));
    }
}
class $1565c3f84209a139$export$55278c3294239828 extends Set {
    constructor(values, key = $1565c3f84209a139$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($1565c3f84209a139$var$intern_get(this, value));
    }
    add(value) {
        return super.add($1565c3f84209a139$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($1565c3f84209a139$var$intern_delete(this, value));
    }
}
function $1565c3f84209a139$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $1565c3f84209a139$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $1565c3f84209a139$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $1565c3f84209a139$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}


function $2d193e9367b7feea$export$2e2bcd8739ae039(x) {
    return x;
}


function $d9d17ae8c456c306$export$2e2bcd8739ae039(values, ...keys) {
    return $d9d17ae8c456c306$var$nest(values, (0, $2d193e9367b7feea$export$2e2bcd8739ae039), (0, $2d193e9367b7feea$export$2e2bcd8739ae039), keys);
}
function $d9d17ae8c456c306$export$d4abd167df80d226(values, ...keys) {
    return $d9d17ae8c456c306$var$nest(values, Array.from, (0, $2d193e9367b7feea$export$2e2bcd8739ae039), keys);
}
function $d9d17ae8c456c306$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $d9d17ae8c456c306$export$4ed6fc79ae2c51b5(values, ...keys) {
    return $d9d17ae8c456c306$var$flatten($d9d17ae8c456c306$export$d4abd167df80d226(values, ...keys), keys);
}
function $d9d17ae8c456c306$export$788c7294dbcd8e36(values, reduce, ...keys) {
    return $d9d17ae8c456c306$var$flatten($d9d17ae8c456c306$export$24814875ed03194b(values, reduce, ...keys), keys);
}
function $d9d17ae8c456c306$export$97e11c0b0230f130(values, reduce, ...keys) {
    return $d9d17ae8c456c306$var$nest(values, (0, $2d193e9367b7feea$export$2e2bcd8739ae039), reduce, keys);
}
function $d9d17ae8c456c306$export$24814875ed03194b(values, reduce, ...keys) {
    return $d9d17ae8c456c306$var$nest(values, Array.from, reduce, keys);
}
function $d9d17ae8c456c306$export$b610b8812bbcded9(values, ...keys) {
    return $d9d17ae8c456c306$var$nest(values, (0, $2d193e9367b7feea$export$2e2bcd8739ae039), $d9d17ae8c456c306$var$unique, keys);
}
function $d9d17ae8c456c306$export$8b04ba635e5803cd(values, ...keys) {
    return $d9d17ae8c456c306$var$nest(values, Array.from, $d9d17ae8c456c306$var$unique, keys);
}
function $d9d17ae8c456c306$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $d9d17ae8c456c306$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new (0, $1565c3f84209a139$export$dcc6fb7d82b5bc7b)();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}





function $cee0855bc77f7075$export$2e2bcd8739ae039(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}


function $6f30b441ad7a113f$export$2e2bcd8739ae039(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $6f30b441ad7a113f$export$686e14b8469efec4(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$6f30b441ad7a113f$export$686e14b8469efec4(f[i], f[j]));
        }
        return (0, $cee0855bc77f7075$export$2e2bcd8739ae039)(values, index);
    }
    return values.sort($6f30b441ad7a113f$export$5708b2c031939e56(f));
}
function $6f30b441ad7a113f$export$5708b2c031939e56(compare = (0, $f64c55ab13ca9913$export$2e2bcd8739ae039)) {
    if (compare === (0, $f64c55ab13ca9913$export$2e2bcd8739ae039)) return $6f30b441ad7a113f$export$686e14b8469efec4;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $6f30b441ad7a113f$export$686e14b8469efec4(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}


function $0dcd0a69e5912f72$export$2e2bcd8739ae039(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $6f30b441ad7a113f$export$2e2bcd8739ae039)((0, $d9d17ae8c456c306$export$97e11c0b0230f130)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $f64c55ab13ca9913$export$2e2bcd8739ae039)(av, bv) || (0, $f64c55ab13ca9913$export$2e2bcd8739ae039)(ak, bk)) : (0, $6f30b441ad7a113f$export$2e2bcd8739ae039)((0, $d9d17ae8c456c306$export$2e2bcd8739ae039)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $f64c55ab13ca9913$export$2e2bcd8739ae039)(ak, bk))).map(([key])=>key);
}


var $5a88f4493993b343$var$array = Array.prototype;
var $5a88f4493993b343$export$58adb3bec8346d0f = $5a88f4493993b343$var$array.slice;
var $5a88f4493993b343$export$871de8747c9eaa88 = $5a88f4493993b343$var$array.map;



function $198247438e58e8bd$export$2e2bcd8739ae039(x) {
    return ()=>x;
}




const $60d8cb9860d70e68$var$e10 = Math.sqrt(50), $60d8cb9860d70e68$var$e5 = Math.sqrt(10), $60d8cb9860d70e68$var$e2 = Math.sqrt(2);
function $60d8cb9860d70e68$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $60d8cb9860d70e68$var$e10 ? 10 : error >= $60d8cb9860d70e68$var$e5 ? 5 : error >= $60d8cb9860d70e68$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $60d8cb9860d70e68$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $60d8cb9860d70e68$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $60d8cb9860d70e68$var$tickSpec(stop, start, count) : $60d8cb9860d70e68$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $60d8cb9860d70e68$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $60d8cb9860d70e68$var$tickSpec(start, stop, count)[2];
}
function $60d8cb9860d70e68$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $60d8cb9860d70e68$export$bc64d00cc98e7e95(stop, start, count) : $60d8cb9860d70e68$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}


function $a71794ecb80cbf90$export$2e2bcd8739ae039(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $60d8cb9860d70e68$export$bc64d00cc98e7e95)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}




function $fd876a2d70480179$export$2e2bcd8739ae039(values) {
    return Math.max(1, Math.ceil(Math.log((0, $651219df81728ee3$export$2e2bcd8739ae039)(values)) / Math.LN2) + 1);
}


function $a834045de4cfbb5b$export$2e2bcd8739ae039() {
    var value = (0, $2d193e9367b7feea$export$2e2bcd8739ae039), domain = (0, $7dfd54d3fa480d64$export$2e2bcd8739ae039), threshold = (0, $fd876a2d70480179$export$2e2bcd8739ae039);
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === (0, $7dfd54d3fa480d64$export$2e2bcd8739ae039)) [x0, x1] = (0, $a71794ecb80cbf90$export$2e2bcd8739ae039)(x0, x1, tn);
            tz = (0, $60d8cb9860d70e68$export$2e2bcd8739ae039)(x0, x1, tn);
            // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $60d8cb9860d70e68$export$bc64d00cc98e7e95)(x0, x1, tn);
            // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === (0, $7dfd54d3fa480d64$export$2e2bcd8739ae039)) {
                    const step = (0, $60d8cb9860d70e68$export$bc64d00cc98e7e95)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        }
        // Remove any thresholds outside the domain.
        // Be careful not to mutate an array owned by the user!
        var m = tz.length, a = 0, b = m;
        while(tz[a] <= x0)++a;
        while(tz[b - 1] > x1)--b;
        if (a || b < m) tz = tz.slice(a, b), m = b - a;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $263d20e47b8a3378$export$2e2bcd8739ae039)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $198247438e58e8bd$export$2e2bcd8739ae039)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $198247438e58e8bd$export$2e2bcd8739ae039)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : (0, $198247438e58e8bd$export$2e2bcd8739ae039)(Array.isArray(_) ? (0, $5a88f4493993b343$export$58adb3bec8346d0f).call(_) : _), histogram) : threshold;
    };
    return histogram;
}



function $2a55c062ab1a12b9$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}


function $aabaa0ca6e97cbe2$export$2e2bcd8739ae039(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}


function $1110482c2879adab$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}


function $44b878b2518322a8$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}



function $33d5ac6315bfa495$export$2e2bcd8739ae039(array, k, left = 0, right = Infinity, compare) {
    k = Math.floor(k);
    left = Math.floor(Math.max(0, left));
    right = Math.floor(Math.min(array.length - 1, right));
    if (!(left <= k && k <= right)) return array;
    compare = compare === undefined ? (0, $6f30b441ad7a113f$export$686e14b8469efec4) : (0, $6f30b441ad7a113f$export$5708b2c031939e56)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $33d5ac6315bfa495$export$2e2bcd8739ae039(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $33d5ac6315bfa495$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $33d5ac6315bfa495$var$swap(array, left, right);
        while(i < j){
            $33d5ac6315bfa495$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $33d5ac6315bfa495$var$swap(array, left, j);
        else ++j, $33d5ac6315bfa495$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $33d5ac6315bfa495$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}





function $09ccbe016bbe9b56$export$2e2bcd8739ae039(values, compare = (0, $f64c55ab13ca9913$export$2e2bcd8739ae039)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $f64c55ab13ca9913$export$2e2bcd8739ae039)(value, maxValue) > 0 : (0, $f64c55ab13ca9913$export$2e2bcd8739ae039)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}


function $058a580f1d366c99$export$2e2bcd8739ae039(values, p, valueof) {
    values = Float64Array.from((0, $30b688f7f9a34de6$export$1f6c9cc012ebacae)(values, valueof));
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return (0, $1110482c2879adab$export$2e2bcd8739ae039)(values);
    if (p >= 1) return (0, $2a55c062ab1a12b9$export$2e2bcd8739ae039)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $2a55c062ab1a12b9$export$2e2bcd8739ae039)((0, $33d5ac6315bfa495$export$2e2bcd8739ae039)(values, i0).subarray(0, i0 + 1)), value1 = (0, $1110482c2879adab$export$2e2bcd8739ae039)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $058a580f1d366c99$export$f924a6cad778dddb(values, p, valueof = (0, $30b688f7f9a34de6$export$2e2bcd8739ae039)) {
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}
function $058a580f1d366c99$export$f1fcc854ecc6ce55(values, p, valueof = (0, $30b688f7f9a34de6$export$2e2bcd8739ae039)) {
    if (isNaN(p = +p)) return;
    numbers = Float64Array.from(values, (_, i)=>(0, $30b688f7f9a34de6$export$2e2bcd8739ae039)(valueof(values[i], i, values)));
    if (p <= 0) return (0, $44b878b2518322a8$export$2e2bcd8739ae039)(numbers);
    if (p >= 1) return (0, $aabaa0ca6e97cbe2$export$2e2bcd8739ae039)(numbers);
    var numbers, index = Uint32Array.from(values, (_, i)=>i), j = numbers.length - 1, i = Math.floor(j * p);
    (0, $33d5ac6315bfa495$export$2e2bcd8739ae039)(index, i, 0, j, (i, j)=>(0, $6f30b441ad7a113f$export$686e14b8469efec4)(numbers[i], numbers[j]));
    i = (0, $09ccbe016bbe9b56$export$2e2bcd8739ae039)(index.subarray(0, i + 1), (i)=>numbers[i]);
    return i >= 0 ? i : -1;
}


function $d245e7f7f6278a9f$export$2e2bcd8739ae039(values, min, max) {
    const c = (0, $651219df81728ee3$export$2e2bcd8739ae039)(values), d = (0, $058a580f1d366c99$export$2e2bcd8739ae039)(values, 0.75) - (0, $058a580f1d366c99$export$2e2bcd8739ae039)(values, 0.25);
    return c && d ? Math.ceil((max - min) / (2 * d * Math.pow(c, -1 / 3))) : 1;
}




function $a4c4ae797fe5b3c6$export$2e2bcd8739ae039(values, min, max) {
    const c = (0, $651219df81728ee3$export$2e2bcd8739ae039)(values), d = (0, $67d053767afbcfb0$export$2e2bcd8739ae039)(values);
    return c && d ? Math.ceil((max - min) * Math.cbrt(c) / (3.49 * d)) : 1;
}





function $7ddf432de505a4dc$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}



function $6a40b4b9e100e776$export$2e2bcd8739ae039(values, valueof) {
    return (0, $058a580f1d366c99$export$2e2bcd8739ae039)(values, 0.5, valueof);
}
function $6a40b4b9e100e776$export$57546ab4fd3c7a5e(values, valueof) {
    return (0, $058a580f1d366c99$export$f1fcc854ecc6ce55)(values, 0.5, valueof);
}


function* $6341023b666029a7$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $6341023b666029a7$export$2e2bcd8739ae039(arrays) {
    return Array.from($6341023b666029a7$var$flatten(arrays));
}





function $6e487b69bbe1c75a$export$2e2bcd8739ae039(values, valueof) {
    const counts = new (0, $1565c3f84209a139$export$dcc6fb7d82b5bc7b)();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}



function $22f93d164c9f5d36$export$2e2bcd8739ae039(values, pairof = $22f93d164c9f5d36$export$a04cb3fe8b81dd) {
    const pairs = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs;
}
function $22f93d164c9f5d36$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}





function $e4dbde6ec669fccd$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}




function $c60d74e2a9330f2b$export$2e2bcd8739ae039(values, valueof = (0, $f64c55ab13ca9913$export$2e2bcd8739ae039)) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = (0, $f64c55ab13ca9913$export$2e2bcd8739ae039);
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    values = Uint32Array.from(V, (_, i)=>i);
    // Risky chaining due to Safari 14 https://github.com/d3/d3-array/issues/123
    values.sort(valueof === (0, $f64c55ab13ca9913$export$2e2bcd8739ae039) ? (i, j)=>(0, $6f30b441ad7a113f$export$686e14b8469efec4)(V[i], V[j]) : (0, $6f30b441ad7a113f$export$5708b2c031939e56)(compareIndex));
    values.forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}



function $d946f525fcb687dc$export$2e2bcd8739ae039(values, compare = (0, $f64c55ab13ca9913$export$2e2bcd8739ae039)) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $f64c55ab13ca9913$export$2e2bcd8739ae039)(value, minValue) < 0 : (0, $f64c55ab13ca9913$export$2e2bcd8739ae039)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}




function $17137e49b6270194$export$2e2bcd8739ae039(values, compare = (0, $f64c55ab13ca9913$export$2e2bcd8739ae039)) {
    if (compare.length === 1) return (0, $44b878b2518322a8$export$2e2bcd8739ae039)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}





function $72a32bc84d2e3f54$export$2e2bcd8739ae039(values, compare = (0, $f64c55ab13ca9913$export$2e2bcd8739ae039)) {
    if (compare.length === 1) return (0, $aabaa0ca6e97cbe2$export$2e2bcd8739ae039)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}



function $16b080726d96aeaf$export$2e2bcd8739ae039(values, compare) {
    const index = (0, $17137e49b6270194$export$2e2bcd8739ae039)(values, compare);
    return index < 0 ? undefined : index;
}


var $09aa46897db2fb54$export$2e2bcd8739ae039 = $09aa46897db2fb54$export$a430ea578c95d356(Math.random);
function $09aa46897db2fb54$export$a430ea578c95d356(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}


function $2ab268eff5ee0033$export$2e2bcd8739ae039(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}




function $f9b8d6b640b443c5$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $1110482c2879adab$export$2e2bcd8739ae039)(matrix, $f9b8d6b640b443c5$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $f9b8d6b640b443c5$var$length(d) {
    return d.length;
}




function $8ce2aba54db49350$export$2e2bcd8739ae039() {
    return (0, $f9b8d6b640b443c5$export$2e2bcd8739ae039)(arguments);
}


function $fcef2b6a367d44cb$export$2e2bcd8739ae039(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}


function $ccc5fd93232e02e3$export$2e2bcd8739ae039(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}


function $fbf82e41ba141931$export$2e2bcd8739ae039(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}


function $e174c94416ec168c$export$2e2bcd8739ae039(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}


function $f1146cac7d5ba9b3$export$2e2bcd8739ae039(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}


function $15cdfea54388641a$export$2e2bcd8739ae039(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}




function $b669dc05423acfc8$export$2e2bcd8739ae039(values, ...others) {
    values = new (0, $1565c3f84209a139$export$55278c3294239828)(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}



function $49822c8e3c2d52ca$export$2e2bcd8739ae039(values, other) {
    const iterator = other[Symbol.iterator](), set = new (0, $1565c3f84209a139$export$55278c3294239828)();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}



function $350c0faa8b97fdcf$export$2e2bcd8739ae039(values, ...others) {
    values = new (0, $1565c3f84209a139$export$55278c3294239828)(values);
    others = others.map($350c0faa8b97fdcf$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $350c0faa8b97fdcf$var$set(values) {
    return values instanceof (0, $1565c3f84209a139$export$55278c3294239828) ? values : new (0, $1565c3f84209a139$export$55278c3294239828)(values);
}


function $9cf973f3ac1fdcf0$export$2e2bcd8739ae039(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $9cf973f3ac1fdcf0$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $9cf973f3ac1fdcf0$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $9cf973f3ac1fdcf0$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}


function $2a902786db480752$export$2e2bcd8739ae039(values, other) {
    return (0, $9cf973f3ac1fdcf0$export$2e2bcd8739ae039)(other, values);
}




function $b5a88d212a54c510$export$2e2bcd8739ae039(...others) {
    const set = new (0, $1565c3f84209a139$export$55278c3294239828)();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}





var $277c79f82b28ccb6$exports = {};

$parcel$export($277c79f82b28ccb6$exports, "axisTop", () => $fcde3119b7ee4695$export$59b8cfab074bdeb1);
$parcel$export($277c79f82b28ccb6$exports, "axisRight", () => $fcde3119b7ee4695$export$b0d2e24dc4f898f0);
$parcel$export($277c79f82b28ccb6$exports, "axisBottom", () => $fcde3119b7ee4695$export$e5cb22533a15e72e);
$parcel$export($277c79f82b28ccb6$exports, "axisLeft", () => $fcde3119b7ee4695$export$2749afb169a520d2);
function $66a5f6e2e251287e$export$2e2bcd8739ae039(x) {
    return x;
}


var $fcde3119b7ee4695$var$top = 1, $fcde3119b7ee4695$var$right = 2, $fcde3119b7ee4695$var$bottom = 3, $fcde3119b7ee4695$var$left = 4, $fcde3119b7ee4695$var$epsilon = 1e-6;
function $fcde3119b7ee4695$var$translateX(x) {
    return "translate(" + x + ",0)";
}
function $fcde3119b7ee4695$var$translateY(y) {
    return "translate(0," + y + ")";
}
function $fcde3119b7ee4695$var$number(scale) {
    return (d)=>+scale(d);
}
function $fcde3119b7ee4695$var$center(scale, offset) {
    offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
    if (scale.round()) offset = Math.round(offset);
    return (d)=>+scale(d) + offset;
}
function $fcde3119b7ee4695$var$entering() {
    return !this.__axis;
}
function $fcde3119b7ee4695$var$axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === $fcde3119b7ee4695$var$top || orient === $fcde3119b7ee4695$var$left ? -1 : 1, x = orient === $fcde3119b7ee4695$var$left || orient === $fcde3119b7ee4695$var$right ? "x" : "y", transform = orient === $fcde3119b7ee4695$var$top || orient === $fcde3119b7ee4695$var$bottom ? $fcde3119b7ee4695$var$translateX : $fcde3119b7ee4695$var$translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, $66a5f6e2e251287e$export$2e2bcd8739ae039) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? $fcde3119b7ee4695$var$center : $fcde3119b7ee4695$var$number)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === $fcde3119b7ee4695$var$top ? "0em" : orient === $fcde3119b7ee4695$var$bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", $fcde3119b7ee4695$var$epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", $fcde3119b7ee4695$var$epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
            });
        }
        tickExit.remove();
        path.attr("d", orient === $fcde3119b7ee4695$var$left || orient === $fcde3119b7ee4695$var$right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d) + offset);
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter($fcde3119b7ee4695$var$entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === $fcde3119b7ee4695$var$right ? "start" : orient === $fcde3119b7ee4695$var$left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = Array.from(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    axis.offset = function(_) {
        return arguments.length ? (offset = +_, axis) : offset;
    };
    return axis;
}
function $fcde3119b7ee4695$export$59b8cfab074bdeb1(scale) {
    return $fcde3119b7ee4695$var$axis($fcde3119b7ee4695$var$top, scale);
}
function $fcde3119b7ee4695$export$b0d2e24dc4f898f0(scale) {
    return $fcde3119b7ee4695$var$axis($fcde3119b7ee4695$var$right, scale);
}
function $fcde3119b7ee4695$export$e5cb22533a15e72e(scale) {
    return $fcde3119b7ee4695$var$axis($fcde3119b7ee4695$var$bottom, scale);
}
function $fcde3119b7ee4695$export$2749afb169a520d2(scale) {
    return $fcde3119b7ee4695$var$axis($fcde3119b7ee4695$var$left, scale);
}




var $61be40fcd0bd3059$exports = {};

$parcel$export($61be40fcd0bd3059$exports, "brush", () => $d5efb4258115f400$export$2e2bcd8739ae039);
$parcel$export($61be40fcd0bd3059$exports, "brushX", () => $d5efb4258115f400$export$979ace6c88860aa8);
$parcel$export($61be40fcd0bd3059$exports, "brushY", () => $d5efb4258115f400$export$468748b530991c54);
$parcel$export($61be40fcd0bd3059$exports, "brushSelection", () => $d5efb4258115f400$export$69760394fc76f689);
var $cfaa4969c311d138$var$noop = {
    value: ()=>{}
};
function $cfaa4969c311d138$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $cfaa4969c311d138$var$Dispatch(_);
}
function $cfaa4969c311d138$var$Dispatch(_) {
    this._ = _;
}
function $cfaa4969c311d138$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$cfaa4969c311d138$var$Dispatch.prototype = $cfaa4969c311d138$var$dispatch.prototype = {
    constructor: $cfaa4969c311d138$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $cfaa4969c311d138$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $cfaa4969c311d138$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $cfaa4969c311d138$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $cfaa4969c311d138$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $cfaa4969c311d138$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $cfaa4969c311d138$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $cfaa4969c311d138$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $cfaa4969c311d138$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $cfaa4969c311d138$export$2e2bcd8739ae039 = $cfaa4969c311d138$var$dispatch;



function $90fcd2cfb31c5c0b$var$none() {}
function $90fcd2cfb31c5c0b$export$2e2bcd8739ae039(selector) {
    return selector == null ? $90fcd2cfb31c5c0b$var$none : function() {
        return this.querySelector(selector);
    };
}


function $f0ecf74bb2a5bd06$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $90fcd2cfb31c5c0b$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $c7a3341731fa3134$export$52baac22726c72bf)(subgroups, this._parents);
}



// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $ba07a0cf1948a8eb$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}


function $52a7a1b454645792$var$empty() {
    return [];
}
function $52a7a1b454645792$export$2e2bcd8739ae039(selector) {
    return selector == null ? $52a7a1b454645792$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $8e7e8960067b5d07$var$arrayAll(select) {
    return function() {
        return (0, $ba07a0cf1948a8eb$export$2e2bcd8739ae039)(select.apply(this, arguments));
    };
}
function $8e7e8960067b5d07$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $8e7e8960067b5d07$var$arrayAll(select);
    else select = (0, $52a7a1b454645792$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $c7a3341731fa3134$export$52baac22726c72bf)(subgroups, parents);
}


function $0f1039f38e52fb7d$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $0f1039f38e52fb7d$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}


var $bb463a9397326c9e$var$find = Array.prototype.find;
function $bb463a9397326c9e$var$childFind(match) {
    return function() {
        return $bb463a9397326c9e$var$find.call(this.children, match);
    };
}
function $bb463a9397326c9e$var$childFirst() {
    return this.firstElementChild;
}
function $bb463a9397326c9e$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $bb463a9397326c9e$var$childFirst : $bb463a9397326c9e$var$childFind(typeof match === "function" ? match : (0, $0f1039f38e52fb7d$export$90c2759c036528)(match)));
}



var $ae438e35bbd83734$var$filter = Array.prototype.filter;
function $ae438e35bbd83734$var$children() {
    return Array.from(this.children);
}
function $ae438e35bbd83734$var$childrenFilter(match) {
    return function() {
        return $ae438e35bbd83734$var$filter.call(this.children, match);
    };
}
function $ae438e35bbd83734$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $ae438e35bbd83734$var$children : $ae438e35bbd83734$var$childrenFilter(typeof match === "function" ? match : (0, $0f1039f38e52fb7d$export$90c2759c036528)(match)));
}




function $abbab8ee29edcdea$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $0f1039f38e52fb7d$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $c7a3341731fa3134$export$52baac22726c72bf)(subgroups, this._parents);
}



function $6e0246af0349ced2$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $9747d4bbb7847ef2$export$2e2bcd8739ae039() {
    return new (0, $c7a3341731fa3134$export$52baac22726c72bf)(this._enter || this._groups.map((0, $6e0246af0349ced2$export$2e2bcd8739ae039)), this._parents);
}
function $9747d4bbb7847ef2$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$9747d4bbb7847ef2$export$67b01759a14cf6a4.prototype = {
    constructor: $9747d4bbb7847ef2$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $ba4acac99da02bbb$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $dab9fdc00c497d8f$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $9747d4bbb7847ef2$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $dab9fdc00c497d8f$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $9747d4bbb7847ef2$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $dab9fdc00c497d8f$var$datum(node) {
    return node.__data__;
}
function $dab9fdc00c497d8f$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $dab9fdc00c497d8f$var$datum);
    var bind = key ? $dab9fdc00c497d8f$var$bindKey : $dab9fdc00c497d8f$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $ba4acac99da02bbb$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $dab9fdc00c497d8f$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $c7a3341731fa3134$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $dab9fdc00c497d8f$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}





function $7f52a4d435d02449$export$2e2bcd8739ae039() {
    return new (0, $c7a3341731fa3134$export$52baac22726c72bf)(this._exit || this._groups.map((0, $6e0246af0349ced2$export$2e2bcd8739ae039)), this._parents);
}


function $f4ec982fcd47fcc2$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $fb1dd5a16a392471$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $c7a3341731fa3134$export$52baac22726c72bf)(merges, this._parents);
}


function $573c552b927523a2$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $4825f799aa857e3b$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $4825f799aa857e3b$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $c7a3341731fa3134$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $4825f799aa857e3b$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $ee95ea18884f476e$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $0bbf80b40bde1774$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $b241347273b76b06$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $fd1e661fbd912067$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}


function $a284ae34d9d38caa$export$2e2bcd8739ae039() {
    return !this.node();
}


function $ca2462bc87140d2c$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $a3b29abb9e79fdd3$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $a3b29abb9e79fdd3$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $a3b29abb9e79fdd3$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $19191a1b5ffaa8c1$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $a3b29abb9e79fdd3$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $a3b29abb9e79fdd3$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}


function $1b9f9a2acd6315a4$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $1b9f9a2acd6315a4$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $1b9f9a2acd6315a4$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $1b9f9a2acd6315a4$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $1b9f9a2acd6315a4$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $1b9f9a2acd6315a4$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $1b9f9a2acd6315a4$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $19191a1b5ffaa8c1$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $1b9f9a2acd6315a4$var$attrRemoveNS : $1b9f9a2acd6315a4$var$attrRemove : typeof value === "function" ? fullname.local ? $1b9f9a2acd6315a4$var$attrFunctionNS : $1b9f9a2acd6315a4$var$attrFunction : fullname.local ? $1b9f9a2acd6315a4$var$attrConstantNS : $1b9f9a2acd6315a4$var$attrConstant)(fullname, value));
}


function $b5c39d7204a2477a$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $8dc8fef8928e5abd$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $8dc8fef8928e5abd$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $8dc8fef8928e5abd$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $8dc8fef8928e5abd$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $8dc8fef8928e5abd$var$styleRemove : typeof value === "function" ? $8dc8fef8928e5abd$var$styleFunction : $8dc8fef8928e5abd$var$styleConstant)(name, value, priority == null ? "" : priority)) : $8dc8fef8928e5abd$export$5e3cec964f0b5efd(this.node(), name);
}
function $8dc8fef8928e5abd$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $b5c39d7204a2477a$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $622251064130cc61$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $622251064130cc61$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $622251064130cc61$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $622251064130cc61$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $622251064130cc61$var$propertyRemove : typeof value === "function" ? $622251064130cc61$var$propertyFunction : $622251064130cc61$var$propertyConstant)(name, value)) : this.node()[name];
}


function $11d6e3df745f9168$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $11d6e3df745f9168$var$classList(node) {
    return node.classList || new $11d6e3df745f9168$var$ClassList(node);
}
function $11d6e3df745f9168$var$ClassList(node) {
    this._node = node;
    this._names = $11d6e3df745f9168$var$classArray(node.getAttribute("class") || "");
}
$11d6e3df745f9168$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $11d6e3df745f9168$var$classedAdd(node, names) {
    var list = $11d6e3df745f9168$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $11d6e3df745f9168$var$classedRemove(node, names) {
    var list = $11d6e3df745f9168$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $11d6e3df745f9168$var$classedTrue(names) {
    return function() {
        $11d6e3df745f9168$var$classedAdd(this, names);
    };
}
function $11d6e3df745f9168$var$classedFalse(names) {
    return function() {
        $11d6e3df745f9168$var$classedRemove(this, names);
    };
}
function $11d6e3df745f9168$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $11d6e3df745f9168$var$classedAdd : $11d6e3df745f9168$var$classedRemove)(this, names);
    };
}
function $11d6e3df745f9168$export$2e2bcd8739ae039(name, value) {
    var names = $11d6e3df745f9168$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $11d6e3df745f9168$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $11d6e3df745f9168$var$classedFunction : value ? $11d6e3df745f9168$var$classedTrue : $11d6e3df745f9168$var$classedFalse)(names, value));
}


function $faa417fb8ac15983$var$textRemove() {
    this.textContent = "";
}
function $faa417fb8ac15983$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $faa417fb8ac15983$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $faa417fb8ac15983$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $faa417fb8ac15983$var$textRemove : (typeof value === "function" ? $faa417fb8ac15983$var$textFunction : $faa417fb8ac15983$var$textConstant)(value)) : this.node().textContent;
}


function $d28b9a0bf8540ec8$var$htmlRemove() {
    this.innerHTML = "";
}
function $d28b9a0bf8540ec8$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $d28b9a0bf8540ec8$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $d28b9a0bf8540ec8$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $d28b9a0bf8540ec8$var$htmlRemove : (typeof value === "function" ? $d28b9a0bf8540ec8$var$htmlFunction : $d28b9a0bf8540ec8$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $94036021d6aaf4f6$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $94036021d6aaf4f6$export$2e2bcd8739ae039() {
    return this.each($94036021d6aaf4f6$var$raise);
}


function $fc4a3484faf40886$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $fc4a3484faf40886$export$2e2bcd8739ae039() {
    return this.each($fc4a3484faf40886$var$lower);
}




function $a5c2223f44c4b5b7$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $a3b29abb9e79fdd3$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $a3b29abb9e79fdd3$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $a5c2223f44c4b5b7$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $a5c2223f44c4b5b7$export$2e2bcd8739ae039(name) {
    var fullname = (0, $19191a1b5ffaa8c1$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $a5c2223f44c4b5b7$var$creatorFixed : $a5c2223f44c4b5b7$var$creatorInherit)(fullname);
}


function $6d771da4270af993$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $a5c2223f44c4b5b7$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $7b36ca0a23c64558$var$constantNull() {
    return null;
}
function $7b36ca0a23c64558$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $a5c2223f44c4b5b7$export$2e2bcd8739ae039)(name), select = before == null ? $7b36ca0a23c64558$var$constantNull : typeof before === "function" ? before : (0, $90fcd2cfb31c5c0b$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $df2d6c42bc4b6869$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $df2d6c42bc4b6869$export$2e2bcd8739ae039() {
    return this.each($df2d6c42bc4b6869$var$remove);
}


function $2e751fad79ae8c93$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $2e751fad79ae8c93$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $2e751fad79ae8c93$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $2e751fad79ae8c93$var$selection_cloneDeep : $2e751fad79ae8c93$var$selection_cloneShallow);
}


function $61bbfd6f327be577$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


function $f7a7e99f395002f8$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $f7a7e99f395002f8$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $f7a7e99f395002f8$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $f7a7e99f395002f8$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $f7a7e99f395002f8$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $f7a7e99f395002f8$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $f7a7e99f395002f8$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $f7a7e99f395002f8$var$onAdd : $f7a7e99f395002f8$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}



function $584338c580de444d$var$dispatchEvent(node, type, params) {
    var window = (0, $b5c39d7204a2477a$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $584338c580de444d$var$dispatchConstant(type, params) {
    return function() {
        return $584338c580de444d$var$dispatchEvent(this, type, params);
    };
}
function $584338c580de444d$var$dispatchFunction(type, params) {
    return function() {
        return $584338c580de444d$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $584338c580de444d$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $584338c580de444d$var$dispatchFunction : $584338c580de444d$var$dispatchConstant)(type, params));
}


function* $fde77b7d7dfd94ff$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}


var $c7a3341731fa3134$export$e8e78c978b129247 = [
    null
];
function $c7a3341731fa3134$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $c7a3341731fa3134$var$selection() {
    return new $c7a3341731fa3134$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $c7a3341731fa3134$export$e8e78c978b129247);
}
function $c7a3341731fa3134$var$selection_selection() {
    return this;
}
$c7a3341731fa3134$export$52baac22726c72bf.prototype = $c7a3341731fa3134$var$selection.prototype = {
    constructor: $c7a3341731fa3134$export$52baac22726c72bf,
    select: (0, $f0ecf74bb2a5bd06$export$2e2bcd8739ae039),
    selectAll: (0, $8e7e8960067b5d07$export$2e2bcd8739ae039),
    selectChild: (0, $bb463a9397326c9e$export$2e2bcd8739ae039),
    selectChildren: (0, $ae438e35bbd83734$export$2e2bcd8739ae039),
    filter: (0, $abbab8ee29edcdea$export$2e2bcd8739ae039),
    data: (0, $dab9fdc00c497d8f$export$2e2bcd8739ae039),
    enter: (0, $9747d4bbb7847ef2$export$2e2bcd8739ae039),
    exit: (0, $7f52a4d435d02449$export$2e2bcd8739ae039),
    join: (0, $f4ec982fcd47fcc2$export$2e2bcd8739ae039),
    merge: (0, $fb1dd5a16a392471$export$2e2bcd8739ae039),
    selection: $c7a3341731fa3134$var$selection_selection,
    order: (0, $573c552b927523a2$export$2e2bcd8739ae039),
    sort: (0, $4825f799aa857e3b$export$2e2bcd8739ae039),
    call: (0, $ee95ea18884f476e$export$2e2bcd8739ae039),
    nodes: (0, $0bbf80b40bde1774$export$2e2bcd8739ae039),
    node: (0, $b241347273b76b06$export$2e2bcd8739ae039),
    size: (0, $fd1e661fbd912067$export$2e2bcd8739ae039),
    empty: (0, $a284ae34d9d38caa$export$2e2bcd8739ae039),
    each: (0, $ca2462bc87140d2c$export$2e2bcd8739ae039),
    attr: (0, $1b9f9a2acd6315a4$export$2e2bcd8739ae039),
    style: (0, $8dc8fef8928e5abd$export$2e2bcd8739ae039),
    property: (0, $622251064130cc61$export$2e2bcd8739ae039),
    classed: (0, $11d6e3df745f9168$export$2e2bcd8739ae039),
    text: (0, $faa417fb8ac15983$export$2e2bcd8739ae039),
    html: (0, $d28b9a0bf8540ec8$export$2e2bcd8739ae039),
    raise: (0, $94036021d6aaf4f6$export$2e2bcd8739ae039),
    lower: (0, $fc4a3484faf40886$export$2e2bcd8739ae039),
    append: (0, $6d771da4270af993$export$2e2bcd8739ae039),
    insert: (0, $7b36ca0a23c64558$export$2e2bcd8739ae039),
    remove: (0, $df2d6c42bc4b6869$export$2e2bcd8739ae039),
    clone: (0, $2e751fad79ae8c93$export$2e2bcd8739ae039),
    datum: (0, $61bbfd6f327be577$export$2e2bcd8739ae039),
    on: (0, $f7a7e99f395002f8$export$2e2bcd8739ae039),
    dispatch: (0, $584338c580de444d$export$2e2bcd8739ae039),
    [Symbol.iterator]: (0, $fde77b7d7dfd94ff$export$2e2bcd8739ae039)
};
var $c7a3341731fa3134$export$2e2bcd8739ae039 = $c7a3341731fa3134$var$selection;


function $c38382a82e61d17a$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $c7a3341731fa3134$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $c7a3341731fa3134$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $c7a3341731fa3134$export$e8e78c978b129247));
}


// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
const $7023336a67ab2e82$export$524615cd03e458cc = {
    passive: false
};
const $7023336a67ab2e82$export$35431a0e47022de1 = {
    capture: true,
    passive: false
};
function $7023336a67ab2e82$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $7023336a67ab2e82$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


function $2cf643e39b411f06$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $c38382a82e61d17a$export$2e2bcd8739ae039)(view).on("dragstart.drag", (0, $7023336a67ab2e82$export$2e2bcd8739ae039), (0, $7023336a67ab2e82$export$35431a0e47022de1));
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $7023336a67ab2e82$export$2e2bcd8739ae039), (0, $7023336a67ab2e82$export$35431a0e47022de1));
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $2cf643e39b411f06$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $c38382a82e61d17a$export$2e2bcd8739ae039)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $7023336a67ab2e82$export$2e2bcd8739ae039), (0, $7023336a67ab2e82$export$35431a0e47022de1));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}



var $gisW9 = parcelRequire("gisW9");

var $gisW9 = parcelRequire("gisW9");
function $4102a56c61d8399a$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $4102a56c61d8399a$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $4102a56c61d8399a$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $b3f75379502ead17$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $4102a56c61d8399a$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $59363326efdc582f$export$2e2bcd8739ae039 = (x)=>()=>x;


function $52257f64b25d794c$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $52257f64b25d794c$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $52257f64b25d794c$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $52257f64b25d794c$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $59363326efdc582f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $52257f64b25d794c$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $52257f64b25d794c$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $52257f64b25d794c$var$exponential(a, b, y) : (0, $59363326efdc582f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $52257f64b25d794c$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $52257f64b25d794c$var$linear(a, d) : (0, $59363326efdc582f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $71264ae493339a33$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $52257f64b25d794c$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $gisW9.rgb)(start)).r, (end = (0, $gisW9.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $52257f64b25d794c$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $71264ae493339a33$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $gisW9.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $71264ae493339a33$export$2c0e28f2e2852d3f = $71264ae493339a33$var$rgbSpline((0, $4102a56c61d8399a$export$2e2bcd8739ae039));
var $71264ae493339a33$export$53d5214f625ccd4c = $71264ae493339a33$var$rgbSpline((0, $b3f75379502ead17$export$2e2bcd8739ae039));



function $96579e3589354e98$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $96579e3589354e98$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $08bd73eb67b4a221$export$2e2bcd8739ae039(a, b) {
    return ((0, $96579e3589354e98$export$5cd576d1827d40c8)(b) ? (0, $96579e3589354e98$export$2e2bcd8739ae039) : $08bd73eb67b4a221$export$15d09067c6a5ee49)(a, b);
}
function $08bd73eb67b4a221$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $fdef680a1ac134b1$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $91f1193a05630492$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $aa9385f41bac0020$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $bbe5d1c2c2bbd2fa$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $fdef680a1ac134b1$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $18136aa94f9d1484$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $18136aa94f9d1484$var$reB = new RegExp($18136aa94f9d1484$var$reA.source, "g");
function $18136aa94f9d1484$var$zero(b) {
    return function() {
        return b;
    };
}
function $18136aa94f9d1484$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $18136aa94f9d1484$export$2e2bcd8739ae039(a, b) {
    var bi = $18136aa94f9d1484$var$reA.lastIndex = $18136aa94f9d1484$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $18136aa94f9d1484$var$reA.exec(a)) && (bm = $18136aa94f9d1484$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $aa9385f41bac0020$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $18136aa94f9d1484$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $18136aa94f9d1484$var$one(q[0].x) : $18136aa94f9d1484$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $fdef680a1ac134b1$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $59363326efdc582f$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $aa9385f41bac0020$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $gisW9.default)(b)) ? (b = c, $71264ae493339a33$export$2e2bcd8739ae039) : (0, $18136aa94f9d1484$export$2e2bcd8739ae039) : b instanceof (0, $gisW9.default) ? (0, $71264ae493339a33$export$2e2bcd8739ae039) : b instanceof Date ? (0, $91f1193a05630492$export$2e2bcd8739ae039) : (0, $96579e3589354e98$export$5cd576d1827d40c8)(b) ? (0, $96579e3589354e98$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $08bd73eb67b4a221$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $bbe5d1c2c2bbd2fa$export$2e2bcd8739ae039) : (0, $aa9385f41bac0020$export$2e2bcd8739ae039))(a, b);
}


function $35308b9a8dd4304c$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}


function $01126f29f8cc9cfb$export$2e2bcd8739ae039(event, node) {
    event = (0, $35308b9a8dd4304c$export$2e2bcd8739ae039)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}


var $984dbdbcfb5f6759$exports = {};

$parcel$export($984dbdbcfb5f6759$exports, "transition", () => $ca531d477b956dfc$export$2e2bcd8739ae039);
$parcel$export($984dbdbcfb5f6759$exports, "active", () => $76948324d72da979$export$2e2bcd8739ae039);
$parcel$export($984dbdbcfb5f6759$exports, "interrupt", () => $fd4ea3403db5c867$export$2e2bcd8739ae039);


var $30ea27ad4ddf4734$var$frame = 0, $30ea27ad4ddf4734$var$timeout = 0, $30ea27ad4ddf4734$var$interval = 0, $30ea27ad4ddf4734$var$pokeDelay = 1000, $30ea27ad4ddf4734$var$taskHead, $30ea27ad4ddf4734$var$taskTail, $30ea27ad4ddf4734$var$clockLast = 0, $30ea27ad4ddf4734$var$clockNow = 0, $30ea27ad4ddf4734$var$clockSkew = 0, $30ea27ad4ddf4734$var$clock = typeof performance === "object" && performance.now ? performance : Date, $30ea27ad4ddf4734$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $30ea27ad4ddf4734$export$461939dd4422153() {
    return $30ea27ad4ddf4734$var$clockNow || ($30ea27ad4ddf4734$var$setFrame($30ea27ad4ddf4734$var$clearNow), $30ea27ad4ddf4734$var$clockNow = $30ea27ad4ddf4734$var$clock.now() + $30ea27ad4ddf4734$var$clockSkew);
}
function $30ea27ad4ddf4734$var$clearNow() {
    $30ea27ad4ddf4734$var$clockNow = 0;
}
function $30ea27ad4ddf4734$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$30ea27ad4ddf4734$export$c57e9b2d8b9e4de.prototype = $30ea27ad4ddf4734$export$9dc4ecf953986f04.prototype = {
    constructor: $30ea27ad4ddf4734$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $30ea27ad4ddf4734$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $30ea27ad4ddf4734$var$taskTail !== this) {
            if ($30ea27ad4ddf4734$var$taskTail) $30ea27ad4ddf4734$var$taskTail._next = this;
            else $30ea27ad4ddf4734$var$taskHead = this;
            $30ea27ad4ddf4734$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $30ea27ad4ddf4734$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $30ea27ad4ddf4734$var$sleep();
        }
    }
};
function $30ea27ad4ddf4734$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $30ea27ad4ddf4734$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $30ea27ad4ddf4734$export$d60154c1d7f3990e() {
    $30ea27ad4ddf4734$export$461939dd4422153(); // Get the current time, if not already set.
    ++$30ea27ad4ddf4734$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $30ea27ad4ddf4734$var$taskHead, e;
    while(t){
        if ((e = $30ea27ad4ddf4734$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$30ea27ad4ddf4734$var$frame;
}
function $30ea27ad4ddf4734$var$wake() {
    $30ea27ad4ddf4734$var$clockNow = ($30ea27ad4ddf4734$var$clockLast = $30ea27ad4ddf4734$var$clock.now()) + $30ea27ad4ddf4734$var$clockSkew;
    $30ea27ad4ddf4734$var$frame = $30ea27ad4ddf4734$var$timeout = 0;
    try {
        $30ea27ad4ddf4734$export$d60154c1d7f3990e();
    } finally{
        $30ea27ad4ddf4734$var$frame = 0;
        $30ea27ad4ddf4734$var$nap();
        $30ea27ad4ddf4734$var$clockNow = 0;
    }
}
function $30ea27ad4ddf4734$var$poke() {
    var now = $30ea27ad4ddf4734$var$clock.now(), delay = now - $30ea27ad4ddf4734$var$clockLast;
    if (delay > $30ea27ad4ddf4734$var$pokeDelay) $30ea27ad4ddf4734$var$clockSkew -= delay, $30ea27ad4ddf4734$var$clockLast = now;
}
function $30ea27ad4ddf4734$var$nap() {
    var t0, t1 = $30ea27ad4ddf4734$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $30ea27ad4ddf4734$var$taskHead = t2;
    }
    $30ea27ad4ddf4734$var$taskTail = t0;
    $30ea27ad4ddf4734$var$sleep(time);
}
function $30ea27ad4ddf4734$var$sleep(time) {
    if ($30ea27ad4ddf4734$var$frame) return; // Soonest alarm already set, or will be.
    if ($30ea27ad4ddf4734$var$timeout) $30ea27ad4ddf4734$var$timeout = clearTimeout($30ea27ad4ddf4734$var$timeout);
    var delay = time - $30ea27ad4ddf4734$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $30ea27ad4ddf4734$var$timeout = setTimeout($30ea27ad4ddf4734$var$wake, time - $30ea27ad4ddf4734$var$clock.now() - $30ea27ad4ddf4734$var$clockSkew);
        if ($30ea27ad4ddf4734$var$interval) $30ea27ad4ddf4734$var$interval = clearInterval($30ea27ad4ddf4734$var$interval);
    } else {
        if (!$30ea27ad4ddf4734$var$interval) $30ea27ad4ddf4734$var$clockLast = $30ea27ad4ddf4734$var$clock.now(), $30ea27ad4ddf4734$var$interval = setInterval($30ea27ad4ddf4734$var$poke, $30ea27ad4ddf4734$var$pokeDelay);
        $30ea27ad4ddf4734$var$frame = 1, $30ea27ad4ddf4734$var$setFrame($30ea27ad4ddf4734$var$wake);
    }
}


function $f984208cdff58421$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $30ea27ad4ddf4734$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $aef1e5adfcb3a330$var$emptyOn = (0, $cfaa4969c311d138$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $aef1e5adfcb3a330$var$emptyTween = [];
var $aef1e5adfcb3a330$export$ff39ebd4bb12b718 = 0;
var $aef1e5adfcb3a330$export$584530fe98d14a84 = 1;
var $aef1e5adfcb3a330$export$a5d151aee16efd42 = 2;
var $aef1e5adfcb3a330$export$fb935ab5849a0db9 = 3;
var $aef1e5adfcb3a330$export$1573e22b087389af = 4;
var $aef1e5adfcb3a330$export$a2e792214ded83b2 = 5;
var $aef1e5adfcb3a330$export$9d38167254403955 = 6;
function $aef1e5adfcb3a330$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $aef1e5adfcb3a330$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $aef1e5adfcb3a330$var$emptyOn,
        tween: $aef1e5adfcb3a330$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $aef1e5adfcb3a330$export$ff39ebd4bb12b718
    });
}
function $aef1e5adfcb3a330$export$2cd8252107eb640b(node, id) {
    var schedule = $aef1e5adfcb3a330$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $aef1e5adfcb3a330$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $aef1e5adfcb3a330$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $aef1e5adfcb3a330$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $aef1e5adfcb3a330$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $aef1e5adfcb3a330$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $aef1e5adfcb3a330$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $30ea27ad4ddf4734$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $aef1e5adfcb3a330$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $aef1e5adfcb3a330$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $aef1e5adfcb3a330$export$fb935ab5849a0db9) return (0, $f984208cdff58421$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $aef1e5adfcb3a330$export$1573e22b087389af) {
                o.state = $aef1e5adfcb3a330$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $aef1e5adfcb3a330$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $f984208cdff58421$export$2e2bcd8739ae039)(function() {
            if (self.state === $aef1e5adfcb3a330$export$fb935ab5849a0db9) {
                self.state = $aef1e5adfcb3a330$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $aef1e5adfcb3a330$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $aef1e5adfcb3a330$export$a5d151aee16efd42) return; // interrupted
        self.state = $aef1e5adfcb3a330$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $aef1e5adfcb3a330$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $aef1e5adfcb3a330$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $aef1e5adfcb3a330$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $fd4ea3403db5c867$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $aef1e5adfcb3a330$export$a5d151aee16efd42) && schedule.state < (0, $aef1e5adfcb3a330$export$a2e792214ded83b2);
        schedule.state = (0, $aef1e5adfcb3a330$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $d05c54c38f75b5b2$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $fd4ea3403db5c867$export$2e2bcd8739ae039)(this, name);
    });
}




var $cc9b062100834d94$var$degrees = 180 / Math.PI;
var $cc9b062100834d94$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $cc9b062100834d94$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $cc9b062100834d94$var$degrees,
        skewX: Math.atan(skewX) * $cc9b062100834d94$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $f3eee3ceba9e7fd7$var$svgNode;
function $f3eee3ceba9e7fd7$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $cc9b062100834d94$export$f0954fd7d5368655) : (0, $cc9b062100834d94$export$2e2bcd8739ae039)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $f3eee3ceba9e7fd7$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $cc9b062100834d94$export$f0954fd7d5368655;
    if (!$f3eee3ceba9e7fd7$var$svgNode) $f3eee3ceba9e7fd7$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $f3eee3ceba9e7fd7$var$svgNode.setAttribute("transform", value);
    if (!(value = $f3eee3ceba9e7fd7$var$svgNode.transform.baseVal.consolidate())) return 0, $cc9b062100834d94$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $cc9b062100834d94$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $d32f3373a01276ef$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $aa9385f41bac0020$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $aa9385f41bac0020$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $aa9385f41bac0020$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $aa9385f41bac0020$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $aa9385f41bac0020$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $aa9385f41bac0020$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $d32f3373a01276ef$export$56bec7123bb3589a = $d32f3373a01276ef$var$interpolateTransform((0, $f3eee3ceba9e7fd7$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $d32f3373a01276ef$export$da8cba906d64c082 = $d32f3373a01276ef$var$interpolateTransform((0, $f3eee3ceba9e7fd7$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $972c1de6adf52838$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $aef1e5adfcb3a330$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $972c1de6adf52838$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $aef1e5adfcb3a330$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $972c1de6adf52838$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $aef1e5adfcb3a330$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $972c1de6adf52838$var$tweenRemove : $972c1de6adf52838$var$tweenFunction)(id, name, value));
}
function $972c1de6adf52838$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $aef1e5adfcb3a330$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $aef1e5adfcb3a330$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $gisW9 = parcelRequire("gisW9");

function $6a934eada5bd0381$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $aa9385f41bac0020$export$2e2bcd8739ae039) : b instanceof (0, $gisW9.default) ? (0, $71264ae493339a33$export$2e2bcd8739ae039) : (c = (0, $gisW9.default)(b)) ? (b = c, $71264ae493339a33$export$2e2bcd8739ae039) : (0, $18136aa94f9d1484$export$2e2bcd8739ae039))(a, b);
}


function $8f59c2a26292bd01$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $8f59c2a26292bd01$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $8f59c2a26292bd01$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $8f59c2a26292bd01$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $8f59c2a26292bd01$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $8f59c2a26292bd01$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $8f59c2a26292bd01$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $19191a1b5ffaa8c1$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $d32f3373a01276ef$export$da8cba906d64c082) : (0, $6a934eada5bd0381$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $8f59c2a26292bd01$var$attrFunctionNS : $8f59c2a26292bd01$var$attrFunction)(fullname, i, (0, $972c1de6adf52838$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $8f59c2a26292bd01$var$attrRemoveNS : $8f59c2a26292bd01$var$attrRemove)(fullname) : (fullname.local ? $8f59c2a26292bd01$var$attrConstantNS : $8f59c2a26292bd01$var$attrConstant)(fullname, i, value));
}



function $e97753fde7e44c56$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $e97753fde7e44c56$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $e97753fde7e44c56$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $e97753fde7e44c56$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $e97753fde7e44c56$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $e97753fde7e44c56$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $e97753fde7e44c56$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $19191a1b5ffaa8c1$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $e97753fde7e44c56$var$attrTweenNS : $e97753fde7e44c56$var$attrTween)(fullname, value));
}



function $3a89057eb7f4ae82$var$delayFunction(id, value) {
    return function() {
        (0, $aef1e5adfcb3a330$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $3a89057eb7f4ae82$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $aef1e5adfcb3a330$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $3a89057eb7f4ae82$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $3a89057eb7f4ae82$var$delayFunction : $3a89057eb7f4ae82$var$delayConstant)(id, value)) : (0, $aef1e5adfcb3a330$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $2f97b56873c6d7ba$var$durationFunction(id, value) {
    return function() {
        (0, $aef1e5adfcb3a330$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $2f97b56873c6d7ba$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $aef1e5adfcb3a330$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $2f97b56873c6d7ba$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $2f97b56873c6d7ba$var$durationFunction : $2f97b56873c6d7ba$var$durationConstant)(id, value)) : (0, $aef1e5adfcb3a330$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $cf6b31c3799d16e1$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $aef1e5adfcb3a330$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $cf6b31c3799d16e1$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($cf6b31c3799d16e1$var$easeConstant(id, value)) : (0, $aef1e5adfcb3a330$export$3988ae62b71be9a3)(this.node(), id).ease;
}



function $980e63a0d1ceaf98$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $aef1e5adfcb3a330$export$adaa4cf7ef1b65be)(this, id).ease = v;
    };
}
function $980e63a0d1ceaf98$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($980e63a0d1ceaf98$var$easeVarying(this._id, value));
}




function $8e4143b141ab1449$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $0f1039f38e52fb7d$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $ca531d477b956dfc$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $f49f117706d883d7$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $ca531d477b956dfc$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $443548d7d26f7729$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $443548d7d26f7729$var$onFunction(id, name, listener) {
    var on0, on1, sit = $443548d7d26f7729$var$start(name) ? (0, $aef1e5adfcb3a330$export$2cd8252107eb640b) : (0, $aef1e5adfcb3a330$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $443548d7d26f7729$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $aef1e5adfcb3a330$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($443548d7d26f7729$var$onFunction(id, name, listener));
}


function $027f01ba7ce3e445$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $027f01ba7ce3e445$export$2e2bcd8739ae039() {
    return this.on("end.remove", $027f01ba7ce3e445$var$removeFunction(this._id));
}





function $f2387434931ed77d$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $90fcd2cfb31c5c0b$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $aef1e5adfcb3a330$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $aef1e5adfcb3a330$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $ca531d477b956dfc$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $8046fdb6e1cfd23e$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $52a7a1b454645792$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $aef1e5adfcb3a330$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $aef1e5adfcb3a330$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $ca531d477b956dfc$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $58ca85f807dc7b91$var$Selection = (0, $c7a3341731fa3134$export$2e2bcd8739ae039).prototype.constructor;
function $58ca85f807dc7b91$export$2e2bcd8739ae039() {
    return new $58ca85f807dc7b91$var$Selection(this._groups, this._parents);
}







function $0696bb0618fd1ca6$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $8dc8fef8928e5abd$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $8dc8fef8928e5abd$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $0696bb0618fd1ca6$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $0696bb0618fd1ca6$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $8dc8fef8928e5abd$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $0696bb0618fd1ca6$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $8dc8fef8928e5abd$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $8dc8fef8928e5abd$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $0696bb0618fd1ca6$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $aef1e5adfcb3a330$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $0696bb0618fd1ca6$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $0696bb0618fd1ca6$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $d32f3373a01276ef$export$56bec7123bb3589a) : (0, $6a934eada5bd0381$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $0696bb0618fd1ca6$var$styleNull(name, i)).on("end.style." + name, $0696bb0618fd1ca6$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $0696bb0618fd1ca6$var$styleFunction(name, i, (0, $972c1de6adf52838$export$f78ce6ab10405d82)(this, "style." + name, value))).each($0696bb0618fd1ca6$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $0696bb0618fd1ca6$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $80d4a0c4f2454f6b$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $80d4a0c4f2454f6b$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $80d4a0c4f2454f6b$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $80d4a0c4f2454f6b$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $80d4a0c4f2454f6b$var$styleTween(name, value, priority == null ? "" : priority));
}



function $33c3e7b14c4759a2$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $33c3e7b14c4759a2$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $33c3e7b14c4759a2$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $33c3e7b14c4759a2$var$textFunction((0, $972c1de6adf52838$export$f78ce6ab10405d82)(this, "text", value)) : $33c3e7b14c4759a2$var$textConstant(value == null ? "" : value + ""));
}


function $5c1b5f6d98b45d7b$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $5c1b5f6d98b45d7b$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $5c1b5f6d98b45d7b$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $5c1b5f6d98b45d7b$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $5c1b5f6d98b45d7b$var$textTween(value));
}




function $474d301243e872c2$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $ca531d477b956dfc$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $aef1e5adfcb3a330$export$3988ae62b71be9a3)(node, id0);
            (0, $aef1e5adfcb3a330$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $ca531d477b956dfc$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $68c0dc4085eec804$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $aef1e5adfcb3a330$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}


var $ca531d477b956dfc$var$id = 0;
function $ca531d477b956dfc$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $ca531d477b956dfc$export$2e2bcd8739ae039(name) {
    return (0, $c7a3341731fa3134$export$2e2bcd8739ae039)().transition(name);
}
function $ca531d477b956dfc$export$9ffd10a3fbdc175b() {
    return ++$ca531d477b956dfc$var$id;
}
var $ca531d477b956dfc$var$selection_prototype = (0, $c7a3341731fa3134$export$2e2bcd8739ae039).prototype;
$ca531d477b956dfc$export$be58926105124dd4.prototype = $ca531d477b956dfc$export$2e2bcd8739ae039.prototype = {
    constructor: $ca531d477b956dfc$export$be58926105124dd4,
    select: (0, $f2387434931ed77d$export$2e2bcd8739ae039),
    selectAll: (0, $8046fdb6e1cfd23e$export$2e2bcd8739ae039),
    selectChild: $ca531d477b956dfc$var$selection_prototype.selectChild,
    selectChildren: $ca531d477b956dfc$var$selection_prototype.selectChildren,
    filter: (0, $8e4143b141ab1449$export$2e2bcd8739ae039),
    merge: (0, $f49f117706d883d7$export$2e2bcd8739ae039),
    selection: (0, $58ca85f807dc7b91$export$2e2bcd8739ae039),
    transition: (0, $474d301243e872c2$export$2e2bcd8739ae039),
    call: $ca531d477b956dfc$var$selection_prototype.call,
    nodes: $ca531d477b956dfc$var$selection_prototype.nodes,
    node: $ca531d477b956dfc$var$selection_prototype.node,
    size: $ca531d477b956dfc$var$selection_prototype.size,
    empty: $ca531d477b956dfc$var$selection_prototype.empty,
    each: $ca531d477b956dfc$var$selection_prototype.each,
    on: (0, $443548d7d26f7729$export$2e2bcd8739ae039),
    attr: (0, $8f59c2a26292bd01$export$2e2bcd8739ae039),
    attrTween: (0, $e97753fde7e44c56$export$2e2bcd8739ae039),
    style: (0, $0696bb0618fd1ca6$export$2e2bcd8739ae039),
    styleTween: (0, $80d4a0c4f2454f6b$export$2e2bcd8739ae039),
    text: (0, $33c3e7b14c4759a2$export$2e2bcd8739ae039),
    textTween: (0, $5c1b5f6d98b45d7b$export$2e2bcd8739ae039),
    remove: (0, $027f01ba7ce3e445$export$2e2bcd8739ae039),
    tween: (0, $972c1de6adf52838$export$2e2bcd8739ae039),
    delay: (0, $3a89057eb7f4ae82$export$2e2bcd8739ae039),
    duration: (0, $2f97b56873c6d7ba$export$2e2bcd8739ae039),
    ease: (0, $cf6b31c3799d16e1$export$2e2bcd8739ae039),
    easeVarying: (0, $980e63a0d1ceaf98$export$2e2bcd8739ae039),
    end: (0, $68c0dc4085eec804$export$2e2bcd8739ae039),
    [Symbol.iterator]: $ca531d477b956dfc$var$selection_prototype[Symbol.iterator]
};



function $98f74d529807ec12$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $98f74d529807ec12$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $98f74d529807ec12$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $3a9f30314a3fe7c4$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $98f74d529807ec12$export$89238d3bc79d3ada)
};
function $3a9f30314a3fe7c4$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $3a9f30314a3fe7c4$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $ca531d477b956dfc$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $ca531d477b956dfc$export$9ffd10a3fbdc175b)(), (timing = $3a9f30314a3fe7c4$var$defaultTiming).time = (0, $30ea27ad4ddf4734$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $aef1e5adfcb3a330$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $3a9f30314a3fe7c4$var$inherit(node, id));
    }
    return new (0, $ca531d477b956dfc$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $c7a3341731fa3134$export$2e2bcd8739ae039).prototype.interrupt = (0, $d05c54c38f75b5b2$export$2e2bcd8739ae039);
(0, $c7a3341731fa3134$export$2e2bcd8739ae039).prototype.transition = (0, $3a9f30314a3fe7c4$export$2e2bcd8739ae039);





var $76948324d72da979$var$root = [
    null
];
function $76948324d72da979$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, i;
    if (schedules) {
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).state > (0, $aef1e5adfcb3a330$export$584530fe98d14a84) && schedule.name === name) return new (0, $ca531d477b956dfc$export$be58926105124dd4)([
                [
                    node
                ]
            ], $76948324d72da979$var$root, name, +i);
        }
    }
    return null;
}





var $31c44a71f11bebb4$export$2e2bcd8739ae039 = (x)=>()=>x;


function $fc6ddb4ffd00de62$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $ef220e9bb1d855c4$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $ef220e9bb1d855c4$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


var $d5efb4258115f400$var$MODE_DRAG = {
    name: "drag"
}, $d5efb4258115f400$var$MODE_SPACE = {
    name: "space"
}, $d5efb4258115f400$var$MODE_HANDLE = {
    name: "handle"
}, $d5efb4258115f400$var$MODE_CENTER = {
    name: "center"
};
const { abs: $d5efb4258115f400$var$abs, max: $d5efb4258115f400$var$max, min: $d5efb4258115f400$var$min } = Math;
function $d5efb4258115f400$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $d5efb4258115f400$var$number2(e) {
    return [
        $d5efb4258115f400$var$number1(e[0]),
        $d5efb4258115f400$var$number1(e[1])
    ];
}
var $d5efb4258115f400$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($d5efb4258115f400$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $d5efb4258115f400$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($d5efb4258115f400$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $d5efb4258115f400$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($d5efb4258115f400$var$type),
    input: function(xy) {
        return xy == null ? null : $d5efb4258115f400$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $d5efb4258115f400$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $d5efb4258115f400$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $d5efb4258115f400$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $d5efb4258115f400$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $d5efb4258115f400$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $d5efb4258115f400$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $d5efb4258115f400$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $d5efb4258115f400$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $d5efb4258115f400$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $d5efb4258115f400$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $d5efb4258115f400$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $d5efb4258115f400$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $d5efb4258115f400$export$979ace6c88860aa8() {
    return $d5efb4258115f400$var$brush($d5efb4258115f400$var$X);
}
function $d5efb4258115f400$export$468748b530991c54() {
    return $d5efb4258115f400$var$brush($d5efb4258115f400$var$Y);
}
function $d5efb4258115f400$export$2e2bcd8739ae039() {
    return $d5efb4258115f400$var$brush($d5efb4258115f400$var$XY);
}
function $d5efb4258115f400$var$brush(dim) {
    var extent = $d5efb4258115f400$var$defaultExtent, filter = $d5efb4258115f400$var$defaultFilter, touchable = $d5efb4258115f400$var$defaultTouchable, keys = true, listeners = (0, $cfaa4969c311d138$export$2e2bcd8739ae039)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $d5efb4258115f400$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $d5efb4258115f400$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $d5efb4258115f400$var$local(this).extent;
            (0, $c38382a82e61d17a$export$2e2bcd8739ae039)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $d5efb4258115f400$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $d5efb4258115f400$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $d5efb4258115f400$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection, event) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $fdef680a1ac134b1$export$2e2bcd8739ae039)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $fd4ea3403db5c867$export$2e2bcd8739ae039)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start(event).brush(event).end(event);
        });
    };
    brush.clear = function(group, event) {
        brush.move(group, null, event);
    };
    function redraw() {
        var group = (0, $c38382a82e61d17a$export$2e2bcd8739ae039)(this), selection = $d5efb4258115f400$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $c38382a82e61d17a$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $fc6ddb4ffd00de62$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $d5efb4258115f400$var$MODE_DRAG : keys && event.altKey ? $d5efb4258115f400$var$MODE_CENTER : $d5efb4258115f400$var$MODE_HANDLE, signX = dim === $d5efb4258115f400$var$Y ? null : $d5efb4258115f400$var$signsX[type], signY = dim === $d5efb4258115f400$var$X ? null : $d5efb4258115f400$var$signsY[type], state = $d5efb4258115f400$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $01126f29f8cc9cfb$export$2e2bcd8739ae039)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        (0, $fd4ea3403db5c867$export$2e2bcd8739ae039)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $d5efb4258115f400$var$Y ? W : $d5efb4258115f400$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $d5efb4258115f400$var$X ? N : $d5efb4258115f400$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $d5efb4258115f400$var$Y ? E : $d5efb4258115f400$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $d5efb4258115f400$var$X ? S : $d5efb4258115f400$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move(event);
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $c38382a82e61d17a$export$2e2bcd8739ae039)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $d5efb4258115f400$var$cursors[type]);
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $c38382a82e61d17a$export$2e2bcd8739ae039)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $2cf643e39b411f06$export$2e2bcd8739ae039)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $01126f29f8cc9cfb$export$2e2bcd8739ae039)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($d5efb4258115f400$var$abs(point.cur[0] - point[0]) > $d5efb4258115f400$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $ef220e9bb1d855c4$export$2e2bcd8739ae039)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $d5efb4258115f400$var$MODE_SPACE:
                case $d5efb4258115f400$var$MODE_DRAG:
                    if (signX) dx = $d5efb4258115f400$var$max(W - w0, $d5efb4258115f400$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $d5efb4258115f400$var$max(N - n0, $d5efb4258115f400$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $d5efb4258115f400$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $d5efb4258115f400$var$max(W, $d5efb4258115f400$var$min(E, points[0][0])), e1 = $d5efb4258115f400$var$max(W, $d5efb4258115f400$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $d5efb4258115f400$var$max(N, $d5efb4258115f400$var$min(S, points[0][1])), s1 = $d5efb4258115f400$var$max(N, $d5efb4258115f400$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $d5efb4258115f400$var$max(W - w0, $d5efb4258115f400$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $d5efb4258115f400$var$max(W - e0, $d5efb4258115f400$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $d5efb4258115f400$var$max(N - n0, $d5efb4258115f400$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $d5efb4258115f400$var$max(N - s0, $d5efb4258115f400$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $d5efb4258115f400$var$MODE_CENTER:
                    if (signX) w1 = $d5efb4258115f400$var$max(W, $d5efb4258115f400$var$min(E, w0 - dx * signX)), e1 = $d5efb4258115f400$var$max(W, $d5efb4258115f400$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $d5efb4258115f400$var$max(N, $d5efb4258115f400$var$min(S, n0 - dy * signY)), s1 = $d5efb4258115f400$var$max(N, $d5efb4258115f400$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $d5efb4258115f400$var$flipX) overlay.attr("cursor", $d5efb4258115f400$var$cursors[type = $d5efb4258115f400$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $d5efb4258115f400$var$flipY) overlay.attr("cursor", $d5efb4258115f400$var$cursors[type = $d5efb4258115f400$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $ef220e9bb1d855c4$export$2e2561858db9bf47)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $2cf643e39b411f06$export$833237748009e1e1)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $d5efb4258115f400$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($d5efb4258115f400$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $d5efb4258115f400$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $d5efb4258115f400$var$MODE_CENTER;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $d5efb4258115f400$var$MODE_HANDLE || mode === $d5efb4258115f400$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $d5efb4258115f400$var$MODE_SPACE;
                        overlay.attr("cursor", $d5efb4258115f400$var$cursors.selection);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $ef220e9bb1d855c4$export$2e2bcd8739ae039)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move(event);
                    }
                    break;
                case 18:
                    if (mode === $d5efb4258115f400$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $d5efb4258115f400$var$MODE_HANDLE;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $d5efb4258115f400$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $d5efb4258115f400$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $d5efb4258115f400$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $d5efb4258115f400$var$cursors[type]);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $ef220e9bb1d855c4$export$2e2bcd8739ae039)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $d5efb4258115f400$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $31c44a71f11bebb4$export$2e2bcd8739ae039)($d5efb4258115f400$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $31c44a71f11bebb4$export$2e2bcd8739ae039)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $31c44a71f11bebb4$export$2e2bcd8739ae039)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}




var $37552dd2331c372d$exports = {};

$parcel$export($37552dd2331c372d$exports, "chord", () => $8cc11fc1ad97a158$export$2e2bcd8739ae039);
$parcel$export($37552dd2331c372d$exports, "chordTranspose", () => $8cc11fc1ad97a158$export$ccf0fb804feeadb0);
$parcel$export($37552dd2331c372d$exports, "chordDirected", () => $8cc11fc1ad97a158$export$66e653ba9a7a4d8c);
$parcel$export($37552dd2331c372d$exports, "ribbon", () => $92e565812e3eaac4$export$2e2bcd8739ae039);
$parcel$export($37552dd2331c372d$exports, "ribbonArrow", () => $92e565812e3eaac4$export$63f6c8bb9e816a34);
var $be92f0392036dd94$export$2335f513bbd82c6d = Math.abs;
var $be92f0392036dd94$export$50d414a77b60d802 = Math.cos;
var $be92f0392036dd94$export$5de3937cb4b592ed = Math.sin;
var $be92f0392036dd94$export$18c7bea995a110f = Math.PI;
var $be92f0392036dd94$export$e51408a300e8929a = $be92f0392036dd94$export$18c7bea995a110f / 2;
var $be92f0392036dd94$export$a4b4b4d4d776fe92 = $be92f0392036dd94$export$18c7bea995a110f * 2;
var $be92f0392036dd94$export$8960430cfd85939f = Math.max;
var $be92f0392036dd94$export$6c421550c66a327d = 1e-12;


function $8cc11fc1ad97a158$var$range(i, j) {
    return Array.from({
        length: j - i
    }, (_, k)=>i + k);
}
function $8cc11fc1ad97a158$var$compareValue(compare) {
    return function(a, b) {
        return compare(a.source.value + a.target.value, b.source.value + b.target.value);
    };
}
function $8cc11fc1ad97a158$export$2e2bcd8739ae039() {
    return $8cc11fc1ad97a158$var$chord(false, false);
}
function $8cc11fc1ad97a158$export$ccf0fb804feeadb0() {
    return $8cc11fc1ad97a158$var$chord(false, true);
}
function $8cc11fc1ad97a158$export$66e653ba9a7a4d8c() {
    return $8cc11fc1ad97a158$var$chord(true, false);
}
function $8cc11fc1ad97a158$var$chord(directed, transpose) {
    var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
    function chord(matrix) {
        var n = matrix.length, groupSums = new Array(n), groupIndex = $8cc11fc1ad97a158$var$range(0, n), chords = new Array(n * n), groups = new Array(n), k = 0, dx;
        matrix = Float64Array.from({
            length: n * n
        }, transpose ? (_, i)=>matrix[i % n][i / n | 0] : (_, i)=>matrix[i / n | 0][i % n]);
        // Compute the scaling factor from value to angle in [0, 2pi].
        for(let i = 0; i < n; ++i){
            let x = 0;
            for(let j = 0; j < n; ++j)x += matrix[i * n + j] + directed * matrix[j * n + i];
            k += groupSums[i] = x;
        }
        k = (0, $be92f0392036dd94$export$8960430cfd85939f)(0, (0, $be92f0392036dd94$export$a4b4b4d4d776fe92) - padAngle * n) / k;
        dx = k ? padAngle : (0, $be92f0392036dd94$export$a4b4b4d4d776fe92) / n;
        // Compute the angles for each group and constituent chord.
        {
            let x = 0;
            if (sortGroups) groupIndex.sort((a, b)=>sortGroups(groupSums[a], groupSums[b]));
            for (const i of groupIndex){
                const x0 = x;
                if (directed) {
                    const subgroupIndex = $8cc11fc1ad97a158$var$range(~n + 1, n).filter((j)=>j < 0 ? matrix[~j * n + i] : matrix[i * n + j]);
                    if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(a < 0 ? -matrix[~a * n + i] : matrix[i * n + a], b < 0 ? -matrix[~b * n + i] : matrix[i * n + b]));
                    for (const j of subgroupIndex)if (j < 0) {
                        const chord = chords[~j * n + i] || (chords[~j * n + i] = {
                            source: null,
                            target: null
                        });
                        chord.target = {
                            index: i,
                            startAngle: x,
                            endAngle: x += matrix[~j * n + i] * k,
                            value: matrix[~j * n + i]
                        };
                    } else {
                        const chord = chords[i * n + j] || (chords[i * n + j] = {
                            source: null,
                            target: null
                        });
                        chord.source = {
                            index: i,
                            startAngle: x,
                            endAngle: x += matrix[i * n + j] * k,
                            value: matrix[i * n + j]
                        };
                    }
                    groups[i] = {
                        index: i,
                        startAngle: x0,
                        endAngle: x,
                        value: groupSums[i]
                    };
                } else {
                    const subgroupIndex = $8cc11fc1ad97a158$var$range(0, n).filter((j)=>matrix[i * n + j] || matrix[j * n + i]);
                    if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(matrix[i * n + a], matrix[i * n + b]));
                    for (const j of subgroupIndex){
                        let chord;
                        if (i < j) {
                            chord = chords[i * n + j] || (chords[i * n + j] = {
                                source: null,
                                target: null
                            });
                            chord.source = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[i * n + j] * k,
                                value: matrix[i * n + j]
                            };
                        } else {
                            chord = chords[j * n + i] || (chords[j * n + i] = {
                                source: null,
                                target: null
                            });
                            chord.target = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[i * n + j] * k,
                                value: matrix[i * n + j]
                            };
                            if (i === j) chord.source = chord.target;
                        }
                        if (chord.source && chord.target && chord.source.value < chord.target.value) {
                            const source = chord.source;
                            chord.source = chord.target;
                            chord.target = source;
                        }
                    }
                    groups[i] = {
                        index: i,
                        startAngle: x0,
                        endAngle: x,
                        value: groupSums[i]
                    };
                }
                x += dx;
            }
        }
        // Remove empty chords.
        chords = Object.values(chords);
        chords.groups = groups;
        return sortChords ? chords.sort(sortChords) : chords;
    }
    chord.padAngle = function(_) {
        return arguments.length ? (padAngle = (0, $be92f0392036dd94$export$8960430cfd85939f)(0, _), chord) : padAngle;
    };
    chord.sortGroups = function(_) {
        return arguments.length ? (sortGroups = _, chord) : sortGroups;
    };
    chord.sortSubgroups = function(_) {
        return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
    };
    chord.sortChords = function(_) {
        return arguments.length ? (_ == null ? sortChords = null : (sortChords = $8cc11fc1ad97a158$var$compareValue(_))._ = _, chord) : sortChords && sortChords._;
    };
    return chord;
}


const $2e4cb56f5089693f$var$pi = Math.PI, $2e4cb56f5089693f$var$tau = 2 * $2e4cb56f5089693f$var$pi, $2e4cb56f5089693f$var$epsilon = 1e-6, $2e4cb56f5089693f$var$tauEpsilon = $2e4cb56f5089693f$var$tau - $2e4cb56f5089693f$var$epsilon;
function $2e4cb56f5089693f$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $2e4cb56f5089693f$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $2e4cb56f5089693f$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $2e4cb56f5089693f$export$4b2950bdac9b6ee9 {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $2e4cb56f5089693f$var$append : $2e4cb56f5089693f$var$appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > $2e4cb56f5089693f$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $2e4cb56f5089693f$var$epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($2e4cb56f5089693f$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $2e4cb56f5089693f$var$epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $2e4cb56f5089693f$var$epsilon || Math.abs(this._y1 - y0) > $2e4cb56f5089693f$var$epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $2e4cb56f5089693f$var$tau + $2e4cb56f5089693f$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $2e4cb56f5089693f$var$tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > $2e4cb56f5089693f$var$epsilon) this._append`A${r},${r},0,${+(da >= $2e4cb56f5089693f$var$pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function $2e4cb56f5089693f$export$bb654e07daaf8c3a() {
    return new $2e4cb56f5089693f$export$4b2950bdac9b6ee9;
}
// Allow instanceof d3.path
$2e4cb56f5089693f$export$bb654e07daaf8c3a.prototype = $2e4cb56f5089693f$export$4b2950bdac9b6ee9.prototype;
function $2e4cb56f5089693f$export$e181c6ece8d9cc5f(digits = 3) {
    return new $2e4cb56f5089693f$export$4b2950bdac9b6ee9(+digits);
}


var $4bbc1fa66e8993d2$export$58adb3bec8346d0f = Array.prototype.slice;


function $32bac2c82073af8f$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}



function $92e565812e3eaac4$var$defaultSource(d) {
    return d.source;
}
function $92e565812e3eaac4$var$defaultTarget(d) {
    return d.target;
}
function $92e565812e3eaac4$var$defaultRadius(d) {
    return d.radius;
}
function $92e565812e3eaac4$var$defaultStartAngle(d) {
    return d.startAngle;
}
function $92e565812e3eaac4$var$defaultEndAngle(d) {
    return d.endAngle;
}
function $92e565812e3eaac4$var$defaultPadAngle() {
    return 0;
}
function $92e565812e3eaac4$var$defaultArrowheadRadius() {
    return 10;
}
function $92e565812e3eaac4$var$ribbon(headRadius) {
    var source = $92e565812e3eaac4$var$defaultSource, target = $92e565812e3eaac4$var$defaultTarget, sourceRadius = $92e565812e3eaac4$var$defaultRadius, targetRadius = $92e565812e3eaac4$var$defaultRadius, startAngle = $92e565812e3eaac4$var$defaultStartAngle, endAngle = $92e565812e3eaac4$var$defaultEndAngle, padAngle = $92e565812e3eaac4$var$defaultPadAngle, context = null;
    function ribbon() {
        var buffer, s = source.apply(this, arguments), t = target.apply(this, arguments), ap = padAngle.apply(this, arguments) / 2, argv = (0, $4bbc1fa66e8993d2$export$58adb3bec8346d0f).call(arguments), sr = +sourceRadius.apply(this, (argv[0] = s, argv)), sa0 = startAngle.apply(this, argv) - (0, $be92f0392036dd94$export$e51408a300e8929a), sa1 = endAngle.apply(this, argv) - (0, $be92f0392036dd94$export$e51408a300e8929a), tr = +targetRadius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - (0, $be92f0392036dd94$export$e51408a300e8929a), ta1 = endAngle.apply(this, argv) - (0, $be92f0392036dd94$export$e51408a300e8929a);
        if (!context) context = buffer = (0, $2e4cb56f5089693f$export$bb654e07daaf8c3a)();
        if (ap > (0, $be92f0392036dd94$export$6c421550c66a327d)) {
            if ((0, $be92f0392036dd94$export$2335f513bbd82c6d)(sa1 - sa0) > ap * 2 + (0, $be92f0392036dd94$export$6c421550c66a327d)) sa1 > sa0 ? (sa0 += ap, sa1 -= ap) : (sa0 -= ap, sa1 += ap);
            else sa0 = sa1 = (sa0 + sa1) / 2;
            if ((0, $be92f0392036dd94$export$2335f513bbd82c6d)(ta1 - ta0) > ap * 2 + (0, $be92f0392036dd94$export$6c421550c66a327d)) ta1 > ta0 ? (ta0 += ap, ta1 -= ap) : (ta0 -= ap, ta1 += ap);
            else ta0 = ta1 = (ta0 + ta1) / 2;
        }
        context.moveTo(sr * (0, $be92f0392036dd94$export$50d414a77b60d802)(sa0), sr * (0, $be92f0392036dd94$export$5de3937cb4b592ed)(sa0));
        context.arc(0, 0, sr, sa0, sa1);
        if (sa0 !== ta0 || sa1 !== ta1) {
            if (headRadius) {
                var hr = +headRadius.apply(this, arguments), tr2 = tr - hr, ta2 = (ta0 + ta1) / 2;
                context.quadraticCurveTo(0, 0, tr2 * (0, $be92f0392036dd94$export$50d414a77b60d802)(ta0), tr2 * (0, $be92f0392036dd94$export$5de3937cb4b592ed)(ta0));
                context.lineTo(tr * (0, $be92f0392036dd94$export$50d414a77b60d802)(ta2), tr * (0, $be92f0392036dd94$export$5de3937cb4b592ed)(ta2));
                context.lineTo(tr2 * (0, $be92f0392036dd94$export$50d414a77b60d802)(ta1), tr2 * (0, $be92f0392036dd94$export$5de3937cb4b592ed)(ta1));
            } else {
                context.quadraticCurveTo(0, 0, tr * (0, $be92f0392036dd94$export$50d414a77b60d802)(ta0), tr * (0, $be92f0392036dd94$export$5de3937cb4b592ed)(ta0));
                context.arc(0, 0, tr, ta0, ta1);
            }
        }
        context.quadraticCurveTo(0, 0, sr * (0, $be92f0392036dd94$export$50d414a77b60d802)(sa0), sr * (0, $be92f0392036dd94$export$5de3937cb4b592ed)(sa0));
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    if (headRadius) ribbon.headRadius = function(_) {
        return arguments.length ? (headRadius = typeof _ === "function" ? _ : (0, $32bac2c82073af8f$export$2e2bcd8739ae039)(+_), ribbon) : headRadius;
    };
    ribbon.radius = function(_) {
        return arguments.length ? (sourceRadius = targetRadius = typeof _ === "function" ? _ : (0, $32bac2c82073af8f$export$2e2bcd8739ae039)(+_), ribbon) : sourceRadius;
    };
    ribbon.sourceRadius = function(_) {
        return arguments.length ? (sourceRadius = typeof _ === "function" ? _ : (0, $32bac2c82073af8f$export$2e2bcd8739ae039)(+_), ribbon) : sourceRadius;
    };
    ribbon.targetRadius = function(_) {
        return arguments.length ? (targetRadius = typeof _ === "function" ? _ : (0, $32bac2c82073af8f$export$2e2bcd8739ae039)(+_), ribbon) : targetRadius;
    };
    ribbon.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $32bac2c82073af8f$export$2e2bcd8739ae039)(+_), ribbon) : startAngle;
    };
    ribbon.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $32bac2c82073af8f$export$2e2bcd8739ae039)(+_), ribbon) : endAngle;
    };
    ribbon.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $32bac2c82073af8f$export$2e2bcd8739ae039)(+_), ribbon) : padAngle;
    };
    ribbon.source = function(_) {
        return arguments.length ? (source = _, ribbon) : source;
    };
    ribbon.target = function(_) {
        return arguments.length ? (target = _, ribbon) : target;
    };
    ribbon.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
    };
    return ribbon;
}
function $92e565812e3eaac4$export$2e2bcd8739ae039() {
    return $92e565812e3eaac4$var$ribbon();
}
function $92e565812e3eaac4$export$63f6c8bb9e816a34() {
    return $92e565812e3eaac4$var$ribbon($92e565812e3eaac4$var$defaultArrowheadRadius);
}




var $1e35a39effc36fb0$exports = {};

$parcel$export($1e35a39effc36fb0$exports, "color", () => (parcelRequire("gisW9")).default);
$parcel$export($1e35a39effc36fb0$exports, "rgb", () => (parcelRequire("gisW9")).rgb);
$parcel$export($1e35a39effc36fb0$exports, "hsl", () => (parcelRequire("gisW9")).hsl);
$parcel$export($1e35a39effc36fb0$exports, "lab", () => $b3fc1577323a3235$export$2e2bcd8739ae039);
$parcel$export($1e35a39effc36fb0$exports, "hcl", () => $b3fc1577323a3235$export$d0e870ba50062ff1);
$parcel$export($1e35a39effc36fb0$exports, "lch", () => $b3fc1577323a3235$export$5a21418738164530);
$parcel$export($1e35a39effc36fb0$exports, "gray", () => $b3fc1577323a3235$export$3e2c219d3ab79d01);
$parcel$export($1e35a39effc36fb0$exports, "cubehelix", () => $2e4646047aa20e81$export$2e2bcd8739ae039);

var $gisW9 = parcelRequire("gisW9");

var $PEwcN = parcelRequire("PEwcN");

var $gisW9 = parcelRequire("gisW9");
const $9a29ae64052722a5$export$8449e153fbd325fc = Math.PI / 180;
const $9a29ae64052722a5$export$41fc368e1a942b97 = 180 / Math.PI;


// https://observablehq.com/@mbostock/lab-and-rgb
const $b3fc1577323a3235$var$K = 18, $b3fc1577323a3235$var$Xn = 0.96422, $b3fc1577323a3235$var$Yn = 1, $b3fc1577323a3235$var$Zn = 0.82521, $b3fc1577323a3235$var$t0 = 4 / 29, $b3fc1577323a3235$var$t1 = 6 / 29, $b3fc1577323a3235$var$t2 = 3 * $b3fc1577323a3235$var$t1 * $b3fc1577323a3235$var$t1, $b3fc1577323a3235$var$t3 = $b3fc1577323a3235$var$t1 * $b3fc1577323a3235$var$t1 * $b3fc1577323a3235$var$t1;
function $b3fc1577323a3235$var$labConvert(o) {
    if (o instanceof $b3fc1577323a3235$export$f2722c70a60257f7) return new $b3fc1577323a3235$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $b3fc1577323a3235$export$d9397e094a5fbb9a) return $b3fc1577323a3235$var$hcl2lab(o);
    if (!(o instanceof (0, $gisW9.Rgb))) o = (0, $gisW9.rgbConvert)(o);
    var r = $b3fc1577323a3235$var$rgb2lrgb(o.r), g = $b3fc1577323a3235$var$rgb2lrgb(o.g), b = $b3fc1577323a3235$var$rgb2lrgb(o.b), y = $b3fc1577323a3235$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $b3fc1577323a3235$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $b3fc1577323a3235$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $b3fc1577323a3235$var$Xn);
        z = $b3fc1577323a3235$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $b3fc1577323a3235$var$Zn);
    }
    return new $b3fc1577323a3235$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $b3fc1577323a3235$export$3e2c219d3ab79d01(l, opacity) {
    return new $b3fc1577323a3235$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
}
function $b3fc1577323a3235$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $b3fc1577323a3235$var$labConvert(l) : new $b3fc1577323a3235$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $b3fc1577323a3235$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $PEwcN.default)($b3fc1577323a3235$export$f2722c70a60257f7, $b3fc1577323a3235$export$2e2bcd8739ae039, (0, $PEwcN.extend)((0, $gisW9.Color), {
    brighter (k) {
        return new $b3fc1577323a3235$export$f2722c70a60257f7(this.l + $b3fc1577323a3235$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $b3fc1577323a3235$export$f2722c70a60257f7(this.l - $b3fc1577323a3235$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $b3fc1577323a3235$var$Xn * $b3fc1577323a3235$var$lab2xyz(x);
        y = $b3fc1577323a3235$var$Yn * $b3fc1577323a3235$var$lab2xyz(y);
        z = $b3fc1577323a3235$var$Zn * $b3fc1577323a3235$var$lab2xyz(z);
        return new (0, $gisW9.Rgb)($b3fc1577323a3235$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $b3fc1577323a3235$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $b3fc1577323a3235$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $b3fc1577323a3235$var$xyz2lab(t) {
    return t > $b3fc1577323a3235$var$t3 ? Math.pow(t, 1 / 3) : t / $b3fc1577323a3235$var$t2 + $b3fc1577323a3235$var$t0;
}
function $b3fc1577323a3235$var$lab2xyz(t) {
    return t > $b3fc1577323a3235$var$t1 ? t * t * t : $b3fc1577323a3235$var$t2 * (t - $b3fc1577323a3235$var$t0);
}
function $b3fc1577323a3235$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $b3fc1577323a3235$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $b3fc1577323a3235$var$hclConvert(o) {
    if (o instanceof $b3fc1577323a3235$export$d9397e094a5fbb9a) return new $b3fc1577323a3235$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $b3fc1577323a3235$export$f2722c70a60257f7)) o = $b3fc1577323a3235$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $b3fc1577323a3235$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, $9a29ae64052722a5$export$41fc368e1a942b97);
    return new $b3fc1577323a3235$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $b3fc1577323a3235$export$5a21418738164530(l, c, h, opacity) {
    return arguments.length === 1 ? $b3fc1577323a3235$var$hclConvert(l) : new $b3fc1577323a3235$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $b3fc1577323a3235$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $b3fc1577323a3235$var$hclConvert(h) : new $b3fc1577323a3235$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $b3fc1577323a3235$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $b3fc1577323a3235$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $b3fc1577323a3235$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
    var h = o.h * (0, $9a29ae64052722a5$export$8449e153fbd325fc);
    return new $b3fc1577323a3235$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $PEwcN.default)($b3fc1577323a3235$export$d9397e094a5fbb9a, $b3fc1577323a3235$export$d0e870ba50062ff1, (0, $PEwcN.extend)((0, $gisW9.Color), {
    brighter (k) {
        return new $b3fc1577323a3235$export$d9397e094a5fbb9a(this.h, this.c, this.l + $b3fc1577323a3235$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $b3fc1577323a3235$export$d9397e094a5fbb9a(this.h, this.c, this.l - $b3fc1577323a3235$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $b3fc1577323a3235$var$hcl2lab(this).rgb();
    }
}));



var $PEwcN = parcelRequire("PEwcN");

var $gisW9 = parcelRequire("gisW9");

var $2e4646047aa20e81$var$A = -0.14861, $2e4646047aa20e81$var$B = 1.78277, $2e4646047aa20e81$var$C = -0.29227, $2e4646047aa20e81$var$D = -0.90649, $2e4646047aa20e81$var$E = 1.97294, $2e4646047aa20e81$var$ED = $2e4646047aa20e81$var$E * $2e4646047aa20e81$var$D, $2e4646047aa20e81$var$EB = $2e4646047aa20e81$var$E * $2e4646047aa20e81$var$B, $2e4646047aa20e81$var$BC_DA = $2e4646047aa20e81$var$B * $2e4646047aa20e81$var$C - $2e4646047aa20e81$var$D * $2e4646047aa20e81$var$A;
function $2e4646047aa20e81$var$cubehelixConvert(o) {
    if (o instanceof $2e4646047aa20e81$export$57ed4bde61a1e2f2) return new $2e4646047aa20e81$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $gisW9.Rgb))) o = (0, $gisW9.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($2e4646047aa20e81$var$BC_DA * b + $2e4646047aa20e81$var$ED * r - $2e4646047aa20e81$var$EB * g) / ($2e4646047aa20e81$var$BC_DA + $2e4646047aa20e81$var$ED - $2e4646047aa20e81$var$EB), bl = b - l, k = ($2e4646047aa20e81$var$E * (g - l) - $2e4646047aa20e81$var$C * bl) / $2e4646047aa20e81$var$D, s = Math.sqrt(k * k + bl * bl) / ($2e4646047aa20e81$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $9a29ae64052722a5$export$41fc368e1a942b97) - 120 : NaN;
    return new $2e4646047aa20e81$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $2e4646047aa20e81$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $2e4646047aa20e81$var$cubehelixConvert(h) : new $2e4646047aa20e81$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $2e4646047aa20e81$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $PEwcN.default)($2e4646047aa20e81$export$57ed4bde61a1e2f2, $2e4646047aa20e81$export$2e2bcd8739ae039, (0, $PEwcN.extend)((0, $gisW9.Color), {
    brighter (k) {
        k = k == null ? (0, $gisW9.brighter) : Math.pow((0, $gisW9.brighter), k);
        return new $2e4646047aa20e81$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? (0, $gisW9.darker) : Math.pow((0, $gisW9.darker), k);
        return new $2e4646047aa20e81$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $9a29ae64052722a5$export$8449e153fbd325fc), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $gisW9.Rgb)(255 * (l + a * ($2e4646047aa20e81$var$A * cosh + $2e4646047aa20e81$var$B * sinh)), 255 * (l + a * ($2e4646047aa20e81$var$C * cosh + $2e4646047aa20e81$var$D * sinh)), 255 * (l + a * ($2e4646047aa20e81$var$E * cosh)), this.opacity);
    }
}));




var $b0c30026f923e936$exports = {};

$parcel$export($b0c30026f923e936$exports, "contours", () => $ebb8b55bddf1da83$export$2e2bcd8739ae039);
$parcel$export($b0c30026f923e936$exports, "contourDensity", () => $a228c82aec9e621e$export$2e2bcd8739ae039);

var $8bd26702d8339be6$var$array = Array.prototype;
var $8bd26702d8339be6$export$58adb3bec8346d0f = $8bd26702d8339be6$var$array.slice;


function $79e0d4ed739e55b1$export$2e2bcd8739ae039(a, b) {
    return a - b;
}


function $4474142917742673$export$2e2bcd8739ae039(ring) {
    var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
    while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
    return area;
}


var $86aa7bc3b611ed7b$export$2e2bcd8739ae039 = (x)=>()=>x;


function $8c00e89bbb48a1a4$export$2e2bcd8739ae039(ring, hole) {
    var i = -1, n = hole.length, c;
    while(++i < n)if (c = $8c00e89bbb48a1a4$var$ringContains(ring, hole[i])) return c;
    return 0;
}
function $8c00e89bbb48a1a4$var$ringContains(ring, point) {
    var x = point[0], y = point[1], contains = -1;
    for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
        var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
        if ($8c00e89bbb48a1a4$var$segmentContains(pi, pj, point)) return 0;
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
    }
    return contains;
}
function $8c00e89bbb48a1a4$var$segmentContains(a, b, c) {
    var i;
    return $8c00e89bbb48a1a4$var$collinear(a, b, c) && $8c00e89bbb48a1a4$var$within(a[i = +(a[0] === b[0])], c[i], b[i]);
}
function $8c00e89bbb48a1a4$var$collinear(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}
function $8c00e89bbb48a1a4$var$within(p, q, r) {
    return p <= q && q <= r || r <= q && q <= p;
}


function $12cc985745a83a50$export$2e2bcd8739ae039() {}


var $ebb8b55bddf1da83$var$cases = [
    [],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ],
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ],
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    []
];
function $ebb8b55bddf1da83$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, threshold = (0, $fd876a2d70480179$export$2e2bcd8739ae039), smooth = smoothLinear;
    function contours(values) {
        var tz = threshold(values);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            const e = (0, $7dfd54d3fa480d64$export$2e2bcd8739ae039)(values, $ebb8b55bddf1da83$var$finite);
            tz = (0, $60d8cb9860d70e68$export$2e2bcd8739ae039)(...(0, $a71794ecb80cbf90$export$2e2bcd8739ae039)(e[0], e[1], tz), tz);
            while(tz[tz.length - 1] >= e[1])tz.pop();
            while(tz[1] < e[0])tz.shift();
        } else tz = tz.slice().sort((0, $79e0d4ed739e55b1$export$2e2bcd8739ae039));
        return tz.map((value)=>contour(values, value));
    }
    // Accumulate, smooth contour rings, assign holes to exterior rings.
    // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
    function contour(values, value) {
        const v = value == null ? NaN : +value;
        if (isNaN(v)) throw new Error(`invalid value: ${value}`);
        var polygons = [], holes = [];
        isorings(values, v, function(ring) {
            smooth(ring, values, v);
            if ((0, $4474142917742673$export$2e2bcd8739ae039)(ring) > 0) polygons.push([
                ring
            ]);
            else holes.push(ring);
        });
        holes.forEach(function(hole) {
            for(var i = 0, n = polygons.length, polygon; i < n; ++i)if ((0, $8c00e89bbb48a1a4$export$2e2bcd8739ae039)((polygon = polygons[i])[0], hole) !== -1) {
                polygon.push(hole);
                return;
            }
        });
        return {
            type: "MultiPolygon",
            value: value,
            coordinates: polygons
        };
    }
    // Marching squares with isolines stitched into rings.
    // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
    function isorings(values, value, callback) {
        var fragmentByStart = new Array, fragmentByEnd = new Array, x, y, t0, t1, t2, t3;
        // Special case for the first row (y = -1, t2 = t3 = 0).
        x = y = -1;
        t1 = $ebb8b55bddf1da83$var$above(values[0], value);
        $ebb8b55bddf1da83$var$cases[t1 << 1].forEach(stitch);
        while(++x < dx - 1){
            t0 = t1, t1 = $ebb8b55bddf1da83$var$above(values[x + 1], value);
            $ebb8b55bddf1da83$var$cases[t0 | t1 << 1].forEach(stitch);
        }
        $ebb8b55bddf1da83$var$cases[t1 << 0].forEach(stitch);
        // General case for the intermediate rows.
        while(++y < dy - 1){
            x = -1;
            t1 = $ebb8b55bddf1da83$var$above(values[y * dx + dx], value);
            t2 = $ebb8b55bddf1da83$var$above(values[y * dx], value);
            $ebb8b55bddf1da83$var$cases[t1 << 1 | t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = $ebb8b55bddf1da83$var$above(values[y * dx + dx + x + 1], value);
                t3 = t2, t2 = $ebb8b55bddf1da83$var$above(values[y * dx + x + 1], value);
                $ebb8b55bddf1da83$var$cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
            }
            $ebb8b55bddf1da83$var$cases[t1 | t2 << 3].forEach(stitch);
        }
        // Special case for the last row (y = dy - 1, t0 = t1 = 0).
        x = -1;
        t2 = values[y * dx] >= value;
        $ebb8b55bddf1da83$var$cases[t2 << 2].forEach(stitch);
        while(++x < dx - 1){
            t3 = t2, t2 = $ebb8b55bddf1da83$var$above(values[y * dx + x + 1], value);
            $ebb8b55bddf1da83$var$cases[t2 << 2 | t3 << 3].forEach(stitch);
        }
        $ebb8b55bddf1da83$var$cases[t2 << 3].forEach(stitch);
        function stitch(line) {
            var start = [
                line[0][0] + x,
                line[0][1] + y
            ], end = [
                line[1][0] + x,
                line[1][1] + y
            ], startIndex = index(start), endIndex = index(end), f, g;
            if (f = fragmentByEnd[startIndex]) {
                if (g = fragmentByStart[endIndex]) {
                    delete fragmentByEnd[f.end];
                    delete fragmentByStart[g.start];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                        start: f.start,
                        end: g.end,
                        ring: f.ring.concat(g.ring)
                    };
                } else {
                    delete fragmentByEnd[f.end];
                    f.ring.push(end);
                    fragmentByEnd[f.end = endIndex] = f;
                }
            } else if (f = fragmentByStart[endIndex]) {
                if (g = fragmentByEnd[startIndex]) {
                    delete fragmentByStart[f.start];
                    delete fragmentByEnd[g.end];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                        start: g.start,
                        end: f.end,
                        ring: g.ring.concat(f.ring)
                    };
                } else {
                    delete fragmentByStart[f.start];
                    f.ring.unshift(start);
                    fragmentByStart[f.start = startIndex] = f;
                }
            } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                start: startIndex,
                end: endIndex,
                ring: [
                    start,
                    end
                ]
            };
        }
    }
    function index(point) {
        return point[0] * 2 + point[1] * (dx + 1) * 4;
    }
    function smoothLinear(ring, values, value) {
        ring.forEach(function(point) {
            var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v1 = $ebb8b55bddf1da83$var$valid(values[yt * dx + xt]);
            if (x > 0 && x < dx && xt === x) point[0] = $ebb8b55bddf1da83$var$smooth1(x, $ebb8b55bddf1da83$var$valid(values[yt * dx + xt - 1]), v1, value);
            if (y > 0 && y < dy && yt === y) point[1] = $ebb8b55bddf1da83$var$smooth1(y, $ebb8b55bddf1da83$var$valid(values[(yt - 1) * dx + xt]), v1, value);
        });
    }
    contours.contour = contour;
    contours.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = Math.floor(_[0]), _1 = Math.floor(_[1]);
        if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
        return dx = _0, dy = _1, contours;
    };
    contours.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $86aa7bc3b611ed7b$export$2e2bcd8739ae039)((0, $8bd26702d8339be6$export$58adb3bec8346d0f).call(_)) : (0, $86aa7bc3b611ed7b$export$2e2bcd8739ae039)(_), contours) : threshold;
    };
    contours.smooth = function(_) {
        return arguments.length ? (smooth = _ ? smoothLinear : (0, $12cc985745a83a50$export$2e2bcd8739ae039), contours) : smooth === smoothLinear;
    };
    return contours;
}
// When computing the extent, ignore infinite values (as well as invalid ones).
function $ebb8b55bddf1da83$var$finite(x) {
    return isFinite(x) ? x : NaN;
}
// Is the (possibly invalid) x greater than or equal to the (known valid) value?
// Treat any invalid value as below negative infinity.
function $ebb8b55bddf1da83$var$above(x, value) {
    return x == null ? false : +x >= value;
}
// During smoothing, treat any invalid value as negative infinity.
function $ebb8b55bddf1da83$var$valid(v) {
    return v == null || isNaN(v = +v) ? -Infinity : v;
}
function $ebb8b55bddf1da83$var$smooth1(x, v0, v1, value) {
    const a = value - v0;
    const b = v1 - v0;
    const d = isFinite(a) || isFinite(b) ? a / b : Math.sign(a) / Math.sign(b);
    return isNaN(d) ? x : x + d - 0.5;
}






function $a228c82aec9e621e$var$defaultX(d) {
    return d[0];
}
function $a228c82aec9e621e$var$defaultY(d) {
    return d[1];
}
function $a228c82aec9e621e$var$defaultWeight() {
    return 1;
}
function $a228c82aec9e621e$export$2e2bcd8739ae039() {
    var x = $a228c82aec9e621e$var$defaultX, y = $a228c82aec9e621e$var$defaultY, weight = $a228c82aec9e621e$var$defaultWeight, dx = 960, dy = 500, r = 20, k = 2, o = r * 3, n = dx + o * 2 >> k, m = dy + o * 2 >> k, threshold = (0, $86aa7bc3b611ed7b$export$2e2bcd8739ae039)(20);
    function grid(data) {
        var values = new Float32Array(n * m), pow2k = Math.pow(2, -k), i = -1;
        for (const d of data){
            var xi = (x(d, ++i, data) + o) * pow2k, yi = (y(d, i, data) + o) * pow2k, wi = +weight(d, i, data);
            if (wi && xi >= 0 && xi < n && yi >= 0 && yi < m) {
                var x0 = Math.floor(xi), y0 = Math.floor(yi), xt = xi - x0 - 0.5, yt = yi - y0 - 0.5;
                values[x0 + y0 * n] += (1 - xt) * (1 - yt) * wi;
                values[x0 + 1 + y0 * n] += xt * (1 - yt) * wi;
                values[x0 + 1 + (y0 + 1) * n] += xt * yt * wi;
                values[x0 + (y0 + 1) * n] += (1 - xt) * yt * wi;
            }
        }
        (0, $0e52bb170b12b86c$export$7671911241d9460b)({
            data: values,
            width: n,
            height: m
        }, r * pow2k);
        return values;
    }
    function density(data) {
        var values = grid(data), tz = threshold(values), pow4k = Math.pow(2, 2 * k);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) tz = (0, $60d8cb9860d70e68$export$2e2bcd8739ae039)(Number.MIN_VALUE, (0, $2a55c062ab1a12b9$export$2e2bcd8739ae039)(values) / pow4k, tz);
        return (0, $ebb8b55bddf1da83$export$2e2bcd8739ae039)().size([
            n,
            m
        ]).thresholds(tz.map((d)=>d * pow4k))(values).map((c, i)=>(c.value = +tz[i], transform(c)));
    }
    density.contours = function(data) {
        var values = grid(data), contours = (0, $ebb8b55bddf1da83$export$2e2bcd8739ae039)().size([
            n,
            m
        ]), pow4k = Math.pow(2, 2 * k), contour = (value)=>{
            value = +value;
            var c = transform(contours.contour(values, value * pow4k));
            c.value = value; // preserve exact threshold value
            return c;
        };
        Object.defineProperty(contour, "max", {
            get: ()=>(0, $2a55c062ab1a12b9$export$2e2bcd8739ae039)(values) / pow4k
        });
        return contour;
    };
    function transform(geometry) {
        geometry.coordinates.forEach(transformPolygon);
        return geometry;
    }
    function transformPolygon(coordinates) {
        coordinates.forEach(transformRing);
    }
    function transformRing(coordinates) {
        coordinates.forEach(transformPoint);
    }
    // TODO Optimize.
    function transformPoint(coordinates) {
        coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
        coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
    }
    function resize() {
        o = r * 3;
        n = dx + o * 2 >> k;
        m = dy + o * 2 >> k;
        return density;
    }
    density.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $86aa7bc3b611ed7b$export$2e2bcd8739ae039)(+_), density) : x;
    };
    density.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $86aa7bc3b611ed7b$export$2e2bcd8739ae039)(+_), density) : y;
    };
    density.weight = function(_) {
        return arguments.length ? (weight = typeof _ === "function" ? _ : (0, $86aa7bc3b611ed7b$export$2e2bcd8739ae039)(+_), density) : weight;
    };
    density.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = +_[0], _1 = +_[1];
        if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
        return dx = _0, dy = _1, resize();
    };
    density.cellSize = function(_) {
        if (!arguments.length) return 1 << k;
        if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
        return k = Math.floor(Math.log(_) / Math.LN2), resize();
    };
    density.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $86aa7bc3b611ed7b$export$2e2bcd8739ae039)((0, $8bd26702d8339be6$export$58adb3bec8346d0f).call(_)) : (0, $86aa7bc3b611ed7b$export$2e2bcd8739ae039)(_), density) : threshold;
    };
    density.bandwidth = function(_) {
        if (!arguments.length) return Math.sqrt(r * (r + 1));
        if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
        return r = (Math.sqrt(4 * _ * _ + 1) - 1) / 2, resize();
    };
    return density;
}




var $1b1f70ef6d514e40$exports = {};

$parcel$export($1b1f70ef6d514e40$exports, "Delaunay", () => $3dd77de0651120db$export$2e2bcd8739ae039);
$parcel$export($1b1f70ef6d514e40$exports, "Voronoi", () => $32af31d415bb652f$export$2e2bcd8739ae039);
const $13af0ee187f1d7e9$export$6c421550c66a327d = 1.1102230246251565e-16;
const $13af0ee187f1d7e9$export$8cfde575cbd41e40 = 134217729;
const $13af0ee187f1d7e9$export$a4103c3ab16b06d7 = (3 + 8 * $13af0ee187f1d7e9$export$6c421550c66a327d) * $13af0ee187f1d7e9$export$6c421550c66a327d;
function $13af0ee187f1d7e9$export$8a63f25cc62965f1(elen, e, flen, f, h) {
    let Q, Qnew, hh, bvirt;
    let enow = e[0];
    let fnow = f[0];
    let eindex = 0;
    let findex = 0;
    if (fnow > enow === fnow > -enow) {
        Q = enow;
        enow = e[++eindex];
    } else {
        Q = fnow;
        fnow = f[++findex];
    }
    let hindex = 0;
    if (eindex < elen && findex < flen) {
        if (fnow > enow === fnow > -enow) {
            Qnew = enow + Q;
            hh = Q - (Qnew - enow);
            enow = e[++eindex];
        } else {
            Qnew = fnow + Q;
            hh = Q - (Qnew - fnow);
            fnow = f[++findex];
        }
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
        while(eindex < elen && findex < flen){
            if (fnow > enow === fnow > -enow) {
                Qnew = Q + enow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (enow - bvirt);
                enow = e[++eindex];
            } else {
                Qnew = Q + fnow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
    }
    while(eindex < elen){
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    while(findex < flen){
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f[++findex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function $13af0ee187f1d7e9$export$195a93e4bd4d876f(alen, a, blen, b, clen, c, tmp, out) {
    return $13af0ee187f1d7e9$export$8a63f25cc62965f1($13af0ee187f1d7e9$export$8a63f25cc62965f1(alen, a, blen, b, tmp), tmp, clen, c, out);
}
function $13af0ee187f1d7e9$export$dcdf75081b88279d(elen, e, b, h) {
    let Q, sum, hh, product1, product0;
    let bvirt, c, ahi, alo, bhi, blo;
    c = $13af0ee187f1d7e9$export$8cfde575cbd41e40 * b;
    bhi = c - (c - b);
    blo = b - bhi;
    let enow = e[0];
    Q = enow * b;
    c = $13af0ee187f1d7e9$export$8cfde575cbd41e40 * enow;
    ahi = c - (c - enow);
    alo = enow - ahi;
    hh = alo * blo - (Q - ahi * bhi - alo * bhi - ahi * blo);
    let hindex = 0;
    if (hh !== 0) h[hindex++] = hh;
    for(let i = 1; i < elen; i++){
        enow = e[i];
        product1 = enow * b;
        c = $13af0ee187f1d7e9$export$8cfde575cbd41e40 * enow;
        ahi = c - (c - enow);
        alo = enow - ahi;
        product0 = alo * blo - (product1 - ahi * bhi - alo * bhi - ahi * blo);
        sum = Q + product0;
        bvirt = sum - Q;
        hh = Q - (sum - bvirt) + (product0 - bvirt);
        if (hh !== 0) h[hindex++] = hh;
        Q = product1 + sum;
        hh = sum - (Q - product1);
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function $13af0ee187f1d7e9$export$aef51622e549b8b0(elen, e) {
    for(let i = 0; i < elen; i++)e[i] = -e[i];
    return elen;
}
function $13af0ee187f1d7e9$export$9f3a0795ca2cc944(elen, e) {
    let Q = e[0];
    for(let i = 1; i < elen; i++)Q += e[i];
    return Q;
}
function $13af0ee187f1d7e9$export$202e0172ed3c7be0(n) {
    return new Float64Array(n);
}


const $1126cb99c30e80cc$var$ccwerrboundA = (3 + 16 * (0, $13af0ee187f1d7e9$export$6c421550c66a327d)) * (0, $13af0ee187f1d7e9$export$6c421550c66a327d);
const $1126cb99c30e80cc$var$ccwerrboundB = (2 + 12 * (0, $13af0ee187f1d7e9$export$6c421550c66a327d)) * (0, $13af0ee187f1d7e9$export$6c421550c66a327d);
const $1126cb99c30e80cc$var$ccwerrboundC = (9 + 64 * (0, $13af0ee187f1d7e9$export$6c421550c66a327d)) * (0, $13af0ee187f1d7e9$export$6c421550c66a327d) * (0, $13af0ee187f1d7e9$export$6c421550c66a327d);
const $1126cb99c30e80cc$var$B = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $1126cb99c30e80cc$var$C1 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $1126cb99c30e80cc$var$C2 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(12);
const $1126cb99c30e80cc$var$D = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(16);
const $1126cb99c30e80cc$var$u = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
function $1126cb99c30e80cc$var$orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
    let acxtail, acytail, bcxtail, bcytail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const acx = ax - cx;
    const bcx = bx - cx;
    const acy = ay - cy;
    const bcy = by - cy;
    s1 = acx * bcy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcx;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $1126cb99c30e80cc$var$B[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $1126cb99c30e80cc$var$B[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $1126cb99c30e80cc$var$B[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $1126cb99c30e80cc$var$B[3] = u3;
    let det = (0, $13af0ee187f1d7e9$export$9f3a0795ca2cc944)(4, $1126cb99c30e80cc$var$B);
    let errbound = $1126cb99c30e80cc$var$ccwerrboundB * detsum;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - acx;
    acxtail = ax - (acx + bvirt) + (bvirt - cx);
    bvirt = bx - bcx;
    bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
    bvirt = ay - acy;
    acytail = ay - (acy + bvirt) + (bvirt - cy);
    bvirt = by - bcy;
    bcytail = by - (bcy + bvirt) + (bvirt - cy);
    if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
    errbound = $1126cb99c30e80cc$var$ccwerrboundC * detsum + (0, $13af0ee187f1d7e9$export$a4103c3ab16b06d7) * Math.abs(det);
    det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
    if (det >= errbound || -det >= errbound) return det;
    s1 = acxtail * bcy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcx;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $1126cb99c30e80cc$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $1126cb99c30e80cc$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $1126cb99c30e80cc$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $1126cb99c30e80cc$var$u[3] = u3;
    const C1len = (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)(4, $1126cb99c30e80cc$var$B, 4, $1126cb99c30e80cc$var$u, $1126cb99c30e80cc$var$C1);
    s1 = acx * bcytail;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcxtail;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $1126cb99c30e80cc$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $1126cb99c30e80cc$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $1126cb99c30e80cc$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $1126cb99c30e80cc$var$u[3] = u3;
    const C2len = (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)(C1len, $1126cb99c30e80cc$var$C1, 4, $1126cb99c30e80cc$var$u, $1126cb99c30e80cc$var$C2);
    s1 = acxtail * bcytail;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcxtail;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $1126cb99c30e80cc$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $1126cb99c30e80cc$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $1126cb99c30e80cc$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $1126cb99c30e80cc$var$u[3] = u3;
    const Dlen = (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)(C2len, $1126cb99c30e80cc$var$C2, 4, $1126cb99c30e80cc$var$u, $1126cb99c30e80cc$var$D);
    return $1126cb99c30e80cc$var$D[Dlen - 1];
}
function $1126cb99c30e80cc$export$bbb923599a46a7d8(ax, ay, bx, by, cx, cy) {
    const detleft = (ay - cy) * (bx - cx);
    const detright = (ax - cx) * (by - cy);
    const det = detleft - detright;
    const detsum = Math.abs(detleft + detright);
    if (Math.abs(det) >= $1126cb99c30e80cc$var$ccwerrboundA * detsum) return det;
    return -$1126cb99c30e80cc$var$orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
}
function $1126cb99c30e80cc$export$c42fd1bc0c0a7484(ax, ay, bx, by, cx, cy) {
    return (ay - cy) * (bx - cx) - (ax - cx) * (by - cy);
}



const $70547814c9f36352$var$o3derrboundA = (7 + 56 * (0, $13af0ee187f1d7e9$export$6c421550c66a327d)) * (0, $13af0ee187f1d7e9$export$6c421550c66a327d);
const $70547814c9f36352$var$o3derrboundB = (3 + 28 * (0, $13af0ee187f1d7e9$export$6c421550c66a327d)) * (0, $13af0ee187f1d7e9$export$6c421550c66a327d);
const $70547814c9f36352$var$o3derrboundC = (26 + 288 * (0, $13af0ee187f1d7e9$export$6c421550c66a327d)) * (0, $13af0ee187f1d7e9$export$6c421550c66a327d) * (0, $13af0ee187f1d7e9$export$6c421550c66a327d);
const $70547814c9f36352$var$bc = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $70547814c9f36352$var$ca = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $70547814c9f36352$var$ab = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $70547814c9f36352$var$at_b = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $70547814c9f36352$var$at_c = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $70547814c9f36352$var$bt_c = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $70547814c9f36352$var$bt_a = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $70547814c9f36352$var$ct_a = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $70547814c9f36352$var$ct_b = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $70547814c9f36352$var$bct = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $70547814c9f36352$var$cat = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $70547814c9f36352$var$abt = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $70547814c9f36352$var$u = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $70547814c9f36352$var$_8 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $70547814c9f36352$var$_8b = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $70547814c9f36352$var$_16 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $70547814c9f36352$var$_12 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(12);
let $70547814c9f36352$var$fin = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(192);
let $70547814c9f36352$var$fin2 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(192);
function $70547814c9f36352$var$finadd(finlen, alen, a) {
    finlen = (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)(finlen, $70547814c9f36352$var$fin, alen, a, $70547814c9f36352$var$fin2);
    const tmp = $70547814c9f36352$var$fin;
    $70547814c9f36352$var$fin = $70547814c9f36352$var$fin2;
    $70547814c9f36352$var$fin2 = tmp;
    return finlen;
}
function $70547814c9f36352$var$tailinit(xtail, ytail, ax, ay, bx, by, a, b) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3, negate;
    if (xtail === 0) {
        if (ytail === 0) {
            a[0] = 0;
            b[0] = 0;
            return 1;
        } else {
            negate = -ytail;
            s1 = negate * ax;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * negate;
            ahi = c - (c - negate);
            alo = negate - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ax;
            bhi = c - (c - ax);
            blo = ax - bhi;
            a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            a[1] = s1;
            s1 = ytail * bx;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ytail;
            ahi = c - (c - ytail);
            alo = ytail - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bx;
            bhi = c - (c - bx);
            blo = bx - bhi;
            b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            b[1] = s1;
            return 2;
        }
    } else if (ytail === 0) {
        s1 = xtail * ay;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        a[1] = s1;
        negate = -xtail;
        s1 = negate * by;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * negate;
        ahi = c - (c - negate);
        alo = negate - ahi;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        b[1] = s1;
        return 2;
    } else {
        s1 = xtail * ay;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = ytail * ax;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ax;
        bhi = c - (c - ax);
        blo = ax - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        a[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        a[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        a[2] = _j - (u3 - bvirt) + (_i - bvirt);
        a[3] = u3;
        s1 = ytail * bx;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bx;
        bhi = c - (c - bx);
        blo = bx - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = xtail * by;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        b[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        b[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        b[2] = _j - (u3 - bvirt) + (_i - bvirt);
        b[3] = u3;
        return 4;
    }
}
function $70547814c9f36352$var$tailadd(finlen, a, b, k, z) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, u3;
    s1 = a * b;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * a;
    ahi = c - (c - a);
    alo = a - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * b;
    bhi = c - (c - b);
    blo = b - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * k;
    bhi = c - (c - k);
    blo = k - bhi;
    _i = s0 * k;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * s0;
    ahi = c - (c - s0);
    alo = s0 - ahi;
    $70547814c9f36352$var$u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
    _j = s1 * k;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * s1;
    ahi = c - (c - s1);
    alo = s1 - ahi;
    _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
    _k = _i + _0;
    bvirt = _k - _i;
    $70547814c9f36352$var$u[1] = _i - (_k - bvirt) + (_0 - bvirt);
    u3 = _j + _k;
    $70547814c9f36352$var$u[2] = _k - (u3 - _j);
    $70547814c9f36352$var$u[3] = u3;
    finlen = $70547814c9f36352$var$finadd(finlen, 4, $70547814c9f36352$var$u);
    if (z !== 0) {
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * z;
        bhi = c - (c - z);
        blo = z - bhi;
        _i = s0 * z;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * s0;
        ahi = c - (c - s0);
        alo = s0 - ahi;
        $70547814c9f36352$var$u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
        _j = s1 * z;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * s1;
        ahi = c - (c - s1);
        alo = s1 - ahi;
        _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
        _k = _i + _0;
        bvirt = _k - _i;
        $70547814c9f36352$var$u[1] = _i - (_k - bvirt) + (_0 - bvirt);
        u3 = _j + _k;
        $70547814c9f36352$var$u[2] = _k - (u3 - _j);
        $70547814c9f36352$var$u[3] = u3;
        finlen = $70547814c9f36352$var$finadd(finlen, 4, $70547814c9f36352$var$u);
    }
    return finlen;
}
function $70547814c9f36352$var$orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail;
    let adytail, bdytail, cdytail;
    let adztail, bdztail, cdztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    s1 = bdx * cdy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $70547814c9f36352$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $70547814c9f36352$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $70547814c9f36352$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $70547814c9f36352$var$bc[3] = u3;
    s1 = cdx * ady;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $70547814c9f36352$var$ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $70547814c9f36352$var$ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $70547814c9f36352$var$ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $70547814c9f36352$var$ca[3] = u3;
    s1 = adx * bdy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $70547814c9f36352$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $70547814c9f36352$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $70547814c9f36352$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $70547814c9f36352$var$ab[3] = u3;
    finlen = (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)((0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $70547814c9f36352$var$bc, adz, $70547814c9f36352$var$_8), $70547814c9f36352$var$_8, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $70547814c9f36352$var$ca, bdz, $70547814c9f36352$var$_8b), $70547814c9f36352$var$_8b, $70547814c9f36352$var$_16), $70547814c9f36352$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $70547814c9f36352$var$ab, cdz, $70547814c9f36352$var$_8), $70547814c9f36352$var$_8, $70547814c9f36352$var$fin);
    let det = (0, $13af0ee187f1d7e9$export$9f3a0795ca2cc944)(finlen, $70547814c9f36352$var$fin);
    let errbound = $70547814c9f36352$var$o3derrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    bvirt = az - adz;
    adztail = az - (adz + bvirt) + (bvirt - dz);
    bvirt = bz - bdz;
    bdztail = bz - (bdz + bvirt) + (bvirt - dz);
    bvirt = cz - cdz;
    cdztail = cz - (cdz + bvirt) + (bvirt - dz);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0 && adztail === 0 && bdztail === 0 && cdztail === 0) return det;
    errbound = $70547814c9f36352$var$o3derrboundC * permanent + (0, $13af0ee187f1d7e9$export$a4103c3ab16b06d7) * Math.abs(det);
    det += adz * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + adztail * (bdx * cdy - bdy * cdx) + bdz * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + bdztail * (cdx * ady - cdy * adx) + cdz * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + cdztail * (adx * bdy - ady * bdx);
    if (det >= errbound || -det >= errbound) return det;
    const at_len = $70547814c9f36352$var$tailinit(adxtail, adytail, bdx, bdy, cdx, cdy, $70547814c9f36352$var$at_b, $70547814c9f36352$var$at_c);
    const bt_len = $70547814c9f36352$var$tailinit(bdxtail, bdytail, cdx, cdy, adx, ady, $70547814c9f36352$var$bt_c, $70547814c9f36352$var$bt_a);
    const ct_len = $70547814c9f36352$var$tailinit(cdxtail, cdytail, adx, ady, bdx, bdy, $70547814c9f36352$var$ct_a, $70547814c9f36352$var$ct_b);
    const bctlen = (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)(bt_len, $70547814c9f36352$var$bt_c, ct_len, $70547814c9f36352$var$ct_b, $70547814c9f36352$var$bct);
    finlen = $70547814c9f36352$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(bctlen, $70547814c9f36352$var$bct, adz, $70547814c9f36352$var$_16), $70547814c9f36352$var$_16);
    const catlen = (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)(ct_len, $70547814c9f36352$var$ct_a, at_len, $70547814c9f36352$var$at_c, $70547814c9f36352$var$cat);
    finlen = $70547814c9f36352$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(catlen, $70547814c9f36352$var$cat, bdz, $70547814c9f36352$var$_16), $70547814c9f36352$var$_16);
    const abtlen = (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)(at_len, $70547814c9f36352$var$at_b, bt_len, $70547814c9f36352$var$bt_a, $70547814c9f36352$var$abt);
    finlen = $70547814c9f36352$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(abtlen, $70547814c9f36352$var$abt, cdz, $70547814c9f36352$var$_16), $70547814c9f36352$var$_16);
    if (adztail !== 0) {
        finlen = $70547814c9f36352$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $70547814c9f36352$var$bc, adztail, $70547814c9f36352$var$_12), $70547814c9f36352$var$_12);
        finlen = $70547814c9f36352$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(bctlen, $70547814c9f36352$var$bct, adztail, $70547814c9f36352$var$_16), $70547814c9f36352$var$_16);
    }
    if (bdztail !== 0) {
        finlen = $70547814c9f36352$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $70547814c9f36352$var$ca, bdztail, $70547814c9f36352$var$_12), $70547814c9f36352$var$_12);
        finlen = $70547814c9f36352$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(catlen, $70547814c9f36352$var$cat, bdztail, $70547814c9f36352$var$_16), $70547814c9f36352$var$_16);
    }
    if (cdztail !== 0) {
        finlen = $70547814c9f36352$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $70547814c9f36352$var$ab, cdztail, $70547814c9f36352$var$_12), $70547814c9f36352$var$_12);
        finlen = $70547814c9f36352$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(abtlen, $70547814c9f36352$var$abt, cdztail, $70547814c9f36352$var$_16), $70547814c9f36352$var$_16);
    }
    if (adxtail !== 0) {
        if (bdytail !== 0) finlen = $70547814c9f36352$var$tailadd(finlen, adxtail, bdytail, cdz, cdztail);
        if (cdytail !== 0) finlen = $70547814c9f36352$var$tailadd(finlen, -adxtail, cdytail, bdz, bdztail);
    }
    if (bdxtail !== 0) {
        if (cdytail !== 0) finlen = $70547814c9f36352$var$tailadd(finlen, bdxtail, cdytail, adz, adztail);
        if (adytail !== 0) finlen = $70547814c9f36352$var$tailadd(finlen, -bdxtail, adytail, cdz, cdztail);
    }
    if (cdxtail !== 0) {
        if (adytail !== 0) finlen = $70547814c9f36352$var$tailadd(finlen, cdxtail, adytail, bdz, bdztail);
        if (bdytail !== 0) finlen = $70547814c9f36352$var$tailadd(finlen, -cdxtail, bdytail, adz, adztail);
    }
    return $70547814c9f36352$var$fin[finlen - 1];
}
function $70547814c9f36352$export$248ff23af2e93e3e(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
    const errbound = $70547814c9f36352$var$o3derrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return $70547814c9f36352$var$orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent);
}
function $70547814c9f36352$export$407220085d2c43a5(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    return adx * (bdy * cdz - bdz * cdy) + bdx * (cdy * adz - cdz * ady) + cdx * (ady * bdz - adz * bdy);
}



const $6cac593a01268d0d$var$iccerrboundA = (10 + 96 * (0, $13af0ee187f1d7e9$export$6c421550c66a327d)) * (0, $13af0ee187f1d7e9$export$6c421550c66a327d);
const $6cac593a01268d0d$var$iccerrboundB = (4 + 48 * (0, $13af0ee187f1d7e9$export$6c421550c66a327d)) * (0, $13af0ee187f1d7e9$export$6c421550c66a327d);
const $6cac593a01268d0d$var$iccerrboundC = (44 + 576 * (0, $13af0ee187f1d7e9$export$6c421550c66a327d)) * (0, $13af0ee187f1d7e9$export$6c421550c66a327d) * (0, $13af0ee187f1d7e9$export$6c421550c66a327d);
const $6cac593a01268d0d$var$bc = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $6cac593a01268d0d$var$ca = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $6cac593a01268d0d$var$ab = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $6cac593a01268d0d$var$aa = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $6cac593a01268d0d$var$bb = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $6cac593a01268d0d$var$cc = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $6cac593a01268d0d$var$u = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $6cac593a01268d0d$var$v = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $6cac593a01268d0d$var$axtbc = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $6cac593a01268d0d$var$aytbc = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $6cac593a01268d0d$var$bxtca = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $6cac593a01268d0d$var$bytca = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $6cac593a01268d0d$var$cxtab = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $6cac593a01268d0d$var$cytab = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $6cac593a01268d0d$var$abt = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $6cac593a01268d0d$var$bct = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $6cac593a01268d0d$var$cat = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $6cac593a01268d0d$var$abtt = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $6cac593a01268d0d$var$bctt = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $6cac593a01268d0d$var$catt = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $6cac593a01268d0d$var$_8 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $6cac593a01268d0d$var$_16 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(16);
const $6cac593a01268d0d$var$_16b = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(16);
const $6cac593a01268d0d$var$_16c = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(16);
const $6cac593a01268d0d$var$_32 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(32);
const $6cac593a01268d0d$var$_32b = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(32);
const $6cac593a01268d0d$var$_48 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(48);
const $6cac593a01268d0d$var$_64 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(64);
let $6cac593a01268d0d$var$fin = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(1152);
let $6cac593a01268d0d$var$fin2 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(1152);
function $6cac593a01268d0d$var$finadd(finlen, a, alen) {
    finlen = (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)(finlen, $6cac593a01268d0d$var$fin, a, alen, $6cac593a01268d0d$var$fin2);
    const tmp = $6cac593a01268d0d$var$fin;
    $6cac593a01268d0d$var$fin = $6cac593a01268d0d$var$fin2;
    $6cac593a01268d0d$var$fin2 = tmp;
    return finlen;
}
function $6cac593a01268d0d$var$incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail, adytail, bdytail, cdytail;
    let axtbclen, aytbclen, bxtcalen, bytcalen, cxtablen, cytablen;
    let abtlen, bctlen, catlen;
    let abttlen, bcttlen, cattlen;
    let n1, n0;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    s1 = bdx * cdy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $6cac593a01268d0d$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $6cac593a01268d0d$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $6cac593a01268d0d$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $6cac593a01268d0d$var$bc[3] = u3;
    s1 = cdx * ady;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $6cac593a01268d0d$var$ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $6cac593a01268d0d$var$ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $6cac593a01268d0d$var$ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $6cac593a01268d0d$var$ca[3] = u3;
    s1 = adx * bdy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $6cac593a01268d0d$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $6cac593a01268d0d$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $6cac593a01268d0d$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $6cac593a01268d0d$var$ab[3] = u3;
    finlen = (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)((0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)((0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$bc, adx, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, adx, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$bc, ady, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, ady, $6cac593a01268d0d$var$_16b), $6cac593a01268d0d$var$_16b, $6cac593a01268d0d$var$_32), $6cac593a01268d0d$var$_32, (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$ca, bdx, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, bdx, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$ca, bdy, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, bdy, $6cac593a01268d0d$var$_16b), $6cac593a01268d0d$var$_16b, $6cac593a01268d0d$var$_32b), $6cac593a01268d0d$var$_32b, $6cac593a01268d0d$var$_64), $6cac593a01268d0d$var$_64, (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$ab, cdx, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, cdx, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$ab, cdy, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, cdy, $6cac593a01268d0d$var$_16b), $6cac593a01268d0d$var$_16b, $6cac593a01268d0d$var$_32), $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$fin);
    let det = (0, $13af0ee187f1d7e9$export$9f3a0795ca2cc944)(finlen, $6cac593a01268d0d$var$fin);
    let errbound = $6cac593a01268d0d$var$iccerrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0) return det;
    errbound = $6cac593a01268d0d$var$iccerrboundC * permanent + (0, $13af0ee187f1d7e9$export$a4103c3ab16b06d7) * Math.abs(det);
    det += (adx * adx + ady * ady) * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + 2 * (adx * adxtail + ady * adytail) * (bdx * cdy - bdy * cdx) + ((bdx * bdx + bdy * bdy) * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + 2 * (bdx * bdxtail + bdy * bdytail) * (cdx * ady - cdy * adx)) + ((cdx * cdx + cdy * cdy) * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + 2 * (cdx * cdxtail + cdy * cdytail) * (adx * bdy - ady * bdx));
    if (det >= errbound || -det >= errbound) return det;
    if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
        s1 = adx * adx;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * adx;
        ahi = c - (c - adx);
        alo = adx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = ady * ady;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ady;
        ahi = c - (c - ady);
        alo = ady - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $6cac593a01268d0d$var$aa[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $6cac593a01268d0d$var$aa[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $6cac593a01268d0d$var$aa[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $6cac593a01268d0d$var$aa[3] = u3;
    }
    if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
        s1 = bdx * bdx;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdx;
        ahi = c - (c - bdx);
        alo = bdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = bdy * bdy;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdy;
        ahi = c - (c - bdy);
        alo = bdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $6cac593a01268d0d$var$bb[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $6cac593a01268d0d$var$bb[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $6cac593a01268d0d$var$bb[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $6cac593a01268d0d$var$bb[3] = u3;
    }
    if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
        s1 = cdx * cdx;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdx;
        ahi = c - (c - cdx);
        alo = cdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = cdy * cdy;
        c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdy;
        ahi = c - (c - cdy);
        alo = cdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $6cac593a01268d0d$var$cc[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $6cac593a01268d0d$var$cc[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $6cac593a01268d0d$var$cc[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $6cac593a01268d0d$var$cc[3] = u3;
    }
    if (adxtail !== 0) {
        axtbclen = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$bc, adxtail, $6cac593a01268d0d$var$axtbc);
        finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$195a93e4bd4d876f)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(axtbclen, $6cac593a01268d0d$var$axtbc, 2 * adx, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$cc, adxtail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, bdy, $6cac593a01268d0d$var$_16b), $6cac593a01268d0d$var$_16b, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$bb, adxtail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, -cdy, $6cac593a01268d0d$var$_16c), $6cac593a01268d0d$var$_16c, $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_48), $6cac593a01268d0d$var$_48);
    }
    if (adytail !== 0) {
        aytbclen = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$bc, adytail, $6cac593a01268d0d$var$aytbc);
        finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$195a93e4bd4d876f)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(aytbclen, $6cac593a01268d0d$var$aytbc, 2 * ady, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$bb, adytail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, cdx, $6cac593a01268d0d$var$_16b), $6cac593a01268d0d$var$_16b, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$cc, adytail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, -bdx, $6cac593a01268d0d$var$_16c), $6cac593a01268d0d$var$_16c, $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_48), $6cac593a01268d0d$var$_48);
    }
    if (bdxtail !== 0) {
        bxtcalen = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$ca, bdxtail, $6cac593a01268d0d$var$bxtca);
        finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$195a93e4bd4d876f)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(bxtcalen, $6cac593a01268d0d$var$bxtca, 2 * bdx, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$aa, bdxtail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, cdy, $6cac593a01268d0d$var$_16b), $6cac593a01268d0d$var$_16b, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$cc, bdxtail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, -ady, $6cac593a01268d0d$var$_16c), $6cac593a01268d0d$var$_16c, $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_48), $6cac593a01268d0d$var$_48);
    }
    if (bdytail !== 0) {
        bytcalen = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$ca, bdytail, $6cac593a01268d0d$var$bytca);
        finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$195a93e4bd4d876f)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(bytcalen, $6cac593a01268d0d$var$bytca, 2 * bdy, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$cc, bdytail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, adx, $6cac593a01268d0d$var$_16b), $6cac593a01268d0d$var$_16b, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$aa, bdytail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, -cdx, $6cac593a01268d0d$var$_16c), $6cac593a01268d0d$var$_16c, $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_48), $6cac593a01268d0d$var$_48);
    }
    if (cdxtail !== 0) {
        cxtablen = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$ab, cdxtail, $6cac593a01268d0d$var$cxtab);
        finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$195a93e4bd4d876f)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(cxtablen, $6cac593a01268d0d$var$cxtab, 2 * cdx, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$bb, cdxtail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, ady, $6cac593a01268d0d$var$_16b), $6cac593a01268d0d$var$_16b, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$aa, cdxtail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, -bdy, $6cac593a01268d0d$var$_16c), $6cac593a01268d0d$var$_16c, $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_48), $6cac593a01268d0d$var$_48);
    }
    if (cdytail !== 0) {
        cytablen = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$ab, cdytail, $6cac593a01268d0d$var$cytab);
        finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$195a93e4bd4d876f)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(cytablen, $6cac593a01268d0d$var$cytab, 2 * cdy, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$aa, cdytail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, bdx, $6cac593a01268d0d$var$_16b), $6cac593a01268d0d$var$_16b, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$bb, cdytail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, -adx, $6cac593a01268d0d$var$_16c), $6cac593a01268d0d$var$_16c, $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_48), $6cac593a01268d0d$var$_48);
    }
    if (adxtail !== 0 || adytail !== 0) {
        if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
            s1 = bdxtail * cdy;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdy;
            bhi = c - (c - cdy);
            blo = cdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * cdytail;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $6cac593a01268d0d$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $6cac593a01268d0d$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $6cac593a01268d0d$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $6cac593a01268d0d$var$u[3] = u3;
            s1 = cdxtail * -bdy;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * -bdy;
            bhi = c - (c - -bdy);
            blo = -bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * -bdytail;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * -bdytail;
            bhi = c - (c - -bdytail);
            blo = -bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $6cac593a01268d0d$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $6cac593a01268d0d$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $6cac593a01268d0d$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $6cac593a01268d0d$var$v[3] = u3;
            bctlen = (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)(4, $6cac593a01268d0d$var$u, 4, $6cac593a01268d0d$var$v, $6cac593a01268d0d$var$bct);
            s1 = bdxtail * cdytail;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdxtail * bdytail;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $6cac593a01268d0d$var$bctt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $6cac593a01268d0d$var$bctt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $6cac593a01268d0d$var$bctt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $6cac593a01268d0d$var$bctt[3] = u3;
            bcttlen = 4;
        } else {
            $6cac593a01268d0d$var$bct[0] = 0;
            bctlen = 1;
            $6cac593a01268d0d$var$bctt[0] = 0;
            bcttlen = 1;
        }
        if (adxtail !== 0) {
            const len = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(bctlen, $6cac593a01268d0d$var$bct, adxtail, $6cac593a01268d0d$var$_16c);
            finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(axtbclen, $6cac593a01268d0d$var$axtbc, adxtail, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $6cac593a01268d0d$var$_16c, 2 * adx, $6cac593a01268d0d$var$_32), $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_48), $6cac593a01268d0d$var$_48);
            const len2 = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(bcttlen, $6cac593a01268d0d$var$bctt, adxtail, $6cac593a01268d0d$var$_8);
            finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$195a93e4bd4d876f)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len2, $6cac593a01268d0d$var$_8, 2 * adx, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len2, $6cac593a01268d0d$var$_8, adxtail, $6cac593a01268d0d$var$_16b), $6cac593a01268d0d$var$_16b, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $6cac593a01268d0d$var$_16c, adxtail, $6cac593a01268d0d$var$_32), $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_32b, $6cac593a01268d0d$var$_64), $6cac593a01268d0d$var$_64);
            if (bdytail !== 0) finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$cc, adxtail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, bdytail, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16);
            if (cdytail !== 0) finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$bb, -adxtail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, cdytail, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16);
        }
        if (adytail !== 0) {
            const len = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(bctlen, $6cac593a01268d0d$var$bct, adytail, $6cac593a01268d0d$var$_16c);
            finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(aytbclen, $6cac593a01268d0d$var$aytbc, adytail, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $6cac593a01268d0d$var$_16c, 2 * ady, $6cac593a01268d0d$var$_32), $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_48), $6cac593a01268d0d$var$_48);
            const len2 = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(bcttlen, $6cac593a01268d0d$var$bctt, adytail, $6cac593a01268d0d$var$_8);
            finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$195a93e4bd4d876f)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len2, $6cac593a01268d0d$var$_8, 2 * ady, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len2, $6cac593a01268d0d$var$_8, adytail, $6cac593a01268d0d$var$_16b), $6cac593a01268d0d$var$_16b, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $6cac593a01268d0d$var$_16c, adytail, $6cac593a01268d0d$var$_32), $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_32b, $6cac593a01268d0d$var$_64), $6cac593a01268d0d$var$_64);
        }
    }
    if (bdxtail !== 0 || bdytail !== 0) {
        if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
            s1 = cdxtail * ady;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ady;
            bhi = c - (c - ady);
            blo = ady - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * adytail;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $6cac593a01268d0d$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $6cac593a01268d0d$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $6cac593a01268d0d$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $6cac593a01268d0d$var$u[3] = u3;
            n1 = -cdy;
            n0 = -cdytail;
            s1 = adxtail * n1;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * n0;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $6cac593a01268d0d$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $6cac593a01268d0d$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $6cac593a01268d0d$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $6cac593a01268d0d$var$v[3] = u3;
            catlen = (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)(4, $6cac593a01268d0d$var$u, 4, $6cac593a01268d0d$var$v, $6cac593a01268d0d$var$cat);
            s1 = cdxtail * adytail;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adxtail * cdytail;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $6cac593a01268d0d$var$catt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $6cac593a01268d0d$var$catt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $6cac593a01268d0d$var$catt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $6cac593a01268d0d$var$catt[3] = u3;
            cattlen = 4;
        } else {
            $6cac593a01268d0d$var$cat[0] = 0;
            catlen = 1;
            $6cac593a01268d0d$var$catt[0] = 0;
            cattlen = 1;
        }
        if (bdxtail !== 0) {
            const len = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(catlen, $6cac593a01268d0d$var$cat, bdxtail, $6cac593a01268d0d$var$_16c);
            finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(bxtcalen, $6cac593a01268d0d$var$bxtca, bdxtail, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $6cac593a01268d0d$var$_16c, 2 * bdx, $6cac593a01268d0d$var$_32), $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_48), $6cac593a01268d0d$var$_48);
            const len2 = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(cattlen, $6cac593a01268d0d$var$catt, bdxtail, $6cac593a01268d0d$var$_8);
            finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$195a93e4bd4d876f)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len2, $6cac593a01268d0d$var$_8, 2 * bdx, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len2, $6cac593a01268d0d$var$_8, bdxtail, $6cac593a01268d0d$var$_16b), $6cac593a01268d0d$var$_16b, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $6cac593a01268d0d$var$_16c, bdxtail, $6cac593a01268d0d$var$_32), $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_32b, $6cac593a01268d0d$var$_64), $6cac593a01268d0d$var$_64);
            if (cdytail !== 0) finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$aa, bdxtail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, cdytail, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16);
            if (adytail !== 0) finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$cc, -bdxtail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, adytail, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16);
        }
        if (bdytail !== 0) {
            const len = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(catlen, $6cac593a01268d0d$var$cat, bdytail, $6cac593a01268d0d$var$_16c);
            finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(bytcalen, $6cac593a01268d0d$var$bytca, bdytail, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $6cac593a01268d0d$var$_16c, 2 * bdy, $6cac593a01268d0d$var$_32), $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_48), $6cac593a01268d0d$var$_48);
            const len2 = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(cattlen, $6cac593a01268d0d$var$catt, bdytail, $6cac593a01268d0d$var$_8);
            finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$195a93e4bd4d876f)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len2, $6cac593a01268d0d$var$_8, 2 * bdy, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len2, $6cac593a01268d0d$var$_8, bdytail, $6cac593a01268d0d$var$_16b), $6cac593a01268d0d$var$_16b, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $6cac593a01268d0d$var$_16c, bdytail, $6cac593a01268d0d$var$_32), $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_32b, $6cac593a01268d0d$var$_64), $6cac593a01268d0d$var$_64);
        }
    }
    if (cdxtail !== 0 || cdytail !== 0) {
        if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
            s1 = adxtail * bdy;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdy;
            bhi = c - (c - bdy);
            blo = bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * bdytail;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $6cac593a01268d0d$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $6cac593a01268d0d$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $6cac593a01268d0d$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $6cac593a01268d0d$var$u[3] = u3;
            n1 = -ady;
            n0 = -adytail;
            s1 = bdxtail * n1;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * n0;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $6cac593a01268d0d$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $6cac593a01268d0d$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $6cac593a01268d0d$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $6cac593a01268d0d$var$v[3] = u3;
            abtlen = (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)(4, $6cac593a01268d0d$var$u, 4, $6cac593a01268d0d$var$v, $6cac593a01268d0d$var$abt);
            s1 = adxtail * bdytail;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdxtail * adytail;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $6cac593a01268d0d$var$abtt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $6cac593a01268d0d$var$abtt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $6cac593a01268d0d$var$abtt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $6cac593a01268d0d$var$abtt[3] = u3;
            abttlen = 4;
        } else {
            $6cac593a01268d0d$var$abt[0] = 0;
            abtlen = 1;
            $6cac593a01268d0d$var$abtt[0] = 0;
            abttlen = 1;
        }
        if (cdxtail !== 0) {
            const len = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(abtlen, $6cac593a01268d0d$var$abt, cdxtail, $6cac593a01268d0d$var$_16c);
            finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(cxtablen, $6cac593a01268d0d$var$cxtab, cdxtail, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $6cac593a01268d0d$var$_16c, 2 * cdx, $6cac593a01268d0d$var$_32), $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_48), $6cac593a01268d0d$var$_48);
            const len2 = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(abttlen, $6cac593a01268d0d$var$abtt, cdxtail, $6cac593a01268d0d$var$_8);
            finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$195a93e4bd4d876f)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len2, $6cac593a01268d0d$var$_8, 2 * cdx, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len2, $6cac593a01268d0d$var$_8, cdxtail, $6cac593a01268d0d$var$_16b), $6cac593a01268d0d$var$_16b, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $6cac593a01268d0d$var$_16c, cdxtail, $6cac593a01268d0d$var$_32), $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_32b, $6cac593a01268d0d$var$_64), $6cac593a01268d0d$var$_64);
            if (adytail !== 0) finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$bb, cdxtail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, adytail, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16);
            if (bdytail !== 0) finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, $6cac593a01268d0d$var$aa, -cdxtail, $6cac593a01268d0d$var$_8), $6cac593a01268d0d$var$_8, bdytail, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16);
        }
        if (cdytail !== 0) {
            const len = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(abtlen, $6cac593a01268d0d$var$abt, cdytail, $6cac593a01268d0d$var$_16c);
            finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(cytablen, $6cac593a01268d0d$var$cytab, cdytail, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $6cac593a01268d0d$var$_16c, 2 * cdy, $6cac593a01268d0d$var$_32), $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_48), $6cac593a01268d0d$var$_48);
            const len2 = (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(abttlen, $6cac593a01268d0d$var$abtt, cdytail, $6cac593a01268d0d$var$_8);
            finlen = $6cac593a01268d0d$var$finadd(finlen, (0, $13af0ee187f1d7e9$export$195a93e4bd4d876f)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len2, $6cac593a01268d0d$var$_8, 2 * cdy, $6cac593a01268d0d$var$_16), $6cac593a01268d0d$var$_16, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len2, $6cac593a01268d0d$var$_8, cdytail, $6cac593a01268d0d$var$_16b), $6cac593a01268d0d$var$_16b, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $6cac593a01268d0d$var$_16c, cdytail, $6cac593a01268d0d$var$_32), $6cac593a01268d0d$var$_32, $6cac593a01268d0d$var$_32b, $6cac593a01268d0d$var$_64), $6cac593a01268d0d$var$_64);
        }
    }
    return $6cac593a01268d0d$var$fin[finlen - 1];
}
function $6cac593a01268d0d$export$454d2cfe884d4dd6(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const alift = adx * adx + ady * ady;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const blift = bdx * bdx + bdy * bdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const clift = cdx * cdx + cdy * cdy;
    const det = alift * (bdxcdy - cdxbdy) + blift * (cdxady - adxcdy) + clift * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * alift + (Math.abs(cdxady) + Math.abs(adxcdy)) * blift + (Math.abs(adxbdy) + Math.abs(bdxady)) * clift;
    const errbound = $6cac593a01268d0d$var$iccerrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return $6cac593a01268d0d$var$incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent);
}
function $6cac593a01268d0d$export$f98e78581b4485e6(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const ady = ay - dy;
    const bdx = bx - dx;
    const bdy = by - dy;
    const cdx = cx - dx;
    const cdy = cy - dy;
    const abdet = adx * bdy - bdx * ady;
    const bcdet = bdx * cdy - cdx * bdy;
    const cadet = cdx * ady - adx * cdy;
    const alift = adx * adx + ady * ady;
    const blift = bdx * bdx + bdy * bdy;
    const clift = cdx * cdx + cdy * cdy;
    return alift * bcdet + blift * cadet + clift * abdet;
}



const $c2d1510c3fc8d2de$var$isperrboundA = (16 + 224 * (0, $13af0ee187f1d7e9$export$6c421550c66a327d)) * (0, $13af0ee187f1d7e9$export$6c421550c66a327d);
const $c2d1510c3fc8d2de$var$isperrboundB = (5 + 72 * (0, $13af0ee187f1d7e9$export$6c421550c66a327d)) * (0, $13af0ee187f1d7e9$export$6c421550c66a327d);
const $c2d1510c3fc8d2de$var$isperrboundC = (71 + 1408 * (0, $13af0ee187f1d7e9$export$6c421550c66a327d)) * (0, $13af0ee187f1d7e9$export$6c421550c66a327d) * (0, $13af0ee187f1d7e9$export$6c421550c66a327d);
const $c2d1510c3fc8d2de$var$ab = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $c2d1510c3fc8d2de$var$bc = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $c2d1510c3fc8d2de$var$cd = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $c2d1510c3fc8d2de$var$de = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $c2d1510c3fc8d2de$var$ea = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $c2d1510c3fc8d2de$var$ac = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $c2d1510c3fc8d2de$var$bd = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $c2d1510c3fc8d2de$var$ce = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $c2d1510c3fc8d2de$var$da = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $c2d1510c3fc8d2de$var$eb = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(4);
const $c2d1510c3fc8d2de$var$abc = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(24);
const $c2d1510c3fc8d2de$var$bcd = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(24);
const $c2d1510c3fc8d2de$var$cde = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(24);
const $c2d1510c3fc8d2de$var$dea = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(24);
const $c2d1510c3fc8d2de$var$eab = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(24);
const $c2d1510c3fc8d2de$var$abd = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(24);
const $c2d1510c3fc8d2de$var$bce = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(24);
const $c2d1510c3fc8d2de$var$cda = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(24);
const $c2d1510c3fc8d2de$var$deb = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(24);
const $c2d1510c3fc8d2de$var$eac = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(24);
const $c2d1510c3fc8d2de$var$adet = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(1152);
const $c2d1510c3fc8d2de$var$bdet = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(1152);
const $c2d1510c3fc8d2de$var$cdet = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(1152);
const $c2d1510c3fc8d2de$var$ddet = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(1152);
const $c2d1510c3fc8d2de$var$edet = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(1152);
const $c2d1510c3fc8d2de$var$abdet = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(2304);
const $c2d1510c3fc8d2de$var$cddet = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(2304);
const $c2d1510c3fc8d2de$var$cdedet = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(3456);
const $c2d1510c3fc8d2de$var$deter = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(5760);
const $c2d1510c3fc8d2de$var$_8 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $c2d1510c3fc8d2de$var$_8b = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $c2d1510c3fc8d2de$var$_8c = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(8);
const $c2d1510c3fc8d2de$var$_16 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(16);
const $c2d1510c3fc8d2de$var$_24 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(24);
const $c2d1510c3fc8d2de$var$_48 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(48);
const $c2d1510c3fc8d2de$var$_48b = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(48);
const $c2d1510c3fc8d2de$var$_96 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(96);
const $c2d1510c3fc8d2de$var$_192 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(192);
const $c2d1510c3fc8d2de$var$_384x = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(384);
const $c2d1510c3fc8d2de$var$_384y = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(384);
const $c2d1510c3fc8d2de$var$_384z = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(384);
const $c2d1510c3fc8d2de$var$_768 = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(768);
function $c2d1510c3fc8d2de$var$sum_three_scale(a, b, c, az, bz, cz, out) {
    return (0, $13af0ee187f1d7e9$export$195a93e4bd4d876f)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, a, az, $c2d1510c3fc8d2de$var$_8), $c2d1510c3fc8d2de$var$_8, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, b, bz, $c2d1510c3fc8d2de$var$_8b), $c2d1510c3fc8d2de$var$_8b, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(4, c, cz, $c2d1510c3fc8d2de$var$_8c), $c2d1510c3fc8d2de$var$_8c, $c2d1510c3fc8d2de$var$_16, out);
}
function $c2d1510c3fc8d2de$var$liftexact(alen, a, blen, b, clen, c, dlen, d, x, y, z, out) {
    const len = (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)((0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)(alen, a, blen, b, $c2d1510c3fc8d2de$var$_48), $c2d1510c3fc8d2de$var$_48, (0, $13af0ee187f1d7e9$export$aef51622e549b8b0)((0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)(clen, c, dlen, d, $c2d1510c3fc8d2de$var$_48b), $c2d1510c3fc8d2de$var$_48b), $c2d1510c3fc8d2de$var$_48b, $c2d1510c3fc8d2de$var$_96);
    return (0, $13af0ee187f1d7e9$export$195a93e4bd4d876f)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $c2d1510c3fc8d2de$var$_96, x, $c2d1510c3fc8d2de$var$_192), $c2d1510c3fc8d2de$var$_192, x, $c2d1510c3fc8d2de$var$_384x), $c2d1510c3fc8d2de$var$_384x, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $c2d1510c3fc8d2de$var$_96, y, $c2d1510c3fc8d2de$var$_192), $c2d1510c3fc8d2de$var$_192, y, $c2d1510c3fc8d2de$var$_384y), $c2d1510c3fc8d2de$var$_384y, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $c2d1510c3fc8d2de$var$_96, z, $c2d1510c3fc8d2de$var$_192), $c2d1510c3fc8d2de$var$_192, z, $c2d1510c3fc8d2de$var$_384z), $c2d1510c3fc8d2de$var$_384z, $c2d1510c3fc8d2de$var$_768, out);
}
function $c2d1510c3fc8d2de$var$insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    s1 = ax * by;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ay;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $c2d1510c3fc8d2de$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $c2d1510c3fc8d2de$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $c2d1510c3fc8d2de$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $c2d1510c3fc8d2de$var$ab[3] = u3;
    s1 = bx * cy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * by;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $c2d1510c3fc8d2de$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $c2d1510c3fc8d2de$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $c2d1510c3fc8d2de$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $c2d1510c3fc8d2de$var$bc[3] = u3;
    s1 = cx * dy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * cy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $c2d1510c3fc8d2de$var$cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $c2d1510c3fc8d2de$var$cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $c2d1510c3fc8d2de$var$cd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $c2d1510c3fc8d2de$var$cd[3] = u3;
    s1 = dx * ey;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * dy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $c2d1510c3fc8d2de$var$de[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $c2d1510c3fc8d2de$var$de[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $c2d1510c3fc8d2de$var$de[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $c2d1510c3fc8d2de$var$de[3] = u3;
    s1 = ex * ay;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * ey;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $c2d1510c3fc8d2de$var$ea[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $c2d1510c3fc8d2de$var$ea[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $c2d1510c3fc8d2de$var$ea[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $c2d1510c3fc8d2de$var$ea[3] = u3;
    s1 = ax * cy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * ay;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $c2d1510c3fc8d2de$var$ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $c2d1510c3fc8d2de$var$ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $c2d1510c3fc8d2de$var$ac[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $c2d1510c3fc8d2de$var$ac[3] = u3;
    s1 = bx * dy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * by;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $c2d1510c3fc8d2de$var$bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $c2d1510c3fc8d2de$var$bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $c2d1510c3fc8d2de$var$bd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $c2d1510c3fc8d2de$var$bd[3] = u3;
    s1 = cx * ey;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * cy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $c2d1510c3fc8d2de$var$ce[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $c2d1510c3fc8d2de$var$ce[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $c2d1510c3fc8d2de$var$ce[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $c2d1510c3fc8d2de$var$ce[3] = u3;
    s1 = dx * ay;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * dy;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $c2d1510c3fc8d2de$var$da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $c2d1510c3fc8d2de$var$da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $c2d1510c3fc8d2de$var$da[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $c2d1510c3fc8d2de$var$da[3] = u3;
    s1 = ex * by;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ey;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $c2d1510c3fc8d2de$var$eb[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $c2d1510c3fc8d2de$var$eb[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $c2d1510c3fc8d2de$var$eb[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $c2d1510c3fc8d2de$var$eb[3] = u3;
    const abclen = $c2d1510c3fc8d2de$var$sum_three_scale($c2d1510c3fc8d2de$var$ab, $c2d1510c3fc8d2de$var$bc, $c2d1510c3fc8d2de$var$ac, cz, az, -bz, $c2d1510c3fc8d2de$var$abc);
    const bcdlen = $c2d1510c3fc8d2de$var$sum_three_scale($c2d1510c3fc8d2de$var$bc, $c2d1510c3fc8d2de$var$cd, $c2d1510c3fc8d2de$var$bd, dz, bz, -cz, $c2d1510c3fc8d2de$var$bcd);
    const cdelen = $c2d1510c3fc8d2de$var$sum_three_scale($c2d1510c3fc8d2de$var$cd, $c2d1510c3fc8d2de$var$de, $c2d1510c3fc8d2de$var$ce, ez, cz, -dz, $c2d1510c3fc8d2de$var$cde);
    const dealen = $c2d1510c3fc8d2de$var$sum_three_scale($c2d1510c3fc8d2de$var$de, $c2d1510c3fc8d2de$var$ea, $c2d1510c3fc8d2de$var$da, az, dz, -ez, $c2d1510c3fc8d2de$var$dea);
    const eablen = $c2d1510c3fc8d2de$var$sum_three_scale($c2d1510c3fc8d2de$var$ea, $c2d1510c3fc8d2de$var$ab, $c2d1510c3fc8d2de$var$eb, bz, ez, -az, $c2d1510c3fc8d2de$var$eab);
    const abdlen = $c2d1510c3fc8d2de$var$sum_three_scale($c2d1510c3fc8d2de$var$ab, $c2d1510c3fc8d2de$var$bd, $c2d1510c3fc8d2de$var$da, dz, az, bz, $c2d1510c3fc8d2de$var$abd);
    const bcelen = $c2d1510c3fc8d2de$var$sum_three_scale($c2d1510c3fc8d2de$var$bc, $c2d1510c3fc8d2de$var$ce, $c2d1510c3fc8d2de$var$eb, ez, bz, cz, $c2d1510c3fc8d2de$var$bce);
    const cdalen = $c2d1510c3fc8d2de$var$sum_three_scale($c2d1510c3fc8d2de$var$cd, $c2d1510c3fc8d2de$var$da, $c2d1510c3fc8d2de$var$ac, az, cz, dz, $c2d1510c3fc8d2de$var$cda);
    const deblen = $c2d1510c3fc8d2de$var$sum_three_scale($c2d1510c3fc8d2de$var$de, $c2d1510c3fc8d2de$var$eb, $c2d1510c3fc8d2de$var$bd, bz, dz, ez, $c2d1510c3fc8d2de$var$deb);
    const eaclen = $c2d1510c3fc8d2de$var$sum_three_scale($c2d1510c3fc8d2de$var$ea, $c2d1510c3fc8d2de$var$ac, $c2d1510c3fc8d2de$var$ce, cz, ez, az, $c2d1510c3fc8d2de$var$eac);
    const deterlen = (0, $13af0ee187f1d7e9$export$195a93e4bd4d876f)($c2d1510c3fc8d2de$var$liftexact(cdelen, $c2d1510c3fc8d2de$var$cde, bcelen, $c2d1510c3fc8d2de$var$bce, deblen, $c2d1510c3fc8d2de$var$deb, bcdlen, $c2d1510c3fc8d2de$var$bcd, ax, ay, az, $c2d1510c3fc8d2de$var$adet), $c2d1510c3fc8d2de$var$adet, $c2d1510c3fc8d2de$var$liftexact(dealen, $c2d1510c3fc8d2de$var$dea, cdalen, $c2d1510c3fc8d2de$var$cda, eaclen, $c2d1510c3fc8d2de$var$eac, cdelen, $c2d1510c3fc8d2de$var$cde, bx, by, bz, $c2d1510c3fc8d2de$var$bdet), $c2d1510c3fc8d2de$var$bdet, (0, $13af0ee187f1d7e9$export$195a93e4bd4d876f)($c2d1510c3fc8d2de$var$liftexact(eablen, $c2d1510c3fc8d2de$var$eab, deblen, $c2d1510c3fc8d2de$var$deb, abdlen, $c2d1510c3fc8d2de$var$abd, dealen, $c2d1510c3fc8d2de$var$dea, cx, cy, cz, $c2d1510c3fc8d2de$var$cdet), $c2d1510c3fc8d2de$var$cdet, $c2d1510c3fc8d2de$var$liftexact(abclen, $c2d1510c3fc8d2de$var$abc, eaclen, $c2d1510c3fc8d2de$var$eac, bcelen, $c2d1510c3fc8d2de$var$bce, eablen, $c2d1510c3fc8d2de$var$eab, dx, dy, dz, $c2d1510c3fc8d2de$var$ddet), $c2d1510c3fc8d2de$var$ddet, $c2d1510c3fc8d2de$var$liftexact(bcdlen, $c2d1510c3fc8d2de$var$bcd, abdlen, $c2d1510c3fc8d2de$var$abd, cdalen, $c2d1510c3fc8d2de$var$cda, abclen, $c2d1510c3fc8d2de$var$abc, ex, ey, ez, $c2d1510c3fc8d2de$var$edet), $c2d1510c3fc8d2de$var$edet, $c2d1510c3fc8d2de$var$cddet, $c2d1510c3fc8d2de$var$cdedet), $c2d1510c3fc8d2de$var$cdedet, $c2d1510c3fc8d2de$var$abdet, $c2d1510c3fc8d2de$var$deter);
    return $c2d1510c3fc8d2de$var$deter[deterlen - 1];
}
const $c2d1510c3fc8d2de$var$xdet = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(96);
const $c2d1510c3fc8d2de$var$ydet = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(96);
const $c2d1510c3fc8d2de$var$zdet = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(96);
const $c2d1510c3fc8d2de$var$fin = (0, $13af0ee187f1d7e9$export$202e0172ed3c7be0)(1152);
function $c2d1510c3fc8d2de$var$liftadapt(a, b, c, az, bz, cz, x, y, z, out) {
    const len = $c2d1510c3fc8d2de$var$sum_three_scale(a, b, c, az, bz, cz, $c2d1510c3fc8d2de$var$_24);
    return (0, $13af0ee187f1d7e9$export$195a93e4bd4d876f)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $c2d1510c3fc8d2de$var$_24, x, $c2d1510c3fc8d2de$var$_48), $c2d1510c3fc8d2de$var$_48, x, $c2d1510c3fc8d2de$var$xdet), $c2d1510c3fc8d2de$var$xdet, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $c2d1510c3fc8d2de$var$_24, y, $c2d1510c3fc8d2de$var$_48), $c2d1510c3fc8d2de$var$_48, y, $c2d1510c3fc8d2de$var$ydet), $c2d1510c3fc8d2de$var$ydet, (0, $13af0ee187f1d7e9$export$dcdf75081b88279d)((0, $13af0ee187f1d7e9$export$dcdf75081b88279d)(len, $c2d1510c3fc8d2de$var$_24, z, $c2d1510c3fc8d2de$var$_48), $c2d1510c3fc8d2de$var$_48, z, $c2d1510c3fc8d2de$var$zdet), $c2d1510c3fc8d2de$var$zdet, $c2d1510c3fc8d2de$var$_192, out);
}
function $c2d1510c3fc8d2de$var$insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent) {
    let ab3, bc3, cd3, da3, ac3, bd3;
    let aextail, bextail, cextail, dextail;
    let aeytail, beytail, ceytail, deytail;
    let aeztail, beztail, ceztail, deztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0;
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    s1 = aex * bey;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bex * aey;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $c2d1510c3fc8d2de$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $c2d1510c3fc8d2de$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ab3 = _j + _i;
    bvirt = ab3 - _j;
    $c2d1510c3fc8d2de$var$ab[2] = _j - (ab3 - bvirt) + (_i - bvirt);
    $c2d1510c3fc8d2de$var$ab[3] = ab3;
    s1 = bex * cey;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * bey;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $c2d1510c3fc8d2de$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $c2d1510c3fc8d2de$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bc3 = _j + _i;
    bvirt = bc3 - _j;
    $c2d1510c3fc8d2de$var$bc[2] = _j - (bc3 - bvirt) + (_i - bvirt);
    $c2d1510c3fc8d2de$var$bc[3] = bc3;
    s1 = cex * dey;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * cey;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $c2d1510c3fc8d2de$var$cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $c2d1510c3fc8d2de$var$cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    cd3 = _j + _i;
    bvirt = cd3 - _j;
    $c2d1510c3fc8d2de$var$cd[2] = _j - (cd3 - bvirt) + (_i - bvirt);
    $c2d1510c3fc8d2de$var$cd[3] = cd3;
    s1 = dex * aey;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = aex * dey;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $c2d1510c3fc8d2de$var$da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $c2d1510c3fc8d2de$var$da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    da3 = _j + _i;
    bvirt = da3 - _j;
    $c2d1510c3fc8d2de$var$da[2] = _j - (da3 - bvirt) + (_i - bvirt);
    $c2d1510c3fc8d2de$var$da[3] = da3;
    s1 = aex * cey;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * aey;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $c2d1510c3fc8d2de$var$ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $c2d1510c3fc8d2de$var$ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ac3 = _j + _i;
    bvirt = ac3 - _j;
    $c2d1510c3fc8d2de$var$ac[2] = _j - (ac3 - bvirt) + (_i - bvirt);
    $c2d1510c3fc8d2de$var$ac[3] = ac3;
    s1 = bex * dey;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * bey;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $13af0ee187f1d7e9$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $c2d1510c3fc8d2de$var$bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $c2d1510c3fc8d2de$var$bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bd3 = _j + _i;
    bvirt = bd3 - _j;
    $c2d1510c3fc8d2de$var$bd[2] = _j - (bd3 - bvirt) + (_i - bvirt);
    $c2d1510c3fc8d2de$var$bd[3] = bd3;
    const finlen = (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)((0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)((0, $13af0ee187f1d7e9$export$aef51622e549b8b0)($c2d1510c3fc8d2de$var$liftadapt($c2d1510c3fc8d2de$var$bc, $c2d1510c3fc8d2de$var$cd, $c2d1510c3fc8d2de$var$bd, dez, bez, -cez, aex, aey, aez, $c2d1510c3fc8d2de$var$adet), $c2d1510c3fc8d2de$var$adet), $c2d1510c3fc8d2de$var$adet, $c2d1510c3fc8d2de$var$liftadapt($c2d1510c3fc8d2de$var$cd, $c2d1510c3fc8d2de$var$da, $c2d1510c3fc8d2de$var$ac, aez, cez, dez, bex, bey, bez, $c2d1510c3fc8d2de$var$bdet), $c2d1510c3fc8d2de$var$bdet, $c2d1510c3fc8d2de$var$abdet), $c2d1510c3fc8d2de$var$abdet, (0, $13af0ee187f1d7e9$export$8a63f25cc62965f1)((0, $13af0ee187f1d7e9$export$aef51622e549b8b0)($c2d1510c3fc8d2de$var$liftadapt($c2d1510c3fc8d2de$var$da, $c2d1510c3fc8d2de$var$ab, $c2d1510c3fc8d2de$var$bd, bez, dez, aez, cex, cey, cez, $c2d1510c3fc8d2de$var$cdet), $c2d1510c3fc8d2de$var$cdet), $c2d1510c3fc8d2de$var$cdet, $c2d1510c3fc8d2de$var$liftadapt($c2d1510c3fc8d2de$var$ab, $c2d1510c3fc8d2de$var$bc, $c2d1510c3fc8d2de$var$ac, cez, aez, -bez, dex, dey, dez, $c2d1510c3fc8d2de$var$ddet), $c2d1510c3fc8d2de$var$ddet, $c2d1510c3fc8d2de$var$cddet), $c2d1510c3fc8d2de$var$cddet, $c2d1510c3fc8d2de$var$fin);
    let det = (0, $13af0ee187f1d7e9$export$9f3a0795ca2cc944)(finlen, $c2d1510c3fc8d2de$var$fin);
    let errbound = $c2d1510c3fc8d2de$var$isperrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - aex;
    aextail = ax - (aex + bvirt) + (bvirt - ex);
    bvirt = ay - aey;
    aeytail = ay - (aey + bvirt) + (bvirt - ey);
    bvirt = az - aez;
    aeztail = az - (aez + bvirt) + (bvirt - ez);
    bvirt = bx - bex;
    bextail = bx - (bex + bvirt) + (bvirt - ex);
    bvirt = by - bey;
    beytail = by - (bey + bvirt) + (bvirt - ey);
    bvirt = bz - bez;
    beztail = bz - (bez + bvirt) + (bvirt - ez);
    bvirt = cx - cex;
    cextail = cx - (cex + bvirt) + (bvirt - ex);
    bvirt = cy - cey;
    ceytail = cy - (cey + bvirt) + (bvirt - ey);
    bvirt = cz - cez;
    ceztail = cz - (cez + bvirt) + (bvirt - ez);
    bvirt = dx - dex;
    dextail = dx - (dex + bvirt) + (bvirt - ex);
    bvirt = dy - dey;
    deytail = dy - (dey + bvirt) + (bvirt - ey);
    bvirt = dz - dez;
    deztail = dz - (dez + bvirt) + (bvirt - ez);
    if (aextail === 0 && aeytail === 0 && aeztail === 0 && bextail === 0 && beytail === 0 && beztail === 0 && cextail === 0 && ceytail === 0 && ceztail === 0 && dextail === 0 && deytail === 0 && deztail === 0) return det;
    errbound = $c2d1510c3fc8d2de$var$isperrboundC * permanent + (0, $13af0ee187f1d7e9$export$a4103c3ab16b06d7) * Math.abs(det);
    const abeps = aex * beytail + bey * aextail - (aey * bextail + bex * aeytail);
    const bceps = bex * ceytail + cey * bextail - (bey * cextail + cex * beytail);
    const cdeps = cex * deytail + dey * cextail - (cey * dextail + dex * ceytail);
    const daeps = dex * aeytail + aey * dextail - (dey * aextail + aex * deytail);
    const aceps = aex * ceytail + cey * aextail - (aey * cextail + cex * aeytail);
    const bdeps = bex * deytail + dey * bextail - (bey * dextail + dex * beytail);
    det += (bex * bex + bey * bey + bez * bez) * (cez * daeps + dez * aceps + aez * cdeps + (ceztail * da3 + deztail * ac3 + aeztail * cd3)) + (dex * dex + dey * dey + dez * dez) * (aez * bceps - bez * aceps + cez * abeps + (aeztail * bc3 - beztail * ac3 + ceztail * ab3)) - ((aex * aex + aey * aey + aez * aez) * (bez * cdeps - cez * bdeps + dez * bceps + (beztail * cd3 - ceztail * bd3 + deztail * bc3)) + (cex * cex + cey * cey + cez * cez) * (dez * abeps + aez * bdeps + bez * daeps + (deztail * ab3 + aeztail * bd3 + beztail * da3))) + 2 * ((bex * bextail + bey * beytail + bez * beztail) * (cez * da3 + dez * ac3 + aez * cd3) + (dex * dextail + dey * deytail + dez * deztail) * (aez * bc3 - bez * ac3 + cez * ab3) - ((aex * aextail + aey * aeytail + aez * aeztail) * (bez * cd3 - cez * bd3 + dez * bc3) + (cex * cextail + cey * ceytail + cez * ceztail) * (dez * ab3 + aez * bd3 + bez * da3)));
    if (det >= errbound || -det >= errbound) return det;
    return $c2d1510c3fc8d2de$var$insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez);
}
function $c2d1510c3fc8d2de$export$7846ecd8d3a5d1ac(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    const aexbey = aex * bey;
    const bexaey = bex * aey;
    const ab = aexbey - bexaey;
    const bexcey = bex * cey;
    const cexbey = cex * bey;
    const bc = bexcey - cexbey;
    const cexdey = cex * dey;
    const dexcey = dex * cey;
    const cd = cexdey - dexcey;
    const dexaey = dex * aey;
    const aexdey = aex * dey;
    const da = dexaey - aexdey;
    const aexcey = aex * cey;
    const cexaey = cex * aey;
    const ac = aexcey - cexaey;
    const bexdey = bex * dey;
    const dexbey = dex * bey;
    const bd = bexdey - dexbey;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    const det = clift * (dez * ab + aez * bd + bez * da) - dlift * (aez * bc - bez * ac + cez * ab) + (alift * (bez * cd - cez * bd + dez * bc) - blift * (cez * da + dez * ac + aez * cd));
    const aezplus = Math.abs(aez);
    const bezplus = Math.abs(bez);
    const cezplus = Math.abs(cez);
    const dezplus = Math.abs(dez);
    const aexbeyplus = Math.abs(aexbey) + Math.abs(bexaey);
    const bexceyplus = Math.abs(bexcey) + Math.abs(cexbey);
    const cexdeyplus = Math.abs(cexdey) + Math.abs(dexcey);
    const dexaeyplus = Math.abs(dexaey) + Math.abs(aexdey);
    const aexceyplus = Math.abs(aexcey) + Math.abs(cexaey);
    const bexdeyplus = Math.abs(bexdey) + Math.abs(dexbey);
    const permanent = (cexdeyplus * bezplus + bexdeyplus * cezplus + bexceyplus * dezplus) * alift + (dexaeyplus * cezplus + aexceyplus * dezplus + cexdeyplus * aezplus) * blift + (aexbeyplus * dezplus + bexdeyplus * aezplus + dexaeyplus * bezplus) * clift + (bexceyplus * aezplus + aexceyplus * bezplus + aexbeyplus * cezplus) * dlift;
    const errbound = $c2d1510c3fc8d2de$var$isperrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return -$c2d1510c3fc8d2de$var$insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent);
}
function $c2d1510c3fc8d2de$export$11235b985c819946(pax, pay, paz, pbx, pby, pbz, pcx, pcy, pcz, pdx, pdy, pdz, pex, pey, pez) {
    const aex = pax - pex;
    const bex = pbx - pex;
    const cex = pcx - pex;
    const dex = pdx - pex;
    const aey = pay - pey;
    const bey = pby - pey;
    const cey = pcy - pey;
    const dey = pdy - pey;
    const aez = paz - pez;
    const bez = pbz - pez;
    const cez = pcz - pez;
    const dez = pdz - pez;
    const ab = aex * bey - bex * aey;
    const bc = bex * cey - cex * bey;
    const cd = cex * dey - dex * cey;
    const da = dex * aey - aex * dey;
    const ac = aex * cey - cex * aey;
    const bd = bex * dey - dex * bey;
    const abc = aez * bc - bez * ac + cez * ab;
    const bcd = bez * cd - cez * bd + dez * bc;
    const cda = cez * da + dez * ac + aez * cd;
    const dab = dez * ab + aez * bd + bez * da;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    return clift * dab - dlift * abc + (alift * bcd - blift * cda);
}




const $9e9dbe7caf1f8787$var$EPSILON = Math.pow(2, -52);
const $9e9dbe7caf1f8787$var$EDGE_STACK = new Uint32Array(512);
class $9e9dbe7caf1f8787$export$2e2bcd8739ae039 {
    static from(points, getX = $9e9dbe7caf1f8787$var$defaultGetX, getY = $9e9dbe7caf1f8787$var$defaultGetY) {
        const n = points.length;
        const coords = new Float64Array(n * 2);
        for(let i = 0; i < n; i++){
            const p = points[i];
            coords[2 * i] = getX(p);
            coords[2 * i + 1] = getY(p);
        }
        return new $9e9dbe7caf1f8787$export$2e2bcd8739ae039(coords);
    }
    constructor(coords){
        const n = coords.length >> 1;
        if (n > 0 && typeof coords[0] !== "number") throw new Error("Expected coords to contain numbers.");
        this.coords = coords;
        // arrays that will store the triangulation graph
        const maxTriangles = Math.max(2 * n - 5, 0);
        this._triangles = new Uint32Array(maxTriangles * 3);
        this._halfedges = new Int32Array(maxTriangles * 3);
        // temporary arrays for tracking the edges of the advancing convex hull
        this._hashSize = Math.ceil(Math.sqrt(n));
        this._hullPrev = new Uint32Array(n); // edge to prev edge
        this._hullNext = new Uint32Array(n); // edge to next edge
        this._hullTri = new Uint32Array(n); // edge to adjacent triangle
        this._hullHash = new Int32Array(this._hashSize).fill(-1); // angular edge hash
        // temporary arrays for sorting points
        this._ids = new Uint32Array(n);
        this._dists = new Float64Array(n);
        this.update();
    }
    update() {
        const { coords: coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
        const n = coords.length >> 1;
        // populate an array of point indices; calculate input data bbox
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = 0; i < n; i++){
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            this._ids[i] = i;
        }
        const cx = (minX + maxX) / 2;
        const cy = (minY + maxY) / 2;
        let minDist = Infinity;
        let i0, i1, i2;
        // pick a seed point close to the center
        for(let i = 0; i < n; i++){
            const d = $9e9dbe7caf1f8787$var$dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist) {
                i0 = i;
                minDist = d;
            }
        }
        const i0x = coords[2 * i0];
        const i0y = coords[2 * i0 + 1];
        minDist = Infinity;
        // find the point closest to the seed
        for(let i = 0; i < n; i++){
            if (i === i0) continue;
            const d = $9e9dbe7caf1f8787$var$dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist && d > 0) {
                i1 = i;
                minDist = d;
            }
        }
        let i1x = coords[2 * i1];
        let i1y = coords[2 * i1 + 1];
        let minRadius = Infinity;
        // find the third point which forms the smallest circumcircle with the first two
        for(let i = 0; i < n; i++){
            if (i === i0 || i === i1) continue;
            const r = $9e9dbe7caf1f8787$var$circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
            if (r < minRadius) {
                i2 = i;
                minRadius = r;
            }
        }
        let i2x = coords[2 * i2];
        let i2y = coords[2 * i2 + 1];
        if (minRadius === Infinity) {
            // order collinear points by dx (or dy if all x are identical)
            // and return the list as a hull
            for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
            $9e9dbe7caf1f8787$var$quicksort(this._ids, this._dists, 0, n - 1);
            const hull = new Uint32Array(n);
            let j = 0;
            for(let i = 0, d0 = -Infinity; i < n; i++){
                const id = this._ids[i];
                if (this._dists[id] > d0) {
                    hull[j++] = id;
                    d0 = this._dists[id];
                }
            }
            this.hull = hull.subarray(0, j);
            this.triangles = new Uint32Array(0);
            this.halfedges = new Uint32Array(0);
            return;
        }
        // swap the order of the seed points for counter-clockwise orientation
        if ((0, $1126cb99c30e80cc$export$bbb923599a46a7d8)(i0x, i0y, i1x, i1y, i2x, i2y) < 0) {
            const i = i1;
            const x = i1x;
            const y = i1y;
            i1 = i2;
            i1x = i2x;
            i1y = i2y;
            i2 = i;
            i2x = x;
            i2y = y;
        }
        const center = $9e9dbe7caf1f8787$var$circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
        this._cx = center.x;
        this._cy = center.y;
        for(let i = 0; i < n; i++)this._dists[i] = $9e9dbe7caf1f8787$var$dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
        // sort the points by distance from the seed triangle circumcenter
        $9e9dbe7caf1f8787$var$quicksort(this._ids, this._dists, 0, n - 1);
        // set up the seed triangle as the starting hull
        this._hullStart = i0;
        let hullSize = 3;
        hullNext[i0] = hullPrev[i2] = i1;
        hullNext[i1] = hullPrev[i0] = i2;
        hullNext[i2] = hullPrev[i1] = i0;
        hullTri[i0] = 0;
        hullTri[i1] = 1;
        hullTri[i2] = 2;
        hullHash.fill(-1);
        hullHash[this._hashKey(i0x, i0y)] = i0;
        hullHash[this._hashKey(i1x, i1y)] = i1;
        hullHash[this._hashKey(i2x, i2y)] = i2;
        this.trianglesLen = 0;
        this._addTriangle(i0, i1, i2, -1, -1, -1);
        for(let k = 0, xp, yp; k < this._ids.length; k++){
            const i = this._ids[k];
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            // skip near-duplicate points
            if (k > 0 && Math.abs(x - xp) <= $9e9dbe7caf1f8787$var$EPSILON && Math.abs(y - yp) <= $9e9dbe7caf1f8787$var$EPSILON) continue;
            xp = x;
            yp = y;
            // skip seed triangle points
            if (i === i0 || i === i1 || i === i2) continue;
            // find a visible edge on the convex hull using edge hash
            let start = 0;
            for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                start = hullHash[(key + j) % this._hashSize];
                if (start !== -1 && start !== hullNext[start]) break;
            }
            start = hullPrev[start];
            let e = start, q;
            while(q = hullNext[e], (0, $1126cb99c30e80cc$export$bbb923599a46a7d8)(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1]) >= 0){
                e = q;
                if (e === start) {
                    e = -1;
                    break;
                }
            }
            if (e === -1) continue; // likely a near-duplicate point; skip it
            // add the first triangle from the point
            let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
            // recursively flip triangles from the point until they satisfy the Delaunay condition
            hullTri[i] = this._legalize(t + 2);
            hullTri[e] = t; // keep track of boundary triangles on the hull
            hullSize++;
            // walk forward through the hull, adding more triangles and flipping recursively
            let n = hullNext[e];
            while(q = hullNext[n], (0, $1126cb99c30e80cc$export$bbb923599a46a7d8)(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1]) < 0){
                t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                hullTri[i] = this._legalize(t + 2);
                hullNext[n] = n; // mark as removed
                hullSize--;
                n = q;
            }
            // walk backward from the other side, adding more triangles and flipping
            if (e === start) while(q = hullPrev[e], (0, $1126cb99c30e80cc$export$bbb923599a46a7d8)(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1]) < 0){
                t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                this._legalize(t + 2);
                hullTri[q] = t;
                hullNext[e] = e; // mark as removed
                hullSize--;
                e = q;
            }
            // update the hull indices
            this._hullStart = hullPrev[i] = e;
            hullNext[e] = hullPrev[n] = i;
            hullNext[i] = n;
            // save the two new edges in the hash table
            hullHash[this._hashKey(x, y)] = i;
            hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
        }
        this.hull = new Uint32Array(hullSize);
        for(let i = 0, e = this._hullStart; i < hullSize; i++){
            this.hull[i] = e;
            e = hullNext[e];
        }
        // trim typed triangle mesh arrays
        this.triangles = this._triangles.subarray(0, this.trianglesLen);
        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }
    _hashKey(x, y) {
        return Math.floor($9e9dbe7caf1f8787$var$pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    }
    _legalize(a) {
        const { _triangles: triangles, _halfedges: halfedges, coords: coords } = this;
        let i = 0;
        let ar = 0;
        // recursion eliminated with a fixed-size stack
        while(true){
            const b = halfedges[a];
            /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */ const a0 = a - a % 3;
            ar = a0 + (a + 2) % 3;
            if (b === -1) {
                if (i === 0) break;
                a = $9e9dbe7caf1f8787$var$EDGE_STACK[--i];
                continue;
            }
            const b0 = b - b % 3;
            const al = a0 + (a + 1) % 3;
            const bl = b0 + (b + 2) % 3;
            const p0 = triangles[ar];
            const pr = triangles[a];
            const pl = triangles[al];
            const p1 = triangles[bl];
            const illegal = $9e9dbe7caf1f8787$var$inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
            if (illegal) {
                triangles[a] = p1;
                triangles[b] = p0;
                const hbl = halfedges[bl];
                // edge swapped on the other side of the hull (rare); fix the halfedge reference
                if (hbl === -1) {
                    let e = this._hullStart;
                    do {
                        if (this._hullTri[e] === bl) {
                            this._hullTri[e] = a;
                            break;
                        }
                        e = this._hullPrev[e];
                    }while (e !== this._hullStart);
                }
                this._link(a, hbl);
                this._link(b, halfedges[ar]);
                this._link(ar, bl);
                const br = b0 + (b + 1) % 3;
                // don't worry about hitting the cap: it can only happen on extremely degenerate input
                if (i < $9e9dbe7caf1f8787$var$EDGE_STACK.length) $9e9dbe7caf1f8787$var$EDGE_STACK[i++] = br;
            } else {
                if (i === 0) break;
                a = $9e9dbe7caf1f8787$var$EDGE_STACK[--i];
            }
        }
        return ar;
    }
    _link(a, b) {
        this._halfedges[a] = b;
        if (b !== -1) this._halfedges[b] = a;
    }
    // add a new triangle given vertex indices and adjacent half-edge ids
    _addTriangle(i0, i1, i2, a, b, c) {
        const t = this.trianglesLen;
        this._triangles[t] = i0;
        this._triangles[t + 1] = i1;
        this._triangles[t + 2] = i2;
        this._link(t, a);
        this._link(t + 1, b);
        this._link(t + 2, c);
        this.trianglesLen += 3;
        return t;
    }
}
// monotonically increases with real angle, but doesn't need expensive trigonometry
function $9e9dbe7caf1f8787$var$pseudoAngle(dx, dy) {
    const p = dx / (Math.abs(dx) + Math.abs(dy));
    return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
}
function $9e9dbe7caf1f8787$var$dist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}
function $9e9dbe7caf1f8787$var$inCircle(ax, ay, bx, by, cx, cy, px, py) {
    const dx = ax - px;
    const dy = ay - py;
    const ex = bx - px;
    const ey = by - py;
    const fx = cx - px;
    const fy = cy - py;
    const ap = dx * dx + dy * dy;
    const bp = ex * ex + ey * ey;
    const cp = fx * fx + fy * fy;
    return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
function $9e9dbe7caf1f8787$var$circumradius(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = (ey * bl - dy * cl) * d;
    const y = (dx * cl - ex * bl) * d;
    return x * x + y * y;
}
function $9e9dbe7caf1f8787$var$circumcenter(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = ax + (ey * bl - dy * cl) * d;
    const y = ay + (dx * cl - ex * bl) * d;
    return {
        x: x,
        y: y
    };
}
function $9e9dbe7caf1f8787$var$quicksort(ids, dists, left, right) {
    if (right - left <= 20) for(let i = left + 1; i <= right; i++){
        const temp = ids[i];
        const tempDist = dists[temp];
        let j = i - 1;
        while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
        ids[j + 1] = temp;
    }
    else {
        const median = left + right >> 1;
        let i = left + 1;
        let j = right;
        $9e9dbe7caf1f8787$var$swap(ids, median, i);
        if (dists[ids[left]] > dists[ids[right]]) $9e9dbe7caf1f8787$var$swap(ids, left, right);
        if (dists[ids[i]] > dists[ids[right]]) $9e9dbe7caf1f8787$var$swap(ids, i, right);
        if (dists[ids[left]] > dists[ids[i]]) $9e9dbe7caf1f8787$var$swap(ids, left, i);
        const temp = ids[i];
        const tempDist = dists[temp];
        while(true){
            do i++;
            while (dists[ids[i]] < tempDist);
            do j--;
            while (dists[ids[j]] > tempDist);
            if (j < i) break;
            $9e9dbe7caf1f8787$var$swap(ids, i, j);
        }
        ids[left + 1] = ids[j];
        ids[j] = temp;
        if (right - i + 1 >= j - left) {
            $9e9dbe7caf1f8787$var$quicksort(ids, dists, i, right);
            $9e9dbe7caf1f8787$var$quicksort(ids, dists, left, j - 1);
        } else {
            $9e9dbe7caf1f8787$var$quicksort(ids, dists, left, j - 1);
            $9e9dbe7caf1f8787$var$quicksort(ids, dists, i, right);
        }
    }
}
function $9e9dbe7caf1f8787$var$swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
function $9e9dbe7caf1f8787$var$defaultGetX(p) {
    return p[0];
}
function $9e9dbe7caf1f8787$var$defaultGetY(p) {
    return p[1];
}


const $af9afc1e1274d6e6$var$epsilon = 1e-6;
class $af9afc1e1274d6e6$export$2e2bcd8739ae039 {
    constructor(){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
    }
    moveTo(x, y) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    }
    lineTo(x, y) {
        this._ += `L${this._x1 = +x},${this._y1 = +y}`;
    }
    arc(x, y, r) {
        x = +x, y = +y, r = +r;
        const x0 = x + r;
        const y0 = y;
        if (r < 0) throw new Error("negative radius");
        if (this._x1 === null) this._ += `M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $af9afc1e1274d6e6$var$epsilon || Math.abs(this._y1 - y0) > $af9afc1e1274d6e6$var$epsilon) this._ += "L" + x0 + "," + y0;
        if (!r) return;
        this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
    }
    rect(x, y, w, h) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
    }
    value() {
        return this._ || null;
    }
}


class $f5e698a9cbc548e6$export$2e2bcd8739ae039 {
    constructor(){
        this._ = [];
    }
    moveTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    closePath() {
        this._.push(this._[0].slice());
    }
    lineTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    value() {
        return this._.length ? this._ : null;
    }
}




class $32af31d415bb652f$export$2e2bcd8739ae039 {
    constructor(delaunay, [xmin, ymin, xmax, ymax] = [
        0,
        0,
        960,
        500
    ]){
        if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
        this.delaunay = delaunay;
        this._circumcenters = new Float64Array(delaunay.points.length * 2);
        this.vectors = new Float64Array(delaunay.points.length * 2);
        this.xmax = xmax, this.xmin = xmin;
        this.ymax = ymax, this.ymin = ymin;
        this._init();
    }
    update() {
        this.delaunay.update();
        this._init();
        return this;
    }
    _init() {
        const { delaunay: { points: points, hull: hull, triangles: triangles }, vectors: vectors } = this;
        let bx, by; // lazily computed barycenter of the hull
        // Compute circumcenters.
        const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
        for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
            const t1 = triangles[i] * 2;
            const t2 = triangles[i + 1] * 2;
            const t3 = triangles[i + 2] * 2;
            const x1 = points[t1];
            const y1 = points[t1 + 1];
            const x2 = points[t2];
            const y2 = points[t2 + 1];
            const x3 = points[t3];
            const y3 = points[t3 + 1];
            const dx = x2 - x1;
            const dy = y2 - y1;
            const ex = x3 - x1;
            const ey = y3 - y1;
            const ab = (dx * ey - dy * ex) * 2;
            if (Math.abs(ab) < 1e-9) {
                // For a degenerate triangle, the circumcenter is at the infinity, in a
                // direction orthogonal to the halfedge and away from the “center” of
                // the diagram <bx, by>, defined as the hull’s barycenter.
                if (bx === undefined) {
                    bx = by = 0;
                    for (const i of hull)bx += points[i * 2], by += points[i * 2 + 1];
                    bx /= hull.length, by /= hull.length;
                }
                const a = 1e9 * Math.sign((bx - x1) * ey - (by - y1) * ex);
                x = (x1 + x3) / 2 - a * ey;
                y = (y1 + y3) / 2 + a * ex;
            } else {
                const d = 1 / ab;
                const bl = dx * dx + dy * dy;
                const cl = ex * ex + ey * ey;
                x = x1 + (ey * bl - dy * cl) * d;
                y = y1 + (dx * cl - ex * bl) * d;
            }
            circumcenters[j] = x;
            circumcenters[j + 1] = y;
        }
        // Compute exterior cell rays.
        let h = hull[hull.length - 1];
        let p0, p1 = h * 4;
        let x0, x1 = points[2 * h];
        let y0, y1 = points[2 * h + 1];
        vectors.fill(0);
        for(let i = 0; i < hull.length; ++i){
            h = hull[i];
            p0 = p1, x0 = x1, y0 = y1;
            p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
            vectors[p0 + 2] = vectors[p1] = y0 - y1;
            vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
        }
    }
    render(context) {
        const buffer = context == null ? context = new (0, $af9afc1e1274d6e6$export$2e2bcd8739ae039) : undefined;
        const { delaunay: { halfedges: halfedges, inedges: inedges, hull: hull }, circumcenters: circumcenters, vectors: vectors } = this;
        if (hull.length <= 1) return null;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = Math.floor(i / 3) * 2;
            const tj = Math.floor(j / 3) * 2;
            const xi = circumcenters[ti];
            const yi = circumcenters[ti + 1];
            const xj = circumcenters[tj];
            const yj = circumcenters[tj + 1];
            this._renderSegment(xi, yi, xj, yj, context);
        }
        let h0, h1 = hull[hull.length - 1];
        for(let i = 0; i < hull.length; ++i){
            h0 = h1, h1 = hull[i];
            const t = Math.floor(inedges[h1] / 3) * 2;
            const x = circumcenters[t];
            const y = circumcenters[t + 1];
            const v = h0 * 4;
            const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
            if (p) this._renderSegment(x, y, p[0], p[1], context);
        }
        return buffer && buffer.value();
    }
    renderBounds(context) {
        const buffer = context == null ? context = new (0, $af9afc1e1274d6e6$export$2e2bcd8739ae039) : undefined;
        context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
        return buffer && buffer.value();
    }
    renderCell(i, context) {
        const buffer = context == null ? context = new (0, $af9afc1e1274d6e6$export$2e2bcd8739ae039) : undefined;
        const points = this._clip(i);
        if (points === null || !points.length) return;
        context.moveTo(points[0], points[1]);
        let n = points.length;
        while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
        for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *cellPolygons() {
        const { delaunay: { points: points } } = this;
        for(let i = 0, n = points.length / 2; i < n; ++i){
            const cell = this.cellPolygon(i);
            if (cell) cell.index = i, yield cell;
        }
    }
    cellPolygon(i) {
        const polygon = new (0, $f5e698a9cbc548e6$export$2e2bcd8739ae039);
        this.renderCell(i, polygon);
        return polygon.value();
    }
    _renderSegment(x0, y0, x1, y1, context) {
        let S;
        const c0 = this._regioncode(x0, y0);
        const c1 = this._regioncode(x1, y1);
        if (c0 === 0 && c1 === 0) {
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
        } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
            context.moveTo(S[0], S[1]);
            context.lineTo(S[2], S[3]);
        }
    }
    contains(i, x, y) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
        return this.delaunay._step(i, x, y) === i;
    }
    *neighbors(i) {
        const ci = this._clip(i);
        if (ci) for (const j of this.delaunay.neighbors(i)){
            const cj = this._clip(j);
            // find the common edge
            if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] === cj[aj] && ci[ai + 1] === cj[aj + 1] && ci[(ai + 2) % li] === cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] === cj[(aj + lj - 1) % lj]) {
                    yield j;
                    break loop;
                }
            }
        }
    }
    _cell(i) {
        const { circumcenters: circumcenters, delaunay: { inedges: inedges, halfedges: halfedges, triangles: triangles } } = this;
        const e0 = inedges[i];
        if (e0 === -1) return null; // coincident point
        const points = [];
        let e = e0;
        do {
            const t = Math.floor(e / 3);
            points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
        }while (e !== e0 && e !== -1);
        return points;
    }
    _clip(i) {
        // degenerate case (1 valid point: return the box)
        if (i === 0 && this.delaunay.hull.length === 1) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        const points = this._cell(i);
        if (points === null) return null;
        const { vectors: V } = this;
        const v = i * 4;
        return this._simplify(V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points));
    }
    _clipFinite(i, points) {
        const n = points.length;
        let P = null;
        let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
        let c0, c1 = this._regioncode(x1, y1);
        let e0, e1 = 0;
        for(let j = 0; j < n; j += 2){
            x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
            c0 = c1, c1 = this._regioncode(x1, y1);
            if (c0 === 0 && c1 === 0) {
                e0 = e1, e1 = 0;
                if (P) P.push(x1, y1);
                else P = [
                    x1,
                    y1
                ];
            } else {
                let S, sx0, sy0, sx1, sy1;
                if (c0 === 0) {
                    if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                    [sx0, sy0, sx1, sy1] = S;
                } else {
                    if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                    [sx1, sy1, sx0, sy0] = S;
                    e0 = e1, e1 = this._edgecode(sx0, sy0);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                    if (P) P.push(sx0, sy0);
                    else P = [
                        sx0,
                        sy0
                    ];
                }
                e0 = e1, e1 = this._edgecode(sx1, sy1);
                if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                if (P) P.push(sx1, sy1);
                else P = [
                    sx1,
                    sy1
                ];
            }
        }
        if (P) {
            e0 = e1, e1 = this._edgecode(P[0], P[1]);
            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
        } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        return P;
    }
    _clipSegment(x0, y0, x1, y1, c0, c1) {
        // for more robustness, always consider the segment in the same order
        const flip = c0 < c1;
        if (flip) [x0, y0, x1, y1, c0, c1] = [
            x1,
            y1,
            x0,
            y0,
            c1,
            c0
        ];
        while(true){
            if (c0 === 0 && c1 === 0) return flip ? [
                x1,
                y1,
                x0,
                y0
            ] : [
                x0,
                y0,
                x1,
                y1
            ];
            if (c0 & c1) return null;
            let x, y, c = c0 || c1;
            if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
            else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
            else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
            else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
            if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
            else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
        }
    }
    _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
        let P = Array.from(points), p;
        if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
        if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
        if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
            c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
            if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
        }
        else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
            this.xmin,
            this.ymin,
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax
        ];
        return P;
    }
    _edge(i, e0, e1, P, j) {
        while(e0 !== e1){
            let x, y;
            switch(e0){
                case 5:
                    e0 = 4;
                    continue; // top-left
                case 4:
                    e0 = 6, x = this.xmax, y = this.ymin;
                    break; // top
                case 6:
                    e0 = 2;
                    continue; // top-right
                case 2:
                    e0 = 10, x = this.xmax, y = this.ymax;
                    break; // right
                case 10:
                    e0 = 8;
                    continue; // bottom-right
                case 8:
                    e0 = 9, x = this.xmin, y = this.ymax;
                    break; // bottom
                case 9:
                    e0 = 1;
                    continue; // bottom-left
                case 1:
                    e0 = 5, x = this.xmin, y = this.ymin;
                    break; // left
            }
            // Note: this implicitly checks for out of bounds: if P[j] or P[j+1] are
            // undefined, the conditional statement will be executed.
            if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
        }
        return j;
    }
    _project(x0, y0, vx, vy) {
        let t = Infinity, c, x, y;
        if (vy < 0) {
            if (y0 <= this.ymin) return null;
            if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
        } else if (vy > 0) {
            if (y0 >= this.ymax) return null;
            if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
        }
        if (vx > 0) {
            if (x0 >= this.xmax) return null;
            if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
        } else if (vx < 0) {
            if (x0 <= this.xmin) return null;
            if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
        }
        return [
            x,
            y
        ];
    }
    _edgecode(x, y) {
        return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
    }
    _regioncode(x, y) {
        return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
    }
    _simplify(P) {
        if (P && P.length > 4) {
            for(let i = 0; i < P.length; i += 2){
                const j = (i + 2) % P.length, k = (i + 4) % P.length;
                if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
            }
            if (!P.length) P = null;
        }
        return P;
    }
}


const $3dd77de0651120db$var$tau = 2 * Math.PI, $3dd77de0651120db$var$pow = Math.pow;
function $3dd77de0651120db$var$pointX(p) {
    return p[0];
}
function $3dd77de0651120db$var$pointY(p) {
    return p[1];
}
// A triangulation is collinear if all its triangles have a non-null area
function $3dd77de0651120db$var$collinear(d) {
    const { triangles: triangles, coords: coords } = d;
    for(let i = 0; i < triangles.length; i += 3){
        const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
        if (cross > 1e-10) return false;
    }
    return true;
}
function $3dd77de0651120db$var$jitter(x, y, r) {
    return [
        x + Math.sin(x + y) * r,
        y + Math.cos(x - y) * r
    ];
}
class $3dd77de0651120db$export$2e2bcd8739ae039 {
    static from(points, fx = $3dd77de0651120db$var$pointX, fy = $3dd77de0651120db$var$pointY, that) {
        return new $3dd77de0651120db$export$2e2bcd8739ae039("length" in points ? $3dd77de0651120db$var$flatArray(points, fx, fy, that) : Float64Array.from($3dd77de0651120db$var$flatIterable(points, fx, fy, that)));
    }
    constructor(points){
        this._delaunator = new (0, $9e9dbe7caf1f8787$export$2e2bcd8739ae039)(points);
        this.inedges = new Int32Array(points.length / 2);
        this._hullIndex = new Int32Array(points.length / 2);
        this.points = this._delaunator.coords;
        this._init();
    }
    update() {
        this._delaunator.update();
        this._init();
        return this;
    }
    _init() {
        const d = this._delaunator, points = this.points;
        // check for collinear
        if (d.hull && d.hull.length > 2 && $3dd77de0651120db$var$collinear(d)) {
            this.collinear = Int32Array.from({
                length: points.length / 2
            }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
            const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                points[2 * e],
                points[2 * e + 1],
                points[2 * f],
                points[2 * f + 1]
            ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
            for(let i = 0, n = points.length / 2; i < n; ++i){
                const p = $3dd77de0651120db$var$jitter(points[2 * i], points[2 * i + 1], r);
                points[2 * i] = p[0];
                points[2 * i + 1] = p[1];
            }
            this._delaunator = new (0, $9e9dbe7caf1f8787$export$2e2bcd8739ae039)(points);
        } else delete this.collinear;
        const halfedges = this.halfedges = this._delaunator.halfedges;
        const hull = this.hull = this._delaunator.hull;
        const triangles = this.triangles = this._delaunator.triangles;
        const inedges = this.inedges.fill(-1);
        const hullIndex = this._hullIndex.fill(-1);
        // Compute an index from each point to an (arbitrary) incoming halfedge
        // Used to give the first neighbor of each point; for this reason,
        // on the hull we give priority to exterior halfedges
        for(let e = 0, n = halfedges.length; e < n; ++e){
            const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
            if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
        }
        for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
        // degenerate case: 1 or 2 (distinct) points
        if (hull.length <= 2 && hull.length > 0) {
            this.triangles = new Int32Array(3).fill(-1);
            this.halfedges = new Int32Array(3).fill(-1);
            this.triangles[0] = hull[0];
            inedges[hull[0]] = 1;
            if (hull.length === 2) {
                inedges[hull[1]] = 0;
                this.triangles[1] = hull[1];
                this.triangles[2] = hull[1];
            }
        }
    }
    voronoi(bounds) {
        return new (0, $32af31d415bb652f$export$2e2bcd8739ae039)(this, bounds);
    }
    *neighbors(i) {
        const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, collinear: collinear } = this;
        // degenerate case with several collinear points
        if (collinear) {
            const l = collinear.indexOf(i);
            if (l > 0) yield collinear[l - 1];
            if (l < collinear.length - 1) yield collinear[l + 1];
            return;
        }
        const e0 = inedges[i];
        if (e0 === -1) return; // coincident point
        let e = e0, p0 = -1;
        do {
            yield p0 = triangles[e];
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) return; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                const p = hull[(_hullIndex[i] + 1) % hull.length];
                if (p !== p0) yield p;
                return;
            }
        }while (e !== e0);
    }
    find(x, y, i = 0) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
        const i0 = i;
        let c;
        while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
        return c;
    }
    _step(i, x, y) {
        const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, points: points } = this;
        if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
        let c = i;
        let dc = $3dd77de0651120db$var$pow(x - points[i * 2], 2) + $3dd77de0651120db$var$pow(y - points[i * 2 + 1], 2);
        const e0 = inedges[i];
        let e = e0;
        do {
            let t = triangles[e];
            const dt = $3dd77de0651120db$var$pow(x - points[t * 2], 2) + $3dd77de0651120db$var$pow(y - points[t * 2 + 1], 2);
            if (dt < dc) dc = dt, c = t;
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                e = hull[(_hullIndex[i] + 1) % hull.length];
                if (e !== t) {
                    if ($3dd77de0651120db$var$pow(x - points[e * 2], 2) + $3dd77de0651120db$var$pow(y - points[e * 2 + 1], 2) < dc) return e;
                }
                break;
            }
        }while (e !== e0);
        return c;
    }
    render(context) {
        const buffer = context == null ? context = new (0, $af9afc1e1274d6e6$export$2e2bcd8739ae039) : undefined;
        const { points: points, halfedges: halfedges, triangles: triangles } = this;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = triangles[i] * 2;
            const tj = triangles[j] * 2;
            context.moveTo(points[ti], points[ti + 1]);
            context.lineTo(points[tj], points[tj + 1]);
        }
        this.renderHull(context);
        return buffer && buffer.value();
    }
    renderPoints(context, r) {
        if (r === undefined && (!context || typeof context.moveTo !== "function")) r = context, context = null;
        r = r == undefined ? 2 : +r;
        const buffer = context == null ? context = new (0, $af9afc1e1274d6e6$export$2e2bcd8739ae039) : undefined;
        const { points: points } = this;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i], y = points[i + 1];
            context.moveTo(x + r, y);
            context.arc(x, y, r, 0, $3dd77de0651120db$var$tau);
        }
        return buffer && buffer.value();
    }
    renderHull(context) {
        const buffer = context == null ? context = new (0, $af9afc1e1274d6e6$export$2e2bcd8739ae039) : undefined;
        const { hull: hull, points: points } = this;
        const h = hull[0] * 2, n = hull.length;
        context.moveTo(points[h], points[h + 1]);
        for(let i = 1; i < n; ++i){
            const h = 2 * hull[i];
            context.lineTo(points[h], points[h + 1]);
        }
        context.closePath();
        return buffer && buffer.value();
    }
    hullPolygon() {
        const polygon = new (0, $f5e698a9cbc548e6$export$2e2bcd8739ae039);
        this.renderHull(polygon);
        return polygon.value();
    }
    renderTriangle(i, context) {
        const buffer = context == null ? context = new (0, $af9afc1e1274d6e6$export$2e2bcd8739ae039) : undefined;
        const { points: points, triangles: triangles } = this;
        const t0 = triangles[i *= 3] * 2;
        const t1 = triangles[i + 1] * 2;
        const t2 = triangles[i + 2] * 2;
        context.moveTo(points[t0], points[t0 + 1]);
        context.lineTo(points[t1], points[t1 + 1]);
        context.lineTo(points[t2], points[t2 + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *trianglePolygons() {
        const { triangles: triangles } = this;
        for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
    }
    trianglePolygon(i) {
        const polygon = new (0, $f5e698a9cbc548e6$export$2e2bcd8739ae039);
        this.renderTriangle(i, polygon);
        return polygon.value();
    }
}
function $3dd77de0651120db$var$flatArray(points, fx, fy, that) {
    const n = points.length;
    const array = new Float64Array(n * 2);
    for(let i = 0; i < n; ++i){
        const p = points[i];
        array[i * 2] = fx.call(that, p, i, points);
        array[i * 2 + 1] = fy.call(that, p, i, points);
    }
    return array;
}
function* $3dd77de0651120db$var$flatIterable(points, fx, fy, that) {
    let i = 0;
    for (const p of points){
        yield fx.call(that, p, i, points);
        yield fy.call(that, p, i, points);
        ++i;
    }
}





var $d2eef0483e3528fd$exports = {};

$parcel$export($d2eef0483e3528fd$exports, "dispatch", () => $cfaa4969c311d138$export$2e2bcd8739ae039);



var $9ea5feb77cd607ae$exports = {};

$parcel$export($9ea5feb77cd607ae$exports, "drag", () => $f1dfc871c9f04a6c$export$2e2bcd8739ae039);
$parcel$export($9ea5feb77cd607ae$exports, "dragDisable", () => $2cf643e39b411f06$export$2e2bcd8739ae039);
$parcel$export($9ea5feb77cd607ae$exports, "dragEnable", () => $2cf643e39b411f06$export$833237748009e1e1);




var $efee46a15eddd742$export$2e2bcd8739ae039 = (x)=>()=>x;


function $732b6861353d5220$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, subject: subject, target: target, identifier: identifier, active: active, x: x, y: y, dx: dx, dy: dy, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        subject: {
            value: subject,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        identifier: {
            value: identifier,
            enumerable: true,
            configurable: true
        },
        active: {
            value: active,
            enumerable: true,
            configurable: true
        },
        x: {
            value: x,
            enumerable: true,
            configurable: true
        },
        y: {
            value: y,
            enumerable: true,
            configurable: true
        },
        dx: {
            value: dx,
            enumerable: true,
            configurable: true
        },
        dy: {
            value: dy,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}
$732b6861353d5220$export$2e2bcd8739ae039.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};


// Ignore right-click, since that should open the context menu.
function $f1dfc871c9f04a6c$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $f1dfc871c9f04a6c$var$defaultContainer() {
    return this.parentNode;
}
function $f1dfc871c9f04a6c$var$defaultSubject(event, d) {
    return d == null ? {
        x: event.x,
        y: event.y
    } : d;
}
function $f1dfc871c9f04a6c$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $f1dfc871c9f04a6c$export$2e2bcd8739ae039() {
    var filter = $f1dfc871c9f04a6c$var$defaultFilter, container = $f1dfc871c9f04a6c$var$defaultContainer, subject = $f1dfc871c9f04a6c$var$defaultSubject, touchable = $f1dfc871c9f04a6c$var$defaultTouchable, gestures = {}, listeners = (0, $cfaa4969c311d138$export$2e2bcd8739ae039)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
    function drag(selection) {
        selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved, (0, $7023336a67ab2e82$export$524615cd03e458cc)).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    function mousedowned(event, d) {
        if (touchending || !filter.call(this, event, d)) return;
        var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
        if (!gesture) return;
        (0, $c38382a82e61d17a$export$2e2bcd8739ae039)(event.view).on("mousemove.drag", mousemoved, (0, $7023336a67ab2e82$export$35431a0e47022de1)).on("mouseup.drag", mouseupped, (0, $7023336a67ab2e82$export$35431a0e47022de1));
        (0, $2cf643e39b411f06$export$2e2bcd8739ae039)(event.view);
        (0, $7023336a67ab2e82$export$2e2561858db9bf47)(event);
        mousemoving = false;
        mousedownx = event.clientX;
        mousedowny = event.clientY;
        gesture("start", event);
    }
    function mousemoved(event) {
        (0, $7023336a67ab2e82$export$2e2bcd8739ae039)(event);
        if (!mousemoving) {
            var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
            mousemoving = dx * dx + dy * dy > clickDistance2;
        }
        gestures.mouse("drag", event);
    }
    function mouseupped(event) {
        (0, $c38382a82e61d17a$export$2e2bcd8739ae039)(event.view).on("mousemove.drag mouseup.drag", null);
        (0, $2cf643e39b411f06$export$833237748009e1e1)(event.view, mousemoving);
        (0, $7023336a67ab2e82$export$2e2bcd8739ae039)(event);
        gestures.mouse("end", event);
    }
    function touchstarted(event, d) {
        if (!filter.call(this, event, d)) return;
        var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
            (0, $7023336a67ab2e82$export$2e2561858db9bf47)(event);
            gesture("start", event, touches[i]);
        }
    }
    function touchmoved(event) {
        var touches = event.changedTouches, n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $7023336a67ab2e82$export$2e2bcd8739ae039)(event);
            gesture("drag", event, touches[i]);
        }
    }
    function touchended(event) {
        var touches = event.changedTouches, n = touches.length, i, gesture;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, 500); // Ghost clicks are delayed!
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $7023336a67ab2e82$export$2e2561858db9bf47)(event);
            gesture("end", event, touches[i]);
        }
    }
    function beforestart(that, container, event, d, identifier, touch) {
        var dispatch = listeners.copy(), p = (0, $01126f29f8cc9cfb$export$2e2bcd8739ae039)(touch || event, container), dx, dy, s;
        if ((s = subject.call(that, new (0, $732b6861353d5220$export$2e2bcd8739ae039)("beforestart", {
            sourceEvent: event,
            target: drag,
            identifier: identifier,
            active: active,
            x: p[0],
            y: p[1],
            dx: 0,
            dy: 0,
            dispatch: dispatch
        }), d)) == null) return;
        dx = s.x - p[0] || 0;
        dy = s.y - p[1] || 0;
        return function gesture(type, event, touch) {
            var p0 = p, n;
            switch(type){
                case "start":
                    gestures[identifier] = gesture, n = active++;
                    break;
                case "end":
                    delete gestures[identifier], --active; // falls through
                case "drag":
                    p = (0, $01126f29f8cc9cfb$export$2e2bcd8739ae039)(touch || event, container), n = active;
                    break;
            }
            dispatch.call(type, that, new (0, $732b6861353d5220$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                subject: s,
                target: drag,
                identifier: identifier,
                active: n,
                x: p[0] + dx,
                y: p[1] + dy,
                dx: p[0] - p0[0],
                dy: p[1] - p0[1],
                dispatch: dispatch
            }), d);
        };
    }
    drag.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $efee46a15eddd742$export$2e2bcd8739ae039)(!!_), drag) : filter;
    };
    drag.container = function(_) {
        return arguments.length ? (container = typeof _ === "function" ? _ : (0, $efee46a15eddd742$export$2e2bcd8739ae039)(_), drag) : container;
    };
    drag.subject = function(_) {
        return arguments.length ? (subject = typeof _ === "function" ? _ : (0, $efee46a15eddd742$export$2e2bcd8739ae039)(_), drag) : subject;
    };
    drag.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $efee46a15eddd742$export$2e2bcd8739ae039)(!!_), drag) : touchable;
    };
    drag.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? drag : value;
    };
    drag.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
    };
    return drag;
}





var $a6bf3498874c0285$exports = {};

$parcel$export($a6bf3498874c0285$exports, "dsvFormat", () => $d96dd9178e18ab29$export$2e2bcd8739ae039);
$parcel$export($a6bf3498874c0285$exports, "csvParse", () => $2f2892cac207b834$export$289d25497b0f4c16);
$parcel$export($a6bf3498874c0285$exports, "csvParseRows", () => $2f2892cac207b834$export$c82550ca942d869);
$parcel$export($a6bf3498874c0285$exports, "csvFormat", () => $2f2892cac207b834$export$afe767551074aa08);
$parcel$export($a6bf3498874c0285$exports, "csvFormatBody", () => $2f2892cac207b834$export$b46fa59a5e3bc8a2);
$parcel$export($a6bf3498874c0285$exports, "csvFormatRows", () => $2f2892cac207b834$export$3f42a65843fbd1d9);
$parcel$export($a6bf3498874c0285$exports, "csvFormatRow", () => $2f2892cac207b834$export$c30212b87b2d080f);
$parcel$export($a6bf3498874c0285$exports, "csvFormatValue", () => $2f2892cac207b834$export$2771de09a60fc648);
$parcel$export($a6bf3498874c0285$exports, "tsvParse", () => $4196127017a9d0c7$export$f913251db2f734ee);
$parcel$export($a6bf3498874c0285$exports, "tsvParseRows", () => $4196127017a9d0c7$export$8de3b5abc40a067f);
$parcel$export($a6bf3498874c0285$exports, "tsvFormat", () => $4196127017a9d0c7$export$77e754c4f8504293);
$parcel$export($a6bf3498874c0285$exports, "tsvFormatBody", () => $4196127017a9d0c7$export$9d44987d460c9cb3);
$parcel$export($a6bf3498874c0285$exports, "tsvFormatRows", () => $4196127017a9d0c7$export$ae461973f6adc981);
$parcel$export($a6bf3498874c0285$exports, "tsvFormatRow", () => $4196127017a9d0c7$export$5d61cf35a4a738d2);
$parcel$export($a6bf3498874c0285$exports, "tsvFormatValue", () => $4196127017a9d0c7$export$4280e6a416cd92a3);
$parcel$export($a6bf3498874c0285$exports, "autoType", () => $a8b85263c78626e3$export$2e2bcd8739ae039);
var $d96dd9178e18ab29$var$EOL = {}, $d96dd9178e18ab29$var$EOF = {}, $d96dd9178e18ab29$var$QUOTE = 34, $d96dd9178e18ab29$var$NEWLINE = 10, $d96dd9178e18ab29$var$RETURN = 13;
function $d96dd9178e18ab29$var$objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + '] || ""';
    }).join(",") + "}");
}
function $d96dd9178e18ab29$var$customConverter(columns, f) {
    var object = $d96dd9178e18ab29$var$objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function $d96dd9178e18ab29$var$inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function $d96dd9178e18ab29$var$pad(value, width) {
    var s = value + "", length = s.length;
    return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function $d96dd9178e18ab29$var$formatYear(year) {
    return year < 0 ? "-" + $d96dd9178e18ab29$var$pad(-year, 6) : year > 9999 ? "+" + $d96dd9178e18ab29$var$pad(year, 6) : $d96dd9178e18ab29$var$pad(year, 4);
}
function $d96dd9178e18ab29$var$formatDate(date) {
    var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
    return isNaN(date) ? "Invalid Date" : $d96dd9178e18ab29$var$formatYear(date.getUTCFullYear(), 4) + "-" + $d96dd9178e18ab29$var$pad(date.getUTCMonth() + 1, 2) + "-" + $d96dd9178e18ab29$var$pad(date.getUTCDate(), 2) + (milliseconds ? "T" + $d96dd9178e18ab29$var$pad(hours, 2) + ":" + $d96dd9178e18ab29$var$pad(minutes, 2) + ":" + $d96dd9178e18ab29$var$pad(seconds, 2) + "." + $d96dd9178e18ab29$var$pad(milliseconds, 3) + "Z" : seconds ? "T" + $d96dd9178e18ab29$var$pad(hours, 2) + ":" + $d96dd9178e18ab29$var$pad(minutes, 2) + ":" + $d96dd9178e18ab29$var$pad(seconds, 2) + "Z" : minutes || hours ? "T" + $d96dd9178e18ab29$var$pad(hours, 2) + ":" + $d96dd9178e18ab29$var$pad(minutes, 2) + "Z" : "");
}
function $d96dd9178e18ab29$export$2e2bcd8739ae039(delimiter) {
    var reFormat = new RegExp('["' + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
    function parse(text, f) {
        var convert, columns, rows = parseRows(text, function(row, i) {
            if (convert) return convert(row, i - 1);
            columns = row, convert = f ? $d96dd9178e18ab29$var$customConverter(row, f) : $d96dd9178e18ab29$var$objectConverter(row);
        });
        rows.columns = columns || [];
        return rows;
    }
    function parseRows(text, f) {
        var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
        // Strip the trailing newline.
        if (text.charCodeAt(N - 1) === $d96dd9178e18ab29$var$NEWLINE) --N;
        if (text.charCodeAt(N - 1) === $d96dd9178e18ab29$var$RETURN) --N;
        function token() {
            if (eof) return $d96dd9178e18ab29$var$EOF;
            if (eol) return eol = false, $d96dd9178e18ab29$var$EOL;
            // Unescape quotes.
            var i, j = I, c;
            if (text.charCodeAt(j) === $d96dd9178e18ab29$var$QUOTE) {
                while(I++ < N && text.charCodeAt(I) !== $d96dd9178e18ab29$var$QUOTE || text.charCodeAt(++I) === $d96dd9178e18ab29$var$QUOTE);
                if ((i = I) >= N) eof = true;
                else if ((c = text.charCodeAt(I++)) === $d96dd9178e18ab29$var$NEWLINE) eol = true;
                else if (c === $d96dd9178e18ab29$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $d96dd9178e18ab29$var$NEWLINE) ++I;
                }
                return text.slice(j + 1, i - 1).replace(/""/g, '"');
            }
            // Find next delimiter or newline.
            while(I < N){
                if ((c = text.charCodeAt(i = I++)) === $d96dd9178e18ab29$var$NEWLINE) eol = true;
                else if (c === $d96dd9178e18ab29$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $d96dd9178e18ab29$var$NEWLINE) ++I;
                } else if (c !== DELIMITER) continue;
                return text.slice(j, i);
            }
            // Return last token before EOF.
            return eof = true, text.slice(j, N);
        }
        while((t = token()) !== $d96dd9178e18ab29$var$EOF){
            var row = [];
            while(t !== $d96dd9178e18ab29$var$EOL && t !== $d96dd9178e18ab29$var$EOF)row.push(t), t = token();
            if (f && (row = f(row, n++)) == null) continue;
            rows.push(row);
        }
        return rows;
    }
    function preformatBody(rows, columns) {
        return rows.map(function(row) {
            return columns.map(function(column) {
                return formatValue(row[column]);
            }).join(delimiter);
        });
    }
    function format(rows, columns) {
        if (columns == null) columns = $d96dd9178e18ab29$var$inferColumns(rows);
        return [
            columns.map(formatValue).join(delimiter)
        ].concat(preformatBody(rows, columns)).join("\n");
    }
    function formatBody(rows, columns) {
        if (columns == null) columns = $d96dd9178e18ab29$var$inferColumns(rows);
        return preformatBody(rows, columns).join("\n");
    }
    function formatRows(rows) {
        return rows.map(formatRow).join("\n");
    }
    function formatRow(row) {
        return row.map(formatValue).join(delimiter);
    }
    function formatValue(value) {
        return value == null ? "" : value instanceof Date ? $d96dd9178e18ab29$var$formatDate(value) : reFormat.test(value += "") ? '"' + value.replace(/"/g, '""') + '"' : value;
    }
    return {
        parse: parse,
        parseRows: parseRows,
        format: format,
        formatBody: formatBody,
        formatRows: formatRows,
        formatRow: formatRow,
        formatValue: formatValue
    };
}



var $2f2892cac207b834$var$csv = (0, $d96dd9178e18ab29$export$2e2bcd8739ae039)(",");
var $2f2892cac207b834$export$289d25497b0f4c16 = $2f2892cac207b834$var$csv.parse;
var $2f2892cac207b834$export$c82550ca942d869 = $2f2892cac207b834$var$csv.parseRows;
var $2f2892cac207b834$export$afe767551074aa08 = $2f2892cac207b834$var$csv.format;
var $2f2892cac207b834$export$b46fa59a5e3bc8a2 = $2f2892cac207b834$var$csv.formatBody;
var $2f2892cac207b834$export$3f42a65843fbd1d9 = $2f2892cac207b834$var$csv.formatRows;
var $2f2892cac207b834$export$c30212b87b2d080f = $2f2892cac207b834$var$csv.formatRow;
var $2f2892cac207b834$export$2771de09a60fc648 = $2f2892cac207b834$var$csv.formatValue;



var $4196127017a9d0c7$var$tsv = (0, $d96dd9178e18ab29$export$2e2bcd8739ae039)("	");
var $4196127017a9d0c7$export$f913251db2f734ee = $4196127017a9d0c7$var$tsv.parse;
var $4196127017a9d0c7$export$8de3b5abc40a067f = $4196127017a9d0c7$var$tsv.parseRows;
var $4196127017a9d0c7$export$77e754c4f8504293 = $4196127017a9d0c7$var$tsv.format;
var $4196127017a9d0c7$export$9d44987d460c9cb3 = $4196127017a9d0c7$var$tsv.formatBody;
var $4196127017a9d0c7$export$ae461973f6adc981 = $4196127017a9d0c7$var$tsv.formatRows;
var $4196127017a9d0c7$export$5d61cf35a4a738d2 = $4196127017a9d0c7$var$tsv.formatRow;
var $4196127017a9d0c7$export$4280e6a416cd92a3 = $4196127017a9d0c7$var$tsv.formatValue;


function $a8b85263c78626e3$export$2e2bcd8739ae039(object) {
    for(var key in object){
        var value = object[key].trim(), number, m;
        if (!value) value = null;
        else if (value === "true") value = true;
        else if (value === "false") value = false;
        else if (value === "NaN") value = NaN;
        else if (!isNaN(number = +value)) value = number;
        else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
            if ($a8b85263c78626e3$var$fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
            value = new Date(value);
        } else continue;
        object[key] = value;
    }
    return object;
}
// https://github.com/d3/d3-dsv/issues/45
const $a8b85263c78626e3$var$fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();




var $b7fc7c265f537bd8$exports = {};

$parcel$export($b7fc7c265f537bd8$exports, "easeLinear", () => $54689755519f6db9$export$45db2fc2f15997e7);
$parcel$export($b7fc7c265f537bd8$exports, "easeQuad", () => $0aa45900073a0014$export$d6ded66933892ed3);
$parcel$export($b7fc7c265f537bd8$exports, "easeQuadIn", () => $0aa45900073a0014$export$5118fc7a1e64441b);
$parcel$export($b7fc7c265f537bd8$exports, "easeQuadOut", () => $0aa45900073a0014$export$5be5f5e804d0b60c);
$parcel$export($b7fc7c265f537bd8$exports, "easeQuadInOut", () => $0aa45900073a0014$export$d6ded66933892ed3);
$parcel$export($b7fc7c265f537bd8$exports, "easeCubic", () => $98f74d529807ec12$export$89238d3bc79d3ada);
$parcel$export($b7fc7c265f537bd8$exports, "easeCubicIn", () => $98f74d529807ec12$export$b1a09cb1b71f86aa);
$parcel$export($b7fc7c265f537bd8$exports, "easeCubicOut", () => $98f74d529807ec12$export$68d528839c701b6);
$parcel$export($b7fc7c265f537bd8$exports, "easeCubicInOut", () => $98f74d529807ec12$export$89238d3bc79d3ada);
$parcel$export($b7fc7c265f537bd8$exports, "easePoly", () => $57ce089432fbbcc8$export$ae94c6a40058b429);
$parcel$export($b7fc7c265f537bd8$exports, "easePolyIn", () => $57ce089432fbbcc8$export$aa0b5c3ce2df9d7d);
$parcel$export($b7fc7c265f537bd8$exports, "easePolyOut", () => $57ce089432fbbcc8$export$e3d987a417dc6640);
$parcel$export($b7fc7c265f537bd8$exports, "easePolyInOut", () => $57ce089432fbbcc8$export$ae94c6a40058b429);
$parcel$export($b7fc7c265f537bd8$exports, "easeSin", () => $fbf3005ff05b3858$export$ff58b604d3ba15ba);
$parcel$export($b7fc7c265f537bd8$exports, "easeSinIn", () => $fbf3005ff05b3858$export$a83a280f8d31ba8d);
$parcel$export($b7fc7c265f537bd8$exports, "easeSinOut", () => $fbf3005ff05b3858$export$62ec6410ca53f2a7);
$parcel$export($b7fc7c265f537bd8$exports, "easeSinInOut", () => $fbf3005ff05b3858$export$ff58b604d3ba15ba);
$parcel$export($b7fc7c265f537bd8$exports, "easeExp", () => $1121342d85f4f492$export$ae4d4e77fab188ff);
$parcel$export($b7fc7c265f537bd8$exports, "easeExpIn", () => $1121342d85f4f492$export$fc3e95f15e1ef38e);
$parcel$export($b7fc7c265f537bd8$exports, "easeExpOut", () => $1121342d85f4f492$export$f3c9b2f85fbcf0ab);
$parcel$export($b7fc7c265f537bd8$exports, "easeExpInOut", () => $1121342d85f4f492$export$ae4d4e77fab188ff);
$parcel$export($b7fc7c265f537bd8$exports, "easeCircle", () => $25d8c6989dff64c0$export$2d757ff9ad09038f);
$parcel$export($b7fc7c265f537bd8$exports, "easeCircleIn", () => $25d8c6989dff64c0$export$9f82a71b0377c018);
$parcel$export($b7fc7c265f537bd8$exports, "easeCircleOut", () => $25d8c6989dff64c0$export$27989e665abef2c8);
$parcel$export($b7fc7c265f537bd8$exports, "easeCircleInOut", () => $25d8c6989dff64c0$export$2d757ff9ad09038f);
$parcel$export($b7fc7c265f537bd8$exports, "easeBounce", () => $662c06028f5f1f34$export$cccc9e04465dce11);
$parcel$export($b7fc7c265f537bd8$exports, "easeBounceIn", () => $662c06028f5f1f34$export$fccebd7948554554);
$parcel$export($b7fc7c265f537bd8$exports, "easeBounceOut", () => $662c06028f5f1f34$export$cccc9e04465dce11);
$parcel$export($b7fc7c265f537bd8$exports, "easeBounceInOut", () => $662c06028f5f1f34$export$41ad9e9849a703ce);
$parcel$export($b7fc7c265f537bd8$exports, "easeBack", () => $d4c794a8fc46a401$export$ddc5fd596f6c71b2);
$parcel$export($b7fc7c265f537bd8$exports, "easeBackIn", () => $d4c794a8fc46a401$export$b01116c84cdfe1a2);
$parcel$export($b7fc7c265f537bd8$exports, "easeBackOut", () => $d4c794a8fc46a401$export$77edfce482316a60);
$parcel$export($b7fc7c265f537bd8$exports, "easeBackInOut", () => $d4c794a8fc46a401$export$ddc5fd596f6c71b2);
$parcel$export($b7fc7c265f537bd8$exports, "easeElastic", () => $f9f19488aae1acf9$export$ed1782b99e69bbc8);
$parcel$export($b7fc7c265f537bd8$exports, "easeElasticIn", () => $f9f19488aae1acf9$export$41f42134872a5fa0);
$parcel$export($b7fc7c265f537bd8$exports, "easeElasticOut", () => $f9f19488aae1acf9$export$ed1782b99e69bbc8);
$parcel$export($b7fc7c265f537bd8$exports, "easeElasticInOut", () => $f9f19488aae1acf9$export$309de4f35f218bfd);
const $54689755519f6db9$export$45db2fc2f15997e7 = (t)=>+t;


function $0aa45900073a0014$export$5118fc7a1e64441b(t) {
    return t * t;
}
function $0aa45900073a0014$export$5be5f5e804d0b60c(t) {
    return t * (2 - t);
}
function $0aa45900073a0014$export$d6ded66933892ed3(t) {
    return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}



var $57ce089432fbbcc8$var$exponent = 3;
var $57ce089432fbbcc8$export$aa0b5c3ce2df9d7d = function custom(e) {
    e = +e;
    function polyIn(t) {
        return Math.pow(t, e);
    }
    polyIn.exponent = custom;
    return polyIn;
}($57ce089432fbbcc8$var$exponent);
var $57ce089432fbbcc8$export$e3d987a417dc6640 = function custom(e) {
    e = +e;
    function polyOut(t) {
        return 1 - Math.pow(1 - t, e);
    }
    polyOut.exponent = custom;
    return polyOut;
}($57ce089432fbbcc8$var$exponent);
var $57ce089432fbbcc8$export$ae94c6a40058b429 = function custom(e) {
    e = +e;
    function polyInOut(t) {
        return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
    }
    polyInOut.exponent = custom;
    return polyInOut;
}($57ce089432fbbcc8$var$exponent);


var $fbf3005ff05b3858$var$pi = Math.PI, $fbf3005ff05b3858$var$halfPi = $fbf3005ff05b3858$var$pi / 2;
function $fbf3005ff05b3858$export$a83a280f8d31ba8d(t) {
    return +t === 1 ? 1 : 1 - Math.cos(t * $fbf3005ff05b3858$var$halfPi);
}
function $fbf3005ff05b3858$export$62ec6410ca53f2a7(t) {
    return Math.sin(t * $fbf3005ff05b3858$var$halfPi);
}
function $fbf3005ff05b3858$export$ff58b604d3ba15ba(t) {
    return (1 - Math.cos($fbf3005ff05b3858$var$pi * t)) / 2;
}


// tpmt is two power minus ten times t scaled to [0,1]
function $f4196b5b035c44c3$export$be3f0f7224794b88(x) {
    return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}


function $1121342d85f4f492$export$fc3e95f15e1ef38e(t) {
    return (0, $f4196b5b035c44c3$export$be3f0f7224794b88)(1 - +t);
}
function $1121342d85f4f492$export$f3c9b2f85fbcf0ab(t) {
    return 1 - (0, $f4196b5b035c44c3$export$be3f0f7224794b88)(t);
}
function $1121342d85f4f492$export$ae4d4e77fab188ff(t) {
    return ((t *= 2) <= 1 ? (0, $f4196b5b035c44c3$export$be3f0f7224794b88)(1 - t) : 2 - (0, $f4196b5b035c44c3$export$be3f0f7224794b88)(t - 1)) / 2;
}


function $25d8c6989dff64c0$export$9f82a71b0377c018(t) {
    return 1 - Math.sqrt(1 - t * t);
}
function $25d8c6989dff64c0$export$27989e665abef2c8(t) {
    return Math.sqrt(1 - --t * t);
}
function $25d8c6989dff64c0$export$2d757ff9ad09038f(t) {
    return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}


var $662c06028f5f1f34$var$b1 = 4 / 11, $662c06028f5f1f34$var$b2 = 6 / 11, $662c06028f5f1f34$var$b3 = 8 / 11, $662c06028f5f1f34$var$b4 = 3 / 4, $662c06028f5f1f34$var$b5 = 9 / 11, $662c06028f5f1f34$var$b6 = 10 / 11, $662c06028f5f1f34$var$b7 = 15 / 16, $662c06028f5f1f34$var$b8 = 21 / 22, $662c06028f5f1f34$var$b9 = 63 / 64, $662c06028f5f1f34$var$b0 = 1 / $662c06028f5f1f34$var$b1 / $662c06028f5f1f34$var$b1;
function $662c06028f5f1f34$export$fccebd7948554554(t) {
    return 1 - $662c06028f5f1f34$export$cccc9e04465dce11(1 - t);
}
function $662c06028f5f1f34$export$cccc9e04465dce11(t) {
    return (t = +t) < $662c06028f5f1f34$var$b1 ? $662c06028f5f1f34$var$b0 * t * t : t < $662c06028f5f1f34$var$b3 ? $662c06028f5f1f34$var$b0 * (t -= $662c06028f5f1f34$var$b2) * t + $662c06028f5f1f34$var$b4 : t < $662c06028f5f1f34$var$b6 ? $662c06028f5f1f34$var$b0 * (t -= $662c06028f5f1f34$var$b5) * t + $662c06028f5f1f34$var$b7 : $662c06028f5f1f34$var$b0 * (t -= $662c06028f5f1f34$var$b8) * t + $662c06028f5f1f34$var$b9;
}
function $662c06028f5f1f34$export$41ad9e9849a703ce(t) {
    return ((t *= 2) <= 1 ? 1 - $662c06028f5f1f34$export$cccc9e04465dce11(1 - t) : $662c06028f5f1f34$export$cccc9e04465dce11(t - 1) + 1) / 2;
}


var $d4c794a8fc46a401$var$overshoot = 1.70158;
var $d4c794a8fc46a401$export$b01116c84cdfe1a2 = function custom(s) {
    s = +s;
    function backIn(t) {
        return (t = +t) * t * (s * (t - 1) + t);
    }
    backIn.overshoot = custom;
    return backIn;
}($d4c794a8fc46a401$var$overshoot);
var $d4c794a8fc46a401$export$77edfce482316a60 = function custom(s) {
    s = +s;
    function backOut(t) {
        return --t * t * ((t + 1) * s + t) + 1;
    }
    backOut.overshoot = custom;
    return backOut;
}($d4c794a8fc46a401$var$overshoot);
var $d4c794a8fc46a401$export$ddc5fd596f6c71b2 = function custom(s) {
    s = +s;
    function backInOut(t) {
        return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
    }
    backInOut.overshoot = custom;
    return backInOut;
}($d4c794a8fc46a401$var$overshoot);



var $f9f19488aae1acf9$var$tau = 2 * Math.PI, $f9f19488aae1acf9$var$amplitude = 1, $f9f19488aae1acf9$var$period = 0.3;
var $f9f19488aae1acf9$export$41f42134872a5fa0 = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $f9f19488aae1acf9$var$tau);
    function elasticIn(t) {
        return a * (0, $f4196b5b035c44c3$export$be3f0f7224794b88)(- --t) * Math.sin((s - t) / p);
    }
    elasticIn.amplitude = function(a) {
        return custom(a, p * $f9f19488aae1acf9$var$tau);
    };
    elasticIn.period = function(p) {
        return custom(a, p);
    };
    return elasticIn;
}($f9f19488aae1acf9$var$amplitude, $f9f19488aae1acf9$var$period);
var $f9f19488aae1acf9$export$ed1782b99e69bbc8 = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $f9f19488aae1acf9$var$tau);
    function elasticOut(t) {
        return 1 - a * (0, $f4196b5b035c44c3$export$be3f0f7224794b88)(t = +t) * Math.sin((t + s) / p);
    }
    elasticOut.amplitude = function(a) {
        return custom(a, p * $f9f19488aae1acf9$var$tau);
    };
    elasticOut.period = function(p) {
        return custom(a, p);
    };
    return elasticOut;
}($f9f19488aae1acf9$var$amplitude, $f9f19488aae1acf9$var$period);
var $f9f19488aae1acf9$export$309de4f35f218bfd = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $f9f19488aae1acf9$var$tau);
    function elasticInOut(t) {
        return ((t = t * 2 - 1) < 0 ? a * (0, $f4196b5b035c44c3$export$be3f0f7224794b88)(-t) * Math.sin((s - t) / p) : 2 - a * (0, $f4196b5b035c44c3$export$be3f0f7224794b88)(t) * Math.sin((s + t) / p)) / 2;
    }
    elasticInOut.amplitude = function(a) {
        return custom(a, p * $f9f19488aae1acf9$var$tau);
    };
    elasticInOut.period = function(p) {
        return custom(a, p);
    };
    return elasticInOut;
}($f9f19488aae1acf9$var$amplitude, $f9f19488aae1acf9$var$period);




var $5c65ad318a8bf09b$exports = {};

$parcel$export($5c65ad318a8bf09b$exports, "blob", () => $a596f9f1d7579b2f$export$2e2bcd8739ae039);
$parcel$export($5c65ad318a8bf09b$exports, "buffer", () => $3de06b0bd9dc3630$export$2e2bcd8739ae039);
$parcel$export($5c65ad318a8bf09b$exports, "dsv", () => $a2934413bbd88e16$export$2e2bcd8739ae039);
$parcel$export($5c65ad318a8bf09b$exports, "csv", () => $a2934413bbd88e16$export$901ba78aa04f49da);
$parcel$export($5c65ad318a8bf09b$exports, "tsv", () => $a2934413bbd88e16$export$580b2de76423ff18);
$parcel$export($5c65ad318a8bf09b$exports, "image", () => $46d7640035e7fcc3$export$2e2bcd8739ae039);
$parcel$export($5c65ad318a8bf09b$exports, "json", () => $e5610075509d521a$export$2e2bcd8739ae039);
$parcel$export($5c65ad318a8bf09b$exports, "text", () => $ba0ce1f950c36b7b$export$2e2bcd8739ae039);
$parcel$export($5c65ad318a8bf09b$exports, "xml", () => $a4b7b6a2571cd603$export$2e2bcd8739ae039);
$parcel$export($5c65ad318a8bf09b$exports, "html", () => $a4b7b6a2571cd603$export$c0bb0b647f701bb5);
$parcel$export($5c65ad318a8bf09b$exports, "svg", () => $a4b7b6a2571cd603$export$7ed1367e7fa1ad68);
function $a596f9f1d7579b2f$var$responseBlob(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.blob();
}
function $a596f9f1d7579b2f$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($a596f9f1d7579b2f$var$responseBlob);
}


function $3de06b0bd9dc3630$var$responseArrayBuffer(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.arrayBuffer();
}
function $3de06b0bd9dc3630$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($3de06b0bd9dc3630$var$responseArrayBuffer);
}



function $ba0ce1f950c36b7b$var$responseText(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.text();
}
function $ba0ce1f950c36b7b$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($ba0ce1f950c36b7b$var$responseText);
}


function $a2934413bbd88e16$var$dsvParse(parse) {
    return function(input, init, row) {
        if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
        return (0, $ba0ce1f950c36b7b$export$2e2bcd8739ae039)(input, init).then(function(response) {
            return parse(response, row);
        });
    };
}
function $a2934413bbd88e16$export$2e2bcd8739ae039(delimiter, input, init, row) {
    if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
    var format = (0, $d96dd9178e18ab29$export$2e2bcd8739ae039)(delimiter);
    return (0, $ba0ce1f950c36b7b$export$2e2bcd8739ae039)(input, init).then(function(response) {
        return format.parse(response, row);
    });
}
var $a2934413bbd88e16$export$901ba78aa04f49da = $a2934413bbd88e16$var$dsvParse((0, $2f2892cac207b834$export$289d25497b0f4c16));
var $a2934413bbd88e16$export$580b2de76423ff18 = $a2934413bbd88e16$var$dsvParse((0, $4196127017a9d0c7$export$f913251db2f734ee));


function $46d7640035e7fcc3$export$2e2bcd8739ae039(input, init) {
    return new Promise(function(resolve, reject) {
        var image = new Image;
        for(var key in init)image[key] = init[key];
        image.onerror = reject;
        image.onload = function() {
            resolve(image);
        };
        image.src = input;
    });
}


function $e5610075509d521a$var$responseJson(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    if (response.status === 204 || response.status === 205) return;
    return response.json();
}
function $e5610075509d521a$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($e5610075509d521a$var$responseJson);
}




function $a4b7b6a2571cd603$var$parser(type) {
    return (input, init)=>(0, $ba0ce1f950c36b7b$export$2e2bcd8739ae039)(input, init).then((text)=>(new DOMParser).parseFromString(text, type));
}
var $a4b7b6a2571cd603$export$2e2bcd8739ae039 = $a4b7b6a2571cd603$var$parser("application/xml");
var $a4b7b6a2571cd603$export$c0bb0b647f701bb5 = $a4b7b6a2571cd603$var$parser("text/html");
var $a4b7b6a2571cd603$export$7ed1367e7fa1ad68 = $a4b7b6a2571cd603$var$parser("image/svg+xml");




var $7fb8675b7815fed9$exports = {};

$parcel$export($7fb8675b7815fed9$exports, "forceCenter", () => $67b32f4b4eb7e6e6$export$2e2bcd8739ae039);
$parcel$export($7fb8675b7815fed9$exports, "forceCollide", () => $8d9b29504d0cb122$export$2e2bcd8739ae039);
$parcel$export($7fb8675b7815fed9$exports, "forceLink", () => $245e0bcc13363ea7$export$2e2bcd8739ae039);
$parcel$export($7fb8675b7815fed9$exports, "forceManyBody", () => $7bedc69c36ea6e96$export$2e2bcd8739ae039);
$parcel$export($7fb8675b7815fed9$exports, "forceRadial", () => $4a1201a13491f130$export$2e2bcd8739ae039);
$parcel$export($7fb8675b7815fed9$exports, "forceSimulation", () => $a6a959f0d8ac28e6$export$2e2bcd8739ae039);
$parcel$export($7fb8675b7815fed9$exports, "forceX", () => $bdf363e8b2af0a2f$export$2e2bcd8739ae039);
$parcel$export($7fb8675b7815fed9$exports, "forceY", () => $7f80564a83d584ad$export$2e2bcd8739ae039);
function $67b32f4b4eb7e6e6$export$2e2bcd8739ae039(x, y) {
    var nodes, strength = 1;
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force() {
        var i, n = nodes.length, node, sx = 0, sy = 0;
        for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
        for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
    }
    force.initialize = function(_) {
        nodes = _;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    return force;
}


function $aade664668e1b6c1$export$2e2bcd8739ae039(d) {
    const x = +this._x.call(null, d), y = +this._y.call(null, d);
    return $aade664668e1b6c1$var$add(this.cover(x, y), x, y, d);
}
function $aade664668e1b6c1$var$add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $aade664668e1b6c1$export$32ed0561867ec8a1(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)$aade664668e1b6c1$var$add(this, xz[i], yz[i], data[i]);
    return this;
}


function $c38876fd1873d1f4$export$2e2bcd8739ae039(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
    } else {
        var z = x1 - x0 || 1, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1){
            i = (y < y0) << 1 | x < x0;
            parent = new Array(4), parent[i] = node, node = parent, z *= 2;
            switch(i){
                case 0:
                    x1 = x0 + z, y1 = y0 + z;
                    break;
                case 1:
                    x0 = x1 - z, y1 = y0 + z;
                    break;
                case 2:
                    x1 = x0 + z, y0 = y1 - z;
                    break;
                case 3:
                    x0 = x1 - z, y0 = y1 - z;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
}


function $2544b1acbd39c95b$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}


function $d8e05639ddcdce1c$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0
        ],
        [
            this._x1,
            this._y1
        ]
    ];
}


function $dd3c8be8de17ce19$export$2e2bcd8739ae039(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
}


function $01db5f1a41775ebd$export$2e2bcd8739ae039(x, y, radius) {
    var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
    if (node) quads.push(new (0, $dd3c8be8de17ce19$export$2e2bcd8739ae039)(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius;
        x3 = x + radius, y3 = y + radius;
        radius *= radius;
    }
    while(q = quads.pop()){
        // Stop searching if this quadrant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
        // Bisect the current quadrant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
            quads.push(new (0, $dd3c8be8de17ce19$export$2e2bcd8739ae039)(node[3], xm, ym, x2, y2), new (0, $dd3c8be8de17ce19$export$2e2bcd8739ae039)(node[2], x1, ym, xm, y2), new (0, $dd3c8be8de17ce19$export$2e2bcd8739ae039)(node[1], xm, y1, x2, ym), new (0, $dd3c8be8de17ce19$export$2e2bcd8739ae039)(node[0], x1, y1, xm, ym));
            // Visit the closest quadrant first.
            if (i = (y >= ym) << 1 | x >= xm) {
                q = quads[quads.length - 1];
                quads[quads.length - 1] = quads[quads.length - 1 - i];
                quads[quads.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d;
                x3 = x + d, y3 = y + d;
                data = node.data;
            }
        }
    }
    return data;
}


function $9b24abbc2c9adf46$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $9b24abbc2c9adf46$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}


function $16542677a4d485e4$export$2e2bcd8739ae039() {
    return this._root;
}


function $bcc228d04841aa0c$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}



function $4fca53a4bfcd7af6$export$2e2bcd8739ae039(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new (0, $dd3c8be8de17ce19$export$2e2bcd8739ae039)(node, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new (0, $dd3c8be8de17ce19$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new (0, $dd3c8be8de17ce19$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new (0, $dd3c8be8de17ce19$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new (0, $dd3c8be8de17ce19$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
    }
    return this;
}



function $2ee405e3b49980d7$export$2e2bcd8739ae039(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new (0, $dd3c8be8de17ce19$export$2e2bcd8739ae039)(this._root, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[0]) quads.push(new (0, $dd3c8be8de17ce19$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
            if (child = node[1]) quads.push(new (0, $dd3c8be8de17ce19$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
            if (child = node[2]) quads.push(new (0, $dd3c8be8de17ce19$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
            if (child = node[3]) quads.push(new (0, $dd3c8be8de17ce19$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
    return this;
}


function $7b9e2e32000dc2a5$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $7b9e2e32000dc2a5$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}


function $3b10ae87f508593b$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $3b10ae87f508593b$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}


function $38d27fd39e705624$export$2e2bcd8739ae039(nodes, x, y) {
    var tree = new $38d27fd39e705624$var$Quadtree(x == null ? (0, $7b9e2e32000dc2a5$export$e6fafc98131d2a44) : x, y == null ? (0, $3b10ae87f508593b$export$6f0a21aeb844a64c) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $38d27fd39e705624$var$Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function $38d27fd39e705624$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $38d27fd39e705624$var$treeProto = $38d27fd39e705624$export$2e2bcd8739ae039.prototype = $38d27fd39e705624$var$Quadtree.prototype;
$38d27fd39e705624$var$treeProto.copy = function() {
    var copy = new $38d27fd39e705624$var$Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $38d27fd39e705624$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = $38d27fd39e705624$var$leaf_copy(child);
        }
    }
    return copy;
};
$38d27fd39e705624$var$treeProto.add = (0, $aade664668e1b6c1$export$2e2bcd8739ae039);
$38d27fd39e705624$var$treeProto.addAll = (0, $aade664668e1b6c1$export$32ed0561867ec8a1);
$38d27fd39e705624$var$treeProto.cover = (0, $c38876fd1873d1f4$export$2e2bcd8739ae039);
$38d27fd39e705624$var$treeProto.data = (0, $2544b1acbd39c95b$export$2e2bcd8739ae039);
$38d27fd39e705624$var$treeProto.extent = (0, $d8e05639ddcdce1c$export$2e2bcd8739ae039);
$38d27fd39e705624$var$treeProto.find = (0, $01db5f1a41775ebd$export$2e2bcd8739ae039);
$38d27fd39e705624$var$treeProto.remove = (0, $9b24abbc2c9adf46$export$2e2bcd8739ae039);
$38d27fd39e705624$var$treeProto.removeAll = (0, $9b24abbc2c9adf46$export$1cfc7aad5cb1833b);
$38d27fd39e705624$var$treeProto.root = (0, $16542677a4d485e4$export$2e2bcd8739ae039);
$38d27fd39e705624$var$treeProto.size = (0, $bcc228d04841aa0c$export$2e2bcd8739ae039);
$38d27fd39e705624$var$treeProto.visit = (0, $4fca53a4bfcd7af6$export$2e2bcd8739ae039);
$38d27fd39e705624$var$treeProto.visitAfter = (0, $2ee405e3b49980d7$export$2e2bcd8739ae039);
$38d27fd39e705624$var$treeProto.x = (0, $7b9e2e32000dc2a5$export$2e2bcd8739ae039);
$38d27fd39e705624$var$treeProto.y = (0, $3b10ae87f508593b$export$2e2bcd8739ae039);


function $e8248a8fd06f5a9e$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $93c2072d0add173c$export$2e2bcd8739ae039(random) {
    return (random() - 0.5) * 1e-6;
}


function $8d9b29504d0cb122$var$x(d) {
    return d.x + d.vx;
}
function $8d9b29504d0cb122$var$y(d) {
    return d.y + d.vy;
}
function $8d9b29504d0cb122$export$2e2bcd8739ae039(radius) {
    var nodes, radii, random, strength = 1, iterations = 1;
    if (typeof radius !== "function") radius = (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(radius == null ? 1 : +radius);
    function force() {
        var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
        for(var k = 0; k < iterations; ++k){
            tree = (0, $38d27fd39e705624$export$2e2bcd8739ae039)(nodes, $8d9b29504d0cb122$var$x, $8d9b29504d0cb122$var$y).visitAfter(prepare);
            for(i = 0; i < n; ++i){
                node = nodes[i];
                ri = radii[node.index], ri2 = ri * ri;
                xi = node.x + node.vx;
                yi = node.y + node.vy;
                tree.visit(apply);
            }
        }
        function apply(quad, x0, y0, x1, y1) {
            var data = quad.data, rj = quad.r, r = ri + rj;
            if (data) {
                if (data.index > node.index) {
                    var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                    if (l < r * r) {
                        if (x === 0) x = (0, $93c2072d0add173c$export$2e2bcd8739ae039)(random), l += x * x;
                        if (y === 0) y = (0, $93c2072d0add173c$export$2e2bcd8739ae039)(random), l += y * y;
                        l = (r - (l = Math.sqrt(l))) / l * strength;
                        node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                        node.vy += (y *= l) * r;
                        data.vx -= x * (r = 1 - r);
                        data.vy -= y * r;
                    }
                }
                return;
            }
            return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
        }
    }
    function prepare(quad) {
        if (quad.data) return quad.r = radii[quad.data.index];
        for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        radii = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(+_), initialize(), force) : radius;
    };
    return force;
}




function $245e0bcc13363ea7$var$index(d) {
    return d.index;
}
function $245e0bcc13363ea7$var$find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("node not found: " + nodeId);
    return node;
}
function $245e0bcc13363ea7$export$2e2bcd8739ae039(links) {
    var id = $245e0bcc13363ea7$var$index, strength = defaultStrength, strengths, distance = (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(30), distances, nodes, count, bias, random, iterations = 1;
    if (links == null) links = [];
    function defaultStrength(link) {
        return 1 / Math.min(count[link.source.index], count[link.target.index]);
    }
    function force(alpha) {
        for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
            link = links[i], source = link.source, target = link.target;
            x = target.x + target.vx - source.x - source.vx || (0, $93c2072d0add173c$export$2e2bcd8739ae039)(random);
            y = target.y + target.vy - source.y - source.vy || (0, $93c2072d0add173c$export$2e2bcd8739ae039)(random);
            l = Math.sqrt(x * x + y * y);
            l = (l - distances[i]) / l * alpha * strengths[i];
            x *= l, y *= l;
            target.vx -= x * (b = bias[i]);
            target.vy -= y * b;
            source.vx += x * (b = 1 - b);
            source.vy += y * b;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                id(d, i, nodes),
                d
            ])), link;
        for(i = 0, count = new Array(n); i < m; ++i){
            link = links[i], link.index = i;
            if (typeof link.source !== "object") link.source = $245e0bcc13363ea7$var$find(nodeById, link.source);
            if (typeof link.target !== "object") link.target = $245e0bcc13363ea7$var$find(nodeById, link.target);
            count[link.source.index] = (count[link.source.index] || 0) + 1;
            count[link.target.index] = (count[link.target.index] || 0) + 1;
        }
        for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
        strengths = new Array(m), initializeStrength();
        distances = new Array(m), initializeDistance();
    }
    function initializeStrength() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
    }
    function initializeDistance() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.links = function(_) {
        return arguments.length ? (links = _, initialize(), force) : links;
    };
    force.id = function(_) {
        return arguments.length ? (id = _, force) : id;
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(+_), initializeStrength(), force) : strength;
    };
    force.distance = function(_) {
        return arguments.length ? (distance = typeof _ === "function" ? _ : (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(+_), initializeDistance(), force) : distance;
    };
    return force;
}







// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $f551b0ba8c20c2f9$var$a = 1664525;
const $f551b0ba8c20c2f9$var$c = 1013904223;
const $f551b0ba8c20c2f9$var$m = 4294967296; // 2^32
function $f551b0ba8c20c2f9$export$2e2bcd8739ae039() {
    let s = 1;
    return ()=>(s = ($f551b0ba8c20c2f9$var$a * s + $f551b0ba8c20c2f9$var$c) % $f551b0ba8c20c2f9$var$m) / $f551b0ba8c20c2f9$var$m;
}


function $a6a959f0d8ac28e6$export$d141bba7fdc215a3(d) {
    return d.x;
}
function $a6a959f0d8ac28e6$export$4a5767248b18ef41(d) {
    return d.y;
}
var $a6a959f0d8ac28e6$var$initialRadius = 10, $a6a959f0d8ac28e6$var$initialAngle = Math.PI * (3 - Math.sqrt(5));
function $a6a959f0d8ac28e6$export$2e2bcd8739ae039(nodes) {
    var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = (0, $30ea27ad4ddf4734$export$9dc4ecf953986f04)(step), event = (0, $cfaa4969c311d138$export$2e2bcd8739ae039)("tick", "end"), random = (0, $f551b0ba8c20c2f9$export$2e2bcd8739ae039)();
    if (nodes == null) nodes = [];
    function step() {
        tick();
        event.call("tick", simulation);
        if (alpha < alphaMin) {
            stepper.stop();
            event.call("end", simulation);
        }
    }
    function tick(iterations) {
        var i, n = nodes.length, node;
        if (iterations === undefined) iterations = 1;
        for(var k = 0; k < iterations; ++k){
            alpha += (alphaTarget - alpha) * alphaDecay;
            forces.forEach(function(force) {
                force(alpha);
            });
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (node.fx == null) node.x += node.vx *= velocityDecay;
                else node.x = node.fx, node.vx = 0;
                if (node.fy == null) node.y += node.vy *= velocityDecay;
                else node.y = node.fy, node.vy = 0;
            }
        }
        return simulation;
    }
    function initializeNodes() {
        for(var i = 0, n = nodes.length, node; i < n; ++i){
            node = nodes[i], node.index = i;
            if (node.fx != null) node.x = node.fx;
            if (node.fy != null) node.y = node.fy;
            if (isNaN(node.x) || isNaN(node.y)) {
                var radius = $a6a959f0d8ac28e6$var$initialRadius * Math.sqrt(0.5 + i), angle = i * $a6a959f0d8ac28e6$var$initialAngle;
                node.x = radius * Math.cos(angle);
                node.y = radius * Math.sin(angle);
            }
            if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
        }
    }
    function initializeForce(force) {
        if (force.initialize) force.initialize(nodes, random);
        return force;
    }
    initializeNodes();
    return simulation = {
        tick: tick,
        restart: function() {
            return stepper.restart(step), simulation;
        },
        stop: function() {
            return stepper.stop(), simulation;
        },
        nodes: function(_) {
            return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
        },
        alpha: function(_) {
            return arguments.length ? (alpha = +_, simulation) : alpha;
        },
        alphaMin: function(_) {
            return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
        },
        alphaDecay: function(_) {
            return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
        },
        alphaTarget: function(_) {
            return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
        },
        velocityDecay: function(_) {
            return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
        },
        randomSource: function(_) {
            return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
        },
        force: function(name, _) {
            return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
        },
        find: function(x, y, radius) {
            var i = 0, n = nodes.length, dx, dy, d2, node, closest;
            if (radius == null) radius = Infinity;
            else radius *= radius;
            for(i = 0; i < n; ++i){
                node = nodes[i];
                dx = x - node.x;
                dy = y - node.y;
                d2 = dx * dx + dy * dy;
                if (d2 < radius) closest = node, radius = d2;
            }
            return closest;
        },
        on: function(name, _) {
            return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
        }
    };
}


function $7bedc69c36ea6e96$export$2e2bcd8739ae039() {
    var nodes, node, random, alpha, strength = (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
    function force(_) {
        var i, n = nodes.length, tree = (0, $38d27fd39e705624$export$2e2bcd8739ae039)(nodes, (0, $a6a959f0d8ac28e6$export$d141bba7fdc215a3), (0, $a6a959f0d8ac28e6$export$4a5767248b18ef41)).visitAfter(accumulate);
        for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        strengths = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
    }
    function accumulate(quad) {
        var strength = 0, q, c, weight = 0, x, y, i;
        // For internal nodes, accumulate forces from child quadrants.
        if (quad.length) {
            for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
            quad.x = x / weight;
            quad.y = y / weight;
        } else {
            q = quad;
            q.x = q.data.x;
            q.y = q.data.y;
            do strength += strengths[q.data.index];
            while (q = q.next);
        }
        quad.value = strength;
    }
    function apply(quad, x1, _, x2) {
        if (!quad.value) return true;
        var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
        // Apply the Barnes-Hut approximation if possible.
        // Limit forces for very close nodes; randomize direction if coincident.
        if (w * w / theta2 < l) {
            if (l < distanceMax2) {
                if (x === 0) x = (0, $93c2072d0add173c$export$2e2bcd8739ae039)(random), l += x * x;
                if (y === 0) y = (0, $93c2072d0add173c$export$2e2bcd8739ae039)(random), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                node.vx += x * quad.value * alpha / l;
                node.vy += y * quad.value * alpha / l;
            }
            return true;
        } else if (quad.length || l >= distanceMax2) return;
        // Limit forces for very close nodes; randomize direction if coincident.
        if (quad.data !== node || quad.next) {
            if (x === 0) x = (0, $93c2072d0add173c$export$2e2bcd8739ae039)(random), l += x * x;
            if (y === 0) y = (0, $93c2072d0add173c$export$2e2bcd8739ae039)(random), l += y * y;
            if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        }
        do if (quad.data !== node) {
            w = strengths[quad.data.index] * alpha / l;
            node.vx += x * w;
            node.vy += y * w;
        }
        while (quad = quad.next);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.distanceMin = function(_) {
        return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
    };
    force.distanceMax = function(_) {
        return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
    };
    force.theta = function(_) {
        return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
    };
    return force;
}



function $4a1201a13491f130$export$2e2bcd8739ae039(radius, x, y) {
    var nodes, strength = (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(0.1), strengths, radiuses;
    if (typeof radius !== "function") radius = (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(+radius);
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force(alpha) {
        for(var i = 0, n = nodes.length; i < n; ++i){
            var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
            node.vx += dx * k;
            node.vy += dy * k;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        radiuses = new Array(n);
        for(i = 0; i < n; ++i){
            radiuses[i] = +radius(nodes[i], i, nodes);
            strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
        }
    }
    force.initialize = function(_) {
        nodes = _, initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(+_), initialize(), force) : radius;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    return force;
}




function $bdf363e8b2af0a2f$export$2e2bcd8739ae039(x) {
    var strength = (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(0.1), nodes, strengths, xz;
    if (typeof x !== "function") x = (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(x == null ? 0 : +x);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        xz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(+_), initialize(), force) : x;
    };
    return force;
}



function $7f80564a83d584ad$export$2e2bcd8739ae039(y) {
    var strength = (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(0.1), nodes, strengths, yz;
    if (typeof y !== "function") y = (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(y == null ? 0 : +y);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        yz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $e8248a8fd06f5a9e$export$2e2bcd8739ae039)(+_), initialize(), force) : y;
    };
    return force;
}




var $9a82798372102918$exports = {};

$parcel$export($9a82798372102918$exports, "formatDefaultLocale", () => $d8610aae6830e542$export$2e2bcd8739ae039);
$parcel$export($9a82798372102918$exports, "format", () => $d8610aae6830e542$export$d9468344d3651243);
$parcel$export($9a82798372102918$exports, "formatPrefix", () => $d8610aae6830e542$export$8d85692a469dde6f);
$parcel$export($9a82798372102918$exports, "formatLocale", () => $ef800a87de473a1e$export$2e2bcd8739ae039);
$parcel$export($9a82798372102918$exports, "formatSpecifier", () => $4d11e40433d14d49$export$2e2bcd8739ae039);
$parcel$export($9a82798372102918$exports, "FormatSpecifier", () => $4d11e40433d14d49$export$963aac351db36ed4);
$parcel$export($9a82798372102918$exports, "precisionFixed", () => $170ab4c42df99f46$export$2e2bcd8739ae039);
$parcel$export($9a82798372102918$exports, "precisionPrefix", () => $e9d5960850bc50d4$export$2e2bcd8739ae039);
$parcel$export($9a82798372102918$exports, "precisionRound", () => $e8f418ea446b2e3e$export$2e2bcd8739ae039);
function $a1312397731f67a5$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $a1312397731f67a5$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $b9f45b5b9c9b2a65$export$2e2bcd8739ae039(x) {
    return x = (0, $a1312397731f67a5$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $78be9309e3d65ee3$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $14a997ea377d9789$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $4d11e40433d14d49$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $4d11e40433d14d49$export$2e2bcd8739ae039(specifier) {
    if (!(match = $4d11e40433d14d49$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $4d11e40433d14d49$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$4d11e40433d14d49$export$2e2bcd8739ae039.prototype = $4d11e40433d14d49$export$963aac351db36ed4.prototype; // instanceof
function $4d11e40433d14d49$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$4d11e40433d14d49$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $b6a3ea0113208d3f$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $4ff0484ac89607a6$export$6863724d9a42263;
function $4ff0484ac89607a6$export$2e2bcd8739ae039(x, p) {
    var d = (0, $a1312397731f67a5$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($4ff0484ac89607a6$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $a1312397731f67a5$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $197148eb14061d0f$export$2e2bcd8739ae039(x, p) {
    var d = (0, $a1312397731f67a5$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $bc5f4285201294f7$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $a1312397731f67a5$export$2e2bcd8739ae039),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $197148eb14061d0f$export$2e2bcd8739ae039)(x * 100, p),
    "r": (0, $197148eb14061d0f$export$2e2bcd8739ae039),
    "s": (0, $4ff0484ac89607a6$export$2e2bcd8739ae039),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};



function $968d00e47281975c$export$2e2bcd8739ae039(x) {
    return x;
}


var $ef800a87de473a1e$var$map = Array.prototype.map, $ef800a87de473a1e$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $ef800a87de473a1e$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $968d00e47281975c$export$2e2bcd8739ae039) : (0, $78be9309e3d65ee3$export$2e2bcd8739ae039)($ef800a87de473a1e$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $968d00e47281975c$export$2e2bcd8739ae039) : (0, $14a997ea377d9789$export$2e2bcd8739ae039)($ef800a87de473a1e$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $4d11e40433d14d49$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $bc5f4285201294f7$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $bc5f4285201294f7$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $b6a3ea0113208d3f$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $ef800a87de473a1e$var$prefixes[8 + (0, $4ff0484ac89607a6$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $4d11e40433d14d49$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $b9f45b5b9c9b2a65$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $ef800a87de473a1e$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $d8610aae6830e542$var$locale;
var $d8610aae6830e542$export$d9468344d3651243;
var $d8610aae6830e542$export$8d85692a469dde6f;
$d8610aae6830e542$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $d8610aae6830e542$export$2e2bcd8739ae039(definition) {
    $d8610aae6830e542$var$locale = (0, $ef800a87de473a1e$export$2e2bcd8739ae039)(definition);
    $d8610aae6830e542$export$d9468344d3651243 = $d8610aae6830e542$var$locale.format;
    $d8610aae6830e542$export$8d85692a469dde6f = $d8610aae6830e542$var$locale.formatPrefix;
    return $d8610aae6830e542$var$locale;
}





function $170ab4c42df99f46$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $b9f45b5b9c9b2a65$export$2e2bcd8739ae039)(Math.abs(step)));
}



function $e9d5960850bc50d4$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $b9f45b5b9c9b2a65$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $b9f45b5b9c9b2a65$export$2e2bcd8739ae039)(Math.abs(step)));
}



function $e8f418ea446b2e3e$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $b9f45b5b9c9b2a65$export$2e2bcd8739ae039)(max) - (0, $b9f45b5b9c9b2a65$export$2e2bcd8739ae039)(step)) + 1;
}




var $9817ff4df005c27a$exports = {};

$parcel$export($9817ff4df005c27a$exports, "geoArea", () => $df6f79e3b27e6a07$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoBounds", () => $fabc5a9c8592d996$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoCentroid", () => $d1f46817fe1e19c8$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoCircle", () => $5eca00066e433a13$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoClipAntimeridian", () => $978b3e0d666d25f4$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoClipCircle", () => $a5a5213728324883$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoClipExtent", () => $9115c55214ca8df2$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoClipRectangle", () => $7ce1c7a535e2b6a2$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoContains", () => $1cbc8a8b6dfbdc99$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoDistance", () => $2e0b131eeef62d40$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoGraticule", () => $b0e557498ec3feb6$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoGraticule10", () => $b0e557498ec3feb6$export$b8db4e9403a5b6f1);
$parcel$export($9817ff4df005c27a$exports, "geoInterpolate", () => $3b321785a0548de2$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoLength", () => $19c36ec7a1ae23fd$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoPath", () => $1b3cf1508d129a92$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoAlbers", () => $24fef71d2ff65239$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoAlbersUsa", () => $3f07d9f593fd88bd$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoAzimuthalEqualArea", () => $9591be1912a4a1f3$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoAzimuthalEqualAreaRaw", () => $9591be1912a4a1f3$export$5e11f94fc4a8d2c6);
$parcel$export($9817ff4df005c27a$exports, "geoAzimuthalEquidistant", () => $5fd605e4e4ed8d25$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoAzimuthalEquidistantRaw", () => $5fd605e4e4ed8d25$export$b94a4d6aa3dd25c);
$parcel$export($9817ff4df005c27a$exports, "geoConicConformal", () => $bd0e15f8d76790a5$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoConicConformalRaw", () => $bd0e15f8d76790a5$export$2b1bc913962ed170);
$parcel$export($9817ff4df005c27a$exports, "geoConicEqualArea", () => $7b570b59d8990f0e$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoConicEqualAreaRaw", () => $7b570b59d8990f0e$export$75409dad1c406288);
$parcel$export($9817ff4df005c27a$exports, "geoConicEquidistant", () => $15f979c3979c9d71$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoConicEquidistantRaw", () => $15f979c3979c9d71$export$24f604fe80e5f192);
$parcel$export($9817ff4df005c27a$exports, "geoEqualEarth", () => $cd3a6f7fbd655c4d$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoEqualEarthRaw", () => $cd3a6f7fbd655c4d$export$a320734067e7a731);
$parcel$export($9817ff4df005c27a$exports, "geoEquirectangular", () => $8d7adeaddf07303d$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoEquirectangularRaw", () => $8d7adeaddf07303d$export$f5fee52180f2f058);
$parcel$export($9817ff4df005c27a$exports, "geoGnomonic", () => $71b03ee498119038$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoGnomonicRaw", () => $71b03ee498119038$export$dc8c6ddfc8b22c85);
$parcel$export($9817ff4df005c27a$exports, "geoIdentity", () => $e205fe6c7cb8019c$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoProjection", () => $14becbff16fda383$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoProjectionMutator", () => $14becbff16fda383$export$155d5a6fa6fddeba);
$parcel$export($9817ff4df005c27a$exports, "geoMercator", () => $2368fe22dc039c7f$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoMercatorRaw", () => $2368fe22dc039c7f$export$94ff8a57e9b91cc3);
$parcel$export($9817ff4df005c27a$exports, "geoNaturalEarth1", () => $07284b0851de8932$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoNaturalEarth1Raw", () => $07284b0851de8932$export$acb6def22fe878e6);
$parcel$export($9817ff4df005c27a$exports, "geoOrthographic", () => $fba3b3394aa72bf2$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoOrthographicRaw", () => $fba3b3394aa72bf2$export$1cd9c2eb846182a);
$parcel$export($9817ff4df005c27a$exports, "geoStereographic", () => $371bd064f4de910a$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoStereographicRaw", () => $371bd064f4de910a$export$f9ccbb0dcb3dcd2b);
$parcel$export($9817ff4df005c27a$exports, "geoTransverseMercator", () => $cac52a2ef3cd5ffd$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoTransverseMercatorRaw", () => $cac52a2ef3cd5ffd$export$e84942adec6de533);
$parcel$export($9817ff4df005c27a$exports, "geoRotation", () => $1bf6c214ce0c31b0$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoStream", () => $e2f4477abc5f18d1$export$2e2bcd8739ae039);
$parcel$export($9817ff4df005c27a$exports, "geoTransform", () => $63e3e91a377016cd$export$2e2bcd8739ae039);

var $961dd5ad4f13a8be$export$6c421550c66a327d = 1e-6;
var $961dd5ad4f13a8be$export$92c06fba281fe81b = 1e-12;
var $961dd5ad4f13a8be$export$18c7bea995a110f = Math.PI;
var $961dd5ad4f13a8be$export$e51408a300e8929a = $961dd5ad4f13a8be$export$18c7bea995a110f / 2;
var $961dd5ad4f13a8be$export$c39a5cba78ea0fc2 = $961dd5ad4f13a8be$export$18c7bea995a110f / 4;
var $961dd5ad4f13a8be$export$a4b4b4d4d776fe92 = $961dd5ad4f13a8be$export$18c7bea995a110f * 2;
var $961dd5ad4f13a8be$export$41fc368e1a942b97 = 180 / $961dd5ad4f13a8be$export$18c7bea995a110f;
var $961dd5ad4f13a8be$export$8449e153fbd325fc = $961dd5ad4f13a8be$export$18c7bea995a110f / 180;
var $961dd5ad4f13a8be$export$2335f513bbd82c6d = Math.abs;
var $961dd5ad4f13a8be$export$628dc4eed22b0fbd = Math.atan;
var $961dd5ad4f13a8be$export$b8b770ee6a0d9760 = Math.atan2;
var $961dd5ad4f13a8be$export$50d414a77b60d802 = Math.cos;
var $961dd5ad4f13a8be$export$803ce6b71a0a94b2 = Math.ceil;
var $961dd5ad4f13a8be$export$b310ec824aaee37f = Math.exp;
var $961dd5ad4f13a8be$export$a3fe094919f356fd = Math.floor;
var $961dd5ad4f13a8be$export$f95c7888b62f8e9a = Math.hypot;
var $961dd5ad4f13a8be$export$bef1f36f5486a6a3 = Math.log;
var $961dd5ad4f13a8be$export$9c297f60e22e3389 = Math.pow;
var $961dd5ad4f13a8be$export$5de3937cb4b592ed = Math.sin;
var $961dd5ad4f13a8be$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $961dd5ad4f13a8be$export$eba8049fb5020b81 = Math.sqrt;
var $961dd5ad4f13a8be$export$fcdd3b0b3246a325 = Math.tan;
function $961dd5ad4f13a8be$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $961dd5ad4f13a8be$export$18c7bea995a110f : Math.acos(x);
}
function $961dd5ad4f13a8be$export$41726bdb1fc63f(x) {
    return x > 1 ? $961dd5ad4f13a8be$export$e51408a300e8929a : x < -1 ? -$961dd5ad4f13a8be$export$e51408a300e8929a : Math.asin(x);
}
function $961dd5ad4f13a8be$export$e808712c2966e662(x) {
    return (x = $961dd5ad4f13a8be$export$5de3937cb4b592ed(x / 2)) * x;
}


function $3c146c97f8d7b5e7$export$2e2bcd8739ae039() {}


function $e2f4477abc5f18d1$var$streamGeometry(geometry, stream) {
    if (geometry && $e2f4477abc5f18d1$var$streamGeometryType.hasOwnProperty(geometry.type)) $e2f4477abc5f18d1$var$streamGeometryType[geometry.type](geometry, stream);
}
var $e2f4477abc5f18d1$var$streamObjectType = {
    Feature: function(object, stream) {
        $e2f4477abc5f18d1$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$e2f4477abc5f18d1$var$streamGeometry(features[i].geometry, stream);
    }
};
var $e2f4477abc5f18d1$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $e2f4477abc5f18d1$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$e2f4477abc5f18d1$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $e2f4477abc5f18d1$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$e2f4477abc5f18d1$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$e2f4477abc5f18d1$var$streamGeometry(geometries[i], stream);
    }
};
function $e2f4477abc5f18d1$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $e2f4477abc5f18d1$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$e2f4477abc5f18d1$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $e2f4477abc5f18d1$export$2e2bcd8739ae039(object, stream) {
    if (object && $e2f4477abc5f18d1$var$streamObjectType.hasOwnProperty(object.type)) $e2f4477abc5f18d1$var$streamObjectType[object.type](object, stream);
    else $e2f4477abc5f18d1$var$streamGeometry(object, stream);
}


var $df6f79e3b27e6a07$export$bf8f994332070c7f = new (0, $4e51c5d9e96ea8c7$export$bda7ba77fb86c375)();
// hello?
var $df6f79e3b27e6a07$var$areaSum = new (0, $4e51c5d9e96ea8c7$export$bda7ba77fb86c375)(), $df6f79e3b27e6a07$var$lambda00, $df6f79e3b27e6a07$var$phi00, $df6f79e3b27e6a07$var$lambda0, $df6f79e3b27e6a07$var$cosPhi0, $df6f79e3b27e6a07$var$sinPhi0;
var $df6f79e3b27e6a07$export$cb67cfa750ae69dc = {
    point: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039),
    lineStart: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039),
    lineEnd: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039),
    polygonStart: function() {
        $df6f79e3b27e6a07$export$bf8f994332070c7f = new (0, $4e51c5d9e96ea8c7$export$bda7ba77fb86c375)();
        $df6f79e3b27e6a07$export$cb67cfa750ae69dc.lineStart = $df6f79e3b27e6a07$var$areaRingStart;
        $df6f79e3b27e6a07$export$cb67cfa750ae69dc.lineEnd = $df6f79e3b27e6a07$var$areaRingEnd;
    },
    polygonEnd: function() {
        var areaRing = +$df6f79e3b27e6a07$export$bf8f994332070c7f;
        $df6f79e3b27e6a07$var$areaSum.add(areaRing < 0 ? (0, $961dd5ad4f13a8be$export$a4b4b4d4d776fe92) + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039);
    },
    sphere: function() {
        $df6f79e3b27e6a07$var$areaSum.add((0, $961dd5ad4f13a8be$export$a4b4b4d4d776fe92));
    }
};
function $df6f79e3b27e6a07$var$areaRingStart() {
    $df6f79e3b27e6a07$export$cb67cfa750ae69dc.point = $df6f79e3b27e6a07$var$areaPointFirst;
}
function $df6f79e3b27e6a07$var$areaRingEnd() {
    $df6f79e3b27e6a07$var$areaPoint($df6f79e3b27e6a07$var$lambda00, $df6f79e3b27e6a07$var$phi00);
}
function $df6f79e3b27e6a07$var$areaPointFirst(lambda, phi) {
    $df6f79e3b27e6a07$export$cb67cfa750ae69dc.point = $df6f79e3b27e6a07$var$areaPoint;
    $df6f79e3b27e6a07$var$lambda00 = lambda, $df6f79e3b27e6a07$var$phi00 = phi;
    lambda *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), phi *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc);
    $df6f79e3b27e6a07$var$lambda0 = lambda, $df6f79e3b27e6a07$var$cosPhi0 = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi = phi / 2 + (0, $961dd5ad4f13a8be$export$c39a5cba78ea0fc2)), $df6f79e3b27e6a07$var$sinPhi0 = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi);
}
function $df6f79e3b27e6a07$var$areaPoint(lambda, phi) {
    lambda *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), phi *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc);
    phi = phi / 2 + (0, $961dd5ad4f13a8be$export$c39a5cba78ea0fc2); // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    var dLambda = lambda - $df6f79e3b27e6a07$var$lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi), sinPhi = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi), k = $df6f79e3b27e6a07$var$sinPhi0 * sinPhi, u = $df6f79e3b27e6a07$var$cosPhi0 * cosPhi + k * (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(adLambda), v = k * sdLambda * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(adLambda);
    $df6f79e3b27e6a07$export$bf8f994332070c7f.add((0, $961dd5ad4f13a8be$export$b8b770ee6a0d9760)(v, u));
    // Advance the previous points.
    $df6f79e3b27e6a07$var$lambda0 = lambda, $df6f79e3b27e6a07$var$cosPhi0 = cosPhi, $df6f79e3b27e6a07$var$sinPhi0 = sinPhi;
}
function $df6f79e3b27e6a07$export$2e2bcd8739ae039(object) {
    $df6f79e3b27e6a07$var$areaSum = new (0, $4e51c5d9e96ea8c7$export$bda7ba77fb86c375)();
    (0, $e2f4477abc5f18d1$export$2e2bcd8739ae039)(object, $df6f79e3b27e6a07$export$cb67cfa750ae69dc);
    return $df6f79e3b27e6a07$var$areaSum * 2;
}





function $e0b7fba90feb13d3$export$12f9ad44fe773943(cartesian) {
    return [
        (0, $961dd5ad4f13a8be$export$b8b770ee6a0d9760)(cartesian[1], cartesian[0]),
        (0, $961dd5ad4f13a8be$export$41726bdb1fc63f)(cartesian[2])
    ];
}
function $e0b7fba90feb13d3$export$6e6697ef026a96(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi);
    return [
        cosPhi * (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(lambda),
        cosPhi * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(lambda),
        (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi)
    ];
}
function $e0b7fba90feb13d3$export$2ef80f51436a9de9(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $e0b7fba90feb13d3$export$4763f5351b14293f(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $e0b7fba90feb13d3$export$e62eba72fc898eae(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function $e0b7fba90feb13d3$export$52d0ee3fc868d452(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function $e0b7fba90feb13d3$export$6789498aec2cb34b(d) {
    var l = (0, $961dd5ad4f13a8be$export$eba8049fb5020b81)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}




var $fabc5a9c8592d996$var$lambda0, $fabc5a9c8592d996$var$phi0, $fabc5a9c8592d996$var$lambda1, $fabc5a9c8592d996$var$phi1, $fabc5a9c8592d996$var$lambda2, $fabc5a9c8592d996$var$lambda00, $fabc5a9c8592d996$var$phi00, $fabc5a9c8592d996$var$p0, $fabc5a9c8592d996$var$deltaSum, $fabc5a9c8592d996$var$ranges, $fabc5a9c8592d996$var$range;
var $fabc5a9c8592d996$var$boundsStream = {
    point: $fabc5a9c8592d996$var$boundsPoint,
    lineStart: $fabc5a9c8592d996$var$boundsLineStart,
    lineEnd: $fabc5a9c8592d996$var$boundsLineEnd,
    polygonStart: function() {
        $fabc5a9c8592d996$var$boundsStream.point = $fabc5a9c8592d996$var$boundsRingPoint;
        $fabc5a9c8592d996$var$boundsStream.lineStart = $fabc5a9c8592d996$var$boundsRingStart;
        $fabc5a9c8592d996$var$boundsStream.lineEnd = $fabc5a9c8592d996$var$boundsRingEnd;
        $fabc5a9c8592d996$var$deltaSum = new (0, $4e51c5d9e96ea8c7$export$bda7ba77fb86c375)();
        (0, $df6f79e3b27e6a07$export$cb67cfa750ae69dc).polygonStart();
    },
    polygonEnd: function() {
        (0, $df6f79e3b27e6a07$export$cb67cfa750ae69dc).polygonEnd();
        $fabc5a9c8592d996$var$boundsStream.point = $fabc5a9c8592d996$var$boundsPoint;
        $fabc5a9c8592d996$var$boundsStream.lineStart = $fabc5a9c8592d996$var$boundsLineStart;
        $fabc5a9c8592d996$var$boundsStream.lineEnd = $fabc5a9c8592d996$var$boundsLineEnd;
        if ((0, $df6f79e3b27e6a07$export$bf8f994332070c7f) < 0) $fabc5a9c8592d996$var$lambda0 = -($fabc5a9c8592d996$var$lambda1 = 180), $fabc5a9c8592d996$var$phi0 = -($fabc5a9c8592d996$var$phi1 = 90);
        else if ($fabc5a9c8592d996$var$deltaSum > (0, $961dd5ad4f13a8be$export$6c421550c66a327d)) $fabc5a9c8592d996$var$phi1 = 90;
        else if ($fabc5a9c8592d996$var$deltaSum < -(0, $961dd5ad4f13a8be$export$6c421550c66a327d)) $fabc5a9c8592d996$var$phi0 = -90;
        $fabc5a9c8592d996$var$range[0] = $fabc5a9c8592d996$var$lambda0, $fabc5a9c8592d996$var$range[1] = $fabc5a9c8592d996$var$lambda1;
    },
    sphere: function() {
        $fabc5a9c8592d996$var$lambda0 = -($fabc5a9c8592d996$var$lambda1 = 180), $fabc5a9c8592d996$var$phi0 = -($fabc5a9c8592d996$var$phi1 = 90);
    }
};
function $fabc5a9c8592d996$var$boundsPoint(lambda, phi) {
    $fabc5a9c8592d996$var$ranges.push($fabc5a9c8592d996$var$range = [
        $fabc5a9c8592d996$var$lambda0 = lambda,
        $fabc5a9c8592d996$var$lambda1 = lambda
    ]);
    if (phi < $fabc5a9c8592d996$var$phi0) $fabc5a9c8592d996$var$phi0 = phi;
    if (phi > $fabc5a9c8592d996$var$phi1) $fabc5a9c8592d996$var$phi1 = phi;
}
function $fabc5a9c8592d996$var$linePoint(lambda, phi) {
    var p = (0, $e0b7fba90feb13d3$export$6e6697ef026a96)([
        lambda * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc),
        phi * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc)
    ]);
    if ($fabc5a9c8592d996$var$p0) {
        var normal = (0, $e0b7fba90feb13d3$export$4763f5351b14293f)($fabc5a9c8592d996$var$p0, p), equatorial = [
            normal[1],
            -normal[0],
            0
        ], inflection = (0, $e0b7fba90feb13d3$export$4763f5351b14293f)(equatorial, normal);
        (0, $e0b7fba90feb13d3$export$6789498aec2cb34b)(inflection);
        inflection = (0, $e0b7fba90feb13d3$export$12f9ad44fe773943)(inflection);
        var delta = lambda - $fabc5a9c8592d996$var$lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97) * sign, phii, antimeridian = (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(delta) > 180;
        if (antimeridian ^ (sign * $fabc5a9c8592d996$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = inflection[1] * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97);
            if (phii > $fabc5a9c8592d996$var$phi1) $fabc5a9c8592d996$var$phi1 = phii;
        } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * $fabc5a9c8592d996$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = -inflection[1] * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97);
            if (phii < $fabc5a9c8592d996$var$phi0) $fabc5a9c8592d996$var$phi0 = phii;
        } else {
            if (phi < $fabc5a9c8592d996$var$phi0) $fabc5a9c8592d996$var$phi0 = phi;
            if (phi > $fabc5a9c8592d996$var$phi1) $fabc5a9c8592d996$var$phi1 = phi;
        }
        if (antimeridian) {
            if (lambda < $fabc5a9c8592d996$var$lambda2) {
                if ($fabc5a9c8592d996$var$angle($fabc5a9c8592d996$var$lambda0, lambda) > $fabc5a9c8592d996$var$angle($fabc5a9c8592d996$var$lambda0, $fabc5a9c8592d996$var$lambda1)) $fabc5a9c8592d996$var$lambda1 = lambda;
            } else if ($fabc5a9c8592d996$var$angle(lambda, $fabc5a9c8592d996$var$lambda1) > $fabc5a9c8592d996$var$angle($fabc5a9c8592d996$var$lambda0, $fabc5a9c8592d996$var$lambda1)) $fabc5a9c8592d996$var$lambda0 = lambda;
        } else if ($fabc5a9c8592d996$var$lambda1 >= $fabc5a9c8592d996$var$lambda0) {
            if (lambda < $fabc5a9c8592d996$var$lambda0) $fabc5a9c8592d996$var$lambda0 = lambda;
            if (lambda > $fabc5a9c8592d996$var$lambda1) $fabc5a9c8592d996$var$lambda1 = lambda;
        } else {
            if (lambda > $fabc5a9c8592d996$var$lambda2) {
                if ($fabc5a9c8592d996$var$angle($fabc5a9c8592d996$var$lambda0, lambda) > $fabc5a9c8592d996$var$angle($fabc5a9c8592d996$var$lambda0, $fabc5a9c8592d996$var$lambda1)) $fabc5a9c8592d996$var$lambda1 = lambda;
            } else if ($fabc5a9c8592d996$var$angle(lambda, $fabc5a9c8592d996$var$lambda1) > $fabc5a9c8592d996$var$angle($fabc5a9c8592d996$var$lambda0, $fabc5a9c8592d996$var$lambda1)) $fabc5a9c8592d996$var$lambda0 = lambda;
        }
    } else $fabc5a9c8592d996$var$ranges.push($fabc5a9c8592d996$var$range = [
        $fabc5a9c8592d996$var$lambda0 = lambda,
        $fabc5a9c8592d996$var$lambda1 = lambda
    ]);
    if (phi < $fabc5a9c8592d996$var$phi0) $fabc5a9c8592d996$var$phi0 = phi;
    if (phi > $fabc5a9c8592d996$var$phi1) $fabc5a9c8592d996$var$phi1 = phi;
    $fabc5a9c8592d996$var$p0 = p, $fabc5a9c8592d996$var$lambda2 = lambda;
}
function $fabc5a9c8592d996$var$boundsLineStart() {
    $fabc5a9c8592d996$var$boundsStream.point = $fabc5a9c8592d996$var$linePoint;
}
function $fabc5a9c8592d996$var$boundsLineEnd() {
    $fabc5a9c8592d996$var$range[0] = $fabc5a9c8592d996$var$lambda0, $fabc5a9c8592d996$var$range[1] = $fabc5a9c8592d996$var$lambda1;
    $fabc5a9c8592d996$var$boundsStream.point = $fabc5a9c8592d996$var$boundsPoint;
    $fabc5a9c8592d996$var$p0 = null;
}
function $fabc5a9c8592d996$var$boundsRingPoint(lambda, phi) {
    if ($fabc5a9c8592d996$var$p0) {
        var delta = lambda - $fabc5a9c8592d996$var$lambda2;
        $fabc5a9c8592d996$var$deltaSum.add((0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else $fabc5a9c8592d996$var$lambda00 = lambda, $fabc5a9c8592d996$var$phi00 = phi;
    (0, $df6f79e3b27e6a07$export$cb67cfa750ae69dc).point(lambda, phi);
    $fabc5a9c8592d996$var$linePoint(lambda, phi);
}
function $fabc5a9c8592d996$var$boundsRingStart() {
    (0, $df6f79e3b27e6a07$export$cb67cfa750ae69dc).lineStart();
}
function $fabc5a9c8592d996$var$boundsRingEnd() {
    $fabc5a9c8592d996$var$boundsRingPoint($fabc5a9c8592d996$var$lambda00, $fabc5a9c8592d996$var$phi00);
    (0, $df6f79e3b27e6a07$export$cb67cfa750ae69dc).lineEnd();
    if ((0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)($fabc5a9c8592d996$var$deltaSum) > (0, $961dd5ad4f13a8be$export$6c421550c66a327d)) $fabc5a9c8592d996$var$lambda0 = -($fabc5a9c8592d996$var$lambda1 = 180);
    $fabc5a9c8592d996$var$range[0] = $fabc5a9c8592d996$var$lambda0, $fabc5a9c8592d996$var$range[1] = $fabc5a9c8592d996$var$lambda1;
    $fabc5a9c8592d996$var$p0 = null;
}
// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function $fabc5a9c8592d996$var$angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function $fabc5a9c8592d996$var$rangeCompare(a, b) {
    return a[0] - b[0];
}
function $fabc5a9c8592d996$var$rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}
function $fabc5a9c8592d996$export$2e2bcd8739ae039(feature) {
    var i, n, a, b, merged, deltaMax, delta;
    $fabc5a9c8592d996$var$phi1 = $fabc5a9c8592d996$var$lambda1 = -($fabc5a9c8592d996$var$lambda0 = $fabc5a9c8592d996$var$phi0 = Infinity);
    $fabc5a9c8592d996$var$ranges = [];
    (0, $e2f4477abc5f18d1$export$2e2bcd8739ae039)(feature, $fabc5a9c8592d996$var$boundsStream);
    // First, sort ranges by their minimum longitudes.
    if (n = $fabc5a9c8592d996$var$ranges.length) {
        $fabc5a9c8592d996$var$ranges.sort($fabc5a9c8592d996$var$rangeCompare);
        // Then, merge any ranges that overlap.
        for(i = 1, a = $fabc5a9c8592d996$var$ranges[0], merged = [
            a
        ]; i < n; ++i){
            b = $fabc5a9c8592d996$var$ranges[i];
            if ($fabc5a9c8592d996$var$rangeContains(a, b[0]) || $fabc5a9c8592d996$var$rangeContains(a, b[1])) {
                if ($fabc5a9c8592d996$var$angle(a[0], b[1]) > $fabc5a9c8592d996$var$angle(a[0], a[1])) a[1] = b[1];
                if ($fabc5a9c8592d996$var$angle(b[0], a[1]) > $fabc5a9c8592d996$var$angle(a[0], a[1])) a[0] = b[0];
            } else merged.push(a = b);
        }
        // Finally, find the largest gap between the merged ranges.
        // The final bounding box will be the inverse of this gap.
        for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
            b = merged[i];
            if ((delta = $fabc5a9c8592d996$var$angle(a[1], b[0])) > deltaMax) deltaMax = delta, $fabc5a9c8592d996$var$lambda0 = b[0], $fabc5a9c8592d996$var$lambda1 = a[1];
        }
    }
    $fabc5a9c8592d996$var$ranges = $fabc5a9c8592d996$var$range = null;
    return $fabc5a9c8592d996$var$lambda0 === Infinity || $fabc5a9c8592d996$var$phi0 === Infinity ? [
        [
            NaN,
            NaN
        ],
        [
            NaN,
            NaN
        ]
    ] : [
        [
            $fabc5a9c8592d996$var$lambda0,
            $fabc5a9c8592d996$var$phi0
        ],
        [
            $fabc5a9c8592d996$var$lambda1,
            $fabc5a9c8592d996$var$phi1
        ]
    ];
}






var $d1f46817fe1e19c8$var$W0, $d1f46817fe1e19c8$var$W1, $d1f46817fe1e19c8$var$X0, $d1f46817fe1e19c8$var$Y0, $d1f46817fe1e19c8$var$Z0, $d1f46817fe1e19c8$var$X1, $d1f46817fe1e19c8$var$Y1, $d1f46817fe1e19c8$var$Z1, $d1f46817fe1e19c8$var$X2, $d1f46817fe1e19c8$var$Y2, $d1f46817fe1e19c8$var$Z2, $d1f46817fe1e19c8$var$lambda00, $d1f46817fe1e19c8$var$phi00, $d1f46817fe1e19c8$var$x0, $d1f46817fe1e19c8$var$y0, $d1f46817fe1e19c8$var$z0; // previous point
var $d1f46817fe1e19c8$var$centroidStream = {
    sphere: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039),
    point: $d1f46817fe1e19c8$var$centroidPoint,
    lineStart: $d1f46817fe1e19c8$var$centroidLineStart,
    lineEnd: $d1f46817fe1e19c8$var$centroidLineEnd,
    polygonStart: function() {
        $d1f46817fe1e19c8$var$centroidStream.lineStart = $d1f46817fe1e19c8$var$centroidRingStart;
        $d1f46817fe1e19c8$var$centroidStream.lineEnd = $d1f46817fe1e19c8$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $d1f46817fe1e19c8$var$centroidStream.lineStart = $d1f46817fe1e19c8$var$centroidLineStart;
        $d1f46817fe1e19c8$var$centroidStream.lineEnd = $d1f46817fe1e19c8$var$centroidLineEnd;
    }
};
// Arithmetic mean of Cartesian vectors.
function $d1f46817fe1e19c8$var$centroidPoint(lambda, phi) {
    lambda *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), phi *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc);
    var cosPhi = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi);
    $d1f46817fe1e19c8$var$centroidPointCartesian(cosPhi * (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(lambda), cosPhi * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(lambda), (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi));
}
function $d1f46817fe1e19c8$var$centroidPointCartesian(x, y, z) {
    ++$d1f46817fe1e19c8$var$W0;
    $d1f46817fe1e19c8$var$X0 += (x - $d1f46817fe1e19c8$var$X0) / $d1f46817fe1e19c8$var$W0;
    $d1f46817fe1e19c8$var$Y0 += (y - $d1f46817fe1e19c8$var$Y0) / $d1f46817fe1e19c8$var$W0;
    $d1f46817fe1e19c8$var$Z0 += (z - $d1f46817fe1e19c8$var$Z0) / $d1f46817fe1e19c8$var$W0;
}
function $d1f46817fe1e19c8$var$centroidLineStart() {
    $d1f46817fe1e19c8$var$centroidStream.point = $d1f46817fe1e19c8$var$centroidLinePointFirst;
}
function $d1f46817fe1e19c8$var$centroidLinePointFirst(lambda, phi) {
    lambda *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), phi *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc);
    var cosPhi = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi);
    $d1f46817fe1e19c8$var$x0 = cosPhi * (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(lambda);
    $d1f46817fe1e19c8$var$y0 = cosPhi * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(lambda);
    $d1f46817fe1e19c8$var$z0 = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi);
    $d1f46817fe1e19c8$var$centroidStream.point = $d1f46817fe1e19c8$var$centroidLinePoint;
    $d1f46817fe1e19c8$var$centroidPointCartesian($d1f46817fe1e19c8$var$x0, $d1f46817fe1e19c8$var$y0, $d1f46817fe1e19c8$var$z0);
}
function $d1f46817fe1e19c8$var$centroidLinePoint(lambda, phi) {
    lambda *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), phi *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc);
    var cosPhi = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi), x = cosPhi * (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(lambda), y = cosPhi * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(lambda), z = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi), w = (0, $961dd5ad4f13a8be$export$b8b770ee6a0d9760)((0, $961dd5ad4f13a8be$export$eba8049fb5020b81)((w = $d1f46817fe1e19c8$var$y0 * z - $d1f46817fe1e19c8$var$z0 * y) * w + (w = $d1f46817fe1e19c8$var$z0 * x - $d1f46817fe1e19c8$var$x0 * z) * w + (w = $d1f46817fe1e19c8$var$x0 * y - $d1f46817fe1e19c8$var$y0 * x) * w), $d1f46817fe1e19c8$var$x0 * x + $d1f46817fe1e19c8$var$y0 * y + $d1f46817fe1e19c8$var$z0 * z);
    $d1f46817fe1e19c8$var$W1 += w;
    $d1f46817fe1e19c8$var$X1 += w * ($d1f46817fe1e19c8$var$x0 + ($d1f46817fe1e19c8$var$x0 = x));
    $d1f46817fe1e19c8$var$Y1 += w * ($d1f46817fe1e19c8$var$y0 + ($d1f46817fe1e19c8$var$y0 = y));
    $d1f46817fe1e19c8$var$Z1 += w * ($d1f46817fe1e19c8$var$z0 + ($d1f46817fe1e19c8$var$z0 = z));
    $d1f46817fe1e19c8$var$centroidPointCartesian($d1f46817fe1e19c8$var$x0, $d1f46817fe1e19c8$var$y0, $d1f46817fe1e19c8$var$z0);
}
function $d1f46817fe1e19c8$var$centroidLineEnd() {
    $d1f46817fe1e19c8$var$centroidStream.point = $d1f46817fe1e19c8$var$centroidPoint;
}
// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function $d1f46817fe1e19c8$var$centroidRingStart() {
    $d1f46817fe1e19c8$var$centroidStream.point = $d1f46817fe1e19c8$var$centroidRingPointFirst;
}
function $d1f46817fe1e19c8$var$centroidRingEnd() {
    $d1f46817fe1e19c8$var$centroidRingPoint($d1f46817fe1e19c8$var$lambda00, $d1f46817fe1e19c8$var$phi00);
    $d1f46817fe1e19c8$var$centroidStream.point = $d1f46817fe1e19c8$var$centroidPoint;
}
function $d1f46817fe1e19c8$var$centroidRingPointFirst(lambda, phi) {
    $d1f46817fe1e19c8$var$lambda00 = lambda, $d1f46817fe1e19c8$var$phi00 = phi;
    lambda *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), phi *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc);
    $d1f46817fe1e19c8$var$centroidStream.point = $d1f46817fe1e19c8$var$centroidRingPoint;
    var cosPhi = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi);
    $d1f46817fe1e19c8$var$x0 = cosPhi * (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(lambda);
    $d1f46817fe1e19c8$var$y0 = cosPhi * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(lambda);
    $d1f46817fe1e19c8$var$z0 = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi);
    $d1f46817fe1e19c8$var$centroidPointCartesian($d1f46817fe1e19c8$var$x0, $d1f46817fe1e19c8$var$y0, $d1f46817fe1e19c8$var$z0);
}
function $d1f46817fe1e19c8$var$centroidRingPoint(lambda, phi) {
    lambda *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), phi *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc);
    var cosPhi = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi), x = cosPhi * (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(lambda), y = cosPhi * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(lambda), z = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi), cx = $d1f46817fe1e19c8$var$y0 * z - $d1f46817fe1e19c8$var$z0 * y, cy = $d1f46817fe1e19c8$var$z0 * x - $d1f46817fe1e19c8$var$x0 * z, cz = $d1f46817fe1e19c8$var$x0 * y - $d1f46817fe1e19c8$var$y0 * x, m = (0, $961dd5ad4f13a8be$export$f95c7888b62f8e9a)(cx, cy, cz), w = (0, $961dd5ad4f13a8be$export$41726bdb1fc63f)(m), v = m && -w / m; // area weight multiplier
    $d1f46817fe1e19c8$var$X2.add(v * cx);
    $d1f46817fe1e19c8$var$Y2.add(v * cy);
    $d1f46817fe1e19c8$var$Z2.add(v * cz);
    $d1f46817fe1e19c8$var$W1 += w;
    $d1f46817fe1e19c8$var$X1 += w * ($d1f46817fe1e19c8$var$x0 + ($d1f46817fe1e19c8$var$x0 = x));
    $d1f46817fe1e19c8$var$Y1 += w * ($d1f46817fe1e19c8$var$y0 + ($d1f46817fe1e19c8$var$y0 = y));
    $d1f46817fe1e19c8$var$Z1 += w * ($d1f46817fe1e19c8$var$z0 + ($d1f46817fe1e19c8$var$z0 = z));
    $d1f46817fe1e19c8$var$centroidPointCartesian($d1f46817fe1e19c8$var$x0, $d1f46817fe1e19c8$var$y0, $d1f46817fe1e19c8$var$z0);
}
function $d1f46817fe1e19c8$export$2e2bcd8739ae039(object) {
    $d1f46817fe1e19c8$var$W0 = $d1f46817fe1e19c8$var$W1 = $d1f46817fe1e19c8$var$X0 = $d1f46817fe1e19c8$var$Y0 = $d1f46817fe1e19c8$var$Z0 = $d1f46817fe1e19c8$var$X1 = $d1f46817fe1e19c8$var$Y1 = $d1f46817fe1e19c8$var$Z1 = 0;
    $d1f46817fe1e19c8$var$X2 = new (0, $4e51c5d9e96ea8c7$export$bda7ba77fb86c375)();
    $d1f46817fe1e19c8$var$Y2 = new (0, $4e51c5d9e96ea8c7$export$bda7ba77fb86c375)();
    $d1f46817fe1e19c8$var$Z2 = new (0, $4e51c5d9e96ea8c7$export$bda7ba77fb86c375)();
    (0, $e2f4477abc5f18d1$export$2e2bcd8739ae039)(object, $d1f46817fe1e19c8$var$centroidStream);
    var x = +$d1f46817fe1e19c8$var$X2, y = +$d1f46817fe1e19c8$var$Y2, z = +$d1f46817fe1e19c8$var$Z2, m = (0, $961dd5ad4f13a8be$export$f95c7888b62f8e9a)(x, y, z);
    // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
    if (m < (0, $961dd5ad4f13a8be$export$92c06fba281fe81b)) {
        x = $d1f46817fe1e19c8$var$X1, y = $d1f46817fe1e19c8$var$Y1, z = $d1f46817fe1e19c8$var$Z1;
        // If the feature has zero length, fall back to arithmetic mean of point vectors.
        if ($d1f46817fe1e19c8$var$W1 < (0, $961dd5ad4f13a8be$export$6c421550c66a327d)) x = $d1f46817fe1e19c8$var$X0, y = $d1f46817fe1e19c8$var$Y0, z = $d1f46817fe1e19c8$var$Z0;
        m = (0, $961dd5ad4f13a8be$export$f95c7888b62f8e9a)(x, y, z);
        // If the feature still has an undefined ccentroid, then return.
        if (m < (0, $961dd5ad4f13a8be$export$92c06fba281fe81b)) return [
            NaN,
            NaN
        ];
    }
    return [
        (0, $961dd5ad4f13a8be$export$b8b770ee6a0d9760)(y, x) * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97),
        (0, $961dd5ad4f13a8be$export$41726bdb1fc63f)(z / m) * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97)
    ];
}



function $daf7194c93de6bca$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}



function $f109361b05c0603f$export$2e2bcd8739ae039(a, b) {
    function compose(x, y) {
        return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
        return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
}



function $1bf6c214ce0c31b0$var$rotationIdentity(lambda, phi) {
    if ((0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(lambda) > (0, $961dd5ad4f13a8be$export$18c7bea995a110f)) lambda -= Math.round(lambda / (0, $961dd5ad4f13a8be$export$a4b4b4d4d776fe92)) * (0, $961dd5ad4f13a8be$export$a4b4b4d4d776fe92);
    return [
        lambda,
        phi
    ];
}
$1bf6c214ce0c31b0$var$rotationIdentity.invert = $1bf6c214ce0c31b0$var$rotationIdentity;
function $1bf6c214ce0c31b0$export$a2ba89726971a90f(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, $961dd5ad4f13a8be$export$a4b4b4d4d776fe92)) ? deltaPhi || deltaGamma ? (0, $f109361b05c0603f$export$2e2bcd8739ae039)($1bf6c214ce0c31b0$var$rotationLambda(deltaLambda), $1bf6c214ce0c31b0$var$rotationPhiGamma(deltaPhi, deltaGamma)) : $1bf6c214ce0c31b0$var$rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? $1bf6c214ce0c31b0$var$rotationPhiGamma(deltaPhi, deltaGamma) : $1bf6c214ce0c31b0$var$rotationIdentity;
}
function $1bf6c214ce0c31b0$var$forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        lambda += deltaLambda;
        if ((0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(lambda) > (0, $961dd5ad4f13a8be$export$18c7bea995a110f)) lambda -= Math.round(lambda / (0, $961dd5ad4f13a8be$export$a4b4b4d4d776fe92)) * (0, $961dd5ad4f13a8be$export$a4b4b4d4d776fe92);
        return [
            lambda,
            phi
        ];
    };
}
function $1bf6c214ce0c31b0$var$rotationLambda(deltaLambda) {
    var rotation = $1bf6c214ce0c31b0$var$forwardRotationLambda(deltaLambda);
    rotation.invert = $1bf6c214ce0c31b0$var$forwardRotationLambda(-deltaLambda);
    return rotation;
}
function $1bf6c214ce0c31b0$var$rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(deltaPhi), sinDeltaPhi = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(deltaPhi), cosDeltaGamma = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(deltaGamma), sinDeltaGamma = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi), x = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, $961dd5ad4f13a8be$export$b8b770ee6a0d9760)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, $961dd5ad4f13a8be$export$41726bdb1fc63f)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi), x = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, $961dd5ad4f13a8be$export$b8b770ee6a0d9760)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, $961dd5ad4f13a8be$export$41726bdb1fc63f)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}
function $1bf6c214ce0c31b0$export$2e2bcd8739ae039(rotate) {
    rotate = $1bf6c214ce0c31b0$export$a2ba89726971a90f(rotate[0] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), rotate[1] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), rotate.length > 2 ? rotate[2] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc) : 0);
    function forward(coordinates) {
        coordinates = rotate(coordinates[0] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), coordinates[1] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $961dd5ad4f13a8be$export$41fc368e1a942b97), coordinates[1] *= (0, $961dd5ad4f13a8be$export$41fc368e1a942b97), coordinates;
    }
    forward.invert = function(coordinates) {
        coordinates = rotate.invert(coordinates[0] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), coordinates[1] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $961dd5ad4f13a8be$export$41fc368e1a942b97), coordinates[1] *= (0, $961dd5ad4f13a8be$export$41fc368e1a942b97), coordinates;
    };
    return forward;
}


function $5eca00066e433a13$export$b5441eb324cd8d4e(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(radius), sinRadius = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, $961dd5ad4f13a8be$export$a4b4b4d4d776fe92);
        t1 = radius - step / 2;
    } else {
        t0 = $5eca00066e433a13$var$circleRadius(cosRadius, t0);
        t1 = $5eca00066e433a13$var$circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, $961dd5ad4f13a8be$export$a4b4b4d4d776fe92);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, $e0b7fba90feb13d3$export$12f9ad44fe773943)([
            cosRadius,
            -sinRadius * (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(t),
            -sinRadius * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function $5eca00066e433a13$var$circleRadius(cosRadius, point) {
    point = (0, $e0b7fba90feb13d3$export$6e6697ef026a96)(point), point[0] -= cosRadius;
    (0, $e0b7fba90feb13d3$export$6789498aec2cb34b)(point);
    var radius = (0, $961dd5ad4f13a8be$export$fd6306be3fde5b04)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, $961dd5ad4f13a8be$export$a4b4b4d4d776fe92) - (0, $961dd5ad4f13a8be$export$6c421550c66a327d)) % (0, $961dd5ad4f13a8be$export$a4b4b4d4d776fe92);
}
function $5eca00066e433a13$export$2e2bcd8739ae039() {
    var center = (0, $daf7194c93de6bca$export$2e2bcd8739ae039)([
        0,
        0
    ]), radius = (0, $daf7194c93de6bca$export$2e2bcd8739ae039)(90), precision = (0, $daf7194c93de6bca$export$2e2bcd8739ae039)(6), ring, rotate, stream = {
        point: point
    };
    function point(x, y) {
        ring.push(x = rotate(x, y));
        x[0] *= (0, $961dd5ad4f13a8be$export$41fc368e1a942b97), x[1] *= (0, $961dd5ad4f13a8be$export$41fc368e1a942b97);
    }
    function circle() {
        var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), p = precision.apply(this, arguments) * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc);
        ring = [];
        rotate = (0, $1bf6c214ce0c31b0$export$a2ba89726971a90f)(-c[0] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), -c[1] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), 0).invert;
        $5eca00066e433a13$export$b5441eb324cd8d4e(stream, r, p, 1);
        c = {
            type: "Polygon",
            coordinates: [
                ring
            ]
        };
        ring = rotate = null;
        return c;
    }
    circle.center = function(_) {
        return arguments.length ? (center = typeof _ === "function" ? _ : (0, $daf7194c93de6bca$export$2e2bcd8739ae039)([
            +_[0],
            +_[1]
        ]), circle) : center;
    };
    circle.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $daf7194c93de6bca$export$2e2bcd8739ae039)(+_), circle) : radius;
    };
    circle.precision = function(_) {
        return arguments.length ? (precision = typeof _ === "function" ? _ : (0, $daf7194c93de6bca$export$2e2bcd8739ae039)(+_), circle) : precision;
    };
    return circle;
}



function $62947761efd68a93$export$2e2bcd8739ae039() {
    var lines = [], line;
    return {
        point: function(x, y, m) {
            line.push([
                x,
                y,
                m
            ]);
        },
        lineStart: function() {
            lines.push(line = []);
        },
        lineEnd: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039),
        rejoin: function() {
            if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
        },
        result: function() {
            var result = lines;
            lines = [];
            line = null;
            return result;
        }
    };
}



function $bbd8e745b1f2f667$export$2e2bcd8739ae039(a, b) {
    return (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(a[0] - b[0]) < (0, $961dd5ad4f13a8be$export$6c421550c66a327d) && (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(a[1] - b[1]) < (0, $961dd5ad4f13a8be$export$6c421550c66a327d);
}



function $9f6022d841d5236c$var$Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function $9f6022d841d5236c$export$2e2bcd8739ae039(segments, compareIntersection, startInside, interpolate, stream) {
    var subject = [], clip = [], i, n;
    segments.forEach(function(segment) {
        if ((n = segment.length - 1) <= 0) return;
        var n, p0 = segment[0], p1 = segment[n], x;
        if ((0, $bbd8e745b1f2f667$export$2e2bcd8739ae039)(p0, p1)) {
            if (!p0[2] && !p1[2]) {
                stream.lineStart();
                for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                stream.lineEnd();
                return;
            }
            // handle degenerate cases by moving the point
            p1[0] += 2 * (0, $961dd5ad4f13a8be$export$6c421550c66a327d);
        }
        subject.push(x = new $9f6022d841d5236c$var$Intersection(p0, segment, null, true));
        clip.push(x.o = new $9f6022d841d5236c$var$Intersection(p0, null, x, false));
        subject.push(x = new $9f6022d841d5236c$var$Intersection(p1, segment, null, false));
        clip.push(x.o = new $9f6022d841d5236c$var$Intersection(p1, null, x, true));
    });
    if (!subject.length) return;
    clip.sort(compareIntersection);
    $9f6022d841d5236c$var$link(subject);
    $9f6022d841d5236c$var$link(clip);
    for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
    var start = subject[0], points, point;
    while(true){
        // Find first unvisited intersection.
        var current = start, isSubject = true;
        while(current.v)if ((current = current.n) === start) return;
        points = current.z;
        stream.lineStart();
        do {
            current.v = current.o.v = true;
            if (current.e) {
                if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                else interpolate(current.x, current.n.x, 1, stream);
                current = current.n;
            } else {
                if (isSubject) {
                    points = current.p.z;
                    for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                } else interpolate(current.x, current.p.x, -1, stream);
                current = current.p;
            }
            current = current.o;
            points = current.z;
            isSubject = !isSubject;
        }while (!current.v);
        stream.lineEnd();
    }
}
function $9f6022d841d5236c$var$link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}






function $18489d1b1ca8f0ca$var$longitude(point) {
    return (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(point[0]) <= (0, $961dd5ad4f13a8be$export$18c7bea995a110f) ? point[0] : (0, $961dd5ad4f13a8be$export$c5552dfdbc7cec71)(point[0]) * (((0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(point[0]) + (0, $961dd5ad4f13a8be$export$18c7bea995a110f)) % (0, $961dd5ad4f13a8be$export$a4b4b4d4d776fe92) - (0, $961dd5ad4f13a8be$export$18c7bea995a110f));
}
function $18489d1b1ca8f0ca$export$2e2bcd8739ae039(polygon, point) {
    var lambda = $18489d1b1ca8f0ca$var$longitude(point), phi = point[1], sinPhi = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi), normal = [
        (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(lambda),
        -(0, $961dd5ad4f13a8be$export$50d414a77b60d802)(lambda),
        0
    ], angle = 0, winding = 0;
    var sum = new (0, $4e51c5d9e96ea8c7$export$bda7ba77fb86c375)();
    if (sinPhi === 1) phi = (0, $961dd5ad4f13a8be$export$e51408a300e8929a) + (0, $961dd5ad4f13a8be$export$6c421550c66a327d);
    else if (sinPhi === -1) phi = -(0, $961dd5ad4f13a8be$export$e51408a300e8929a) - (0, $961dd5ad4f13a8be$export$6c421550c66a327d);
    for(var i = 0, n = polygon.length; i < n; ++i){
        if (!(m = (ring = polygon[i]).length)) continue;
        var ring, m, point0 = ring[m - 1], lambda0 = $18489d1b1ca8f0ca$var$longitude(point0), phi0 = point0[1] / 2 + (0, $961dd5ad4f13a8be$export$c39a5cba78ea0fc2), sinPhi0 = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi0), cosPhi0 = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi0);
        for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
            var point1 = ring[j], lambda1 = $18489d1b1ca8f0ca$var$longitude(point1), phi1 = point1[1] / 2 + (0, $961dd5ad4f13a8be$export$c39a5cba78ea0fc2), sinPhi1 = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi1), cosPhi1 = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, $961dd5ad4f13a8be$export$18c7bea995a110f), k = sinPhi0 * sinPhi1;
            sum.add((0, $961dd5ad4f13a8be$export$b8b770ee6a0d9760)(k * sign * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(absDelta), cosPhi0 * cosPhi1 + k * (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(absDelta)));
            angle += antimeridian ? delta + sign * (0, $961dd5ad4f13a8be$export$a4b4b4d4d776fe92) : delta;
            // Are the longitudes either side of the point’s meridian (lambda),
            // and are the latitudes smaller than the parallel (phi)?
            if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                var arc = (0, $e0b7fba90feb13d3$export$4763f5351b14293f)((0, $e0b7fba90feb13d3$export$6e6697ef026a96)(point0), (0, $e0b7fba90feb13d3$export$6e6697ef026a96)(point1));
                (0, $e0b7fba90feb13d3$export$6789498aec2cb34b)(arc);
                var intersection = (0, $e0b7fba90feb13d3$export$4763f5351b14293f)(normal, arc);
                (0, $e0b7fba90feb13d3$export$6789498aec2cb34b)(intersection);
                var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, $961dd5ad4f13a8be$export$41726bdb1fc63f)(intersection[2]);
                if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
            }
        }
    }
    // First, determine whether the South pole is inside or outside:
    //
    // It is inside if:
    // * the polygon winds around it in a clockwise direction.
    // * the polygon does not (cumulatively) wind around it, but has a negative
    //   (counter-clockwise) area.
    //
    // Second, count the (signed) number of times a segment crosses a lambda
    // from the point to the South pole.  If it is zero, then the point is the
    // same side as the South pole.
    return (angle < -(0, $961dd5ad4f13a8be$export$6c421550c66a327d) || angle < (0, $961dd5ad4f13a8be$export$6c421550c66a327d) && sum < -(0, $961dd5ad4f13a8be$export$92c06fba281fe81b)) ^ winding & 1;
}



function $4b8791d3c418c038$export$2e2bcd8739ae039(pointVisible, clipLine, interpolate, start) {
    return function(sink) {
        var line = clipLine(sink), ringBuffer = (0, $62947761efd68a93$export$2e2bcd8739ae039)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
        var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                clip.point = pointRing;
                clip.lineStart = ringStart;
                clip.lineEnd = ringEnd;
                segments = [];
                polygon = [];
            },
            polygonEnd: function() {
                clip.point = point;
                clip.lineStart = lineStart;
                clip.lineEnd = lineEnd;
                segments = (0, $6341023b666029a7$export$2e2bcd8739ae039)(segments);
                var startInside = (0, $18489d1b1ca8f0ca$export$2e2bcd8739ae039)(polygon, start);
                if (segments.length) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    (0, $9f6022d841d5236c$export$2e2bcd8739ae039)(segments, $4b8791d3c418c038$var$compareIntersection, startInside, interpolate, sink);
                } else if (startInside) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                }
                if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                segments = polygon = null;
            },
            sphere: function() {
                sink.polygonStart();
                sink.lineStart();
                interpolate(null, null, 1, sink);
                sink.lineEnd();
                sink.polygonEnd();
            }
        };
        function point(lambda, phi) {
            if (pointVisible(lambda, phi)) sink.point(lambda, phi);
        }
        function pointLine(lambda, phi) {
            line.point(lambda, phi);
        }
        function lineStart() {
            clip.point = pointLine;
            line.lineStart();
        }
        function lineEnd() {
            clip.point = point;
            line.lineEnd();
        }
        function pointRing(lambda, phi) {
            ring.push([
                lambda,
                phi
            ]);
            ringSink.point(lambda, phi);
        }
        function ringStart() {
            ringSink.lineStart();
            ring = [];
        }
        function ringEnd() {
            pointRing(ring[0][0], ring[0][1]);
            ringSink.lineEnd();
            var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
            ring.pop();
            polygon.push(ring);
            ring = null;
            if (!n) return;
            // No intersections.
            if (clean & 1) {
                segment = ringSegments[0];
                if ((m = segment.length - 1) > 0) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                    sink.lineEnd();
                }
                return;
            }
            // Rejoin connected segments.
            // TODO reuse ringBuffer.rejoin()?
            if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
            segments.push(ringSegments.filter($4b8791d3c418c038$var$validSegment));
        }
        return clip;
    };
}
function $4b8791d3c418c038$var$validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function $4b8791d3c418c038$var$compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, $961dd5ad4f13a8be$export$e51408a300e8929a) - (0, $961dd5ad4f13a8be$export$6c421550c66a327d) : (0, $961dd5ad4f13a8be$export$e51408a300e8929a) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, $961dd5ad4f13a8be$export$e51408a300e8929a) - (0, $961dd5ad4f13a8be$export$6c421550c66a327d) : (0, $961dd5ad4f13a8be$export$e51408a300e8929a) - b[1]);
}



var $978b3e0d666d25f4$export$2e2bcd8739ae039 = (0, $4b8791d3c418c038$export$2e2bcd8739ae039)(function() {
    return true;
}, $978b3e0d666d25f4$var$clipAntimeridianLine, $978b3e0d666d25f4$var$clipAntimeridianInterpolate, [
    -(0, $961dd5ad4f13a8be$export$18c7bea995a110f),
    -(0, $961dd5ad4f13a8be$export$e51408a300e8929a)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function $978b3e0d666d25f4$var$clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, $961dd5ad4f13a8be$export$18c7bea995a110f) : -(0, $961dd5ad4f13a8be$export$18c7bea995a110f), delta = (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(lambda1 - lambda0);
            if ((0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(delta - (0, $961dd5ad4f13a8be$export$18c7bea995a110f)) < (0, $961dd5ad4f13a8be$export$6c421550c66a327d)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, $961dd5ad4f13a8be$export$e51408a300e8929a) : -(0, $961dd5ad4f13a8be$export$e51408a300e8929a));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, $961dd5ad4f13a8be$export$18c7bea995a110f)) {
                if ((0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(lambda0 - sign0) < (0, $961dd5ad4f13a8be$export$6c421550c66a327d)) lambda0 -= sign0 * (0, $961dd5ad4f13a8be$export$6c421550c66a327d); // handle degeneracies
                if ((0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(lambda1 - sign1) < (0, $961dd5ad4f13a8be$export$6c421550c66a327d)) lambda1 -= sign1 * (0, $961dd5ad4f13a8be$export$6c421550c66a327d);
                phi0 = $978b3e0d666d25f4$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function $978b3e0d666d25f4$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(lambda0 - lambda1);
    return (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(sinLambda0Lambda1) > (0, $961dd5ad4f13a8be$export$6c421550c66a327d) ? (0, $961dd5ad4f13a8be$export$628dc4eed22b0fbd)(((0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi0) * (cosPhi1 = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi1)) * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(lambda1) - (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi1) * (cosPhi0 = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi0)) * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function $978b3e0d666d25f4$var$clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, $961dd5ad4f13a8be$export$e51408a300e8929a);
        stream.point(-(0, $961dd5ad4f13a8be$export$18c7bea995a110f), phi);
        stream.point(0, phi);
        stream.point((0, $961dd5ad4f13a8be$export$18c7bea995a110f), phi);
        stream.point((0, $961dd5ad4f13a8be$export$18c7bea995a110f), 0);
        stream.point((0, $961dd5ad4f13a8be$export$18c7bea995a110f), -phi);
        stream.point(0, -phi);
        stream.point(-(0, $961dd5ad4f13a8be$export$18c7bea995a110f), -phi);
        stream.point(-(0, $961dd5ad4f13a8be$export$18c7bea995a110f), 0);
        stream.point(-(0, $961dd5ad4f13a8be$export$18c7bea995a110f), phi);
    } else if ((0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(from[0] - to[0]) > (0, $961dd5ad4f13a8be$export$6c421550c66a327d)) {
        var lambda = from[0] < to[0] ? (0, $961dd5ad4f13a8be$export$18c7bea995a110f) : -(0, $961dd5ad4f13a8be$export$18c7bea995a110f);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}







function $a5a5213728324883$export$2e2bcd8739ae039(radius) {
    var cr = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(radius), delta = 6 * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), smallRadius = cr > 0, notHemisphere = (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(cr) > (0, $961dd5ad4f13a8be$export$6c421550c66a327d); // TODO optimise for this common case
    function interpolate(from, to, direction, stream) {
        (0, $5eca00066e433a13$export$b5441eb324cd8d4e)(stream, radius, delta, direction, from, to);
    }
    function visible(lambda, phi) {
        return (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(lambda) * (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi) > cr;
    }
    // Takes a line and cuts into visible segments. Return values used for polygon
    // clipping: 0 - there were intersections or the line was empty; 1 - no
    // intersections 2 - there were intersections, and the first and last segments
    // should be rejoined.
    function clipLine(stream) {
        var point0, c0, v0, v00, clean; // no intersections
        return {
            lineStart: function() {
                v00 = v0 = false;
                clean = 1;
            },
            point: function(lambda, phi) {
                var point1 = [
                    lambda,
                    phi
                ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, $961dd5ad4f13a8be$export$18c7bea995a110f) : -(0, $961dd5ad4f13a8be$export$18c7bea995a110f)), phi) : 0;
                if (!point0 && (v00 = v0 = v)) stream.lineStart();
                if (v !== v0) {
                    point2 = intersect(point0, point1);
                    if (!point2 || (0, $bbd8e745b1f2f667$export$2e2bcd8739ae039)(point0, point2) || (0, $bbd8e745b1f2f667$export$2e2bcd8739ae039)(point1, point2)) point1[2] = 1;
                }
                if (v !== v0) {
                    clean = 0;
                    if (v) {
                        // outside going in
                        stream.lineStart();
                        point2 = intersect(point1, point0);
                        stream.point(point2[0], point2[1]);
                    } else {
                        // inside going out
                        point2 = intersect(point0, point1);
                        stream.point(point2[0], point2[1], 2);
                        stream.lineEnd();
                    }
                    point0 = point2;
                } else if (notHemisphere && point0 && smallRadius ^ v) {
                    var t;
                    // If the codes for two points are different, or are both zero,
                    // and there this segment intersects with the small circle.
                    if (!(c & c0) && (t = intersect(point1, point0, true))) {
                        clean = 0;
                        if (smallRadius) {
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                        } else {
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1], 3);
                        }
                    }
                }
                if (v && (!point0 || !(0, $bbd8e745b1f2f667$export$2e2bcd8739ae039)(point0, point1))) stream.point(point1[0], point1[1]);
                point0 = point1, v0 = v, c0 = c;
            },
            lineEnd: function() {
                if (v0) stream.lineEnd();
                point0 = null;
            },
            // Rejoin first and last segments if there were intersections and the first
            // and last points were visible.
            clean: function() {
                return clean | (v00 && v0) << 1;
            }
        };
    }
    // Intersects the great circle between a and b with the clip circle.
    function intersect(a, b, two) {
        var pa = (0, $e0b7fba90feb13d3$export$6e6697ef026a96)(a), pb = (0, $e0b7fba90feb13d3$export$6e6697ef026a96)(b);
        // We have two planes, n1.p = d1 and n2.p = d2.
        // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
        var n1 = [
            1,
            0,
            0
        ], n2 = (0, $e0b7fba90feb13d3$export$4763f5351b14293f)(pa, pb), n2n2 = (0, $e0b7fba90feb13d3$export$2ef80f51436a9de9)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
        // Two polar points.
        if (!determinant) return !two && a;
        var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, $e0b7fba90feb13d3$export$4763f5351b14293f)(n1, n2), A = (0, $e0b7fba90feb13d3$export$52d0ee3fc868d452)(n1, c1), B = (0, $e0b7fba90feb13d3$export$52d0ee3fc868d452)(n2, c2);
        (0, $e0b7fba90feb13d3$export$e62eba72fc898eae)(A, B);
        // Solve |p(t)|^2 = 1.
        var u = n1xn2, w = (0, $e0b7fba90feb13d3$export$2ef80f51436a9de9)(A, u), uu = (0, $e0b7fba90feb13d3$export$2ef80f51436a9de9)(u, u), t2 = w * w - uu * ((0, $e0b7fba90feb13d3$export$2ef80f51436a9de9)(A, A) - 1);
        if (t2 < 0) return;
        var t = (0, $961dd5ad4f13a8be$export$eba8049fb5020b81)(t2), q = (0, $e0b7fba90feb13d3$export$52d0ee3fc868d452)(u, (-w - t) / uu);
        (0, $e0b7fba90feb13d3$export$e62eba72fc898eae)(q, A);
        q = (0, $e0b7fba90feb13d3$export$12f9ad44fe773943)(q);
        if (!two) return q;
        // Two intersection points.
        var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
        if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
        var delta = lambda1 - lambda0, polar = (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(delta - (0, $961dd5ad4f13a8be$export$18c7bea995a110f)) < (0, $961dd5ad4f13a8be$export$6c421550c66a327d), meridian = polar || delta < (0, $961dd5ad4f13a8be$export$6c421550c66a327d);
        if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
        // Check that the first point is between a and b.
        if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(q[0] - lambda0) < (0, $961dd5ad4f13a8be$export$6c421550c66a327d) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, $961dd5ad4f13a8be$export$18c7bea995a110f) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
            var q1 = (0, $e0b7fba90feb13d3$export$52d0ee3fc868d452)(u, (-w + t) / uu);
            (0, $e0b7fba90feb13d3$export$e62eba72fc898eae)(q1, A);
            return [
                q,
                (0, $e0b7fba90feb13d3$export$12f9ad44fe773943)(q1)
            ];
        }
    }
    // Generates a 4-bit vector representing the location of a point relative to
    // the small circle's bounding box.
    function code(lambda, phi) {
        var r = smallRadius ? radius : (0, $961dd5ad4f13a8be$export$18c7bea995a110f) - radius, code = 0;
        if (lambda < -r) code |= 1; // left
        else if (lambda > r) code |= 2; // right
        if (phi < -r) code |= 4; // below
        else if (phi > r) code |= 8; // above
        return code;
    }
    return (0, $4b8791d3c418c038$export$2e2bcd8739ae039)(visible, clipLine, interpolate, smallRadius ? [
        0,
        -radius
    ] : [
        -(0, $961dd5ad4f13a8be$export$18c7bea995a110f),
        radius - (0, $961dd5ad4f13a8be$export$18c7bea995a110f)
    ]);
}




function $26bf2feefedf85ac$export$2e2bcd8739ae039(a, b, x0, y0, x1, y1) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
    if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
    return true;
}




var $7ce1c7a535e2b6a2$var$clipMax = 1e9, $7ce1c7a535e2b6a2$var$clipMin = -$7ce1c7a535e2b6a2$var$clipMax;
function $7ce1c7a535e2b6a2$export$2e2bcd8739ae039(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(p[0] - x0) < (0, $961dd5ad4f13a8be$export$6c421550c66a327d) ? direction > 0 ? 0 : 3 : (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(p[0] - x1) < (0, $961dd5ad4f13a8be$export$6c421550c66a327d) ? direction > 0 ? 2 : 1 : (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(p[1] - y0) < (0, $961dd5ad4f13a8be$export$6c421550c66a327d) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, $62947761efd68a93$export$2e2bcd8739ae039)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, $6341023b666029a7$export$2e2bcd8739ae039)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, $9f6022d841d5236c$export$2e2bcd8739ae039)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max($7ce1c7a535e2b6a2$var$clipMin, Math.min($7ce1c7a535e2b6a2$var$clipMax, x_)),
                    y_ = Math.max($7ce1c7a535e2b6a2$var$clipMin, Math.min($7ce1c7a535e2b6a2$var$clipMax, y_))
                ], b = [
                    x = Math.max($7ce1c7a535e2b6a2$var$clipMin, Math.min($7ce1c7a535e2b6a2$var$clipMax, x)),
                    y = Math.max($7ce1c7a535e2b6a2$var$clipMin, Math.min($7ce1c7a535e2b6a2$var$clipMax, y))
                ];
                if ((0, $26bf2feefedf85ac$export$2e2bcd8739ae039)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}


function $9115c55214ca8df2$export$2e2bcd8739ae039() {
    var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
    return clip = {
        stream: function(stream) {
            return cache && cacheStream === stream ? cache : cache = (0, $7ce1c7a535e2b6a2$export$2e2bcd8739ae039)(x0, y0, x1, y1)(cacheStream = stream);
        },
        extent: function(_) {
            return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        }
    };
}








var $19c36ec7a1ae23fd$var$lengthSum, $19c36ec7a1ae23fd$var$lambda0, $19c36ec7a1ae23fd$var$sinPhi0, $19c36ec7a1ae23fd$var$cosPhi0;
var $19c36ec7a1ae23fd$var$lengthStream = {
    sphere: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039),
    point: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039),
    lineStart: $19c36ec7a1ae23fd$var$lengthLineStart,
    lineEnd: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039),
    polygonStart: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039),
    polygonEnd: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039)
};
function $19c36ec7a1ae23fd$var$lengthLineStart() {
    $19c36ec7a1ae23fd$var$lengthStream.point = $19c36ec7a1ae23fd$var$lengthPointFirst;
    $19c36ec7a1ae23fd$var$lengthStream.lineEnd = $19c36ec7a1ae23fd$var$lengthLineEnd;
}
function $19c36ec7a1ae23fd$var$lengthLineEnd() {
    $19c36ec7a1ae23fd$var$lengthStream.point = $19c36ec7a1ae23fd$var$lengthStream.lineEnd = (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039);
}
function $19c36ec7a1ae23fd$var$lengthPointFirst(lambda, phi) {
    lambda *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), phi *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc);
    $19c36ec7a1ae23fd$var$lambda0 = lambda, $19c36ec7a1ae23fd$var$sinPhi0 = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi), $19c36ec7a1ae23fd$var$cosPhi0 = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi);
    $19c36ec7a1ae23fd$var$lengthStream.point = $19c36ec7a1ae23fd$var$lengthPoint;
}
function $19c36ec7a1ae23fd$var$lengthPoint(lambda, phi) {
    lambda *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), phi *= (0, $961dd5ad4f13a8be$export$8449e153fbd325fc);
    var sinPhi = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi), cosPhi = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi), delta = (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(lambda - $19c36ec7a1ae23fd$var$lambda0), cosDelta = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(delta), sinDelta = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(delta), x = cosPhi * sinDelta, y = $19c36ec7a1ae23fd$var$cosPhi0 * sinPhi - $19c36ec7a1ae23fd$var$sinPhi0 * cosPhi * cosDelta, z = $19c36ec7a1ae23fd$var$sinPhi0 * sinPhi + $19c36ec7a1ae23fd$var$cosPhi0 * cosPhi * cosDelta;
    $19c36ec7a1ae23fd$var$lengthSum.add((0, $961dd5ad4f13a8be$export$b8b770ee6a0d9760)((0, $961dd5ad4f13a8be$export$eba8049fb5020b81)(x * x + y * y), z));
    $19c36ec7a1ae23fd$var$lambda0 = lambda, $19c36ec7a1ae23fd$var$sinPhi0 = sinPhi, $19c36ec7a1ae23fd$var$cosPhi0 = cosPhi;
}
function $19c36ec7a1ae23fd$export$2e2bcd8739ae039(object) {
    $19c36ec7a1ae23fd$var$lengthSum = new (0, $4e51c5d9e96ea8c7$export$bda7ba77fb86c375)();
    (0, $e2f4477abc5f18d1$export$2e2bcd8739ae039)(object, $19c36ec7a1ae23fd$var$lengthStream);
    return +$19c36ec7a1ae23fd$var$lengthSum;
}


var $2e0b131eeef62d40$var$coordinates = [
    null,
    null
], $2e0b131eeef62d40$var$object = {
    type: "LineString",
    coordinates: $2e0b131eeef62d40$var$coordinates
};
function $2e0b131eeef62d40$export$2e2bcd8739ae039(a, b) {
    $2e0b131eeef62d40$var$coordinates[0] = a;
    $2e0b131eeef62d40$var$coordinates[1] = b;
    return (0, $19c36ec7a1ae23fd$export$2e2bcd8739ae039)($2e0b131eeef62d40$var$object);
}



var $1cbc8a8b6dfbdc99$var$containsObjectType = {
    Feature: function(object, point) {
        return $1cbc8a8b6dfbdc99$var$containsGeometry(object.geometry, point);
    },
    FeatureCollection: function(object, point) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)if ($1cbc8a8b6dfbdc99$var$containsGeometry(features[i].geometry, point)) return true;
        return false;
    }
};
var $1cbc8a8b6dfbdc99$var$containsGeometryType = {
    Sphere: function() {
        return true;
    },
    Point: function(object, point) {
        return $1cbc8a8b6dfbdc99$var$containsPoint(object.coordinates, point);
    },
    MultiPoint: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($1cbc8a8b6dfbdc99$var$containsPoint(coordinates[i], point)) return true;
        return false;
    },
    LineString: function(object, point) {
        return $1cbc8a8b6dfbdc99$var$containsLine(object.coordinates, point);
    },
    MultiLineString: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($1cbc8a8b6dfbdc99$var$containsLine(coordinates[i], point)) return true;
        return false;
    },
    Polygon: function(object, point) {
        return $1cbc8a8b6dfbdc99$var$containsPolygon(object.coordinates, point);
    },
    MultiPolygon: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($1cbc8a8b6dfbdc99$var$containsPolygon(coordinates[i], point)) return true;
        return false;
    },
    GeometryCollection: function(object, point) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)if ($1cbc8a8b6dfbdc99$var$containsGeometry(geometries[i], point)) return true;
        return false;
    }
};
function $1cbc8a8b6dfbdc99$var$containsGeometry(geometry, point) {
    return geometry && $1cbc8a8b6dfbdc99$var$containsGeometryType.hasOwnProperty(geometry.type) ? $1cbc8a8b6dfbdc99$var$containsGeometryType[geometry.type](geometry, point) : false;
}
function $1cbc8a8b6dfbdc99$var$containsPoint(coordinates, point) {
    return (0, $2e0b131eeef62d40$export$2e2bcd8739ae039)(coordinates, point) === 0;
}
function $1cbc8a8b6dfbdc99$var$containsLine(coordinates, point) {
    var ao, bo, ab;
    for(var i = 0, n = coordinates.length; i < n; i++){
        bo = (0, $2e0b131eeef62d40$export$2e2bcd8739ae039)(coordinates[i], point);
        if (bo === 0) return true;
        if (i > 0) {
            ab = (0, $2e0b131eeef62d40$export$2e2bcd8739ae039)(coordinates[i], coordinates[i - 1]);
            if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < (0, $961dd5ad4f13a8be$export$92c06fba281fe81b) * ab) return true;
        }
        ao = bo;
    }
    return false;
}
function $1cbc8a8b6dfbdc99$var$containsPolygon(coordinates, point) {
    return !!(0, $18489d1b1ca8f0ca$export$2e2bcd8739ae039)(coordinates.map($1cbc8a8b6dfbdc99$var$ringRadians), $1cbc8a8b6dfbdc99$var$pointRadians(point));
}
function $1cbc8a8b6dfbdc99$var$ringRadians(ring) {
    return ring = ring.map($1cbc8a8b6dfbdc99$var$pointRadians), ring.pop(), ring;
}
function $1cbc8a8b6dfbdc99$var$pointRadians(point) {
    return [
        point[0] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc),
        point[1] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc)
    ];
}
function $1cbc8a8b6dfbdc99$export$2e2bcd8739ae039(object, point) {
    return (object && $1cbc8a8b6dfbdc99$var$containsObjectType.hasOwnProperty(object.type) ? $1cbc8a8b6dfbdc99$var$containsObjectType[object.type] : $1cbc8a8b6dfbdc99$var$containsGeometry)(object, point);
}





function $b0e557498ec3feb6$var$graticuleX(y0, y1, dy) {
    var y = (0, $e4dbde6ec669fccd$export$2e2bcd8739ae039)(y0, y1 - (0, $961dd5ad4f13a8be$export$6c421550c66a327d), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function $b0e557498ec3feb6$var$graticuleY(x0, x1, dx) {
    var x = (0, $e4dbde6ec669fccd$export$2e2bcd8739ae039)(x0, x1 - (0, $961dd5ad4f13a8be$export$6c421550c66a327d), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function $b0e557498ec3feb6$export$2e2bcd8739ae039() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, $e4dbde6ec669fccd$export$2e2bcd8739ae039)((0, $961dd5ad4f13a8be$export$803ce6b71a0a94b2)(X0 / DX) * DX, X1, DX).map(X).concat((0, $e4dbde6ec669fccd$export$2e2bcd8739ae039)((0, $961dd5ad4f13a8be$export$803ce6b71a0a94b2)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, $e4dbde6ec669fccd$export$2e2bcd8739ae039)((0, $961dd5ad4f13a8be$export$803ce6b71a0a94b2)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(x % DX) > (0, $961dd5ad4f13a8be$export$6c421550c66a327d);
        }).map(x)).concat((0, $e4dbde6ec669fccd$export$2e2bcd8739ae039)((0, $961dd5ad4f13a8be$export$803ce6b71a0a94b2)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(y % DY) > (0, $961dd5ad4f13a8be$export$6c421550c66a327d);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = $b0e557498ec3feb6$var$graticuleX(y0, y1, 90);
        y = $b0e557498ec3feb6$var$graticuleY(x0, x1, precision);
        X = $b0e557498ec3feb6$var$graticuleX(Y0, Y1, 90);
        Y = $b0e557498ec3feb6$var$graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, $961dd5ad4f13a8be$export$6c421550c66a327d)
        ],
        [
            180,
            90 - (0, $961dd5ad4f13a8be$export$6c421550c66a327d)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, $961dd5ad4f13a8be$export$6c421550c66a327d)
        ],
        [
            180,
            80 + (0, $961dd5ad4f13a8be$export$6c421550c66a327d)
        ]
    ]);
}
function $b0e557498ec3feb6$export$b8db4e9403a5b6f1() {
    return $b0e557498ec3feb6$export$2e2bcd8739ae039()();
}



function $3b321785a0548de2$export$2e2bcd8739ae039(a, b) {
    var x0 = a[0] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), y0 = a[1] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), x1 = b[0] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), y1 = b[1] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), cy0 = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(y0), sy0 = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(y0), cy1 = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(y1), sy1 = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(y1), kx0 = cy0 * (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(x0), ky0 = cy0 * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(x0), kx1 = cy1 * (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(x1), ky1 = cy1 * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(x1), d = 2 * (0, $961dd5ad4f13a8be$export$41726bdb1fc63f)((0, $961dd5ad4f13a8be$export$eba8049fb5020b81)((0, $961dd5ad4f13a8be$export$e808712c2966e662)(y1 - y0) + cy0 * cy1 * (0, $961dd5ad4f13a8be$export$e808712c2966e662)(x1 - x0))), k = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(d);
    var interpolate = d ? function(t) {
        var B = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(t *= d) / k, A = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
        return [
            (0, $961dd5ad4f13a8be$export$b8b770ee6a0d9760)(y, x) * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97),
            (0, $961dd5ad4f13a8be$export$b8b770ee6a0d9760)(z, (0, $961dd5ad4f13a8be$export$eba8049fb5020b81)(x * x + y * y)) * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97)
        ];
    } : function() {
        return [
            x0 * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97),
            y0 * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97)
        ];
    };
    interpolate.distance = d;
    return interpolate;
}



var $eea2e29c671b5324$export$2e2bcd8739ae039 = (x)=>x;






var $abcb669e6ef654ab$var$areaSum = new (0, $4e51c5d9e96ea8c7$export$bda7ba77fb86c375)(), $abcb669e6ef654ab$var$areaRingSum = new (0, $4e51c5d9e96ea8c7$export$bda7ba77fb86c375)(), $abcb669e6ef654ab$var$x00, $abcb669e6ef654ab$var$y00, $abcb669e6ef654ab$var$x0, $abcb669e6ef654ab$var$y0;
var $abcb669e6ef654ab$var$areaStream = {
    point: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039),
    lineStart: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039),
    lineEnd: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039),
    polygonStart: function() {
        $abcb669e6ef654ab$var$areaStream.lineStart = $abcb669e6ef654ab$var$areaRingStart;
        $abcb669e6ef654ab$var$areaStream.lineEnd = $abcb669e6ef654ab$var$areaRingEnd;
    },
    polygonEnd: function() {
        $abcb669e6ef654ab$var$areaStream.lineStart = $abcb669e6ef654ab$var$areaStream.lineEnd = $abcb669e6ef654ab$var$areaStream.point = (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039);
        $abcb669e6ef654ab$var$areaSum.add((0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)($abcb669e6ef654ab$var$areaRingSum));
        $abcb669e6ef654ab$var$areaRingSum = new (0, $4e51c5d9e96ea8c7$export$bda7ba77fb86c375)();
    },
    result: function() {
        var area = $abcb669e6ef654ab$var$areaSum / 2;
        $abcb669e6ef654ab$var$areaSum = new (0, $4e51c5d9e96ea8c7$export$bda7ba77fb86c375)();
        return area;
    }
};
function $abcb669e6ef654ab$var$areaRingStart() {
    $abcb669e6ef654ab$var$areaStream.point = $abcb669e6ef654ab$var$areaPointFirst;
}
function $abcb669e6ef654ab$var$areaPointFirst(x, y) {
    $abcb669e6ef654ab$var$areaStream.point = $abcb669e6ef654ab$var$areaPoint;
    $abcb669e6ef654ab$var$x00 = $abcb669e6ef654ab$var$x0 = x, $abcb669e6ef654ab$var$y00 = $abcb669e6ef654ab$var$y0 = y;
}
function $abcb669e6ef654ab$var$areaPoint(x, y) {
    $abcb669e6ef654ab$var$areaRingSum.add($abcb669e6ef654ab$var$y0 * x - $abcb669e6ef654ab$var$x0 * y);
    $abcb669e6ef654ab$var$x0 = x, $abcb669e6ef654ab$var$y0 = y;
}
function $abcb669e6ef654ab$var$areaRingEnd() {
    $abcb669e6ef654ab$var$areaPoint($abcb669e6ef654ab$var$x00, $abcb669e6ef654ab$var$y00);
}
var $abcb669e6ef654ab$export$2e2bcd8739ae039 = $abcb669e6ef654ab$var$areaStream;



var $eac085636b143886$var$x0 = Infinity, $eac085636b143886$var$y0 = $eac085636b143886$var$x0, $eac085636b143886$var$x1 = -$eac085636b143886$var$x0, $eac085636b143886$var$y1 = $eac085636b143886$var$x1;
var $eac085636b143886$var$boundsStream = {
    point: $eac085636b143886$var$boundsPoint,
    lineStart: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039),
    lineEnd: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039),
    polygonStart: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039),
    polygonEnd: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039),
    result: function() {
        var bounds = [
            [
                $eac085636b143886$var$x0,
                $eac085636b143886$var$y0
            ],
            [
                $eac085636b143886$var$x1,
                $eac085636b143886$var$y1
            ]
        ];
        $eac085636b143886$var$x1 = $eac085636b143886$var$y1 = -($eac085636b143886$var$y0 = $eac085636b143886$var$x0 = Infinity);
        return bounds;
    }
};
function $eac085636b143886$var$boundsPoint(x, y) {
    if (x < $eac085636b143886$var$x0) $eac085636b143886$var$x0 = x;
    if (x > $eac085636b143886$var$x1) $eac085636b143886$var$x1 = x;
    if (y < $eac085636b143886$var$y0) $eac085636b143886$var$y0 = y;
    if (y > $eac085636b143886$var$y1) $eac085636b143886$var$y1 = y;
}
var $eac085636b143886$export$2e2bcd8739ae039 = $eac085636b143886$var$boundsStream;



// TODO Enforce positive area for exterior, negative area for interior?
var $0f7e0ac34b8b9d75$var$X0 = 0, $0f7e0ac34b8b9d75$var$Y0 = 0, $0f7e0ac34b8b9d75$var$Z0 = 0, $0f7e0ac34b8b9d75$var$X1 = 0, $0f7e0ac34b8b9d75$var$Y1 = 0, $0f7e0ac34b8b9d75$var$Z1 = 0, $0f7e0ac34b8b9d75$var$X2 = 0, $0f7e0ac34b8b9d75$var$Y2 = 0, $0f7e0ac34b8b9d75$var$Z2 = 0, $0f7e0ac34b8b9d75$var$x00, $0f7e0ac34b8b9d75$var$y00, $0f7e0ac34b8b9d75$var$x0, $0f7e0ac34b8b9d75$var$y0;
var $0f7e0ac34b8b9d75$var$centroidStream = {
    point: $0f7e0ac34b8b9d75$var$centroidPoint,
    lineStart: $0f7e0ac34b8b9d75$var$centroidLineStart,
    lineEnd: $0f7e0ac34b8b9d75$var$centroidLineEnd,
    polygonStart: function() {
        $0f7e0ac34b8b9d75$var$centroidStream.lineStart = $0f7e0ac34b8b9d75$var$centroidRingStart;
        $0f7e0ac34b8b9d75$var$centroidStream.lineEnd = $0f7e0ac34b8b9d75$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $0f7e0ac34b8b9d75$var$centroidStream.point = $0f7e0ac34b8b9d75$var$centroidPoint;
        $0f7e0ac34b8b9d75$var$centroidStream.lineStart = $0f7e0ac34b8b9d75$var$centroidLineStart;
        $0f7e0ac34b8b9d75$var$centroidStream.lineEnd = $0f7e0ac34b8b9d75$var$centroidLineEnd;
    },
    result: function() {
        var centroid = $0f7e0ac34b8b9d75$var$Z2 ? [
            $0f7e0ac34b8b9d75$var$X2 / $0f7e0ac34b8b9d75$var$Z2,
            $0f7e0ac34b8b9d75$var$Y2 / $0f7e0ac34b8b9d75$var$Z2
        ] : $0f7e0ac34b8b9d75$var$Z1 ? [
            $0f7e0ac34b8b9d75$var$X1 / $0f7e0ac34b8b9d75$var$Z1,
            $0f7e0ac34b8b9d75$var$Y1 / $0f7e0ac34b8b9d75$var$Z1
        ] : $0f7e0ac34b8b9d75$var$Z0 ? [
            $0f7e0ac34b8b9d75$var$X0 / $0f7e0ac34b8b9d75$var$Z0,
            $0f7e0ac34b8b9d75$var$Y0 / $0f7e0ac34b8b9d75$var$Z0
        ] : [
            NaN,
            NaN
        ];
        $0f7e0ac34b8b9d75$var$X0 = $0f7e0ac34b8b9d75$var$Y0 = $0f7e0ac34b8b9d75$var$Z0 = $0f7e0ac34b8b9d75$var$X1 = $0f7e0ac34b8b9d75$var$Y1 = $0f7e0ac34b8b9d75$var$Z1 = $0f7e0ac34b8b9d75$var$X2 = $0f7e0ac34b8b9d75$var$Y2 = $0f7e0ac34b8b9d75$var$Z2 = 0;
        return centroid;
    }
};
function $0f7e0ac34b8b9d75$var$centroidPoint(x, y) {
    $0f7e0ac34b8b9d75$var$X0 += x;
    $0f7e0ac34b8b9d75$var$Y0 += y;
    ++$0f7e0ac34b8b9d75$var$Z0;
}
function $0f7e0ac34b8b9d75$var$centroidLineStart() {
    $0f7e0ac34b8b9d75$var$centroidStream.point = $0f7e0ac34b8b9d75$var$centroidPointFirstLine;
}
function $0f7e0ac34b8b9d75$var$centroidPointFirstLine(x, y) {
    $0f7e0ac34b8b9d75$var$centroidStream.point = $0f7e0ac34b8b9d75$var$centroidPointLine;
    $0f7e0ac34b8b9d75$var$centroidPoint($0f7e0ac34b8b9d75$var$x0 = x, $0f7e0ac34b8b9d75$var$y0 = y);
}
function $0f7e0ac34b8b9d75$var$centroidPointLine(x, y) {
    var dx = x - $0f7e0ac34b8b9d75$var$x0, dy = y - $0f7e0ac34b8b9d75$var$y0, z = (0, $961dd5ad4f13a8be$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $0f7e0ac34b8b9d75$var$X1 += z * ($0f7e0ac34b8b9d75$var$x0 + x) / 2;
    $0f7e0ac34b8b9d75$var$Y1 += z * ($0f7e0ac34b8b9d75$var$y0 + y) / 2;
    $0f7e0ac34b8b9d75$var$Z1 += z;
    $0f7e0ac34b8b9d75$var$centroidPoint($0f7e0ac34b8b9d75$var$x0 = x, $0f7e0ac34b8b9d75$var$y0 = y);
}
function $0f7e0ac34b8b9d75$var$centroidLineEnd() {
    $0f7e0ac34b8b9d75$var$centroidStream.point = $0f7e0ac34b8b9d75$var$centroidPoint;
}
function $0f7e0ac34b8b9d75$var$centroidRingStart() {
    $0f7e0ac34b8b9d75$var$centroidStream.point = $0f7e0ac34b8b9d75$var$centroidPointFirstRing;
}
function $0f7e0ac34b8b9d75$var$centroidRingEnd() {
    $0f7e0ac34b8b9d75$var$centroidPointRing($0f7e0ac34b8b9d75$var$x00, $0f7e0ac34b8b9d75$var$y00);
}
function $0f7e0ac34b8b9d75$var$centroidPointFirstRing(x, y) {
    $0f7e0ac34b8b9d75$var$centroidStream.point = $0f7e0ac34b8b9d75$var$centroidPointRing;
    $0f7e0ac34b8b9d75$var$centroidPoint($0f7e0ac34b8b9d75$var$x00 = $0f7e0ac34b8b9d75$var$x0 = x, $0f7e0ac34b8b9d75$var$y00 = $0f7e0ac34b8b9d75$var$y0 = y);
}
function $0f7e0ac34b8b9d75$var$centroidPointRing(x, y) {
    var dx = x - $0f7e0ac34b8b9d75$var$x0, dy = y - $0f7e0ac34b8b9d75$var$y0, z = (0, $961dd5ad4f13a8be$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $0f7e0ac34b8b9d75$var$X1 += z * ($0f7e0ac34b8b9d75$var$x0 + x) / 2;
    $0f7e0ac34b8b9d75$var$Y1 += z * ($0f7e0ac34b8b9d75$var$y0 + y) / 2;
    $0f7e0ac34b8b9d75$var$Z1 += z;
    z = $0f7e0ac34b8b9d75$var$y0 * x - $0f7e0ac34b8b9d75$var$x0 * y;
    $0f7e0ac34b8b9d75$var$X2 += z * ($0f7e0ac34b8b9d75$var$x0 + x);
    $0f7e0ac34b8b9d75$var$Y2 += z * ($0f7e0ac34b8b9d75$var$y0 + y);
    $0f7e0ac34b8b9d75$var$Z2 += z * 3;
    $0f7e0ac34b8b9d75$var$centroidPoint($0f7e0ac34b8b9d75$var$x0 = x, $0f7e0ac34b8b9d75$var$y0 = y);
}
var $0f7e0ac34b8b9d75$export$2e2bcd8739ae039 = $0f7e0ac34b8b9d75$var$centroidStream;




function $98c0916c470f7b72$export$2e2bcd8739ae039(context) {
    this._context = context;
}
$98c0916c470f7b72$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, $961dd5ad4f13a8be$export$a4b4b4d4d776fe92));
                break;
        }
    },
    result: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039)
};





var $8e14ba7c64528c1e$var$lengthSum = new (0, $4e51c5d9e96ea8c7$export$bda7ba77fb86c375)(), $8e14ba7c64528c1e$var$lengthRing, $8e14ba7c64528c1e$var$x00, $8e14ba7c64528c1e$var$y00, $8e14ba7c64528c1e$var$x0, $8e14ba7c64528c1e$var$y0;
var $8e14ba7c64528c1e$var$lengthStream = {
    point: (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039),
    lineStart: function() {
        $8e14ba7c64528c1e$var$lengthStream.point = $8e14ba7c64528c1e$var$lengthPointFirst;
    },
    lineEnd: function() {
        if ($8e14ba7c64528c1e$var$lengthRing) $8e14ba7c64528c1e$var$lengthPoint($8e14ba7c64528c1e$var$x00, $8e14ba7c64528c1e$var$y00);
        $8e14ba7c64528c1e$var$lengthStream.point = (0, $3c146c97f8d7b5e7$export$2e2bcd8739ae039);
    },
    polygonStart: function() {
        $8e14ba7c64528c1e$var$lengthRing = true;
    },
    polygonEnd: function() {
        $8e14ba7c64528c1e$var$lengthRing = null;
    },
    result: function() {
        var length = +$8e14ba7c64528c1e$var$lengthSum;
        $8e14ba7c64528c1e$var$lengthSum = new (0, $4e51c5d9e96ea8c7$export$bda7ba77fb86c375)();
        return length;
    }
};
function $8e14ba7c64528c1e$var$lengthPointFirst(x, y) {
    $8e14ba7c64528c1e$var$lengthStream.point = $8e14ba7c64528c1e$var$lengthPoint;
    $8e14ba7c64528c1e$var$x00 = $8e14ba7c64528c1e$var$x0 = x, $8e14ba7c64528c1e$var$y00 = $8e14ba7c64528c1e$var$y0 = y;
}
function $8e14ba7c64528c1e$var$lengthPoint(x, y) {
    $8e14ba7c64528c1e$var$x0 -= x, $8e14ba7c64528c1e$var$y0 -= y;
    $8e14ba7c64528c1e$var$lengthSum.add((0, $961dd5ad4f13a8be$export$eba8049fb5020b81)($8e14ba7c64528c1e$var$x0 * $8e14ba7c64528c1e$var$x0 + $8e14ba7c64528c1e$var$y0 * $8e14ba7c64528c1e$var$y0));
    $8e14ba7c64528c1e$var$x0 = x, $8e14ba7c64528c1e$var$y0 = y;
}
var $8e14ba7c64528c1e$export$2e2bcd8739ae039 = $8e14ba7c64528c1e$var$lengthStream;


// Simple caching for constant-radius points.
let $7680b9dc062461be$var$cacheDigits, $7680b9dc062461be$var$cacheAppend, $7680b9dc062461be$var$cacheRadius, $7680b9dc062461be$var$cacheCircle;
class $7680b9dc062461be$export$2e2bcd8739ae039 {
    constructor(digits){
        this._append = digits == null ? $7680b9dc062461be$var$append : $7680b9dc062461be$var$appendRound(digits);
        this._radius = 4.5;
        this._ = "";
    }
    pointRadius(_) {
        this._radius = +_;
        return this;
    }
    polygonStart() {
        this._line = 0;
    }
    polygonEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line === 0) this._ += "Z";
        this._point = NaN;
    }
    point(x, y) {
        switch(this._point){
            case 0:
                this._append`M${x},${y}`;
                this._point = 1;
                break;
            case 1:
                this._append`L${x},${y}`;
                break;
            default:
                this._append`M${x},${y}`;
                if (this._radius !== $7680b9dc062461be$var$cacheRadius || this._append !== $7680b9dc062461be$var$cacheAppend) {
                    const r = this._radius;
                    const s = this._;
                    this._ = ""; // stash the old string so we can cache the circle path fragment
                    this._append`m0,${r}a${r},${r} 0 1,1 0,${-2 * r}a${r},${r} 0 1,1 0,${2 * r}z`;
                    $7680b9dc062461be$var$cacheRadius = r;
                    $7680b9dc062461be$var$cacheAppend = this._append;
                    $7680b9dc062461be$var$cacheCircle = this._;
                    this._ = s;
                }
                this._ += $7680b9dc062461be$var$cacheCircle;
                break;
        }
    }
    result() {
        const result = this._;
        this._ = "";
        return result.length ? result : null;
    }
}
function $7680b9dc062461be$var$append(strings) {
    let i = 1;
    this._ += strings[0];
    for(const j = strings.length; i < j; ++i)this._ += arguments[i] + strings[i];
}
function $7680b9dc062461be$var$appendRound(digits) {
    const d = Math.floor(digits);
    if (!(d >= 0)) throw new RangeError(`invalid digits: ${digits}`);
    if (d > 15) return $7680b9dc062461be$var$append;
    if (d !== $7680b9dc062461be$var$cacheDigits) {
        const k = 10 ** d;
        $7680b9dc062461be$var$cacheDigits = d;
        $7680b9dc062461be$var$cacheAppend = function append(strings) {
            let i = 1;
            this._ += strings[0];
            for(const j = strings.length; i < j; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
        };
    }
    return $7680b9dc062461be$var$cacheAppend;
}


function $1b3cf1508d129a92$export$2e2bcd8739ae039(projection, context) {
    let digits = 3, pointRadius = 4.5, projectionStream, contextStream;
    function path(object) {
        if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            (0, $e2f4477abc5f18d1$export$2e2bcd8739ae039)(object, projectionStream(contextStream));
        }
        return contextStream.result();
    }
    path.area = function(object) {
        (0, $e2f4477abc5f18d1$export$2e2bcd8739ae039)(object, projectionStream((0, $abcb669e6ef654ab$export$2e2bcd8739ae039)));
        return (0, $abcb669e6ef654ab$export$2e2bcd8739ae039).result();
    };
    path.measure = function(object) {
        (0, $e2f4477abc5f18d1$export$2e2bcd8739ae039)(object, projectionStream((0, $8e14ba7c64528c1e$export$2e2bcd8739ae039)));
        return (0, $8e14ba7c64528c1e$export$2e2bcd8739ae039).result();
    };
    path.bounds = function(object) {
        (0, $e2f4477abc5f18d1$export$2e2bcd8739ae039)(object, projectionStream((0, $eac085636b143886$export$2e2bcd8739ae039)));
        return (0, $eac085636b143886$export$2e2bcd8739ae039).result();
    };
    path.centroid = function(object) {
        (0, $e2f4477abc5f18d1$export$2e2bcd8739ae039)(object, projectionStream((0, $0f7e0ac34b8b9d75$export$2e2bcd8739ae039)));
        return (0, $0f7e0ac34b8b9d75$export$2e2bcd8739ae039).result();
    };
    path.projection = function(_) {
        if (!arguments.length) return projection;
        projectionStream = _ == null ? (projection = null, $eea2e29c671b5324$export$2e2bcd8739ae039) : (projection = _).stream;
        return path;
    };
    path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = _ == null ? (context = null, new (0, $7680b9dc062461be$export$2e2bcd8739ae039)(digits)) : new (0, $98c0916c470f7b72$export$2e2bcd8739ae039)(context = _);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return path;
    };
    path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
    };
    path.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        if (context === null) contextStream = new (0, $7680b9dc062461be$export$2e2bcd8739ae039)(digits);
        return path;
    };
    return path.projection(projection).digits(digits).context(context);
}











function $63e3e91a377016cd$export$2e2bcd8739ae039(methods) {
    return {
        stream: $63e3e91a377016cd$export$6b468dcfb64c653c(methods)
    };
}
function $63e3e91a377016cd$export$6b468dcfb64c653c(methods) {
    return function(stream) {
        var s = new $63e3e91a377016cd$var$TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function $63e3e91a377016cd$var$TransformStream() {}
$63e3e91a377016cd$var$TransformStream.prototype = {
    constructor: $63e3e91a377016cd$var$TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};




function $33af29e7d3a9342b$var$fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, $e2f4477abc5f18d1$export$2e2bcd8739ae039)(object, projection.stream((0, $eac085636b143886$export$2e2bcd8739ae039)));
    fitBounds((0, $eac085636b143886$export$2e2bcd8739ae039).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function $33af29e7d3a9342b$export$e450184041869e7f(projection, extent, object) {
    return $33af29e7d3a9342b$var$fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $33af29e7d3a9342b$export$33a367fa1728c3ba(projection, size, object) {
    return $33af29e7d3a9342b$export$e450184041869e7f(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function $33af29e7d3a9342b$export$7d8f2192ef31c5a7(projection, width, object) {
    return $33af29e7d3a9342b$var$fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $33af29e7d3a9342b$export$7069bab0d2ced675(projection, height, object) {
    return $33af29e7d3a9342b$var$fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}





var $582adbdd34c215e6$var$maxDepth = 16, $582adbdd34c215e6$var$cosMinDistance = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(30 * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc)); // cos(minimum angular distance)
function $582adbdd34c215e6$export$2e2bcd8739ae039(project, delta2) {
    return +delta2 ? $582adbdd34c215e6$var$resample(project, delta2) : $582adbdd34c215e6$var$resampleNone(project);
}
function $582adbdd34c215e6$var$resampleNone(project) {
    return (0, $63e3e91a377016cd$export$6b468dcfb64c653c)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function $582adbdd34c215e6$var$resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, $961dd5ad4f13a8be$export$eba8049fb5020b81)(a * a + b * b + c * c), phi2 = (0, $961dd5ad4f13a8be$export$41726bdb1fc63f)(c /= m), lambda2 = (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)((0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(c) - 1) < (0, $961dd5ad4f13a8be$export$6c421550c66a327d) || (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(lambda0 - lambda1) < (0, $961dd5ad4f13a8be$export$6c421550c66a327d) ? (lambda0 + lambda1) / 2 : (0, $961dd5ad4f13a8be$export$b8b770ee6a0d9760)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < $582adbdd34c215e6$var$cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, $e0b7fba90feb13d3$export$6e6697ef026a96)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], $582adbdd34c215e6$var$maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, $582adbdd34c215e6$var$maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}


var $14becbff16fda383$var$transformRadians = (0, $63e3e91a377016cd$export$6b468dcfb64c653c)({
    point: function(x, y) {
        this.stream.point(x * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), y * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc));
    }
});
function $14becbff16fda383$var$transformRotate(rotate) {
    return (0, $63e3e91a377016cd$export$6b468dcfb64c653c)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function $14becbff16fda383$var$scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            dx + k * x,
            dy - k * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            (x - dx) / k * sx,
            (dy - y) / k * sy
        ];
    };
    return transform;
}
function $14becbff16fda383$var$scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    if (!alpha) return $14becbff16fda383$var$scaleTranslate(k, dx, dy, sx, sy);
    var cosAlpha = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(alpha), sinAlpha = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            a * x - b * y + dx,
            dy - b * x - a * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            sx * (ai * x - bi * y + ci),
            sy * (fi - bi * x - ai * y)
        ];
    };
    return transform;
}
function $14becbff16fda383$export$2e2bcd8739ae039(project) {
    return $14becbff16fda383$export$155d5a6fa6fddeba(function() {
        return project;
    })();
}
function $14becbff16fda383$export$155d5a6fa6fddeba(projectAt) {
    var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = (0, $978b3e0d666d25f4$export$2e2bcd8739ae039), x0 = null, y0, x1, y1, postclip = (0, $eea2e29c671b5324$export$2e2bcd8739ae039), delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
    function projection(point) {
        return projectRotateTransform(point[0] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), point[1] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc));
    }
    function invert(point) {
        point = projectRotateTransform.invert(point[0], point[1]);
        return point && [
            point[0] * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97),
            point[1] * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97)
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $14becbff16fda383$var$transformRadians($14becbff16fda383$var$transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, $a5a5213728324883$export$2e2bcd8739ae039)(theta = _ * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc)) : (theta = null, $978b3e0d666d25f4$export$2e2bcd8739ae039), reset()) : theta * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $eea2e29c671b5324$export$2e2bcd8739ae039) : (0, $7ce1c7a535e2b6a2$export$2e2bcd8739ae039)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), phi = _[1] % 360 * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), recenter()) : [
            lambda * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97),
            phi * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), deltaPhi = _[1] % 360 * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), deltaGamma = _.length > 2 ? _[2] % 360 * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc) : 0, recenter()) : [
            deltaLambda * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97),
            deltaPhi * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97),
            deltaGamma * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97)
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), recenter()) : alpha * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, $582adbdd34c215e6$export$2e2bcd8739ae039)(projectTransform, delta2 = _ * _), reset()) : (0, $961dd5ad4f13a8be$export$eba8049fb5020b81)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, $33af29e7d3a9342b$export$e450184041869e7f)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $33af29e7d3a9342b$export$33a367fa1728c3ba)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $33af29e7d3a9342b$export$7d8f2192ef31c5a7)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $33af29e7d3a9342b$export$7069bab0d2ced675)(projection, height, object);
    };
    function recenter() {
        var center = $14becbff16fda383$var$scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = $14becbff16fda383$var$scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
        rotate = (0, $1bf6c214ce0c31b0$export$a2ba89726971a90f)(deltaLambda, deltaPhi, deltaGamma);
        projectTransform = (0, $f109361b05c0603f$export$2e2bcd8739ae039)(project, transform);
        projectRotateTransform = (0, $f109361b05c0603f$export$2e2bcd8739ae039)(rotate, projectTransform);
        projectResample = (0, $582adbdd34c215e6$export$2e2bcd8739ae039)(projectTransform, delta2);
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}


function $5077ed515b1fadff$export$228272587c4d24d8(projectAt) {
    var phi0 = 0, phi1 = (0, $961dd5ad4f13a8be$export$18c7bea995a110f) / 3, m = (0, $14becbff16fda383$export$155d5a6fa6fddeba)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), phi1 = _[1] * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc)) : [
            phi0 * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97),
            phi1 * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97)
        ];
    };
    return p;
}



function $211127e315dede72$export$ae68c6db8b65046a(phi0) {
    var cosPhi0 = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, $961dd5ad4f13a8be$export$41726bdb1fc63f)(y * cosPhi0)
        ];
    };
    return forward;
}


function $7b570b59d8990f0e$export$75409dad1c406288(y0, y1) {
    var sy0 = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(y0), n = (sy0 + (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(n) < (0, $961dd5ad4f13a8be$export$6c421550c66a327d)) return (0, $211127e315dede72$export$ae68c6db8b65046a)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, $961dd5ad4f13a8be$export$eba8049fb5020b81)(c) / n;
    function project(x, y) {
        var r = (0, $961dd5ad4f13a8be$export$eba8049fb5020b81)(c - 2 * n * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(y)) / n;
        return [
            r * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(x *= n),
            r0 - r * (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y, l = (0, $961dd5ad4f13a8be$export$b8b770ee6a0d9760)(x, (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(r0y)) * (0, $961dd5ad4f13a8be$export$c5552dfdbc7cec71)(r0y);
        if (r0y * n < 0) l -= (0, $961dd5ad4f13a8be$export$18c7bea995a110f) * (0, $961dd5ad4f13a8be$export$c5552dfdbc7cec71)(x) * (0, $961dd5ad4f13a8be$export$c5552dfdbc7cec71)(r0y);
        return [
            l / n,
            (0, $961dd5ad4f13a8be$export$41726bdb1fc63f)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}
function $7b570b59d8990f0e$export$2e2bcd8739ae039() {
    return (0, $5077ed515b1fadff$export$228272587c4d24d8)($7b570b59d8990f0e$export$75409dad1c406288).scale(155.424).center([
        0,
        33.6442
    ]);
}


function $24fef71d2ff65239$export$2e2bcd8739ae039() {
    return (0, $7b570b59d8990f0e$export$2e2bcd8739ae039)().parallels([
        29.5,
        45.5
    ]).scale(1070).translate([
        480,
        250
    ]).rotate([
        96,
        0
    ]).center([
        -0.6,
        38.7
    ]);
}






// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function $3f07d9f593fd88bd$var$multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}
function $3f07d9f593fd88bd$export$2e2bcd8739ae039() {
    var cache, cacheStream, lower48 = (0, $24fef71d2ff65239$export$2e2bcd8739ae039)(), lower48Point, alaska = (0, $7b570b59d8990f0e$export$2e2bcd8739ae039)().rotate([
        154,
        0
    ]).center([
        -2,
        58.5
    ]).parallels([
        55,
        65
    ]), alaskaPoint, hawaii = (0, $7b570b59d8990f0e$export$2e2bcd8739ae039)().rotate([
        157,
        0
    ]).center([
        -3,
        19.9
    ]).parallels([
        8,
        18
    ]), hawaiiPoint, point, pointStream = {
        point: function(x, y) {
            point = [
                x,
                y
            ];
        }
    };
    function albersUsa(coordinates) {
        var x = coordinates[0], y = coordinates[1];
        return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
    }
    albersUsa.invert = function(coordinates) {
        var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
        return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $3f07d9f593fd88bd$var$multiplex([
            lower48.stream(cacheStream = stream),
            alaska.stream(stream),
            hawaii.stream(stream)
        ]);
    };
    albersUsa.precision = function(_) {
        if (!arguments.length) return lower48.precision();
        lower48.precision(_), alaska.precision(_), hawaii.precision(_);
        return reset();
    };
    albersUsa.scale = function(_) {
        if (!arguments.length) return lower48.scale();
        lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
        return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
        if (!arguments.length) return lower48.translate();
        var k = lower48.scale(), x = +_[0], y = +_[1];
        lower48Point = lower48.translate(_).clipExtent([
            [
                x - 0.455 * k,
                y - 0.238 * k
            ],
            [
                x + 0.455 * k,
                y + 0.238 * k
            ]
        ]).stream(pointStream);
        alaskaPoint = alaska.translate([
            x - 0.307 * k,
            y + 0.201 * k
        ]).clipExtent([
            [
                x - 0.425 * k + (0, $961dd5ad4f13a8be$export$6c421550c66a327d),
                y + 0.120 * k + (0, $961dd5ad4f13a8be$export$6c421550c66a327d)
            ],
            [
                x - 0.214 * k - (0, $961dd5ad4f13a8be$export$6c421550c66a327d),
                y + 0.234 * k - (0, $961dd5ad4f13a8be$export$6c421550c66a327d)
            ]
        ]).stream(pointStream);
        hawaiiPoint = hawaii.translate([
            x - 0.205 * k,
            y + 0.212 * k
        ]).clipExtent([
            [
                x - 0.214 * k + (0, $961dd5ad4f13a8be$export$6c421550c66a327d),
                y + 0.166 * k + (0, $961dd5ad4f13a8be$export$6c421550c66a327d)
            ],
            [
                x - 0.115 * k - (0, $961dd5ad4f13a8be$export$6c421550c66a327d),
                y + 0.234 * k - (0, $961dd5ad4f13a8be$export$6c421550c66a327d)
            ]
        ]).stream(pointStream);
        return reset();
    };
    albersUsa.fitExtent = function(extent, object) {
        return (0, $33af29e7d3a9342b$export$e450184041869e7f)(albersUsa, extent, object);
    };
    albersUsa.fitSize = function(size, object) {
        return (0, $33af29e7d3a9342b$export$33a367fa1728c3ba)(albersUsa, size, object);
    };
    albersUsa.fitWidth = function(width, object) {
        return (0, $33af29e7d3a9342b$export$7d8f2192ef31c5a7)(albersUsa, width, object);
    };
    albersUsa.fitHeight = function(height, object) {
        return (0, $33af29e7d3a9342b$export$7069bab0d2ced675)(albersUsa, height, object);
    };
    function reset() {
        cache = cacheStream = null;
        return albersUsa;
    }
    return albersUsa.scale(1070);
}




function $a85930ef0ee224cc$export$f1211ac1bdb0796(scale) {
    return function(x, y) {
        var cx = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(x), cy = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(y), k = scale(cx * cy);
        if (k === Infinity) return [
            2,
            0
        ];
        return [
            k * cy * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(x),
            k * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(y)
        ];
    };
}
function $a85930ef0ee224cc$export$3cee429f13e44eac(angle) {
    return function(x, y) {
        var z = (0, $961dd5ad4f13a8be$export$eba8049fb5020b81)(x * x + y * y), c = angle(z), sc = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(c), cc = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(c);
        return [
            (0, $961dd5ad4f13a8be$export$b8b770ee6a0d9760)(x * sc, z * cc),
            (0, $961dd5ad4f13a8be$export$41726bdb1fc63f)(z && y * sc / z)
        ];
    };
}



var $9591be1912a4a1f3$export$5e11f94fc4a8d2c6 = (0, $a85930ef0ee224cc$export$f1211ac1bdb0796)(function(cxcy) {
    return (0, $961dd5ad4f13a8be$export$eba8049fb5020b81)(2 / (1 + cxcy));
});
$9591be1912a4a1f3$export$5e11f94fc4a8d2c6.invert = (0, $a85930ef0ee224cc$export$3cee429f13e44eac)(function(z) {
    return 2 * (0, $961dd5ad4f13a8be$export$41726bdb1fc63f)(z / 2);
});
function $9591be1912a4a1f3$export$2e2bcd8739ae039() {
    return (0, $14becbff16fda383$export$2e2bcd8739ae039)($9591be1912a4a1f3$export$5e11f94fc4a8d2c6).scale(124.75).clipAngle(179.999);
}





var $5fd605e4e4ed8d25$export$b94a4d6aa3dd25c = (0, $a85930ef0ee224cc$export$f1211ac1bdb0796)(function(c) {
    return (c = (0, $961dd5ad4f13a8be$export$fd6306be3fde5b04)(c)) && c / (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(c);
});
$5fd605e4e4ed8d25$export$b94a4d6aa3dd25c.invert = (0, $a85930ef0ee224cc$export$3cee429f13e44eac)(function(z) {
    return z;
});
function $5fd605e4e4ed8d25$export$2e2bcd8739ae039() {
    return (0, $14becbff16fda383$export$2e2bcd8739ae039)($5fd605e4e4ed8d25$export$b94a4d6aa3dd25c).scale(79.4188).clipAngle(179.999);
}







function $2368fe22dc039c7f$export$94ff8a57e9b91cc3(lambda, phi) {
    return [
        lambda,
        (0, $961dd5ad4f13a8be$export$bef1f36f5486a6a3)((0, $961dd5ad4f13a8be$export$fcdd3b0b3246a325)(((0, $961dd5ad4f13a8be$export$e51408a300e8929a) + phi) / 2))
    ];
}
$2368fe22dc039c7f$export$94ff8a57e9b91cc3.invert = function(x, y) {
    return [
        x,
        2 * (0, $961dd5ad4f13a8be$export$628dc4eed22b0fbd)((0, $961dd5ad4f13a8be$export$b310ec824aaee37f)(y)) - (0, $961dd5ad4f13a8be$export$e51408a300e8929a)
    ];
};
function $2368fe22dc039c7f$export$2e2bcd8739ae039() {
    return $2368fe22dc039c7f$export$44b9b66a01f2127b($2368fe22dc039c7f$export$94ff8a57e9b91cc3).scale(961 / (0, $961dd5ad4f13a8be$export$a4b4b4d4d776fe92));
}
function $2368fe22dc039c7f$export$44b9b66a01f2127b(project) {
    var m = (0, $14becbff16fda383$export$2e2bcd8739ae039)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, $961dd5ad4f13a8be$export$18c7bea995a110f) * scale(), t = m((0, $1bf6c214ce0c31b0$export$2e2bcd8739ae039)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === $2368fe22dc039c7f$export$94ff8a57e9b91cc3 ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}


function $bd0e15f8d76790a5$var$tany(y) {
    return (0, $961dd5ad4f13a8be$export$fcdd3b0b3246a325)(((0, $961dd5ad4f13a8be$export$e51408a300e8929a) + y) / 2);
}
function $bd0e15f8d76790a5$export$2b1bc913962ed170(y0, y1) {
    var cy0 = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(y0), n = y0 === y1 ? (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(y0) : (0, $961dd5ad4f13a8be$export$bef1f36f5486a6a3)(cy0 / (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(y1)) / (0, $961dd5ad4f13a8be$export$bef1f36f5486a6a3)($bd0e15f8d76790a5$var$tany(y1) / $bd0e15f8d76790a5$var$tany(y0)), f = cy0 * (0, $961dd5ad4f13a8be$export$9c297f60e22e3389)($bd0e15f8d76790a5$var$tany(y0), n) / n;
    if (!n) return 0, $2368fe22dc039c7f$export$94ff8a57e9b91cc3;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, $961dd5ad4f13a8be$export$e51408a300e8929a) + (0, $961dd5ad4f13a8be$export$6c421550c66a327d)) y = -(0, $961dd5ad4f13a8be$export$e51408a300e8929a) + (0, $961dd5ad4f13a8be$export$6c421550c66a327d);
        } else if (y > (0, $961dd5ad4f13a8be$export$e51408a300e8929a) - (0, $961dd5ad4f13a8be$export$6c421550c66a327d)) y = (0, $961dd5ad4f13a8be$export$e51408a300e8929a) - (0, $961dd5ad4f13a8be$export$6c421550c66a327d);
        var r = f / (0, $961dd5ad4f13a8be$export$9c297f60e22e3389)($bd0e15f8d76790a5$var$tany(y), n);
        return [
            r * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(n * x),
            f - r * (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, $961dd5ad4f13a8be$export$c5552dfdbc7cec71)(n) * (0, $961dd5ad4f13a8be$export$eba8049fb5020b81)(x * x + fy * fy), l = (0, $961dd5ad4f13a8be$export$b8b770ee6a0d9760)(x, (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(fy)) * (0, $961dd5ad4f13a8be$export$c5552dfdbc7cec71)(fy);
        if (fy * n < 0) l -= (0, $961dd5ad4f13a8be$export$18c7bea995a110f) * (0, $961dd5ad4f13a8be$export$c5552dfdbc7cec71)(x) * (0, $961dd5ad4f13a8be$export$c5552dfdbc7cec71)(fy);
        return [
            l / n,
            2 * (0, $961dd5ad4f13a8be$export$628dc4eed22b0fbd)((0, $961dd5ad4f13a8be$export$9c297f60e22e3389)(f / r, 1 / n)) - (0, $961dd5ad4f13a8be$export$e51408a300e8929a)
        ];
    };
    return project;
}
function $bd0e15f8d76790a5$export$2e2bcd8739ae039() {
    return (0, $5077ed515b1fadff$export$228272587c4d24d8)($bd0e15f8d76790a5$export$2b1bc913962ed170).scale(109.5).parallels([
        30,
        30
    ]);
}






function $8d7adeaddf07303d$export$f5fee52180f2f058(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
$8d7adeaddf07303d$export$f5fee52180f2f058.invert = $8d7adeaddf07303d$export$f5fee52180f2f058;
function $8d7adeaddf07303d$export$2e2bcd8739ae039() {
    return (0, $14becbff16fda383$export$2e2bcd8739ae039)($8d7adeaddf07303d$export$f5fee52180f2f058).scale(152.63);
}


function $15f979c3979c9d71$export$24f604fe80e5f192(y0, y1) {
    var cy0 = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(y0), n = y0 === y1 ? (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(y0) : (cy0 - (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(n) < (0, $961dd5ad4f13a8be$export$6c421550c66a327d)) return 0, $8d7adeaddf07303d$export$f5fee52180f2f058;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(nx),
            g - gy * (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y, l = (0, $961dd5ad4f13a8be$export$b8b770ee6a0d9760)(x, (0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(gy)) * (0, $961dd5ad4f13a8be$export$c5552dfdbc7cec71)(gy);
        if (gy * n < 0) l -= (0, $961dd5ad4f13a8be$export$18c7bea995a110f) * (0, $961dd5ad4f13a8be$export$c5552dfdbc7cec71)(x) * (0, $961dd5ad4f13a8be$export$c5552dfdbc7cec71)(gy);
        return [
            l / n,
            g - (0, $961dd5ad4f13a8be$export$c5552dfdbc7cec71)(n) * (0, $961dd5ad4f13a8be$export$eba8049fb5020b81)(x * x + gy * gy)
        ];
    };
    return project;
}
function $15f979c3979c9d71$export$2e2bcd8739ae039() {
    return (0, $5077ed515b1fadff$export$228272587c4d24d8)($15f979c3979c9d71$export$24f604fe80e5f192).scale(131.154).center([
        0,
        13.9389
    ]);
}




var $cd3a6f7fbd655c4d$var$A1 = 1.340264, $cd3a6f7fbd655c4d$var$A2 = -0.081106, $cd3a6f7fbd655c4d$var$A3 = 0.000893, $cd3a6f7fbd655c4d$var$A4 = 0.003796, $cd3a6f7fbd655c4d$var$M = (0, $961dd5ad4f13a8be$export$eba8049fb5020b81)(3) / 2, $cd3a6f7fbd655c4d$var$iterations = 12;
function $cd3a6f7fbd655c4d$export$a320734067e7a731(lambda, phi) {
    var l = (0, $961dd5ad4f13a8be$export$41726bdb1fc63f)($cd3a6f7fbd655c4d$var$M * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
    return [
        lambda * (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(l) / ($cd3a6f7fbd655c4d$var$M * ($cd3a6f7fbd655c4d$var$A1 + 3 * $cd3a6f7fbd655c4d$var$A2 * l2 + l6 * (7 * $cd3a6f7fbd655c4d$var$A3 + 9 * $cd3a6f7fbd655c4d$var$A4 * l2))),
        l * ($cd3a6f7fbd655c4d$var$A1 + $cd3a6f7fbd655c4d$var$A2 * l2 + l6 * ($cd3a6f7fbd655c4d$var$A3 + $cd3a6f7fbd655c4d$var$A4 * l2))
    ];
}
$cd3a6f7fbd655c4d$export$a320734067e7a731.invert = function(x, y) {
    var l = y, l2 = l * l, l6 = l2 * l2 * l2;
    for(var i = 0, delta, fy, fpy; i < $cd3a6f7fbd655c4d$var$iterations; ++i){
        fy = l * ($cd3a6f7fbd655c4d$var$A1 + $cd3a6f7fbd655c4d$var$A2 * l2 + l6 * ($cd3a6f7fbd655c4d$var$A3 + $cd3a6f7fbd655c4d$var$A4 * l2)) - y;
        fpy = $cd3a6f7fbd655c4d$var$A1 + 3 * $cd3a6f7fbd655c4d$var$A2 * l2 + l6 * (7 * $cd3a6f7fbd655c4d$var$A3 + 9 * $cd3a6f7fbd655c4d$var$A4 * l2);
        l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
        if ((0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(delta) < (0, $961dd5ad4f13a8be$export$92c06fba281fe81b)) break;
    }
    return [
        $cd3a6f7fbd655c4d$var$M * x * ($cd3a6f7fbd655c4d$var$A1 + 3 * $cd3a6f7fbd655c4d$var$A2 * l2 + l6 * (7 * $cd3a6f7fbd655c4d$var$A3 + 9 * $cd3a6f7fbd655c4d$var$A4 * l2)) / (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(l),
        (0, $961dd5ad4f13a8be$export$41726bdb1fc63f)((0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(l) / $cd3a6f7fbd655c4d$var$M)
    ];
};
function $cd3a6f7fbd655c4d$export$2e2bcd8739ae039() {
    return (0, $14becbff16fda383$export$2e2bcd8739ae039)($cd3a6f7fbd655c4d$export$a320734067e7a731).scale(177.158);
}






function $71b03ee498119038$export$dc8c6ddfc8b22c85(x, y) {
    var cy = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(y), k = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(x) * cy;
    return [
        cy * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(x) / k,
        (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(y) / k
    ];
}
$71b03ee498119038$export$dc8c6ddfc8b22c85.invert = (0, $a85930ef0ee224cc$export$3cee429f13e44eac)((0, $961dd5ad4f13a8be$export$628dc4eed22b0fbd));
function $71b03ee498119038$export$2e2bcd8739ae039() {
    return (0, $14becbff16fda383$export$2e2bcd8739ae039)($71b03ee498119038$export$dc8c6ddfc8b22c85).scale(144.049).clipAngle(60);
}







function $e205fe6c7cb8019c$export$2e2bcd8739ae039() {
    var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x0 = null, y0, x1, y1, kx = 1, ky = 1, transform = (0, $63e3e91a377016cd$export$6b468dcfb64c653c)({
        point: function(x, y) {
            var p = projection([
                x,
                y
            ]);
            this.stream.point(p[0], p[1]);
        }
    }), postclip = (0, $eea2e29c671b5324$export$2e2bcd8739ae039), cache, cacheStream;
    function reset() {
        kx = k * sx;
        ky = k * sy;
        cache = cacheStream = null;
        return projection;
    }
    function projection(p) {
        var x = p[0] * kx, y = p[1] * ky;
        if (alpha) {
            var t = y * ca - x * sa;
            x = x * ca + y * sa;
            y = t;
        }
        return [
            x + tx,
            y + ty
        ];
    }
    projection.invert = function(p) {
        var x = p[0] - tx, y = p[1] - ty;
        if (alpha) {
            var t = y * ca + x * sa;
            x = x * ca - y * sa;
            y = t;
        }
        return [
            x / kx,
            y / ky
        ];
    };
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $eea2e29c671b5324$export$2e2bcd8739ae039) : (0, $7ce1c7a535e2b6a2$export$2e2bcd8739ae039)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, reset()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [
            tx,
            ty
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, $961dd5ad4f13a8be$export$8449e153fbd325fc), sa = (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(alpha), ca = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(alpha), reset()) : alpha * (0, $961dd5ad4f13a8be$export$41fc368e1a942b97);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
    };
    projection.fitExtent = function(extent, object) {
        return (0, $33af29e7d3a9342b$export$e450184041869e7f)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $33af29e7d3a9342b$export$33a367fa1728c3ba)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $33af29e7d3a9342b$export$7d8f2192ef31c5a7)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $33af29e7d3a9342b$export$7069bab0d2ced675)(projection, height, object);
    };
    return projection;
}






function $07284b0851de8932$export$acb6def22fe878e6(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    return [
        lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
        phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
    ];
}
$07284b0851de8932$export$acb6def22fe878e6.invert = function(x, y) {
    var phi = y, i = 25, delta;
    do {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
    }while ((0, $961dd5ad4f13a8be$export$2335f513bbd82c6d)(delta) > (0, $961dd5ad4f13a8be$export$6c421550c66a327d) && --i > 0);
    return [
        x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
        phi
    ];
};
function $07284b0851de8932$export$2e2bcd8739ae039() {
    return (0, $14becbff16fda383$export$2e2bcd8739ae039)($07284b0851de8932$export$acb6def22fe878e6).scale(175.295);
}





function $fba3b3394aa72bf2$export$1cd9c2eb846182a(x, y) {
    return [
        (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(y) * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(x),
        (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(y)
    ];
}
$fba3b3394aa72bf2$export$1cd9c2eb846182a.invert = (0, $a85930ef0ee224cc$export$3cee429f13e44eac)((0, $961dd5ad4f13a8be$export$41726bdb1fc63f));
function $fba3b3394aa72bf2$export$2e2bcd8739ae039() {
    return (0, $14becbff16fda383$export$2e2bcd8739ae039)($fba3b3394aa72bf2$export$1cd9c2eb846182a).scale(249.5).clipAngle(90 + (0, $961dd5ad4f13a8be$export$6c421550c66a327d));
}





function $371bd064f4de910a$export$f9ccbb0dcb3dcd2b(x, y) {
    var cy = (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(y), k = 1 + (0, $961dd5ad4f13a8be$export$50d414a77b60d802)(x) * cy;
    return [
        cy * (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(x) / k,
        (0, $961dd5ad4f13a8be$export$5de3937cb4b592ed)(y) / k
    ];
}
$371bd064f4de910a$export$f9ccbb0dcb3dcd2b.invert = (0, $a85930ef0ee224cc$export$3cee429f13e44eac)(function(z) {
    return 2 * (0, $961dd5ad4f13a8be$export$628dc4eed22b0fbd)(z);
});
function $371bd064f4de910a$export$2e2bcd8739ae039() {
    return (0, $14becbff16fda383$export$2e2bcd8739ae039)($371bd064f4de910a$export$f9ccbb0dcb3dcd2b).scale(250).clipAngle(142);
}




function $cac52a2ef3cd5ffd$export$e84942adec6de533(lambda, phi) {
    return [
        (0, $961dd5ad4f13a8be$export$bef1f36f5486a6a3)((0, $961dd5ad4f13a8be$export$fcdd3b0b3246a325)(((0, $961dd5ad4f13a8be$export$e51408a300e8929a) + phi) / 2)),
        -lambda
    ];
}
$cac52a2ef3cd5ffd$export$e84942adec6de533.invert = function(x, y) {
    return [
        -y,
        2 * (0, $961dd5ad4f13a8be$export$628dc4eed22b0fbd)((0, $961dd5ad4f13a8be$export$b310ec824aaee37f)(x)) - (0, $961dd5ad4f13a8be$export$e51408a300e8929a)
    ];
};
function $cac52a2ef3cd5ffd$export$2e2bcd8739ae039() {
    var m = (0, $2368fe22dc039c7f$export$44b9b66a01f2127b)($cac52a2ef3cd5ffd$export$e84942adec6de533), center = m.center, rotate = m.rotate;
    m.center = function(_) {
        return arguments.length ? center([
            -_[1],
            _[0]
        ]) : (_ = center(), [
            _[1],
            -_[0]
        ]);
    };
    m.rotate = function(_) {
        return arguments.length ? rotate([
            _[0],
            _[1],
            _.length > 2 ? _[2] + 90 : 90
        ]) : (_ = rotate(), [
            _[0],
            _[1],
            _[2] - 90
        ]);
    };
    return rotate([
        0,
        0,
        90
    ]).scale(159.155);
}







var $01ddd7c46c96854e$exports = {};

$parcel$export($01ddd7c46c96854e$exports, "cluster", () => $8832cbaad4e9cf45$export$2e2bcd8739ae039);
$parcel$export($01ddd7c46c96854e$exports, "hierarchy", () => $54d6dcad589c67eb$export$2e2bcd8739ae039);
$parcel$export($01ddd7c46c96854e$exports, "Node", () => $54d6dcad589c67eb$export$85c928794f8d04d4);
$parcel$export($01ddd7c46c96854e$exports, "pack", () => $3f41cdbedc0d2d3d$export$2e2bcd8739ae039);
$parcel$export($01ddd7c46c96854e$exports, "packSiblings", () => $79631aa1ad5b1106$export$2e2bcd8739ae039);
$parcel$export($01ddd7c46c96854e$exports, "packEnclose", () => $b65fd33f0e5929d4$export$2e2bcd8739ae039);
$parcel$export($01ddd7c46c96854e$exports, "partition", () => $2c79297fb73fdcd8$export$2e2bcd8739ae039);
$parcel$export($01ddd7c46c96854e$exports, "stratify", () => $8977e266d4ce7ef5$export$2e2bcd8739ae039);
$parcel$export($01ddd7c46c96854e$exports, "tree", () => $e829340dfde6f30f$export$2e2bcd8739ae039);
$parcel$export($01ddd7c46c96854e$exports, "treemap", () => $2c88fa8bd63d6d86$export$2e2bcd8739ae039);
$parcel$export($01ddd7c46c96854e$exports, "treemapBinary", () => $b9740c63896bff3a$export$2e2bcd8739ae039);
$parcel$export($01ddd7c46c96854e$exports, "treemapDice", () => $70033ebae9657a87$export$2e2bcd8739ae039);
$parcel$export($01ddd7c46c96854e$exports, "treemapSlice", () => $6fcd651ff42d45a4$export$2e2bcd8739ae039);
$parcel$export($01ddd7c46c96854e$exports, "treemapSliceDice", () => $5a77b219d8b3416e$export$2e2bcd8739ae039);
$parcel$export($01ddd7c46c96854e$exports, "treemapSquarify", () => $51777e8b461a959f$export$2e2bcd8739ae039);
$parcel$export($01ddd7c46c96854e$exports, "treemapResquarify", () => $a442e3d7aceb6f87$export$2e2bcd8739ae039);
function $8832cbaad4e9cf45$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
function $8832cbaad4e9cf45$var$meanX(children) {
    return children.reduce($8832cbaad4e9cf45$var$meanXReduce, 0) / children.length;
}
function $8832cbaad4e9cf45$var$meanXReduce(x, c) {
    return x + c.x;
}
function $8832cbaad4e9cf45$var$maxY(children) {
    return 1 + children.reduce($8832cbaad4e9cf45$var$maxYReduce, 0);
}
function $8832cbaad4e9cf45$var$maxYReduce(y, c) {
    return Math.max(y, c.y);
}
function $8832cbaad4e9cf45$var$leafLeft(node) {
    var children;
    while(children = node.children)node = children[0];
    return node;
}
function $8832cbaad4e9cf45$var$leafRight(node) {
    var children;
    while(children = node.children)node = children[children.length - 1];
    return node;
}
function $8832cbaad4e9cf45$export$2e2bcd8739ae039() {
    var separation = $8832cbaad4e9cf45$var$defaultSeparation, dx = 1, dy = 1, nodeSize = false;
    function cluster(root) {
        var previousNode, x = 0;
        // First walk, computing the initial x & y values.
        root.eachAfter(function(node) {
            var children = node.children;
            if (children) {
                node.x = $8832cbaad4e9cf45$var$meanX(children);
                node.y = $8832cbaad4e9cf45$var$maxY(children);
            } else {
                node.x = previousNode ? x += separation(node, previousNode) : 0;
                node.y = 0;
                previousNode = node;
            }
        });
        var left = $8832cbaad4e9cf45$var$leafLeft(root), right = $8832cbaad4e9cf45$var$leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
        // Second walk, normalizing x & y to the desired size.
        return root.eachAfter(nodeSize ? function(node) {
            node.x = (node.x - root.x) * dx;
            node.y = (root.y - node.y) * dy;
        } : function(node) {
            node.x = (node.x - x0) / (x1 - x0) * dx;
            node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
        });
    }
    cluster.separation = function(x) {
        return arguments.length ? (separation = x, cluster) : separation;
    };
    cluster.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    cluster.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return cluster;
}


function $9831bd3c190966a7$var$count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}
function $9831bd3c190966a7$export$2e2bcd8739ae039() {
    return this.eachAfter($9831bd3c190966a7$var$count);
}


function $2900bf0b63fa8712$export$2e2bcd8739ae039(callback, that) {
    let index = -1;
    for (const node of this)callback.call(that, node, ++index, this);
    return this;
}


function $fb5640d9fbe03a76$export$2e2bcd8739ae039(callback, that) {
    var node = this, nodes = [
        node
    ], children, i, index = -1;
    while(node = nodes.pop()){
        callback.call(that, node, ++index, this);
        if (children = node.children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
    }
    return this;
}


function $0a1d02fd367fc14c$export$2e2bcd8739ae039(callback, that) {
    var node = this, nodes = [
        node
    ], next = [], children, i, n, index = -1;
    while(node = nodes.pop()){
        next.push(node);
        if (children = node.children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
    }
    while(node = next.pop())callback.call(that, node, ++index, this);
    return this;
}


function $54f8f7f78ce6a65f$export$2e2bcd8739ae039(callback, that) {
    let index = -1;
    for (const node of this){
        if (callback.call(that, node, ++index, this)) return node;
    }
}


function $8f57fc6b25c383bf$export$2e2bcd8739ae039(value) {
    return this.eachAfter(function(node) {
        var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
        while(--i >= 0)sum += children[i].value;
        node.value = sum;
    });
}


function $15f83702e27e2f4b$export$2e2bcd8739ae039(compare) {
    return this.eachBefore(function(node) {
        if (node.children) node.children.sort(compare);
    });
}


function $16d8144e12d235e1$export$2e2bcd8739ae039(end) {
    var start = this, ancestor = $16d8144e12d235e1$var$leastCommonAncestor(start, end), nodes = [
        start
    ];
    while(start !== ancestor){
        start = start.parent;
        nodes.push(start);
    }
    var k = nodes.length;
    while(end !== ancestor){
        nodes.splice(k, 0, end);
        end = end.parent;
    }
    return nodes;
}
function $16d8144e12d235e1$var$leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}


function $75245d081d253cd2$export$2e2bcd8739ae039() {
    var node = this, nodes = [
        node
    ];
    while(node = node.parent)nodes.push(node);
    return nodes;
}


function $3cb5ba580460e75f$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $a2c6cbe58023f413$export$2e2bcd8739ae039() {
    var leaves = [];
    this.eachBefore(function(node) {
        if (!node.children) leaves.push(node);
    });
    return leaves;
}


function $bf75bc5fc0788e83$export$2e2bcd8739ae039() {
    var root = this, links = [];
    root.each(function(node) {
        if (node !== root) links.push({
            source: node.parent,
            target: node
        });
    });
    return links;
}


function* $7642fbe9b8e6bc77$export$2e2bcd8739ae039() {
    var node = this, current, next = [
        node
    ], children, i, n;
    do {
        current = next.reverse(), next = [];
        while(node = current.pop()){
            yield node;
            if (children = node.children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
        }
    }while (next.length);
}


function $54d6dcad589c67eb$export$2e2bcd8739ae039(data, children) {
    if (data instanceof Map) {
        data = [
            undefined,
            data
        ];
        if (children === undefined) children = $54d6dcad589c67eb$var$mapChildren;
    } else if (children === undefined) children = $54d6dcad589c67eb$var$objectChildren;
    var root = new $54d6dcad589c67eb$export$85c928794f8d04d4(data), node, nodes = [
        root
    ], child, childs, i, n;
    while(node = nodes.pop())if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
        node.children = childs;
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = childs[i] = new $54d6dcad589c67eb$export$85c928794f8d04d4(childs[i]));
            child.parent = node;
            child.depth = node.depth + 1;
        }
    }
    return root.eachBefore($54d6dcad589c67eb$export$5af32d52ab5dfd57);
}
function $54d6dcad589c67eb$var$node_copy() {
    return $54d6dcad589c67eb$export$2e2bcd8739ae039(this).eachBefore($54d6dcad589c67eb$var$copyData);
}
function $54d6dcad589c67eb$var$objectChildren(d) {
    return d.children;
}
function $54d6dcad589c67eb$var$mapChildren(d) {
    return Array.isArray(d) ? d[1] : null;
}
function $54d6dcad589c67eb$var$copyData(node) {
    if (node.data.value !== undefined) node.value = node.data.value;
    node.data = node.data.data;
}
function $54d6dcad589c67eb$export$5af32d52ab5dfd57(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function $54d6dcad589c67eb$export$85c928794f8d04d4(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
$54d6dcad589c67eb$export$85c928794f8d04d4.prototype = $54d6dcad589c67eb$export$2e2bcd8739ae039.prototype = {
    constructor: $54d6dcad589c67eb$export$85c928794f8d04d4,
    count: (0, $9831bd3c190966a7$export$2e2bcd8739ae039),
    each: (0, $2900bf0b63fa8712$export$2e2bcd8739ae039),
    eachAfter: (0, $0a1d02fd367fc14c$export$2e2bcd8739ae039),
    eachBefore: (0, $fb5640d9fbe03a76$export$2e2bcd8739ae039),
    find: (0, $54f8f7f78ce6a65f$export$2e2bcd8739ae039),
    sum: (0, $8f57fc6b25c383bf$export$2e2bcd8739ae039),
    sort: (0, $15f83702e27e2f4b$export$2e2bcd8739ae039),
    path: (0, $16d8144e12d235e1$export$2e2bcd8739ae039),
    ancestors: (0, $75245d081d253cd2$export$2e2bcd8739ae039),
    descendants: (0, $3cb5ba580460e75f$export$2e2bcd8739ae039),
    leaves: (0, $a2c6cbe58023f413$export$2e2bcd8739ae039),
    links: (0, $bf75bc5fc0788e83$export$2e2bcd8739ae039),
    copy: $54d6dcad589c67eb$var$node_copy,
    [Symbol.iterator]: (0, $7642fbe9b8e6bc77$export$2e2bcd8739ae039)
};


function $2b40bbc713c858e1$export$516e28dec6a4b6d4(f) {
    return f == null ? null : $2b40bbc713c858e1$export$a7a0278c004aac3f(f);
}
function $2b40bbc713c858e1$export$a7a0278c004aac3f(f) {
    if (typeof f !== "function") throw new Error;
    return f;
}


function $bd0792977f613bd5$export$99e2e371aa6a9db() {
    return 0;
}
function $bd0792977f613bd5$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $006a2d9bed5f39e4$var$a = 1664525;
const $006a2d9bed5f39e4$var$c = 1013904223;
const $006a2d9bed5f39e4$var$m = 4294967296; // 2^32
function $006a2d9bed5f39e4$export$2e2bcd8739ae039() {
    let s = 1;
    return ()=>(s = ($006a2d9bed5f39e4$var$a * s + $006a2d9bed5f39e4$var$c) % $006a2d9bed5f39e4$var$m) / $006a2d9bed5f39e4$var$m;
}


function $6a8f15062547de21$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}
function $6a8f15062547de21$export$448332262467e042(array, random) {
    let m = array.length, t, i;
    while(m){
        i = random() * m-- | 0;
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}





function $b65fd33f0e5929d4$export$2e2bcd8739ae039(circles) {
    return $b65fd33f0e5929d4$export$55712536b4d8ce73(circles, (0, $006a2d9bed5f39e4$export$2e2bcd8739ae039)());
}
function $b65fd33f0e5929d4$export$55712536b4d8ce73(circles, random) {
    var i = 0, n = (circles = (0, $6a8f15062547de21$export$448332262467e042)(Array.from(circles), random)).length, B = [], p, e;
    while(i < n){
        p = circles[i];
        if (e && $b65fd33f0e5929d4$var$enclosesWeak(e, p)) ++i;
        else e = $b65fd33f0e5929d4$var$encloseBasis(B = $b65fd33f0e5929d4$var$extendBasis(B, p)), i = 0;
    }
    return e;
}
function $b65fd33f0e5929d4$var$extendBasis(B, p) {
    var i, j;
    if ($b65fd33f0e5929d4$var$enclosesWeakAll(p, B)) return [
        p
    ];
    // If we get here then B must have at least one element.
    for(i = 0; i < B.length; ++i){
        if ($b65fd33f0e5929d4$var$enclosesNot(p, B[i]) && $b65fd33f0e5929d4$var$enclosesWeakAll($b65fd33f0e5929d4$var$encloseBasis2(B[i], p), B)) return [
            B[i],
            p
        ];
    }
    // If we get here then B must have at least two elements.
    for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
        if ($b65fd33f0e5929d4$var$enclosesNot($b65fd33f0e5929d4$var$encloseBasis2(B[i], B[j]), p) && $b65fd33f0e5929d4$var$enclosesNot($b65fd33f0e5929d4$var$encloseBasis2(B[i], p), B[j]) && $b65fd33f0e5929d4$var$enclosesNot($b65fd33f0e5929d4$var$encloseBasis2(B[j], p), B[i]) && $b65fd33f0e5929d4$var$enclosesWeakAll($b65fd33f0e5929d4$var$encloseBasis3(B[i], B[j], p), B)) return [
            B[i],
            B[j],
            p
        ];
    }
    // If we get here then something is very wrong.
    throw new Error;
}
function $b65fd33f0e5929d4$var$enclosesNot(a, b) {
    var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function $b65fd33f0e5929d4$var$enclosesWeak(a, b) {
    var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $b65fd33f0e5929d4$var$enclosesWeakAll(a, B) {
    for(var i = 0; i < B.length; ++i){
        if (!$b65fd33f0e5929d4$var$enclosesWeak(a, B[i])) return false;
    }
    return true;
}
function $b65fd33f0e5929d4$var$encloseBasis(B) {
    switch(B.length){
        case 1:
            return $b65fd33f0e5929d4$var$encloseBasis1(B[0]);
        case 2:
            return $b65fd33f0e5929d4$var$encloseBasis2(B[0], B[1]);
        case 3:
            return $b65fd33f0e5929d4$var$encloseBasis3(B[0], B[1], B[2]);
    }
}
function $b65fd33f0e5929d4$var$encloseBasis1(a) {
    return {
        x: a.x,
        y: a.y,
        r: a.r
    };
}
function $b65fd33f0e5929d4$var$encloseBasis2(a, b) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
        x: (x1 + x2 + x21 / l * r21) / 2,
        y: (y1 + y2 + y21 / l * r21) / 2,
        r: (l + r1 + r2) / 2
    };
}
function $b65fd33f0e5929d4$var$encloseBasis3(a, b, c) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(Math.abs(A) > 1e-6 ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
        x: x1 + xa + xb * r,
        y: y1 + ya + yb * r,
        r: r
    };
}


function $79631aa1ad5b1106$var$place(b, a, c) {
    var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
    if (d2) {
        a2 = a.r + c.r, a2 *= a2;
        b2 = b.r + c.r, b2 *= b2;
        if (a2 > b2) {
            x = (d2 + b2 - a2) / (2 * d2);
            y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
            c.x = b.x - x * dx - y * dy;
            c.y = b.y - x * dy + y * dx;
        } else {
            x = (d2 + a2 - b2) / (2 * d2);
            y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
            c.x = a.x + x * dx - y * dy;
            c.y = a.y + x * dy + y * dx;
        }
    } else {
        c.x = a.x + c.r;
        c.y = a.y;
    }
}
function $79631aa1ad5b1106$var$intersects(a, b) {
    var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $79631aa1ad5b1106$var$score(node) {
    var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
}
function $79631aa1ad5b1106$var$Node(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
}
function $79631aa1ad5b1106$export$5390336473d877c8(circles, random) {
    if (!(n = (circles = (0, $6a8f15062547de21$export$2e2bcd8739ae039)(circles)).length)) return 0;
    var a, b, c, n, aa, ca, i, j, k, sj, sk;
    // Place the first circle.
    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r;
    // Place the second circle.
    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r;
    // Place the third circle.
    $79631aa1ad5b1106$var$place(b, a, c = circles[2]);
    // Initialize the front-chain using the first three circles a, b and c.
    a = new $79631aa1ad5b1106$var$Node(a), b = new $79631aa1ad5b1106$var$Node(b), c = new $79631aa1ad5b1106$var$Node(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a;
    // Attempt to place each remaining circle…
    pack: for(i = 3; i < n; ++i){
        $79631aa1ad5b1106$var$place(a._, b._, c = circles[i]), c = new $79631aa1ad5b1106$var$Node(c);
        // Find the closest intersecting circle on the front-chain, if any.
        // “Closeness” is determined by linear distance along the front-chain.
        // “Ahead” or “behind” is likewise determined by linear distance.
        j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
        do if (sj <= sk) {
            if ($79631aa1ad5b1106$var$intersects(j._, c._)) {
                b = j, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sj += j._.r, j = j.next;
        } else {
            if ($79631aa1ad5b1106$var$intersects(k._, c._)) {
                a = k, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sk += k._.r, k = k.previous;
        }
        while (j !== k.next);
        // Success! Insert the new circle c between a and b.
        c.previous = a, c.next = b, a.next = b.previous = b = c;
        // Compute the new closest circle pair to the centroid.
        aa = $79631aa1ad5b1106$var$score(a);
        while((c = c.next) !== b)if ((ca = $79631aa1ad5b1106$var$score(c)) < aa) a = c, aa = ca;
        b = a.next;
    }
    // Compute the enclosing circle of the front chain.
    a = [
        b._
    ], c = b;
    while((c = c.next) !== b)a.push(c._);
    c = (0, $b65fd33f0e5929d4$export$55712536b4d8ce73)(a, random);
    // Translate the circles to put the enclosing circle around the origin.
    for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
    return c.r;
}
function $79631aa1ad5b1106$export$2e2bcd8739ae039(circles) {
    $79631aa1ad5b1106$export$5390336473d877c8(circles, (0, $006a2d9bed5f39e4$export$2e2bcd8739ae039)());
    return circles;
}


function $3f41cdbedc0d2d3d$var$defaultRadius(d) {
    return Math.sqrt(d.value);
}
function $3f41cdbedc0d2d3d$export$2e2bcd8739ae039() {
    var radius = null, dx = 1, dy = 1, padding = (0, $bd0792977f613bd5$export$99e2e371aa6a9db);
    function pack(root) {
        const random = (0, $006a2d9bed5f39e4$export$2e2bcd8739ae039)();
        root.x = dx / 2, root.y = dy / 2;
        if (radius) root.eachBefore($3f41cdbedc0d2d3d$var$radiusLeaf(radius)).eachAfter($3f41cdbedc0d2d3d$var$packChildrenRandom(padding, 0.5, random)).eachBefore($3f41cdbedc0d2d3d$var$translateChild(1));
        else root.eachBefore($3f41cdbedc0d2d3d$var$radiusLeaf($3f41cdbedc0d2d3d$var$defaultRadius)).eachAfter($3f41cdbedc0d2d3d$var$packChildrenRandom((0, $bd0792977f613bd5$export$99e2e371aa6a9db), 1, random)).eachAfter($3f41cdbedc0d2d3d$var$packChildrenRandom(padding, root.r / Math.min(dx, dy), random)).eachBefore($3f41cdbedc0d2d3d$var$translateChild(Math.min(dx, dy) / (2 * root.r)));
        return root;
    }
    pack.radius = function(x) {
        return arguments.length ? (radius = (0, $2b40bbc713c858e1$export$516e28dec6a4b6d4)(x), pack) : radius;
    };
    pack.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
            dx,
            dy
        ];
    };
    pack.padding = function(x) {
        return arguments.length ? (padding = typeof x === "function" ? x : (0, $bd0792977f613bd5$export$2e2bcd8739ae039)(+x), pack) : padding;
    };
    return pack;
}
function $3f41cdbedc0d2d3d$var$radiusLeaf(radius) {
    return function(node) {
        if (!node.children) node.r = Math.max(0, +radius(node) || 0);
    };
}
function $3f41cdbedc0d2d3d$var$packChildrenRandom(padding, k, random) {
    return function(node) {
        if (children = node.children) {
            var children, i, n = children.length, r = padding(node) * k || 0, e;
            if (r) for(i = 0; i < n; ++i)children[i].r += r;
            e = (0, $79631aa1ad5b1106$export$5390336473d877c8)(children, random);
            if (r) for(i = 0; i < n; ++i)children[i].r -= r;
            node.r = e + r;
        }
    };
}
function $3f41cdbedc0d2d3d$var$translateChild(k) {
    return function(node) {
        var parent = node.parent;
        node.r *= k;
        if (parent) {
            node.x = parent.x + k * node.x;
            node.y = parent.y + k * node.y;
        }
    };
}




function $c3f195bcd4612226$export$2e2bcd8739ae039(node) {
    node.x0 = Math.round(node.x0);
    node.y0 = Math.round(node.y0);
    node.x1 = Math.round(node.x1);
    node.y1 = Math.round(node.y1);
}


function $70033ebae9657a87$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
    while(++i < n){
        node = nodes[i], node.y0 = y0, node.y1 = y1;
        node.x0 = x0, node.x1 = x0 += node.value * k;
    }
}


function $2c79297fb73fdcd8$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, padding = 0, round = false;
    function partition(root) {
        var n = root.height + 1;
        root.x0 = root.y0 = padding;
        root.x1 = dx;
        root.y1 = dy / n;
        root.eachBefore(positionNode(dy, n));
        if (round) root.eachBefore((0, $c3f195bcd4612226$export$2e2bcd8739ae039));
        return root;
    }
    function positionNode(dy, n) {
        return function(node) {
            if (node.children) (0, $70033ebae9657a87$export$2e2bcd8739ae039)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
            var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
        };
    }
    partition.round = function(x) {
        return arguments.length ? (round = !!x, partition) : round;
    };
    partition.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
            dx,
            dy
        ];
    };
    partition.padding = function(x) {
        return arguments.length ? (padding = +x, partition) : padding;
    };
    return partition;
}




var $8977e266d4ce7ef5$var$preroot = {
    depth: -1
}, $8977e266d4ce7ef5$var$ambiguous = {}, $8977e266d4ce7ef5$var$imputed = {};
function $8977e266d4ce7ef5$var$defaultId(d) {
    return d.id;
}
function $8977e266d4ce7ef5$var$defaultParentId(d) {
    return d.parentId;
}
function $8977e266d4ce7ef5$export$2e2bcd8739ae039() {
    var id = $8977e266d4ce7ef5$var$defaultId, parentId = $8977e266d4ce7ef5$var$defaultParentId, path;
    function stratify(data) {
        var nodes = Array.from(data), currentId = id, currentParentId = parentId, n, d, i, root, parent, node, nodeId, nodeKey, nodeByKey = new Map;
        if (path != null) {
            const I = nodes.map((d, i)=>$8977e266d4ce7ef5$var$normalize(path(d, i, data)));
            const P = I.map($8977e266d4ce7ef5$var$parentof);
            const S = new Set(I).add("");
            for (const i of P)if (!S.has(i)) {
                S.add(i);
                I.push(i);
                P.push($8977e266d4ce7ef5$var$parentof(i));
                nodes.push($8977e266d4ce7ef5$var$imputed);
            }
            currentId = (_, i)=>I[i];
            currentParentId = (_, i)=>P[i];
        }
        for(i = 0, n = nodes.length; i < n; ++i){
            d = nodes[i], node = nodes[i] = new (0, $54d6dcad589c67eb$export$85c928794f8d04d4)(d);
            if ((nodeId = currentId(d, i, data)) != null && (nodeId += "")) {
                nodeKey = node.id = nodeId;
                nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? $8977e266d4ce7ef5$var$ambiguous : node);
            }
            if ((nodeId = currentParentId(d, i, data)) != null && (nodeId += "")) node.parent = nodeId;
        }
        for(i = 0; i < n; ++i){
            node = nodes[i];
            if (nodeId = node.parent) {
                parent = nodeByKey.get(nodeId);
                if (!parent) throw new Error("missing: " + nodeId);
                if (parent === $8977e266d4ce7ef5$var$ambiguous) throw new Error("ambiguous: " + nodeId);
                if (parent.children) parent.children.push(node);
                else parent.children = [
                    node
                ];
                node.parent = parent;
            } else {
                if (root) throw new Error("multiple roots");
                root = node;
            }
        }
        if (!root) throw new Error("no root");
        // When imputing internal nodes, only introduce roots if needed.
        // Then replace the imputed marker data with null.
        if (path != null) {
            while(root.data === $8977e266d4ce7ef5$var$imputed && root.children.length === 1)root = root.children[0], --n;
            for(let i = nodes.length - 1; i >= 0; --i){
                node = nodes[i];
                if (node.data !== $8977e266d4ce7ef5$var$imputed) break;
                node.data = null;
            }
        }
        root.parent = $8977e266d4ce7ef5$var$preroot;
        root.eachBefore(function(node) {
            node.depth = node.parent.depth + 1;
            --n;
        }).eachBefore((0, $54d6dcad589c67eb$export$5af32d52ab5dfd57));
        root.parent = null;
        if (n > 0) throw new Error("cycle");
        return root;
    }
    stratify.id = function(x) {
        return arguments.length ? (id = (0, $2b40bbc713c858e1$export$516e28dec6a4b6d4)(x), stratify) : id;
    };
    stratify.parentId = function(x) {
        return arguments.length ? (parentId = (0, $2b40bbc713c858e1$export$516e28dec6a4b6d4)(x), stratify) : parentId;
    };
    stratify.path = function(x) {
        return arguments.length ? (path = (0, $2b40bbc713c858e1$export$516e28dec6a4b6d4)(x), stratify) : path;
    };
    return stratify;
}
// To normalize a path, we coerce to a string, strip the trailing slash if any
// (as long as the trailing slash is not immediately preceded by another slash),
// and add leading slash if missing.
function $8977e266d4ce7ef5$var$normalize(path) {
    path = `${path}`;
    let i = path.length;
    if ($8977e266d4ce7ef5$var$slash(path, i - 1) && !$8977e266d4ce7ef5$var$slash(path, i - 2)) path = path.slice(0, -1);
    return path[0] === "/" ? path : `/${path}`;
}
// Walk backwards to find the first slash that is not the leading slash, e.g.:
// "/foo/bar" ⇥ "/foo", "/foo" ⇥ "/", "/" ↦ "". (The root is special-cased
// because the id of the root must be a truthy value.)
function $8977e266d4ce7ef5$var$parentof(path) {
    let i = path.length;
    if (i < 2) return "";
    while(--i > 1)if ($8977e266d4ce7ef5$var$slash(path, i)) break;
    return path.slice(0, i);
}
// Slashes can be escaped; to determine whether a slash is a path delimiter, we
// count the number of preceding backslashes escaping the forward slash: an odd
// number indicates an escaped forward slash.
function $8977e266d4ce7ef5$var$slash(path, i) {
    if (path[i] === "/") {
        let k = 0;
        while(i > 0 && path[--i] === "\\")++k;
        if ((k & 1) === 0) return true;
    }
    return false;
}



function $e829340dfde6f30f$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }
// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function $e829340dfde6f30f$var$nextLeft(v) {
    var children = v.children;
    return children ? children[0] : v.t;
}
// This function works analogously to nextLeft.
function $e829340dfde6f30f$var$nextRight(v) {
    var children = v.children;
    return children ? children[children.length - 1] : v.t;
}
// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function $e829340dfde6f30f$var$moveSubtree(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
}
// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function $e829340dfde6f30f$var$executeShifts(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while(--i >= 0){
        w = children[i];
        w.z += shift;
        w.m += shift;
        shift += w.s + (change += w.c);
    }
}
// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function $e829340dfde6f30f$var$nextAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
}
function $e829340dfde6f30f$var$TreeNode(node, i) {
    this._ = node;
    this.parent = null;
    this.children = null;
    this.A = null; // default ancestor
    this.a = this; // ancestor
    this.z = 0; // prelim
    this.m = 0; // mod
    this.c = 0; // change
    this.s = 0; // shift
    this.t = null; // thread
    this.i = i; // number
}
$e829340dfde6f30f$var$TreeNode.prototype = Object.create((0, $54d6dcad589c67eb$export$85c928794f8d04d4).prototype);
function $e829340dfde6f30f$var$treeRoot(root) {
    var tree = new $e829340dfde6f30f$var$TreeNode(root, 0), node, nodes = [
        tree
    ], child, children, i, n;
    while(node = nodes.pop())if (children = node._.children) {
        node.children = new Array(n = children.length);
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = node.children[i] = new $e829340dfde6f30f$var$TreeNode(children[i], i));
            child.parent = node;
        }
    }
    (tree.parent = new $e829340dfde6f30f$var$TreeNode(null, 0)).children = [
        tree
    ];
    return tree;
}
function $e829340dfde6f30f$export$2e2bcd8739ae039() {
    var separation = $e829340dfde6f30f$var$defaultSeparation, dx = 1, dy = 1, nodeSize = null;
    function tree(root) {
        var t = $e829340dfde6f30f$var$treeRoot(root);
        // Compute the layout using Buchheim et al.’s algorithm.
        t.eachAfter(firstWalk), t.parent.m = -t.z;
        t.eachBefore(secondWalk);
        // If a fixed node size is specified, scale x and y.
        if (nodeSize) root.eachBefore(sizeNode);
        else {
            var left = root, right = root, bottom = root;
            root.eachBefore(function(node) {
                if (node.x < left.x) left = node;
                if (node.x > right.x) right = node;
                if (node.depth > bottom.depth) bottom = node;
            });
            var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
            root.eachBefore(function(node) {
                node.x = (node.x + tx) * kx;
                node.y = node.depth * ky;
            });
        }
        return root;
    }
    // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
    // applied recursively to the children of v, as well as the function
    // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
    // node v is placed to the midpoint of its outermost children.
    function firstWalk(v) {
        var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
        if (children) {
            $e829340dfde6f30f$var$executeShifts(v);
            var midpoint = (children[0].z + children[children.length - 1].z) / 2;
            if (w) {
                v.z = w.z + separation(v._, w._);
                v.m = v.z - midpoint;
            } else v.z = midpoint;
        } else if (w) v.z = w.z + separation(v._, w._);
        v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    // Computes all real x-coordinates by summing up the modifiers recursively.
    function secondWalk(v) {
        v._.x = v.z + v.parent.m;
        v.m += v.parent.m;
    }
    // The core of the algorithm. Here, a new subtree is combined with the
    // previous subtrees. Threads are used to traverse the inside and outside
    // contours of the left and right subtree up to the highest common level. The
    // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
    // superscript o means outside and i means inside, the subscript - means left
    // subtree and + means right subtree. For summing up the modifiers along the
    // contour, we use respective variables si+, si-, so-, and so+. Whenever two
    // nodes of the inside contours conflict, we compute the left one of the
    // greatest uncommon ancestors using the function ANCESTOR and call MOVE
    // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
    // Finally, we add a new thread (if necessary).
    function apportion(v, w, ancestor) {
        if (w) {
            var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
            while(vim = $e829340dfde6f30f$var$nextRight(vim), vip = $e829340dfde6f30f$var$nextLeft(vip), vim && vip){
                vom = $e829340dfde6f30f$var$nextLeft(vom);
                vop = $e829340dfde6f30f$var$nextRight(vop);
                vop.a = v;
                shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                if (shift > 0) {
                    $e829340dfde6f30f$var$moveSubtree($e829340dfde6f30f$var$nextAncestor(vim, v, ancestor), v, shift);
                    sip += shift;
                    sop += shift;
                }
                sim += vim.m;
                sip += vip.m;
                som += vom.m;
                sop += vop.m;
            }
            if (vim && !$e829340dfde6f30f$var$nextRight(vop)) {
                vop.t = vim;
                vop.m += sim - sop;
            }
            if (vip && !$e829340dfde6f30f$var$nextLeft(vom)) {
                vom.t = vip;
                vom.m += sip - som;
                ancestor = v;
            }
        }
        return ancestor;
    }
    function sizeNode(node) {
        node.x *= dx;
        node.y = node.depth * dy;
    }
    tree.separation = function(x) {
        return arguments.length ? (separation = x, tree) : separation;
    };
    tree.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    tree.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return tree;
}




function $6fcd651ff42d45a4$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
    while(++i < n){
        node = nodes[i], node.x0 = x0, node.x1 = x1;
        node.y0 = y0, node.y1 = y0 += node.value * k;
    }
}


var $51777e8b461a959f$export$324943737027944a = (1 + Math.sqrt(5)) / 2;
function $51777e8b461a959f$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, $70033ebae9657a87$export$2e2bcd8739ae039)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, $6fcd651ff42d45a4$export$2e2bcd8739ae039)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
var $51777e8b461a959f$export$2e2bcd8739ae039 = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        $51777e8b461a959f$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}($51777e8b461a959f$export$324943737027944a);




function $2c88fa8bd63d6d86$export$2e2bcd8739ae039() {
    var tile = (0, $51777e8b461a959f$export$2e2bcd8739ae039), round = false, dx = 1, dy = 1, paddingStack = [
        0
    ], paddingInner = (0, $bd0792977f613bd5$export$99e2e371aa6a9db), paddingTop = (0, $bd0792977f613bd5$export$99e2e371aa6a9db), paddingRight = (0, $bd0792977f613bd5$export$99e2e371aa6a9db), paddingBottom = (0, $bd0792977f613bd5$export$99e2e371aa6a9db), paddingLeft = (0, $bd0792977f613bd5$export$99e2e371aa6a9db);
    function treemap(root) {
        root.x0 = root.y0 = 0;
        root.x1 = dx;
        root.y1 = dy;
        root.eachBefore(positionNode);
        paddingStack = [
            0
        ];
        if (round) root.eachBefore((0, $c3f195bcd4612226$export$2e2bcd8739ae039));
        return root;
    }
    function positionNode(node) {
        var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
        if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
        if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
        node.x0 = x0;
        node.y0 = y0;
        node.x1 = x1;
        node.y1 = y1;
        if (node.children) {
            p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
            x0 += paddingLeft(node) - p;
            y0 += paddingTop(node) - p;
            x1 -= paddingRight(node) - p;
            y1 -= paddingBottom(node) - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            tile(node, x0, y0, x1, y1);
        }
    }
    treemap.round = function(x) {
        return arguments.length ? (round = !!x, treemap) : round;
    };
    treemap.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
            dx,
            dy
        ];
    };
    treemap.tile = function(x) {
        return arguments.length ? (tile = (0, $2b40bbc713c858e1$export$a7a0278c004aac3f)(x), treemap) : tile;
    };
    treemap.padding = function(x) {
        return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
    };
    treemap.paddingInner = function(x) {
        return arguments.length ? (paddingInner = typeof x === "function" ? x : (0, $bd0792977f613bd5$export$2e2bcd8739ae039)(+x), treemap) : paddingInner;
    };
    treemap.paddingOuter = function(x) {
        return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
    };
    treemap.paddingTop = function(x) {
        return arguments.length ? (paddingTop = typeof x === "function" ? x : (0, $bd0792977f613bd5$export$2e2bcd8739ae039)(+x), treemap) : paddingTop;
    };
    treemap.paddingRight = function(x) {
        return arguments.length ? (paddingRight = typeof x === "function" ? x : (0, $bd0792977f613bd5$export$2e2bcd8739ae039)(+x), treemap) : paddingRight;
    };
    treemap.paddingBottom = function(x) {
        return arguments.length ? (paddingBottom = typeof x === "function" ? x : (0, $bd0792977f613bd5$export$2e2bcd8739ae039)(+x), treemap) : paddingBottom;
    };
    treemap.paddingLeft = function(x) {
        return arguments.length ? (paddingLeft = typeof x === "function" ? x : (0, $bd0792977f613bd5$export$2e2bcd8739ae039)(+x), treemap) : paddingLeft;
    };
    return treemap;
}


function $b9740c63896bff3a$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
    for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
    partition(0, n, parent.value, x0, y0, x1, y1);
    function partition(i, j, value, x0, y0, x1, y1) {
        if (i >= j - 1) {
            var node = nodes[i];
            node.x0 = x0, node.y0 = y0;
            node.x1 = x1, node.y1 = y1;
            return;
        }
        var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
        while(k < hi){
            var mid = k + hi >>> 1;
            if (sums[mid] < valueTarget) k = mid + 1;
            else hi = mid;
        }
        if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
        var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
        if (x1 - x0 > y1 - y0) {
            var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
            partition(i, k, valueLeft, x0, y0, xk, y1);
            partition(k, j, valueRight, xk, y0, x1, y1);
        } else {
            var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
            partition(i, k, valueLeft, x0, y0, x1, yk);
            partition(k, j, valueRight, x0, yk, x1, y1);
        }
    }
}






function $5a77b219d8b3416e$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    (parent.depth & 1 ? (0, $6fcd651ff42d45a4$export$2e2bcd8739ae039) : (0, $70033ebae9657a87$export$2e2bcd8739ae039))(parent, x0, y0, x1, y1);
}






var $a442e3d7aceb6f87$export$2e2bcd8739ae039 = function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
            var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
            while(++j < m){
                row = rows[j], nodes = row.children;
                for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                if (row.dice) (0, $70033ebae9657a87$export$2e2bcd8739ae039)(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);
                else (0, $6fcd651ff42d45a4$export$2e2bcd8739ae039)(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
                value -= row.value;
            }
        } else {
            parent._squarify = rows = (0, $51777e8b461a959f$export$9ff1217655212093)(ratio, parent, x0, y0, x1, y1);
            rows.ratio = ratio;
        }
    }
    resquarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return resquarify;
}((0, $51777e8b461a959f$export$324943737027944a));




var $1a65dff94eccdd27$exports = {};

$parcel$export($1a65dff94eccdd27$exports, "interpolate", () => $fdef680a1ac134b1$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateArray", () => $08bd73eb67b4a221$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateBasis", () => $4102a56c61d8399a$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateBasisClosed", () => $b3f75379502ead17$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateDate", () => $91f1193a05630492$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateDiscrete", () => $11b2437a0efa0cca$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateHue", () => $14c3401f4871b9ea$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateNumber", () => $aa9385f41bac0020$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateNumberArray", () => $96579e3589354e98$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateObject", () => $bbe5d1c2c2bbd2fa$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateRound", () => $56f517ab42b48aac$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateString", () => $18136aa94f9d1484$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateTransformCss", () => $d32f3373a01276ef$export$56bec7123bb3589a);
$parcel$export($1a65dff94eccdd27$exports, "interpolateTransformSvg", () => $d32f3373a01276ef$export$da8cba906d64c082);
$parcel$export($1a65dff94eccdd27$exports, "interpolateZoom", () => $5e05683ac1cc2c47$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateRgb", () => $71264ae493339a33$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateRgbBasis", () => $71264ae493339a33$export$2c0e28f2e2852d3f);
$parcel$export($1a65dff94eccdd27$exports, "interpolateRgbBasisClosed", () => $71264ae493339a33$export$53d5214f625ccd4c);
$parcel$export($1a65dff94eccdd27$exports, "interpolateHsl", () => $6ec6c68391f837fb$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateHslLong", () => $6ec6c68391f837fb$export$a2c535e270a59256);
$parcel$export($1a65dff94eccdd27$exports, "interpolateLab", () => $3cedd46d4e3bec48$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateHcl", () => $7bf4978f325a1eba$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateHclLong", () => $7bf4978f325a1eba$export$5aaa50f7615f9b70);
$parcel$export($1a65dff94eccdd27$exports, "interpolateCubehelix", () => $71cfe7fab883bd8a$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "interpolateCubehelixLong", () => $71cfe7fab883bd8a$export$934fa09ad474a1b4);
$parcel$export($1a65dff94eccdd27$exports, "piecewise", () => $2adf3d3588dadf1c$export$2e2bcd8739ae039);
$parcel$export($1a65dff94eccdd27$exports, "quantize", () => $e3442d6cef607317$export$2e2bcd8739ae039);





function $11b2437a0efa0cca$export$2e2bcd8739ae039(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}



function $14c3401f4871b9ea$export$2e2bcd8739ae039(a, b) {
    var i = (0, $52257f64b25d794c$export$97d7b0c7ddb78dcf)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}





function $56f517ab42b48aac$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}




var $5e05683ac1cc2c47$var$epsilon2 = 1e-12;
function $5e05683ac1cc2c47$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $5e05683ac1cc2c47$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $5e05683ac1cc2c47$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $5e05683ac1cc2c47$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $5e05683ac1cc2c47$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $5e05683ac1cc2c47$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $5e05683ac1cc2c47$var$tanh(rho * s + r0) - $5e05683ac1cc2c47$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $5e05683ac1cc2c47$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);




var $gisW9 = parcelRequire("gisW9");

function $6ec6c68391f837fb$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $gisW9.hsl)(start)).h, (end = (0, $gisW9.hsl)(end)).h), s = (0, $52257f64b25d794c$export$2e2bcd8739ae039)(start.s, end.s), l = (0, $52257f64b25d794c$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $52257f64b25d794c$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $6ec6c68391f837fb$export$2e2bcd8739ae039 = $6ec6c68391f837fb$var$hsl((0, $52257f64b25d794c$export$97d7b0c7ddb78dcf));
var $6ec6c68391f837fb$export$a2c535e270a59256 = $6ec6c68391f837fb$var$hsl((0, $52257f64b25d794c$export$2e2bcd8739ae039));




function $3cedd46d4e3bec48$export$2e2bcd8739ae039(start, end) {
    var l = (0, $52257f64b25d794c$export$2e2bcd8739ae039)((start = (0, $b3fc1577323a3235$export$2e2bcd8739ae039)(start)).l, (end = (0, $b3fc1577323a3235$export$2e2bcd8739ae039)(end)).l), a = (0, $52257f64b25d794c$export$2e2bcd8739ae039)(start.a, end.a), b = (0, $52257f64b25d794c$export$2e2bcd8739ae039)(start.b, end.b), opacity = (0, $52257f64b25d794c$export$2e2bcd8739ae039)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}




function $7bf4978f325a1eba$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $b3fc1577323a3235$export$d0e870ba50062ff1)(start)).h, (end = (0, $b3fc1577323a3235$export$d0e870ba50062ff1)(end)).h), c = (0, $52257f64b25d794c$export$2e2bcd8739ae039)(start.c, end.c), l = (0, $52257f64b25d794c$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $52257f64b25d794c$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $7bf4978f325a1eba$export$2e2bcd8739ae039 = $7bf4978f325a1eba$var$hcl((0, $52257f64b25d794c$export$97d7b0c7ddb78dcf));
var $7bf4978f325a1eba$export$5aaa50f7615f9b70 = $7bf4978f325a1eba$var$hcl((0, $52257f64b25d794c$export$2e2bcd8739ae039));




function $71cfe7fab883bd8a$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $2e4646047aa20e81$export$2e2bcd8739ae039)(start)).h, (end = (0, $2e4646047aa20e81$export$2e2bcd8739ae039)(end)).h), s = (0, $52257f64b25d794c$export$2e2bcd8739ae039)(start.s, end.s), l = (0, $52257f64b25d794c$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $52257f64b25d794c$export$2e2bcd8739ae039)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $71cfe7fab883bd8a$export$2e2bcd8739ae039 = $71cfe7fab883bd8a$var$cubehelix((0, $52257f64b25d794c$export$97d7b0c7ddb78dcf));
var $71cfe7fab883bd8a$export$934fa09ad474a1b4 = $71cfe7fab883bd8a$var$cubehelix((0, $52257f64b25d794c$export$2e2bcd8739ae039));



function $2adf3d3588dadf1c$export$2e2bcd8739ae039(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, $fdef680a1ac134b1$export$2e2bcd8739ae039);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}


function $e3442d6cef607317$export$2e2bcd8739ae039(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}




var $6204ec323e71459a$exports = {};

$parcel$export($6204ec323e71459a$exports, "Path", () => $2e4cb56f5089693f$export$4b2950bdac9b6ee9);
$parcel$export($6204ec323e71459a$exports, "path", () => $2e4cb56f5089693f$export$bb654e07daaf8c3a);
$parcel$export($6204ec323e71459a$exports, "pathRound", () => $2e4cb56f5089693f$export$e181c6ece8d9cc5f);



var $ff6392c6d3577ebe$exports = {};

$parcel$export($ff6392c6d3577ebe$exports, "polygonArea", () => $e70ec4e5a95fb783$export$2e2bcd8739ae039);
$parcel$export($ff6392c6d3577ebe$exports, "polygonCentroid", () => $1531fc437e288ff3$export$2e2bcd8739ae039);
$parcel$export($ff6392c6d3577ebe$exports, "polygonHull", () => $852d3c0c9df27685$export$2e2bcd8739ae039);
$parcel$export($ff6392c6d3577ebe$exports, "polygonContains", () => $35352476493ec702$export$2e2bcd8739ae039);
$parcel$export($ff6392c6d3577ebe$exports, "polygonLength", () => $3f6beab0e9f9d473$export$2e2bcd8739ae039);
function $e70ec4e5a95fb783$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, a, b = polygon[n - 1], area = 0;
    while(++i < n){
        a = b;
        b = polygon[i];
        area += a[1] * b[0] - a[0] * b[1];
    }
    return area / 2;
}


function $1531fc437e288ff3$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, x = 0, y = 0, a, b = polygon[n - 1], c, k = 0;
    while(++i < n){
        a = b;
        b = polygon[i];
        k += c = a[0] * b[1] - b[0] * a[1];
        x += (a[0] + b[0]) * c;
        y += (a[1] + b[1]) * c;
    }
    return k *= 3, [
        x / k,
        y / k
    ];
}


// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
function $f5c642a2cbc9525e$export$2e2bcd8739ae039(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
}


function $852d3c0c9df27685$var$lexicographicOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
}
// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function $852d3c0c9df27685$var$computeUpperHullIndexes(points) {
    const n = points.length, indexes = [
        0,
        1
    ];
    let size = 2, i;
    for(i = 2; i < n; ++i){
        while(size > 1 && (0, $f5c642a2cbc9525e$export$2e2bcd8739ae039)(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0)--size;
        indexes[size++] = i;
    }
    return indexes.slice(0, size); // remove popped points
}
function $852d3c0c9df27685$export$2e2bcd8739ae039(points) {
    if ((n = points.length) < 3) return null;
    var i, n, sortedPoints = new Array(n), flippedPoints = new Array(n);
    for(i = 0; i < n; ++i)sortedPoints[i] = [
        +points[i][0],
        +points[i][1],
        i
    ];
    sortedPoints.sort($852d3c0c9df27685$var$lexicographicOrder);
    for(i = 0; i < n; ++i)flippedPoints[i] = [
        sortedPoints[i][0],
        -sortedPoints[i][1]
    ];
    var upperIndexes = $852d3c0c9df27685$var$computeUpperHullIndexes(sortedPoints), lowerIndexes = $852d3c0c9df27685$var$computeUpperHullIndexes(flippedPoints);
    // Construct the hull polygon, removing possible duplicate endpoints.
    var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull = [];
    // Add upper hull in right-to-l order.
    // Then add lower hull in left-to-right order.
    for(i = upperIndexes.length - 1; i >= 0; --i)hull.push(points[sortedPoints[upperIndexes[i]][2]]);
    for(i = +skipLeft; i < lowerIndexes.length - skipRight; ++i)hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
    return hull;
}


function $35352476493ec702$export$2e2bcd8739ae039(polygon, point) {
    var n = polygon.length, p = polygon[n - 1], x = point[0], y = point[1], x0 = p[0], y0 = p[1], x1, y1, inside = false;
    for(var i = 0; i < n; ++i){
        p = polygon[i], x1 = p[0], y1 = p[1];
        if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
        x0 = x1, y0 = y1;
    }
    return inside;
}


function $3f6beab0e9f9d473$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, b = polygon[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
    while(++i < n){
        xa = xb;
        ya = yb;
        b = polygon[i];
        xb = b[0];
        yb = b[1];
        xa -= xb;
        ya -= yb;
        perimeter += Math.hypot(xa, ya);
    }
    return perimeter;
}




var $59337f127480c7df$exports = {};

$parcel$export($59337f127480c7df$exports, "quadtree", () => $38d27fd39e705624$export$2e2bcd8739ae039);



var $882b9ed40ac51fca$exports = {};

$parcel$export($882b9ed40ac51fca$exports, "randomUniform", () => $8d7f2b9d51e08a23$export$2e2bcd8739ae039);
$parcel$export($882b9ed40ac51fca$exports, "randomInt", () => $4cdaab6566221e29$export$2e2bcd8739ae039);
$parcel$export($882b9ed40ac51fca$exports, "randomNormal", () => $664d593d130e7ff1$export$2e2bcd8739ae039);
$parcel$export($882b9ed40ac51fca$exports, "randomLogNormal", () => $8900b83ce2f7fd7c$export$2e2bcd8739ae039);
$parcel$export($882b9ed40ac51fca$exports, "randomBates", () => $e4576b6b885377a8$export$2e2bcd8739ae039);
$parcel$export($882b9ed40ac51fca$exports, "randomIrwinHall", () => $684add213f621a23$export$2e2bcd8739ae039);
$parcel$export($882b9ed40ac51fca$exports, "randomExponential", () => $5917fee5715330d0$export$2e2bcd8739ae039);
$parcel$export($882b9ed40ac51fca$exports, "randomPareto", () => $c6e1972c5de5a160$export$2e2bcd8739ae039);
$parcel$export($882b9ed40ac51fca$exports, "randomBernoulli", () => $e0bbcbfd92edfe1d$export$2e2bcd8739ae039);
$parcel$export($882b9ed40ac51fca$exports, "randomGeometric", () => $3cab552428c2a1ad$export$2e2bcd8739ae039);
$parcel$export($882b9ed40ac51fca$exports, "randomBinomial", () => $047a49617b62b6d3$export$2e2bcd8739ae039);
$parcel$export($882b9ed40ac51fca$exports, "randomGamma", () => $b5cd0a0475089c5c$export$2e2bcd8739ae039);
$parcel$export($882b9ed40ac51fca$exports, "randomBeta", () => $cd03a1eb429ed2f7$export$2e2bcd8739ae039);
$parcel$export($882b9ed40ac51fca$exports, "randomWeibull", () => $a833ce2f954a4ba7$export$2e2bcd8739ae039);
$parcel$export($882b9ed40ac51fca$exports, "randomCauchy", () => $e91e999353c6298c$export$2e2bcd8739ae039);
$parcel$export($882b9ed40ac51fca$exports, "randomLogistic", () => $6c302c73c7d89b67$export$2e2bcd8739ae039);
$parcel$export($882b9ed40ac51fca$exports, "randomPoisson", () => $f81dd73188f1fe2b$export$2e2bcd8739ae039);
$parcel$export($882b9ed40ac51fca$exports, "randomLcg", () => $0b18690628320717$export$2e2bcd8739ae039);
var $3dd1a2af57c2e759$export$2e2bcd8739ae039 = Math.random;


var $8d7f2b9d51e08a23$export$2e2bcd8739ae039 = function sourceRandomUniform(source) {
    function randomUniform(min, max) {
        min = min == null ? 0 : +min;
        max = max == null ? 1 : +max;
        if (arguments.length === 1) max = min, min = 0;
        else max -= min;
        return function() {
            return source() * max + min;
        };
    }
    randomUniform.source = sourceRandomUniform;
    return randomUniform;
}((0, $3dd1a2af57c2e759$export$2e2bcd8739ae039));



var $4cdaab6566221e29$export$2e2bcd8739ae039 = function sourceRandomInt(source) {
    function randomInt(min, max) {
        if (arguments.length < 2) max = min, min = 0;
        min = Math.floor(min);
        max = Math.floor(max) - min;
        return function() {
            return Math.floor(source() * max + min);
        };
    }
    randomInt.source = sourceRandomInt;
    return randomInt;
}((0, $3dd1a2af57c2e759$export$2e2bcd8739ae039));



var $664d593d130e7ff1$export$2e2bcd8739ae039 = function sourceRandomNormal(source) {
    function randomNormal(mu, sigma) {
        var x, r;
        mu = mu == null ? 0 : +mu;
        sigma = sigma == null ? 1 : +sigma;
        return function() {
            var y;
            // If available, use the second previously-generated uniform random.
            if (x != null) y = x, x = null;
            else do {
                x = source() * 2 - 1;
                y = source() * 2 - 1;
                r = x * x + y * y;
            }while (!r || r > 1);
            return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
        };
    }
    randomNormal.source = sourceRandomNormal;
    return randomNormal;
}((0, $3dd1a2af57c2e759$export$2e2bcd8739ae039));




var $8900b83ce2f7fd7c$export$2e2bcd8739ae039 = function sourceRandomLogNormal(source) {
    var N = (0, $664d593d130e7ff1$export$2e2bcd8739ae039).source(source);
    function randomLogNormal() {
        var randomNormal = N.apply(this, arguments);
        return function() {
            return Math.exp(randomNormal());
        };
    }
    randomLogNormal.source = sourceRandomLogNormal;
    return randomLogNormal;
}((0, $3dd1a2af57c2e759$export$2e2bcd8739ae039));




var $684add213f621a23$export$2e2bcd8739ae039 = function sourceRandomIrwinHall(source) {
    function randomIrwinHall(n) {
        if ((n = +n) <= 0) return ()=>0;
        return function() {
            for(var sum = 0, i = n; i > 1; --i)sum += source();
            return sum + i * source();
        };
    }
    randomIrwinHall.source = sourceRandomIrwinHall;
    return randomIrwinHall;
}((0, $3dd1a2af57c2e759$export$2e2bcd8739ae039));


var $e4576b6b885377a8$export$2e2bcd8739ae039 = function sourceRandomBates(source) {
    var I = (0, $684add213f621a23$export$2e2bcd8739ae039).source(source);
    function randomBates(n) {
        // use limiting distribution at n === 0
        if ((n = +n) === 0) return source;
        var randomIrwinHall = I(n);
        return function() {
            return randomIrwinHall() / n;
        };
    }
    randomBates.source = sourceRandomBates;
    return randomBates;
}((0, $3dd1a2af57c2e759$export$2e2bcd8739ae039));




var $5917fee5715330d0$export$2e2bcd8739ae039 = function sourceRandomExponential(source) {
    function randomExponential(lambda) {
        return function() {
            return -Math.log1p(-source()) / lambda;
        };
    }
    randomExponential.source = sourceRandomExponential;
    return randomExponential;
}((0, $3dd1a2af57c2e759$export$2e2bcd8739ae039));



var $c6e1972c5de5a160$export$2e2bcd8739ae039 = function sourceRandomPareto(source) {
    function randomPareto(alpha) {
        if ((alpha = +alpha) < 0) throw new RangeError("invalid alpha");
        alpha = 1 / -alpha;
        return function() {
            return Math.pow(1 - source(), alpha);
        };
    }
    randomPareto.source = sourceRandomPareto;
    return randomPareto;
}((0, $3dd1a2af57c2e759$export$2e2bcd8739ae039));



var $e0bbcbfd92edfe1d$export$2e2bcd8739ae039 = function sourceRandomBernoulli(source) {
    function randomBernoulli(p) {
        if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
        return function() {
            return Math.floor(source() + p);
        };
    }
    randomBernoulli.source = sourceRandomBernoulli;
    return randomBernoulli;
}((0, $3dd1a2af57c2e759$export$2e2bcd8739ae039));



var $3cab552428c2a1ad$export$2e2bcd8739ae039 = function sourceRandomGeometric(source) {
    function randomGeometric(p) {
        if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
        if (p === 0) return ()=>Infinity;
        if (p === 1) return ()=>1;
        p = Math.log1p(-p);
        return function() {
            return 1 + Math.floor(Math.log1p(-source()) / p);
        };
    }
    randomGeometric.source = sourceRandomGeometric;
    return randomGeometric;
}((0, $3dd1a2af57c2e759$export$2e2bcd8739ae039));






var $b5cd0a0475089c5c$export$2e2bcd8739ae039 = function sourceRandomGamma(source) {
    var randomNormal = (0, $664d593d130e7ff1$export$2e2bcd8739ae039).source(source)();
    function randomGamma(k, theta) {
        if ((k = +k) < 0) throw new RangeError("invalid k");
        // degenerate distribution if k === 0
        if (k === 0) return ()=>0;
        theta = theta == null ? 1 : +theta;
        // exponential distribution if k === 1
        if (k === 1) return ()=>-Math.log1p(-source()) * theta;
        var d = (k < 1 ? k + 1 : k) - 1 / 3, c = 1 / (3 * Math.sqrt(d)), multiplier = k < 1 ? ()=>Math.pow(source(), 1 / k) : ()=>1;
        return function() {
            do {
                do var x = randomNormal(), v = 1 + c * x;
                while (v <= 0);
                v *= v * v;
                var u = 1 - source();
            }while (u >= 1 - 0.0331 * x * x * x * x && Math.log(u) >= 0.5 * x * x + d * (1 - v + Math.log(v)));
            return d * v * multiplier() * theta;
        };
    }
    randomGamma.source = sourceRandomGamma;
    return randomGamma;
}((0, $3dd1a2af57c2e759$export$2e2bcd8739ae039));


var $cd03a1eb429ed2f7$export$2e2bcd8739ae039 = function sourceRandomBeta(source) {
    var G = (0, $b5cd0a0475089c5c$export$2e2bcd8739ae039).source(source);
    function randomBeta(alpha, beta) {
        var X = G(alpha), Y = G(beta);
        return function() {
            var x = X();
            return x === 0 ? 0 : x / (x + Y());
        };
    }
    randomBeta.source = sourceRandomBeta;
    return randomBeta;
}((0, $3dd1a2af57c2e759$export$2e2bcd8739ae039));



var $047a49617b62b6d3$export$2e2bcd8739ae039 = function sourceRandomBinomial(source) {
    var G = (0, $3cab552428c2a1ad$export$2e2bcd8739ae039).source(source), B = (0, $cd03a1eb429ed2f7$export$2e2bcd8739ae039).source(source);
    function randomBinomial(n, p) {
        n = +n;
        if ((p = +p) >= 1) return ()=>n;
        if (p <= 0) return ()=>0;
        return function() {
            var acc = 0, nn = n, pp = p;
            while(nn * pp > 16 && nn * (1 - pp) > 16){
                var i = Math.floor((nn + 1) * pp), y = B(i, nn - i + 1)();
                if (y <= pp) {
                    acc += i;
                    nn -= i;
                    pp = (pp - y) / (1 - y);
                } else {
                    nn = i - 1;
                    pp /= y;
                }
            }
            var sign = pp < 0.5, pFinal = sign ? pp : 1 - pp, g = G(pFinal);
            for(var s = g(), k = 0; s <= nn; ++k)s += g();
            return acc + (sign ? k : nn - k);
        };
    }
    randomBinomial.source = sourceRandomBinomial;
    return randomBinomial;
}((0, $3dd1a2af57c2e759$export$2e2bcd8739ae039));





var $a833ce2f954a4ba7$export$2e2bcd8739ae039 = function sourceRandomWeibull(source) {
    function randomWeibull(k, a, b) {
        var outerFunc;
        if ((k = +k) === 0) outerFunc = (x)=>-Math.log(x);
        else {
            k = 1 / k;
            outerFunc = (x)=>Math.pow(x, k);
        }
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            return a + b * outerFunc(-Math.log1p(-source()));
        };
    }
    randomWeibull.source = sourceRandomWeibull;
    return randomWeibull;
}((0, $3dd1a2af57c2e759$export$2e2bcd8739ae039));



var $e91e999353c6298c$export$2e2bcd8739ae039 = function sourceRandomCauchy(source) {
    function randomCauchy(a, b) {
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            return a + b * Math.tan(Math.PI * source());
        };
    }
    randomCauchy.source = sourceRandomCauchy;
    return randomCauchy;
}((0, $3dd1a2af57c2e759$export$2e2bcd8739ae039));



var $6c302c73c7d89b67$export$2e2bcd8739ae039 = function sourceRandomLogistic(source) {
    function randomLogistic(a, b) {
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            var u = source();
            return a + b * Math.log(u / (1 - u));
        };
    }
    randomLogistic.source = sourceRandomLogistic;
    return randomLogistic;
}((0, $3dd1a2af57c2e759$export$2e2bcd8739ae039));





var $f81dd73188f1fe2b$export$2e2bcd8739ae039 = function sourceRandomPoisson(source) {
    var G = (0, $b5cd0a0475089c5c$export$2e2bcd8739ae039).source(source), B = (0, $047a49617b62b6d3$export$2e2bcd8739ae039).source(source);
    function randomPoisson(lambda) {
        return function() {
            var acc = 0, l = lambda;
            while(l > 16){
                var n = Math.floor(0.875 * l), t = G(n)();
                if (t > l) return acc + B(n - 1, l / t)();
                acc += n;
                l -= t;
            }
            for(var s = -Math.log1p(-source()), k = 0; s <= l; ++k)s -= Math.log1p(-source());
            return acc + k;
        };
    }
    randomPoisson.source = sourceRandomPoisson;
    return randomPoisson;
}((0, $3dd1a2af57c2e759$export$2e2bcd8739ae039));


// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $0b18690628320717$var$mul = 0x19660D;
const $0b18690628320717$var$inc = 0x3C6EF35F;
const $0b18690628320717$var$eps = 1 / 0x100000000;
function $0b18690628320717$export$2e2bcd8739ae039(seed = Math.random()) {
    let state = (0 <= seed && seed < 1 ? seed / $0b18690628320717$var$eps : Math.abs(seed)) | 0;
    return ()=>(state = $0b18690628320717$var$mul * state + $0b18690628320717$var$inc | 0, $0b18690628320717$var$eps * (state >>> 0));
}




var $f7842e95fb3e91b5$exports = {};

$parcel$export($f7842e95fb3e91b5$exports, "scaleBand", () => $89cbeb0a9ca9b25b$export$2e2bcd8739ae039);
$parcel$export($f7842e95fb3e91b5$exports, "scalePoint", () => $89cbeb0a9ca9b25b$export$105684a3041cb6f3);
$parcel$export($f7842e95fb3e91b5$exports, "scaleIdentity", () => $80c5b943eee2ca39$export$2e2bcd8739ae039);
$parcel$export($f7842e95fb3e91b5$exports, "scaleLinear", () => $0a099a6407198660$export$2e2bcd8739ae039);
$parcel$export($f7842e95fb3e91b5$exports, "scaleLog", () => $2e8e773e88cd103f$export$2e2bcd8739ae039);
$parcel$export($f7842e95fb3e91b5$exports, "scaleSymlog", () => $b5bfb562709c245a$export$2e2bcd8739ae039);
$parcel$export($f7842e95fb3e91b5$exports, "scaleOrdinal", () => $1cf736358eb3ea40$export$2e2bcd8739ae039);
$parcel$export($f7842e95fb3e91b5$exports, "scaleImplicit", () => $1cf736358eb3ea40$export$e4f898ab14d9d460);
$parcel$export($f7842e95fb3e91b5$exports, "scalePow", () => $78083bc3056bf6a5$export$2e2bcd8739ae039);
$parcel$export($f7842e95fb3e91b5$exports, "scaleSqrt", () => $78083bc3056bf6a5$export$eba8049fb5020b81);
$parcel$export($f7842e95fb3e91b5$exports, "scaleRadial", () => $d6326c2b750f93f4$export$2e2bcd8739ae039);
$parcel$export($f7842e95fb3e91b5$exports, "scaleQuantile", () => $beeab6209d21acdd$export$2e2bcd8739ae039);
$parcel$export($f7842e95fb3e91b5$exports, "scaleQuantize", () => $dc29f233796df919$export$2e2bcd8739ae039);
$parcel$export($f7842e95fb3e91b5$exports, "scaleThreshold", () => $83359f80c3a85df0$export$2e2bcd8739ae039);
$parcel$export($f7842e95fb3e91b5$exports, "scaleTime", () => $c62717be14c35f93$export$2e2bcd8739ae039);
$parcel$export($f7842e95fb3e91b5$exports, "scaleUtc", () => $3a16a604f7bb8175$export$2e2bcd8739ae039);
$parcel$export($f7842e95fb3e91b5$exports, "scaleSequential", () => $c7cde8d62e1e3e5c$export$2e2bcd8739ae039);
$parcel$export($f7842e95fb3e91b5$exports, "scaleSequentialLog", () => $c7cde8d62e1e3e5c$export$6843e08bf2ff981f);
$parcel$export($f7842e95fb3e91b5$exports, "scaleSequentialPow", () => $c7cde8d62e1e3e5c$export$de9f78581b4f2405);
$parcel$export($f7842e95fb3e91b5$exports, "scaleSequentialSqrt", () => $c7cde8d62e1e3e5c$export$413d935127ed466e);
$parcel$export($f7842e95fb3e91b5$exports, "scaleSequentialSymlog", () => $c7cde8d62e1e3e5c$export$9d4af4de62c81941);
$parcel$export($f7842e95fb3e91b5$exports, "scaleSequentialQuantile", () => $8b7121ace5a11a57$export$2e2bcd8739ae039);
$parcel$export($f7842e95fb3e91b5$exports, "scaleDiverging", () => $b0a2f805036835c3$export$2e2bcd8739ae039);
$parcel$export($f7842e95fb3e91b5$exports, "scaleDivergingLog", () => $b0a2f805036835c3$export$5f0266a9159c47fb);
$parcel$export($f7842e95fb3e91b5$exports, "scaleDivergingPow", () => $b0a2f805036835c3$export$d6cedcc63bf26e7e);
$parcel$export($f7842e95fb3e91b5$exports, "scaleDivergingSqrt", () => $b0a2f805036835c3$export$33ddefb5c4ab9e9c);
$parcel$export($f7842e95fb3e91b5$exports, "scaleDivergingSymlog", () => $b0a2f805036835c3$export$50b3da713cf557c6);
$parcel$export($f7842e95fb3e91b5$exports, "tickFormat", () => $372a0acd6008e28f$export$2e2bcd8739ae039);

function $f8605c04d320312f$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $f8605c04d320312f$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}




const $1cf736358eb3ea40$export$e4f898ab14d9d460 = Symbol("implicit");
function $1cf736358eb3ea40$export$2e2bcd8739ae039() {
    var index = new (0, $1565c3f84209a139$export$dcc6fb7d82b5bc7b)(), domain = [], range = [], unknown = $1cf736358eb3ea40$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $1cf736358eb3ea40$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $1565c3f84209a139$export$dcc6fb7d82b5bc7b)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $1cf736358eb3ea40$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $f8605c04d320312f$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}


function $89cbeb0a9ca9b25b$export$2e2bcd8739ae039() {
    var scale = (0, $1cf736358eb3ea40$export$2e2bcd8739ae039)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $e4dbde6ec669fccd$export$2e2bcd8739ae039)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $89cbeb0a9ca9b25b$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $f8605c04d320312f$export$23c7bb9e6558da2a).apply(rescale(), arguments);
}
function $89cbeb0a9ca9b25b$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $89cbeb0a9ca9b25b$var$pointish(copy());
    };
    return scale;
}
function $89cbeb0a9ca9b25b$export$105684a3041cb6f3() {
    return $89cbeb0a9ca9b25b$var$pointish($89cbeb0a9ca9b25b$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}





function $2074ea5448015bac$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $f2471f61c6f4fe8e$export$2e2bcd8739ae039(x) {
    return +x;
}


var $f2eaa3e16911c52c$var$unit = [
    0,
    1
];
function $f2eaa3e16911c52c$export$f0954fd7d5368655(x) {
    return x;
}
function $f2eaa3e16911c52c$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $2074ea5448015bac$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $f2eaa3e16911c52c$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $f2eaa3e16911c52c$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $f2eaa3e16911c52c$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $f2eaa3e16911c52c$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $f2eaa3e16911c52c$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $f2eaa3e16911c52c$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $263d20e47b8a3378$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $f2eaa3e16911c52c$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $f2eaa3e16911c52c$export$6b468dcfb64c653c() {
    var domain = $f2eaa3e16911c52c$var$unit, range = $f2eaa3e16911c52c$var$unit, interpolate = (0, $fdef680a1ac134b1$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $f2eaa3e16911c52c$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $f2eaa3e16911c52c$export$f0954fd7d5368655) clamp = $f2eaa3e16911c52c$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $f2eaa3e16911c52c$var$polymap : $f2eaa3e16911c52c$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $aa9385f41bac0020$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $f2471f61c6f4fe8e$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $56f517ab42b48aac$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $f2eaa3e16911c52c$export$f0954fd7d5368655, rescale()) : clamp !== $f2eaa3e16911c52c$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $f2eaa3e16911c52c$export$2e2bcd8739ae039() {
    return $f2eaa3e16911c52c$export$6b468dcfb64c653c()($f2eaa3e16911c52c$export$f0954fd7d5368655, $f2eaa3e16911c52c$export$f0954fd7d5368655);
}





function $372a0acd6008e28f$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $60d8cb9860d70e68$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $4d11e40433d14d49$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $e9d5960850bc50d4$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $d8610aae6830e542$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $e8f418ea446b2e3e$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $170ab4c42df99f46$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $d8610aae6830e542$export$d9468344d3651243)(specifier);
}


function $0a099a6407198660$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $60d8cb9860d70e68$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $372a0acd6008e28f$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $60d8cb9860d70e68$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $0a099a6407198660$export$2e2bcd8739ae039() {
    var scale = (0, $f2eaa3e16911c52c$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $f2eaa3e16911c52c$export$784d13d8ee351f07)(scale, $0a099a6407198660$export$2e2bcd8739ae039());
    };
    (0, $f8605c04d320312f$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $0a099a6407198660$export$16a5d4b4a61a274d(scale);
}



function $80c5b943eee2ca39$export$2e2bcd8739ae039(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $f2471f61c6f4fe8e$export$2e2bcd8739ae039)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $80c5b943eee2ca39$export$2e2bcd8739ae039(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, (0, $f2471f61c6f4fe8e$export$2e2bcd8739ae039)) : [
        0,
        1
    ];
    return (0, $0a099a6407198660$export$16a5d4b4a61a274d)(scale);
}





function $b290e0a21701388e$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}




function $2e8e773e88cd103f$var$transformLog(x) {
    return Math.log(x);
}
function $2e8e773e88cd103f$var$transformExp(x) {
    return Math.exp(x);
}
function $2e8e773e88cd103f$var$transformLogn(x) {
    return -Math.log(-x);
}
function $2e8e773e88cd103f$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $2e8e773e88cd103f$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $2e8e773e88cd103f$var$powp(base) {
    return base === 10 ? $2e8e773e88cd103f$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $2e8e773e88cd103f$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $2e8e773e88cd103f$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $2e8e773e88cd103f$export$860836db074028f0(transform) {
    const scale = transform($2e8e773e88cd103f$var$transformLog, $2e8e773e88cd103f$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $2e8e773e88cd103f$var$logp(base), pows = $2e8e773e88cd103f$var$powp(base);
        if (domain()[0] < 0) {
            logs = $2e8e773e88cd103f$var$reflect(logs), pows = $2e8e773e88cd103f$var$reflect(pows);
            transform($2e8e773e88cd103f$var$transformLogn, $2e8e773e88cd103f$var$transformExpn);
        } else transform($2e8e773e88cd103f$var$transformLog, $2e8e773e88cd103f$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $60d8cb9860d70e68$export$2e2bcd8739ae039)(u, v, n);
        } else z = (0, $60d8cb9860d70e68$export$2e2bcd8739ae039)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $4d11e40433d14d49$export$2e2bcd8739ae039)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $d8610aae6830e542$export$d9468344d3651243)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $b290e0a21701388e$export$2e2bcd8739ae039)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $2e8e773e88cd103f$export$2e2bcd8739ae039() {
    const scale = $2e8e773e88cd103f$export$860836db074028f0((0, $f2eaa3e16911c52c$export$6b468dcfb64c653c)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $f2eaa3e16911c52c$export$784d13d8ee351f07)(scale, $2e8e773e88cd103f$export$2e2bcd8739ae039()).base(scale.base());
    (0, $f8605c04d320312f$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}





function $b5bfb562709c245a$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $b5bfb562709c245a$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $b5bfb562709c245a$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($b5bfb562709c245a$var$transformSymlog(c), $b5bfb562709c245a$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($b5bfb562709c245a$var$transformSymlog(c = +_), $b5bfb562709c245a$var$transformSymexp(c)) : c;
    };
    return (0, $0a099a6407198660$export$16a5d4b4a61a274d)(scale);
}
function $b5bfb562709c245a$export$2e2bcd8739ae039() {
    var scale = $b5bfb562709c245a$export$4602684e614eba38((0, $f2eaa3e16911c52c$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $f2eaa3e16911c52c$export$784d13d8ee351f07)(scale, $b5bfb562709c245a$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $f8605c04d320312f$export$23c7bb9e6558da2a).apply(scale, arguments);
}






function $78083bc3056bf6a5$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $78083bc3056bf6a5$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $78083bc3056bf6a5$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $78083bc3056bf6a5$export$34695211ec403a46(transform) {
    var scale = transform((0, $f2eaa3e16911c52c$export$f0954fd7d5368655), (0, $f2eaa3e16911c52c$export$f0954fd7d5368655)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $f2eaa3e16911c52c$export$f0954fd7d5368655), (0, $f2eaa3e16911c52c$export$f0954fd7d5368655)) : exponent === 0.5 ? transform($78083bc3056bf6a5$var$transformSqrt, $78083bc3056bf6a5$var$transformSquare) : transform($78083bc3056bf6a5$var$transformPow(exponent), $78083bc3056bf6a5$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $0a099a6407198660$export$16a5d4b4a61a274d)(scale);
}
function $78083bc3056bf6a5$export$2e2bcd8739ae039() {
    var scale = $78083bc3056bf6a5$export$34695211ec403a46((0, $f2eaa3e16911c52c$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $f2eaa3e16911c52c$export$784d13d8ee351f07)(scale, $78083bc3056bf6a5$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $f8605c04d320312f$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}
function $78083bc3056bf6a5$export$eba8049fb5020b81() {
    return $78083bc3056bf6a5$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}






function $d6326c2b750f93f4$var$square(x) {
    return Math.sign(x) * x * x;
}
function $d6326c2b750f93f4$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $d6326c2b750f93f4$export$2e2bcd8739ae039() {
    var squared = (0, $f2eaa3e16911c52c$export$2e2bcd8739ae039)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $d6326c2b750f93f4$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($d6326c2b750f93f4$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, (0, $f2471f61c6f4fe8e$export$2e2bcd8739ae039))).map($d6326c2b750f93f4$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $d6326c2b750f93f4$export$2e2bcd8739ae039(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    (0, $f8605c04d320312f$export$23c7bb9e6558da2a).apply(scale, arguments);
    return (0, $0a099a6407198660$export$16a5d4b4a61a274d)(scale);
}




function $beeab6209d21acdd$export$2e2bcd8739ae039() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $058a580f1d366c99$export$f924a6cad778dddb)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $263d20e47b8a3378$export$2e2bcd8739ae039)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $f64c55ab13ca9913$export$2e2bcd8739ae039));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $beeab6209d21acdd$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $f8605c04d320312f$export$23c7bb9e6558da2a).apply(scale, arguments);
}





function $dc29f233796df919$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $263d20e47b8a3378$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $dc29f233796df919$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $f8605c04d320312f$export$23c7bb9e6558da2a).apply((0, $0a099a6407198660$export$16a5d4b4a61a274d)(scale), arguments);
}




function $83359f80c3a85df0$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $263d20e47b8a3378$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $83359f80c3a85df0$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $f8605c04d320312f$export$23c7bb9e6558da2a).apply(scale, arguments);
}


const $6ec19887e6a2f70d$var$t0 = new Date, $6ec19887e6a2f70d$var$t1 = new Date;
function $6ec19887e6a2f70d$export$1a539c8b2950ab40(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return $6ec19887e6a2f70d$export$1a539c8b2950ab40((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            $6ec19887e6a2f70d$var$t0.setTime(+start), $6ec19887e6a2f70d$var$t1.setTime(+end);
            floori($6ec19887e6a2f70d$var$t0), floori($6ec19887e6a2f70d$var$t1);
            return Math.floor(count($6ec19887e6a2f70d$var$t0, $6ec19887e6a2f70d$var$t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}


const $5ef8ab0cd9872346$export$79ef0e34099623dc = 1000;
const $5ef8ab0cd9872346$export$683905d551c33fa9 = $5ef8ab0cd9872346$export$79ef0e34099623dc * 60;
const $5ef8ab0cd9872346$export$4157bf0c8e241659 = $5ef8ab0cd9872346$export$683905d551c33fa9 * 60;
const $5ef8ab0cd9872346$export$353686095f4fbf45 = $5ef8ab0cd9872346$export$4157bf0c8e241659 * 24;
const $5ef8ab0cd9872346$export$c241eb88520d5016 = $5ef8ab0cd9872346$export$353686095f4fbf45 * 7;
const $5ef8ab0cd9872346$export$ab95684df7020b26 = $5ef8ab0cd9872346$export$353686095f4fbf45 * 30;
const $5ef8ab0cd9872346$export$61f8ee2d834c6959 = $5ef8ab0cd9872346$export$353686095f4fbf45 * 365;


const $0510fd4f155849d7$export$8888529b966033e5 = (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $5ef8ab0cd9872346$export$683905d551c33fa9)) / (0, $5ef8ab0cd9872346$export$353686095f4fbf45), (date)=>date.getDate() - 1);
const $0510fd4f155849d7$export$6657a54f3034cf45 = $0510fd4f155849d7$export$8888529b966033e5.range;
const $0510fd4f155849d7$export$c8cbc42cefd47140 = (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $5ef8ab0cd9872346$export$353686095f4fbf45);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const $0510fd4f155849d7$export$d277e198508549a1 = $0510fd4f155849d7$export$c8cbc42cefd47140.range;
const $0510fd4f155849d7$export$fb065be2d7ea4a71 = (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $5ef8ab0cd9872346$export$353686095f4fbf45);
}, (date)=>{
    return Math.floor(date / (0, $5ef8ab0cd9872346$export$353686095f4fbf45));
});
const $0510fd4f155849d7$export$a491caaf5e9481aa = $0510fd4f155849d7$export$fb065be2d7ea4a71.range;



const $71bc9e75aba412b8$export$46c68a5833bc315b = (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $5ef8ab0cd9872346$export$79ef0e34099623dc) - date.getMinutes() * (0, $5ef8ab0cd9872346$export$683905d551c33fa9));
}, (date, step)=>{
    date.setTime(+date + step * (0, $5ef8ab0cd9872346$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $5ef8ab0cd9872346$export$4157bf0c8e241659);
}, (date)=>{
    return date.getHours();
});
const $71bc9e75aba412b8$export$fb843f9087cd5235 = $71bc9e75aba412b8$export$46c68a5833bc315b.range;
const $71bc9e75aba412b8$export$31f6f2b3c63ac75e = (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $5ef8ab0cd9872346$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $5ef8ab0cd9872346$export$4157bf0c8e241659);
}, (date)=>{
    return date.getUTCHours();
});
const $71bc9e75aba412b8$export$6e7a76cd5f50b719 = $71bc9e75aba412b8$export$31f6f2b3c63ac75e.range;



const $7af3d84c55f5e66a$export$a7e4c34a52f0576 = (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $5ef8ab0cd9872346$export$79ef0e34099623dc));
}, (date, step)=>{
    date.setTime(+date + step * (0, $5ef8ab0cd9872346$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $5ef8ab0cd9872346$export$683905d551c33fa9);
}, (date)=>{
    return date.getMinutes();
});
const $7af3d84c55f5e66a$export$186d65358374c0a2 = $7af3d84c55f5e66a$export$a7e4c34a52f0576.range;
const $7af3d84c55f5e66a$export$efe6712d6003761b = (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $5ef8ab0cd9872346$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $5ef8ab0cd9872346$export$683905d551c33fa9);
}, (date)=>{
    return date.getUTCMinutes();
});
const $7af3d84c55f5e66a$export$cedd563624e8ee50 = $7af3d84c55f5e66a$export$efe6712d6003761b.range;


const $f49497a07f26fc9e$export$7e1084fb688591c1 = (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const $f49497a07f26fc9e$export$3e24aa839cd0f1c4 = $f49497a07f26fc9e$export$7e1084fb688591c1.range;
const $f49497a07f26fc9e$export$cd49b3d2bcfe50d5 = (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const $f49497a07f26fc9e$export$49159f585997498 = $f49497a07f26fc9e$export$cd49b3d2bcfe50d5.range;



const $88f32e66450fe893$export$3d3c77ce7df7d30d = (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, $5ef8ab0cd9872346$export$79ef0e34099623dc));
}, (start, end)=>{
    return (end - start) / (0, $5ef8ab0cd9872346$export$79ef0e34099623dc);
}, (date)=>{
    return date.getUTCSeconds();
});
const $88f32e66450fe893$export$4792e48abc550fa1 = $88f32e66450fe893$export$3d3c77ce7df7d30d.range;




const $7cb32965fb4d0e37$export$edc5e5cb87280477 = (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
$7cb32965fb4d0e37$export$edc5e5cb87280477.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $7cb32965fb4d0e37$export$edc5e5cb87280477;
    return (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const $7cb32965fb4d0e37$export$9a27fac83d67afd3 = $7cb32965fb4d0e37$export$edc5e5cb87280477.range;








function $829beff7f10c8695$var$timeWeekday(i) {
    return (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $5ef8ab0cd9872346$export$683905d551c33fa9)) / (0, $5ef8ab0cd9872346$export$c241eb88520d5016);
    });
}
const $829beff7f10c8695$export$22ee6205b762968c = $829beff7f10c8695$var$timeWeekday(0);
const $829beff7f10c8695$export$e79bbe0177cf1b01 = $829beff7f10c8695$var$timeWeekday(1);
const $829beff7f10c8695$export$57c0658c29f77708 = $829beff7f10c8695$var$timeWeekday(2);
const $829beff7f10c8695$export$3fbeef226c256e43 = $829beff7f10c8695$var$timeWeekday(3);
const $829beff7f10c8695$export$608689422d5cf9f4 = $829beff7f10c8695$var$timeWeekday(4);
const $829beff7f10c8695$export$548e5227aa183dca = $829beff7f10c8695$var$timeWeekday(5);
const $829beff7f10c8695$export$c56a3ad248908e19 = $829beff7f10c8695$var$timeWeekday(6);
const $829beff7f10c8695$export$eac514c8a8674eba = $829beff7f10c8695$export$22ee6205b762968c.range;
const $829beff7f10c8695$export$f7219b1481948356 = $829beff7f10c8695$export$e79bbe0177cf1b01.range;
const $829beff7f10c8695$export$77e22b12c5bed05b = $829beff7f10c8695$export$57c0658c29f77708.range;
const $829beff7f10c8695$export$b85d407a471809e8 = $829beff7f10c8695$export$3fbeef226c256e43.range;
const $829beff7f10c8695$export$c1bc1c49254c8855 = $829beff7f10c8695$export$608689422d5cf9f4.range;
const $829beff7f10c8695$export$3691a1557fff46f1 = $829beff7f10c8695$export$548e5227aa183dca.range;
const $829beff7f10c8695$export$b755452d02cba8d2 = $829beff7f10c8695$export$c56a3ad248908e19.range;
function $829beff7f10c8695$var$utcWeekday(i) {
    return (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, $5ef8ab0cd9872346$export$c241eb88520d5016);
    });
}
const $829beff7f10c8695$export$4898b06303a92011 = $829beff7f10c8695$var$utcWeekday(0);
const $829beff7f10c8695$export$9cfc53b9cfafd080 = $829beff7f10c8695$var$utcWeekday(1);
const $829beff7f10c8695$export$2a6d545f77eceb15 = $829beff7f10c8695$var$utcWeekday(2);
const $829beff7f10c8695$export$a5c25d8ed64433c4 = $829beff7f10c8695$var$utcWeekday(3);
const $829beff7f10c8695$export$1db08111baec2f53 = $829beff7f10c8695$var$utcWeekday(4);
const $829beff7f10c8695$export$29265e34dd5921f7 = $829beff7f10c8695$var$utcWeekday(5);
const $829beff7f10c8695$export$85b74dad05049604 = $829beff7f10c8695$var$utcWeekday(6);
const $829beff7f10c8695$export$6f3e1c2b0f7d7880 = $829beff7f10c8695$export$4898b06303a92011.range;
const $829beff7f10c8695$export$1d2d8b858bb366f9 = $829beff7f10c8695$export$9cfc53b9cfafd080.range;
const $829beff7f10c8695$export$1d5f6785fc7f30f8 = $829beff7f10c8695$export$2a6d545f77eceb15.range;
const $829beff7f10c8695$export$7a75faf0e37ef4af = $829beff7f10c8695$export$a5c25d8ed64433c4.range;
const $829beff7f10c8695$export$417eb959611b2f2f = $829beff7f10c8695$export$1db08111baec2f53.range;
const $829beff7f10c8695$export$59d308db7af08c64 = $829beff7f10c8695$export$29265e34dd5921f7.range;
const $829beff7f10c8695$export$a124108a0a7f34c8 = $829beff7f10c8695$export$85b74dad05049604.range;




const $ddf3f8970489211a$export$cd17cfe45df0c046 = (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$ddf3f8970489211a$export$cd17cfe45df0c046.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const $ddf3f8970489211a$export$69a4e90dd2cc3bd1 = $ddf3f8970489211a$export$cd17cfe45df0c046.range;
const $ddf3f8970489211a$export$d5c3802e389714c4 = (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$ddf3f8970489211a$export$d5c3802e389714c4.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $6ec19887e6a2f70d$export$1a539c8b2950ab40)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const $ddf3f8970489211a$export$3e24d311e17f5802 = $ddf3f8970489211a$export$d5c3802e389714c4.range;


function $c71cf5d5cab5b066$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $88f32e66450fe893$export$3d3c77ce7df7d30d),
            1,
            (0, $5ef8ab0cd9872346$export$79ef0e34099623dc)
        ],
        [
            (0, $88f32e66450fe893$export$3d3c77ce7df7d30d),
            5,
            5 * (0, $5ef8ab0cd9872346$export$79ef0e34099623dc)
        ],
        [
            (0, $88f32e66450fe893$export$3d3c77ce7df7d30d),
            15,
            15 * (0, $5ef8ab0cd9872346$export$79ef0e34099623dc)
        ],
        [
            (0, $88f32e66450fe893$export$3d3c77ce7df7d30d),
            30,
            30 * (0, $5ef8ab0cd9872346$export$79ef0e34099623dc)
        ],
        [
            minute,
            1,
            (0, $5ef8ab0cd9872346$export$683905d551c33fa9)
        ],
        [
            minute,
            5,
            5 * (0, $5ef8ab0cd9872346$export$683905d551c33fa9)
        ],
        [
            minute,
            15,
            15 * (0, $5ef8ab0cd9872346$export$683905d551c33fa9)
        ],
        [
            minute,
            30,
            30 * (0, $5ef8ab0cd9872346$export$683905d551c33fa9)
        ],
        [
            hour,
            1,
            (0, $5ef8ab0cd9872346$export$4157bf0c8e241659)
        ],
        [
            hour,
            3,
            3 * (0, $5ef8ab0cd9872346$export$4157bf0c8e241659)
        ],
        [
            hour,
            6,
            6 * (0, $5ef8ab0cd9872346$export$4157bf0c8e241659)
        ],
        [
            hour,
            12,
            12 * (0, $5ef8ab0cd9872346$export$4157bf0c8e241659)
        ],
        [
            day,
            1,
            (0, $5ef8ab0cd9872346$export$353686095f4fbf45)
        ],
        [
            day,
            2,
            2 * (0, $5ef8ab0cd9872346$export$353686095f4fbf45)
        ],
        [
            week,
            1,
            (0, $5ef8ab0cd9872346$export$c241eb88520d5016)
        ],
        [
            month,
            1,
            (0, $5ef8ab0cd9872346$export$ab95684df7020b26)
        ],
        [
            month,
            3,
            3 * (0, $5ef8ab0cd9872346$export$ab95684df7020b26)
        ],
        [
            year,
            1,
            (0, $5ef8ab0cd9872346$export$61f8ee2d834c6959)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $a48de5bf29a63c46$export$2e2bcd8739ae039)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $60d8cb9860d70e68$export$81087d9b915d4ede)(start / (0, $5ef8ab0cd9872346$export$61f8ee2d834c6959), stop / (0, $5ef8ab0cd9872346$export$61f8ee2d834c6959), count));
        if (i === 0) return (0, $7cb32965fb4d0e37$export$edc5e5cb87280477).every(Math.max((0, $60d8cb9860d70e68$export$81087d9b915d4ede)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$c71cf5d5cab5b066$export$826ba5ae907e9767, $c71cf5d5cab5b066$export$6262d8d056ea44c4] = $c71cf5d5cab5b066$var$ticker((0, $ddf3f8970489211a$export$d5c3802e389714c4), (0, $f49497a07f26fc9e$export$cd49b3d2bcfe50d5), (0, $829beff7f10c8695$export$4898b06303a92011), (0, $0510fd4f155849d7$export$fb065be2d7ea4a71), (0, $71bc9e75aba412b8$export$31f6f2b3c63ac75e), (0, $7af3d84c55f5e66a$export$efe6712d6003761b));
const [$c71cf5d5cab5b066$export$60c76498552d28a6, $c71cf5d5cab5b066$export$69511150134dd174] = $c71cf5d5cab5b066$var$ticker((0, $ddf3f8970489211a$export$cd17cfe45df0c046), (0, $f49497a07f26fc9e$export$7e1084fb688591c1), (0, $829beff7f10c8695$export$22ee6205b762968c), (0, $0510fd4f155849d7$export$8888529b966033e5), (0, $71bc9e75aba412b8$export$46c68a5833bc315b), (0, $7af3d84c55f5e66a$export$a7e4c34a52f0576));



function $44fe361b644f94fb$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $44fe361b644f94fb$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $44fe361b644f94fb$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $44fe361b644f94fb$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $44fe361b644f94fb$var$formatRe(locale_periods), periodLookup = $44fe361b644f94fb$var$formatLookup(locale_periods), weekdayRe = $44fe361b644f94fb$var$formatRe(locale_weekdays), weekdayLookup = $44fe361b644f94fb$var$formatLookup(locale_weekdays), shortWeekdayRe = $44fe361b644f94fb$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $44fe361b644f94fb$var$formatLookup(locale_shortWeekdays), monthRe = $44fe361b644f94fb$var$formatRe(locale_months), monthLookup = $44fe361b644f94fb$var$formatLookup(locale_months), shortMonthRe = $44fe361b644f94fb$var$formatRe(locale_shortMonths), shortMonthLookup = $44fe361b644f94fb$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $44fe361b644f94fb$var$formatDayOfMonth,
        "e": $44fe361b644f94fb$var$formatDayOfMonth,
        "f": $44fe361b644f94fb$var$formatMicroseconds,
        "g": $44fe361b644f94fb$var$formatYearISO,
        "G": $44fe361b644f94fb$var$formatFullYearISO,
        "H": $44fe361b644f94fb$var$formatHour24,
        "I": $44fe361b644f94fb$var$formatHour12,
        "j": $44fe361b644f94fb$var$formatDayOfYear,
        "L": $44fe361b644f94fb$var$formatMilliseconds,
        "m": $44fe361b644f94fb$var$formatMonthNumber,
        "M": $44fe361b644f94fb$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $44fe361b644f94fb$var$formatUnixTimestamp,
        "s": $44fe361b644f94fb$var$formatUnixTimestampSeconds,
        "S": $44fe361b644f94fb$var$formatSeconds,
        "u": $44fe361b644f94fb$var$formatWeekdayNumberMonday,
        "U": $44fe361b644f94fb$var$formatWeekNumberSunday,
        "V": $44fe361b644f94fb$var$formatWeekNumberISO,
        "w": $44fe361b644f94fb$var$formatWeekdayNumberSunday,
        "W": $44fe361b644f94fb$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $44fe361b644f94fb$var$formatYear,
        "Y": $44fe361b644f94fb$var$formatFullYear,
        "Z": $44fe361b644f94fb$var$formatZone,
        "%": $44fe361b644f94fb$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $44fe361b644f94fb$var$formatUTCDayOfMonth,
        "e": $44fe361b644f94fb$var$formatUTCDayOfMonth,
        "f": $44fe361b644f94fb$var$formatUTCMicroseconds,
        "g": $44fe361b644f94fb$var$formatUTCYearISO,
        "G": $44fe361b644f94fb$var$formatUTCFullYearISO,
        "H": $44fe361b644f94fb$var$formatUTCHour24,
        "I": $44fe361b644f94fb$var$formatUTCHour12,
        "j": $44fe361b644f94fb$var$formatUTCDayOfYear,
        "L": $44fe361b644f94fb$var$formatUTCMilliseconds,
        "m": $44fe361b644f94fb$var$formatUTCMonthNumber,
        "M": $44fe361b644f94fb$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $44fe361b644f94fb$var$formatUnixTimestamp,
        "s": $44fe361b644f94fb$var$formatUnixTimestampSeconds,
        "S": $44fe361b644f94fb$var$formatUTCSeconds,
        "u": $44fe361b644f94fb$var$formatUTCWeekdayNumberMonday,
        "U": $44fe361b644f94fb$var$formatUTCWeekNumberSunday,
        "V": $44fe361b644f94fb$var$formatUTCWeekNumberISO,
        "w": $44fe361b644f94fb$var$formatUTCWeekdayNumberSunday,
        "W": $44fe361b644f94fb$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $44fe361b644f94fb$var$formatUTCYear,
        "Y": $44fe361b644f94fb$var$formatUTCFullYear,
        "Z": $44fe361b644f94fb$var$formatUTCZone,
        "%": $44fe361b644f94fb$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $44fe361b644f94fb$var$parseDayOfMonth,
        "e": $44fe361b644f94fb$var$parseDayOfMonth,
        "f": $44fe361b644f94fb$var$parseMicroseconds,
        "g": $44fe361b644f94fb$var$parseYear,
        "G": $44fe361b644f94fb$var$parseFullYear,
        "H": $44fe361b644f94fb$var$parseHour24,
        "I": $44fe361b644f94fb$var$parseHour24,
        "j": $44fe361b644f94fb$var$parseDayOfYear,
        "L": $44fe361b644f94fb$var$parseMilliseconds,
        "m": $44fe361b644f94fb$var$parseMonthNumber,
        "M": $44fe361b644f94fb$var$parseMinutes,
        "p": parsePeriod,
        "q": $44fe361b644f94fb$var$parseQuarter,
        "Q": $44fe361b644f94fb$var$parseUnixTimestamp,
        "s": $44fe361b644f94fb$var$parseUnixTimestampSeconds,
        "S": $44fe361b644f94fb$var$parseSeconds,
        "u": $44fe361b644f94fb$var$parseWeekdayNumberMonday,
        "U": $44fe361b644f94fb$var$parseWeekNumberSunday,
        "V": $44fe361b644f94fb$var$parseWeekNumberISO,
        "w": $44fe361b644f94fb$var$parseWeekdayNumberSunday,
        "W": $44fe361b644f94fb$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $44fe361b644f94fb$var$parseYear,
        "Y": $44fe361b644f94fb$var$parseFullYear,
        "Z": $44fe361b644f94fb$var$parseZone,
        "%": $44fe361b644f94fb$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $44fe361b644f94fb$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $44fe361b644f94fb$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $44fe361b644f94fb$var$utcDate($44fe361b644f94fb$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $829beff7f10c8695$export$9cfc53b9cfafd080).ceil(week) : (0, $829beff7f10c8695$export$9cfc53b9cfafd080)(week);
                    week = (0, $0510fd4f155849d7$export$c8cbc42cefd47140).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $44fe361b644f94fb$var$localDate($44fe361b644f94fb$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $829beff7f10c8695$export$e79bbe0177cf1b01).ceil(week) : (0, $829beff7f10c8695$export$e79bbe0177cf1b01)(week);
                    week = (0, $0510fd4f155849d7$export$8888529b966033e5).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $44fe361b644f94fb$var$utcDate($44fe361b644f94fb$var$newDate(d.y, 0, 1)).getUTCDay() : $44fe361b644f94fb$var$localDate($44fe361b644f94fb$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $44fe361b644f94fb$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $44fe361b644f94fb$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $44fe361b644f94fb$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $44fe361b644f94fb$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $44fe361b644f94fb$var$numberRe = /^\s*\d+/, $44fe361b644f94fb$var$percentRe = /^%/, $44fe361b644f94fb$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $44fe361b644f94fb$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $44fe361b644f94fb$var$requote(s) {
    return s.replace($44fe361b644f94fb$var$requoteRe, "\\$&");
}
function $44fe361b644f94fb$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($44fe361b644f94fb$var$requote).join("|") + ")", "i");
}
function $44fe361b644f94fb$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $44fe361b644f94fb$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseWeekNumberSunday(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseWeekNumberISO(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseWeekNumberMonday(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseFullYear(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseYear(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseQuarter(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseMonthNumber(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseDayOfMonth(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseDayOfYear(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseHour24(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseMinutes(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseSeconds(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseMilliseconds(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseMicroseconds(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseLiteralPercent(d, string, i) {
    var n = $44fe361b644f94fb$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $44fe361b644f94fb$var$parseUnixTimestamp(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $44fe361b644f94fb$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $44fe361b644f94fb$var$formatDayOfMonth(d, p) {
    return $44fe361b644f94fb$var$pad(d.getDate(), p, 2);
}
function $44fe361b644f94fb$var$formatHour24(d, p) {
    return $44fe361b644f94fb$var$pad(d.getHours(), p, 2);
}
function $44fe361b644f94fb$var$formatHour12(d, p) {
    return $44fe361b644f94fb$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $44fe361b644f94fb$var$formatDayOfYear(d, p) {
    return $44fe361b644f94fb$var$pad(1 + (0, $0510fd4f155849d7$export$8888529b966033e5).count((0, $ddf3f8970489211a$export$cd17cfe45df0c046)(d), d), p, 3);
}
function $44fe361b644f94fb$var$formatMilliseconds(d, p) {
    return $44fe361b644f94fb$var$pad(d.getMilliseconds(), p, 3);
}
function $44fe361b644f94fb$var$formatMicroseconds(d, p) {
    return $44fe361b644f94fb$var$formatMilliseconds(d, p) + "000";
}
function $44fe361b644f94fb$var$formatMonthNumber(d, p) {
    return $44fe361b644f94fb$var$pad(d.getMonth() + 1, p, 2);
}
function $44fe361b644f94fb$var$formatMinutes(d, p) {
    return $44fe361b644f94fb$var$pad(d.getMinutes(), p, 2);
}
function $44fe361b644f94fb$var$formatSeconds(d, p) {
    return $44fe361b644f94fb$var$pad(d.getSeconds(), p, 2);
}
function $44fe361b644f94fb$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $44fe361b644f94fb$var$formatWeekNumberSunday(d, p) {
    return $44fe361b644f94fb$var$pad((0, $829beff7f10c8695$export$22ee6205b762968c).count((0, $ddf3f8970489211a$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $44fe361b644f94fb$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $829beff7f10c8695$export$608689422d5cf9f4)(d) : (0, $829beff7f10c8695$export$608689422d5cf9f4).ceil(d);
}
function $44fe361b644f94fb$var$formatWeekNumberISO(d, p) {
    d = $44fe361b644f94fb$var$dISO(d);
    return $44fe361b644f94fb$var$pad((0, $829beff7f10c8695$export$608689422d5cf9f4).count((0, $ddf3f8970489211a$export$cd17cfe45df0c046)(d), d) + ((0, $ddf3f8970489211a$export$cd17cfe45df0c046)(d).getDay() === 4), p, 2);
}
function $44fe361b644f94fb$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $44fe361b644f94fb$var$formatWeekNumberMonday(d, p) {
    return $44fe361b644f94fb$var$pad((0, $829beff7f10c8695$export$e79bbe0177cf1b01).count((0, $ddf3f8970489211a$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $44fe361b644f94fb$var$formatYear(d, p) {
    return $44fe361b644f94fb$var$pad(d.getFullYear() % 100, p, 2);
}
function $44fe361b644f94fb$var$formatYearISO(d, p) {
    d = $44fe361b644f94fb$var$dISO(d);
    return $44fe361b644f94fb$var$pad(d.getFullYear() % 100, p, 2);
}
function $44fe361b644f94fb$var$formatFullYear(d, p) {
    return $44fe361b644f94fb$var$pad(d.getFullYear() % 10000, p, 4);
}
function $44fe361b644f94fb$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $829beff7f10c8695$export$608689422d5cf9f4)(d) : (0, $829beff7f10c8695$export$608689422d5cf9f4).ceil(d);
    return $44fe361b644f94fb$var$pad(d.getFullYear() % 10000, p, 4);
}
function $44fe361b644f94fb$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $44fe361b644f94fb$var$pad(z / 60 | 0, "0", 2) + $44fe361b644f94fb$var$pad(z % 60, "0", 2);
}
function $44fe361b644f94fb$var$formatUTCDayOfMonth(d, p) {
    return $44fe361b644f94fb$var$pad(d.getUTCDate(), p, 2);
}
function $44fe361b644f94fb$var$formatUTCHour24(d, p) {
    return $44fe361b644f94fb$var$pad(d.getUTCHours(), p, 2);
}
function $44fe361b644f94fb$var$formatUTCHour12(d, p) {
    return $44fe361b644f94fb$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $44fe361b644f94fb$var$formatUTCDayOfYear(d, p) {
    return $44fe361b644f94fb$var$pad(1 + (0, $0510fd4f155849d7$export$c8cbc42cefd47140).count((0, $ddf3f8970489211a$export$d5c3802e389714c4)(d), d), p, 3);
}
function $44fe361b644f94fb$var$formatUTCMilliseconds(d, p) {
    return $44fe361b644f94fb$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $44fe361b644f94fb$var$formatUTCMicroseconds(d, p) {
    return $44fe361b644f94fb$var$formatUTCMilliseconds(d, p) + "000";
}
function $44fe361b644f94fb$var$formatUTCMonthNumber(d, p) {
    return $44fe361b644f94fb$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $44fe361b644f94fb$var$formatUTCMinutes(d, p) {
    return $44fe361b644f94fb$var$pad(d.getUTCMinutes(), p, 2);
}
function $44fe361b644f94fb$var$formatUTCSeconds(d, p) {
    return $44fe361b644f94fb$var$pad(d.getUTCSeconds(), p, 2);
}
function $44fe361b644f94fb$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $44fe361b644f94fb$var$formatUTCWeekNumberSunday(d, p) {
    return $44fe361b644f94fb$var$pad((0, $829beff7f10c8695$export$4898b06303a92011).count((0, $ddf3f8970489211a$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $44fe361b644f94fb$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $829beff7f10c8695$export$1db08111baec2f53)(d) : (0, $829beff7f10c8695$export$1db08111baec2f53).ceil(d);
}
function $44fe361b644f94fb$var$formatUTCWeekNumberISO(d, p) {
    d = $44fe361b644f94fb$var$UTCdISO(d);
    return $44fe361b644f94fb$var$pad((0, $829beff7f10c8695$export$1db08111baec2f53).count((0, $ddf3f8970489211a$export$d5c3802e389714c4)(d), d) + ((0, $ddf3f8970489211a$export$d5c3802e389714c4)(d).getUTCDay() === 4), p, 2);
}
function $44fe361b644f94fb$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $44fe361b644f94fb$var$formatUTCWeekNumberMonday(d, p) {
    return $44fe361b644f94fb$var$pad((0, $829beff7f10c8695$export$9cfc53b9cfafd080).count((0, $ddf3f8970489211a$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $44fe361b644f94fb$var$formatUTCYear(d, p) {
    return $44fe361b644f94fb$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $44fe361b644f94fb$var$formatUTCYearISO(d, p) {
    d = $44fe361b644f94fb$var$UTCdISO(d);
    return $44fe361b644f94fb$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $44fe361b644f94fb$var$formatUTCFullYear(d, p) {
    return $44fe361b644f94fb$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $44fe361b644f94fb$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $829beff7f10c8695$export$1db08111baec2f53)(d) : (0, $829beff7f10c8695$export$1db08111baec2f53).ceil(d);
    return $44fe361b644f94fb$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $44fe361b644f94fb$var$formatUTCZone() {
    return "+0000";
}
function $44fe361b644f94fb$var$formatLiteralPercent() {
    return "%";
}
function $44fe361b644f94fb$var$formatUnixTimestamp(d) {
    return +d;
}
function $44fe361b644f94fb$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $d227e7bf2f197803$var$locale;
var $d227e7bf2f197803$export$94f4d87fad5dcf9a;
var $d227e7bf2f197803$export$32b9cd16e1b8c8d2;
var $d227e7bf2f197803$export$1a08fe38f63ebbbb;
var $d227e7bf2f197803$export$3edae9cf8e233729;
$d227e7bf2f197803$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $d227e7bf2f197803$export$2e2bcd8739ae039(definition) {
    $d227e7bf2f197803$var$locale = (0, $44fe361b644f94fb$export$2e2bcd8739ae039)(definition);
    $d227e7bf2f197803$export$94f4d87fad5dcf9a = $d227e7bf2f197803$var$locale.format;
    $d227e7bf2f197803$export$32b9cd16e1b8c8d2 = $d227e7bf2f197803$var$locale.parse;
    $d227e7bf2f197803$export$1a08fe38f63ebbbb = $d227e7bf2f197803$var$locale.utcFormat;
    $d227e7bf2f197803$export$3edae9cf8e233729 = $d227e7bf2f197803$var$locale.utcParse;
    return $d227e7bf2f197803$var$locale;
}





function $c62717be14c35f93$var$date(t) {
    return new Date(t);
}
function $c62717be14c35f93$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $c62717be14c35f93$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $f2eaa3e16911c52c$export$2e2bcd8739ae039)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $c62717be14c35f93$var$number)) : domain().map($c62717be14c35f93$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $b290e0a21701388e$export$2e2bcd8739ae039)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $f2eaa3e16911c52c$export$784d13d8ee351f07)(scale, $c62717be14c35f93$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $c62717be14c35f93$export$2e2bcd8739ae039() {
    return (0, $f8605c04d320312f$export$23c7bb9e6558da2a).apply($c62717be14c35f93$export$56bbcdb8aca31149((0, $c71cf5d5cab5b066$export$60c76498552d28a6), (0, $c71cf5d5cab5b066$export$69511150134dd174), (0, $ddf3f8970489211a$export$cd17cfe45df0c046), (0, $f49497a07f26fc9e$export$7e1084fb688591c1), (0, $829beff7f10c8695$export$22ee6205b762968c), (0, $0510fd4f155849d7$export$8888529b966033e5), (0, $71bc9e75aba412b8$export$46c68a5833bc315b), (0, $7af3d84c55f5e66a$export$a7e4c34a52f0576), (0, $88f32e66450fe893$export$3d3c77ce7df7d30d), (0, $d227e7bf2f197803$export$94f4d87fad5dcf9a)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}






function $3a16a604f7bb8175$export$2e2bcd8739ae039() {
    return (0, $f8605c04d320312f$export$23c7bb9e6558da2a).apply((0, $c62717be14c35f93$export$56bbcdb8aca31149)((0, $c71cf5d5cab5b066$export$826ba5ae907e9767), (0, $c71cf5d5cab5b066$export$6262d8d056ea44c4), (0, $ddf3f8970489211a$export$d5c3802e389714c4), (0, $f49497a07f26fc9e$export$cd49b3d2bcfe50d5), (0, $829beff7f10c8695$export$4898b06303a92011), (0, $0510fd4f155849d7$export$c8cbc42cefd47140), (0, $71bc9e75aba412b8$export$31f6f2b3c63ac75e), (0, $7af3d84c55f5e66a$export$efe6712d6003761b), (0, $88f32e66450fe893$export$3d3c77ce7df7d30d), (0, $d227e7bf2f197803$export$1a08fe38f63ebbbb)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}









function $c7cde8d62e1e3e5c$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $f2eaa3e16911c52c$export$f0954fd7d5368655), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $fdef680a1ac134b1$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $56f517ab42b48aac$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $c7cde8d62e1e3e5c$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $c7cde8d62e1e3e5c$export$2e2bcd8739ae039() {
    var scale = (0, $0a099a6407198660$export$16a5d4b4a61a274d)($c7cde8d62e1e3e5c$var$transformer()((0, $f2eaa3e16911c52c$export$f0954fd7d5368655)));
    scale.copy = function() {
        return $c7cde8d62e1e3e5c$export$784d13d8ee351f07(scale, $c7cde8d62e1e3e5c$export$2e2bcd8739ae039());
    };
    return (0, $f8605c04d320312f$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $c7cde8d62e1e3e5c$export$6843e08bf2ff981f() {
    var scale = (0, $2e8e773e88cd103f$export$860836db074028f0)($c7cde8d62e1e3e5c$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $c7cde8d62e1e3e5c$export$784d13d8ee351f07(scale, $c7cde8d62e1e3e5c$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $f8605c04d320312f$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $c7cde8d62e1e3e5c$export$9d4af4de62c81941() {
    var scale = (0, $b5bfb562709c245a$export$4602684e614eba38)($c7cde8d62e1e3e5c$var$transformer());
    scale.copy = function() {
        return $c7cde8d62e1e3e5c$export$784d13d8ee351f07(scale, $c7cde8d62e1e3e5c$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $f8605c04d320312f$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $c7cde8d62e1e3e5c$export$de9f78581b4f2405() {
    var scale = (0, $78083bc3056bf6a5$export$34695211ec403a46)($c7cde8d62e1e3e5c$var$transformer());
    scale.copy = function() {
        return $c7cde8d62e1e3e5c$export$784d13d8ee351f07(scale, $c7cde8d62e1e3e5c$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $f8605c04d320312f$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $c7cde8d62e1e3e5c$export$413d935127ed466e() {
    return $c7cde8d62e1e3e5c$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}





function $8b7121ace5a11a57$export$2e2bcd8739ae039() {
    var domain = [], interpolator = (0, $f2eaa3e16911c52c$export$f0954fd7d5368655);
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $263d20e47b8a3378$export$2e2bcd8739ae039)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $f64c55ab13ca9913$export$2e2bcd8739ae039));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $058a580f1d366c99$export$2e2bcd8739ae039)(domain, i / n));
    };
    scale.copy = function() {
        return $8b7121ace5a11a57$export$2e2bcd8739ae039(interpolator).domain(domain);
    };
    return (0, $f8605c04d320312f$export$7d6b419e59e83f3d).apply(scale, arguments);
}










function $b0a2f805036835c3$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, $f2eaa3e16911c52c$export$f0954fd7d5368655), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $2adf3d3588dadf1c$export$2e2bcd8739ae039)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $fdef680a1ac134b1$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $56f517ab42b48aac$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $b0a2f805036835c3$export$2e2bcd8739ae039() {
    var scale = (0, $0a099a6407198660$export$16a5d4b4a61a274d)($b0a2f805036835c3$var$transformer()((0, $f2eaa3e16911c52c$export$f0954fd7d5368655)));
    scale.copy = function() {
        return (0, $c7cde8d62e1e3e5c$export$784d13d8ee351f07)(scale, $b0a2f805036835c3$export$2e2bcd8739ae039());
    };
    return (0, $f8605c04d320312f$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $b0a2f805036835c3$export$5f0266a9159c47fb() {
    var scale = (0, $2e8e773e88cd103f$export$860836db074028f0)($b0a2f805036835c3$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $c7cde8d62e1e3e5c$export$784d13d8ee351f07)(scale, $b0a2f805036835c3$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $f8605c04d320312f$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $b0a2f805036835c3$export$50b3da713cf557c6() {
    var scale = (0, $b5bfb562709c245a$export$4602684e614eba38)($b0a2f805036835c3$var$transformer());
    scale.copy = function() {
        return (0, $c7cde8d62e1e3e5c$export$784d13d8ee351f07)(scale, $b0a2f805036835c3$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $f8605c04d320312f$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $b0a2f805036835c3$export$d6cedcc63bf26e7e() {
    var scale = (0, $78083bc3056bf6a5$export$34695211ec403a46)($b0a2f805036835c3$var$transformer());
    scale.copy = function() {
        return (0, $c7cde8d62e1e3e5c$export$784d13d8ee351f07)(scale, $b0a2f805036835c3$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $f8605c04d320312f$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $b0a2f805036835c3$export$33ddefb5c4ab9e9c() {
    return $b0a2f805036835c3$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}





var $32ba1530b4c192a4$exports = {};

$parcel$export($32ba1530b4c192a4$exports, "schemeCategory10", () => $0285681af2a07737$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeAccent", () => $5f0ded1b1a4ed4ad$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeDark2", () => $dba99e1f9d95e5b2$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemePaired", () => $5f5255330cc927e0$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemePastel1", () => $0ee5c6fe1e2eefc8$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemePastel2", () => $666f18b0ad56f11d$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeSet1", () => $c8dfa1af4ccbf714$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeSet2", () => $bd836bed6800c42e$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeSet3", () => $4abdc5938c536c85$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeTableau10", () => $40ecd71de5f37da2$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "interpolateBrBG", () => $dc2bb522fe958b38$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeBrBG", () => $dc2bb522fe958b38$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolatePRGn", () => $49dc4eb21f63cf13$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemePRGn", () => $49dc4eb21f63cf13$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolatePiYG", () => $3468282ecaf9e2e9$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemePiYG", () => $3468282ecaf9e2e9$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolatePuOr", () => $022c36d1c0e17538$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemePuOr", () => $022c36d1c0e17538$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateRdBu", () => $3c5f3b289a8a2a94$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeRdBu", () => $3c5f3b289a8a2a94$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateRdGy", () => $f5f903c3439b33a5$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeRdGy", () => $f5f903c3439b33a5$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateRdYlBu", () => $ab7dc1f761af4807$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeRdYlBu", () => $ab7dc1f761af4807$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateRdYlGn", () => $7dd0d264b45055fc$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeRdYlGn", () => $7dd0d264b45055fc$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateSpectral", () => $30be565053fb5d42$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeSpectral", () => $30be565053fb5d42$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateBuGn", () => $cb4a62197f76c682$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeBuGn", () => $cb4a62197f76c682$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateBuPu", () => $4238bdc227c6ca25$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeBuPu", () => $4238bdc227c6ca25$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateGnBu", () => $05817d762639a095$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeGnBu", () => $05817d762639a095$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateOrRd", () => $38034980f6bda2a5$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeOrRd", () => $38034980f6bda2a5$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolatePuBuGn", () => $a76903c13653a6d1$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemePuBuGn", () => $a76903c13653a6d1$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolatePuBu", () => $c3e97c3a0db0ca56$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemePuBu", () => $c3e97c3a0db0ca56$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolatePuRd", () => $dbd0906b7053070d$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemePuRd", () => $dbd0906b7053070d$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateRdPu", () => $46b90c53da26fefa$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeRdPu", () => $46b90c53da26fefa$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateYlGnBu", () => $2c4195ab8c467a0f$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeYlGnBu", () => $2c4195ab8c467a0f$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateYlGn", () => $a730232f239678e9$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeYlGn", () => $a730232f239678e9$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateYlOrBr", () => $7a4ab6ef2873bf28$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeYlOrBr", () => $7a4ab6ef2873bf28$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateYlOrRd", () => $a984bd0217112e01$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeYlOrRd", () => $a984bd0217112e01$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateBlues", () => $032a1c9cc5999b06$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeBlues", () => $032a1c9cc5999b06$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateGreens", () => $a6e1969b89f32f43$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeGreens", () => $a6e1969b89f32f43$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateGreys", () => $2f5506ba5d0de794$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeGreys", () => $2f5506ba5d0de794$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolatePurples", () => $5178b4a5498fc064$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemePurples", () => $5178b4a5498fc064$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateReds", () => $ec3b10c71f571543$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeReds", () => $ec3b10c71f571543$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateOranges", () => $85f057a08e6cbc18$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "schemeOranges", () => $85f057a08e6cbc18$export$3005042704f95a69);
$parcel$export($32ba1530b4c192a4$exports, "interpolateCividis", () => $8c259962be79bed1$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "interpolateCubehelixDefault", () => $c8c9cfc5a9523981$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "interpolateRainbow", () => $0f422e4c16db85fd$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "interpolateWarm", () => $0f422e4c16db85fd$export$fc70efcec537be98);
$parcel$export($32ba1530b4c192a4$exports, "interpolateCool", () => $0f422e4c16db85fd$export$c5cedbc1ab3be2c3);
$parcel$export($32ba1530b4c192a4$exports, "interpolateSinebow", () => $7389f00a359b75a2$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "interpolateTurbo", () => $3ec05b733673cd7c$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "interpolateViridis", () => $f30993525053f120$export$2e2bcd8739ae039);
$parcel$export($32ba1530b4c192a4$exports, "interpolateMagma", () => $f30993525053f120$export$c41e69203f572e8d);
$parcel$export($32ba1530b4c192a4$exports, "interpolateInferno", () => $f30993525053f120$export$ad0c8285c8ea6dbd);
$parcel$export($32ba1530b4c192a4$exports, "interpolatePlasma", () => $f30993525053f120$export$6664860a633d9daf);
function $c8a29cfdae9a80d0$export$2e2bcd8739ae039(specifier) {
    var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
    while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
    return colors;
}


var $0285681af2a07737$export$2e2bcd8739ae039 = (0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");



var $5f0ded1b1a4ed4ad$export$2e2bcd8739ae039 = (0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");



var $dba99e1f9d95e5b2$export$2e2bcd8739ae039 = (0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");



var $5f5255330cc927e0$export$2e2bcd8739ae039 = (0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");



var $0ee5c6fe1e2eefc8$export$2e2bcd8739ae039 = (0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");



var $666f18b0ad56f11d$export$2e2bcd8739ae039 = (0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");



var $c8dfa1af4ccbf714$export$2e2bcd8739ae039 = (0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");



var $bd836bed6800c42e$export$2e2bcd8739ae039 = (0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");



var $4abdc5938c536c85$export$2e2bcd8739ae039 = (0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");



var $40ecd71de5f37da2$export$2e2bcd8739ae039 = (0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039)("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");




var $bc68644ff931fb92$export$2e2bcd8739ae039 = (scheme)=>(0, $71264ae493339a33$export$2c0e28f2e2852d3f)(scheme[scheme.length - 1]);


var $dc2bb522fe958b38$export$3005042704f95a69 = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $dc2bb522fe958b38$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($dc2bb522fe958b38$export$3005042704f95a69);




var $49dc4eb21f63cf13$export$3005042704f95a69 = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $49dc4eb21f63cf13$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($49dc4eb21f63cf13$export$3005042704f95a69);




var $3468282ecaf9e2e9$export$3005042704f95a69 = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $3468282ecaf9e2e9$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($3468282ecaf9e2e9$export$3005042704f95a69);




var $022c36d1c0e17538$export$3005042704f95a69 = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $022c36d1c0e17538$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($022c36d1c0e17538$export$3005042704f95a69);




var $3c5f3b289a8a2a94$export$3005042704f95a69 = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $3c5f3b289a8a2a94$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($3c5f3b289a8a2a94$export$3005042704f95a69);




var $f5f903c3439b33a5$export$3005042704f95a69 = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $f5f903c3439b33a5$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($f5f903c3439b33a5$export$3005042704f95a69);




var $ab7dc1f761af4807$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $ab7dc1f761af4807$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($ab7dc1f761af4807$export$3005042704f95a69);




var $7dd0d264b45055fc$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $7dd0d264b45055fc$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($7dd0d264b45055fc$export$3005042704f95a69);




var $30be565053fb5d42$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $30be565053fb5d42$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($30be565053fb5d42$export$3005042704f95a69);




var $cb4a62197f76c682$export$3005042704f95a69 = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $cb4a62197f76c682$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($cb4a62197f76c682$export$3005042704f95a69);




var $4238bdc227c6ca25$export$3005042704f95a69 = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $4238bdc227c6ca25$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($4238bdc227c6ca25$export$3005042704f95a69);




var $05817d762639a095$export$3005042704f95a69 = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $05817d762639a095$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($05817d762639a095$export$3005042704f95a69);




var $38034980f6bda2a5$export$3005042704f95a69 = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $38034980f6bda2a5$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($38034980f6bda2a5$export$3005042704f95a69);




var $a76903c13653a6d1$export$3005042704f95a69 = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $a76903c13653a6d1$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($a76903c13653a6d1$export$3005042704f95a69);




var $c3e97c3a0db0ca56$export$3005042704f95a69 = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $c3e97c3a0db0ca56$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($c3e97c3a0db0ca56$export$3005042704f95a69);




var $dbd0906b7053070d$export$3005042704f95a69 = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $dbd0906b7053070d$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($dbd0906b7053070d$export$3005042704f95a69);




var $46b90c53da26fefa$export$3005042704f95a69 = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $46b90c53da26fefa$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($46b90c53da26fefa$export$3005042704f95a69);




var $2c4195ab8c467a0f$export$3005042704f95a69 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $2c4195ab8c467a0f$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($2c4195ab8c467a0f$export$3005042704f95a69);




var $a730232f239678e9$export$3005042704f95a69 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $a730232f239678e9$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($a730232f239678e9$export$3005042704f95a69);




var $7a4ab6ef2873bf28$export$3005042704f95a69 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $7a4ab6ef2873bf28$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($7a4ab6ef2873bf28$export$3005042704f95a69);




var $a984bd0217112e01$export$3005042704f95a69 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $a984bd0217112e01$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($a984bd0217112e01$export$3005042704f95a69);




var $032a1c9cc5999b06$export$3005042704f95a69 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $032a1c9cc5999b06$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($032a1c9cc5999b06$export$3005042704f95a69);




var $a6e1969b89f32f43$export$3005042704f95a69 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $a6e1969b89f32f43$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($a6e1969b89f32f43$export$3005042704f95a69);




var $2f5506ba5d0de794$export$3005042704f95a69 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $2f5506ba5d0de794$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($2f5506ba5d0de794$export$3005042704f95a69);




var $5178b4a5498fc064$export$3005042704f95a69 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $5178b4a5498fc064$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($5178b4a5498fc064$export$3005042704f95a69);




var $ec3b10c71f571543$export$3005042704f95a69 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $ec3b10c71f571543$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($ec3b10c71f571543$export$3005042704f95a69);




var $85f057a08e6cbc18$export$3005042704f95a69 = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039));
var $85f057a08e6cbc18$export$2e2bcd8739ae039 = (0, $bc68644ff931fb92$export$2e2bcd8739ae039)($85f057a08e6cbc18$export$3005042704f95a69);


function $8c259962be79bed1$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}




var $c8c9cfc5a9523981$export$2e2bcd8739ae039 = (0, $71cfe7fab883bd8a$export$934fa09ad474a1b4)((0, $2e4646047aa20e81$export$2e2bcd8739ae039)(300, 0.5, 0.0), (0, $2e4646047aa20e81$export$2e2bcd8739ae039)(-240, 0.5, 1.0));




var $0f422e4c16db85fd$export$fc70efcec537be98 = (0, $71cfe7fab883bd8a$export$934fa09ad474a1b4)((0, $2e4646047aa20e81$export$2e2bcd8739ae039)(-100, 0.75, 0.35), (0, $2e4646047aa20e81$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $0f422e4c16db85fd$export$c5cedbc1ab3be2c3 = (0, $71cfe7fab883bd8a$export$934fa09ad474a1b4)((0, $2e4646047aa20e81$export$2e2bcd8739ae039)(260, 0.75, 0.35), (0, $2e4646047aa20e81$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $0f422e4c16db85fd$var$c = (0, $2e4646047aa20e81$export$2e2bcd8739ae039)();
function $0f422e4c16db85fd$export$2e2bcd8739ae039(t) {
    if (t < 0 || t > 1) t -= Math.floor(t);
    var ts = Math.abs(t - 0.5);
    $0f422e4c16db85fd$var$c.h = 360 * t - 100;
    $0f422e4c16db85fd$var$c.s = 1.5 - 1.5 * ts;
    $0f422e4c16db85fd$var$c.l = 0.8 - 0.9 * ts;
    return $0f422e4c16db85fd$var$c + "";
}



var $gisW9 = parcelRequire("gisW9");
var $7389f00a359b75a2$var$c = (0, $gisW9.rgb)(), $7389f00a359b75a2$var$pi_1_3 = Math.PI / 3, $7389f00a359b75a2$var$pi_2_3 = Math.PI * 2 / 3;
function $7389f00a359b75a2$export$2e2bcd8739ae039(t) {
    var x;
    t = (0.5 - t) * Math.PI;
    $7389f00a359b75a2$var$c.r = 255 * (x = Math.sin(t)) * x;
    $7389f00a359b75a2$var$c.g = 255 * (x = Math.sin(t + $7389f00a359b75a2$var$pi_1_3)) * x;
    $7389f00a359b75a2$var$c.b = 255 * (x = Math.sin(t + $7389f00a359b75a2$var$pi_2_3)) * x;
    return $7389f00a359b75a2$var$c + "";
}


function $3ec05b733673cd7c$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}



function $f30993525053f120$var$ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
var $f30993525053f120$export$2e2bcd8739ae039 = $f30993525053f120$var$ramp((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var $f30993525053f120$export$c41e69203f572e8d = $f30993525053f120$var$ramp((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var $f30993525053f120$export$ad0c8285c8ea6dbd = $f30993525053f120$var$ramp((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var $f30993525053f120$export$6664860a633d9daf = $f30993525053f120$var$ramp((0, $c8a29cfdae9a80d0$export$2e2bcd8739ae039)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));




var $8ef8f659f1c2214e$exports = {};

$parcel$export($8ef8f659f1c2214e$exports, "create", () => $ad8b9b19f3290ba2$export$2e2bcd8739ae039);
$parcel$export($8ef8f659f1c2214e$exports, "creator", () => $a5c2223f44c4b5b7$export$2e2bcd8739ae039);
$parcel$export($8ef8f659f1c2214e$exports, "local", () => $375ca69e5452e651$export$2e2bcd8739ae039);
$parcel$export($8ef8f659f1c2214e$exports, "matcher", () => $0f1039f38e52fb7d$export$2e2bcd8739ae039);
$parcel$export($8ef8f659f1c2214e$exports, "namespace", () => $19191a1b5ffaa8c1$export$2e2bcd8739ae039);
$parcel$export($8ef8f659f1c2214e$exports, "namespaces", () => $a3b29abb9e79fdd3$export$2e2bcd8739ae039);
$parcel$export($8ef8f659f1c2214e$exports, "pointer", () => $01126f29f8cc9cfb$export$2e2bcd8739ae039);
$parcel$export($8ef8f659f1c2214e$exports, "pointers", () => $b9b85dd18532e22e$export$2e2bcd8739ae039);
$parcel$export($8ef8f659f1c2214e$exports, "select", () => $c38382a82e61d17a$export$2e2bcd8739ae039);
$parcel$export($8ef8f659f1c2214e$exports, "selectAll", () => $cb6a5fec880df491$export$2e2bcd8739ae039);
$parcel$export($8ef8f659f1c2214e$exports, "selection", () => $c7a3341731fa3134$export$2e2bcd8739ae039);
$parcel$export($8ef8f659f1c2214e$exports, "selector", () => $90fcd2cfb31c5c0b$export$2e2bcd8739ae039);
$parcel$export($8ef8f659f1c2214e$exports, "selectorAll", () => $52a7a1b454645792$export$2e2bcd8739ae039);
$parcel$export($8ef8f659f1c2214e$exports, "style", () => $8dc8fef8928e5abd$export$5e3cec964f0b5efd);
$parcel$export($8ef8f659f1c2214e$exports, "window", () => $b5c39d7204a2477a$export$2e2bcd8739ae039);


function $ad8b9b19f3290ba2$export$2e2bcd8739ae039(name) {
    return (0, $c38382a82e61d17a$export$2e2bcd8739ae039)((0, $a5c2223f44c4b5b7$export$2e2bcd8739ae039)(name).call(document.documentElement));
}



var $375ca69e5452e651$var$nextId = 0;
function $375ca69e5452e651$export$2e2bcd8739ae039() {
    return new $375ca69e5452e651$var$Local;
}
function $375ca69e5452e651$var$Local() {
    this._ = "@" + (++$375ca69e5452e651$var$nextId).toString(36);
}
$375ca69e5452e651$var$Local.prototype = $375ca69e5452e651$export$2e2bcd8739ae039.prototype = {
    constructor: $375ca69e5452e651$var$Local,
    get: function(node) {
        var id = this._;
        while(!(id in node))if (!(node = node.parentNode)) return;
        return node[id];
    },
    set: function(node, value) {
        return node[this._] = value;
    },
    remove: function(node) {
        return this._ in node && delete node[this._];
    },
    toString: function() {
        return this._;
    }
};








function $b9b85dd18532e22e$export$2e2bcd8739ae039(events, node) {
    if (events.target) {
        events = (0, $35308b9a8dd4304c$export$2e2bcd8739ae039)(events);
        if (node === undefined) node = events.currentTarget;
        events = events.touches || [
            events
        ];
    }
    return Array.from(events, (event)=>(0, $01126f29f8cc9cfb$export$2e2bcd8739ae039)(event, node));
}





function $cb6a5fec880df491$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $c7a3341731fa3134$export$52baac22726c72bf)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $c7a3341731fa3134$export$52baac22726c72bf)([
        (0, $ba07a0cf1948a8eb$export$2e2bcd8739ae039)(selector)
    ], (0, $c7a3341731fa3134$export$e8e78c978b129247));
}









var $4f002fc54a73d992$exports = {};

$parcel$export($4f002fc54a73d992$exports, "arc", () => $2519d5065eb17914$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "area", () => $788e765728842347$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "line", () => $9ee317ec5fdf75e2$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "pie", () => $bb11e7478fce2a47$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "areaRadial", () => $f23fef98bcf93ca7$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "radialArea", () => $f23fef98bcf93ca7$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "lineRadial", () => $663679e7ab88253d$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "radialLine", () => $663679e7ab88253d$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "pointRadial", () => $871a1510c5a344ac$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "link", () => $5e763394b4280491$export$9c30223ca0a664fb);
$parcel$export($4f002fc54a73d992$exports, "linkHorizontal", () => $5e763394b4280491$export$e7c381889b2cd14d);
$parcel$export($4f002fc54a73d992$exports, "linkVertical", () => $5e763394b4280491$export$75de4c8c66884e04);
$parcel$export($4f002fc54a73d992$exports, "linkRadial", () => $5e763394b4280491$export$7739cfe68d4e0799);
$parcel$export($4f002fc54a73d992$exports, "symbol", () => $029e321f2b0593fb$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "symbolsStroke", () => $029e321f2b0593fb$export$915e06de6acf8fe);
$parcel$export($4f002fc54a73d992$exports, "symbolsFill", () => $029e321f2b0593fb$export$19158c96a6700c15);
$parcel$export($4f002fc54a73d992$exports, "symbols", () => $029e321f2b0593fb$export$19158c96a6700c15);
$parcel$export($4f002fc54a73d992$exports, "symbolAsterisk", () => $63d443cc70805b64$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "symbolCircle", () => $2fad96d340a028f2$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "symbolCross", () => $5fffe77e6e64954c$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "symbolDiamond", () => $9df2df4fb67a0d51$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "symbolDiamond2", () => $4872155e08983436$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "symbolPlus", () => $fde9c58f45c7f298$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "symbolSquare", () => $e4116d2296c82d82$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "symbolSquare2", () => $b53fcdacf573c6af$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "symbolStar", () => $9e5dc91122e065da$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "symbolTriangle", () => $906ec55b6bead206$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "symbolTriangle2", () => $b7b531e503e939dd$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "symbolWye", () => $a704f0b9f6cc93cb$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "symbolTimes", () => $7554f66ddccbb0d0$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "symbolX", () => $7554f66ddccbb0d0$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "curveBasisClosed", () => $05a0567bd9680b1b$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "curveBasisOpen", () => $6c1a919714a504bd$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "curveBasis", () => $f1d94120dd67e173$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "curveBumpX", () => $ae92cfd737aa5b29$export$2c099b5096f70ce6);
$parcel$export($4f002fc54a73d992$exports, "curveBumpY", () => $ae92cfd737aa5b29$export$908da9dfa54cbed6);
$parcel$export($4f002fc54a73d992$exports, "curveBundle", () => $e39ff5e7f4c8ed39$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "curveCardinalClosed", () => $d702e430e5aef10b$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "curveCardinalOpen", () => $59658346d42cc3e7$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "curveCardinal", () => (parcelRequire("hpcPW")).default);
$parcel$export($4f002fc54a73d992$exports, "curveCatmullRomClosed", () => $9db9a208bb77ee0f$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "curveCatmullRomOpen", () => $802ebba5a0efb8d9$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "curveCatmullRom", () => (parcelRequire("61ebs")).default);
$parcel$export($4f002fc54a73d992$exports, "curveLinearClosed", () => $fad3f82d4445c25b$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "curveLinear", () => $6ced360e5b202aec$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "curveMonotoneX", () => $c178b0c170a2e4cf$export$99563b5420dbdc55);
$parcel$export($4f002fc54a73d992$exports, "curveMonotoneY", () => $c178b0c170a2e4cf$export$8b5360456d6bdb88);
$parcel$export($4f002fc54a73d992$exports, "curveNatural", () => $fed03e81b7aee77f$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "curveStep", () => $3ff1699e8143ef4b$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "curveStepAfter", () => $3ff1699e8143ef4b$export$793b3db073781cbb);
$parcel$export($4f002fc54a73d992$exports, "curveStepBefore", () => $3ff1699e8143ef4b$export$10eafa5b7478b343);
$parcel$export($4f002fc54a73d992$exports, "stack", () => $7c6d90e966079d12$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "stackOffsetExpand", () => $a7123a37f4cda083$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "stackOffsetDiverging", () => $4a58bb06cc38b066$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "stackOffsetNone", () => $8bf2c729606f77a9$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "stackOffsetSilhouette", () => $750cdc94002e3779$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "stackOffsetWiggle", () => $2aff8fe4039d81ec$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "stackOrderAppearance", () => $955f901550f4b858$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "stackOrderAscending", () => $8f511ba65f035587$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "stackOrderDescending", () => $de369c07536c71be$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "stackOrderInsideOut", () => $e28c8eaab91ca549$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "stackOrderNone", () => $b7870e60c963d51c$export$2e2bcd8739ae039);
$parcel$export($4f002fc54a73d992$exports, "stackOrderReverse", () => $e580a682dfe2df28$export$2e2bcd8739ae039);
function $e37b3936d07e3353$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}



var $5Wuwv = parcelRequire("5Wuwv");

function $ce5e56282a56a8c7$export$fb6e83118a5dcd45(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, $2e4cb56f5089693f$export$4b2950bdac9b6ee9)(digits);
}


function $2519d5065eb17914$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $2519d5065eb17914$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $2519d5065eb17914$var$arcStartAngle(d) {
    return d.startAngle;
}
function $2519d5065eb17914$var$arcEndAngle(d) {
    return d.endAngle;
}
function $2519d5065eb17914$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $2519d5065eb17914$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, $5Wuwv.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $2519d5065eb17914$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $5Wuwv.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $5Wuwv.sqrt)((0, $5Wuwv.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $2519d5065eb17914$export$2e2bcd8739ae039() {
    var innerRadius = $2519d5065eb17914$var$arcInnerRadius, outerRadius = $2519d5065eb17914$var$arcOuterRadius, cornerRadius = (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(0), padRadius = null, startAngle = $2519d5065eb17914$var$arcStartAngle, endAngle = $2519d5065eb17914$var$arcEndAngle, padAngle = $2519d5065eb17914$var$arcPadAngle, context = null, path = (0, $ce5e56282a56a8c7$export$fb6e83118a5dcd45)(arc);
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $5Wuwv.halfPi), a1 = endAngle.apply(this, arguments) - (0, $5Wuwv.halfPi), da = (0, $5Wuwv.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = path();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $5Wuwv.epsilon))) context.moveTo(0, 0);
        else if (da > (0, $5Wuwv.tau) - (0, $5Wuwv.epsilon)) {
            context.moveTo(r1 * (0, $5Wuwv.cos)(a0), r1 * (0, $5Wuwv.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $5Wuwv.epsilon)) {
                context.moveTo(r0 * (0, $5Wuwv.cos)(a1), r0 * (0, $5Wuwv.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $5Wuwv.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, $5Wuwv.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $5Wuwv.min)((0, $5Wuwv.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $5Wuwv.epsilon)) {
                var p0 = (0, $5Wuwv.asin)(rp / r0 * (0, $5Wuwv.sin)(ap)), p1 = (0, $5Wuwv.asin)(rp / r1 * (0, $5Wuwv.sin)(ap));
                if ((da0 -= p0 * 2) > (0, $5Wuwv.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $5Wuwv.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $5Wuwv.cos)(a01), y01 = r1 * (0, $5Wuwv.sin)(a01), x10 = r0 * (0, $5Wuwv.cos)(a10), y10 = r0 * (0, $5Wuwv.sin)(a10);
            // Apply rounded corners?
            if (rc > (0, $5Wuwv.epsilon)) {
                var x11 = r1 * (0, $5Wuwv.cos)(a11), y11 = r1 * (0, $5Wuwv.sin)(a11), x00 = r0 * (0, $5Wuwv.cos)(a00), y00 = r0 * (0, $5Wuwv.sin)(a00), oc;
                // Restrict the corner radius according to the sector angle. If this
                // intersection fails, it’s probably because the arc is too small, so
                // disable the corner radius entirely.
                if (da < (0, $5Wuwv.pi)) {
                    if (oc = $2519d5065eb17914$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $5Wuwv.sin)((0, $5Wuwv.acos)((ax * bx + ay * by) / ((0, $5Wuwv.sqrt)(ax * ax + ay * ay) * (0, $5Wuwv.sqrt)(bx * bx + by * by))) / 2), lc = (0, $5Wuwv.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = (0, $5Wuwv.min)(rc, (r0 - lc) / (kc - 1));
                        rc1 = (0, $5Wuwv.min)(rc, (r1 - lc) / (kc + 1));
                    } else rc0 = rc1 = 0;
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $5Wuwv.epsilon))) context.moveTo(x01, y01);
            else if (rc1 > (0, $5Wuwv.epsilon)) {
                t0 = $2519d5065eb17914$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $2519d5065eb17914$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $5Wuwv.atan2)(t0.y01, t0.x01), (0, $5Wuwv.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $5Wuwv.atan2)(t0.y01, t0.x01), (0, $5Wuwv.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $5Wuwv.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $5Wuwv.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $5Wuwv.atan2)(t1.y11, t1.x11), (0, $5Wuwv.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $5Wuwv.epsilon)) || !(da0 > (0, $5Wuwv.epsilon))) context.lineTo(x10, y10);
            else if (rc0 > (0, $5Wuwv.epsilon)) {
                t0 = $2519d5065eb17914$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $2519d5065eb17914$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $5Wuwv.atan2)(t0.y01, t0.x01), (0, $5Wuwv.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $5Wuwv.atan2)(t0.y01, t0.x01), (0, $5Wuwv.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $5Wuwv.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $5Wuwv.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $5Wuwv.atan2)(t1.y11, t1.x11), (0, $5Wuwv.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $5Wuwv.pi) / 2;
        return [
            (0, $5Wuwv.cos)(a) * r,
            (0, $5Wuwv.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}


var $18431644d88981bd$export$58adb3bec8346d0f = Array.prototype.slice;
function $18431644d88981bd$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}



function $6ced360e5b202aec$var$Linear(context) {
    this._context = context;
}
$6ced360e5b202aec$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $6ced360e5b202aec$export$2e2bcd8739ae039(context) {
    return new $6ced360e5b202aec$var$Linear(context);
}






function $d2ec527a7f8e727a$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $d2ec527a7f8e727a$export$4a5767248b18ef41(p) {
    return p[1];
}


function $9ee317ec5fdf75e2$export$2e2bcd8739ae039(x, y) {
    var defined = (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(true), context = null, curve = (0, $6ced360e5b202aec$export$2e2bcd8739ae039), output = null, path = (0, $ce5e56282a56a8c7$export$fb6e83118a5dcd45)(line);
    x = typeof x === "function" ? x : x === undefined ? (0, $d2ec527a7f8e727a$export$d141bba7fdc215a3) : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(x);
    y = typeof y === "function" ? y : y === undefined ? (0, $d2ec527a7f8e727a$export$4a5767248b18ef41) : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(y);
    function line(data) {
        var i, n = (data = (0, $18431644d88981bd$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}




function $788e765728842347$export$2e2bcd8739ae039(x0, y0, y1) {
    var x1 = null, defined = (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(true), context = null, curve = (0, $6ced360e5b202aec$export$2e2bcd8739ae039), output = null, path = (0, $ce5e56282a56a8c7$export$fb6e83118a5dcd45)(area);
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, $d2ec527a7f8e727a$export$d141bba7fdc215a3) : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(0) : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, $d2ec527a7f8e727a$export$4a5767248b18ef41) : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $18431644d88981bd$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $9ee317ec5fdf75e2$export$2e2bcd8739ae039)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}





function $3e5e164f5a88dd0c$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $c3a8872797798aa3$export$2e2bcd8739ae039(d) {
    return d;
}



var $5Wuwv = parcelRequire("5Wuwv");
function $bb11e7478fce2a47$export$2e2bcd8739ae039() {
    var value = (0, $c3a8872797798aa3$export$2e2bcd8739ae039), sortValues = (0, $3e5e164f5a88dd0c$export$2e2bcd8739ae039), sort = null, startAngle = (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(0), endAngle = (0, $e37b3936d07e3353$export$2e2bcd8739ae039)((0, $5Wuwv.tau)), padAngle = (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(0);
    function pie(data) {
        var i, n = (data = (0, $18431644d88981bd$export$2e2bcd8739ae039)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, $5Wuwv.tau), Math.max(-(0, $5Wuwv.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), pie) : padAngle;
    };
    return pie;
}



var $dfb35683d57011e6$export$22d25ffb9fb15b6f = $dfb35683d57011e6$export$2e2bcd8739ae039((0, $6ced360e5b202aec$export$2e2bcd8739ae039));
function $dfb35683d57011e6$var$Radial(curve) {
    this._curve = curve;
}
$dfb35683d57011e6$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $dfb35683d57011e6$export$2e2bcd8739ae039(curve) {
    function radial(context) {
        return new $dfb35683d57011e6$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}





function $663679e7ab88253d$export$4d8815a75dc8cd4d(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $dfb35683d57011e6$export$2e2bcd8739ae039)(_)) : c()._curve;
    };
    return l;
}
function $663679e7ab88253d$export$2e2bcd8739ae039() {
    return $663679e7ab88253d$export$4d8815a75dc8cd4d((0, $9ee317ec5fdf75e2$export$2e2bcd8739ae039)().curve((0, $dfb35683d57011e6$export$22d25ffb9fb15b6f)));
}


function $f23fef98bcf93ca7$export$2e2bcd8739ae039() {
    var a = (0, $788e765728842347$export$2e2bcd8739ae039)().curve((0, $dfb35683d57011e6$export$22d25ffb9fb15b6f)), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $663679e7ab88253d$export$4d8815a75dc8cd4d)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $663679e7ab88253d$export$4d8815a75dc8cd4d)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $663679e7ab88253d$export$4d8815a75dc8cd4d)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $663679e7ab88253d$export$4d8815a75dc8cd4d)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $dfb35683d57011e6$export$2e2bcd8739ae039)(_)) : c()._curve;
    };
    return a;
}



function $871a1510c5a344ac$export$2e2bcd8739ae039(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}





class $ae92cfd737aa5b29$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $ae92cfd737aa5b29$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point === 0) this._point = 1;
        else {
            const p0 = (0, $871a1510c5a344ac$export$2e2bcd8739ae039)(this._x0, this._y0);
            const p1 = (0, $871a1510c5a344ac$export$2e2bcd8739ae039)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $871a1510c5a344ac$export$2e2bcd8739ae039)(x, this._y0);
            const p3 = (0, $871a1510c5a344ac$export$2e2bcd8739ae039)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
        this._x0 = x, this._y0 = y;
    }
}
function $ae92cfd737aa5b29$export$2c099b5096f70ce6(context) {
    return new $ae92cfd737aa5b29$var$Bump(context, true);
}
function $ae92cfd737aa5b29$export$908da9dfa54cbed6(context) {
    return new $ae92cfd737aa5b29$var$Bump(context, false);
}
function $ae92cfd737aa5b29$export$8c82a77a5061b331(context) {
    return new $ae92cfd737aa5b29$var$BumpRadial(context);
}




function $5e763394b4280491$var$linkSource(d) {
    return d.source;
}
function $5e763394b4280491$var$linkTarget(d) {
    return d.target;
}
function $5e763394b4280491$export$9c30223ca0a664fb(curve) {
    let source = $5e763394b4280491$var$linkSource, target = $5e763394b4280491$var$linkTarget, x = (0, $d2ec527a7f8e727a$export$d141bba7fdc215a3), y = (0, $d2ec527a7f8e727a$export$4a5767248b18ef41), context = null, output = null, path = (0, $ce5e56282a56a8c7$export$fb6e83118a5dcd45)(link);
    function link() {
        let buffer;
        const argv = (0, $18431644d88981bd$export$58adb3bec8346d0f).call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = path());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $5e763394b4280491$export$e7c381889b2cd14d() {
    return $5e763394b4280491$export$9c30223ca0a664fb((0, $ae92cfd737aa5b29$export$2c099b5096f70ce6));
}
function $5e763394b4280491$export$75de4c8c66884e04() {
    return $5e763394b4280491$export$9c30223ca0a664fb((0, $ae92cfd737aa5b29$export$908da9dfa54cbed6));
}
function $5e763394b4280491$export$7739cfe68d4e0799() {
    const l = $5e763394b4280491$export$9c30223ca0a664fb((0, $ae92cfd737aa5b29$export$8c82a77a5061b331));
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}





var $5Wuwv = parcelRequire("5Wuwv");
const $63d443cc70805b64$var$sqrt3 = (0, $5Wuwv.sqrt)(3);
var $63d443cc70805b64$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $5Wuwv.sqrt)(size + (0, $5Wuwv.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $63d443cc70805b64$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};



var $5Wuwv = parcelRequire("5Wuwv");
var $2fad96d340a028f2$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $5Wuwv.sqrt)(size / (0, $5Wuwv.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, $5Wuwv.tau));
    }
};



var $5Wuwv = parcelRequire("5Wuwv");
var $5fffe77e6e64954c$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $5Wuwv.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};



var $5Wuwv = parcelRequire("5Wuwv");
const $9df2df4fb67a0d51$var$tan30 = (0, $5Wuwv.sqrt)(1 / 3);
const $9df2df4fb67a0d51$var$tan30_2 = $9df2df4fb67a0d51$var$tan30 * 2;
var $9df2df4fb67a0d51$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = (0, $5Wuwv.sqrt)(size / $9df2df4fb67a0d51$var$tan30_2);
        const x = y * $9df2df4fb67a0d51$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};



var $5Wuwv = parcelRequire("5Wuwv");
var $4872155e08983436$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $5Wuwv.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};



var $5Wuwv = parcelRequire("5Wuwv");
var $fde9c58f45c7f298$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $5Wuwv.sqrt)(size - (0, $5Wuwv.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};



var $5Wuwv = parcelRequire("5Wuwv");
var $e4116d2296c82d82$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const w = (0, $5Wuwv.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};



var $5Wuwv = parcelRequire("5Wuwv");
var $b53fcdacf573c6af$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $5Wuwv.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};



var $5Wuwv = parcelRequire("5Wuwv");
const $9e5dc91122e065da$var$ka = 0.89081309152928522810;
const $9e5dc91122e065da$var$kr = (0, $5Wuwv.sin)((0, $5Wuwv.pi) / 10) / (0, $5Wuwv.sin)(7 * (0, $5Wuwv.pi) / 10);
const $9e5dc91122e065da$var$kx = (0, $5Wuwv.sin)((0, $5Wuwv.tau) / 10) * $9e5dc91122e065da$var$kr;
const $9e5dc91122e065da$var$ky = -(0, $5Wuwv.cos)((0, $5Wuwv.tau) / 10) * $9e5dc91122e065da$var$kr;
var $9e5dc91122e065da$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $5Wuwv.sqrt)(size * $9e5dc91122e065da$var$ka);
        const x = $9e5dc91122e065da$var$kx * r;
        const y = $9e5dc91122e065da$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = (0, $5Wuwv.tau) * i / 5;
            const c = (0, $5Wuwv.cos)(a);
            const s = (0, $5Wuwv.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};



var $5Wuwv = parcelRequire("5Wuwv");
const $906ec55b6bead206$var$sqrt3 = (0, $5Wuwv.sqrt)(3);
var $906ec55b6bead206$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = -(0, $5Wuwv.sqrt)(size / ($906ec55b6bead206$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$906ec55b6bead206$var$sqrt3 * y, -y);
        context.lineTo($906ec55b6bead206$var$sqrt3 * y, -y);
        context.closePath();
    }
};



var $5Wuwv = parcelRequire("5Wuwv");
const $b7b531e503e939dd$var$sqrt3 = (0, $5Wuwv.sqrt)(3);
var $b7b531e503e939dd$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const s = (0, $5Wuwv.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $b7b531e503e939dd$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};



var $5Wuwv = parcelRequire("5Wuwv");
const $a704f0b9f6cc93cb$var$c = -0.5;
const $a704f0b9f6cc93cb$var$s = (0, $5Wuwv.sqrt)(3) / 2;
const $a704f0b9f6cc93cb$var$k = 1 / (0, $5Wuwv.sqrt)(12);
const $a704f0b9f6cc93cb$var$a = ($a704f0b9f6cc93cb$var$k / 2 + 1) * 3;
var $a704f0b9f6cc93cb$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $5Wuwv.sqrt)(size / $a704f0b9f6cc93cb$var$a);
        const x0 = r / 2, y0 = r * $a704f0b9f6cc93cb$var$k;
        const x1 = x0, y1 = r * $a704f0b9f6cc93cb$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($a704f0b9f6cc93cb$var$c * x0 - $a704f0b9f6cc93cb$var$s * y0, $a704f0b9f6cc93cb$var$s * x0 + $a704f0b9f6cc93cb$var$c * y0);
        context.lineTo($a704f0b9f6cc93cb$var$c * x1 - $a704f0b9f6cc93cb$var$s * y1, $a704f0b9f6cc93cb$var$s * x1 + $a704f0b9f6cc93cb$var$c * y1);
        context.lineTo($a704f0b9f6cc93cb$var$c * x2 - $a704f0b9f6cc93cb$var$s * y2, $a704f0b9f6cc93cb$var$s * x2 + $a704f0b9f6cc93cb$var$c * y2);
        context.lineTo($a704f0b9f6cc93cb$var$c * x0 + $a704f0b9f6cc93cb$var$s * y0, $a704f0b9f6cc93cb$var$c * y0 - $a704f0b9f6cc93cb$var$s * x0);
        context.lineTo($a704f0b9f6cc93cb$var$c * x1 + $a704f0b9f6cc93cb$var$s * y1, $a704f0b9f6cc93cb$var$c * y1 - $a704f0b9f6cc93cb$var$s * x1);
        context.lineTo($a704f0b9f6cc93cb$var$c * x2 + $a704f0b9f6cc93cb$var$s * y2, $a704f0b9f6cc93cb$var$c * y2 - $a704f0b9f6cc93cb$var$s * x2);
        context.closePath();
    }
};



var $5Wuwv = parcelRequire("5Wuwv");
var $7554f66ddccbb0d0$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $5Wuwv.sqrt)(size - (0, $5Wuwv.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};


const $029e321f2b0593fb$export$19158c96a6700c15 = [
    (0, $2fad96d340a028f2$export$2e2bcd8739ae039),
    (0, $5fffe77e6e64954c$export$2e2bcd8739ae039),
    (0, $9df2df4fb67a0d51$export$2e2bcd8739ae039),
    (0, $e4116d2296c82d82$export$2e2bcd8739ae039),
    (0, $9e5dc91122e065da$export$2e2bcd8739ae039),
    (0, $906ec55b6bead206$export$2e2bcd8739ae039),
    (0, $a704f0b9f6cc93cb$export$2e2bcd8739ae039)
];
const $029e321f2b0593fb$export$915e06de6acf8fe = [
    (0, $2fad96d340a028f2$export$2e2bcd8739ae039),
    (0, $fde9c58f45c7f298$export$2e2bcd8739ae039),
    (0, $7554f66ddccbb0d0$export$2e2bcd8739ae039),
    (0, $b7b531e503e939dd$export$2e2bcd8739ae039),
    (0, $63d443cc70805b64$export$2e2bcd8739ae039),
    (0, $b53fcdacf573c6af$export$2e2bcd8739ae039),
    (0, $4872155e08983436$export$2e2bcd8739ae039)
];
function $029e321f2b0593fb$export$2e2bcd8739ae039(type, size) {
    let context = null, path = (0, $ce5e56282a56a8c7$export$fb6e83118a5dcd45)(symbol);
    type = typeof type === "function" ? type : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(type || (0, $2fad96d340a028f2$export$2e2bcd8739ae039));
    size = typeof size === "function" ? size : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = path();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}















function $6bd323196ef5b52e$export$2e2bcd8739ae039() {}


function $f1d94120dd67e173$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $f1d94120dd67e173$export$957f7263e89bedd2(context) {
    this._context = context;
}
$f1d94120dd67e173$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $f1d94120dd67e173$export$105684a3041cb6f3(this, this._x1, this._y1); // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
            default:
                $f1d94120dd67e173$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $f1d94120dd67e173$export$2e2bcd8739ae039(context) {
    return new $f1d94120dd67e173$export$957f7263e89bedd2(context);
}


function $05a0567bd9680b1b$var$BasisClosed(context) {
    this._context = context;
}
$05a0567bd9680b1b$var$BasisClosed.prototype = {
    areaStart: (0, $6bd323196ef5b52e$export$2e2bcd8739ae039),
    areaEnd: (0, $6bd323196ef5b52e$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $f1d94120dd67e173$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $05a0567bd9680b1b$export$2e2bcd8739ae039(context) {
    return new $05a0567bd9680b1b$var$BasisClosed(context);
}



function $6c1a919714a504bd$var$BasisOpen(context) {
    this._context = context;
}
$6c1a919714a504bd$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $f1d94120dd67e173$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $6c1a919714a504bd$export$2e2bcd8739ae039(context) {
    return new $6c1a919714a504bd$var$BasisOpen(context);
}





function $e39ff5e7f4c8ed39$var$Bundle(context, beta) {
    this._basis = new (0, $f1d94120dd67e173$export$957f7263e89bedd2)(context);
    this._beta = beta;
}
$e39ff5e7f4c8ed39$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $e39ff5e7f4c8ed39$export$2e2bcd8739ae039 = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, $f1d94120dd67e173$export$957f7263e89bedd2)(context) : new $e39ff5e7f4c8ed39$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);




var $hpcPW = parcelRequire("hpcPW");
function $d702e430e5aef10b$export$da3940d7e9162858(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$d702e430e5aef10b$export$da3940d7e9162858.prototype = {
    areaStart: (0, $6bd323196ef5b52e$export$2e2bcd8739ae039),
    areaEnd: (0, $6bd323196ef5b52e$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $hpcPW.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $d702e430e5aef10b$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $d702e430e5aef10b$export$da3940d7e9162858(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);



var $hpcPW = parcelRequire("hpcPW");
function $59658346d42cc3e7$export$cd7d1a617282f2f1(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$59658346d42cc3e7$export$cd7d1a617282f2f1.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $hpcPW.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $59658346d42cc3e7$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $59658346d42cc3e7$export$cd7d1a617282f2f1(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);



var $hpcPW = parcelRequire("hpcPW");



var $61ebs = parcelRequire("61ebs");
function $9db9a208bb77ee0f$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$9db9a208bb77ee0f$var$CatmullRomClosed.prototype = {
    areaStart: (0, $6bd323196ef5b52e$export$2e2bcd8739ae039),
    areaEnd: (0, $6bd323196ef5b52e$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $61ebs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $9db9a208bb77ee0f$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $9db9a208bb77ee0f$var$CatmullRomClosed(context, alpha) : new (0, $d702e430e5aef10b$export$da3940d7e9162858)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);




var $61ebs = parcelRequire("61ebs");
function $802ebba5a0efb8d9$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$802ebba5a0efb8d9$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $61ebs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $802ebba5a0efb8d9$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $802ebba5a0efb8d9$var$CatmullRomOpen(context, alpha) : new (0, $59658346d42cc3e7$export$cd7d1a617282f2f1)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);



var $61ebs = parcelRequire("61ebs");

function $fad3f82d4445c25b$var$LinearClosed(context) {
    this._context = context;
}
$fad3f82d4445c25b$var$LinearClosed.prototype = {
    areaStart: (0, $6bd323196ef5b52e$export$2e2bcd8739ae039),
    areaEnd: (0, $6bd323196ef5b52e$export$2e2bcd8739ae039),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $fad3f82d4445c25b$export$2e2bcd8739ae039(context) {
    return new $fad3f82d4445c25b$var$LinearClosed(context);
}



function $c178b0c170a2e4cf$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $c178b0c170a2e4cf$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($c178b0c170a2e4cf$var$sign(s0) + $c178b0c170a2e4cf$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $c178b0c170a2e4cf$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $c178b0c170a2e4cf$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $c178b0c170a2e4cf$var$MonotoneX(context) {
    this._context = context;
}
$c178b0c170a2e4cf$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $c178b0c170a2e4cf$var$point(this, this._t0, $c178b0c170a2e4cf$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $c178b0c170a2e4cf$var$point(this, $c178b0c170a2e4cf$var$slope2(this, t1 = $c178b0c170a2e4cf$var$slope3(this, x, y)), t1);
                break;
            default:
                $c178b0c170a2e4cf$var$point(this, this._t0, t1 = $c178b0c170a2e4cf$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $c178b0c170a2e4cf$var$MonotoneY(context) {
    this._context = new $c178b0c170a2e4cf$var$ReflectContext(context);
}
($c178b0c170a2e4cf$var$MonotoneY.prototype = Object.create($c178b0c170a2e4cf$var$MonotoneX.prototype)).point = function(x, y) {
    $c178b0c170a2e4cf$var$MonotoneX.prototype.point.call(this, y, x);
};
function $c178b0c170a2e4cf$var$ReflectContext(context) {
    this._context = context;
}
$c178b0c170a2e4cf$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $c178b0c170a2e4cf$export$99563b5420dbdc55(context) {
    return new $c178b0c170a2e4cf$var$MonotoneX(context);
}
function $c178b0c170a2e4cf$export$8b5360456d6bdb88(context) {
    return new $c178b0c170a2e4cf$var$MonotoneY(context);
}


function $fed03e81b7aee77f$var$Natural(context) {
    this._context = context;
}
$fed03e81b7aee77f$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $fed03e81b7aee77f$var$controlPoints(x), py = $fed03e81b7aee77f$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $fed03e81b7aee77f$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $fed03e81b7aee77f$export$2e2bcd8739ae039(context) {
    return new $fed03e81b7aee77f$var$Natural(context);
}


function $3ff1699e8143ef4b$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$3ff1699e8143ef4b$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $3ff1699e8143ef4b$export$2e2bcd8739ae039(context) {
    return new $3ff1699e8143ef4b$var$Step(context, 0.5);
}
function $3ff1699e8143ef4b$export$10eafa5b7478b343(context) {
    return new $3ff1699e8143ef4b$var$Step(context, 0);
}
function $3ff1699e8143ef4b$export$793b3db073781cbb(context) {
    return new $3ff1699e8143ef4b$var$Step(context, 1);
}




function $8bf2c729606f77a9$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}


function $b7870e60c963d51c$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}


function $7c6d90e966079d12$var$stackValue(d, key) {
    return d[key];
}
function $7c6d90e966079d12$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $7c6d90e966079d12$export$2e2bcd8739ae039() {
    var keys = (0, $e37b3936d07e3353$export$2e2bcd8739ae039)([]), order = (0, $b7870e60c963d51c$export$2e2bcd8739ae039), offset = (0, $8bf2c729606f77a9$export$2e2bcd8739ae039), value = $7c6d90e966079d12$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $7c6d90e966079d12$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $18431644d88981bd$export$2e2bcd8739ae039)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $b7870e60c963d51c$export$2e2bcd8739ae039) : typeof _ === "function" ? _ : (0, $e37b3936d07e3353$export$2e2bcd8739ae039)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $8bf2c729606f77a9$export$2e2bcd8739ae039) : _, stack) : offset;
    };
    return stack;
}



function $a7123a37f4cda083$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $8bf2c729606f77a9$export$2e2bcd8739ae039)(series, order);
}


function $4a58bb06cc38b066$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}




function $750cdc94002e3779$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $8bf2c729606f77a9$export$2e2bcd8739ae039)(series, order);
}



function $2aff8fe4039d81ec$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $8bf2c729606f77a9$export$2e2bcd8739ae039)(series, order);
}



function $955f901550f4b858$export$2e2bcd8739ae039(series) {
    var peaks = series.map($955f901550f4b858$var$peak);
    return (0, $b7870e60c963d51c$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $955f901550f4b858$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}



function $8f511ba65f035587$export$2e2bcd8739ae039(series) {
    var sums = series.map($8f511ba65f035587$export$8a63f25cc62965f1);
    return (0, $b7870e60c963d51c$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $8f511ba65f035587$export$8a63f25cc62965f1(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}



function $de369c07536c71be$export$2e2bcd8739ae039(series) {
    return (0, $8f511ba65f035587$export$2e2bcd8739ae039)(series).reverse();
}




function $e28c8eaab91ca549$export$2e2bcd8739ae039(series) {
    var n = series.length, i, j, sums = series.map((0, $8f511ba65f035587$export$8a63f25cc62965f1)), order = (0, $955f901550f4b858$export$2e2bcd8739ae039)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}




function $e580a682dfe2df28$export$2e2bcd8739ae039(series) {
    return (0, $b7870e60c963d51c$export$2e2bcd8739ae039)(series).reverse();
}




var $41d1f83e7711dc42$exports = {};

$parcel$export($41d1f83e7711dc42$exports, "timeInterval", () => $6ec19887e6a2f70d$export$1a539c8b2950ab40);
$parcel$export($41d1f83e7711dc42$exports, "utcMillisecond", () => $7cb32965fb4d0e37$export$edc5e5cb87280477);
$parcel$export($41d1f83e7711dc42$exports, "utcMilliseconds", () => $7cb32965fb4d0e37$export$9a27fac83d67afd3);
$parcel$export($41d1f83e7711dc42$exports, "timeMillisecond", () => $7cb32965fb4d0e37$export$edc5e5cb87280477);
$parcel$export($41d1f83e7711dc42$exports, "timeMilliseconds", () => $7cb32965fb4d0e37$export$9a27fac83d67afd3);
$parcel$export($41d1f83e7711dc42$exports, "utcSecond", () => $88f32e66450fe893$export$3d3c77ce7df7d30d);
$parcel$export($41d1f83e7711dc42$exports, "utcSeconds", () => $88f32e66450fe893$export$4792e48abc550fa1);
$parcel$export($41d1f83e7711dc42$exports, "timeSecond", () => $88f32e66450fe893$export$3d3c77ce7df7d30d);
$parcel$export($41d1f83e7711dc42$exports, "timeSeconds", () => $88f32e66450fe893$export$4792e48abc550fa1);
$parcel$export($41d1f83e7711dc42$exports, "timeMinute", () => $7af3d84c55f5e66a$export$a7e4c34a52f0576);
$parcel$export($41d1f83e7711dc42$exports, "timeMinutes", () => $7af3d84c55f5e66a$export$186d65358374c0a2);
$parcel$export($41d1f83e7711dc42$exports, "utcMinute", () => $7af3d84c55f5e66a$export$efe6712d6003761b);
$parcel$export($41d1f83e7711dc42$exports, "utcMinutes", () => $7af3d84c55f5e66a$export$cedd563624e8ee50);
$parcel$export($41d1f83e7711dc42$exports, "timeHour", () => $71bc9e75aba412b8$export$46c68a5833bc315b);
$parcel$export($41d1f83e7711dc42$exports, "timeHours", () => $71bc9e75aba412b8$export$fb843f9087cd5235);
$parcel$export($41d1f83e7711dc42$exports, "utcHour", () => $71bc9e75aba412b8$export$31f6f2b3c63ac75e);
$parcel$export($41d1f83e7711dc42$exports, "utcHours", () => $71bc9e75aba412b8$export$6e7a76cd5f50b719);
$parcel$export($41d1f83e7711dc42$exports, "timeDay", () => $0510fd4f155849d7$export$8888529b966033e5);
$parcel$export($41d1f83e7711dc42$exports, "timeDays", () => $0510fd4f155849d7$export$6657a54f3034cf45);
$parcel$export($41d1f83e7711dc42$exports, "utcDay", () => $0510fd4f155849d7$export$c8cbc42cefd47140);
$parcel$export($41d1f83e7711dc42$exports, "utcDays", () => $0510fd4f155849d7$export$d277e198508549a1);
$parcel$export($41d1f83e7711dc42$exports, "unixDay", () => $0510fd4f155849d7$export$fb065be2d7ea4a71);
$parcel$export($41d1f83e7711dc42$exports, "unixDays", () => $0510fd4f155849d7$export$a491caaf5e9481aa);
$parcel$export($41d1f83e7711dc42$exports, "timeWeek", () => $829beff7f10c8695$export$22ee6205b762968c);
$parcel$export($41d1f83e7711dc42$exports, "timeWeeks", () => $829beff7f10c8695$export$eac514c8a8674eba);
$parcel$export($41d1f83e7711dc42$exports, "timeSunday", () => $829beff7f10c8695$export$22ee6205b762968c);
$parcel$export($41d1f83e7711dc42$exports, "timeSundays", () => $829beff7f10c8695$export$eac514c8a8674eba);
$parcel$export($41d1f83e7711dc42$exports, "timeMonday", () => $829beff7f10c8695$export$e79bbe0177cf1b01);
$parcel$export($41d1f83e7711dc42$exports, "timeMondays", () => $829beff7f10c8695$export$f7219b1481948356);
$parcel$export($41d1f83e7711dc42$exports, "timeTuesday", () => $829beff7f10c8695$export$57c0658c29f77708);
$parcel$export($41d1f83e7711dc42$exports, "timeTuesdays", () => $829beff7f10c8695$export$77e22b12c5bed05b);
$parcel$export($41d1f83e7711dc42$exports, "timeWednesday", () => $829beff7f10c8695$export$3fbeef226c256e43);
$parcel$export($41d1f83e7711dc42$exports, "timeWednesdays", () => $829beff7f10c8695$export$b85d407a471809e8);
$parcel$export($41d1f83e7711dc42$exports, "timeThursday", () => $829beff7f10c8695$export$608689422d5cf9f4);
$parcel$export($41d1f83e7711dc42$exports, "timeThursdays", () => $829beff7f10c8695$export$c1bc1c49254c8855);
$parcel$export($41d1f83e7711dc42$exports, "timeFriday", () => $829beff7f10c8695$export$548e5227aa183dca);
$parcel$export($41d1f83e7711dc42$exports, "timeFridays", () => $829beff7f10c8695$export$3691a1557fff46f1);
$parcel$export($41d1f83e7711dc42$exports, "timeSaturday", () => $829beff7f10c8695$export$c56a3ad248908e19);
$parcel$export($41d1f83e7711dc42$exports, "timeSaturdays", () => $829beff7f10c8695$export$b755452d02cba8d2);
$parcel$export($41d1f83e7711dc42$exports, "utcWeek", () => $829beff7f10c8695$export$4898b06303a92011);
$parcel$export($41d1f83e7711dc42$exports, "utcWeeks", () => $829beff7f10c8695$export$6f3e1c2b0f7d7880);
$parcel$export($41d1f83e7711dc42$exports, "utcSunday", () => $829beff7f10c8695$export$4898b06303a92011);
$parcel$export($41d1f83e7711dc42$exports, "utcSundays", () => $829beff7f10c8695$export$6f3e1c2b0f7d7880);
$parcel$export($41d1f83e7711dc42$exports, "utcMonday", () => $829beff7f10c8695$export$9cfc53b9cfafd080);
$parcel$export($41d1f83e7711dc42$exports, "utcMondays", () => $829beff7f10c8695$export$1d2d8b858bb366f9);
$parcel$export($41d1f83e7711dc42$exports, "utcTuesday", () => $829beff7f10c8695$export$2a6d545f77eceb15);
$parcel$export($41d1f83e7711dc42$exports, "utcTuesdays", () => $829beff7f10c8695$export$1d5f6785fc7f30f8);
$parcel$export($41d1f83e7711dc42$exports, "utcWednesday", () => $829beff7f10c8695$export$a5c25d8ed64433c4);
$parcel$export($41d1f83e7711dc42$exports, "utcWednesdays", () => $829beff7f10c8695$export$7a75faf0e37ef4af);
$parcel$export($41d1f83e7711dc42$exports, "utcThursday", () => $829beff7f10c8695$export$1db08111baec2f53);
$parcel$export($41d1f83e7711dc42$exports, "utcThursdays", () => $829beff7f10c8695$export$417eb959611b2f2f);
$parcel$export($41d1f83e7711dc42$exports, "utcFriday", () => $829beff7f10c8695$export$29265e34dd5921f7);
$parcel$export($41d1f83e7711dc42$exports, "utcFridays", () => $829beff7f10c8695$export$59d308db7af08c64);
$parcel$export($41d1f83e7711dc42$exports, "utcSaturday", () => $829beff7f10c8695$export$85b74dad05049604);
$parcel$export($41d1f83e7711dc42$exports, "utcSaturdays", () => $829beff7f10c8695$export$a124108a0a7f34c8);
$parcel$export($41d1f83e7711dc42$exports, "timeMonth", () => $f49497a07f26fc9e$export$7e1084fb688591c1);
$parcel$export($41d1f83e7711dc42$exports, "timeMonths", () => $f49497a07f26fc9e$export$3e24aa839cd0f1c4);
$parcel$export($41d1f83e7711dc42$exports, "utcMonth", () => $f49497a07f26fc9e$export$cd49b3d2bcfe50d5);
$parcel$export($41d1f83e7711dc42$exports, "utcMonths", () => $f49497a07f26fc9e$export$49159f585997498);
$parcel$export($41d1f83e7711dc42$exports, "timeYear", () => $ddf3f8970489211a$export$cd17cfe45df0c046);
$parcel$export($41d1f83e7711dc42$exports, "timeYears", () => $ddf3f8970489211a$export$69a4e90dd2cc3bd1);
$parcel$export($41d1f83e7711dc42$exports, "utcYear", () => $ddf3f8970489211a$export$d5c3802e389714c4);
$parcel$export($41d1f83e7711dc42$exports, "utcYears", () => $ddf3f8970489211a$export$3e24d311e17f5802);
$parcel$export($41d1f83e7711dc42$exports, "utcTicks", () => $c71cf5d5cab5b066$export$826ba5ae907e9767);
$parcel$export($41d1f83e7711dc42$exports, "utcTickInterval", () => $c71cf5d5cab5b066$export$6262d8d056ea44c4);
$parcel$export($41d1f83e7711dc42$exports, "timeTicks", () => $c71cf5d5cab5b066$export$60c76498552d28a6);
$parcel$export($41d1f83e7711dc42$exports, "timeTickInterval", () => $c71cf5d5cab5b066$export$69511150134dd174);












var $96e23ced71f9bcea$exports = {};

$parcel$export($96e23ced71f9bcea$exports, "timeFormatDefaultLocale", () => $d227e7bf2f197803$export$2e2bcd8739ae039);
$parcel$export($96e23ced71f9bcea$exports, "timeFormat", () => $d227e7bf2f197803$export$94f4d87fad5dcf9a);
$parcel$export($96e23ced71f9bcea$exports, "timeParse", () => $d227e7bf2f197803$export$32b9cd16e1b8c8d2);
$parcel$export($96e23ced71f9bcea$exports, "utcFormat", () => $d227e7bf2f197803$export$1a08fe38f63ebbbb);
$parcel$export($96e23ced71f9bcea$exports, "utcParse", () => $d227e7bf2f197803$export$3edae9cf8e233729);
$parcel$export($96e23ced71f9bcea$exports, "timeFormatLocale", () => $44fe361b644f94fb$export$2e2bcd8739ae039);
$parcel$export($96e23ced71f9bcea$exports, "isoFormat", () => $78fc20e794c4e8c4$export$2e2bcd8739ae039);
$parcel$export($96e23ced71f9bcea$exports, "isoParse", () => $d1281fe6fdecb5bb$export$2e2bcd8739ae039);



var $78fc20e794c4e8c4$export$491f7bf2e88d83ce = "%Y-%m-%dT%H:%M:%S.%LZ";
function $78fc20e794c4e8c4$var$formatIsoNative(date) {
    return date.toISOString();
}
var $78fc20e794c4e8c4$var$formatIso = Date.prototype.toISOString ? $78fc20e794c4e8c4$var$formatIsoNative : (0, $d227e7bf2f197803$export$1a08fe38f63ebbbb)($78fc20e794c4e8c4$export$491f7bf2e88d83ce);
var $78fc20e794c4e8c4$export$2e2bcd8739ae039 = $78fc20e794c4e8c4$var$formatIso;




function $d1281fe6fdecb5bb$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $d1281fe6fdecb5bb$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $d1281fe6fdecb5bb$var$parseIsoNative : (0, $d227e7bf2f197803$export$3edae9cf8e233729)((0, $78fc20e794c4e8c4$export$491f7bf2e88d83ce));
var $d1281fe6fdecb5bb$export$2e2bcd8739ae039 = $d1281fe6fdecb5bb$var$parseIso;




var $804b017a2abcd284$exports = {};

$parcel$export($804b017a2abcd284$exports, "now", () => $30ea27ad4ddf4734$export$461939dd4422153);
$parcel$export($804b017a2abcd284$exports, "timer", () => $30ea27ad4ddf4734$export$9dc4ecf953986f04);
$parcel$export($804b017a2abcd284$exports, "timerFlush", () => $30ea27ad4ddf4734$export$d60154c1d7f3990e);
$parcel$export($804b017a2abcd284$exports, "timeout", () => $f984208cdff58421$export$2e2bcd8739ae039);
$parcel$export($804b017a2abcd284$exports, "interval", () => $a8bbe3a70c282f7f$export$2e2bcd8739ae039);



function $a8bbe3a70c282f7f$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $30ea27ad4ddf4734$export$c57e9b2d8b9e4de), total = delay;
    if (delay == null) return t.restart(callback, delay, time), t;
    t._restart = t.restart;
    t.restart = function(callback, delay, time) {
        delay = +delay, time = time == null ? (0, $30ea27ad4ddf4734$export$461939dd4422153)() : +time;
        t._restart(function tick(elapsed) {
            elapsed += total;
            t._restart(tick, total += delay, time);
            callback(elapsed);
        }, delay, time);
    };
    t.restart(callback, delay, time);
    return t;
}





var $5b34be3a56655df8$exports = {};

$parcel$export($5b34be3a56655df8$exports, "zoom", () => $512db782c3219262$export$2e2bcd8739ae039);
$parcel$export($5b34be3a56655df8$exports, "zoomTransform", () => $1a561483ebc17877$export$2e2bcd8739ae039);
$parcel$export($5b34be3a56655df8$exports, "zoomIdentity", () => $1a561483ebc17877$export$f0954fd7d5368655);
$parcel$export($5b34be3a56655df8$exports, "ZoomTransform", () => $1a561483ebc17877$export$563a914cafbdc389);





var $bc35566e32c26b65$export$2e2bcd8739ae039 = (x)=>()=>x;


function $e8fb7064a7d3d767$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $1a561483ebc17877$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$1a561483ebc17877$export$563a914cafbdc389.prototype = {
    constructor: $1a561483ebc17877$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $1a561483ebc17877$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $1a561483ebc17877$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $1a561483ebc17877$export$f0954fd7d5368655 = new $1a561483ebc17877$export$563a914cafbdc389(1, 0, 0);
$1a561483ebc17877$export$2e2bcd8739ae039.prototype = $1a561483ebc17877$export$563a914cafbdc389.prototype;
function $1a561483ebc17877$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $1a561483ebc17877$export$f0954fd7d5368655;
    return node.__zoom;
}


function $eb263d110cb757e8$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $eb263d110cb757e8$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $512db782c3219262$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === "wheel") && !event.button;
}
function $512db782c3219262$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $512db782c3219262$var$defaultTransform() {
    return this.__zoom || (0, $1a561483ebc17877$export$f0954fd7d5368655);
}
function $512db782c3219262$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $512db782c3219262$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $512db782c3219262$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $512db782c3219262$export$2e2bcd8739ae039() {
    var filter = $512db782c3219262$var$defaultFilter, extent = $512db782c3219262$var$defaultExtent, constrain = $512db782c3219262$var$defaultConstrain, wheelDelta = $512db782c3219262$var$defaultWheelDelta, touchable = $512db782c3219262$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $5e05683ac1cc2c47$export$2e2bcd8739ae039), listeners = (0, $cfaa4969c311d138$export$2e2bcd8739ae039)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $512db782c3219262$var$defaultTransform).on("wheel.zoom", wheeled, {
            passive: false
        }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $512db782c3219262$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $1a561483ebc17877$export$f0954fd7d5368655).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $1a561483ebc17877$export$563a914cafbdc389)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $1a561483ebc17877$export$563a914cafbdc389)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $1a561483ebc17877$export$563a914cafbdc389)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $c38382a82e61d17a$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $e8fb7064a7d3d767$export$2e2bcd8739ae039)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $01126f29f8cc9cfb$export$2e2bcd8739ae039)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $fd4ea3403db5c867$export$2e2bcd8739ae039)(this);
            g.start();
        }
        (0, $eb263d110cb757e8$export$2e2bcd8739ae039)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, $c38382a82e61d17a$export$2e2bcd8739ae039)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $01126f29f8cc9cfb$export$2e2bcd8739ae039)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
        (0, $2cf643e39b411f06$export$2e2bcd8739ae039)(event.view);
        (0, $eb263d110cb757e8$export$2e2561858db9bf47)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $fd4ea3403db5c867$export$2e2bcd8739ae039)(this);
        g.start();
        function mousemoved(event) {
            (0, $eb263d110cb757e8$export$2e2bcd8739ae039)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $01126f29f8cc9cfb$export$2e2bcd8739ae039)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $2cf643e39b411f06$export$833237748009e1e1)(event.view, g.moved);
            (0, $eb263d110cb757e8$export$2e2bcd8739ae039)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $01126f29f8cc9cfb$export$2e2bcd8739ae039)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $eb263d110cb757e8$export$2e2bcd8739ae039)(event);
        if (duration > 0) (0, $c38382a82e61d17a$export$2e2bcd8739ae039)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $c38382a82e61d17a$export$2e2bcd8739ae039)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $eb263d110cb757e8$export$2e2561858db9bf47)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $01126f29f8cc9cfb$export$2e2bcd8739ae039)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $fd4ea3403db5c867$export$2e2bcd8739ae039)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $eb263d110cb757e8$export$2e2bcd8739ae039)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $01126f29f8cc9cfb$export$2e2bcd8739ae039)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $eb263d110cb757e8$export$2e2561858db9bf47)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $01126f29f8cc9cfb$export$2e2bcd8739ae039)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $c38382a82e61d17a$export$2e2bcd8739ae039)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $bc35566e32c26b65$export$2e2bcd8739ae039)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $bc35566e32c26b65$export$2e2bcd8739ae039)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $bc35566e32c26b65$export$2e2bcd8739ae039)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $bc35566e32c26b65$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}





$parcel$exportWildcard($ac9f869b8637e826$exports, $519a338fba25811b$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $277c79f82b28ccb6$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $61be40fcd0bd3059$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $37552dd2331c372d$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $1e35a39effc36fb0$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $b0c30026f923e936$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $1b1f70ef6d514e40$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $d2eef0483e3528fd$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $9ea5feb77cd607ae$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $a6bf3498874c0285$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $b7fc7c265f537bd8$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $5c65ad318a8bf09b$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $7fb8675b7815fed9$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $9a82798372102918$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $9817ff4df005c27a$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $01ddd7c46c96854e$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $1a65dff94eccdd27$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $6204ec323e71459a$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $ff6392c6d3577ebe$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $59337f127480c7df$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $882b9ed40ac51fca$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $f7842e95fb3e91b5$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $32ba1530b4c192a4$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $8ef8f659f1c2214e$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $4f002fc54a73d992$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $41d1f83e7711dc42$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $96e23ced71f9bcea$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $804b017a2abcd284$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $984dbdbcfb5f6759$exports);
$parcel$exportWildcard($ac9f869b8637e826$exports, $5b34be3a56655df8$exports);


var $c287ed218d52408b$export$2e2bcd8739ae039 = $ac9f869b8637e826$exports;


function $8effea8628a9f030$export$905fe28a7c283e1d(map, template) {
    return (template || "").replace(/:\{(\w+)\|([^\|]+)\|?([^\}]*)\}/g, (match, key, fun, arg)=>{
        if (key in map) {
            if (fun in funs) return (0, (/*@__PURE__*/$parcel$interopDefault($f5dPJ))).get(funs, fun)((0, (/*@__PURE__*/$parcel$interopDefault($f5dPJ))).get(map, key), arg);
        }
        return match;
    }).replace(/\:(\w+)/g, (match, key)=>{
        if (key in map) return (0, (/*@__PURE__*/$parcel$interopDefault($f5dPJ))).get(map, key);
        return match;
    });
}
var // import * as dc from 'lib/d3-scale-chromatic';
$8effea8628a9f030$export$2e2bcd8739ae039 = /* ChartBarV */ {
    render: (vnode)=>{
        let element = vnode.dom;
        let payload = vnode.attrs.payload;
        let object = $8effea8628a9f030$var$createPlot(vnode.attrs.options).payload(payload);
        let update = ()=>{
            /* Flush the target element contents. */ (0, $c287ed218d52408b$export$2e2bcd8739ae039).select(element).selectAll("*").remove();
            /* Render the plot into the target element. */ object.render(element, {
                width: element.clientWidth || 720
            });
            console.log("render chart/bar/vertical", object.serial);
        };
        window.addEventListener("resize", (event)=>{
            requestAnimationFrame(update);
        });
        /* Update the plot for the first time. */ update();
    },
    /* Mithril lifecycle methods. */ oncreate: (vnode)=>{
        vnode.state.render(vnode);
    },
    onupdate: (vnode)=>{
        vnode.state.render(vnode);
    },
    view: (vnode)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))(".chart-bar.chart-bar-v");
    }
};
/* Intantiates the Plot. */ function $8effea8628a9f030$var$createPlot(options) {
    var that = (0, (/*@__PURE__*/$parcel$interopDefault($71a2d64234b12d65$exports)))({
        payload: [],
        display: {
            horizontal: {},
            vertical: []
        },
        margins: {
            top: 0,
            left: 100,
            right: 100,
            bottom: 50
        },
        lengths: {
            figure: {
                width: 720,
                height: 640
            },
            legend: {
                line: {
                    height: 20,
                    skip: 5
                },
                skip: 10
            },
            axis: {
                horizontal: {
                    skip: 10
                },
                vertical: {
                    skip: 10
                }
            }
        },
        axes: {
            horizontal: {},
            vertical: {}
        },
        classes: {},
        legends: {
            show: true
        }
    }, options);
    return Object.create({
        payload: function(payload) {
            if (arguments.length < 1) return that.payload;
            that.payload = Object.assign([], payload);
            return this;
        },
        render: function(target, size) {
            that.lengths.figure = (0, (/*@__PURE__*/$parcel$interopDefault($71a2d64234b12d65$exports)))(that.lengths.figure, size || {});
            $8effea8628a9f030$var$renderT(target, that, that.payload);
            return this;
        },
        serial: "1243"
    });
}
function $8effea8628a9f030$var$renderT(target, options, payload) {
    /* Compute the lengths of the components. */ var bodyX = options.margins.left;
    var bodyY = options.margins.top;
    var bodyW = options.lengths.figure.width - options.margins.left - options.margins.right;
    var bodyH = options.lengths.figure.height - options.margins.top - options.margins.bottom;
    /* Compute the domains. */ var domainX = payload.map((row)=>row[options.display.horizontal.key]);
    var domainY = (0, $c287ed218d52408b$export$2e2bcd8739ae039).merge(options.display.vertical.map((field)=>{
        return payload.map((row)=>row[field.key]);
    }));
    if (options.refline && Array.isArray(options.refline)) domainY = (0, $c287ed218d52408b$export$2e2bcd8739ae039).merge([
        options.refline,
        domainY
    ]);
    var domainG = (0, $c287ed218d52408b$export$2e2bcd8739ae039).range(0, options.display.vertical.length);
    /* Extend the domainY to cover (0, ...) */ if (options.axes.vertical.ticks.extend) domainY.push(0);
    /* Prepare the horizontal, vertical, and grouping scales. */ var scaleY = (0, $c287ed218d52408b$export$2e2bcd8739ae039).scaleLinear().domain((0, $c287ed218d52408b$export$2e2bcd8739ae039).extent((0, $c287ed218d52408b$export$2e2bcd8739ae039).merge([
        domainY,
        [
            0
        ]
    ]))).rangeRound([
        bodyH,
        0
    ]).nice();
    var scaleX = (0, $c287ed218d52408b$export$2e2bcd8739ae039).scaleBand().domain(domainX).rangeRound([
        0,
        bodyW
    ]).paddingOuter(1).paddingInner(0.1);
    var scaleG = (0, $c287ed218d52408b$export$2e2bcd8739ae039).scaleBand().domain(domainG).rangeRound([
        0,
        scaleX.bandwidth()
    ]).paddingInner(0.1);
    var scaleC = (0, $c287ed218d52408b$export$2e2bcd8739ae039).scaleSequential((0, $c287ed218d52408b$export$2e2bcd8739ae039).interpolateYlGnBu).domain((0, $c287ed218d52408b$export$2e2bcd8739ae039).extent(domainG)).domain([
        domainG.length,
        -1
    ]);
    console.log(scaleC.domain());
    /* Prepare the plot basis. */ var plot = (0, $c287ed218d52408b$export$2e2bcd8739ae039).select(target).append("svg").attr("width", options.lengths.figure.width).attr("height", options.lengths.figure.height).classed(options.classes.figure, true);
    /* Prepare the body of the plot. */ var body = plot.append("svg");
    body.classed("body", true).attr("width", bodyW).attr("height", bodyH).attr("x", bodyX).attr("y", bodyY);
    body.selectAll("svg").data(payload).enter().append("svg").classed("column-wrapper", true).each(function(value, index) {
        var x = value[options.display.horizontal.key];
        var g = (0, $c287ed218d52408b$export$2e2bcd8739ae039).select(this).attr("width", scaleX.bandwidth()).attr("x", scaleX(x));
        options.display.vertical.forEach((field, offset)=>{
            var y = value[field.key];
            var h = scaleY(0) - scaleY(y);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($f5dPJ))).isEmpty(field.tooltip)) field.tooltip = ":" + options.display.horizontal.key + " \u21A6  :" + field.key;
            let attrs = Object.assign({}, value);
            if (options.axes.vertical.ticks.format) attrs[field.key] = (0, $c287ed218d52408b$export$2e2bcd8739ae039).format(options.axes.vertical.ticks.format)(y);
            let label = $8effea8628a9f030$export$905fe28a7c283e1d(attrs, field.tooltip);
            var r = g.append("rect").attr("x", scaleG(offset)).attr("y", h > 0 ? scaleY(y) : scaleY(0)).attr("width", scaleG.bandwidth()).attr("height", Math.abs(h)).attr("fill", field.color ? field.color : scaleC(offset)).on("click", ($)=>{
                displayFollowDialog(target, options, value);
            }).classed("plot-bar", true).append("title").text(label);
        });
    });
    /* Prepare the axes. */ var axisHorizontal = (0, $c287ed218d52408b$export$2e2bcd8739ae039).axisBottom().scale(scaleX).tickValues(options.axes.horizontal.ticks.values).tickFormat(options.axes.horizontal.ticks.format ? (0, $c287ed218d52408b$export$2e2bcd8739ae039).format(options.axes.horizontal.ticks.format) : null);
    var axisVertical = (0, $c287ed218d52408b$export$2e2bcd8739ae039).axisLeft().scale(scaleY).tickValues(options.axes.vertical.ticks.values).tickFormat(options.axes.vertical.ticks.format ? (0, $c287ed218d52408b$export$2e2bcd8739ae039).format(options.axes.vertical.ticks.format) : null);
    if (Math.abs((0, $c287ed218d52408b$export$2e2bcd8739ae039).max(domainY)) < 10) axisVertical.tickValues(domainY);
    /* Produce the axes. */ var axisX = plot.append("svg").classed("axis-horizontal", true).attr("x", bodyX).attr("y", bodyY + bodyH + options.lengths.axis.horizontal.skip).call(axisHorizontal);
    if (options.axes.horizontal.ticks.rotate) axisX.selectAll("text").each(function() {
        var that = (0, $c287ed218d52408b$export$2e2bcd8739ae039).select(this);
        var size = this.getBBox();
        var y = size.height / 3;
        that.attr("dy", 0);
        that.attr("y", 0);
        that.attr("transform", `translate(0, 10) rotate(90)`);
        that.style("text-anchor", "start");
        that.style("alignment-baseline", "middle");
    });
    var axisY = plot.append("svg").classed("axis-vertical", true).attr("x", bodyX - options.lengths.axis.vertical.skip).attr("y", bodyY).call(axisVertical);
    /* Prepare the axis labels. */ if (options.axes.horizontal.label) {
        var x = bodyW / 2;
        var y = options.lengths.axis.horizontal.skip * 2 + axisX.node().getBBox().height;
        axisX.append("text").classed("label-horizontal", true).attr("transform", `translate(${x}, ${y})`).attr("fill", "#000").attr("text-anchor", "middle").text(options.axes.horizontal.label);
    }
    if (options.axes.vertical.label) {
        var x = -options.lengths.axis.vertical.skip * 2 - axisY.node().getBBox().width;
        var y = bodyH / 2;
        axisY.append("text").classed("label-vertical", true).attr("transform", `translate(${x}, ${y}) rotate(-90)`).attr("fill", "#000").attr("text-anchor", "middle").text(options.axes.vertical.label);
    }
    /* Prepare the reference lines. */ if (options.refline && Array.isArray(options.refline)) options.refline.forEach((value)=>{
        console.log("yay", value);
        body.append("line").attr("class", "plot-refline").attr("x1", 0).attr("x2", bodyW).attr("y1", scaleY(value)).attr("y2", scaleY(value)).attr("shape-rendering", "crispEdges").attr("stroke", "#000");
    });
    if (options.legends && options.legends.show) {
        /* Prepare the legends. */ var legendW = options.margins.right - options.lengths.legend.skip;
        var legendH = options.display.vertical.length * (options.lengths.legend.line.height + options.lengths.legend.line.skip) - options.lengths.legend.line.skip;
        var legendX = bodyX + bodyW + 10;
        var legendY = bodyY + (bodyH - legendH) / 2;
        var legend = plot.append("svg").attr("x", legendX).attr("y", legendY).attr("width", legendW).attr("height", legendH);
        legend.selectAll("g").data(options.display.vertical).enter().append("g").attr("class", "plot-legend-line").each(function(value, index) {
            var line = (0, $c287ed218d52408b$export$2e2bcd8739ae039).select(this);
            line.append("rect").attr("y", index * (options.lengths.legend.line.skip + options.lengths.legend.line.height) - options.lengths.legend.line.height / 2).attr("width", options.lengths.legend.line.height).attr("height", options.lengths.legend.line.height).attr("fill", value.color ? value.color : scaleC(index));
            line.append("text").attr("y", index * (options.lengths.legend.line.skip + options.lengths.legend.line.height)).attr("x", 1.5 * options.lengths.legend.line.height).attr("text-anchor", "left").attr("alignment-baseline", "middle").text(value.legend);
        });
    }
    /* Highlight! */ // const lineHighlight = body
    //   .append('line')
    //     .classed('plot-highlight-line', true)
    //     .style('visibility', 'hidden')
    //     .style('stroke', 'black')
    //     .style('shape-rendering', 'crispEdges')
    // const labelHighlight = body
    //   .append('text')
    //     .classed('plot-highlight-label', true)
    //     .style('visibility', 'hidden')
    //     .style('text-anchor', 'middle')
    //     .style('alignment-baseline', 'baseline')
    //     .style('font-size', 'x-small')
    // body
    //   .selectAll('.plot-bar')
    //   .on('mouseover', function (d, index) {
    //     let y = Number.parseFloat(d3.select(this).attr('y'))
    //     let x = Number.parseFloat(d3.select(this.parentNode).attr('x'))
    //     let w = Number.parseFloat(d3.select(this).attr('width'))
    //     console.log(x, bodyW)
    //     lineHighlight
    //       .style('visibility', 'visible')
    //       .attr('x1', 0)
    //       .attr('x2', bodyW)
    //       .transition()
    //         .attr('y1', y)
    //         .attr('y2', y)
    //       /*      
    //       labelHighlight
    //       .style('visibility', 'visible')
    //         .attr('x', x + 0.5 * w)
    //         .attr('y', y - 5)
    //       .text(y)
    //       */
    //      
    //   })
    //   .on('mouseout', function (d, index) {
    //     lineHighlight
    //       .style('visibility', 'hidden')
    //   })
    /* Yey, its done. */ return plot;
}


//
async function $9c7fe9c5272b2668$var$bootstrap() {
    (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports))).mount(document.body, $9c7fe9c5272b2668$var$ComponentPrototype);
}
window.addEventListener("load", $9c7fe9c5272b2668$var$bootstrap);
// Remote request helpers
//
async function $9c7fe9c5272b2668$var$requestPull(path) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports))).request({
        url: path,
        background: true
    });
}
async function $9c7fe9c5272b2668$var$requestPush(path, body) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports))).request({
        url: path,
        body: body,
        method: "POST",
        background: true
    });
}
// ModelDimension helper
async function $9c7fe9c5272b2668$var$makeModelDimension(remote, title, field) {
    return $9c7fe9c5272b2668$var$requestPull(remote).then((payload)=>new (0, $d881a5f91c2f3e81$export$2e2bcd8739ae039)(payload, title, field));
}
//
class $9c7fe9c5272b2668$var$ComponentPrototype {
    constructor(){
        this.modelCubeFacts = new (0, $c855476682ea0f22$export$2e2bcd8739ae039)([
            {
                "field": "vl_ks",
                "title": "Kusy"
            },
            {
                "field": "vl_kc",
                "title": "Koruny"
            }
        ]);
        this.arrayModelCubeDimension = [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9fb2269b6c8334a7$exports))).all([
            $9c7fe9c5272b2668$var$makeModelDimension("/static/dim-year.json", "Rok", "i_rok"),
            $9c7fe9c5272b2668$var$makeModelDimension("/static/dim-month.json", "M\u011Bs\xedc", "i_mesic"),
            $9c7fe9c5272b2668$var$makeModelDimension("/static/dim-category.json", "Kategorie", "c_cat")
        ]).then((result)=>this.arrayModelCubeDimension = result).finally((0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports))).redraw);
        this.selectedAxis = null;
    }
    renderControlsCube() {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))(".section", [
                (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("h2", "Fakta (hodnoty)"),
                (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))((0, $c2eadb66456eb74a$export$2e2bcd8739ae039), {
                    model: this.modelCubeFacts
                })
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))(".section", [
                (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("h2", "Dimenze"),
                this.arrayModelCubeDimension.map((modelCubeDimension)=>{
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))((0, $8bc561695f7b9c84$export$2e2bcd8739ae039), {
                        model: modelCubeDimension
                    });
                })
            ])
        ];
    }
    renderControlsPlot() {
        const available = this.arrayModelCubeDimension.filter((model)=>model.isSelectedSome);
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))(".section", [
                (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("h2", "V\xfdb\u011Br osy X"),
                (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("ul.select-axis", [
                    available.map((model)=>{
                        return (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("li", {
                            onclick: (event)=>this.selectedAxis = model.field
                        }, [
                            (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("input", {
                                type: "checkbox",
                                checked: model.field == this.selectedAxis
                            }),
                            (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))("span", model.title)
                        ]);
                    })
                ])
            ])
        ];
    }
    renderPlot(vnode) {
        if (!this.arrayModelCubeDimension.length) return;
        if (!this.modelCubeFacts.selected.length) return;
        const xfield = this.selectedAxis;
        if (!xfield) return;
        const fentries = this.modelCubeFacts.selected;
        const dentries = this.arrayModelCubeDimension.filter((model)=>model.field != xfield).filter((model)=>model.isSelectedSome);
        const dvalues = dentries.map((model)=>model.selected.map((entry)=>entry.label));
        const xmodel = this.arrayModelCubeDimension.find((model)=>model.field == xfield);
        const xlabel = xmodel.title;
        const xentries = xmodel.selected;
        const xvalues = xentries.map((entry)=>entry.label);
        if (!xentries) return;
        const outcomeYfields = [];
        if (!dentries.length) for (const fentry of fentries)outcomeYfields.push({
            key: fentry.field,
            legend: fentry.title,
            color: $9c7fe9c5272b2668$var$randomColor()
        });
        else {
            const drecords = (0, (/*@__PURE__*/$parcel$interopDefault($7f092e43d4b75e53$exports)))(dvalues);
            for (const drecord of drecords){
                const dfield = drecord.map((value, index)=>`${dentries[index].field}_${value}`).join("_");
                const dtitle = drecord.map((value, index)=>`${dentries[index].title}:${value}`).join(", ");
                for (const fentry of fentries)outcomeYfields.push({
                    key: dfield + fentry.field,
                    legend: dtitle + ", " + fentry.title,
                    color: $9c7fe9c5272b2668$var$randomColor()
                });
            }
        }
        //
        const outcomePayload = new Array;
        for (const xvalue of xvalues){
            const payloadRecord = {};
            payloadRecord[xfield] = xvalue;
            for (const yfield of outcomeYfields)payloadRecord[yfield.key] = Math.random() * 100;
            outcomePayload.push(payloadRecord);
        }
        console.log("yf", outcomeYfields);
        console.log("op", outcomePayload);
        const options = {
            lengths: {
                figure: {
                    height: 400
                }
            },
            margins: {
                right: 300
            },
            display: {
                horizontal: {
                    key: xfield
                },
                vertical: outcomeYfields
            },
            axes: {
                horizontal: {
                    label: xlabel,
                    ticks: {
                        rotate: true,
                        values: null
                    }
                },
                vertical: {
                    label: "...",
                    ticks: {
                        values: null,
                        extend: true,
                        format: ",.0f"
                    }
                }
            }
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))(".column.plot", [
            (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))((0, $8effea8628a9f030$export$2e2bcd8739ae039), {
                options: options,
                payload: outcomePayload
            })
        ]);
    }
    view(vnode) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))(".prototype", [
            (0, (/*@__PURE__*/$parcel$interopDefault($1db9ba4f1f551c94$exports)))(".column.control-cube", [
                this.renderControlsCube(vnode),
                this.renderControlsPlot(vnode)
            ]),
            this.renderPlot(vnode)
        ]);
    }
}
function $9c7fe9c5272b2668$var$fakePayload(xfield, xvalues, yfields) {
    return xvalues.map((xvalue)=>{
        const result = {};
        result[xfield] = xvalue;
        yfields.forEach((yfield)=>{
            result[yfield] = Math.random() * 100;
        });
        return result;
    });
}
function $9c7fe9c5272b2668$var$randomColor() {
    return "#" + Math.floor(Math.random() * 16777215).toString(16);
} // vim:syntax=javascript


//# sourceMappingURL=index.05ef9818.js.map
